export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export interface Scalars {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  CryptocurrencyAmount: { input: bigint; output: bigint; }
  EthereumAddress: { input: EthereumAddress; output: EthereumAddress; }
  ISO8601Date: { input: Date; output: Date; }
  ISO8601DateTime: { input: Date; output: Date; }
  JSON: { input: any; output: any; }
  Json: { input: string | number | boolean | { [key: string]: any }; output: string | number | boolean | { [key: string]: any }; }
  SolanaAddress: { input: string; output: string; }
  WeiAmount: { input: bigint; output: bigint; }
}

/** Autogenerated return type of AcceptTermsMutation. */
export interface AcceptTermsMutationPayload {
  __typename: 'AcceptTermsMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  currentUser?: Maybe<CurrentUser>;
  errors: Array<UserError>;
  /** Generate a JWT Token. null if, and only if, currentUser is null. */
  jwtToken?: Maybe<JwtToken>;
  result: Scalars['String']['output'];
}


/** Autogenerated return type of AcceptTermsMutation. */
export interface AcceptTermsMutationPayloadjwtTokenArgs {
  aud: Scalars['String']['input'];
}

/** The acceptor settlement info */
export interface AcceptorSettlementInfoInput {
  additionalPaymentInfo?: InputMaybe<AdditionalPaymentInfoInput>;
  conversionCreditIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  creditCardType?: InputMaybe<CreditCardType>;
  currency: SupportedCurrency;
  exchangeRateId: Scalars['String']['input'];
  paymentMethod: TokenPaymentMethod;
  platform?: InputMaybe<Platform>;
  returnUrl?: InputMaybe<Scalars['String']['input']>;
  savePaymentMethod?: InputMaybe<Scalars['Boolean']['input']>;
  useAvailableCredits?: InputMaybe<Scalars['Boolean']['input']>;
  walletChallengeSignature?: InputMaybe<StarkwareSignatureInput>;
}

/** An Account */
export interface Account extends Node {
  __typename: 'Account';
  accountable: Accountable;
  id: Scalars['ID']['output'];
  owner?: Maybe<AccountOwner>;
  sorareManaged: Scalars['Boolean']['output'];
}

/** Object that can be an account owner */
export type AccountOwner = Contract | User;

/** Object that can be an account accountable */
export type Accountable = CommonAccount | EthereumAccount | FiatWalletAccount | LoomAccount | SolanaAccount | StarkwareAccount;

/** An activity a manager shared with their followers */
export interface ActivityFeedInterface {
  backgroundUrl?: Maybe<Scalars['String']['output']>;
  /**
   * The most recent reaction the current user left on this activity
   * @deprecated Use currentUserReactions instead
   */
  currentUserReaction?: Maybe<ActivityReaction>;
  /** The reactions the current user left on this activity, the oldest first */
  currentUserReactions: Array<ActivityReaction>;
  id: Scalars['ID']['output'];
  /** The reactions left on this activity, the most recent first The `reactions` field cannot be nested within a list. */
  reactions: ActivityReactionConnection;
  /** How many managers left each emoji, the most reacted first */
  reactionsCount: Array<ActivityReactionCount>;
  sharedAt: Scalars['ISO8601DateTime']['output'];
  user: User;
}


/** An activity a manager shared with their followers */
export interface ActivityFeedInterfacereactionsArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  emoji?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
}

/** The connection type for ActivityFeedInterface. */
export interface ActivityFeedInterfaceConnection {
  __typename: 'ActivityFeedInterfaceConnection';
  /** A list of edges. */
  edges: Array<ActivityFeedInterfaceEdge>;
  /** A list of nodes. */
  nodes: Array<CardPackActivityFeed | LineupActivityFeed | OwnerActivityFeed>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
}

/** An edge in a connection. */
export interface ActivityFeedInterfaceEdge {
  __typename: 'ActivityFeedInterfaceEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<CardPackActivityFeed | LineupActivityFeed | OwnerActivityFeed>;
}

/** The reaction a manager left on an activity */
export interface ActivityReaction extends Node {
  __typename: 'ActivityReaction';
  /** The activity this reaction was left on */
  activity: CardPackActivityFeed | LineupActivityFeed | OwnerActivityFeed;
  emoji: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  reactedAt: Scalars['ISO8601DateTime']['output'];
  user: User;
}

/** The connection type for ActivityReaction. */
export interface ActivityReactionConnection {
  __typename: 'ActivityReactionConnection';
  /** A list of edges. */
  edges: Array<ActivityReactionEdge>;
  /** A list of nodes. */
  nodes: Array<ActivityReaction>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
}

/** How many managers left one emoji on an activity */
export interface ActivityReactionCount {
  __typename: 'ActivityReactionCount';
  count: Scalars['Int']['output'];
  emoji: Scalars['String']['output'];
}

/** An edge in a connection. */
export interface ActivityReactionEdge {
  __typename: 'ActivityReactionEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<ActivityReaction>;
}

export interface AddCardInput {
  signedPrice: Scalars['String']['input'];
}

export const AdditionalKycRequestRequestType = {
  BLOCKED_USER: 'BLOCKED_USER',
  KYC_RENEWAL: 'KYC_RENEWAL'
} as const;

export type AdditionalKycRequestRequestType = typeof AdditionalKycRequestRequestType[keyof typeof AdditionalKycRequestRequestType];
export const AdditionalKycRequestState = {
  CREATED: 'CREATED',
  OUT_OF_DATE: 'OUT_OF_DATE',
  REFUSED: 'REFUSED',
  VALIDATED: 'VALIDATED',
  VALIDATION_ASKED: 'VALIDATION_ASKED'
} as const;

export type AdditionalKycRequestState = typeof AdditionalKycRequestState[keyof typeof AdditionalKycRequestState];
/** Type for additional payment information */
export interface AdditionalPaymentInfoInput {
  klarna?: InputMaybe<KlarnaAdditionalInfoInput>;
}

export interface Age {
  __typename: 'Age';
  cutOffDate: Scalars['ISO8601Date']['output'];
  max?: Maybe<Scalars['Int']['output']>;
  min?: Maybe<Scalars['Int']['output']>;
}

/** An airdrop promotional event taking place */
export interface AirdropPromotionalEvent extends Node, PromotionalEventInterface {
  __typename: 'AirdropPromotionalEvent';
  algoliaFilters: Scalars['String']['output'];
  backgroundPictureUrl?: Maybe<Scalars['String']['output']>;
  bannerAssetsPictureUrl?: Maybe<Scalars['String']['output']>;
  blogUrl?: Maybe<Scalars['String']['output']>;
  claimed: Scalars['Boolean']['output'];
  description: Scalars['String']['output'];
  eligibilityRules: EligibilityRules;
  endDate: Scalars['ISO8601DateTime']['output'];
  filterPictureUrl?: Maybe<Scalars['String']['output']>;
  heroValueProps: Array<HeroValueProp>;
  id: Scalars['ID']['output'];
  logoUrl?: Maybe<Scalars['String']['output']>;
  marketBannerTitle: Scalars['String']['output'];
  mobileBackgroundPictureUrl?: Maybe<Scalars['String']['output']>;
  myReward?: Maybe<AnyCardReward | AnyConversionCreditReward | CardPackReward | CardShardsReward | CoinReward | DeliverableItemReward | ExperienceReward | InGameCurrencyReward | MonetaryReward | ProbabilisticBundleReward | ShopItemReward>;
  myRewards?: Maybe<Array<AnyCardReward | AnyConversionCreditReward | CardPackReward | CardShardsReward | CoinReward | DeliverableItemReward | ExperienceReward | InGameCurrencyReward | MonetaryReward | ProbabilisticBundleReward | ShopItemReward>>;
  name: Scalars['String']['output'];
  pictureUrl?: Maybe<Scalars['String']['output']>;
  probableRewardConfigs: Array<ProbableRewardConfig>;
  promotionType: PromotionType;
  secondaryBannerPictureUrl?: Maybe<Scalars['String']['output']>;
  slug: Scalars['String']['output'];
  sport: Sport;
  startDate: Scalars['ISO8601DateTime']['output'];
  termsAndConditionsUrl?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
}

export interface AlternativeRewardConfig {
  __typename: 'AlternativeRewardConfig';
  rewardConfigs: Array<CardPacksRewardConfig | CardRewardConfig | CardShardRewardConfig | CoinRewardConfig | ConversionCreditRewardConfig | DeliverableItemRewardConfig | ExperienceRewardConfig | InGameCurrencyRewardConfig | MonetaryRewardConfig | ProbabilisticBundleRewardConfig | ShopItemRewardConfig>;
  signedAlternativeRewardConfigs: Scalars['String']['output'];
  validUntil: Scalars['ISO8601DateTime']['output'];
}

/** An amount in cents or wei and its currency */
export interface AmountInput {
  amount: Scalars['String']['input'];
  currency: SupportedCurrency;
}

/** An announcement */
export interface Announcement extends Node {
  __typename: 'Announcement';
  content: Scalars['String']['output'];
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['ID']['output'];
  logoUrl?: Maybe<Scalars['String']['output']>;
  pictureUrl?: Maybe<Scalars['String']['output']>;
  sport?: Maybe<Sport>;
  title: Scalars['String']['output'];
  url?: Maybe<Scalars['String']['output']>;
  webviewUrl: Scalars['String']['output'];
}


/** An announcement */
export interface AnnouncementlogoUrlArgs {
  derivative?: InputMaybe<Scalars['String']['input']>;
}

/** The connection type for Announcement. */
export interface AnnouncementConnection {
  __typename: 'AnnouncementConnection';
  /** A list of edges. */
  edges: Array<AnnouncementEdge>;
  /** A list of nodes. */
  nodes: Array<Announcement>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
}

/** An edge in a connection. */
export interface AnnouncementEdge {
  __typename: 'AnnouncementEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<Announcement>;
}

/** A user notification regarding an Announcement */
export interface AnnouncementNotification extends Node, NotificationInterface {
  __typename: 'AnnouncementNotification';
  announcement: Announcement;
  body: Scalars['String']['output'];
  createdAt: Scalars['ISO8601DateTime']['output'];
  deeplinkUrl: Scalars['String']['output'];
  iconUrl: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  important: Scalars['Boolean']['output'];
  markdownBody: Scalars['String']['output'];
  name: Scalars['String']['output'];
  pictureUrl?: Maybe<Scalars['String']['output']>;
  read: Scalars['Boolean']['output'];
  sport?: Maybe<SportOrShared>;
  title: Scalars['String']['output'];
  user: CurrentUser;
}

/** An anonymous User */
export interface AnonymousUser extends BlockchainUserInterface, Node {
  __typename: 'AnonymousUser';
  cardsCount: Scalars['Int']['output'];
  ethVaultId?: Maybe<Scalars['Int']['output']>;
  ethereumAddress: Scalars['EthereumAddress']['output'];
  id: Scalars['ID']['output'];
  sorareAddress?: Maybe<Scalars['EthereumAddress']['output']>;
  starkKey?: Maybe<Scalars['String']['output']>;
}

/** AverageStatWithValue */
export interface AnyAverageStatWithValueInterface {
  lastValues?: Maybe<Array<Scalars['Float']['output']>>;
  value?: Maybe<Scalars['Float']['output']>;
}

/** Card */
export interface AnyCardInterface {
  activeSuspensions: Array<Suspension>;
  activeTaskAppearances: Array<DecisivePlayerPickerTaskAppearance | TaskAppearance | ThresholdPickerTaskAppearance>;
  anyPlayer: BaseballPlayer | NBAPlayer | Player;
  anyPositions: Array<Position>;
  anyTeam: Club | NationalTeam;
  assetId: Scalars['ID']['output'];
  availableCardBoosts: Array<CardBoost>;
  averageScore?: Maybe<Scalars['Float']['output']>;
  backPictureUrl: Scalars['String']['output'];
  blueprint?: Maybe<Blueprint>;
  bonuses: Array<So5ActiveClubsBonus | So5AverageScoresBonus | So5BoostBonus | So5CaptainBonus | So5CollectionBonus | So5DifferentNationalitiesBonus | So5GradeBonus | So5LineupBonus | So5MalusAfterTransferBonus | So5NationalityBonus | So5PlayerBonus | So5PositionBonus | So5PositionStacksBonus | So5SameActiveClubBonus | So5ScarcityBonus | So5SeasonBonus | So5SpecialEditionCardsBonus>;
  bonusesAfterTransfer: Array<So5ActiveClubsBonus | So5AverageScoresBonus | So5BoostBonus | So5CaptainBonus | So5CollectionBonus | So5DifferentNationalitiesBonus | So5GradeBonus | So5LineupBonus | So5MalusAfterTransferBonus | So5NationalityBonus | So5PlayerBonus | So5PositionBonus | So5PositionStacksBonus | So5SameActiveClubBonus | So5ScarcityBonus | So5SeasonBonus | So5SpecialEditionCardsBonus>;
  borderRadius: Scalars['Int']['output'];
  cardBackgroundUrl?: Maybe<Scalars['String']['output']>;
  cardBackgroundVideoUrl?: Maybe<Scalars['String']['output']>;
  cardCollectionCards: Array<CardCollectionCard>;
  cardEditionName?: Maybe<Scalars['String']['output']>;
  /** @deprecated Not used anymore */
  cardPrice?: Maybe<Scalars['Int']['output']>;
  cardSet?: Maybe<CardSet>;
  cardStats?: Maybe<CardStats>;
  collection?: Maybe<Collection>;
  collectionIncreaseScoreBreakdownAfterTransfer?: Maybe<CardCollectionCardScoreBreakdown>;
  collectionScoringMatrix: Array<CardCollectionScoringMatrix>;
  concurrentSo5Lineups: Array<So5Lineup>;
  contractAddress?: Maybe<Scalars['EthereumAddress']['output']>;
  currentUserSubscription?: Maybe<EmailSubscription>;
  decks: Array<Deck>;
  delayedReveal?: Maybe<Scalars['Boolean']['output']>;
  displayRarity: Scalars['String']['output'];
  /** @deprecated Not used anymore */
  dropRank?: Maybe<Scalars['Int']['output']>;
  eligibleBoards: Array<CareerBoard | SquadBoard>;
  /** Eligible boards on which the card earns a special edition cards bonus */
  eligibleBoardsWithSpecialEditionBonus: Array<BoardWithSpecialEditionBonus>;
  eligiblePlayerGameScores: Array<BaseballPlayerGameScore | BasketballPlayerGameScore | PlayerGameScore | So5Score>;
  eligibleUpcomingLeagueTracks: Array<So5LeagueTrack>;
  ethereumId: Scalars['String']['output'];
  ethereumOwner?: Maybe<TokenOwner>;
  formattedCardEditionName?: Maybe<Scalars['String']['output']>;
  /** Current card level */
  grade: Scalars['Int']['output'];
  gradeAfterTransfer: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  inSeasonEligible: Scalars['Boolean']['output'];
  inSeasonUntil?: Maybe<Scalars['ISO8601DateTime']['output']>;
  ipfsPictureUrl?: Maybe<Scalars['String']['output']>;
  ipfsUrl?: Maybe<Scalars['String']['output']>;
  lastLeveledUpAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  latestEnglishAuction?: Maybe<TokenAuction>;
  latestPrimaryOffer?: Maybe<TokenPrimaryOffer>;
  levelUpAppliedCount: Scalars['Int']['output'];
  livePrimaryOffer?: Maybe<TokenPrimaryOffer>;
  liveSingleBuyOffers: Array<TokenOffer>;
  liveSingleSaleOffer?: Maybe<TokenOffer>;
  /** So5Lineup that this card is being used in for the live So5Fixture */
  liveSo5Lineup?: Maybe<So5Lineup>;
  loanedToken?: Maybe<LoanedToken>;
  /** Returns the lowest price card of the same player, rarity, season and print batch */
  lowestPriceCard?: Maybe<BaseballCard | Card | NBACard>;
  /** Returns the lowest price card of the same player and rarity */
  lowestPriceCardAnySeason?: Maybe<BaseballCard | Card | NBACard>;
  maxLevelUpAppliedCount: Scalars['Int']['output'];
  myCardCollectionSlot?: Maybe<UserCardCollectionSlot>;
  myMintedSingleSaleOffer?: Maybe<TokenOffer>;
  name: Scalars['String']['output'];
  nextLevelUpAvailableAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** So5Lineups that this card is being used in for the opened So5Fixtures */
  openedSo5Lineups: Array<So5Lineup>;
  ownerSince?: Maybe<Scalars['ISO8601DateTime']['output']>;
  ownershipHistory: Array<TokenOwner>;
  pack?: Maybe<Pack>;
  pendingWithdrawal?: Maybe<TokenWithdrawal>;
  pictureUrl?: Maybe<Scalars['String']['output']>;
  /** @deprecated Player loyalty is no longer used */
  playerLoyaltyBoost: RewardBoost;
  /** Total card bonus (XP + Season bonus) */
  power: Scalars['String']['output'];
  /** Total card bonus after transfer */
  powerAfterTransfer: Scalars['String']['output'];
  powerBreakdown: PowerBreakdown;
  powerMalusAfterTransfer: Scalars['String']['output'];
  previouslyOwnedCard?: Maybe<Scalars['Boolean']['output']>;
  previouslyOwnedPlayer?: Maybe<Scalars['Boolean']['output']>;
  priceRange?: Maybe<Range>;
  /** Print batch of the card, 0 for the original print of that player, rarity and season */
  printBatch: Scalars['Int']['output'];
  privateMinPrices?: Maybe<MonetaryAmount>;
  publicMinPrices?: Maybe<MonetaryAmount>;
  rarityTyped: Rarity;
  /**
   * The `related_card_edition_slots` field cannot be nested within a list.
   * @deprecated Use myCardCollectionSlot.relatedCardEditionSlots instead
   */
  relatedCardEditionSlots?: Maybe<Array<UserCardCollectionSlot>>;
  revealableCardCampaign?: Maybe<RevealableCardCampaign>;
  sealable: Scalars['Boolean']['output'];
  sealableFor?: Maybe<Scalars['Int']['output']>;
  sealed: Scalars['Boolean']['output'];
  sealedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  sealedFor?: Maybe<Scalars['Int']['output']>;
  /** @deprecated Player loyalty is no longer used */
  sealedPlayerLoyaltyBoost: RewardBoost;
  seasonYear: Scalars['Int']['output'];
  secondaryMarketFeeEnabled: Scalars['Boolean']['output'];
  /**
   * Returns all live or minted offers where this token is included in the sender
   * side. Returns only if authenticated and sender of the offers.
   */
  sentInLiveOffers?: Maybe<Array<TokenOffer>>;
  serialNumber: Scalars['Int']['output'];
  /** Whether this card qualifies for the social feed */
  shareable: Scalars['Boolean']['output'];
  /** Whether the current user already shared this card */
  shared: Scalars['Boolean']['output'];
  /** @deprecated Not used anymore */
  signedAddCardPrice?: Maybe<SignedCardPrice>;
  signedDropCardPrice?: Maybe<SignedCardPrice>;
  singleCivilYear: Scalars['Boolean']['output'];
  skinEdition?: Maybe<SkinEdition>;
  slug: Scalars['String']['output'];
  solanaAddress?: Maybe<Scalars['String']['output']>;
  solanaBlockExplorerUrl?: Maybe<Scalars['String']['output']>;
  specialEdition?: Maybe<Scalars['String']['output']>;
  sport: Sport;
  sportSeason: SportSeason;
  subscriptionsCount: Scalars['Int']['output'];
  supply: Scalars['Int']['output'];
  threeDimensional: Scalars['Boolean']['output'];
  threeDimensionalAsset?: Maybe<ThreeDimensionalAsset>;
  tokenOwner?: Maybe<TokenOwner>;
  tradeableStatus: Tradeable;
  unsealableAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  unsealedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** @deprecated Player loyalty is no longer used */
  unsealedPlayerLoyaltyBoost: RewardBoost;
  usedIn?: Maybe<ListedOnMarket | UsedInSo5Lineups | UsedInTaskLineups | UsedInTaskPreparedLineups | UsedInTasks>;
  user?: Maybe<User>;
  videoUrl?: Maybe<Scalars['String']['output']>;
  walletStatus: WalletStatus;
  xp: Scalars['Int']['output'];
  xpAfterTransfer: Scalars['Int']['output'];
  /** XP start range of current card level */
  xpNeededForCurrentGrade: Scalars['Int']['output'];
  /** XP end range of current card level */
  xpNeededForNextGrade?: Maybe<Scalars['Int']['output']>;
}


/** Card */
export interface AnyCardInterfaceactiveSuspensionsArgs {
  so5LeaderboardSlug?: InputMaybe<Scalars['String']['input']>;
}


/** Card */
export interface AnyCardInterfaceaverageScoreArgs {
  type: AveragePlayerScore;
}


/** Card */
export interface AnyCardInterfacebonusesArgs {
  highlighted?: InputMaybe<Scalars['Boolean']['input']>;
  so5LeaderboardSlug?: InputMaybe<Scalars['String']['input']>;
}


/** Card */
export interface AnyCardInterfacebonusesAfterTransferArgs {
  so5LeaderboardSlug?: InputMaybe<Scalars['String']['input']>;
}


/** Card */
export interface AnyCardInterfacecardBackgroundVideoUrlArgs {
  derivative?: InputMaybe<Scalars['String']['input']>;
}


/** Card */
export interface AnyCardInterfaceconcurrentSo5LineupsArgs {
  so5FixtureSlug?: InputMaybe<Scalars['String']['input']>;
  so5LeaderboardSlug?: InputMaybe<Scalars['String']['input']>;
}


/** Card */
export interface AnyCardInterfaceeligiblePlayerGameScoresArgs {
  boardId?: InputMaybe<Scalars['String']['input']>;
  gameId?: InputMaybe<Scalars['ID']['input']>;
  so5LeaderboardSlug?: InputMaybe<Scalars['String']['input']>;
  stepId?: InputMaybe<Scalars['String']['input']>;
  taskId?: InputMaybe<Scalars['ID']['input']>;
}


/** Card */
export interface AnyCardInterfacepictureUrlArgs {
  derivative?: InputMaybe<Scalars['String']['input']>;
}


/** Card */
export interface AnyCardInterfacepowerArgs {
  so5LeaderboardSlug?: InputMaybe<Scalars['String']['input']>;
}


/** Card */
export interface AnyCardInterfacepowerAfterTransferArgs {
  so5LeaderboardSlug?: InputMaybe<Scalars['String']['input']>;
}


/** Card */
export interface AnyCardInterfacepowerBreakdownArgs {
  so5LeaderboardSlug?: InputMaybe<Scalars['String']['input']>;
}


/** Card */
export interface AnyCardInterfaceusedInArgs {
  gameId?: InputMaybe<Scalars['ID']['input']>;
  so5LeaderboardSlug?: InputMaybe<Scalars['String']['input']>;
  taskId?: InputMaybe<Scalars['ID']['input']>;
  taskLineupId?: InputMaybe<Scalars['ID']['input']>;
  taskPreparedLineupId?: InputMaybe<Scalars['ID']['input']>;
}


/** Card */
export interface AnyCardInterfacevideoUrlArgs {
  derivative?: InputMaybe<Scalars['String']['input']>;
}

/** The connection type for AnyCardInterface. */
export interface AnyCardInterfaceConnection {
  __typename: 'AnyCardInterfaceConnection';
  /** A list of edges. */
  edges: Array<AnyCardInterfaceEdge>;
  hasAny: Scalars['Boolean']['output'];
  /** A list of nodes. */
  nodes: Array<BaseballCard | Card | NBACard>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
}

/** An edge in a connection. */
export interface AnyCardInterfaceEdge {
  __typename: 'AnyCardInterfaceEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<BaseballCard | Card | NBACard>;
}

/** A Card Reward */
export interface AnyCardReward extends AnyRewardInterface, Node {
  __typename: 'AnyCardReward';
  aasmState: RewardState;
  backPictureUrl?: Maybe<Scalars['String']['output']>;
  card: BaseballCard | Card | NBACard;
  config: CardRewardConfig;
  id: Scalars['ID']['output'];
  pictureUrl?: Maybe<Scalars['String']['output']>;
  quality?: Maybe<Scalars['String']['output']>;
}

export interface AnyCardSubscription {
  __typename: 'AnyCardSubscription';
  card: BaseballCard | Card | NBACard;
  eventType: CardWasUpdatedEvent;
}

export interface AnyCardWithPlayerGameScore {
  __typename: 'AnyCardWithPlayerGameScore';
  card: BaseballCard | Card | NBACard;
  id: Scalars['String']['output'];
  playerGameScore?: Maybe<BaseballPlayerGameScore | BasketballPlayerGameScore | PlayerGameScore | So5Score>;
}

/** The connection type for AnyCardWithPlayerGameScore. */
export interface AnyCardWithPlayerGameScoreConnection {
  __typename: 'AnyCardWithPlayerGameScoreConnection';
  /** A list of edges. */
  edges: Array<AnyCardWithPlayerGameScoreEdge>;
  hasAny: Scalars['Boolean']['output'];
  /** A list of nodes. */
  nodes: Array<AnyCardWithPlayerGameScore>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
}

/** An edge in a connection. */
export interface AnyCardWithPlayerGameScoreEdge {
  __typename: 'AnyCardWithPlayerGameScoreEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<AnyCardWithPlayerGameScore>;
}

/** Any team in a competition */
export interface AnyContestantInterface {
  gamesDrawn: Scalars['Int']['output'];
  gamesLost: Scalars['Int']['output'];
  gamesPlayed: Scalars['Int']['output'];
  gamesWon: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  rank?: Maybe<Scalars['Int']['output']>;
  rankStatus?: Maybe<Scalars['String']['output']>;
  rankType?: Maybe<TournamentCalendarRankType>;
  team: Club | NationalTeam;
}

/** A ConversionCredit Reward */
export interface AnyConversionCreditReward extends AnyRewardInterface, Node {
  __typename: 'AnyConversionCreditReward';
  aasmState: RewardState;
  config: ConversionCreditRewardConfig;
  conversionCredit: ConversionCredit;
  id: Scalars['ID']['output'];
}

/** Game */
export interface AnyGameInterface {
  /** The `any_players` field cannot be nested within a list. */
  anyPlayers: Array<BaseballPlayer | NBAPlayer | Player>;
  awayScore: Scalars['Int']['output'];
  awayStats?: Maybe<BaseballTeamGameStats | BasketballTeamGameStats | FootballTeamGameStats>;
  awayTeam?: Maybe<Club | NationalTeam>;
  competition: Competition;
  date: Scalars['ISO8601DateTime']['output'];
  homeScore: Scalars['Int']['output'];
  homeStats?: Maybe<BaseballTeamGameStats | BasketballTeamGameStats | FootballTeamGameStats>;
  homeTeam?: Maybe<Club | NationalTeam>;
  id: Scalars['ID']['output'];
  lowCoverage: Scalars['Boolean']['output'];
  /** The `my_best_by_player_cards` field cannot be nested within a list. */
  myBestByPlayerCards: AnyCardWithPlayerGameScoreConnection;
  /** The `my_cards` field cannot be nested within a list. */
  myCards: AnyCardInterfaceConnection;
  mySo5Appearances: Array<So5Appearance>;
  mySo5AppearancesPaginated: So5AppearanceConnection;
  mySo5LeaderboardContenders: Array<So5LeaderboardContender>;
  mySo5Lineups: Array<So5Lineup>;
  /** Score for a Game for a specific player and his current position */
  playerGameScore?: Maybe<BaseballPlayerGameScore | BasketballPlayerGameScore | PlayerGameScore | So5Score>;
  /** The `player_game_scores` field cannot be nested within a list. */
  playerGameScores: Array<BaseballPlayerGameScore | BasketballPlayerGameScore | PlayerGameScore | So5Score>;
  scored: Scalars['Boolean']['output'];
  so5Fixture?: Maybe<So5Fixture>;
  sport: Sport;
  statusTyped: GameStatus;
  venue?: Maybe<Scalars['String']['output']>;
  venueTyped?: Maybe<Venue>;
  winner?: Maybe<Club | NationalTeam>;
}


/** Game */
export interface AnyGameInterfacemyBestByPlayerCardsArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  rarities?: InputMaybe<Array<Rarity>>;
}


/** Game */
export interface AnyGameInterfacemyCardsArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  age?: InputMaybe<Scalars['Int']['input']>;
  assetIds?: InputMaybe<Array<Scalars['String']['input']>>;
  before?: InputMaybe<Scalars['String']['input']>;
  classicOnly?: InputMaybe<Scalars['Boolean']['input']>;
  customCardEditionName?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  inActiveCompetitions?: InputMaybe<Array<Scalars['String']['input']>>;
  inSeasonEligible?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  owned?: InputMaybe<Scalars['Boolean']['input']>;
  ownedByMe?: InputMaybe<Scalars['Boolean']['input']>;
  ownedSinceAfter?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  playerSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  positions?: InputMaybe<Array<Position>>;
  rarities?: InputMaybe<Array<Rarity>>;
  revealable?: InputMaybe<Scalars['Boolean']['input']>;
  seasonStartYears?: InputMaybe<Array<Scalars['Int']['input']>>;
  serialNumber?: InputMaybe<Scalars['Int']['input']>;
  shirtNumber?: InputMaybe<Scalars['Int']['input']>;
  slugs?: InputMaybe<Array<Scalars['String']['input']>>;
  sorts?: InputMaybe<Array<CardSort>>;
  sport?: InputMaybe<Sport>;
  teamSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  withinDeckFirst?: InputMaybe<Scalars['String']['input']>;
}


/** Game */
export interface AnyGameInterfacemySo5AppearancesPaginatedArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
}


/** Game */
export interface AnyGameInterfaceplayerGameScoreArgs {
  playerSlug: Scalars['String']['input'];
  position?: InputMaybe<Position>;
}


/** Game */
export interface AnyGameInterfaceplayerGameScoresArgs {
  includingLegends?: InputMaybe<Scalars['Boolean']['input']>;
}


/** Game */
export interface AnyGameInterfaceso5FixtureArgs {
  so5FixtureType?: InputMaybe<So5FixtureEvent>;
}

/** The connection type for AnyGameInterface. */
export interface AnyGameInterfaceConnection {
  __typename: 'AnyGameInterfaceConnection';
  /** A list of edges. */
  edges: Array<AnyGameInterfaceEdge>;
  /** A list of nodes. */
  nodes: Array<Game | GameOfBaseball | GameOfBasketball>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
}

/** An edge in a connection. */
export interface AnyGameInterfaceEdge {
  __typename: 'AnyGameInterfaceEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<Game | GameOfBaseball | GameOfBasketball>;
}

/** Any player */
export type AnyPlayer = BaseballPlayer | NBAPlayer | Player;

/** Player game stats */
export interface AnyPlayerGameStatsInterface {
  anyGame: Game | GameOfBaseball | GameOfBasketball;
  anyPlayer: BaseballPlayer | NBAPlayer | Player;
  anyTeam: Club | NationalTeam;
  id: Scalars['ID']['output'];
  live: Scalars['Boolean']['output'];
  myBestSo5Appearance?: Maybe<So5Appearance>;
  onGameSheet: Scalars['Boolean']['output'];
  playedInGame: Scalars['Boolean']['output'];
  /** Whether the current user aligned a card for this player game in any lineup (So5 or task) */
  playedInLineup: Scalars['Boolean']['output'];
  playerGameScore?: Maybe<BaseballPlayerGameScore | BasketballPlayerGameScore | PlayerGameScore | So5Score>;
  reviewed: Scalars['Boolean']['output'];
}


/** Player game stats */
export interface AnyPlayerGameStatsInterfaceplayerGameScoreArgs {
  position?: InputMaybe<Scalars['String']['input']>;
}

export interface AnyPlayerInterface {
  abbreviatedName: Scalars['String']['output'];
  activeClub?: Maybe<Club>;
  activeClubMembership?: Maybe<Membership>;
  activeInjuries: Array<Injury>;
  activeNationalTeam?: Maybe<NationalTeam>;
  activeSuspensions: Array<Suspension>;
  age: Scalars['Int']['output'];
  /** All player So5Scores ordered by descending game date */
  allPlayerGameScores: PlayerGameScoreInterfaceConnection;
  anyCardWithLiveAuction?: Maybe<BaseballCard | Card | NBACard>;
  anyCardWithLivePrimaryOffer?: Maybe<BaseballCard | Card | NBACard>;
  /** The `any_cards` field cannot be nested within a list. */
  anyCards: AnyCardInterfaceConnection;
  /** Stats of the upcoming games of the player, closest game first */
  anyFutureGameStats: Array<PlayerGameStats | PlayerGameStatsBaseball | PlayerGameStatsBasketball>;
  /** The `any_future_games` field cannot be nested within a list. */
  anyFutureGames: AnyGameInterfaceConnection;
  anyGameStats: Array<Maybe<PlayerGameStats | PlayerGameStatsBaseball | PlayerGameStatsBasketball>>;
  anyGamesForFixture: Array<Game | GameOfBaseball | GameOfBasketball>;
  anyGamesForLeaderboard: Array<Game | GameOfBaseball | GameOfBasketball>;
  /** The `any_past_games` field cannot be nested within a list. */
  anyPastGames: AnyGameInterfaceConnection;
  anyPositions: Array<Position>;
  /** Returns the 3 most followed players in the player's club The `any_related_players` field cannot be nested within a list. */
  anyRelatedPlayers: Array<BaseballPlayer | NBAPlayer | Player>;
  /** The `any_so5_average_last_score` field cannot be nested within a list. */
  anySo5AverageLastScore?: Maybe<AverageLastScore | BaseAverageLastScore>;
  appearances: Scalars['Int']['output'];
  avatarPictureUrl: Scalars['String']['output'];
  averageScore?: Maybe<Scalars['Float']['output']>;
  beforeLastOwningMembership?: Maybe<Membership>;
  birthDay?: Maybe<Scalars['ISO8601Date']['output']>;
  cardPositions: Array<Position>;
  /** @deprecated Not used anymore */
  cardPrice?: Maybe<Scalars['Int']['output']>;
  /** Cards of this player that are owned by a manager. Updated once a day. */
  cardSupply: Array<CardSeasonSupply>;
  careerSeasons: Array<Season>;
  clubMemberships: Array<Membership>;
  commonPlayer?: Maybe<CommonPlayer>;
  country: Country;
  currentSeason?: Maybe<Season>;
  currentUserSubscription?: Maybe<EmailSubscription>;
  /** @deprecated Use gainOnProjection */
  differenceLastTenAndClassicProjection?: Maybe<Scalars['Float']['output']>;
  /** @deprecated Use gainOnProjection(eventType: DAILY) */
  differenceLastTenAndDailyProjection?: Maybe<Scalars['Float']['output']>;
  displayName: Scalars['String']['output'];
  /** The `eligible_so5_competitions` field cannot be nested within a list. */
  eligibleSo5Competitions: Array<So5Competition>;
  firstName: Scalars['String']['output'];
  fullPictureUrl: Scalars['String']['output'];
  /** @deprecated Use gainOnProjection */
  gainOnClassicProjection?: Maybe<Scalars['Float']['output']>;
  /** @deprecated Use gainOnProjection */
  gainOnDailyProjection?: Maybe<Scalars['Float']['output']>;
  gainOnProjection?: Maybe<Scalars['Float']['output']>;
  gameplayTier?: Maybe<GameplayTier>;
  /** The star rating of the player gameplay tier */
  gameplayTierStars?: Maybe<Scalars['Float']['output']>;
  hasSo5LineupForFixture: Scalars['Boolean']['output'];
  height?: Maybe<Scalars['Int']['output']>;
  injuries: Array<Injury>;
  lastClub?: Maybe<Club>;
  lastFifteenSo5Appearances?: Maybe<Scalars['Int']['output']>;
  lastFiveSo5Appearances?: Maybe<Scalars['Int']['output']>;
  lastFortySo5Appearances?: Maybe<Scalars['Int']['output']>;
  lastName: Scalars['String']['output'];
  /** Get the last 2 cards you own of the player */
  lastOwnedCards: Array<BaseballCard | Card | NBACard>;
  lastTenSo5Appearances?: Maybe<Scalars['Int']['output']>;
  lowestPriceAnyCard?: Maybe<BaseballCard | Card | NBACard>;
  mainCardCollectionSlot?: Maybe<CardCollectionSlot>;
  matchName: Scalars['String']['output'];
  memberships: Array<Membership>;
  mySo5LeaderboardContendersForFixture: Array<So5LeaderboardContender>;
  news: Array<AnyPlayerNewsUpdate>;
  nextClassicFixtureProjectedGrade?: Maybe<PlayerGameScoreProjection>;
  nextClassicFixtureProjectedScore?: Maybe<Scalars['Float']['output']>;
  nextDailyFixtureProjectedGrade?: Maybe<PlayerGameScoreProjection>;
  nextDailyFixtureProjectedScore?: Maybe<Scalars['Float']['output']>;
  nextGame?: Maybe<Game | GameOfBaseball | GameOfBasketball>;
  ownedCardsCount: Scalars['Int']['output'];
  playerGameScore?: Maybe<BaseballPlayerGameScore | BasketballPlayerGameScore | PlayerGameScore | So5Score>;
  /** Up to 15 last So5Scores used in a So5Fixture */
  playerGameScores: Array<Maybe<BaseballPlayerGameScore | BasketballPlayerGameScore | PlayerGameScore | So5Score>>;
  printablePlayer?: Maybe<CommonPlayer>;
  /** The `public_watchlists` field cannot be nested within a list. */
  publicWatchlists?: Maybe<WatchlistConnection>;
  /** Up to 15 last So5Scores.score used in a So5Fixture */
  rawPlayerGameScores: Array<Maybe<Scalars['Float']['output']>>;
  seasonAppearances?: Maybe<Scalars['Int']['output']>;
  shirtNumber: Scalars['Int']['output'];
  /** @deprecated Not used anymore */
  signedAddCardPrice?: Maybe<SignedCardPrice>;
  signedDropCardPrice?: Maybe<SignedCardPrice>;
  slug: Scalars['String']['output'];
  sport: Sport;
  squaredPictureUrl: Scalars['String']['output'];
  subscriptionsCount: Scalars['Int']['output'];
  suspensions: Array<Suspension>;
  /** The `token_prices` field cannot be nested within a list. */
  tokenPrices: TokenPriceConnection;
  user?: Maybe<User>;
  weight?: Maybe<Scalars['Int']['output']>;
}


export interface AnyPlayerInterfaceallPlayerGameScoresArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  position?: InputMaybe<Position>;
  to?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
}


export interface AnyPlayerInterfaceanyCardWithLiveAuctionArgs {
  inSeason?: InputMaybe<Scalars['Boolean']['input']>;
  rarity?: InputMaybe<Rarity>;
}


export interface AnyPlayerInterfaceanyCardWithLivePrimaryOfferArgs {
  rarity?: InputMaybe<Rarity>;
}


export interface AnyPlayerInterfaceanyCardsArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  age?: InputMaybe<Scalars['Int']['input']>;
  assetIds?: InputMaybe<Array<Scalars['String']['input']>>;
  before?: InputMaybe<Scalars['String']['input']>;
  classicOnly?: InputMaybe<Scalars['Boolean']['input']>;
  customCardEditionName?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  inActiveCompetitions?: InputMaybe<Array<Scalars['String']['input']>>;
  inSeasonEligible?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  owned?: InputMaybe<Scalars['Boolean']['input']>;
  ownedByMe?: InputMaybe<Scalars['Boolean']['input']>;
  ownedSinceAfter?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  playerSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  positions?: InputMaybe<Array<Position>>;
  rarities?: InputMaybe<Array<Rarity>>;
  revealable?: InputMaybe<Scalars['Boolean']['input']>;
  seasonStartYears?: InputMaybe<Array<Scalars['Int']['input']>>;
  serialNumber?: InputMaybe<Scalars['Int']['input']>;
  shirtNumber?: InputMaybe<Scalars['Int']['input']>;
  slugs?: InputMaybe<Array<Scalars['String']['input']>>;
  sorts?: InputMaybe<Array<CardSort>>;
  sport?: InputMaybe<Sport>;
  teamSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  withinDeckFirst?: InputMaybe<Scalars['String']['input']>;
}


export interface AnyPlayerInterfaceanyFutureGameStatsArgs {
  first: Scalars['Int']['input'];
  teamMode?: InputMaybe<AverageScoreTeamMode>;
}


export interface AnyPlayerInterfaceanyFutureGamesArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  so5FixtureEligible?: InputMaybe<Scalars['Boolean']['input']>;
}


export interface AnyPlayerInterfaceanyGameStatsArgs {
  last: Scalars['Int']['input'];
  lowCoverage?: InputMaybe<Scalars['Boolean']['input']>;
  so5FixtureSlug?: InputMaybe<Scalars['String']['input']>;
  teamMode?: InputMaybe<AverageScoreTeamMode>;
}


export interface AnyPlayerInterfaceanyGamesForFixtureArgs {
  so5FixtureSlug: Scalars['String']['input'];
}


export interface AnyPlayerInterfaceanyGamesForLeaderboardArgs {
  so5LeaderboardSlug: Scalars['String']['input'];
}


export interface AnyPlayerInterfaceanyPastGamesArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
}


export interface AnyPlayerInterfaceanySo5AverageLastScoreArgs {
  competitionSlug?: InputMaybe<Scalars['String']['input']>;
  location?: InputMaybe<AverageLastScoreLocation>;
  position: Position;
  span: AverageLastScoreSpan;
  teamSlug?: InputMaybe<Scalars['String']['input']>;
}


export interface AnyPlayerInterfaceaverageScoreArgs {
  position?: InputMaybe<Position>;
  teamMode?: InputMaybe<AverageScoreTeamMode>;
  type: AveragePlayerScore;
}


export interface AnyPlayerInterfacecardPriceArgs {
  rarity: Rarity;
}


export interface AnyPlayerInterfacecareerSeasonsArgs {
  type?: InputMaybe<CompetitionType>;
}


export interface AnyPlayerInterfacecommonPlayerArgs {
  rarity: Rarity;
}


export interface AnyPlayerInterfacegainOnProjectionArgs {
  eventType?: InputMaybe<So5FixtureEvent>;
}


export interface AnyPlayerInterfacehasSo5LineupForFixtureArgs {
  so5FixtureSlug: Scalars['String']['input'];
}


export interface AnyPlayerInterfacelastFifteenSo5AppearancesArgs {
  teamMode?: InputMaybe<AverageScoreTeamMode>;
}


export interface AnyPlayerInterfacelastFiveSo5AppearancesArgs {
  teamMode?: InputMaybe<AverageScoreTeamMode>;
}


export interface AnyPlayerInterfacelastFortySo5AppearancesArgs {
  teamMode?: InputMaybe<AverageScoreTeamMode>;
}


export interface AnyPlayerInterfacelastOwnedCardsArgs {
  inSeasonEligible?: InputMaybe<Scalars['Boolean']['input']>;
  rarities?: InputMaybe<Array<Rarity>>;
}


export interface AnyPlayerInterfacelastTenSo5AppearancesArgs {
  teamMode?: InputMaybe<AverageScoreTeamMode>;
}


export interface AnyPlayerInterfacelowestPriceAnyCardArgs {
  inSeason?: InputMaybe<Scalars['Boolean']['input']>;
  rarity?: InputMaybe<Rarity>;
}


export interface AnyPlayerInterfacemainCardCollectionSlotArgs {
  rarity: Rarity;
}


export interface AnyPlayerInterfacemySo5LeaderboardContendersForFixtureArgs {
  so5FixtureSlug: Scalars['String']['input'];
}


export interface AnyPlayerInterfacenewsArgs {
  last: Scalars['Int']['input'];
}


export interface AnyPlayerInterfacenextGameArgs {
  so5FixtureEligible?: InputMaybe<Scalars['Boolean']['input']>;
}


export interface AnyPlayerInterfaceownedCardsCountArgs {
  rarities?: InputMaybe<Array<Rarity>>;
  rarity?: InputMaybe<Rarity>;
  seasonEligibility?: InputMaybe<SeasonEligibility>;
}


export interface AnyPlayerInterfaceplayerGameScoreArgs {
  gameId: Scalars['ID']['input'];
  position?: InputMaybe<Position>;
}


export interface AnyPlayerInterfaceplayerGameScoresArgs {
  last: Scalars['Int']['input'];
  lowCoverage?: InputMaybe<Scalars['Boolean']['input']>;
  position?: InputMaybe<Position>;
}


export interface AnyPlayerInterfacepublicWatchlistsArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
}


export interface AnyPlayerInterfacerawPlayerGameScoresArgs {
  last: Scalars['Int']['input'];
  lowCoverage?: InputMaybe<Scalars['Boolean']['input']>;
  position?: InputMaybe<Position>;
}


export interface AnyPlayerInterfaceseasonAppearancesArgs {
  teamMode?: InputMaybe<AverageScoreTeamMode>;
}


export interface AnyPlayerInterfacesignedAddCardPriceArgs {
  rarity: Rarity;
}


export interface AnyPlayerInterfacesignedDropCardPriceArgs {
  rarity: Rarity;
}


export interface AnyPlayerInterfacetokenPricesArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  includePrivateSales?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  rarity: Rarity;
  season?: InputMaybe<Scalars['Int']['input']>;
  seasonEligibility?: InputMaybe<SeasonEligibility>;
  since?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
}

/** The connection type for AnyPlayerInterface. */
export interface AnyPlayerInterfaceConnection {
  __typename: 'AnyPlayerInterfaceConnection';
  /** A list of edges. */
  edges: Array<AnyPlayerInterfaceEdge>;
  /** A list of nodes. */
  nodes: Array<BaseballPlayer | NBAPlayer | Player>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
}

/** An edge in a connection. */
export interface AnyPlayerInterfaceEdge {
  __typename: 'AnyPlayerInterfaceEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<BaseballPlayer | NBAPlayer | Player>;
}

/** Player news */
export interface AnyPlayerNewsUpdate {
  __typename: 'AnyPlayerNewsUpdate';
  analysis: Scalars['String']['output'];
  date?: Maybe<Scalars['ISO8601DateTime']['output']>;
  headline: Scalars['String']['output'];
  notes: Scalars['String']['output'];
}

export interface AnyRewardConfigInterface {
  boostedRewardConfigs?: Maybe<Array<CardPacksRewardConfig | CardRewardConfig | CardShardRewardConfig | CoinRewardConfig | ConversionCreditRewardConfig | DeliverableItemRewardConfig | ExperienceRewardConfig | InGameCurrencyRewardConfig | MonetaryRewardConfig | ProbabilisticBundleRewardConfig | ShopItemRewardConfig>>;
  id: Scalars['ID']['output'];
}

export interface AnyRewardInterface {
  aasmState: RewardState;
  config: CardPacksRewardConfig | CardRewardConfig | CardShardRewardConfig | CoinRewardConfig | ConversionCreditRewardConfig | DeliverableItemRewardConfig | ExperienceRewardConfig | InGameCurrencyRewardConfig | MonetaryRewardConfig | ProbabilisticBundleRewardConfig | ShopItemRewardConfig;
  id: Scalars['ID']['output'];
}

/** The connection type for AnyRewardInterface. */
export interface AnyRewardInterfaceConnection {
  __typename: 'AnyRewardInterfaceConnection';
  /** A list of edges. */
  edges: Array<AnyRewardInterfaceEdge>;
  /** A list of nodes. */
  nodes: Array<AnyCardReward | AnyConversionCreditReward | CardPackReward | CardShardsReward | CoinReward | DeliverableItemReward | ExperienceReward | InGameCurrencyReward | MonetaryReward | ProbabilisticBundleReward | ShopItemReward>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
}

/** An edge in a connection. */
export interface AnyRewardInterfaceEdge {
  __typename: 'AnyRewardInterfaceEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<AnyCardReward | AnyConversionCreditReward | CardPackReward | CardShardsReward | CoinReward | DeliverableItemReward | ExperienceReward | InGameCurrencyReward | MonetaryReward | ProbabilisticBundleReward | ShopItemReward>;
}

/** Any user sport profile */
export type AnyUserSportProfile = BaseballUserSportProfile | FootballUserSportProfile | NBAUserSportProfile;

/** A user API key for the GraphQL API */
export interface ApiKey extends Node {
  __typename: 'ApiKey';
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['ID']['output'];
  rateLimitPerMinute: Scalars['Int']['output'];
  token: Scalars['String']['output'];
}

export interface AppearanceBoostShopItem extends Node, ShopItemInterface {
  __typename: 'AppearanceBoostShopItem';
  boostBasisPoints: Scalars['Int']['output'];
  cardCollectionRequirements: Array<CardCollectionRequirement>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  disabled: Scalars['Boolean']['output'];
  expirationDate?: Maybe<Scalars['ISO8601DateTime']['output']>;
  id: Scalars['ID']['output'];
  infoLink?: Maybe<Scalars['String']['output']>;
  limitPerUser: Scalars['Int']['output'];
  myAvailableTotalPurchasesCount: Scalars['Int']['output'];
  myAvailableUserShopItems?: Maybe<Array<UserShopItem>>;
  myBalance: Scalars['Int']['output'];
  myLimitResetAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  myPurchasesCount: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  pictureUrl: Scalars['String']['output'];
  position: ShopItemType;
  price: Scalars['Int']['output'];
  rarity: Rarity;
  requirementsRulesLink?: Maybe<Scalars['String']['output']>;
  salePrice?: Maybe<Scalars['Int']['output']>;
  shopItemsRequired: Array<ShopItem>;
  threeDimensionalAssetUrl?: Maybe<Scalars['String']['output']>;
  unlocked: Scalars['Boolean']['output'];
}


export interface AppearanceBoostShopItempictureUrlArgs {
  derivative?: InputMaybe<ShopItemDerivative>;
}


export interface AppearanceBoostShopItemthreeDimensionalAssetUrlArgs {
  format?: InputMaybe<ShopItemThreeDimensionalAssetFormat>;
}

/** An Appearance - a card picked for a lineup */
export interface AppearanceInput {
  captain?: InputMaybe<Scalars['Boolean']['input']>;
  cardSlug?: InputMaybe<Scalars['String']['input']>;
  composeTeamBenchObjectId?: InputMaybe<Scalars['ID']['input']>;
  gameId?: InputMaybe<Scalars['ID']['input']>;
  index: Scalars['Int']['input'];
}

/** Appearance interface */
export interface AppearanceInterface {
  activeSuspensions: Array<Suspension>;
  anyCard?: Maybe<BaseballCard | Card | NBACard>;
  anyCardWithLivePrimaryOffer?: Maybe<BaseballCard | Card | NBACard>;
  anyPlayer: BaseballPlayer | NBAPlayer | Player;
  averageScore?: Maybe<Scalars['Float']['output']>;
  bonus?: Maybe<Scalars['Float']['output']>;
  bonusPoints?: Maybe<Scalars['Float']['output']>;
  bonusRating?: Maybe<BonusOrdinalRatingEnum>;
  captain: Scalars['Boolean']['output'];
  cardBorderRadius: Scalars['Int']['output'];
  eligiblePlayerGameScores: Array<BaseballPlayerGameScore | BasketballPlayerGameScore | PlayerGameScore | So5Score>;
  /**
   * Projected score minus the lowest score of the player star tier for NBA, minus
   * the L10 average otherwise, from the projection the bench sorts
   * GAIN_ON_PROJECTION on: the next game on a card bench with no fixture, the
   * fixture projection otherwise
   */
  gainOnProjection?: Maybe<Scalars['Float']['output']>;
  id: Scalars['ID']['output'];
  index: Scalars['Int']['output'];
  licensed: Scalars['Boolean']['output'];
  /** When a bench object will be locked for a leaderboard */
  lockedAt: Scalars['ISO8601DateTime']['output'];
  /** Wether a bench object can be updated for a leaderboard */
  lockedForLeaderboard: Scalars['Boolean']['output'];
  pictureUrl?: Maybe<Scalars['String']['output']>;
  playedGames: Array<Game | GameOfBaseball | GameOfBasketball>;
  player: Player;
  playerGameScore?: Maybe<BaseballPlayerGameScore | BasketballPlayerGameScore | PlayerGameScore | So5Score>;
  position: Position;
  positions: Array<Position>;
  powerBreakdown: PowerBreakdown;
  /** PowerBreakdown as long as leaderboard is playable. PowerPointsBreakdown after */
  powerBreakdownOrPowerPointsBreakdown?: Maybe<PowerBreakdownOrPowerPointsBreakdown>;
  projectedScore?: Maybe<Scalars['Float']['output']>;
  rarity: Rarity;
  score: Scalars['Float']['output'];
  scoreStatus: ScoreStatus;
  upcomingGame?: Maybe<Game | GameOfBaseball | GameOfBasketball>;
  videoUrl?: Maybe<Scalars['String']['output']>;
}


/** Appearance interface */
export interface AppearanceInterfaceactiveSuspensionsArgs {
  so5LeaderboardSlug?: InputMaybe<Scalars['String']['input']>;
}


/** Appearance interface */
export interface AppearanceInterfaceanyCardWithLivePrimaryOfferArgs {
  rarity?: InputMaybe<Rarity>;
}


/** Appearance interface */
export interface AppearanceInterfaceaverageScoreArgs {
  type: AveragePlayerScore;
}


/** Appearance interface */
export interface AppearanceInterfaceeligiblePlayerGameScoresArgs {
  boardId?: InputMaybe<Scalars['String']['input']>;
  gameId?: InputMaybe<Scalars['ID']['input']>;
  so5LeaderboardSlug?: InputMaybe<Scalars['String']['input']>;
  stepId?: InputMaybe<Scalars['String']['input']>;
  taskId?: InputMaybe<Scalars['ID']['input']>;
}


/** Appearance interface */
export interface AppearanceInterfacelockedAtArgs {
  so5LeaderboardSlug?: InputMaybe<Scalars['String']['input']>;
}


/** Appearance interface */
export interface AppearanceInterfacelockedForLeaderboardArgs {
  so5LeaderboardSlug?: InputMaybe<Scalars['String']['input']>;
}


/** Appearance interface */
export interface AppearanceInterfacepictureUrlArgs {
  derivative?: InputMaybe<Scalars['String']['input']>;
}


/** Appearance interface */
export interface AppearanceInterfaceprojectedScoreArgs {
  so5LeaderboardSlug: Scalars['String']['input'];
}


/** Appearance interface */
export interface AppearanceInterfacescoreArgs {
  withBonus?: InputMaybe<Scalars['Boolean']['input']>;
}


/** Appearance interface */
export interface AppearanceInterfacevideoUrlArgs {
  derivative?: InputMaybe<Scalars['String']['input']>;
}

export interface AppearanceRule {
  __typename: 'AppearanceRule';
  /** Set on collaborative lineups only: the user filling the slot. */
  contributor?: Maybe<User>;
  displayName?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  positions: Array<Position>;
  shortName?: Maybe<Scalars['String']['output']>;
  sub: Scalars['Boolean']['output'];
}

/** Apple Pay Payment Data */
export interface ApplePayPaymentDataInput {
  network: Scalars['String']['input'];
  /** JSON-serialized encoded payment token data */
  tokenData: Scalars['String']['input'];
  transactionId: Scalars['String']['input'];
}

/** An Apple purchase token */
export interface ApplePurchaseToken extends Node {
  __typename: 'ApplePurchaseToken';
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['ID']['output'];
  token: Scalars['String']['output'];
  user: User;
}

export const AssetVariant = {
  DESKTOP: 'DESKTOP',
  MOBILE: 'MOBILE'
} as const;

export type AssetVariant = typeof AssetVariant[keyof typeof AssetVariant];
/** A user notification regarding an Auction */
export interface AuctionNotification extends Node, NotificationInterface {
  __typename: 'AuctionNotification';
  bidToEarnReward?: Maybe<BidToEarnReward>;
  bidToEarnRewards?: Maybe<Array<BidToEarnReward>>;
  body: Scalars['String']['output'];
  createdAt: Scalars['ISO8601DateTime']['output'];
  deeplinkUrl: Scalars['String']['output'];
  iconUrl: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  important: Scalars['Boolean']['output'];
  markdownBody: Scalars['String']['output'];
  name: Scalars['String']['output'];
  pictureUrl?: Maybe<Scalars['String']['output']>;
  read: Scalars['Boolean']['output'];
  rewards?: Maybe<Array<AnyCardReward | AnyConversionCreditReward | CardPackReward | CardShardsReward | CoinReward | DeliverableItemReward | ExperienceReward | InGameCurrencyReward | MonetaryReward | ProbabilisticBundleReward | ShopItemReward>>;
  sport?: Maybe<SportOrShared>;
  title: Scalars['String']['output'];
  tokenAuction: TokenAuction;
  tokenBid?: Maybe<TokenBid>;
  url: Scalars['String']['output'];
  user: CurrentUser;
}

/** A reminder on an auction */
export interface AuctionReminder extends Node {
  __typename: 'AuctionReminder';
  enabled: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  tokenAuction: TokenAuction;
}

/** The connection type for AuctionReminder. */
export interface AuctionReminderConnection {
  __typename: 'AuctionReminderConnection';
  /** A list of edges. */
  edges: Array<AuctionReminderEdge>;
  /** A list of nodes. */
  nodes: Array<AuctionReminder>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
}

/** An edge in a connection. */
export interface AuctionReminderEdge {
  __typename: 'AuctionReminderEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<AuctionReminder>;
}

export interface AuthorizationApprovalInput {
  ethereumBankConditionalTransferApproval?: InputMaybe<EthereumBankConditionalTransferApprovalInput>;
  ethereumBankTransferApproval?: InputMaybe<EthereumBankTransferApprovalInput>;
  fingerprint: Scalars['String']['input'];
  mangopayApplePayApproval?: InputMaybe<MangopayApplePayApprovalInput>;
  mangopayWalletTransferApproval?: InputMaybe<MangopayWalletTransferApprovalInput>;
  solanaBankConditionalTransferApproval?: InputMaybe<SolanaBankConditionalTransferApprovalInput>;
  solanaBankTransferApproval?: InputMaybe<SolanaBankTransferApprovalInput>;
  solanaTokenTransferApproval?: InputMaybe<SolanaTokenTransferApprovalInput>;
  starkexLimitOrderApproval?: InputMaybe<StarkexApprovalInput>;
  starkexTransferApproval?: InputMaybe<StarkexApprovalInput>;
}

/** Object that can be an operation of an Authorization */
export type AuthorizationOperation = TokenAuction | TokenBid | TokenOffer | TokenPrimaryOffer;

export interface AuthorizationRequest extends Node {
  __typename: 'AuthorizationRequest';
  cancelledAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  consumedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  fingerprint: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  operation: AuthorizationOperation;
  provisionedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  request: Request;
  reservedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  status: AuthorizationStatus;
}

/** The connection type for AuthorizationRequest. */
export interface AuthorizationRequestConnection {
  __typename: 'AuthorizationRequestConnection';
  /** A list of edges. */
  edges: Array<AuthorizationRequestEdge>;
  /** A list of nodes. */
  nodes: Array<AuthorizationRequest>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
}

/** An edge in a connection. */
export interface AuthorizationRequestEdge {
  __typename: 'AuthorizationRequestEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<AuthorizationRequest>;
}

export const AuthorizationStatus = {
  CANCELLED: 'CANCELLED',
  CONSUMED: 'CONSUMED',
  CREATED: 'CREATED',
  PROVISIONED: 'PROVISIONED',
  RESERVED: 'RESERVED'
} as const;

export type AuthorizationStatus = typeof AuthorizationStatus[keyof typeof AuthorizationStatus];
/** A user notification regarding an auto claim. */
export interface AutoClaimNotification extends Node, NotificationInterface {
  __typename: 'AutoClaimNotification';
  anyCard?: Maybe<BaseballCard | Card | NBACard>;
  body: Scalars['String']['output'];
  cardShardRewardConfig?: Maybe<CardShardRewardConfig>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  deeplinkUrl: Scalars['String']['output'];
  iconUrl: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  important: Scalars['Boolean']['output'];
  markdownBody: Scalars['String']['output'];
  name: Scalars['String']['output'];
  pictureUrl?: Maybe<Scalars['String']['output']>;
  read: Scalars['Boolean']['output'];
  sport?: Maybe<SportOrShared>;
  task?: Maybe<CardsCountTargetTask | CardsCountTask | CompleteCollectionsCountTargetTask | CompleteCollectionsCountTask | DailyActionTask | DecisivePlayerPickerTask | DropChallengeTask | GameWeeklyTask | GuessTheScoreTask | InviteTaskAsReferrer | So5LeaderboardTask | StarPackTask | Task | TasksTrack | ThresholdPickerTask | ThresholdsDuoConnectionTask | ThresholdsStreakAdditionalLineupTask | ThresholdsStreakTask>;
  title: Scalars['String']['output'];
  user: CurrentUser;
}

/** Available Balances */
export interface AvailableBalances {
  __typename: 'AvailableBalances';
  eurCents: MonetaryAmount;
  gbpCents: MonetaryAmount;
  lamport: MonetaryAmount;
  usdCents: MonetaryAmount;
  wei: MonetaryAmount;
}

/** A player average last score */
export interface AverageLastScore extends AverageLastScoreInterface, Node {
  __typename: 'AverageLastScore';
  averageValueAllAround: Scalars['Float']['output'];
  averageValueDecisive: Scalars['Float']['output'];
  averageValueTotal: Scalars['Float']['output'];
  id: Scalars['ID']['output'];
  lastIndividualScores: Array<Maybe<Scalars['Float']['output']>>;
  lastIndividualStats: Array<BaseballAverageStatWithValueType | BasketballAverageStatWithValueType | FootballAverageStatWithValueType>;
  percentageOfGamesPlayed: Scalars['Float']['output'];
}

export interface AverageLastScoreInterface {
  id: Scalars['ID']['output'];
  lastIndividualScores: Array<Maybe<Scalars['Float']['output']>>;
  lastIndividualStats: Array<BaseballAverageStatWithValueType | BasketballAverageStatWithValueType | FootballAverageStatWithValueType>;
  percentageOfGamesPlayed: Scalars['Float']['output'];
}

export const AverageLastScoreLocation = {
  AWAY: 'AWAY',
  HOME: 'HOME'
} as const;

export type AverageLastScoreLocation = typeof AverageLastScoreLocation[keyof typeof AverageLastScoreLocation];
export const AverageLastScoreSpan = {
  LAST_FIFTEEN: 'LAST_FIFTEEN',
  LAST_FIVE: 'LAST_FIVE',
  LAST_FORTY: 'LAST_FORTY',
  LAST_TEN: 'LAST_TEN',
  SEASON: 'SEASON'
} as const;

export type AverageLastScoreSpan = typeof AverageLastScoreSpan[keyof typeof AverageLastScoreSpan];
export const AverageLimit = {
  LAST_5: 'LAST_5',
  LAST_10: 'LAST_10',
  LAST_15: 'LAST_15',
  LAST_40: 'LAST_40',
  SEASON: 'SEASON'
} as const;

export type AverageLimit = typeof AverageLimit[keyof typeof AverageLimit];
export const AveragePlayerScore = {
  LAST_FIFTEEN_AVERAGE_ALL_AROUND_SCORE: 'LAST_FIFTEEN_AVERAGE_ALL_AROUND_SCORE',
  LAST_FIFTEEN_AVERAGE_DECISIVE_SCORE: 'LAST_FIFTEEN_AVERAGE_DECISIVE_SCORE',
  LAST_FIFTEEN_SO5_AVERAGE_SCORE: 'LAST_FIFTEEN_SO5_AVERAGE_SCORE',
  LAST_FIVE_AVERAGE_ALL_AROUND_SCORE: 'LAST_FIVE_AVERAGE_ALL_AROUND_SCORE',
  LAST_FIVE_AVERAGE_DECISIVE_SCORE: 'LAST_FIVE_AVERAGE_DECISIVE_SCORE',
  LAST_FIVE_SO5_AVERAGE_SCORE: 'LAST_FIVE_SO5_AVERAGE_SCORE',
  LAST_FORTY_AVERAGE_ALL_AROUND_SCORE: 'LAST_FORTY_AVERAGE_ALL_AROUND_SCORE',
  LAST_FORTY_AVERAGE_DECISIVE_SCORE: 'LAST_FORTY_AVERAGE_DECISIVE_SCORE',
  LAST_FORTY_SO5_AVERAGE_SCORE: 'LAST_FORTY_SO5_AVERAGE_SCORE',
  LAST_TEN_PLAYED_AVERAGE_ALL_AROUND_SCORE: 'LAST_TEN_PLAYED_AVERAGE_ALL_AROUND_SCORE',
  LAST_TEN_PLAYED_AVERAGE_DECISIVE_SCORE: 'LAST_TEN_PLAYED_AVERAGE_DECISIVE_SCORE',
  LAST_TEN_PLAYED_SO5_AVERAGE_SCORE: 'LAST_TEN_PLAYED_SO5_AVERAGE_SCORE',
  SEASON_AVERAGE_SCORE: 'SEASON_AVERAGE_SCORE'
} as const;

export type AveragePlayerScore = typeof AveragePlayerScore[keyof typeof AveragePlayerScore];
export interface AverageScoreOpenBoundaries {
  __typename: 'AverageScoreOpenBoundaries';
  averageType: AveragePlayerScore;
  count: Scalars['Int']['output'];
  max?: Maybe<Scalars['Int']['output']>;
  min?: Maybe<Scalars['Int']['output']>;
}

export const AverageScoreTeamMode = {
  ALL: 'ALL',
  CLUB: 'CLUB',
  NATIONAL_TEAM: 'NATIONAL_TEAM'
} as const;

export type AverageScoreTeamMode = typeof AverageScoreTeamMode[keyof typeof AverageScoreTeamMode];
export interface AverageScoresRule {
  __typename: 'AverageScoresRule';
  immuneAppearances?: Maybe<Scalars['Int']['output']>;
  max: Scalars['Int']['output'];
}

export const AverageStat = {
  ACCURATE_KEEPER_SWEEPER: 'ACCURATE_KEEPER_SWEEPER',
  ACCURATE_LONG_BALLS: 'ACCURATE_LONG_BALLS',
  ACCURATE_PASS: 'ACCURATE_PASS',
  ASSIST_PENALTY_WON: 'ASSIST_PENALTY_WON',
  ATT_FREEKICK_TOTAL: 'ATT_FREEKICK_TOTAL',
  ATT_PEN_GOAL: 'ATT_PEN_GOAL',
  ATT_PEN_MISS: 'ATT_PEN_MISS',
  ATT_PEN_POST: 'ATT_PEN_POST',
  ATT_PEN_TARGET: 'ATT_PEN_TARGET',
  BIG_CHANCE_CREATED: 'BIG_CHANCE_CREATED',
  BIG_CHANCE_MISSED: 'BIG_CHANCE_MISSED',
  CLEAN_SHEET: 'CLEAN_SHEET',
  CLEAN_SHEET_60: 'CLEAN_SHEET_60',
  CLEARANCE_OFF_LINE: 'CLEARANCE_OFF_LINE',
  CORNER_TAKEN: 'CORNER_TAKEN',
  CROSS_ACCURACY: 'CROSS_ACCURACY',
  CROSS_NOT_CLAIMED: 'CROSS_NOT_CLAIMED',
  DIVE_CATCH: 'DIVE_CATCH',
  DIVE_SAVE: 'DIVE_SAVE',
  DUEL_LOST: 'DUEL_LOST',
  DUEL_WON: 'DUEL_WON',
  EFFECTIVE_CLEARANCE: 'EFFECTIVE_CLEARANCE',
  ERROR_LEAD_TO_GOAL: 'ERROR_LEAD_TO_GOAL',
  ERROR_LEAD_TO_SHOT: 'ERROR_LEAD_TO_SHOT',
  FORMATION_PLACE: 'FORMATION_PLACE',
  FOULS: 'FOULS',
  FREEKICK_CROSS: 'FREEKICK_CROSS',
  GAME_STARTED: 'GAME_STARTED',
  GK_SMOTHER: 'GK_SMOTHER',
  GOALS: 'GOALS',
  GOALS_CONCEDED: 'GOALS_CONCEDED',
  GOAL_ASSIST: 'GOAL_ASSIST',
  GOAL_KICKS: 'GOAL_KICKS',
  GOOD_HIGH_CLAIM: 'GOOD_HIGH_CLAIM',
  INTERCEPTION_WON: 'INTERCEPTION_WON',
  LAST_MAN_TACKLE: 'LAST_MAN_TACKLE',
  LOST_CORNERS: 'LOST_CORNERS',
  MINS_PLAYED: 'MINS_PLAYED',
  MISSED_PASS: 'MISSED_PASS',
  ONTARGET_SCORING_ATT: 'ONTARGET_SCORING_ATT',
  OWN_GOALS: 'OWN_GOALS',
  PARRIES: 'PARRIES',
  PASS_ACCURACY: 'PASS_ACCURACY',
  PENALTIES_SAVED: 'PENALTIES_SAVED',
  PENALTY_CONCEDED: 'PENALTY_CONCEDED',
  PENALTY_KICK_MISSED: 'PENALTY_KICK_MISSED',
  PENALTY_SAVE: 'PENALTY_SAVE',
  PENALTY_TAKEN: 'PENALTY_TAKEN',
  PENALTY_WON: 'PENALTY_WON',
  PEN_AREA_ENTRIES: 'PEN_AREA_ENTRIES',
  POSS_LOST_CTRL: 'POSS_LOST_CTRL',
  POSS_WON: 'POSS_WON',
  PUNCHES: 'PUNCHES',
  RED_CARD: 'RED_CARD',
  SAVED_IBOX: 'SAVED_IBOX',
  SAVES: 'SAVES',
  SET_PIECE_TAKEN: 'SET_PIECE_TAKEN',
  SHOT_ACCURACY: 'SHOT_ACCURACY',
  SHOT_EFFICIENCY: 'SHOT_EFFICIENCY',
  SINGLE_GOAL_GAME: 'SINGLE_GOAL_GAME',
  SIX_SECOND_VIOLATION: 'SIX_SECOND_VIOLATION',
  SUCCESSFUL_FINAL_THIRD_PASSES: 'SUCCESSFUL_FINAL_THIRD_PASSES',
  THREE_GOALS_CONCEDED: 'THREE_GOALS_CONCEDED',
  TOTAL_CLEARANCE: 'TOTAL_CLEARANCE',
  TOTAL_PASS: 'TOTAL_PASS',
  TOTAL_SCORING_ATT: 'TOTAL_SCORING_ATT',
  TOTAL_TACKLE: 'TOTAL_TACKLE',
  WAS_FOULED: 'WAS_FOULED',
  WON_CONTEST: 'WON_CONTEST',
  WON_TACKLE: 'WON_TACKLE',
  YELLOW_CARD: 'YELLOW_CARD'
} as const;

export type AverageStat = typeof AverageStat[keyof typeof AverageStat];
export interface BackupPrivateKeyRecoveryInput {
  encryptedSymmetricKey: Scalars['String']['input'];
  iv: Scalars['String']['input'];
  payload: Scalars['String']['input'];
  rsaEncryptionKey?: InputMaybe<Scalars['String']['input']>;
  rsaPublicKey: Scalars['String']['input'];
}

/** A Mangopay bank account type */
export type BankAccount = CaBankAccount | GbBankAccount | IbanBankAccount | OtherBankAccount | UsBankAccount;

/** The connection type for BankAccount. */
export interface BankAccountConnection {
  __typename: 'BankAccountConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<BankAccountEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<BankAccount>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
}

/** An edge in a connection. */
export interface BankAccountEdge {
  __typename: 'BankAccountEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<BankAccount>;
}

/** Bank account interface */
export interface BankAccountInterface {
  country: Country;
  id: Scalars['ID']['output'];
  minimumWithdrawalAmounts: MonetaryAmount;
  ownerAddress?: Maybe<MangopayBankAccountOwnerAddress>;
  ownerName?: Maybe<Scalars['String']['output']>;
  status?: Maybe<MangopayBankAccountStatus>;
  withdrawalFeeAmounts: MonetaryAmount;
  withdrawalFeeType: MangopayBankAccountWithdrawalFeeType;
}

/** A Mangopay Bank Account Owner Address object */
export interface BankAccountOwnerAddressInput {
  addressLine1: Scalars['String']['input'];
  addressLine2?: InputMaybe<Scalars['String']['input']>;
  city: Scalars['String']['input'];
  countryCode: Scalars['String']['input'];
  postalCode: Scalars['String']['input'];
  region?: InputMaybe<Scalars['String']['input']>;
}

export const BankAccountType = {
  CA: 'CA',
  GB: 'GB',
  IBAN: 'IBAN',
  OTHER: 'OTHER',
  US: 'US'
} as const;

export type BankAccountType = typeof BankAccountType[keyof typeof BankAccountType];
/** A bank withdrawal */
export interface BankWithdrawal extends Node {
  __typename: 'BankWithdrawal';
  blockchain: Blockchain;
  createdAt: Scalars['ISO8601DateTime']['output'];
  feeAmount: MonetaryAmount;
  id: Scalars['ID']['output'];
  status: WithdrawalStatus;
  to: Scalars['String']['output'];
  transactionHash?: Maybe<Scalars['String']['output']>;
  user: User;
  withdrawalAmount: MonetaryAmount;
}

/** A player average last score */
export interface BaseAverageLastScore extends AverageLastScoreInterface, Node {
  __typename: 'BaseAverageLastScore';
  id: Scalars['ID']['output'];
  lastIndividualScores: Array<Maybe<Scalars['Float']['output']>>;
  lastIndividualStats: Array<BaseballAverageStatWithValueType | BasketballAverageStatWithValueType | FootballAverageStatWithValueType>;
  percentageOfGamesPlayed: Scalars['Float']['output'];
}

/** A base withdrawal authorization request */
export interface BaseWithdrawalAuthorizationRequest {
  __typename: 'BaseWithdrawalAuthorizationRequest';
  amount: Scalars['CryptocurrencyAmount']['output'];
  contractAddress: Scalars['String']['output'];
  deadline: Scalars['String']['output'];
  destinationAddress: Scalars['String']['output'];
  feeAmount: Scalars['CryptocurrencyAmount']['output'];
  proxyAddress: Scalars['String']['output'];
  receiverAddress: Scalars['String']['output'];
  salt: Scalars['String']['output'];
  senderAddress: Scalars['String']['output'];
}

export const BaseballAverageStatType = {
  HITTING_AT_BASE: 'HITTING_AT_BASE',
  HITTING_AT_PLATE: 'HITTING_AT_PLATE',
  HITTING_CAUGHT_STEALING: 'HITTING_CAUGHT_STEALING',
  HITTING_DOUBLES: 'HITTING_DOUBLES',
  HITTING_HIT_BY_PITCH: 'HITTING_HIT_BY_PITCH',
  HITTING_HOME_RUNS: 'HITTING_HOME_RUNS',
  HITTING_RUNS: 'HITTING_RUNS',
  HITTING_RUNS_BATTED_IN: 'HITTING_RUNS_BATTED_IN',
  HITTING_SINGLES: 'HITTING_SINGLES',
  HITTING_STOLEN_BASES: 'HITTING_STOLEN_BASES',
  HITTING_STRIKEOUTS: 'HITTING_STRIKEOUTS',
  HITTING_TRIPLES: 'HITTING_TRIPLES',
  HITTING_WALKS: 'HITTING_WALKS',
  PITCHING_EARNED_RUNS: 'PITCHING_EARNED_RUNS',
  PITCHING_HITS_ALLOWED: 'PITCHING_HITS_ALLOWED',
  PITCHING_HIT_BATSMEN: 'PITCHING_HIT_BATSMEN',
  PITCHING_HOLDS: 'PITCHING_HOLDS',
  PITCHING_INNINGS_PITCHED: 'PITCHING_INNINGS_PITCHED',
  PITCHING_NO_HITTERS: 'PITCHING_NO_HITTERS',
  PITCHING_PITCH_COUNT: 'PITCHING_PITCH_COUNT',
  PITCHING_RELIEF_APPEARANCE: 'PITCHING_RELIEF_APPEARANCE',
  PITCHING_SAVES: 'PITCHING_SAVES',
  PITCHING_STRIKEOUTS: 'PITCHING_STRIKEOUTS',
  PITCHING_WALKS: 'PITCHING_WALKS',
  PITCHING_WINS: 'PITCHING_WINS'
} as const;

export type BaseballAverageStatType = typeof BaseballAverageStatType[keyof typeof BaseballAverageStatType];
export interface BaseballAverageStatWithValueType extends AnyAverageStatWithValueInterface {
  __typename: 'BaseballAverageStatWithValueType';
  lastValues?: Maybe<Array<Scalars['Float']['output']>>;
  stat: BaseballAverageStatType;
  value?: Maybe<Scalars['Float']['output']>;
}

/** A baseball card */
export interface BaseballCard extends AnyCardInterface, Node, WithSubscriptionsInterface {
  __typename: 'BaseballCard';
  activeSuspensions: Array<Suspension>;
  activeTaskAppearances: Array<DecisivePlayerPickerTaskAppearance | TaskAppearance | ThresholdPickerTaskAppearance>;
  anyPlayer: BaseballPlayer | NBAPlayer | Player;
  anyPositions: Array<Position>;
  anyTeam: Club | NationalTeam;
  assetId: Scalars['ID']['output'];
  availableCardBoosts: Array<CardBoost>;
  averageScore?: Maybe<Scalars['Float']['output']>;
  backPictureUrl: Scalars['String']['output'];
  baseballPlayer: BaseballPlayer;
  blueprint?: Maybe<Blueprint>;
  bonuses: Array<So5ActiveClubsBonus | So5AverageScoresBonus | So5BoostBonus | So5CaptainBonus | So5CollectionBonus | So5DifferentNationalitiesBonus | So5GradeBonus | So5LineupBonus | So5MalusAfterTransferBonus | So5NationalityBonus | So5PlayerBonus | So5PositionBonus | So5PositionStacksBonus | So5SameActiveClubBonus | So5ScarcityBonus | So5SeasonBonus | So5SpecialEditionCardsBonus>;
  bonusesAfterTransfer: Array<So5ActiveClubsBonus | So5AverageScoresBonus | So5BoostBonus | So5CaptainBonus | So5CollectionBonus | So5DifferentNationalitiesBonus | So5GradeBonus | So5LineupBonus | So5MalusAfterTransferBonus | So5NationalityBonus | So5PlayerBonus | So5PositionBonus | So5PositionStacksBonus | So5SameActiveClubBonus | So5ScarcityBonus | So5SeasonBonus | So5SpecialEditionCardsBonus>;
  borderRadius: Scalars['Int']['output'];
  cardBackgroundUrl?: Maybe<Scalars['String']['output']>;
  cardBackgroundVideoUrl?: Maybe<Scalars['String']['output']>;
  cardCollectionCards: Array<CardCollectionCard>;
  cardEditionName?: Maybe<Scalars['String']['output']>;
  /** @deprecated Not used anymore */
  cardPrice?: Maybe<Scalars['Int']['output']>;
  cardSet?: Maybe<CardSet>;
  cardStats?: Maybe<CardStats>;
  collection?: Maybe<Collection>;
  collectionIncreaseScoreBreakdownAfterTransfer?: Maybe<CardCollectionCardScoreBreakdown>;
  collectionScoringMatrix: Array<CardCollectionScoringMatrix>;
  concurrentSo5Lineups: Array<So5Lineup>;
  contractAddress?: Maybe<Scalars['EthereumAddress']['output']>;
  currentUserSubscription?: Maybe<EmailSubscription>;
  decks: Array<Deck>;
  delayedReveal?: Maybe<Scalars['Boolean']['output']>;
  displayRarity: Scalars['String']['output'];
  /** @deprecated Not used anymore */
  dropRank?: Maybe<Scalars['Int']['output']>;
  eligibleBoards: Array<CareerBoard | SquadBoard>;
  /** Eligible boards on which the card earns a special edition cards bonus */
  eligibleBoardsWithSpecialEditionBonus: Array<BoardWithSpecialEditionBonus>;
  eligiblePlayerGameScores: Array<BaseballPlayerGameScore | BasketballPlayerGameScore | PlayerGameScore | So5Score>;
  eligibleUpcomingLeagueTracks: Array<So5LeagueTrack>;
  ethereumId: Scalars['String']['output'];
  ethereumOwner?: Maybe<TokenOwner>;
  formattedCardEditionName?: Maybe<Scalars['String']['output']>;
  /** Current card level */
  grade: Scalars['Int']['output'];
  gradeAfterTransfer: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  inSeasonEligible: Scalars['Boolean']['output'];
  inSeasonUntil?: Maybe<Scalars['ISO8601DateTime']['output']>;
  ipfsPictureUrl?: Maybe<Scalars['String']['output']>;
  ipfsUrl?: Maybe<Scalars['String']['output']>;
  lastLeveledUpAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  latestEnglishAuction?: Maybe<TokenAuction>;
  latestPrimaryOffer?: Maybe<TokenPrimaryOffer>;
  levelUpAppliedCount: Scalars['Int']['output'];
  livePrimaryOffer?: Maybe<TokenPrimaryOffer>;
  liveSingleBuyOffers: Array<TokenOffer>;
  liveSingleSaleOffer?: Maybe<TokenOffer>;
  /** So5Lineup that this card is being used in for the live So5Fixture */
  liveSo5Lineup?: Maybe<So5Lineup>;
  loanedToken?: Maybe<LoanedToken>;
  /** Returns the lowest price card of the same player, rarity, season and print batch */
  lowestPriceCard?: Maybe<BaseballCard | Card | NBACard>;
  /** Returns the lowest price card of the same player and rarity */
  lowestPriceCardAnySeason?: Maybe<BaseballCard | Card | NBACard>;
  maxLevelUpAppliedCount: Scalars['Int']['output'];
  myCardCollectionSlot?: Maybe<UserCardCollectionSlot>;
  myMintedSingleSaleOffer?: Maybe<TokenOffer>;
  name: Scalars['String']['output'];
  nextLevelUpAvailableAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** So5Lineups that this card is being used in for the opened So5Fixtures */
  openedSo5Lineups: Array<So5Lineup>;
  ownerSince?: Maybe<Scalars['ISO8601DateTime']['output']>;
  ownershipHistory: Array<TokenOwner>;
  pack?: Maybe<Pack>;
  pendingWithdrawal?: Maybe<TokenWithdrawal>;
  pictureUrl?: Maybe<Scalars['String']['output']>;
  /** @deprecated Player loyalty is no longer used */
  playerLoyaltyBoost: RewardBoost;
  /** Total card bonus (XP + Season bonus) */
  power: Scalars['String']['output'];
  /** Total card bonus after transfer */
  powerAfterTransfer: Scalars['String']['output'];
  powerBreakdown: PowerBreakdown;
  powerMalusAfterTransfer: Scalars['String']['output'];
  previouslyOwnedCard?: Maybe<Scalars['Boolean']['output']>;
  previouslyOwnedPlayer?: Maybe<Scalars['Boolean']['output']>;
  priceRange?: Maybe<Range>;
  /** Print batch of the card, 0 for the original print of that player, rarity and season */
  printBatch: Scalars['Int']['output'];
  privateMinPrices?: Maybe<MonetaryAmount>;
  publicMinPrices?: Maybe<MonetaryAmount>;
  rarityTyped: Rarity;
  /**
   * The `related_card_edition_slots` field cannot be nested within a list.
   * @deprecated Use myCardCollectionSlot.relatedCardEditionSlots instead
   */
  relatedCardEditionSlots?: Maybe<Array<UserCardCollectionSlot>>;
  revealableCardCampaign?: Maybe<RevealableCardCampaign>;
  sealable: Scalars['Boolean']['output'];
  sealableFor?: Maybe<Scalars['Int']['output']>;
  sealed: Scalars['Boolean']['output'];
  sealedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  sealedFor?: Maybe<Scalars['Int']['output']>;
  /** @deprecated Player loyalty is no longer used */
  sealedPlayerLoyaltyBoost: RewardBoost;
  seasonYear: Scalars['Int']['output'];
  secondaryMarketFeeEnabled: Scalars['Boolean']['output'];
  /**
   * Returns all live or minted offers where this token is included in the sender
   * side. Returns only if authenticated and sender of the offers.
   */
  sentInLiveOffers?: Maybe<Array<TokenOffer>>;
  serialNumber: Scalars['Int']['output'];
  /** Whether this card qualifies for the social feed */
  shareable: Scalars['Boolean']['output'];
  /** Whether the current user already shared this card */
  shared: Scalars['Boolean']['output'];
  /** @deprecated Not used anymore */
  signedAddCardPrice?: Maybe<SignedCardPrice>;
  signedDropCardPrice?: Maybe<SignedCardPrice>;
  singleCivilYear: Scalars['Boolean']['output'];
  skinEdition?: Maybe<SkinEdition>;
  slug: Scalars['String']['output'];
  solanaAddress?: Maybe<Scalars['String']['output']>;
  solanaBlockExplorerUrl?: Maybe<Scalars['String']['output']>;
  specialEdition?: Maybe<Scalars['String']['output']>;
  sport: Sport;
  sportSeason: SportSeason;
  subscriptionsCount: Scalars['Int']['output'];
  supply: Scalars['Int']['output'];
  threeDimensional: Scalars['Boolean']['output'];
  threeDimensionalAsset?: Maybe<ThreeDimensionalAsset>;
  tokenOwner?: Maybe<TokenOwner>;
  tradeableStatus: Tradeable;
  unsealableAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  unsealedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** @deprecated Player loyalty is no longer used */
  unsealedPlayerLoyaltyBoost: RewardBoost;
  usedIn?: Maybe<ListedOnMarket | UsedInSo5Lineups | UsedInTaskLineups | UsedInTaskPreparedLineups | UsedInTasks>;
  user?: Maybe<User>;
  videoUrl?: Maybe<Scalars['String']['output']>;
  walletStatus: WalletStatus;
  xp: Scalars['Int']['output'];
  xpAfterTransfer: Scalars['Int']['output'];
  /** XP start range of current card level */
  xpNeededForCurrentGrade: Scalars['Int']['output'];
  /** XP end range of current card level */
  xpNeededForNextGrade?: Maybe<Scalars['Int']['output']>;
}


/** A baseball card */
export interface BaseballCardactiveSuspensionsArgs {
  so5LeaderboardSlug?: InputMaybe<Scalars['String']['input']>;
}


/** A baseball card */
export interface BaseballCardaverageScoreArgs {
  type: AveragePlayerScore;
}


/** A baseball card */
export interface BaseballCardbonusesArgs {
  highlighted?: InputMaybe<Scalars['Boolean']['input']>;
  so5LeaderboardSlug?: InputMaybe<Scalars['String']['input']>;
}


/** A baseball card */
export interface BaseballCardbonusesAfterTransferArgs {
  so5LeaderboardSlug?: InputMaybe<Scalars['String']['input']>;
}


/** A baseball card */
export interface BaseballCardcardBackgroundVideoUrlArgs {
  derivative?: InputMaybe<Scalars['String']['input']>;
}


/** A baseball card */
export interface BaseballCardconcurrentSo5LineupsArgs {
  so5FixtureSlug?: InputMaybe<Scalars['String']['input']>;
  so5LeaderboardSlug?: InputMaybe<Scalars['String']['input']>;
}


/** A baseball card */
export interface BaseballCardeligiblePlayerGameScoresArgs {
  boardId?: InputMaybe<Scalars['String']['input']>;
  gameId?: InputMaybe<Scalars['ID']['input']>;
  so5LeaderboardSlug?: InputMaybe<Scalars['String']['input']>;
  stepId?: InputMaybe<Scalars['String']['input']>;
  taskId?: InputMaybe<Scalars['ID']['input']>;
}


/** A baseball card */
export interface BaseballCardpictureUrlArgs {
  derivative?: InputMaybe<Scalars['String']['input']>;
}


/** A baseball card */
export interface BaseballCardpowerArgs {
  so5LeaderboardSlug?: InputMaybe<Scalars['String']['input']>;
}


/** A baseball card */
export interface BaseballCardpowerAfterTransferArgs {
  so5LeaderboardSlug?: InputMaybe<Scalars['String']['input']>;
}


/** A baseball card */
export interface BaseballCardpowerBreakdownArgs {
  so5LeaderboardSlug?: InputMaybe<Scalars['String']['input']>;
}


/** A baseball card */
export interface BaseballCardusedInArgs {
  gameId?: InputMaybe<Scalars['ID']['input']>;
  so5LeaderboardSlug?: InputMaybe<Scalars['String']['input']>;
  taskId?: InputMaybe<Scalars['ID']['input']>;
  taskLineupId?: InputMaybe<Scalars['ID']['input']>;
  taskPreparedLineupId?: InputMaybe<Scalars['ID']['input']>;
}


/** A baseball card */
export interface BaseballCardvideoUrlArgs {
  derivative?: InputMaybe<Scalars['String']['input']>;
}

/** A Baseball team in a competition */
export interface BaseballContestantType extends AnyContestantInterface, Node {
  __typename: 'BaseballContestantType';
  gamesDrawn: Scalars['Int']['output'];
  gamesLost: Scalars['Int']['output'];
  gamesPlayed: Scalars['Int']['output'];
  gamesWon: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  rank?: Maybe<Scalars['Int']['output']>;
  rankStatus?: Maybe<Scalars['String']['output']>;
  rankType?: Maybe<TournamentCalendarRankType>;
  team: Club | NationalTeam;
}

/** A baseball division */
export interface BaseballDivision extends DivisionInterface {
  __typename: 'BaseballDivision';
  /** The name of the division */
  name: Scalars['String']['output'];
}

/** A baseball player */
export interface BaseballPlayer extends AnyPlayerInterface, WithSubscriptionsInterface {
  __typename: 'BaseballPlayer';
  abbreviatedName: Scalars['String']['output'];
  activeClub?: Maybe<Club>;
  activeClubMembership?: Maybe<Membership>;
  activeInjuries: Array<Injury>;
  activeNationalTeam?: Maybe<NationalTeam>;
  activeSuspensions: Array<Suspension>;
  age: Scalars['Int']['output'];
  allAverageStats: Array<BaseballAverageStatWithValueType>;
  /** All player So5Scores ordered by descending game date */
  allPlayerGameScores: PlayerGameScoreInterfaceConnection;
  allTotalStats: Array<BaseballAverageStatWithValueType>;
  anyCardWithLiveAuction?: Maybe<BaseballCard | Card | NBACard>;
  anyCardWithLivePrimaryOffer?: Maybe<BaseballCard | Card | NBACard>;
  /** The `any_cards` field cannot be nested within a list. */
  anyCards: AnyCardInterfaceConnection;
  /** Stats of the upcoming games of the player, closest game first */
  anyFutureGameStats: Array<PlayerGameStats | PlayerGameStatsBaseball | PlayerGameStatsBasketball>;
  /** The `any_future_games` field cannot be nested within a list. */
  anyFutureGames: AnyGameInterfaceConnection;
  anyGameStats: Array<Maybe<PlayerGameStats | PlayerGameStatsBaseball | PlayerGameStatsBasketball>>;
  anyGamesForFixture: Array<Game | GameOfBaseball | GameOfBasketball>;
  anyGamesForLeaderboard: Array<Game | GameOfBaseball | GameOfBasketball>;
  /** The `any_past_games` field cannot be nested within a list. */
  anyPastGames: AnyGameInterfaceConnection;
  anyPositions: Array<Position>;
  /** Returns the 3 most followed players in the player's club The `any_related_players` field cannot be nested within a list. */
  anyRelatedPlayers: Array<BaseballPlayer | NBAPlayer | Player>;
  /** The `any_so5_average_last_score` field cannot be nested within a list. */
  anySo5AverageLastScore?: Maybe<AverageLastScore | BaseAverageLastScore>;
  appearances: Scalars['Int']['output'];
  avatarPictureUrl: Scalars['String']['output'];
  averageScore?: Maybe<Scalars['Float']['output']>;
  averageStats?: Maybe<Scalars['Float']['output']>;
  batHand?: Maybe<PreferredSide>;
  beforeLastOwningMembership?: Maybe<Membership>;
  birthDay?: Maybe<Scalars['ISO8601Date']['output']>;
  cardPositions: Array<Position>;
  /** @deprecated Not used anymore */
  cardPrice?: Maybe<Scalars['Int']['output']>;
  /** Cards of this player that are owned by a manager. Updated once a day. */
  cardSupply: Array<CardSeasonSupply>;
  careerSeasons: Array<Season>;
  clubMemberships: Array<Membership>;
  commonPlayer?: Maybe<CommonPlayer>;
  country: Country;
  currentSeason?: Maybe<Season>;
  currentUserSubscription?: Maybe<EmailSubscription>;
  /** @deprecated Use gainOnProjection */
  differenceLastTenAndClassicProjection?: Maybe<Scalars['Float']['output']>;
  /** @deprecated Use gainOnProjection(eventType: DAILY) */
  differenceLastTenAndDailyProjection?: Maybe<Scalars['Float']['output']>;
  displayName: Scalars['String']['output'];
  /** The `eligible_so5_competitions` field cannot be nested within a list. */
  eligibleSo5Competitions: Array<So5Competition>;
  firstName: Scalars['String']['output'];
  fullPictureUrl: Scalars['String']['output'];
  /** @deprecated Use gainOnProjection */
  gainOnClassicProjection?: Maybe<Scalars['Float']['output']>;
  /** @deprecated Use gainOnProjection */
  gainOnDailyProjection?: Maybe<Scalars['Float']['output']>;
  gainOnProjection?: Maybe<Scalars['Float']['output']>;
  gameplayTier?: Maybe<GameplayTier>;
  /** The star rating of the player gameplay tier */
  gameplayTierStars?: Maybe<Scalars['Float']['output']>;
  hasSo5LineupForFixture: Scalars['Boolean']['output'];
  height?: Maybe<Scalars['Int']['output']>;
  hitterAverageScore?: Maybe<Scalars['Float']['output']>;
  hitterPlayerGameScore?: Maybe<BaseballPlayerGameScore>;
  injuries: Array<Injury>;
  isActive: Scalars['Boolean']['output'];
  lastClub?: Maybe<Club>;
  lastFifteenSo5Appearances?: Maybe<Scalars['Int']['output']>;
  lastFiveSo5Appearances?: Maybe<Scalars['Int']['output']>;
  lastFortySo5Appearances?: Maybe<Scalars['Int']['output']>;
  lastName: Scalars['String']['output'];
  /** Get the last 2 cards you own of the player */
  lastOwnedCards: Array<BaseballCard | Card | NBACard>;
  lastTenSo5Appearances?: Maybe<Scalars['Int']['output']>;
  lowestPriceAnyCard?: Maybe<BaseballCard | Card | NBACard>;
  mainCardCollectionSlot?: Maybe<CardCollectionSlot>;
  matchName: Scalars['String']['output'];
  memberships: Array<Membership>;
  mySo5LeaderboardContendersForFixture: Array<So5LeaderboardContender>;
  news: Array<AnyPlayerNewsUpdate>;
  nextClassicFixtureProjectedGrade?: Maybe<PlayerGameScoreProjection>;
  nextClassicFixtureProjectedScore?: Maybe<Scalars['Float']['output']>;
  nextDailyFixtureProjectedGrade?: Maybe<PlayerGameScoreProjection>;
  nextDailyFixtureProjectedScore?: Maybe<Scalars['Float']['output']>;
  nextGame?: Maybe<Game | GameOfBaseball | GameOfBasketball>;
  ownedCardsCount: Scalars['Int']['output'];
  pitcherAverageScore?: Maybe<Scalars['Float']['output']>;
  pitcherPlayerGameScore?: Maybe<BaseballPlayerGameScore>;
  playerGameScore?: Maybe<BaseballPlayerGameScore | BasketballPlayerGameScore | PlayerGameScore | So5Score>;
  /** Up to 15 last So5Scores used in a So5Fixture */
  playerGameScores: Array<Maybe<BaseballPlayerGameScore | BasketballPlayerGameScore | PlayerGameScore | So5Score>>;
  printablePlayer?: Maybe<CommonPlayer>;
  /** The `public_watchlists` field cannot be nested within a list. */
  publicWatchlists?: Maybe<WatchlistConnection>;
  /** Up to 15 last So5Scores.score used in a So5Fixture */
  rawPlayerGameScores: Array<Maybe<Scalars['Float']['output']>>;
  seasonAppearances?: Maybe<Scalars['Int']['output']>;
  shirtNumber: Scalars['Int']['output'];
  /** @deprecated Not used anymore */
  signedAddCardPrice?: Maybe<SignedCardPrice>;
  signedDropCardPrice?: Maybe<SignedCardPrice>;
  slug: Scalars['String']['output'];
  sport: Sport;
  squaredPictureUrl: Scalars['String']['output'];
  subscriptionsCount: Scalars['Int']['output'];
  suspensions: Array<Suspension>;
  throwHand?: Maybe<PreferredSide>;
  /** The `token_prices` field cannot be nested within a list. */
  tokenPrices: TokenPriceConnection;
  totalStats?: Maybe<Scalars['Float']['output']>;
  user?: Maybe<User>;
  weight?: Maybe<Scalars['Int']['output']>;
}


/** A baseball player */
export interface BaseballPlayerallAverageStatsArgs {
  limit?: InputMaybe<AverageLimit>;
}


/** A baseball player */
export interface BaseballPlayerallPlayerGameScoresArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  position?: InputMaybe<Position>;
  to?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
}


/** A baseball player */
export interface BaseballPlayeranyCardWithLiveAuctionArgs {
  inSeason?: InputMaybe<Scalars['Boolean']['input']>;
  rarity?: InputMaybe<Rarity>;
}


/** A baseball player */
export interface BaseballPlayeranyCardWithLivePrimaryOfferArgs {
  rarity?: InputMaybe<Rarity>;
}


/** A baseball player */
export interface BaseballPlayeranyCardsArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  age?: InputMaybe<Scalars['Int']['input']>;
  assetIds?: InputMaybe<Array<Scalars['String']['input']>>;
  before?: InputMaybe<Scalars['String']['input']>;
  classicOnly?: InputMaybe<Scalars['Boolean']['input']>;
  customCardEditionName?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  inActiveCompetitions?: InputMaybe<Array<Scalars['String']['input']>>;
  inSeasonEligible?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  owned?: InputMaybe<Scalars['Boolean']['input']>;
  ownedByMe?: InputMaybe<Scalars['Boolean']['input']>;
  ownedSinceAfter?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  playerSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  positions?: InputMaybe<Array<Position>>;
  rarities?: InputMaybe<Array<Rarity>>;
  revealable?: InputMaybe<Scalars['Boolean']['input']>;
  seasonStartYears?: InputMaybe<Array<Scalars['Int']['input']>>;
  serialNumber?: InputMaybe<Scalars['Int']['input']>;
  shirtNumber?: InputMaybe<Scalars['Int']['input']>;
  slugs?: InputMaybe<Array<Scalars['String']['input']>>;
  sorts?: InputMaybe<Array<CardSort>>;
  sport?: InputMaybe<Sport>;
  teamSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  withinDeckFirst?: InputMaybe<Scalars['String']['input']>;
}


/** A baseball player */
export interface BaseballPlayeranyFutureGameStatsArgs {
  first: Scalars['Int']['input'];
  teamMode?: InputMaybe<AverageScoreTeamMode>;
}


/** A baseball player */
export interface BaseballPlayeranyFutureGamesArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  so5FixtureEligible?: InputMaybe<Scalars['Boolean']['input']>;
}


/** A baseball player */
export interface BaseballPlayeranyGameStatsArgs {
  last: Scalars['Int']['input'];
  lowCoverage?: InputMaybe<Scalars['Boolean']['input']>;
  so5FixtureSlug?: InputMaybe<Scalars['String']['input']>;
  teamMode?: InputMaybe<AverageScoreTeamMode>;
}


/** A baseball player */
export interface BaseballPlayeranyGamesForFixtureArgs {
  so5FixtureSlug: Scalars['String']['input'];
}


/** A baseball player */
export interface BaseballPlayeranyGamesForLeaderboardArgs {
  so5LeaderboardSlug: Scalars['String']['input'];
}


/** A baseball player */
export interface BaseballPlayeranyPastGamesArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
}


/** A baseball player */
export interface BaseballPlayeranySo5AverageLastScoreArgs {
  competitionSlug?: InputMaybe<Scalars['String']['input']>;
  location?: InputMaybe<AverageLastScoreLocation>;
  position: Position;
  span: AverageLastScoreSpan;
  teamSlug?: InputMaybe<Scalars['String']['input']>;
}


/** A baseball player */
export interface BaseballPlayeraverageScoreArgs {
  position?: InputMaybe<Position>;
  teamMode?: InputMaybe<AverageScoreTeamMode>;
  type: AveragePlayerScore;
}


/** A baseball player */
export interface BaseballPlayeraverageStatsArgs {
  limit?: AverageLimit;
  type: BaseballAverageStatType;
}


/** A baseball player */
export interface BaseballPlayercardPriceArgs {
  rarity: Rarity;
}


/** A baseball player */
export interface BaseballPlayercareerSeasonsArgs {
  type?: InputMaybe<CompetitionType>;
}


/** A baseball player */
export interface BaseballPlayercommonPlayerArgs {
  rarity: Rarity;
}


/** A baseball player */
export interface BaseballPlayergainOnProjectionArgs {
  eventType?: InputMaybe<So5FixtureEvent>;
}


/** A baseball player */
export interface BaseballPlayerhasSo5LineupForFixtureArgs {
  so5FixtureSlug: Scalars['String']['input'];
}


/** A baseball player */
export interface BaseballPlayerhitterAverageScoreArgs {
  type: AveragePlayerScore;
}


/** A baseball player */
export interface BaseballPlayerhitterPlayerGameScoreArgs {
  gameId: Scalars['ID']['input'];
}


/** A baseball player */
export interface BaseballPlayerlastFifteenSo5AppearancesArgs {
  teamMode?: InputMaybe<AverageScoreTeamMode>;
}


/** A baseball player */
export interface BaseballPlayerlastFiveSo5AppearancesArgs {
  teamMode?: InputMaybe<AverageScoreTeamMode>;
}


/** A baseball player */
export interface BaseballPlayerlastFortySo5AppearancesArgs {
  teamMode?: InputMaybe<AverageScoreTeamMode>;
}


/** A baseball player */
export interface BaseballPlayerlastOwnedCardsArgs {
  inSeasonEligible?: InputMaybe<Scalars['Boolean']['input']>;
  rarities?: InputMaybe<Array<Rarity>>;
}


/** A baseball player */
export interface BaseballPlayerlastTenSo5AppearancesArgs {
  teamMode?: InputMaybe<AverageScoreTeamMode>;
}


/** A baseball player */
export interface BaseballPlayerlowestPriceAnyCardArgs {
  inSeason?: InputMaybe<Scalars['Boolean']['input']>;
  rarity?: InputMaybe<Rarity>;
}


/** A baseball player */
export interface BaseballPlayermainCardCollectionSlotArgs {
  rarity: Rarity;
}


/** A baseball player */
export interface BaseballPlayermySo5LeaderboardContendersForFixtureArgs {
  so5FixtureSlug: Scalars['String']['input'];
}


/** A baseball player */
export interface BaseballPlayernewsArgs {
  last: Scalars['Int']['input'];
}


/** A baseball player */
export interface BaseballPlayernextGameArgs {
  so5FixtureEligible?: InputMaybe<Scalars['Boolean']['input']>;
}


/** A baseball player */
export interface BaseballPlayerownedCardsCountArgs {
  rarities?: InputMaybe<Array<Rarity>>;
  rarity?: InputMaybe<Rarity>;
  seasonEligibility?: InputMaybe<SeasonEligibility>;
}


/** A baseball player */
export interface BaseballPlayerpitcherAverageScoreArgs {
  type: AveragePlayerScore;
}


/** A baseball player */
export interface BaseballPlayerpitcherPlayerGameScoreArgs {
  gameId: Scalars['ID']['input'];
}


/** A baseball player */
export interface BaseballPlayerplayerGameScoreArgs {
  gameId: Scalars['ID']['input'];
  position?: InputMaybe<Position>;
}


/** A baseball player */
export interface BaseballPlayerplayerGameScoresArgs {
  last: Scalars['Int']['input'];
  lowCoverage?: InputMaybe<Scalars['Boolean']['input']>;
  position?: InputMaybe<Position>;
}


/** A baseball player */
export interface BaseballPlayerpublicWatchlistsArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
}


/** A baseball player */
export interface BaseballPlayerrawPlayerGameScoresArgs {
  last: Scalars['Int']['input'];
  lowCoverage?: InputMaybe<Scalars['Boolean']['input']>;
  position?: InputMaybe<Position>;
}


/** A baseball player */
export interface BaseballPlayerseasonAppearancesArgs {
  teamMode?: InputMaybe<AverageScoreTeamMode>;
}


/** A baseball player */
export interface BaseballPlayersignedAddCardPriceArgs {
  rarity: Rarity;
}


/** A baseball player */
export interface BaseballPlayersignedDropCardPriceArgs {
  rarity: Rarity;
}


/** A baseball player */
export interface BaseballPlayertokenPricesArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  includePrivateSales?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  rarity: Rarity;
  season?: InputMaybe<Scalars['Int']['input']>;
  seasonEligibility?: InputMaybe<SeasonEligibility>;
  since?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
}


/** A baseball player */
export interface BaseballPlayertotalStatsArgs {
  type: BaseballAverageStatType;
}

/** Stats of a player for a game */
export interface BaseballPlayerGameScore extends Node, PlayerGameScoreInterface {
  __typename: 'BaseballPlayerGameScore';
  activeSuspensions: Array<Suspension>;
  anyGame: Game | GameOfBaseball | GameOfBasketball;
  anyPlayer: BaseballPlayer | NBAPlayer | Player;
  anyPlayerGameStats: PlayerGameStats | PlayerGameStatsBaseball | PlayerGameStatsBasketball;
  averageScore?: Maybe<Scalars['Float']['output']>;
  baseballGame: GameOfBaseball;
  baseballPlayer: BaseballPlayer;
  baseballPlayerGameStats: PlayerGameStatsBaseball;
  detailedScore: Array<StatScore>;
  id: Scalars['ID']['output'];
  position: Scalars['String']['output'];
  positionTyped: Position;
  projectedScore: Scalars['Float']['output'];
  projection?: Maybe<PlayerGameScoreProjection>;
  score: Scalars['Float']['output'];
  scoreStatus: ScoreStatus;
  scoringVersion: Scalars['Int']['output'];
}


/** Stats of a player for a game */
export interface BaseballPlayerGameScoreaverageScoreArgs {
  type: AveragePlayerScore;
}

export const BaseballPosition = {
  CATCHER: 'CATCHER',
  DESIGNATED_HITTER: 'DESIGNATED_HITTER',
  FIRST_BASE: 'FIRST_BASE',
  OUTFIELD: 'OUTFIELD',
  RELIEF_PITCHER: 'RELIEF_PITCHER',
  SECOND_BASE: 'SECOND_BASE',
  SHORTSTOP: 'SHORTSTOP',
  STARTING_PITCHER: 'STARTING_PITCHER',
  THIRD_BASE: 'THIRD_BASE',
  UNKNOWN: 'UNKNOWN'
} as const;

export type BaseballPosition = typeof BaseballPosition[keyof typeof BaseballPosition];
/** Stats of a team in a game */
export interface BaseballTeamGameStats extends TeamGameStatsInterface {
  __typename: 'BaseballTeamGameStats';
  decisiveEvents: Array<FootballGoalEvent | FootballSanctionCardEvent | SubstitutionEvent>;
  id: Scalars['ID']['output'];
  stats?: Maybe<Array<SportStat>>;
}

/** A Sorare Baseball user sport specific profile */
export interface BaseballUserSportProfile extends Node, UserSportProfileInterface {
  __typename: 'BaseballUserSportProfile';
  achievementBadges?: Maybe<Array<Maybe<SkinShopItem>>>;
  /** @deprecated Not used anymore */
  availableOnboardingLeaderboards: Scalars['Boolean']['output'];
  background?: Maybe<SkinShopItem>;
  bannerColor?: Maybe<Scalars['String']['output']>;
  bannerUrl?: Maybe<Scalars['String']['output']>;
  /**
   * Up to five cards owned in the current set, or in the previous set when no set
   * is active, best gameplay tier and last ten average score first, with a single
   * card per player keeping the rarest edition owned The `best_cards` field cannot
   * be nested within a list.
   */
  bestCards: Array<BaseballCard | Card | NBACard>;
  blueprintCardsCount: Scalars['Int']['output'];
  clubBadge?: Maybe<SkinShopItem>;
  clubName?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use CardSet.starterPackClaimed instead */
  commonGameOnboarded: Scalars['Boolean']['output'];
  /** Get a deck of cards */
  deck?: Maybe<Deck>;
  /** The `decks` field cannot be nested within a list. */
  decks: DeckConnection;
  favoriteTeam?: Maybe<Club | NationalTeam>;
  forceToProOnboarding: Scalars['Boolean']['output'];
  gallerySocialPictureUrls: SocialPictureDerivative;
  highlightPro: Scalars['Boolean']['output'];
  /** The `highlighted_deck` field cannot be nested within a list. */
  highlightedDeck?: Maybe<Deck>;
  id: Scalars['ID']['output'];
  managerProfileSocialPictureUrls: SocialPictureDerivative;
  onboarded: Scalars['Boolean']['output'];
  onboardingCompetitions: Array<Competition>;
  /** @deprecated Not used anymore */
  onboardingLeaderboards: Array<OnboardingLeaderboard>;
  onboardingSo5Fixture?: Maybe<So5Fixture>;
  /**
   * The `onboarding_so5_leaderboard` field cannot be nested within a list.
   * @deprecated Not used anymore
   */
  onboardingSo5Leaderboard?: Maybe<So5Leaderboard>;
  /** A frame to apply on top of user profile picture */
  pictureFrame?: Maybe<PictureFrameShopItem>;
  /** @deprecated Player loyalty is no longer used */
  playerLoyaltyBoost: RewardBoost;
  /** @deprecated Use highlightPro instead */
  proOnboarded: Scalars['Boolean']['output'];
  proUnlocked: Scalars['Boolean']['output'];
  rarityVaultBoost: RewardBoost;
  remainingUnsealsInPeriod: Scalars['Int']['output'];
  selectedUserSportStatistics: Array<Maybe<UserSportStatistic>>;
  shieldUrl?: Maybe<Scalars['String']['output']>;
  socialPictureFingerprint: Scalars['String']['output'];
  tournamentEligibilities: Array<TournamentEligibility>;
  userSportStatistics: Array<UserSportStatistic>;
  variant: UserSportProfileVariant;
}


/** A Sorare Baseball user sport specific profile */
export interface BaseballUserSportProfileavailableOnboardingLeaderboardsArgs {
  rarity?: InputMaybe<Rarity>;
}


/** A Sorare Baseball user sport specific profile */
export interface BaseballUserSportProfilebestCardsArgs {
  skins?: InputMaybe<Array<Skin>>;
}


/** A Sorare Baseball user sport specific profile */
export interface BaseballUserSportProfiledeckArgs {
  name?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
}


/** A Sorare Baseball user sport specific profile */
export interface BaseballUserSportProfiledecksArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
}


/** A Sorare Baseball user sport specific profile */
export interface BaseballUserSportProfileonboardingLeaderboardsArgs {
  rarity?: InputMaybe<Rarity>;
}


/** A Sorare Baseball user sport specific profile */
export interface BaseballUserSportProfileplayerLoyaltyBoostArgs {
  editedSeasonsCount: Scalars['Int']['input'];
  sealedCards: Scalars['Int']['input'];
}


/** A Sorare Baseball user sport specific profile */
export interface BaseballUserSportProfilerarityVaultBoostArgs {
  rarity: Rarity;
  sport: Sport;
  unseals?: InputMaybe<Scalars['Int']['input']>;
}


/** A Sorare Baseball user sport specific profile */
export interface BaseballUserSportProfileremainingUnsealsInPeriodArgs {
  rarity: Rarity;
}

export const BasketballAverageStatType = {
  ASSISTS: 'ASSISTS',
  BLOCKS: 'BLOCKS',
  DOUBLE_DOUBLE: 'DOUBLE_DOUBLE',
  MINS_PLAYED: 'MINS_PLAYED',
  POINTS: 'POINTS',
  REBOUNDS: 'REBOUNDS',
  STEALS: 'STEALS',
  THREE_POINTS_MADE: 'THREE_POINTS_MADE',
  TRIPLE_DOUBLE: 'TRIPLE_DOUBLE',
  TURNOVERS: 'TURNOVERS'
} as const;

export type BasketballAverageStatType = typeof BasketballAverageStatType[keyof typeof BasketballAverageStatType];
export interface BasketballAverageStatWithValueType extends AnyAverageStatWithValueInterface {
  __typename: 'BasketballAverageStatWithValueType';
  lastValues?: Maybe<Array<Scalars['Float']['output']>>;
  stat: BasketballAverageStatType;
  value?: Maybe<Scalars['Float']['output']>;
}

/** A Basketball team in a competition */
export interface BasketballContestantType extends AnyContestantInterface, Node {
  __typename: 'BasketballContestantType';
  gamesDrawn: Scalars['Int']['output'];
  gamesLost: Scalars['Int']['output'];
  gamesPlayed: Scalars['Int']['output'];
  gamesWon: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  rank?: Maybe<Scalars['Int']['output']>;
  rankStatus?: Maybe<Scalars['String']['output']>;
  rankType?: Maybe<TournamentCalendarRankType>;
  team: Club | NationalTeam;
}

/** A basketball division */
export interface BasketballDivision extends DivisionInterface {
  __typename: 'BasketballDivision';
  /** The name of the division */
  name: Scalars['String']['output'];
}

/** Stats of a player for a game */
export interface BasketballPlayerGameScore extends Node, PlayerGameScoreInterface {
  __typename: 'BasketballPlayerGameScore';
  activeSuspensions: Array<Suspension>;
  anyGame: Game | GameOfBaseball | GameOfBasketball;
  anyPlayer: BaseballPlayer | NBAPlayer | Player;
  anyPlayerGameStats: PlayerGameStats | PlayerGameStatsBaseball | PlayerGameStatsBasketball;
  averageScore?: Maybe<Scalars['Float']['output']>;
  basketballGame: GameOfBasketball;
  basketballPlayer: NBAPlayer;
  basketballPlayerGameStats: PlayerGameStatsBasketball;
  detailedScore: Array<StatScore>;
  id: Scalars['ID']['output'];
  position: Scalars['String']['output'];
  positionTyped: Position;
  projectedScore: Scalars['Float']['output'];
  projection?: Maybe<PlayerGameScoreProjection>;
  score: Scalars['Float']['output'];
  scoreStatus: ScoreStatus;
  scoringVersion: Scalars['Int']['output'];
}


/** Stats of a player for a game */
export interface BasketballPlayerGameScoreaverageScoreArgs {
  type: AveragePlayerScore;
}

/** Stats of a team in a game */
export interface BasketballTeamGameStats extends TeamGameStatsInterface {
  __typename: 'BasketballTeamGameStats';
  decisiveEvents: Array<FootballGoalEvent | FootballSanctionCardEvent | SubstitutionEvent>;
  id: Scalars['ID']['output'];
  stats?: Maybe<Array<SportStat>>;
}

export interface BenchFilterInput {
  /** The card edition names to filter on (default to all editions) */
  customCardEditionNames?: InputMaybe<Array<Scalars['String']['input']>>;
  deckId?: InputMaybe<Scalars['String']['input']>;
  /** The gameplay tier stars to filter on */
  gameplayTierStars?: InputMaybe<FloatRangeInput>;
  gamesDate?: InputMaybe<DateRangeInput>;
  /** The card grades to filter on */
  grades?: InputMaybe<RangeInput>;
  inSeasonEligible?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether to include cards with no game in this fixture (default false) */
  includeNoGame?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether to include cards whose players only play after the task expiration (default false) */
  includePostExpiration?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether to filter on cards with players injured or suspended (default false) */
  includeUnavailablePlayers?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether to include cards already used in this fixture (default false) */
  includeUsed?: InputMaybe<Scalars['Boolean']['input']>;
  lastFifteenSo5AverageScore?: InputMaybe<RangeInput>;
  lastTenPlayedSo5AverageScore?: InputMaybe<RangeInput>;
  lineupId?: InputMaybe<Scalars['String']['input']>;
  /** Whether to include cards that plays from home */
  playingHomeOnly?: InputMaybe<Scalars['Boolean']['input']>;
  /** The card positions to filter on */
  positions?: InputMaybe<Array<Position>>;
  /** Full text search query to filter cards */
  query?: InputMaybe<Scalars['String']['input']>;
  /** The card rarities to filter on (default to all rarities) */
  rarities?: InputMaybe<Array<Rarity>>;
  /** Objects already selected in the current lineup. It can be a So5Appearance or a ComposeTeamBenchObject. */
  selectedObjectIds?: InputMaybe<Array<Scalars['String']['input']>>;
  /** @deprecated Use lineup_id instead */
  so5LineupId?: InputMaybe<Scalars['String']['input']>;
  sortType?: InputMaybe<EligibleCardsSort>;
  /** The player starting prediction to filter on */
  starterOddsBasisPointsRange?: InputMaybe<RangeInput>;
  /** Scope average-score sorting to the player active club or national team */
  teamMode?: InputMaybe<AverageScoreTeamMode>;
}

export const BenchPlayerScore = {
  GAIN_ON_PROJECTION: 'GAIN_ON_PROJECTION',
  LAST_FIFTEEN_AVERAGE_ALL_AROUND_SCORE: 'LAST_FIFTEEN_AVERAGE_ALL_AROUND_SCORE',
  LAST_FIFTEEN_AVERAGE_DECISIVE_SCORE: 'LAST_FIFTEEN_AVERAGE_DECISIVE_SCORE',
  LAST_FIFTEEN_SO5_AVERAGE_SCORE: 'LAST_FIFTEEN_SO5_AVERAGE_SCORE',
  LAST_FIVE_AVERAGE_ALL_AROUND_SCORE: 'LAST_FIVE_AVERAGE_ALL_AROUND_SCORE',
  LAST_FIVE_AVERAGE_DECISIVE_SCORE: 'LAST_FIVE_AVERAGE_DECISIVE_SCORE',
  LAST_FIVE_SO5_AVERAGE_SCORE: 'LAST_FIVE_SO5_AVERAGE_SCORE',
  LAST_FORTY_AVERAGE_ALL_AROUND_SCORE: 'LAST_FORTY_AVERAGE_ALL_AROUND_SCORE',
  LAST_FORTY_AVERAGE_DECISIVE_SCORE: 'LAST_FORTY_AVERAGE_DECISIVE_SCORE',
  LAST_FORTY_SO5_AVERAGE_SCORE: 'LAST_FORTY_SO5_AVERAGE_SCORE',
  LAST_TEN_PLAYED_AVERAGE_ALL_AROUND_SCORE: 'LAST_TEN_PLAYED_AVERAGE_ALL_AROUND_SCORE',
  LAST_TEN_PLAYED_AVERAGE_DECISIVE_SCORE: 'LAST_TEN_PLAYED_AVERAGE_DECISIVE_SCORE',
  LAST_TEN_PLAYED_SO5_AVERAGE_SCORE: 'LAST_TEN_PLAYED_SO5_AVERAGE_SCORE',
  PROJECTED_GRADE: 'PROJECTED_GRADE',
  PROJECTED_SCORE: 'PROJECTED_SCORE',
  SEASON_AVERAGE_SCORE: 'SEASON_AVERAGE_SCORE',
  STARS: 'STARS'
} as const;

export type BenchPlayerScore = typeof BenchPlayerScore[keyof typeof BenchPlayerScore];
export interface BenchSort {
  __typename: 'BenchSort';
  direction: SortingOption;
  typeData: SortingType;
}

export const BenchSortType = {
  GAIN_ON_PROJECTION: 'GAIN_ON_PROJECTION',
  LAST_FIFTEEN_AVERAGE_ALL_AROUND_SCORE: 'LAST_FIFTEEN_AVERAGE_ALL_AROUND_SCORE',
  LAST_FIFTEEN_AVERAGE_DECISIVE_SCORE: 'LAST_FIFTEEN_AVERAGE_DECISIVE_SCORE',
  LAST_FIFTEEN_SO5_AVERAGE_SCORE: 'LAST_FIFTEEN_SO5_AVERAGE_SCORE',
  LAST_FIVE_AVERAGE_ALL_AROUND_SCORE: 'LAST_FIVE_AVERAGE_ALL_AROUND_SCORE',
  LAST_FIVE_AVERAGE_DECISIVE_SCORE: 'LAST_FIVE_AVERAGE_DECISIVE_SCORE',
  LAST_FIVE_SO5_AVERAGE_SCORE: 'LAST_FIVE_SO5_AVERAGE_SCORE',
  LAST_FORTY_AVERAGE_ALL_AROUND_SCORE: 'LAST_FORTY_AVERAGE_ALL_AROUND_SCORE',
  LAST_FORTY_AVERAGE_DECISIVE_SCORE: 'LAST_FORTY_AVERAGE_DECISIVE_SCORE',
  LAST_FORTY_SO5_AVERAGE_SCORE: 'LAST_FORTY_SO5_AVERAGE_SCORE',
  LAST_TEN_PLAYED_AVERAGE_ALL_AROUND_SCORE: 'LAST_TEN_PLAYED_AVERAGE_ALL_AROUND_SCORE',
  LAST_TEN_PLAYED_AVERAGE_DECISIVE_SCORE: 'LAST_TEN_PLAYED_AVERAGE_DECISIVE_SCORE',
  LAST_TEN_PLAYED_SO5_AVERAGE_SCORE: 'LAST_TEN_PLAYED_SO5_AVERAGE_SCORE',
  PLAYING_SOON: 'PLAYING_SOON',
  POPULARITY: 'POPULARITY',
  POPULAR_STARTERS: 'POPULAR_STARTERS',
  PROJECTED_GRADE: 'PROJECTED_GRADE',
  PROJECTED_SCORE: 'PROJECTED_SCORE',
  SEASON_AVERAGE_SCORE: 'SEASON_AVERAGE_SCORE',
  SPECIAL_EDITION: 'SPECIAL_EDITION',
  STARS: 'STARS'
} as const;

export type BenchSortType = typeof BenchSortType[keyof typeof BenchSortType];
/** The best scoring lineup of a manager profile */
export interface BestScoreManagerProfileStat extends ManagerProfileStat {
  __typename: 'BestScoreManagerProfileStat';
  label: Scalars['String']['output'];
  taskLineup?: Maybe<GuessTheScoreTaskLineup | TaskLineup | ThresholdPickerTaskLineup>;
}

export interface BidSource extends HistoryTransactionInterface {
  __typename: 'BidSource';
  date: Scalars['ISO8601DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  label: Scalars['String']['output'];
  logoUrl?: Maybe<Scalars['String']['output']>;
  quantityByFlavour: Array<PoolKeyShardsCount>;
  totalQuantity: Scalars['Int']['output'];
}

/** A promotional event that rewards auction bidders */
export interface BidToEarnPromotionalEvent extends Node, PromotionalEventInterface {
  __typename: 'BidToEarnPromotionalEvent';
  algoliaFilters: Scalars['String']['output'];
  backgroundPictureUrl?: Maybe<Scalars['String']['output']>;
  bannerAssetsPictureUrl?: Maybe<Scalars['String']['output']>;
  bidRewardsConfigs: Array<BidToEarnRewardConfig>;
  blogUrl?: Maybe<Scalars['String']['output']>;
  description: Scalars['String']['output'];
  eligibilityRules: EligibilityRules;
  endDate: Scalars['ISO8601DateTime']['output'];
  filterPictureUrl?: Maybe<Scalars['String']['output']>;
  heroValueProps: Array<HeroValueProp>;
  id: Scalars['ID']['output'];
  logoUrl?: Maybe<Scalars['String']['output']>;
  marketBannerTitle: Scalars['String']['output'];
  mobileBackgroundPictureUrl?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  pictureUrl?: Maybe<Scalars['String']['output']>;
  probableRewardConfigs: Array<ProbableRewardConfig>;
  promotionType: PromotionType;
  secondaryBannerPictureUrl?: Maybe<Scalars['String']['output']>;
  slug: Scalars['String']['output'];
  sport: Sport;
  startDate: Scalars['ISO8601DateTime']['output'];
  termsAndConditionsUrl?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
}

export interface BidToEarnReward extends Node {
  __typename: 'BidToEarnReward';
  bid?: Maybe<TokenBid>;
  bidderRank: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  reward: AnyCardReward | AnyConversionCreditReward | CardPackReward | CardShardsReward | CoinReward | DeliverableItemReward | ExperienceReward | InGameCurrencyReward | MonetaryReward | ProbabilisticBundleReward | ShopItemReward;
}

/** A Bid To Earn Reward Config */
export interface BidToEarnRewardConfig {
  __typename: 'BidToEarnRewardConfig';
  bidderRank: Scalars['Int']['output'];
  rewards: Array<CardPacksRewardConfig | CardRewardConfig | CardShardRewardConfig | CoinRewardConfig | ConversionCreditRewardConfig | DeliverableItemRewardConfig | ExperienceRewardConfig | InGameCurrencyRewardConfig | MonetaryRewardConfig | ProbabilisticBundleRewardConfig | ShopItemRewardConfig>;
}

/** a billing address */
export interface BillingAddressInput {
  addressLine1: Scalars['String']['input'];
  addressLine2?: InputMaybe<Scalars['String']['input']>;
  city: Scalars['String']['input'];
  countryCode: Scalars['String']['input'];
  postalCode: Scalars['String']['input'];
  region?: InputMaybe<Scalars['String']['input']>;
}

export const Blockchain = {
  BASE: 'BASE',
  ETHEREUM: 'ETHEREUM',
  LOOM: 'LOOM',
  NO_BLOCKCHAIN: 'NO_BLOCKCHAIN',
  SOLANA: 'SOLANA',
  STARKWARE: 'STARKWARE'
} as const;

export type Blockchain = typeof Blockchain[keyof typeof Blockchain];
/** Object that have a blockchain address to interact with the platform */
export type BlockchainUser = AnonymousUser | User;

/** Blockchain info */
export interface BlockchainUserInterface {
  cardsCount: Scalars['Int']['output'];
  ethVaultId?: Maybe<Scalars['Int']['output']>;
  ethereumAddress?: Maybe<Scalars['EthereumAddress']['output']>;
  sorareAddress?: Maybe<Scalars['EthereumAddress']['output']>;
  starkKey?: Maybe<Scalars['String']['output']>;
}

export interface Blueprint {
  __typename: 'Blueprint';
  gltfUrl?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  launchDate?: Maybe<Scalars['ISO8601DateTime']['output']>;
  newPositionsWarning?: Maybe<Array<Position>>;
  pictureUrl?: Maybe<Scalars['String']['output']>;
  revealDate?: Maybe<Scalars['ISO8601DateTime']['output']>;
  revealStatus: BlueprintRevealStatus;
  revealVideoUrl?: Maybe<Scalars['String']['output']>;
  shinyRevealeableOdds?: Maybe<Scalars['Float']['output']>;
  specialEditionRevealableOdds: Scalars['Float']['output'];
  teamTransferWarning: Scalars['Boolean']['output'];
}


export interface BlueprintpictureUrlArgs {
  derivative?: InputMaybe<Scalars['String']['input']>;
}


export interface BlueprintrevealVideoUrlArgs {
  orientation: Orientation;
}

export const BlueprintRevealStatus = {
  /** Blueprint reveal is delayed and reveal date is unknown */
  DELAYED: 'DELAYED',
  /** Blueprint will be revealable at the reveal date */
  NOT_YET_REVEALABLE: 'NOT_YET_REVEALABLE',
  /** Blueprint can now be revealed */
  REVEALABLE: 'REVEALABLE',
  /** Blueprint has already been revealed */
  REVEALED: 'REVEALED',
  /** Blueprint will never be revealable */
  UNREVEALABLE: 'UNREVEALABLE'
} as const;

export type BlueprintRevealStatus = typeof BlueprintRevealStatus[keyof typeof BlueprintRevealStatus];
/** A progression board for a squad or solo player */
export interface Board {
  backgroundUrl?: Maybe<Scalars['String']['output']>;
  color?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  endDate?: Maybe<Scalars['ISO8601DateTime']['output']>;
  hasMyCollectionTasks: Scalars['Boolean']['output'];
  iconUrl?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  myCollectionTasks: Array<CardsCountTargetTask | CardsCountTask | CompleteCollectionsCountTargetTask | CompleteCollectionsCountTask | DailyActionTask | DecisivePlayerPickerTask | DropChallengeTask | GameWeeklyTask | GuessTheScoreTask | InviteTaskAsReferrer | So5LeaderboardTask | StarPackTask | Task | TasksTrack | ThresholdPickerTask | ThresholdsDuoConnectionTask | ThresholdsStreakAdditionalLineupTask | ThresholdsStreakTask>;
  myCurrentStep?: Maybe<CareerProStep | CareerStep | SquadStep>;
  myUnclaimedCollectionTasksCount: Scalars['Int']['output'];
  /** The number of collection tasks, steps and ladder rewards of this board left to claim */
  myUnclaimedRewardsCount: Scalars['Int']['output'];
  steps: Array<CareerProStep | CareerStep | SquadStep>;
  tileBackgroundUrl?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
}


/** A progression board for a squad or solo player */
export interface BoardbackgroundUrlArgs {
  variant?: InputMaybe<AssetVariant>;
}


/** A progression board for a squad or solo player */
export interface BoardcolorArgs {
  variant?: InputMaybe<ColorVariant>;
}


/** A progression board for a squad or solo player */
export interface BoardhasMyCollectionTasksArgs {
  rarity?: InputMaybe<Rarity>;
}


/** A progression board for a squad or solo player */
export interface BoardmyCollectionTasksArgs {
  rarity?: InputMaybe<Rarity>;
}


/** A progression board for a squad or solo player */
export interface BoardmyUnclaimedCollectionTasksCountArgs {
  rarity?: InputMaybe<Rarity>;
}

export interface BoardBookmark extends Bookmark {
  __typename: 'BoardBookmark';
  /** The user's latest run of this board, whatever its state, if the user ever started it */
  board?: Maybe<CareerBoard | SquadBoard>;
  id: Scalars['ID']['output'];
  sport: Sport;
  taskConfigSlug: Scalars['String']['output'];
}

export const BoardMode = {
  CAREER: 'CAREER',
  SQUAD: 'SQUAD'
} as const;

export type BoardMode = typeof BoardMode[keyof typeof BoardMode];
/** A board offering a special edition cards bonus */
export interface BoardWithSpecialEditionBonus {
  __typename: 'BoardWithSpecialEditionBonus';
  board: CareerBoard | SquadBoard;
  bonus: So5SpecialEditionCardsBonus;
}

export const BonusOrdinalRatingEnum = {
  EXCEPTIONAL: 'EXCEPTIONAL',
  HIGH: 'HIGH',
  LOW: 'LOW',
  MEDIUM: 'MEDIUM',
  VERY_HIGH: 'VERY_HIGH',
  VERY_LOW: 'VERY_LOW'
} as const;

export type BonusOrdinalRatingEnum = typeof BonusOrdinalRatingEnum[keyof typeof BonusOrdinalRatingEnum];
/** A user's shortcut to a recurring competition, resolved to its current instance */
export interface Bookmark {
  id: Scalars['ID']['output'];
  sport: Sport;
}

export interface BoostLevel {
  __typename: 'BoostLevel';
  boostBasisPoints: Scalars['Int']['output'];
  milestone: Scalars['Int']['output'];
  points: Scalars['Int']['output'];
}

/** A boosted version of a basic pack, with the odds to get it when buying the basic pack */
export interface BoostedPackOdds {
  __typename: 'BoostedPackOdds';
  cardPack: CardPack;
  /** Probability in basis points (1 bp = 0.01%) to get the boosted pack when buying the basic pack */
  probabilityBasisPoint: Scalars['Int']['output'];
}

/** A Mangopay BrowserInfo object */
export interface BrowserInfoInput {
  colorDepth: Scalars['Int']['input'];
  language: Scalars['String']['input'];
  screenHeight: Scalars['Int']['input'];
  screenWidth: Scalars['Int']['input'];
  timeZoneOffset: Scalars['Int']['input'];
}

/** BudgetTypeType lists what a lineup budget can be denominated in */
export const BudgetType = {
  LAST_FIFTEEN_SO5_AVERAGE_SCORE: 'LAST_FIFTEEN_SO5_AVERAGE_SCORE',
  LAST_TEN_PLAYED_SO5_AVERAGE_SCORE: 'LAST_TEN_PLAYED_SO5_AVERAGE_SCORE',
  STARS: 'STARS'
} as const;

export type BudgetType = typeof BudgetType[keyof typeof BudgetType];
/** A purchasable item that is a bundle */
export interface BundledPurchasableItem extends Node, PurchasableItemInterface {
  __typename: 'BundledPurchasableItem';
  cardPaymentProvider: PaymentMethodProvider;
  discountBasisPoints?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  nextPriceUpdateAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  oldPrice?: Maybe<MonetaryAmount>;
  pictureUrl?: Maybe<Scalars['String']['output']>;
  price: MonetaryAmount;
  purchasableItems: Array<BundledPurchasableItem | CardShardsPurchasableItem | InGameCurrencyPurchasableItem | PackConfigPurchasableItem>;
  slug: Scalars['String']['output'];
  sport?: Maybe<Sport>;
}


/** A purchasable item that is a bundle */
export interface BundledPurchasableItempictureUrlArgs {
  derivative?: InputMaybe<PurchasableItemDerivative>;
}

/** A Mangopay Canadian bank account type */
export interface CaBankAccount extends BankAccountInterface, Node {
  __typename: 'CaBankAccount';
  /** Account number (last 4 digits) */
  accountNumber: Scalars['String']['output'];
  bankName?: Maybe<Scalars['String']['output']>;
  /** 3-digit number assigned to branches of Canadian financial institutions */
  branchCode?: Maybe<Scalars['String']['output']>;
  country: Country;
  id: Scalars['ID']['output'];
  /** 3-digit number assigned to Canadian financial institutions */
  institutionNumber: Scalars['String']['output'];
  minimumWithdrawalAmounts: MonetaryAmount;
  ownerAddress?: Maybe<MangopayBankAccountOwnerAddress>;
  ownerName?: Maybe<Scalars['String']['output']>;
  status?: Maybe<MangopayBankAccountStatus>;
  withdrawalFeeAmounts: MonetaryAmount;
  withdrawalFeeType: MangopayBankAccountWithdrawalFeeType;
}

/** A card representing a professional football player */
export interface Card extends AnyCardInterface, CardGameInterface, Node, WithSubscriptionsInterface {
  __typename: 'Card';
  activeSuspensions: Array<Suspension>;
  activeTaskAppearances: Array<DecisivePlayerPickerTaskAppearance | TaskAppearance | ThresholdPickerTaskAppearance>;
  age?: Maybe<Scalars['Int']['output']>;
  /** All player So5Scores ordered by descending game date */
  allSo5Scores: So5ScoreConnection;
  anyPlayer: BaseballPlayer | NBAPlayer | Player;
  anyPositions: Array<Position>;
  anyTeam: Club | NationalTeam;
  assetId: Scalars['ID']['output'];
  availableCardBoosts: Array<CardBoost>;
  averageScore?: Maybe<Scalars['Float']['output']>;
  backPictureUrl: Scalars['String']['output'];
  birthTxHash?: Maybe<Scalars['String']['output']>;
  blockchain: Scalars['String']['output'];
  blockchainId?: Maybe<Scalars['String']['output']>;
  blueprint?: Maybe<Blueprint>;
  bonuses: Array<So5ActiveClubsBonus | So5AverageScoresBonus | So5BoostBonus | So5CaptainBonus | So5CollectionBonus | So5DifferentNationalitiesBonus | So5GradeBonus | So5LineupBonus | So5MalusAfterTransferBonus | So5NationalityBonus | So5PlayerBonus | So5PositionBonus | So5PositionStacksBonus | So5SameActiveClubBonus | So5ScarcityBonus | So5SeasonBonus | So5SpecialEditionCardsBonus>;
  bonusesAfterTransfer: Array<So5ActiveClubsBonus | So5AverageScoresBonus | So5BoostBonus | So5CaptainBonus | So5CollectionBonus | So5DifferentNationalitiesBonus | So5GradeBonus | So5LineupBonus | So5MalusAfterTransferBonus | So5NationalityBonus | So5PlayerBonus | So5PositionBonus | So5PositionStacksBonus | So5SameActiveClubBonus | So5ScarcityBonus | So5SeasonBonus | So5SpecialEditionCardsBonus>;
  borderRadius: Scalars['Int']['output'];
  cardBackgroundUrl?: Maybe<Scalars['String']['output']>;
  cardBackgroundVideoUrl?: Maybe<Scalars['String']['output']>;
  cardCollectionCards: Array<CardCollectionCard>;
  cardEditionName?: Maybe<Scalars['String']['output']>;
  /** @deprecated Not used anymore */
  cardPrice?: Maybe<Scalars['Int']['output']>;
  cardSet?: Maybe<CardSet>;
  cardStats?: Maybe<CardStats>;
  collection?: Maybe<Collection>;
  collectionIncreaseScoreBreakdownAfterTransfer?: Maybe<CardCollectionCardScoreBreakdown>;
  collectionScoringMatrix: Array<CardCollectionScoringMatrix>;
  concurrentSo5Lineups: Array<So5Lineup>;
  contractAddress?: Maybe<Scalars['EthereumAddress']['output']>;
  coverageStatus: CardCoverageStatus;
  createdAt: Scalars['ISO8601DateTime']['output'];
  currentUserSubscription?: Maybe<EmailSubscription>;
  customCardEditionName?: Maybe<Scalars['String']['output']>;
  decks: Array<Deck>;
  delayedReveal?: Maybe<Scalars['Boolean']['output']>;
  displayRarity: Scalars['String']['output'];
  /** @deprecated Not used anymore */
  dropRank?: Maybe<Scalars['Int']['output']>;
  eligibleBoards: Array<CareerBoard | SquadBoard>;
  /** Eligible boards on which the card earns a special edition cards bonus */
  eligibleBoardsWithSpecialEditionBonus: Array<BoardWithSpecialEditionBonus>;
  eligiblePlayerGameScores: Array<BaseballPlayerGameScore | BasketballPlayerGameScore | PlayerGameScore | So5Score>;
  eligibleUpcomingLeagueTracks: Array<So5LeagueTrack>;
  ethereumId: Scalars['String']['output'];
  ethereumOwner?: Maybe<TokenOwner>;
  footballPlayer: Player;
  formattedCardEditionName?: Maybe<Scalars['String']['output']>;
  gameForLeague?: Maybe<Game>;
  /** Current card level */
  grade: Scalars['Int']['output'];
  gradeAfterTransfer: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  inRollup: Scalars['Boolean']['output'];
  inSeasonEligible: Scalars['Boolean']['output'];
  inSeasonUntil?: Maybe<Scalars['ISO8601DateTime']['output']>;
  ipfsPictureUrl?: Maybe<Scalars['String']['output']>;
  ipfsUrl?: Maybe<Scalars['String']['output']>;
  lastLeveledUpAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  latestEnglishAuction?: Maybe<TokenAuction>;
  latestPrimaryOffer?: Maybe<TokenPrimaryOffer>;
  levelUpAppliedCount: Scalars['Int']['output'];
  livePrimaryOffer?: Maybe<TokenPrimaryOffer>;
  liveSingleBuyOffers: Array<TokenOffer>;
  liveSingleSaleOffer?: Maybe<TokenOffer>;
  /** So5Lineup that this card is being used in for the live So5Fixture */
  liveSo5Lineup?: Maybe<So5Lineup>;
  loanedToken?: Maybe<LoanedToken>;
  /** Returns the lowest price card of the same player, rarity, season and print batch */
  lowestPriceCard?: Maybe<BaseballCard | Card | NBACard>;
  /** Returns the lowest price card of the same player and rarity */
  lowestPriceCardAnySeason?: Maybe<BaseballCard | Card | NBACard>;
  maxLevelUpAppliedCount: Scalars['Int']['output'];
  myCardCollectionSlot?: Maybe<UserCardCollectionSlot>;
  myMintedSingleSaleOffer?: Maybe<TokenOffer>;
  name: Scalars['String']['output'];
  nextLevelUpAvailableAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  notContractOwners: Array<OwnerWithRates>;
  openForDomesticStats: Scalars['Boolean']['output'];
  openForGameStats: Scalars['Boolean']['output'];
  openForGameStatsCompetitions: Array<Competition>;
  /** So5Lineups that this card is being used in for the opened So5Fixtures */
  openedSo5Lineups: Array<So5Lineup>;
  ownerSince?: Maybe<Scalars['ISO8601DateTime']['output']>;
  ownershipHistory: Array<TokenOwner>;
  pack?: Maybe<Pack>;
  pendingWithdrawal?: Maybe<TokenWithdrawal>;
  pictureUrl?: Maybe<Scalars['String']['output']>;
  player: Player;
  /** @deprecated Player loyalty is no longer used */
  playerLoyaltyBoost: RewardBoost;
  positionTyped: Position;
  /** Total card bonus (XP + Season bonus) */
  power: Scalars['String']['output'];
  /** Total card bonus after transfer */
  powerAfterTransfer: Scalars['String']['output'];
  powerBreakdown: PowerBreakdown;
  powerMalusAfterTransfer: Scalars['String']['output'];
  previouslyOwnedCard?: Maybe<Scalars['Boolean']['output']>;
  previouslyOwnedPlayer?: Maybe<Scalars['Boolean']['output']>;
  priceRange?: Maybe<Range>;
  /** Print batch of the card, 0 for the original print of that player, rarity and season */
  printBatch: Scalars['Int']['output'];
  privateMinPrices?: Maybe<MonetaryAmount>;
  publicMinPrices?: Maybe<MonetaryAmount>;
  rarity: Scalars['String']['output'];
  rarityTyped: Rarity;
  /** Up to 10 last So5Scores.score used in a So5Fixture */
  rawSo5Scores: Array<Maybe<Scalars['Float']['output']>>;
  /**
   * The `related_card_edition_slots` field cannot be nested within a list.
   * @deprecated Use myCardCollectionSlot.relatedCardEditionSlots instead
   */
  relatedCardEditionSlots?: Maybe<Array<UserCardCollectionSlot>>;
  revealableCardCampaign?: Maybe<RevealableCardCampaign>;
  sealable: Scalars['Boolean']['output'];
  sealableFor?: Maybe<Scalars['Int']['output']>;
  sealed: Scalars['Boolean']['output'];
  sealedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  sealedFor?: Maybe<Scalars['Int']['output']>;
  /** @deprecated Player loyalty is no longer used */
  sealedPlayerLoyaltyBoost: RewardBoost;
  season: Season;
  seasonYear: Scalars['Int']['output'];
  secondaryMarketFeeEnabled: Scalars['Boolean']['output'];
  /**
   * Returns all live or minted offers where this token is included in the sender
   * side. Returns only if authenticated and sender of the offers.
   */
  sentInLiveOffers?: Maybe<Array<TokenOffer>>;
  serialNumber: Scalars['Int']['output'];
  /** Whether this card qualifies for the social feed */
  shareable: Scalars['Boolean']['output'];
  /** Whether the current user already shared this card */
  shared: Scalars['Boolean']['output'];
  shirtNumber?: Maybe<Scalars['Int']['output']>;
  /** @deprecated Not used anymore */
  signedAddCardPrice?: Maybe<SignedCardPrice>;
  signedDropCardPrice?: Maybe<SignedCardPrice>;
  singleCivilYear: Scalars['Boolean']['output'];
  skinEdition?: Maybe<SkinEdition>;
  slug: Scalars['String']['output'];
  /** Up to 10 last So5Scores used in a So5Fixture */
  so5Scores: Array<Maybe<So5Score>>;
  solanaAddress?: Maybe<Scalars['String']['output']>;
  solanaBlockExplorerUrl?: Maybe<Scalars['String']['output']>;
  specialEdition?: Maybe<Scalars['String']['output']>;
  sport: Sport;
  sportSeason: SportSeason;
  starkwareTokenId?: Maybe<Scalars['String']['output']>;
  subscriptionsCount: Scalars['Int']['output'];
  supply: Scalars['Int']['output'];
  threeDimensional: Scalars['Boolean']['output'];
  threeDimensionalAsset?: Maybe<ThreeDimensionalAsset>;
  tokenOwner?: Maybe<TokenOwner>;
  tradeableStatus: Tradeable;
  u23Eligible: Scalars['Boolean']['output'];
  u23EligibleUntil?: Maybe<Scalars['ISO8601Date']['output']>;
  unsealableAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  unsealedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** @deprecated Player loyalty is no longer used */
  unsealedPlayerLoyaltyBoost: RewardBoost;
  usedIn?: Maybe<ListedOnMarket | UsedInSo5Lineups | UsedInTaskLineups | UsedInTaskPreparedLineups | UsedInTasks>;
  user?: Maybe<User>;
  userOwner?: Maybe<UserOwner>;
  videoUrl?: Maybe<Scalars['String']['output']>;
  walletStatus: WalletStatus;
  xp: Scalars['Int']['output'];
  xpAfterTransfer: Scalars['Int']['output'];
  /** XP start range of current card level */
  xpNeededForCurrentGrade: Scalars['Int']['output'];
  /** XP end range of current card level */
  xpNeededForNextGrade?: Maybe<Scalars['Int']['output']>;
}


/** A card representing a professional football player */
export interface CardactiveSuspensionsArgs {
  so5LeaderboardSlug?: InputMaybe<Scalars['String']['input']>;
}


/** A card representing a professional football player */
export interface CardallSo5ScoresArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
}


/** A card representing a professional football player */
export interface CardaverageScoreArgs {
  type: AveragePlayerScore;
}


/** A card representing a professional football player */
export interface CardbonusesArgs {
  highlighted?: InputMaybe<Scalars['Boolean']['input']>;
  so5LeaderboardSlug?: InputMaybe<Scalars['String']['input']>;
}


/** A card representing a professional football player */
export interface CardbonusesAfterTransferArgs {
  so5LeaderboardSlug?: InputMaybe<Scalars['String']['input']>;
}


/** A card representing a professional football player */
export interface CardcardBackgroundVideoUrlArgs {
  derivative?: InputMaybe<Scalars['String']['input']>;
}


/** A card representing a professional football player */
export interface CardconcurrentSo5LineupsArgs {
  so5FixtureSlug?: InputMaybe<Scalars['String']['input']>;
  so5LeaderboardSlug?: InputMaybe<Scalars['String']['input']>;
}


/** A card representing a professional football player */
export interface CardeligiblePlayerGameScoresArgs {
  boardId?: InputMaybe<Scalars['String']['input']>;
  gameId?: InputMaybe<Scalars['ID']['input']>;
  so5LeaderboardSlug?: InputMaybe<Scalars['String']['input']>;
  stepId?: InputMaybe<Scalars['String']['input']>;
  taskId?: InputMaybe<Scalars['ID']['input']>;
}


/** A card representing a professional football player */
export interface CardgameForLeagueArgs {
  so5LeaderboardSlug?: InputMaybe<Scalars['String']['input']>;
  so5LeagueSlug?: InputMaybe<Scalars['String']['input']>;
}


/** A card representing a professional football player */
export interface CardpictureUrlArgs {
  derivative?: InputMaybe<Scalars['String']['input']>;
}


/** A card representing a professional football player */
export interface CardpowerArgs {
  so5LeaderboardSlug?: InputMaybe<Scalars['String']['input']>;
}


/** A card representing a professional football player */
export interface CardpowerAfterTransferArgs {
  so5LeaderboardSlug?: InputMaybe<Scalars['String']['input']>;
}


/** A card representing a professional football player */
export interface CardpowerBreakdownArgs {
  so5LeaderboardSlug?: InputMaybe<Scalars['String']['input']>;
}


/** A card representing a professional football player */
export interface CardrawSo5ScoresArgs {
  last: Scalars['Int']['input'];
  lowCoverage?: InputMaybe<Scalars['Boolean']['input']>;
}


/** A card representing a professional football player */
export interface Cardso5ScoresArgs {
  last: Scalars['Int']['input'];
  lowCoverage?: InputMaybe<Scalars['Boolean']['input']>;
}


/** A card representing a professional football player */
export interface CardusedInArgs {
  gameId?: InputMaybe<Scalars['ID']['input']>;
  so5LeaderboardSlug?: InputMaybe<Scalars['String']['input']>;
  taskId?: InputMaybe<Scalars['ID']['input']>;
  taskLineupId?: InputMaybe<Scalars['ID']['input']>;
  taskPreparedLineupId?: InputMaybe<Scalars['ID']['input']>;
}


/** A card representing a professional football player */
export interface CardvideoUrlArgs {
  derivative?: InputMaybe<Scalars['String']['input']>;
}

export interface CardBoost {
  __typename: 'CardBoost';
  id: Scalars['String']['output'];
  levelToReach: Scalars['Int']['output'];
  shopItem: ClubShopItem;
  xpToGain: Scalars['Int']['output'];
}

/** CardBoostConfigType is the graphQL Type for a card boost on a leaderboard. */
export interface CardBoostConfig {
  __typename: 'CardBoostConfig';
  allSeasonsBasisPoints: Scalars['Int']['output'];
  captainAllSeasonsBasisPoints: Scalars['Int']['output'];
  captainInSeasonBasisPoints: Scalars['Int']['output'];
  inSeasonBasisPoints: Scalars['Int']['output'];
  mvpAllSeasonsBasisPoints: Scalars['Int']['output'];
  mvpInSeasonBasisPoints: Scalars['Int']['output'];
  rarity: Rarity;
}

/** A collection of cards */
export interface CardCollection extends Node {
  __typename: 'CardCollection';
  anyTeam?: Maybe<Club | NationalTeam>;
  backgroundPictureUrl?: Maybe<Scalars['String']['output']>;
  bannerPictureUrl?: Maybe<Scalars['String']['output']>;
  /** The `best_by_completed_at` field cannot be nested within a list. */
  bestByCompletedAt: UserCardCollectionConnection;
  /** The `best_by_score` field cannot be nested within a list. */
  bestByScore: UserCardCollectionConnection;
  bonusThresholds: Array<CardCollectionBonusThreshold>;
  cardSet?: Maybe<CardSet>;
  emptySlotBackgroundPictureUrl?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  inSeason: Scalars['Boolean']['output'];
  /** The `my_cards_recommendation` field cannot be nested within a list. */
  myCardsRecommendation?: Maybe<Array<BaseballCard | Card | NBACard>>;
  name: Scalars['String']['output'];
  rarity?: Maybe<Rarity>;
  /** The `related_shield` field cannot be nested within a list. */
  relatedShield?: Maybe<SkinShopItem>;
  scoreRankingSize: Scalars['Int']['output'];
  scoringMatrix: Array<CardCollectionScoringMatrix>;
  season?: Maybe<Season>;
  slotsPreview: Array<UserCardCollectionSlot>;
  slug: Scalars['String']['output'];
  snapshotted: Scalars['Boolean']['output'];
  /** The `social_picture_fingerprint` field cannot be nested within a list. */
  socialPictureFingerprint: Scalars['String']['output'];
  /** The `social_picture_urls` field cannot be nested within a list. */
  socialPictureUrls: SocialPictureDerivative;
  sportSeason?: Maybe<SportSeason>;
  subtitle: Scalars['String']['output'];
  userCardCollection: UserCardCollection;
}


/** A collection of cards */
export interface CardCollectionbestByCompletedAtArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
}


/** A collection of cards */
export interface CardCollectionbestByScoreArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
}


/** A collection of cards */
export interface CardCollectionslotsPreviewArgs {
  first?: InputMaybe<Scalars['Int']['input']>;
  forUserSlug: Scalars['String']['input'];
}


/** A collection of cards */
export interface CardCollectionsocialPictureFingerprintArgs {
  forUserSlug: Scalars['String']['input'];
}


/** A collection of cards */
export interface CardCollectionsocialPictureUrlsArgs {
  forUserSlug: Scalars['String']['input'];
}


/** A collection of cards */
export interface CardCollectionuserCardCollectionArgs {
  forUserSlug: Scalars['String']['input'];
}

/** A card collection bonus threshold */
export interface CardCollectionBonusThreshold {
  __typename: 'CardCollectionBonusThreshold';
  bonus: Scalars['Float']['output'];
  threshold: Scalars['Float']['output'];
}

/** A card in a collection of cards */
export interface CardCollectionCard extends Node {
  __typename: 'CardCollectionCard';
  anyCard: BaseballCard | Card | NBACard;
  cardCollection: CardCollection;
  heldSince: Scalars['ISO8601DateTime']['output'];
  highlighted?: Maybe<Scalars['Boolean']['output']>;
  holdingThresholdDays: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  scoreBreakdown: CardCollectionCardScoreBreakdown;
  userCardCollection?: Maybe<UserCardCollection>;
}

/** An object representing the breakdown of the score of a Card in a Card Collection */
export interface CardCollectionCardScoreBreakdown {
  __typename: 'CardCollectionCardScoreBreakdown';
  firstOwner: Scalars['Int']['output'];
  firstSerialNumber: Scalars['Int']['output'];
  holding: Scalars['Int']['output'];
  owner: Scalars['Int']['output'];
  rookie: Scalars['Int']['output'];
  shirtMatchingSerialNumber: Scalars['Int']['output'];
  specialEdition: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
}

/** The connection type for CardCollection. */
export interface CardCollectionConnection {
  __typename: 'CardCollectionConnection';
  competitionsCount: Array<CompetitionCount>;
  /** A list of edges. */
  edges: Array<CardCollectionEdge>;
  /** A list of nodes. */
  nodes: Array<CardCollection>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  raritiesCount: Array<RarityCount>;
  seasonsCount: Array<SeasonCount>;
  totalCount: Scalars['Int']['output'];
}

/** An edge in a connection. */
export interface CardCollectionEdge {
  __typename: 'CardCollectionEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<CardCollection>;
}

/** A user notification regarding a Card Collection */
export interface CardCollectionNotification extends Node, NotificationInterface {
  __typename: 'CardCollectionNotification';
  anyCard?: Maybe<Card>;
  body: Scalars['String']['output'];
  cardCollection: CardCollection;
  cardCollectionSlot?: Maybe<CardCollectionSlot>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  deeplinkUrl: Scalars['String']['output'];
  iconUrl: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  important: Scalars['Boolean']['output'];
  markdownBody: Scalars['String']['output'];
  name: Scalars['String']['output'];
  pictureUrl?: Maybe<Scalars['String']['output']>;
  read: Scalars['Boolean']['output'];
  shieldShopItem?: Maybe<SkinShopItem>;
  sport?: Maybe<SportOrShared>;
  title: Scalars['String']['output'];
  user: CurrentUser;
}

/** A card collection requirement on a shop item */
export interface CardCollectionRequirement {
  __typename: 'CardCollectionRequirement';
  cardCollection: CardCollection;
  score: Scalars['Int']['output'];
}

/** A score increase of a card collection */
export interface CardCollectionScoreIncrease {
  __typename: 'CardCollectionScoreIncrease';
  bonusIncrease: Scalars['Float']['output'];
  cardCollection: CardCollection;
  id: Scalars['String']['output'];
  scoreIncrease: Scalars['Int']['output'];
  userCardCollection?: Maybe<UserCardCollection>;
}

export interface CardCollectionScoringMatrix {
  __typename: 'CardCollectionScoringMatrix';
  explanation: Scalars['String']['output'];
  label: Scalars['String']['output'];
  name: Scalars['String']['output'];
  pictureUrl: Scalars['String']['output'];
  value: Scalars['Int']['output'];
}

/** A slot in a collection of cards */
export interface CardCollectionSlot extends Node {
  __typename: 'CardCollectionSlot';
  anyPlayer: BaseballPlayer | NBAPlayer | Player;
  anyTeam?: Maybe<Club | NationalTeam>;
  cardCollectionCards: Array<CardCollectionCard>;
  cardPacks?: Maybe<Array<CardPack>>;
  cardPictureUrl: Scalars['String']['output'];
  cardSet?: Maybe<CardSet>;
  customCardEditionName?: Maybe<Scalars['String']['output']>;
  displayedRequirements?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  player: Player;
  rarity?: Maybe<Rarity>;
  season?: Maybe<Season>;
  /** @deprecated No longer used */
  serialNumber?: Maybe<Scalars['Int']['output']>;
  transferMarketFilters: Scalars['String']['output'];
  userCardCollectionSlot: UserCardCollectionSlot;
}


/** A slot in a collection of cards */
export interface CardCollectionSlotcardCollectionCardsArgs {
  forUserSlug: Scalars['String']['input'];
}


/** A slot in a collection of cards */
export interface CardCollectionSlotuserCardCollectionSlotArgs {
  forUserSlug: Scalars['String']['input'];
}

export const CardCollectionSortingOption = {
  HIGHEST_SCORE: 'HIGHEST_SCORE',
  LAST_CARD_ADDED: 'LAST_CARD_ADDED'
} as const;

export type CardCollectionSortingOption = typeof CardCollectionSortingOption[keyof typeof CardCollectionSortingOption];
export interface CardCollectionWithProgress {
  __typename: 'CardCollectionWithProgress';
  cardCollection: CardCollection;
  progress: Scalars['Int']['output'];
}

/** The connection type for CardCollectionWithProgress. */
export interface CardCollectionWithProgressConnection {
  __typename: 'CardCollectionWithProgressConnection';
  /** A list of edges. */
  edges: Array<CardCollectionWithProgressEdge>;
  /** A list of nodes. */
  nodes: Array<CardCollectionWithProgress>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
}

/** An edge in a connection. */
export interface CardCollectionWithProgressEdge {
  __typename: 'CardCollectionWithProgressEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<CardCollectionWithProgress>;
}

/** The connection type for Card. */
export interface CardConnection {
  __typename: 'CardConnection';
  /** A list of edges. */
  edges: Array<CardEdge>;
  hasAny: Scalars['Boolean']['output'];
  /** A list of nodes. */
  nodes: Array<Card>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
}

/** A user card count breakdown */
export interface CardCount {
  __typename: 'CardCount';
  common: Scalars['Int']['output'];
  customSeries: Scalars['Int']['output'];
  limited: Scalars['Int']['output'];
  rare: Scalars['Int']['output'];
  superRare: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
  unique: Scalars['Int']['output'];
}

export const CardCoverageStatus = {
  FULL: 'FULL',
  LEGEND: 'LEGEND',
  NOT_COVERED: 'NOT_COVERED',
  NOT_ELIGIBLE: 'NOT_ELIGIBLE',
  PARTIAL: 'PARTIAL',
  SPECIAL: 'SPECIAL'
} as const;

export type CardCoverageStatus = typeof CardCoverageStatus[keyof typeof CardCoverageStatus];
export const CardDesign = {
  ART_EDITION: 'ART_EDITION',
  BASEBALL_2022: 'BASEBALL_2022',
  BASEBALL_2023: 'BASEBALL_2023',
  BASEBALL_2024: 'BASEBALL_2024',
  BASEBALL_2025: 'BASEBALL_2025',
  BASEBALL_2026: 'BASEBALL_2026',
  BASEBALL_AWARDS_2023: 'BASEBALL_AWARDS_2023',
  BASEBALL_EARLY_ACCESS_2026: 'BASEBALL_EARLY_ACCESS_2026',
  FOOTBALL_2018: 'FOOTBALL_2018',
  FOOTBALL_2019: 'FOOTBALL_2019',
  FOOTBALL_2020: 'FOOTBALL_2020',
  FOOTBALL_2021: 'FOOTBALL_2021',
  FOOTBALL_2022: 'FOOTBALL_2022',
  FOOTBALL_2022_2023: 'FOOTBALL_2022_2023',
  FOOTBALL_2023: 'FOOTBALL_2023',
  FOOTBALL_2024: 'FOOTBALL_2024',
  FOOTBALL_2025: 'FOOTBALL_2025',
  FOOTBALL_2026: 'FOOTBALL_2026',
  FOOTBALL_BLUEPRINT_2024: 'FOOTBALL_BLUEPRINT_2024',
  FOOTBALL_EARLY_ACCESS_2025: 'FOOTBALL_EARLY_ACCESS_2025',
  FOOTBALL_EARLY_ACCESS_2026: 'FOOTBALL_EARLY_ACCESS_2026',
  FOOTBALL_GC_2022: 'FOOTBALL_GC_2022',
  FOOTBALL_GC_SILHOUETTE_2022: 'FOOTBALL_GC_SILHOUETTE_2022',
  FOOTBALL_LEGACY_LEGEND: 'FOOTBALL_LEGACY_LEGEND',
  FOOTBALL_LEGEND: 'FOOTBALL_LEGEND',
  FOOTBALL_RIVALS_2023: 'FOOTBALL_RIVALS_2023',
  FOOTBALL_SILHOUETTE_RIVALS_UNLICENSED_2024: 'FOOTBALL_SILHOUETTE_RIVALS_UNLICENSED_2024',
  FOOTBALL_SILHOUETTE_UNLICENSED_2023: 'FOOTBALL_SILHOUETTE_UNLICENSED_2023',
  FOOTBALL_SILHOUETTE_UNLICENSED_2024: 'FOOTBALL_SILHOUETTE_UNLICENSED_2024',
  FOOTBALL_VINTAGE_2024: 'FOOTBALL_VINTAGE_2024',
  NBA_2022: 'NBA_2022',
  NBA_2023: 'NBA_2023',
  NBA_2023_DRAFT: 'NBA_2023_DRAFT',
  NBA_2024: 'NBA_2024',
  NBA_2025: 'NBA_2025',
  NBA_2026: 'NBA_2026',
  NBA_BLUEPRINT_2024: 'NBA_BLUEPRINT_2024',
  NBA_DRAFT_2025: 'NBA_DRAFT_2025',
  NBA_EARLY_ACCESS_2025: 'NBA_EARLY_ACCESS_2025',
  NBA_EARLY_ACCESS_2026: 'NBA_EARLY_ACCESS_2026',
  NBA_RIVALS_2023: 'NBA_RIVALS_2023'
} as const;

export type CardDesign = typeof CardDesign[keyof typeof CardDesign];
/** An edge in a connection. */
export interface CardEdge {
  __typename: 'CardEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<Card>;
}

/** Enforces restrictions on specific card editions of submitted lineups */
export interface CardEditionCount {
  __typename: 'CardEditionCount';
  /** The display name of the card edition on which this rule would apply */
  displayName: Scalars['String']['output'];
  max?: Maybe<Scalars['Int']['output']>;
  min?: Maybe<Scalars['Int']['output']>;
  /** The name of the card edition on which this rule would apply */
  name: Scalars['String']['output'];
}

/** Enforces restrictions on card editions of submitted lineups */
export interface CardEditionsCount {
  __typename: 'CardEditionsCount';
  displayedEditions: Array<CardEditionCount>;
  /** Card editions on which restrictions are applied with their additional restrictions, if any */
  editions: Array<CardEditionCount>;
  max?: Maybe<Scalars['Int']['output']>;
  min?: Maybe<Scalars['Int']['output']>;
}

export interface CardEligibilityRulesInterface {
  eligibleCardEditions?: Maybe<Array<Scalars['String']['output']>>;
  eligibleCompetitions?: Maybe<Array<Competition>>;
  eligibleRarities?: Maybe<Array<Rarity>>;
  eligibleSerialNumbers?: Maybe<Array<Scalars['String']['output']>>;
  eligibleSo5Leagues?: Maybe<Array<Scalars['String']['output']>>;
  eligibleTeams?: Maybe<Array<Team>>;
  id: Scalars['String']['output'];
}

/** Card Game Interface */
export interface CardGameInterface {
  cardCollectionCards: Array<CardCollectionCard>;
  coverageStatus: CardCoverageStatus;
  gameForLeague?: Maybe<Game>;
  u23Eligible: Scalars['Boolean']['output'];
  u23EligibleUntil?: Maybe<Scalars['ISO8601Date']['output']>;
}


/** Card Game Interface */
export interface CardGameInterfacegameForLeagueArgs {
  so5LeaderboardSlug?: InputMaybe<Scalars['String']['input']>;
  so5LeagueSlug?: InputMaybe<Scalars['String']['input']>;
}

/** Represents a card layout */
export interface CardLayout {
  __typename: 'CardLayout';
  /** @deprecated Use frontFoilColorUrl instead */
  backgroundFoilColorUrl?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use frontFoilUrl instead */
  backgroundFoilUrl?: Maybe<Scalars['String']['output']>;
  backgroundLayers: Array<Scalars['String']['output']>;
  backgroundMaskUrl?: Maybe<Scalars['String']['output']>;
  backgroundUrl?: Maybe<Scalars['String']['output']>;
  cardDesign?: Maybe<CardDesign>;
  frontFoilColorUrl?: Maybe<Scalars['String']['output']>;
  frontFoilUrl?: Maybe<Scalars['String']['output']>;
  layers: Array<Scalars['String']['output']>;
  licensorUrl?: Maybe<Scalars['String']['output']>;
  playerMaskUrl?: Maybe<Scalars['String']['output']>;
  videoBackgroundUrl?: Maybe<Scalars['String']['output']>;
}

/** A user notification regarding a Card */
export interface CardNotification extends Node, NotificationInterface {
  __typename: 'CardNotification';
  anyCard?: Maybe<BaseballCard | Card | NBACard>;
  body: Scalars['String']['output'];
  createdAt: Scalars['ISO8601DateTime']['output'];
  deeplinkUrl: Scalars['String']['output'];
  iconUrl: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  important: Scalars['Boolean']['output'];
  markdownBody: Scalars['String']['output'];
  name: Scalars['String']['output'];
  pictureUrl?: Maybe<Scalars['String']['output']>;
  read: Scalars['Boolean']['output'];
  sport?: Maybe<SportOrShared>;
  title: Scalars['String']['output'];
  tokenWithdrawal?: Maybe<TokenWithdrawal>;
  user: CurrentUser;
  withdrawal?: Maybe<StarkwareWithdrawal>;
}

/** A card pack */
export interface CardPack extends MarketItem {
  __typename: 'CardPack';
  /** @deprecated Not used anymore */
  backgroundUrl?: Maybe<Scalars['String']['output']>;
  /** The boosted versions of this basic pack, with the odds to get each one when buying it */
  boostedPackOdds: Array<BoostedPackOdds>;
  /** Whether the current user can purchase this pack */
  canPurchase: Scalars['Boolean']['output'];
  cardPackGroup?: Maybe<CardPackGroup>;
  cardSet?: Maybe<CardSet>;
  cardsCount: Scalars['Int']['output'];
  category?: Maybe<CardPackCategory>;
  color: Scalars['String']['output'];
  competition?: Maybe<Competition>;
  /** @deprecated Not used anymore */
  contributesToUnlockTask?: Maybe<CardsCountTargetTask | CardsCountTask | CompleteCollectionsCountTargetTask | CompleteCollectionsCountTask | DailyActionTask | DecisivePlayerPickerTask | DropChallengeTask | GameWeeklyTask | GuessTheScoreTask | InviteTaskAsReferrer | So5LeaderboardTask | StarPackTask | Task | TasksTrack | ThresholdPickerTask | ThresholdsDuoConnectionTask | ThresholdsStreakAdditionalLineupTask | ThresholdsStreakTask>;
  currency: CardPackCurrency;
  /** A localized description of the pack */
  description?: Maybe<Scalars['String']['output']>;
  desktopBackgroundUrl?: Maybe<Scalars['String']['output']>;
  /** Discounted price if applicable */
  discountedPrice?: Maybe<Scalars['Int']['output']>;
  /** The actual price to pay (discounted or regular) */
  effectivePrice: Scalars['Int']['output'];
  /** @deprecated No longer supported */
  eligibleCommonPlayers: Array<CommonPlayer>;
  /** When the pack stops being available for purchase */
  endDate?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** A localized extra label description of the pack */
  extraLabelDescription?: Maybe<Scalars['String']['output']>;
  /** Whether this pack is featured */
  featured: Scalars['Boolean']['output'];
  /** @deprecated Use slotGameplayTierOdds instead */
  globalRankOdds: Array<CardPackSlotRankOdd>;
  /** Maximum number of times this pack can be purchased per user */
  maxPurchasePerPack?: Maybe<Scalars['Int']['output']>;
  pictureUrl: Scalars['String']['output'];
  price: Scalars['Int']['output'];
  quality?: Maybe<CardPackQuality>;
  /** Number of packs still available to buy (null when supply is unlimited) */
  remainingSupply?: Maybe<Scalars['Int']['output']>;
  /** @deprecated Not used anymore */
  rewardedByTask?: Maybe<CardsCountTargetTask | CardsCountTask | CompleteCollectionsCountTargetTask | CompleteCollectionsCountTask | DailyActionTask | DecisivePlayerPickerTask | DropChallengeTask | GameWeeklyTask | GuessTheScoreTask | InviteTaskAsReferrer | So5LeaderboardTask | StarPackTask | Task | TasksTrack | ThresholdPickerTask | ThresholdsDuoConnectionTask | ThresholdsStreakAdditionalLineupTask | ThresholdsStreakTask>;
  /** @deprecated No longer supported */
  sections: Array<CardPackSection>;
  /** Per-player draw odds for a slot, grouped by gameplay tier */
  slotGameplayTierOdds: Array<GameplayTierOdds>;
  /** @deprecated Use slotGameplayTierOdds instead */
  slots: Array<CardPackSlot>;
  slug: Scalars['String']['output'];
  /** The So5 competition this pack is tied to, if any */
  so5Competition?: Maybe<So5Competition>;
  teams: Array<Club | NationalTeam>;
  title: Scalars['String']['output'];
  /** Maximum number of packs that can ever be sold (null when supply is unlimited) */
  totalSupply?: Maybe<Scalars['Int']['output']>;
  /** Number of times the current user has purchased this pack (only available if max_purchase_per_pack is set) */
  userPurchaseCount?: Maybe<Scalars['Int']['output']>;
}


/** A card pack */
export interface CardPackcolorArgs {
  variant?: InputMaybe<ColorVariant>;
}


/** A card pack */
export interface CardPackslotGameplayTierOddsArgs {
  search?: InputMaybe<Scalars['String']['input']>;
  skin?: InputMaybe<Skin>;
  slotIndex: Scalars['Int']['input'];
}

/** A card pack a manager shared, showcasing one of its cards */
export interface CardPackActivityFeed extends ActivityFeedInterface, Node {
  __typename: 'CardPackActivityFeed';
  backgroundUrl?: Maybe<Scalars['String']['output']>;
  /**
   * The most recent reaction the current user left on this activity
   * @deprecated Use currentUserReactions instead
   */
  currentUserReaction?: Maybe<ActivityReaction>;
  /** The reactions the current user left on this activity, the oldest first */
  currentUserReactions: Array<ActivityReaction>;
  highlightedCard: BaseballCard | Card | NBACard;
  /** @deprecated Use highlightedCard instead */
  highlightedCommonPlayer: CommonPlayer;
  id: Scalars['ID']['output'];
  packConfig: CardPack;
  /** Whether the shared card is defined enough to be displayed in the large format */
  premium: Scalars['Boolean']['output'];
  /** The reactions left on this activity, the most recent first The `reactions` field cannot be nested within a list. */
  reactions: ActivityReactionConnection;
  /** How many managers left each emoji, the most reacted first */
  reactionsCount: Array<ActivityReactionCount>;
  sharedAt: Scalars['ISO8601DateTime']['output'];
  user: User;
}


/** A card pack a manager shared, showcasing one of its cards */
export interface CardPackActivityFeedreactionsArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  emoji?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
}

export const CardPackCategory = {
  BRONZE: 'BRONZE',
  GOLD: 'GOLD',
  LIVE_TODAY: 'LIVE_TODAY',
  LIVE_TODAY_TEMPLATE: 'LIVE_TODAY_TEMPLATE',
  ONLY_STARTING_PLAYERS: 'ONLY_STARTING_PLAYERS',
  ONLY_STARTING_PLAYERS_TEMPLATE: 'ONLY_STARTING_PLAYERS_TEMPLATE',
  SILVER: 'SILVER',
  STARTER: 'STARTER'
} as const;

export type CardPackCategory = typeof CardPackCategory[keyof typeof CardPackCategory];
export const CardPackCurrency = {
  COMMON_ESSENCE: 'COMMON_ESSENCE',
  COMMON_GEM: 'COMMON_GEM'
} as const;

export type CardPackCurrency = typeof CardPackCurrency[keyof typeof CardPackCurrency];
/** A group of card packs */
export interface CardPackGroup extends MarketSetSection {
  __typename: 'CardPackGroup';
  backgroundUrl?: Maybe<Scalars['String']['output']>;
  boughtPacksCountTask?: Maybe<CardsCountTargetTask | CardsCountTask | CompleteCollectionsCountTargetTask | CompleteCollectionsCountTask | DailyActionTask | DecisivePlayerPickerTask | DropChallengeTask | GameWeeklyTask | GuessTheScoreTask | InviteTaskAsReferrer | So5LeaderboardTask | StarPackTask | Task | TasksTrack | ThresholdPickerTask | ThresholdsDuoConnectionTask | ThresholdsStreakAdditionalLineupTask | ThresholdsStreakTask>;
  cardPacks: Array<CardPack>;
  cardSet: CardSet;
  /** @deprecated Not used anymore */
  dailyDeal: Scalars['Boolean']['output'];
  /** @deprecated Moved to CardPackType */
  desktopBackgroundUrl?: Maybe<Scalars['String']['output']>;
  endsAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** @deprecated Not used anymore */
  featured: Scalars['Boolean']['output'];
  /** @deprecated Not used anymore */
  hoverColor?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  mainColor?: Maybe<Scalars['String']['output']>;
  /** @deprecated Not used anymore */
  nextPackRotationAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** @deprecated Not used anymore */
  packConfigGroupType: PackConfigGroup;
  pictureUrl?: Maybe<Scalars['String']['output']>;
  resetAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  slug: Scalars['String']['output'];
  /** When this group becomes buyable; its packs are "coming soon" until this date is reached */
  startDate?: Maybe<Scalars['ISO8601DateTime']['output']>;
  title: Scalars['String']['output'];
  titleBackgroundUrl?: Maybe<Scalars['String']['output']>;
}


/** A group of card packs */
export interface CardPackGroupcardPacksArgs {
  onlyForSale?: InputMaybe<Scalars['Boolean']['input']>;
}

export const CardPackQuality = {
  BRONZE: 'BRONZE',
  GOLD: 'GOLD',
  SILVER: 'SILVER'
} as const;

export type CardPackQuality = typeof CardPackQuality[keyof typeof CardPackQuality];
export interface CardPackReward extends AnyRewardInterface, Node {
  __typename: 'CardPackReward';
  aasmState: RewardState;
  config: CardPacksRewardConfig | CardRewardConfig | CardShardRewardConfig | CoinRewardConfig | ConversionCreditRewardConfig | DeliverableItemRewardConfig | ExperienceRewardConfig | InGameCurrencyRewardConfig | MonetaryRewardConfig | ProbabilisticBundleRewardConfig | ShopItemRewardConfig;
  id: Scalars['ID']['output'];
  pack?: Maybe<Pack>;
}

/** A card pack section */
export interface CardPackSection {
  __typename: 'CardPackSection';
  description: Scalars['String']['output'];
  iconUrl: Scalars['String']['output'];
}

/** A card pack slot */
export interface CardPackSlot {
  __typename: 'CardPackSlot';
  /** @deprecated Use slotGameplayTierOdds instead */
  playingStatusOdds: Array<CardPackSlotPlayingStatusOdd>;
  /** @deprecated Use slotGameplayTierOdds instead */
  positionName: Scalars['String']['output'];
  /** @deprecated Use slotGameplayTierOdds instead */
  positionShortName: Scalars['String']['output'];
  /** @deprecated Use slotGameplayTierOdds instead */
  positions: Array<Position>;
  /** @deprecated Use slotGameplayTierOdds instead */
  rankOdds: Array<CardPackSlotRankOdd>;
}

/** A card pack slot rank odd */
export interface CardPackSlotPlayingStatusOdd {
  __typename: 'CardPackSlotPlayingStatusOdd';
  /** @deprecated Use slotGameplayTierOdds instead */
  probabilityBasisPoint: Scalars['Int']['output'];
  /** @deprecated Use slotGameplayTierOdds instead */
  starter: Scalars['Boolean']['output'];
}

/** A card pack slot rank odd */
export interface CardPackSlotRankOdd {
  __typename: 'CardPackSlotRankOdd';
  /** @deprecated Use slotGameplayTierOdds instead */
  commonPlayer?: Maybe<CommonPlayer>;
  /** @deprecated Use slotGameplayTierOdds instead */
  dropRank: Scalars['Int']['output'];
  /** @deprecated Use slotGameplayTierOdds instead */
  probabilityBasisPoint: Scalars['Int']['output'];
}

/** A CardPack Reward Config */
export interface CardPacksRewardConfig extends AnyRewardConfigInterface {
  __typename: 'CardPacksRewardConfig';
  boostedRewardConfigs?: Maybe<Array<CardPacksRewardConfig | CardRewardConfig | CardShardRewardConfig | CoinRewardConfig | ConversionCreditRewardConfig | DeliverableItemRewardConfig | ExperienceRewardConfig | InGameCurrencyRewardConfig | MonetaryRewardConfig | ProbabilisticBundleRewardConfig | ShopItemRewardConfig>>;
  cardPack?: Maybe<CardPack>;
  id: Scalars['ID']['output'];
}

/** A card pull */
export interface CardPull extends Node {
  __typename: 'CardPull';
  activePulledCards: Array<CardPullCard>;
  bestGameplayTier?: Maybe<GameplayTier>;
  bestQuality?: Maybe<CardQuality>;
  chest: CardShardsChest;
  expiresAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['ID']['output'];
  /** The `pool_key_shards_counts` field cannot be nested within a list. */
  poolKeyShardsCounts: Array<PoolKeyShardsCount>;
  pullConfig: CardPullConfig;
  rarity: Rarity;
  refundAmountInShards: Scalars['Int']['output'];
  reshuffled: Scalars['Boolean']['output'];
  /** @deprecated Halloween-specific; only populated for archived halloween_fifty_fifty pulls. */
  specialEventFiftyFiftyResult?: Maybe<SpecialEventFiftyFiftyResult>;
  sport: Sport;
}

/** A card pulled from a card pull */
export interface CardPullCard extends Node {
  __typename: 'CardPullCard';
  /** @deprecated The Global Cup is over; this field is no longer populated. */
  atGlobalCup?: Maybe<Scalars['Boolean']['output']>;
  competition?: Maybe<Competition>;
  country?: Maybe<Country>;
  division?: Maybe<BaseballDivision | BasketballDivision>;
  fiftyFiftySelected?: Maybe<Scalars['Boolean']['output']>;
  gameplayTier?: Maybe<GameplayTier>;
  id: Scalars['ID']['output'];
  picked: Scalars['Boolean']['output'];
  position?: Maybe<Position>;
  quality?: Maybe<CardQuality>;
  revealedCard?: Maybe<BaseballCard | Card | NBACard>;
}

/** A card pull config */
export interface CardPullConfig {
  __typename: 'CardPullConfig';
  description: Scalars['String']['output'];
  name: Scalars['String']['output'];
  ratioRefundedShardsBasisPoints: Scalars['Int']['output'];
  revealCosts: Array<RevealCost>;
}

export interface CardPullSource extends HistoryTransactionInterface {
  __typename: 'CardPullSource';
  date: Scalars['ISO8601DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  label: Scalars['String']['output'];
  logoUrl?: Maybe<Scalars['String']['output']>;
  quantityByFlavour: Array<PoolKeyShardsCount>;
  totalQuantity: Scalars['Int']['output'];
}

export const CardQuality = {
  TIER_0: 'TIER_0',
  TIER_1: 'TIER_1',
  TIER_2: 'TIER_2',
  TIER_3: 'TIER_3',
  TIER_4: 'TIER_4',
  TIER_5: 'TIER_5'
} as const;

export type CardQuality = typeof CardQuality[keyof typeof CardQuality];
/** A Card Reward Config */
export interface CardRewardConfig extends AnyRewardConfigInterface {
  __typename: 'CardRewardConfig';
  boostedRewardConfigs?: Maybe<Array<CardPacksRewardConfig | CardRewardConfig | CardShardRewardConfig | CoinRewardConfig | ConversionCreditRewardConfig | DeliverableItemRewardConfig | ExperienceRewardConfig | InGameCurrencyRewardConfig | MonetaryRewardConfig | ProbabilisticBundleRewardConfig | ShopItemRewardConfig>>;
  competitionSlugs?: Maybe<Array<Scalars['String']['output']>>;
  configRarity: RewardConfigRarity;
  customCardEditionName?: Maybe<Scalars['String']['output']>;
  customCardEditionNames?: Maybe<Array<Scalars['String']['output']>>;
  gameplayTier?: Maybe<GameplayTier>;
  id: Scalars['ID']['output'];
  pictureUrl?: Maybe<Scalars['String']['output']>;
  playerSlugs?: Maybe<Array<Scalars['String']['output']>>;
  players?: Maybe<Array<BaseballPlayer | NBAPlayer | Player>>;
  qualities?: Maybe<Array<CardQuality>>;
  quality?: Maybe<Scalars['String']['output']>;
  qualityTyped?: Maybe<CardQuality>;
  rarity: Rarity;
  teamSlugs?: Maybe<Array<Scalars['String']['output']>>;
  u23GameplayTier?: Maybe<GameplayTier>;
}

/** Information needed for a card screenshot */
export interface CardSample extends Node {
  __typename: 'CardSample';
  id: Scalars['ID']['output'];
  offsetX: Scalars['Int']['output'];
  offsetY: Scalars['Int']['output'];
  positioning: PicturePositioning;
  rotation?: Maybe<Scalars['Float']['output']>;
  zoom?: Maybe<Scalars['Float']['output']>;
}

/** The supply of cards for a Player in a Season */
export interface CardSeasonSupply {
  __typename: 'CardSeasonSupply';
  anyPlayer: BaseballPlayer | NBAPlayer | Player;
  limited: Scalars['Int']['output'];
  player: Player;
  rare: Scalars['Int']['output'];
  season: Season;
  superRare: Scalars['Int']['output'];
  unique: Scalars['Int']['output'];
}

/** A set of cards */
export interface CardSet {
  __typename: 'CardSet';
  active: Scalars['Boolean']['output'];
  availableCompetitions: Array<Competition>;
  branding: CardSetBranding;
  canDropCards: Scalars['Boolean']['output'];
  canLevelUp: Scalars['Boolean']['output'];
  customCardEditionNames: Array<Scalars['String']['output']>;
  endDate?: Maybe<Scalars['ISO8601DateTime']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  /** @deprecated CardSets are no longer scoped to a season. Returns the current season. */
  season: Season;
  slug: Scalars['String']['output'];
  startDate?: Maybe<Scalars['ISO8601DateTime']['output']>;
}


/** A set of cards */
export interface CardSetactiveArgs {
  sport?: InputMaybe<Sport>;
}


/** A set of cards */
export interface CardSetendDateArgs {
  sport?: InputMaybe<Sport>;
}


/** A set of cards */
export interface CardSetstartDateArgs {
  sport?: InputMaybe<Sport>;
}

/** Branding (images and hex colours) for a card set */
export interface CardSetBranding {
  __typename: 'CardSetBranding';
  assetUrl?: Maybe<Scalars['String']['output']>;
  colorTheme: CardSetBrandingColorTheme;
  colors: CardSetBrandingColors;
  id: Scalars['ID']['output'];
}


/** Branding (images and hex colours) for a card set */
export interface CardSetBrandingassetUrlArgs {
  competitionSlug?: InputMaybe<Scalars['String']['input']>;
  derivative?: InputMaybe<CardSetBrandingAssetDerivative>;
  slot: CardSetBrandingAssetSlot;
}

/** A generated derivative format of a card set branding image */
export const CardSetBrandingAssetDerivative = {
  PDF: 'PDF'
} as const;

export type CardSetBrandingAssetDerivative = typeof CardSetBrandingAssetDerivative[keyof typeof CardSetBrandingAssetDerivative];
/** The slot a card set branding image is displayed in */
export const CardSetBrandingAssetSlot = {
  BRANDING_AFFILIATE_SCREEN_INVITE_MOBILE: 'BRANDING_AFFILIATE_SCREEN_INVITE_MOBILE',
  BRANDING_BOARD_SQUAD_SPLASH: 'BRANDING_BOARD_SQUAD_SPLASH',
  BRANDING_CARD_BACK: 'BRANDING_CARD_BACK',
  BRANDING_COLLECTION_BANNER_MOBILE: 'BRANDING_COLLECTION_BANNER_MOBILE',
  BRANDING_HOMEPAGE_ASSET_SQUAD_MOBILE: 'BRANDING_HOMEPAGE_ASSET_SQUAD_MOBILE',
  BRANDING_REFERRAL_ASSET_MOBILE: 'BRANDING_REFERRAL_ASSET_MOBILE',
  BRANDING_REFERRAL_BANNER_MOBILE: 'BRANDING_REFERRAL_BANNER_MOBILE',
  BRANDING_SET_CURRENCY_MOBILE: 'BRANDING_SET_CURRENCY_MOBILE',
  BRANDING_SET_ICON_MOBILE: 'BRANDING_SET_ICON_MOBILE',
  BRANDING_SET_LOGO_COMPOSITE_DESKTOP: 'BRANDING_SET_LOGO_COMPOSITE_DESKTOP',
  BRANDING_SET_LOGO_COMPOSITE_MOBILE: 'BRANDING_SET_LOGO_COMPOSITE_MOBILE',
  DAILY_PACK_SECTION_TITLE_BACKGROUND: 'DAILY_PACK_SECTION_TITLE_BACKGROUND',
  GEM_SECTION_TITLE_BACKGROUND: 'GEM_SECTION_TITLE_BACKGROUND',
  INVITE_PAGE_BACKGROUND_AFFILIATE_DESKTOP: 'INVITE_PAGE_BACKGROUND_AFFILIATE_DESKTOP',
  INVITE_PAGE_BACKGROUND_AFFILIATE_MOBILE: 'INVITE_PAGE_BACKGROUND_AFFILIATE_MOBILE',
  INVITE_PAGE_BACKGROUND_DESKTOP: 'INVITE_PAGE_BACKGROUND_DESKTOP',
  INVITE_PAGE_BACKGROUND_MOBILE: 'INVITE_PAGE_BACKGROUND_MOBILE',
  INVITE_PAGE_CARDS: 'INVITE_PAGE_CARDS',
  INVITE_PAGE_META: 'INVITE_PAGE_META',
  LANDING_HERO_BACKGROUND: 'LANDING_HERO_BACKGROUND',
  LANDING_HERO_PLAYERS_LEFT: 'LANDING_HERO_PLAYERS_LEFT',
  LANDING_HERO_PLAYERS_RIGHT: 'LANDING_HERO_PLAYERS_RIGHT',
  LANDING_PLAY_BACKGROUND: 'LANDING_PLAY_BACKGROUND',
  LANDING_PLAY_LINEUP: 'LANDING_PLAY_LINEUP',
  LANDING_REWARD_BACKGROUND: 'LANDING_REWARD_BACKGROUND',
  LANDING_REWARD_CASH_ICON: 'LANDING_REWARD_CASH_ICON',
  LANDING_SCOUT_BACKGROUND: 'LANDING_SCOUT_BACKGROUND',
  LANDING_SCOUT_PLAYERS: 'LANDING_SCOUT_PLAYERS',
  MANAGER_PROFILE_BACKGROUND_DESKTOP: 'MANAGER_PROFILE_BACKGROUND_DESKTOP',
  MANAGER_PROFILE_BACKGROUND_MOBILE: 'MANAGER_PROFILE_BACKGROUND_MOBILE',
  MARKET_BANNER_DESKTOP: 'MARKET_BANNER_DESKTOP',
  MARKET_BANNER_MOBILE: 'MARKET_BANNER_MOBILE',
  MARKET_GEMS_BACKGROUND_DESKTOP: 'MARKET_GEMS_BACKGROUND_DESKTOP',
  MARKET_GEMS_BACKGROUND_MOBILE: 'MARKET_GEMS_BACKGROUND_MOBILE',
  MARKET_LIVEOPS_OFFER_BACKGROUND_MOBILE: 'MARKET_LIVEOPS_OFFER_BACKGROUND_MOBILE',
  MARKET_PACKS_BACKGROUND_DESKTOP: 'MARKET_PACKS_BACKGROUND_DESKTOP',
  MARKET_PACKS_BACKGROUND_MOBILE: 'MARKET_PACKS_BACKGROUND_MOBILE',
  MARKET_PACK_DETAILS_DESKTOP: 'MARKET_PACK_DETAILS_DESKTOP',
  MARKET_PACK_DETAILS_MOBILE: 'MARKET_PACK_DETAILS_MOBILE',
  MARKET_PACK_OPENING_MOBILE: 'MARKET_PACK_OPENING_MOBILE',
  MARKET_WELCOME_OFFER_72_H_MOBILE: 'MARKET_WELCOME_OFFER_72_H_MOBILE',
  MARKET_WELCOME_OFFER_MARKET_ENTRY_POINT: 'MARKET_WELCOME_OFFER_MARKET_ENTRY_POINT',
  MARKET_WELCOME_OFFER_MOBILE: 'MARKET_WELCOME_OFFER_MOBILE',
  ONBOARDING_DONT_MISS_OUT_MOBILE: 'ONBOARDING_DONT_MISS_OUT_MOBILE',
  ONBOARDING_DONT_MISS_OUT_PLAYER: 'ONBOARDING_DONT_MISS_OUT_PLAYER',
  ONBOARDING_LOYALTY_REWARD_WELCOME_BACK_OFFER_MOBILE: 'ONBOARDING_LOYALTY_REWARD_WELCOME_BACK_OFFER_MOBILE',
  ONBOARDING_SELECT_LEAGUE_DESKTOP: 'ONBOARDING_SELECT_LEAGUE_DESKTOP',
  ONBOARDING_SELECT_LEAGUE_MOBILE: 'ONBOARDING_SELECT_LEAGUE_MOBILE',
  ONBOARDING_SET_COUNTDOWN_DESKTOP: 'ONBOARDING_SET_COUNTDOWN_DESKTOP',
  ONBOARDING_SET_COUNTDOWN_MOBILE: 'ONBOARDING_SET_COUNTDOWN_MOBILE',
  ONBOARDING_SET_COUNTDOWN_PACK_MOBILE: 'ONBOARDING_SET_COUNTDOWN_PACK_MOBILE',
  ONBOARDING_SET_COUNTDOWN_PLAYERS_DESKTOP_LEFT: 'ONBOARDING_SET_COUNTDOWN_PLAYERS_DESKTOP_LEFT',
  ONBOARDING_SET_COUNTDOWN_PLAYERS_DESKTOP_RIGHT: 'ONBOARDING_SET_COUNTDOWN_PLAYERS_DESKTOP_RIGHT',
  ONBOARDING_SET_COUNTDOWN_PLAYERS_MOBILE: 'ONBOARDING_SET_COUNTDOWN_PLAYERS_MOBILE',
  ONBOARDING_SET_START_DESKTOP: 'ONBOARDING_SET_START_DESKTOP',
  ONBOARDING_SET_START_MOBILE: 'ONBOARDING_SET_START_MOBILE',
  ONBOARDING_TRAINING_BOARD_DESKTOP: 'ONBOARDING_TRAINING_BOARD_DESKTOP',
  ONBOARDING_TRAINING_BOARD_MOBILE: 'ONBOARDING_TRAINING_BOARD_MOBILE',
  PLAY_BOARD_DESKTOP: 'PLAY_BOARD_DESKTOP',
  PLAY_BOARD_MOBILE: 'PLAY_BOARD_MOBILE',
  PLAY_COMPOSE_LINEUP_DESKTOP: 'PLAY_COMPOSE_LINEUP_DESKTOP',
  PLAY_COMPOSE_LINEUP_LINEUP_BACKGROUND: 'PLAY_COMPOSE_LINEUP_LINEUP_BACKGROUND',
  PLAY_COMPOSE_LINEUP_MOBILE: 'PLAY_COMPOSE_LINEUP_MOBILE',
  PLAY_COMPOSE_LINEUP_TRAINING_DESKTOP: 'PLAY_COMPOSE_LINEUP_TRAINING_DESKTOP',
  PLAY_COMPOSE_LINEUP_TRAINING_MOBILE: 'PLAY_COMPOSE_LINEUP_TRAINING_MOBILE',
  PLAY_DAILY_MISSION_BACKGROUND_DESKTOP: 'PLAY_DAILY_MISSION_BACKGROUND_DESKTOP',
  PLAY_DAILY_REWARDS_CALENDAR_BACKGROUND: 'PLAY_DAILY_REWARDS_CALENDAR_BACKGROUND',
  PLAY_LINEUP_VIEW_DESKTOP: 'PLAY_LINEUP_VIEW_DESKTOP',
  PLAY_LINEUP_VIEW_MOBILE: 'PLAY_LINEUP_VIEW_MOBILE',
  PLAY_MISSION_BACKGROUND_DESKTOP: 'PLAY_MISSION_BACKGROUND_DESKTOP',
  PLAY_MISSION_BACKGROUND_MOBILE: 'PLAY_MISSION_BACKGROUND_MOBILE',
  PLAY_MODE_PICKER_CAREER: 'PLAY_MODE_PICKER_CAREER',
  PLAY_MODE_PICKER_SQUAD: 'PLAY_MODE_PICKER_SQUAD',
  PLAY_REWARD_SUCCES_POPUP_MOBILE: 'PLAY_REWARD_SUCCES_POPUP_MOBILE',
  WELCOME_OFFER_SECTION_TITLE_BACKGROUND: 'WELCOME_OFFER_SECTION_TITLE_BACKGROUND'
} as const;

export type CardSetBrandingAssetSlot = typeof CardSetBrandingAssetSlot[keyof typeof CardSetBrandingAssetSlot];
/** The color theme of a card set branding */
export const CardSetBrandingColorTheme = {
  DARK_MODE: 'DARK_MODE',
  LIGHT_MODE: 'LIGHT_MODE'
} as const;

export type CardSetBrandingColorTheme = typeof CardSetBrandingColorTheme[keyof typeof CardSetBrandingColorTheme];
/** The hex colours of a card set branding */
export interface CardSetBrandingColors {
  __typename: 'CardSetBrandingColors';
  main?: Maybe<Scalars['String']['output']>;
  newEffect?: Maybe<Scalars['String']['output']>;
  surfaceOpaque?: Maybe<Scalars['String']['output']>;
  surfacePrimary?: Maybe<Scalars['String']['output']>;
  surfacePrimaryBackground?: Maybe<Scalars['String']['output']>;
  surfacePrimaryMuted?: Maybe<Scalars['String']['output']>;
  surfacePrimaryText?: Maybe<Scalars['String']['output']>;
  surfaceSecondary?: Maybe<Scalars['String']['output']>;
  surfaceSecondaryMuted?: Maybe<Scalars['String']['output']>;
  surfaceSecondaryText?: Maybe<Scalars['String']['output']>;
  surfaceTertiary?: Maybe<Scalars['String']['output']>;
  swipeEffect?: Maybe<Scalars['String']['output']>;
}

/** The connection type for CardSet. */
export interface CardSetConnection {
  __typename: 'CardSetConnection';
  /** A list of edges. */
  edges: Array<CardSetEdge>;
  /** A list of nodes. */
  nodes: Array<CardSet>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
}

/** An edge in a connection. */
export interface CardSetEdge {
  __typename: 'CardSetEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<CardSet>;
}

/** The Card Set fields */
export interface CardSetRoot {
  __typename: 'CardSetRoot';
  currentRaffle?: Maybe<Raffle>;
  currentSet?: Maybe<CardSet>;
  id: Scalars['ID']['output'];
  inviteTaskAsRefereeRewardConfigs?: Maybe<CardsCountTargetTask | CardsCountTask | CompleteCollectionsCountTargetTask | CompleteCollectionsCountTask | DailyActionTask | DecisivePlayerPickerTask | DropChallengeTask | GameWeeklyTask | GuessTheScoreTask | InviteTaskAsReferrer | So5LeaderboardTask | StarPackTask | Task | TasksTrack | ThresholdPickerTask | ThresholdsDuoConnectionTask | ThresholdsStreakAdditionalLineupTask | ThresholdsStreakTask>;
  inviteTasksAsRefereeRewardConfigs?: Maybe<Array<CardsCountTargetTask | CardsCountTask | CompleteCollectionsCountTargetTask | CompleteCollectionsCountTask | DailyActionTask | DecisivePlayerPickerTask | DropChallengeTask | GameWeeklyTask | GuessTheScoreTask | InviteTaskAsReferrer | So5LeaderboardTask | StarPackTask | Task | TasksTrack | ThresholdPickerTask | ThresholdsDuoConnectionTask | ThresholdsStreakAdditionalLineupTask | ThresholdsStreakTask>>;
  inviteTasksAsReferrerRewardConfigs: Array<CardsCountTargetTask | CardsCountTask | CompleteCollectionsCountTargetTask | CompleteCollectionsCountTask | DailyActionTask | DecisivePlayerPickerTask | DropChallengeTask | GameWeeklyTask | GuessTheScoreTask | InviteTaskAsReferrer | So5LeaderboardTask | StarPackTask | Task | TasksTrack | ThresholdPickerTask | ThresholdsDuoConnectionTask | ThresholdsStreakAdditionalLineupTask | ThresholdsStreakTask>;
  inviteTasksExpirationDurationInDays: Scalars['Int']['output'];
  /** @deprecated Use currentRaffle instead */
  liveRaffle?: Maybe<Raffle>;
  maximumInviteTasksAsReferrer: Scalars['Int']['output'];
  nextSet?: Maybe<CardSet>;
  packBought: Scalars['Boolean']['output'];
  previousSet?: Maybe<CardSet>;
  referrerCodeWindowInDays: Scalars['Int']['output'];
  replayFinished: Scalars['Boolean']['output'];
  /** Search squads by name for a given sport, ordered by members count then board progression */
  searchSquads: SquadConnection;
  squad: Squad;
  starterPackClaimed: Scalars['Boolean']['output'];
}


/** The Card Set fields */
export interface CardSetRootcurrentRaffleArgs {
  sport: Sport;
}


/** The Card Set fields */
export interface CardSetRootcurrentSetArgs {
  sport?: InputMaybe<Sport>;
}


/** The Card Set fields */
export interface CardSetRootinviteTaskAsRefereeRewardConfigsArgs {
  sport: Sport;
}


/** The Card Set fields */
export interface CardSetRootinviteTasksAsRefereeRewardConfigsArgs {
  sport: Sport;
}


/** The Card Set fields */
export interface CardSetRootinviteTasksAsReferrerRewardConfigsArgs {
  sport: Sport;
}


/** The Card Set fields */
export interface CardSetRootliveRaffleArgs {
  sport: Sport;
}


/** The Card Set fields */
export interface CardSetRootmaximumInviteTasksAsReferrerArgs {
  sport: Sport;
}


/** The Card Set fields */
export interface CardSetRootnextSetArgs {
  sport?: InputMaybe<Sport>;
}


/** The Card Set fields */
export interface CardSetRootpackBoughtArgs {
  sport: Sport;
}


/** The Card Set fields */
export interface CardSetRootpreviousSetArgs {
  sport?: InputMaybe<Sport>;
}


/** The Card Set fields */
export interface CardSetRootreplayFinishedArgs {
  sport: Sport;
}


/** The Card Set fields */
export interface CardSetRootsearchSquadsArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  sport: Sport;
}


/** The Card Set fields */
export interface CardSetRootsquadArgs {
  id?: InputMaybe<Scalars['ID']['input']>;
  joinSecret?: InputMaybe<Scalars['String']['input']>;
}


/** The Card Set fields */
export interface CardSetRootstarterPackClaimedArgs {
  sport: Sport;
}

/** A Card Shards Reward Config */
export interface CardShardRewardConfig extends AnyRewardConfigInterface {
  __typename: 'CardShardRewardConfig';
  boostedRewardConfigs?: Maybe<Array<CardPacksRewardConfig | CardRewardConfig | CardShardRewardConfig | CoinRewardConfig | ConversionCreditRewardConfig | DeliverableItemRewardConfig | ExperienceRewardConfig | InGameCurrencyRewardConfig | MonetaryRewardConfig | ProbabilisticBundleRewardConfig | ShopItemRewardConfig>>;
  cardSet?: Maybe<CardSet>;
  configRarity: RewardConfigRarity;
  flavour?: Maybe<PoolKeyShardsCount>;
  id: Scalars['ID']['output'];
  poolSize: Scalars['Int']['output'];
  quantity: Scalars['Int']['output'];
  rarity: Rarity;
  sharedPool: Scalars['Boolean']['output'];
}

/** A crafting promotional event */
export interface CardShardThresholdsPromotionalEvent extends Node, PromotionalEventInterface {
  __typename: 'CardShardThresholdsPromotionalEvent';
  algoliaFilters: Scalars['String']['output'];
  backgroundPictureUrl?: Maybe<Scalars['String']['output']>;
  bannerAssetsPictureUrl?: Maybe<Scalars['String']['output']>;
  blogUrl?: Maybe<Scalars['String']['output']>;
  description: Scalars['String']['output'];
  eligibilityRules: EligibilityRules;
  endDate: Scalars['ISO8601DateTime']['output'];
  filterPictureUrl?: Maybe<Scalars['String']['output']>;
  heroValueProps: Array<HeroValueProp>;
  id: Scalars['ID']['output'];
  logoUrl?: Maybe<Scalars['String']['output']>;
  marketBannerTitle: Scalars['String']['output'];
  mobileBackgroundPictureUrl?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  pictureUrl?: Maybe<Scalars['String']['output']>;
  probableRewardConfigs: Array<ProbableRewardConfig>;
  promotionType: PromotionType;
  secondaryBannerPictureUrl?: Maybe<Scalars['String']['output']>;
  slug: Scalars['String']['output'];
  sport: Sport;
  startDate: Scalars['ISO8601DateTime']['output'];
  termsAndConditionsUrl?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
}

/** A chest of card shards */
export interface CardShardsChest extends Node {
  __typename: 'CardShardsChest';
  availableCompetitions: Array<Competition>;
  card?: Maybe<BaseballCard | Card | NBACard>;
  cardSet?: Maybe<CardSet>;
  cardShardsCount: Scalars['Int']['output'];
  craftableCompetitions: Array<Competition>;
  craftableCompetitionsNotInPool: Array<Competition>;
  id: Scalars['ID']['output'];
  maxCardShardsCount: Scalars['Int']['output'];
  newThresholdUnlocked: Scalars['Boolean']['output'];
  poolKeyShardsCounts: Array<PoolKeyShardsCount>;
  rarity: Rarity;
  revealVideoUrl?: Maybe<Scalars['String']['output']>;
  sport: Sport;
  thresholds: Array<CardShardsChestThreshold>;
}


/** A chest of card shards */
export interface CardShardsChestrevealVideoUrlArgs {
  orientation: Orientation;
}

/** A threshold of a chest of card shards */
export interface CardShardsChestThreshold {
  __typename: 'CardShardsChestThreshold';
  draws: Array<CardShardsChestThresholdDraw>;
  name: Scalars['String']['output'];
  /** The probability of having this threshold */
  probability: Scalars['Int']['output'];
  threshold: Scalars['Int']['output'];
}

export interface CardShardsChestThresholdDraw {
  __typename: 'CardShardsChestThresholdDraw';
  drawProbabilities: Array<CardShardsChestThresholdDrawsProbability>;
  nbCards: Scalars['Int']['output'];
  probabilities: Array<CardShardsChestThresholdProbability>;
}

export interface CardShardsChestThresholdDrawsProbability {
  __typename: 'CardShardsChestThresholdDrawsProbability';
  basisPoints: Scalars['Int']['output'];
  quality: CraftGameplayTier;
}

export interface CardShardsChestThresholdProbability {
  __typename: 'CardShardsChestThresholdProbability';
  basisPoints: Scalars['Int']['output'];
  quality: CardQuality;
}

export const CardShardsHistoryTransactionFilter = {
  CREDIT: 'CREDIT',
  DEBIT: 'DEBIT',
  UNSPENT_CREDIT: 'UNSPENT_CREDIT'
} as const;

export type CardShardsHistoryTransactionFilter = typeof CardShardsHistoryTransactionFilter[keyof typeof CardShardsHistoryTransactionFilter];
/** A purchasable item that is a card shards */
export interface CardShardsPurchasableItem extends Node, PurchasableItemInterface {
  __typename: 'CardShardsPurchasableItem';
  cardPaymentProvider: PaymentMethodProvider;
  cardSet?: Maybe<CardSet>;
  flavour?: Maybe<PoolKeyShardsCount>;
  id: Scalars['ID']['output'];
  nextPriceUpdateAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  oldPrice?: Maybe<MonetaryAmount>;
  pictureUrl?: Maybe<Scalars['String']['output']>;
  price: MonetaryAmount;
  quantity: Scalars['Int']['output'];
  rarity: Rarity;
  slug: Scalars['String']['output'];
  sport: Sport;
}


/** A purchasable item that is a card shards */
export interface CardShardsPurchasableItempictureUrlArgs {
  derivative?: InputMaybe<PurchasableItemDerivative>;
}

/** A Card Shards Reward */
export interface CardShardsReward extends AnyRewardInterface, Node {
  __typename: 'CardShardsReward';
  aasmState: RewardState;
  cardSet?: Maybe<CardSet>;
  config: CardShardRewardConfig;
  id: Scalars['ID']['output'];
  quantity: Scalars['Int']['output'];
  rarity: Rarity;
}

export const CardSort = {
  IN_ORDER_OF_IDENTIFIERS: 'IN_ORDER_OF_IDENTIFIERS',
  POPULAR_FIRST: 'POPULAR_FIRST',
  RARITIES: 'RARITIES',
  RECENTLY_OWNED_FIRST: 'RECENTLY_OWNED_FIRST',
  REVEALABLE_FIRST: 'REVEALABLE_FIRST'
} as const;

export type CardSort = typeof CardSort[keyof typeof CardSort];
export interface CardSource extends HistoryTransactionInterface {
  __typename: 'CardSource';
  date: Scalars['ISO8601DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  label: Scalars['String']['output'];
  logoUrl?: Maybe<Scalars['String']['output']>;
  quantityByFlavour: Array<PoolKeyShardsCount>;
  totalQuantity: Scalars['Int']['output'];
}

/** Stats of a card */
export interface CardStats extends Node {
  __typename: 'CardStats';
  bestSo5Appearance?: Maybe<So5Appearance>;
  highlightedStats: Array<HighlightedStat>;
  id: Scalars['ID']['output'];
  so5LineupsCount: Scalars['Int']['output'];
  so5RewardsCount: Scalars['Int']['output'];
}

export interface CardUsageInterface {
  slug: Scalars['String']['output'];
}

export const CardWasUpdatedEvent = {
  /** When a bid was created on an auction */
  auction_event_bid: 'auction_event_bid',
  /** When the bid value is increased */
  auction_event_bid_increased: 'auction_event_bid_increased',
  /** When an auction is cancelled */
  auction_event_cancelled: 'auction_event_cancelled',
  /** When an auction closes without bids */
  auction_event_closed: 'auction_event_closed',
  /** When an auction is flagged as fraudulent */
  auction_event_flagged: 'auction_event_flagged',
  /** When an auction was successfully closed */
  auction_event_successfull: 'auction_event_successfull',
  /** When a card is revealed */
  card_event_revealed: 'card_event_revealed',
  /** When a card is sealed */
  card_event_sealed: 'card_event_sealed',
  /** When a card is sealed */
  card_event_unsealed: 'card_event_unsealed',
  /** When an XP event is added to a card */
  card_event_xp_event_added: 'card_event_xp_event_added',
  /** When an offer is settled */
  offer_event_accepted: 'offer_event_accepted',
  /** When an offer is cancelled */
  offer_event_cancelled: 'offer_event_cancelled',
  /** When an offer is flagged as fraudulent */
  offer_event_flagged: 'offer_event_flagged',
  /** When an offer becomes live */
  offer_event_opened: 'offer_event_opened',
  /** When a card levels up */
  so5_fixture_event_cards_leveled_up: 'so5_fixture_event_cards_leveled_up',
  /** When the bonus of a user card collection changes (deprecated) */
  user_card_collection_event_bonus_changed: 'user_card_collection_event_bonus_changed'
} as const;

export type CardWasUpdatedEvent = typeof CardWasUpdatedEvent[keyof typeof CardWasUpdatedEvent];
/** A card xp grade threshold */
export interface CardXPGradeThreshold {
  __typename: 'CardXPGradeThreshold';
  level: Scalars['Int']['output'];
  threshold?: Maybe<Scalars['Int']['output']>;
}

export interface CardsCountAsFirstOwnerRule extends So5RuleInterface {
  __typename: 'CardsCountAsFirstOwnerRule';
  descriptions: Array<So5RuleDescription>;
  id: Scalars['String']['output'];
  key: Scalars['String']['output'];
  min: Scalars['Int']['output'];
}

export interface CardsCountTargetTask extends ManagerTaskInterface, TaskInterface {
  __typename: 'CardsCountTargetTask';
  aasmState: ManagerProgressionTaskState;
  alternativeRewardConfigs?: Maybe<Array<AlternativeRewardConfig>>;
  cardSet?: Maybe<CardSet>;
  /** @deprecated Not used anymore */
  cards: Array<BaseballCard | Card | NBACard>;
  claimableAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** @deprecated Not used anymore */
  claimedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  color?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `competitions` instead */
  competition?: Maybe<Competition>;
  competitions: Array<Competition>;
  completedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  description: Scalars['String']['output'];
  expired: Scalars['Boolean']['output'];
  genre: TaskGenre;
  group?: Maybe<TaskGroup>;
  iconUrl?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  jonumGated: Scalars['Boolean']['output'];
  /** The points this task earned on a ladder leaderboard, empty when it feeds none. */
  ladderContributions: Array<LadderContribution>;
  /** The `my_related_cards` field cannot be nested within a list. */
  myRelatedCards: AnyCardInterfaceConnection;
  /** The `my_reward_pool_shares` field cannot be nested within a list. */
  myRewardPoolShares?: Maybe<Array<RewardPoolShare>>;
  name: ManagerProgressionTaskSlug;
  parentTask?: Maybe<CardsCountTargetTask | CardsCountTask | CompleteCollectionsCountTargetTask | CompleteCollectionsCountTask | DailyActionTask | DecisivePlayerPickerTask | DropChallengeTask | GameWeeklyTask | GuessTheScoreTask | InviteTaskAsReferrer | So5LeaderboardTask | StarPackTask | Task | TasksTrack | ThresholdPickerTask | ThresholdsDuoConnectionTask | ThresholdsStreakAdditionalLineupTask | ThresholdsStreakTask>;
  periodicity?: Maybe<ManagerTaskPeriodicity>;
  pickOrList: Scalars['Boolean']['output'];
  players?: Maybe<Array<BaseballPlayer | NBAPlayer | Player>>;
  possibleRewardConfigsIconUrl?: Maybe<Scalars['String']['output']>;
  /** @deprecated Not used anymore */
  probabilisticBundles: Array<ProbabilisticBundle>;
  progress: Scalars['Int']['output'];
  rarity?: Maybe<Rarity>;
  /** The `related_pack_configs` field cannot be nested within a list. */
  relatedPackConfigs: Array<CardPack>;
  rewardConfigs: Array<CardPacksRewardConfig | CardRewardConfig | CardShardRewardConfig | CoinRewardConfig | ConversionCreditRewardConfig | DeliverableItemRewardConfig | ExperienceRewardConfig | InGameCurrencyRewardConfig | MonetaryRewardConfig | ProbabilisticBundleRewardConfig | ShopItemRewardConfig>;
  /** The `reward_pool_shares` field cannot be nested within a list. */
  rewardPoolShares?: Maybe<RewardPoolShareConnection>;
  /** The So5 competitions playable with the competitions targeted by this task */
  so5Competitions: Array<So5Competition>;
  specifiedTeams: Array<Team>;
  startDate?: Maybe<Scalars['ISO8601DateTime']['output']>;
  target: Scalars['Int']['output'];
  taskConfigSlug: Scalars['String']['output'];
  templateIconUrl: Scalars['String']['output'];
  title: Scalars['String']['output'];
  uncapped: Scalars['Boolean']['output'];
}


export interface CardsCountTargetTaskcolorArgs {
  variant?: InputMaybe<ColorVariant>;
}


export interface CardsCountTargetTaskmyRelatedCardsArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
}


export interface CardsCountTargetTaskrewardConfigsArgs {
  mergedConfigsByType?: InputMaybe<Scalars['Boolean']['input']>;
}


export interface CardsCountTargetTaskrewardPoolSharesArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
}

export interface CardsCountTask extends ManagerTaskInterface, TaskInterface {
  __typename: 'CardsCountTask';
  aasmState: ManagerProgressionTaskState;
  alternativeRewardConfigs?: Maybe<Array<AlternativeRewardConfig>>;
  cardSet?: Maybe<CardSet>;
  /** @deprecated Not used anymore */
  cards: Array<BaseballCard | Card | NBACard>;
  claimableAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** @deprecated Not used anymore */
  claimedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  color?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `competitions` instead */
  competition?: Maybe<Competition>;
  competitions: Array<Competition>;
  completedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  description: Scalars['String']['output'];
  expired: Scalars['Boolean']['output'];
  genre: TaskGenre;
  group?: Maybe<TaskGroup>;
  iconUrl?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  jonumGated: Scalars['Boolean']['output'];
  /** The points this task earned on a ladder leaderboard, empty when it feeds none. */
  ladderContributions: Array<LadderContribution>;
  liveScore: Scalars['Int']['output'];
  /** The `my_related_cards` field cannot be nested within a list. */
  myRelatedCards: AnyCardInterfaceConnection;
  /** The `my_reward_pool_shares` field cannot be nested within a list. */
  myRewardPoolShares?: Maybe<Array<RewardPoolShare>>;
  name: ManagerProgressionTaskSlug;
  parentTask?: Maybe<CardsCountTargetTask | CardsCountTask | CompleteCollectionsCountTargetTask | CompleteCollectionsCountTask | DailyActionTask | DecisivePlayerPickerTask | DropChallengeTask | GameWeeklyTask | GuessTheScoreTask | InviteTaskAsReferrer | So5LeaderboardTask | StarPackTask | Task | TasksTrack | ThresholdPickerTask | ThresholdsDuoConnectionTask | ThresholdsStreakAdditionalLineupTask | ThresholdsStreakTask>;
  periodicity?: Maybe<ManagerTaskPeriodicity>;
  pickOrList: Scalars['Boolean']['output'];
  possibleRewardConfigsIconUrl?: Maybe<Scalars['String']['output']>;
  /** @deprecated Not used anymore */
  probabilisticBundles: Array<ProbabilisticBundle>;
  progress: Scalars['Int']['output'];
  rarity?: Maybe<Rarity>;
  /** The `related_pack_configs` field cannot be nested within a list. */
  relatedPackConfigs: Array<CardPack>;
  rewardConfigs: Array<CardPacksRewardConfig | CardRewardConfig | CardShardRewardConfig | CoinRewardConfig | ConversionCreditRewardConfig | DeliverableItemRewardConfig | ExperienceRewardConfig | InGameCurrencyRewardConfig | MonetaryRewardConfig | ProbabilisticBundleRewardConfig | ShopItemRewardConfig>;
  /** The `reward_pool_shares` field cannot be nested within a list. */
  rewardPoolShares?: Maybe<RewardPoolShareConnection>;
  scoreToReach: Scalars['Int']['output'];
  specifiedTeams: Array<Team>;
  startDate?: Maybe<Scalars['ISO8601DateTime']['output']>;
  target: Scalars['Int']['output'];
  taskConfigSlug: Scalars['String']['output'];
  templateIconUrl: Scalars['String']['output'];
  thresholds: Array<CollectionTaskThreshold>;
  title: Scalars['String']['output'];
  uncapped: Scalars['Boolean']['output'];
}


export interface CardsCountTaskcolorArgs {
  variant?: InputMaybe<ColorVariant>;
}


export interface CardsCountTaskmyRelatedCardsArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
}


export interface CardsCountTaskrewardConfigsArgs {
  mergedConfigsByType?: InputMaybe<Scalars['Boolean']['input']>;
}


export interface CardsCountTaskrewardPoolSharesArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
}

export interface CareerBoard extends Board {
  __typename: 'CareerBoard';
  backgroundUrl?: Maybe<Scalars['String']['output']>;
  bonuses: Array<So5ActiveClubsBonus | So5AverageScoresBonus | So5BoostBonus | So5CaptainBonus | So5CollectionBonus | So5DifferentNationalitiesBonus | So5GradeBonus | So5LineupBonus | So5MalusAfterTransferBonus | So5NationalityBonus | So5PlayerBonus | So5PositionBonus | So5PositionStacksBonus | So5SameActiveClubBonus | So5ScarcityBonus | So5SeasonBonus | So5SpecialEditionCardsBonus>;
  /** Whether the next track can be unlocked right now, through the unlockNextBoard mutation. */
  canUnlockNextBoard: Scalars['Boolean']['output'];
  color?: Maybe<Scalars['String']['output']>;
  configSlug: Scalars['String']['output'];
  /**
   * The campaign to play this track with a friend, when the user has no connected
   * track yet. The `connect_campaign` field cannot be nested within a list.
   */
  connectCampaign?: Maybe<TaskCampaign>;
  /** The user this track is connected to. */
  connectedUser?: Maybe<User>;
  description?: Maybe<Scalars['String']['output']>;
  endDate?: Maybe<Scalars['ISO8601DateTime']['output']>;
  engaged: Scalars['Boolean']['output'];
  /**
   * The run of the ladder this board contributes to that the manager should be
   * shown: the most recent one holding a reward left to claim, or the most recent
   * run when there is none. Null when the board contributes to no ladder.
   */
  featuredLadderLeaderboard?: Maybe<LadderLeaderboard>;
  hasMyCollectionTasks: Scalars['Boolean']['output'];
  /** Whether completing this track unlocks another one. */
  hasNextBoard: Scalars['Boolean']['output'];
  iconUrl?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  /**
   * Every run of the ladder this board contributes to, most recent first. The
   * `ladder_leaderboards` field cannot be nested within a list.
   */
  ladderLeaderboards: LadderLeaderboardConnection;
  /** @deprecated Renamed to featuredLadderLeaderboard, which prefers a run with a reward to claim. */
  latestLadderLeaderboard?: Maybe<LadderLeaderboard>;
  myCollectionTasks: Array<CardsCountTargetTask | CardsCountTask | CompleteCollectionsCountTargetTask | CompleteCollectionsCountTask | DailyActionTask | DecisivePlayerPickerTask | DropChallengeTask | GameWeeklyTask | GuessTheScoreTask | InviteTaskAsReferrer | So5LeaderboardTask | StarPackTask | Task | TasksTrack | ThresholdPickerTask | ThresholdsDuoConnectionTask | ThresholdsStreakAdditionalLineupTask | ThresholdsStreakTask>;
  /**
   * The board of the connected version of this track, when the user already has
   * one. The `my_connected_board` field cannot be nested within a list.
   */
  myConnectedBoard?: Maybe<CareerBoard>;
  myCurrentStep?: Maybe<CareerProStep | CareerStep | SquadStep>;
  /** The `my_reward_pool_shares` field cannot be nested within a list. */
  myRewardPoolShares?: Maybe<Array<RewardPoolShare>>;
  /**
   * The board of the solo version of this track, when the user already has one.
   * The `my_solo_board` field cannot be nested within a list.
   */
  mySoloBoard?: Maybe<CareerBoard>;
  /** The `my_top_by_position_bench` field cannot be nested within a list. */
  myTopByPositionBench: Array<ComposeTeamBenchCard | ComposeTeamBenchCommonPlayer | DecisivePlayerPickerTaskAppearance | MissedAppearance | So5Appearance | TaskAppearance | ThresholdPickerTaskAppearance>;
  myUnclaimedCollectionTasksCount: Scalars['Int']['output'];
  /** The number of collection tasks, steps and ladder rewards of this board left to claim */
  myUnclaimedRewardsCount: Scalars['Int']['output'];
  /** The `next_pickable_game` field cannot be nested within a list. */
  nextPickableGame?: Maybe<GameWithCardsPreview>;
  pickableDays: GameDayConnection;
  /** The `pickable_games` field cannot be nested within a list. */
  pickableGames: GameWithCardsPreviewConnection;
  rarities: Array<Rarity>;
  restartable: Scalars['Boolean']['output'];
  /**
   * The live campaign boosting the rewards of this track, when the user is
   * eligible to it. The `reward_campaign` field cannot be nested within a list.
   */
  rewardCampaign?: Maybe<TaskCampaign>;
  /** The `reward_pool_shares` field cannot be nested within a list. */
  rewardPoolShares?: Maybe<RewardPoolShareConnection>;
  so5Competition?: Maybe<So5Competition>;
  steps: Array<CareerProStep | CareerStep | SquadStep>;
  tileBackgroundUrl?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  user: User;
}


export interface CareerBoardbackgroundUrlArgs {
  variant?: InputMaybe<AssetVariant>;
}


export interface CareerBoardbonusesArgs {
  cardSlug?: InputMaybe<Scalars['String']['input']>;
  highlighted?: InputMaybe<Scalars['Boolean']['input']>;
}


export interface CareerBoardcolorArgs {
  variant?: InputMaybe<ColorVariant>;
}


export interface CareerBoardhasMyCollectionTasksArgs {
  rarity?: InputMaybe<Rarity>;
}


export interface CareerBoardladderLeaderboardsArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
}


export interface CareerBoardmyCollectionTasksArgs {
  rarity?: InputMaybe<Rarity>;
}


export interface CareerBoardmyTopByPositionBenchArgs {
  filters: BenchFilterInput;
}


export interface CareerBoardmyUnclaimedCollectionTasksCountArgs {
  rarity?: InputMaybe<Rarity>;
}


export interface CareerBoardpickableDaysArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  timeZone: Scalars['String']['input'];
}


export interface CareerBoardpickableGamesArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  fromDate?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  toDate?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
}


export interface CareerBoardrewardPoolSharesArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
}

/** A step in a career Pro board */
export interface CareerProStep extends StepInterface, WithComposeTeamInterface {
  __typename: 'CareerProStep';
  /** Whether some appearances are filled by a contributor rather than the lineup owner. */
  collaborative: Scalars['Boolean']['output'];
  defaultSortType: BenchSort;
  displayedTypedRules: Array<CardsCountAsFirstOwnerRule | OwnedSinceRule | PlayerHeightRule | SeasonsRule | So5ActiveClubsRule | So5ActiveNationalTeamsRule | So5AgeRule | So5AppearancesRule | So5AtLeastOfClubs | So5AtLeastOfCompetitions | So5AverageScoresRule | So5CaptainRule | So5CaptainScarcityRule | So5CardEditionsCountRule | So5CompetitionsRule | So5EntryItemRule | So5MaximumPlayersAverageScoreRule | So5MinimumPlayersAverageScoreRule | So5NationalityRule | So5NotNationalityRule | So5SameActiveClubRule | So5ScarcityRule | So5SeasonBonusRule | VaultPointsRule>;
  engineConfiguration: EngineConfiguration;
  /** The `highlighted_recommendations` field cannot be nested within a list. */
  highlightedRecommendations: Array<PlayerRecommendation>;
  id: Scalars['String']['output'];
  /** The Sorare Points winning this step earns on the active ladders it feeds, null when it feeds none */
  ladderPoints?: Maybe<Scalars['Int']['output']>;
  level: Scalars['Int']['output'];
  /** The `my_filtered_bench` field cannot be nested within a list. */
  myFilteredBench: ComposeTeamBenchObjectInterfaceConnection;
  myLineups: Array<GuessTheScoreTaskLineup | So5Lineup | TaskLineup | ThresholdPickerTaskLineup>;
  myTask: CardsCountTargetTask | CardsCountTask | CompleteCollectionsCountTargetTask | CompleteCollectionsCountTask | DailyActionTask | DecisivePlayerPickerTask | DropChallengeTask | GameWeeklyTask | GuessTheScoreTask | InviteTaskAsReferrer | So5LeaderboardTask | StarPackTask | Task | TasksTrack | ThresholdPickerTask | ThresholdsDuoConnectionTask | ThresholdsStreakAdditionalLineupTask | ThresholdsStreakTask;
  /** The date until which the config is overriden by a promotion */
  originalConfigOverridenUntil?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** The original value of rewardConfigs outside promotions */
  originalRewardConfigs?: Maybe<Array<CardPacksRewardConfig | CardRewardConfig | CardShardRewardConfig | CoinRewardConfig | ConversionCreditRewardConfig | DeliverableItemRewardConfig | ExperienceRewardConfig | InGameCurrencyRewardConfig | MonetaryRewardConfig | ProbabilisticBundleRewardConfig | ShopItemRewardConfig>>;
  /** The original value of target outside promotions */
  originalTarget?: Maybe<Scalars['Int']['output']>;
  possibleBenchSortingTypes: Array<SortingType>;
  previewSo5Lineup: ComposeTeamLineupPreview;
  rewardConfigs: Array<CardPacksRewardConfig | CardRewardConfig | CardShardRewardConfig | CoinRewardConfig | ConversionCreditRewardConfig | DeliverableItemRewardConfig | ExperienceRewardConfig | InGameCurrencyRewardConfig | MonetaryRewardConfig | ProbabilisticBundleRewardConfig | ShopItemRewardConfig>;
  rewardMultiplierConfiguration?: Maybe<RewardMultiplierConfiguration>;
  state: StepState;
  target: Scalars['Int']['output'];
  /** The `top_recommendations` field cannot be nested within a list. */
  topRecommendations: Array<PlayerRecommendation>;
}


/** A step in a career Pro board */
export interface CareerProStephighlightedRecommendationsArgs {
  positions?: InputMaybe<Array<Position>>;
  recommendationEngine: RecommendationEngine;
  sport: Sport;
}


/** A step in a career Pro board */
export interface CareerProStepmyFilteredBenchArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filters: BenchFilterInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  stackByCardData?: InputMaybe<Scalars['Boolean']['input']>;
  topByPosition?: InputMaybe<Scalars['Int']['input']>;
}


/** A step in a career Pro board */
export interface CareerProSteppreviewSo5LineupArgs {
  appearances: Array<So5AppearanceInput>;
}


/** A step in a career Pro board */
export interface CareerProSteptopRecommendationsArgs {
  filters?: InputMaybe<BenchFilterInput>;
  playingHomeOnly?: InputMaybe<Scalars['Boolean']['input']>;
  positions?: InputMaybe<Array<Position>>;
  query?: InputMaybe<Scalars['String']['input']>;
  recommendationEngine: RecommendationEngine;
  sortType?: InputMaybe<EligibleCardsSort>;
  sport: Sport;
  starterOddsBasisPointsRange?: InputMaybe<RangeInput>;
}

/** A step in a career board */
export interface CareerStep extends StepInterface, WithComposeTeamInterface {
  __typename: 'CareerStep';
  averageMode: Scalars['Boolean']['output'];
  /** Card packs printing players eligible for the upcoming games of this step */
  cardPacks: Array<CardPack>;
  /** Whether some appearances are filled by a contributor rather than the lineup owner. */
  collaborative: Scalars['Boolean']['output'];
  defaultSortType: BenchSort;
  displayedPlayer?: Maybe<BaseballPlayer | NBAPlayer | Player>;
  displayedTypedRules: Array<CardsCountAsFirstOwnerRule | OwnedSinceRule | PlayerHeightRule | SeasonsRule | So5ActiveClubsRule | So5ActiveNationalTeamsRule | So5AgeRule | So5AppearancesRule | So5AtLeastOfClubs | So5AtLeastOfCompetitions | So5AverageScoresRule | So5CaptainRule | So5CaptainScarcityRule | So5CardEditionsCountRule | So5CompetitionsRule | So5EntryItemRule | So5MaximumPlayersAverageScoreRule | So5MinimumPlayersAverageScoreRule | So5NationalityRule | So5NotNationalityRule | So5SameActiveClubRule | So5ScarcityRule | So5SeasonBonusRule | VaultPointsRule>;
  engineConfiguration: EngineConfiguration;
  /** The `highlighted_recommendations` field cannot be nested within a list. */
  highlightedRecommendations: Array<PlayerRecommendation>;
  id: Scalars['String']['output'];
  /** The Sorare Points winning this step earns on the active ladders it feeds, null when it feeds none */
  ladderPoints?: Maybe<Scalars['Int']['output']>;
  level: Scalars['Int']['output'];
  lockedLineupsCount: Scalars['Int']['output'];
  marketSections: Array<CardPackGroup | FeaturedCardPack | FeaturedMarketSection | GemsShop | LegacyPacks | MarketLiveOps | MarketSetSpecialBundles | MarketSetWelcomeOffer | SpecialOffers | WeeklyDeals>;
  maxLineupsCount: Scalars['Int']['output'];
  /** The `my_filtered_bench` field cannot be nested within a list. */
  myFilteredBench: ComposeTeamBenchObjectInterfaceConnection;
  myLineups: Array<GuessTheScoreTaskLineup | So5Lineup | TaskLineup | ThresholdPickerTaskLineup>;
  myTask: CardsCountTargetTask | CardsCountTask | CompleteCollectionsCountTargetTask | CompleteCollectionsCountTask | DailyActionTask | DecisivePlayerPickerTask | DropChallengeTask | GameWeeklyTask | GuessTheScoreTask | InviteTaskAsReferrer | So5LeaderboardTask | StarPackTask | Task | TasksTrack | ThresholdPickerTask | ThresholdsDuoConnectionTask | ThresholdsStreakAdditionalLineupTask | ThresholdsStreakTask;
  /** The date until which the config is overriden by a promotion */
  originalConfigOverridenUntil?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** The original value of rewardConfigs outside promotions */
  originalRewardConfigs?: Maybe<Array<CardPacksRewardConfig | CardRewardConfig | CardShardRewardConfig | CoinRewardConfig | ConversionCreditRewardConfig | DeliverableItemRewardConfig | ExperienceRewardConfig | InGameCurrencyRewardConfig | MonetaryRewardConfig | ProbabilisticBundleRewardConfig | ShopItemRewardConfig>>;
  /** The original value of target outside promotions */
  originalTarget?: Maybe<Scalars['Int']['output']>;
  pendingLineupsCount: Scalars['Int']['output'];
  possibleBenchSortingTypes: Array<SortingType>;
  previewSo5Lineup: ComposeTeamLineupPreview;
  remainingLineupsCount: Scalars['Int']['output'];
  rewardConfigs: Array<CardPacksRewardConfig | CardRewardConfig | CardShardRewardConfig | CoinRewardConfig | ConversionCreditRewardConfig | DeliverableItemRewardConfig | ExperienceRewardConfig | InGameCurrencyRewardConfig | MonetaryRewardConfig | ProbabilisticBundleRewardConfig | ShopItemRewardConfig>;
  rewardMultiplierConfiguration?: Maybe<RewardMultiplierConfiguration>;
  state: StepState;
  target: Scalars['Int']['output'];
  /** The `top_recommendations` field cannot be nested within a list. */
  topRecommendations: Array<PlayerRecommendation>;
}


/** A step in a career board */
export interface CareerStephighlightedRecommendationsArgs {
  positions?: InputMaybe<Array<Position>>;
  recommendationEngine: RecommendationEngine;
  sport: Sport;
}


/** A step in a career board */
export interface CareerStepmyFilteredBenchArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filters: BenchFilterInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  stackByCardData?: InputMaybe<Scalars['Boolean']['input']>;
  topByPosition?: InputMaybe<Scalars['Int']['input']>;
}


/** A step in a career board */
export interface CareerSteppreviewSo5LineupArgs {
  appearances: Array<So5AppearanceInput>;
}


/** A step in a career board */
export interface CareerSteptopRecommendationsArgs {
  filters?: InputMaybe<BenchFilterInput>;
  playingHomeOnly?: InputMaybe<Scalars['Boolean']['input']>;
  positions?: InputMaybe<Array<Position>>;
  query?: InputMaybe<Scalars['String']['input']>;
  recommendationEngine: RecommendationEngine;
  sortType?: InputMaybe<EligibleCardsSort>;
  sport: Sport;
  starterOddsBasisPointsRange?: InputMaybe<RangeInput>;
}

/** A cart */
export interface Cart extends Node {
  __typename: 'Cart';
  activePromotionalEvents: Array<CartPurchaseRewardPromotionalEvent>;
  affectedCardCollections?: Maybe<Array<CardCollectionScoreIncrease>>;
  cardPaymentProvider: PaymentMethodProvider;
  currentPrimaryOffer?: Maybe<TokenPrimaryOffer>;
  id: Scalars['ID']['output'];
  mainCartItems: Array<CartItem>;
  price?: Maybe<MonetaryAmount>;
  savedForLaterCartItems: Array<CartItem>;
  signedAmount?: Maybe<Scalars['String']['output']>;
  sport: Sport;
}

/** A cart item */
export interface CartItem extends Node {
  __typename: 'CartItem';
  card: BaseballCard | Card | NBACard;
  cart: Cart;
  id: Scalars['ID']['output'];
  price?: Maybe<MonetaryAmount>;
  savedForLater: Scalars['Boolean']['output'];
  state?: Maybe<CartItemState>;
}

export const CartItemState = {
  CURRENT: 'CURRENT',
  REMOVED: 'REMOVED',
  REPLACED: 'REPLACED'
} as const;

export type CartItemState = typeof CartItemState[keyof typeof CartItemState];
/** A promotional event related to a cart purchase */
export interface CartPurchaseRewardPromotionalEvent extends Node, PromotionalEventInterface {
  __typename: 'CartPurchaseRewardPromotionalEvent';
  algoliaFilters: Scalars['String']['output'];
  backgroundPictureUrl?: Maybe<Scalars['String']['output']>;
  bannerAssetsPictureUrl?: Maybe<Scalars['String']['output']>;
  blogUrl?: Maybe<Scalars['String']['output']>;
  deliverableItemsVariantsStocks?: Maybe<Array<DeliverableItemVariantsStocks>>;
  description: Scalars['String']['output'];
  eligibilityRules: EligibilityRules;
  endDate: Scalars['ISO8601DateTime']['output'];
  filterPictureUrl?: Maybe<Scalars['String']['output']>;
  heroValueProps: Array<HeroValueProp>;
  id: Scalars['ID']['output'];
  logoUrl?: Maybe<Scalars['String']['output']>;
  marketBannerTitle: Scalars['String']['output'];
  mobileBackgroundPictureUrl?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  pictureUrl?: Maybe<Scalars['String']['output']>;
  probableRewardConfigs: Array<ProbableRewardConfig>;
  progression?: Maybe<ProgressionForRewardConfigThresholds>;
  promotionType: PromotionType;
  secondaryBannerPictureUrl?: Maybe<Scalars['String']['output']>;
  slug: Scalars['String']['output'];
  sport: Sport;
  startDate: Scalars['ISO8601DateTime']['output'];
  termsAndConditionsUrl?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
}


/** A promotional event related to a cart purchase */
export interface CartPurchaseRewardPromotionalEventprogressionArgs {
  cartId?: InputMaybe<Scalars['ID']['input']>;
  primaryOfferId?: InputMaybe<Scalars['ID']['input']>;
}

/** A Checkout credit card authorization request */
export interface CheckoutCreditCardAuthorizationRequest {
  __typename: 'CheckoutCreditCardAuthorizationRequest';
  amount: Scalars['Int']['output'];
  currency: FiatCurrency;
  id: Scalars['String']['output'];
}

export interface Club extends Node, TeamInterface, WithSubscriptionsInterface {
  __typename: 'Club';
  activeCompetitions: Array<Competition>;
  activeContestant?: Maybe<BaseballContestantType | BasketballContestantType | FootballContestantType>;
  /** The `active_memberships` field cannot be nested within a list. */
  activeMemberships: MembershipConnection;
  /** The `active_players` field cannot be nested within a list. */
  activePlayers: PlayerConnection;
  /** The `any_active_players` field cannot be nested within a list. */
  anyActivePlayers: AnyPlayerInterfaceConnection;
  /** The `any_cards` field cannot be nested within a list. */
  anyCards: AnyCardInterfaceConnection;
  /** The `any_games` field cannot be nested within a list. */
  anyGames: AnyGameInterfaceConnection;
  /** The `any_players` field cannot be nested within a list. */
  anyPlayers: AnyPlayerInterfaceConnection;
  /** The `any_recent_departures` field cannot be nested within a list. */
  anyRecentDepartures: AnyPlayerInterfaceConnection;
  /** Returns top 5 players of the club based on L15 */
  anyTopPlayers: Array<BaseballPlayer | NBAPlayer | Player>;
  code?: Maybe<Scalars['String']['output']>;
  country: Country;
  currentUserSubscription?: Maybe<EmailSubscription>;
  dataPartner?: Maybe<DataPartner>;
  domesticLeague?: Maybe<Competition>;
  domesticLeagueRanking?: Maybe<Scalars['Int']['output']>;
  domesticLeagueRankingRatioRange?: Maybe<RankingRatioRange>;
  founded?: Maybe<Scalars['String']['output']>;
  /** The `games` field cannot be nested within a list. */
  games: GameConnection;
  id: Scalars['ID']['output'];
  lastFiveAnyGames: Array<Game | GameOfBaseball | GameOfBasketball>;
  lastFiveGames: Array<Game>;
  /** The `latest_any_games` field cannot be nested within a list. */
  latestAnyGames: AnyGameInterfaceConnection;
  /** The `latest_games` field cannot be nested within a list. */
  latestGames: GameConnection;
  name: Scalars['String']['output'];
  officialName: Scalars['String']['output'];
  optaId?: Maybe<Scalars['String']['output']>;
  pictureSecondaryUrl?: Maybe<Scalars['String']['output']>;
  pictureUrl?: Maybe<Scalars['String']['output']>;
  /** The `players` field cannot be nested within a list. */
  players: PlayerConnection;
  ready: Scalars['Boolean']['output'];
  /** The `recent_departures` field cannot be nested within a list. */
  recentDepartures: PlayerConnection;
  /** Returns the top 3 of the league, excluding the current club */
  relatedClubs?: Maybe<Array<Club>>;
  shortName: Scalars['String']['output'];
  slug: Scalars['String']['output'];
  styleGuideColor?: Maybe<Scalars['String']['output']>;
  subscriptionsCount: Scalars['Int']['output'];
  /** Returns top 5 players of the club based on L15 */
  topPlayers: Array<Player>;
  upcomingAnyGames: Array<Maybe<Game | GameOfBaseball | GameOfBasketball>>;
  upcomingGames: Array<Maybe<Game>>;
  withSellablePlayers: Scalars['Boolean']['output'];
}


export interface ClubactiveMembershipsArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
}


export interface ClubactivePlayersArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
}


export interface ClubanyActivePlayersArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
}


export interface ClubanyCardsArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  age?: InputMaybe<Scalars['Int']['input']>;
  assetIds?: InputMaybe<Array<Scalars['String']['input']>>;
  before?: InputMaybe<Scalars['String']['input']>;
  classicOnly?: InputMaybe<Scalars['Boolean']['input']>;
  customCardEditionName?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  inActiveCompetitions?: InputMaybe<Array<Scalars['String']['input']>>;
  inSeasonEligible?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  owned?: InputMaybe<Scalars['Boolean']['input']>;
  ownedByMe?: InputMaybe<Scalars['Boolean']['input']>;
  ownedSinceAfter?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  playerSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  positions?: InputMaybe<Array<Position>>;
  rarities?: InputMaybe<Array<Rarity>>;
  revealable?: InputMaybe<Scalars['Boolean']['input']>;
  seasonStartYears?: InputMaybe<Array<Scalars['Int']['input']>>;
  serialNumber?: InputMaybe<Scalars['Int']['input']>;
  shirtNumber?: InputMaybe<Scalars['Int']['input']>;
  slugs?: InputMaybe<Array<Scalars['String']['input']>>;
  sorts?: InputMaybe<Array<CardSort>>;
  sport?: InputMaybe<Sport>;
  teamSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  withinDeckFirst?: InputMaybe<Scalars['String']['input']>;
}


export interface ClubanyGamesArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  endDate: Scalars['ISO8601DateTime']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  startDate: Scalars['ISO8601DateTime']['input'];
}


export interface ClubanyPlayersArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
}


export interface ClubanyRecentDeparturesArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
}


export interface ClubgamesArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  endDate: Scalars['ISO8601DateTime']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  startDate: Scalars['ISO8601DateTime']['input'];
}


export interface ClublatestAnyGamesArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  includingLive?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
}


export interface ClublatestGamesArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  includingLive?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
}


export interface ClubpictureUrlArgs {
  derivative?: InputMaybe<Scalars['String']['input']>;
}


export interface ClubplayersArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
}


export interface ClubrecentDeparturesArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
}


export interface ClubupcomingAnyGamesArgs {
  first: Scalars['Int']['input'];
}


export interface ClubupcomingGamesArgs {
  first: Scalars['Int']['input'];
}


export interface ClubwithSellablePlayersArgs {
  withSingleSales?: InputMaybe<Scalars['Boolean']['input']>;
}

/** The connection type for Club. */
export interface ClubConnection {
  __typename: 'ClubConnection';
  /** A list of edges. */
  edges: Array<ClubEdge>;
  /** A list of nodes. */
  nodes: Array<Club>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
}

/** An edge in a connection. */
export interface ClubEdge {
  __typename: 'ClubEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<Club>;
}

/** Object that can be a shop item */
export type ClubShopItem = AppearanceBoostShopItem | CommonCardSwapShopItem | DeliverableWithCustomVariantShopItem | DeliverableWithNoVariantShopItem | ExtraSwapShopItem | JerseyShopItem | LevelUpShopItem | RaffleShopItem | ShopItem | SkinShopItem;

/** The connection type for ClubShopItem. */
export interface ClubShopItemConnection {
  __typename: 'ClubShopItemConnection';
  /** A list of edges. */
  edges: Array<ClubShopItemEdge>;
  hasAny: Scalars['Boolean']['output'];
  /** A list of nodes. */
  nodes: Array<ClubShopItem>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
}

/** An edge in a connection. */
export interface ClubShopItemEdge {
  __typename: 'ClubShopItemEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<ClubShopItem>;
}

/** A Coin Reward */
export interface CoinReward extends AnyRewardInterface, Node {
  __typename: 'CoinReward';
  aasmState: RewardState;
  coinAmount: Scalars['Int']['output'];
  config: CoinRewardConfig;
  id: Scalars['ID']['output'];
}

/** A Coin Reward Config */
export interface CoinRewardConfig extends AnyRewardConfigInterface {
  __typename: 'CoinRewardConfig';
  amount: Scalars['Int']['output'];
  boostedRewardConfigs?: Maybe<Array<CardPacksRewardConfig | CardRewardConfig | CardShardRewardConfig | CoinRewardConfig | ConversionCreditRewardConfig | DeliverableItemRewardConfig | ExperienceRewardConfig | InGameCurrencyRewardConfig | MonetaryRewardConfig | ProbabilisticBundleRewardConfig | ShopItemRewardConfig>>;
  currency: InGameCurrency;
  id: Scalars['ID']['output'];
}

export const Collection = {
  BASEBALL: 'BASEBALL',
  FOOTBALL: 'FOOTBALL',
  FOOTBALL_NATIONAL_SERIES: 'FOOTBALL_NATIONAL_SERIES',
  NBA: 'NBA'
} as const;

export type Collection = typeof Collection[keyof typeof Collection];
/** The collection completion of a manager profile */
export interface CollectionCompletionManagerProfileStat extends ManagerProfileStat {
  __typename: 'CollectionCompletionManagerProfileStat';
  label: Scalars['String']['output'];
  /** Ratio of the collection players the manager owns, between 0 and 1 */
  percentage: Scalars['Float']['output'];
}

export interface CollectionTaskThreshold {
  __typename: 'CollectionTaskThreshold';
  count: Scalars['Int']['output'];
  current: Scalars['Boolean']['output'];
  rewardConfigs: Array<CardPacksRewardConfig | CardRewardConfig | CardShardRewardConfig | CoinRewardConfig | ConversionCreditRewardConfig | DeliverableItemRewardConfig | ExperienceRewardConfig | InGameCurrencyRewardConfig | MonetaryRewardConfig | ProbabilisticBundleRewardConfig | ShopItemRewardConfig>;
}

export const ColorVariant = {
  OPTIONAL: 'OPTIONAL',
  PRIMARY: 'PRIMARY',
  SECONDARY: 'SECONDARY'
} as const;

export type ColorVariant = typeof ColorVariant[keyof typeof ColorVariant];
/** A Common Account */
export interface CommonAccount extends Node {
  __typename: 'CommonAccount';
  id: Scalars['ID']['output'];
}

export interface CommonCardSwapShopItem extends Node, ShopItemInterface {
  __typename: 'CommonCardSwapShopItem';
  cardCollectionRequirements: Array<CardCollectionRequirement>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  disabled: Scalars['Boolean']['output'];
  expirationDate?: Maybe<Scalars['ISO8601DateTime']['output']>;
  id: Scalars['ID']['output'];
  infoLink?: Maybe<Scalars['String']['output']>;
  limitPerUser: Scalars['Int']['output'];
  myAvailableTotalPurchasesCount: Scalars['Int']['output'];
  myAvailableUserShopItems?: Maybe<Array<UserShopItem>>;
  myBalance: Scalars['Int']['output'];
  myLimitResetAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  myPurchasesCount: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  pictureUrl: Scalars['String']['output'];
  position: ShopItemType;
  price: Scalars['Int']['output'];
  requirementsRulesLink?: Maybe<Scalars['String']['output']>;
  salePrice?: Maybe<Scalars['Int']['output']>;
  shopItemsRequired: Array<ShopItem>;
  threeDimensionalAssetUrl?: Maybe<Scalars['String']['output']>;
  unlocked: Scalars['Boolean']['output'];
}


export interface CommonCardSwapShopItempictureUrlArgs {
  derivative?: InputMaybe<ShopItemDerivative>;
}


export interface CommonCardSwapShopItemthreeDimensionalAssetUrlArgs {
  format?: InputMaybe<ShopItemThreeDimensionalAssetFormat>;
}

/** A Sorare player */
export interface CommonPlayer extends Node {
  __typename: 'CommonPlayer';
  anyPlayer: BaseballPlayer | NBAPlayer | Player;
  anyTeam: Club | NationalTeam;
  id: Scalars['ID']['output'];
  marketValue?: Maybe<MonetaryAmount>;
  pictureUrl?: Maybe<Scalars['String']['output']>;
  positions: Array<Position>;
}


/** A Sorare player */
export interface CommonPlayermarketValueArgs {
  rarity: Rarity;
  seasonEligibility: SeasonEligibility;
}


/** A Sorare player */
export interface CommonPlayerpictureUrlArgs {
  derivative?: InputMaybe<Scalars['String']['input']>;
}

/** The connection type for CommonPlayer. */
export interface CommonPlayerConnection {
  __typename: 'CommonPlayerConnection';
  /** A list of edges. */
  edges: Array<CommonPlayerEdge>;
  /** A list of nodes. */
  nodes: Array<CommonPlayer>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
}

/** An edge in a connection. */
export interface CommonPlayerEdge {
  __typename: 'CommonPlayerEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<CommonPlayer>;
}

/** The draw odds of a common player within a pack slot */
export interface CommonPlayerOdds {
  __typename: 'CommonPlayerOdds';
  commonPlayer: CommonPlayer;
  /** Draw probability in basis points (1 bp = 0.01%); fractional */
  probabilityBasisPoint: Scalars['Float']['output'];
}

/** A professional football competition */
export interface Competition extends Node, WithSubscriptionsInterface {
  __typename: 'Competition';
  backgroundPictureUrl?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use teams instead */
  clubs: ClubConnection;
  /** The `contestants` field cannot be nested within a list. */
  contestants: Array<Contestant>;
  country?: Maybe<Country>;
  currentUserSubscription?: Maybe<EmailSubscription>;
  displayName: Scalars['String']['output'];
  format: CompetitionFormat;
  /** The `future_games` field cannot be nested within a list. */
  futureGames: GameConnection;
  id: Scalars['ID']['output'];
  licensed: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  openForGameStats: Scalars['Boolean']['output'];
  /**
   * Returns the players ordered by average stat (default last five average
   * so5_score) The `ordered_players` field cannot be nested within a list.
   */
  orderedPlayers: PlayerConnection;
  /** The `past_games` field cannot be nested within a list. */
  pastGames: GameConnection;
  pictureSecondaryUrl?: Maybe<Scalars['String']['output']>;
  pictureUrl?: Maybe<Scalars['String']['output']>;
  /** The `players_by_last_five_average` field cannot be nested within a list. */
  playersByLastFiveAverage: PlayerConnection;
  released: Scalars['Boolean']['output'];
  /** The `seasons` field cannot be nested within a list. */
  seasons: Array<Season>;
  slug: Scalars['String']['output'];
  stages: Array<TournamentCalendarStage>;
  subscriptionsCount: Scalars['Int']['output'];
  teams: TeamInterfaceConnection;
  type: CompetitionType;
}


/** A professional football competition */
export interface CompetitionclubsArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  direction?: InputMaybe<SortingOption>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sortType?: InputMaybe<PopularSortingOption>;
}


/** A professional football competition */
export interface CompetitioncontestantsArgs {
  seasonStartYear: Scalars['Int']['input'];
}


/** A professional football competition */
export interface CompetitionfutureGamesArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
}


/** A professional football competition */
export interface CompetitionorderedPlayersArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  averageStat?: InputMaybe<AverageStat>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<AverageLimit>;
}


/** A professional football competition */
export interface CompetitionpastGamesArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
}


/** A professional football competition */
export interface CompetitionpictureUrlArgs {
  derivative?: InputMaybe<Scalars['String']['input']>;
}


/** A professional football competition */
export interface CompetitionplayersByLastFiveAverageArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
}


/** A professional football competition */
export interface CompetitionstagesArgs {
  seasonStartYear: Scalars['Int']['input'];
}


/** A professional football competition */
export interface CompetitionteamsArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  direction?: InputMaybe<SortingOption>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sortType?: InputMaybe<PopularSortingOption>;
}

export interface CompetitionCardCollections {
  __typename: 'CompetitionCardCollections';
  /** @deprecated Not used anymore */
  cardCollections: Array<CardCollection>;
  /** @deprecated Not used anymore */
  competition?: Maybe<Competition>;
  /** @deprecated Not used anymore */
  myStats?: Maybe<CompetitionCardCollectionsStats>;
}


export interface CompetitionCardCollectionscardCollectionsArgs {
  first?: InputMaybe<Scalars['Int']['input']>;
}

export interface CompetitionCardCollectionsStats {
  __typename: 'CompetitionCardCollectionsStats';
  /** @deprecated Not used anymore */
  liveRanking?: Maybe<Scalars['Int']['output']>;
  /** @deprecated Not used anymore */
  liveRankingRatio?: Maybe<Scalars['Int']['output']>;
  /** @deprecated Not used anymore */
  ownedCardsCount: Scalars['Int']['output'];
  /** @deprecated Not used anymore */
  ownedPlayersCount: Scalars['Int']['output'];
  /** @deprecated Not used anymore */
  totalCardsCount: Scalars['Int']['output'];
  /** @deprecated Not used anymore */
  totalPlayersCount: Scalars['Int']['output'];
}


export interface CompetitionCardCollectionsStatsliveRankingRatioArgs {
  top?: InputMaybe<Scalars['Boolean']['input']>;
}

export interface CompetitionCount {
  __typename: 'CompetitionCount';
  competition: Competition;
  count: Scalars['Int']['output'];
}

export const CompetitionFormat = {
  DOMESTIC_CUP: 'DOMESTIC_CUP',
  DOMESTIC_LEAGUE: 'DOMESTIC_LEAGUE',
  DOMESTIC_SUPER_CUP: 'DOMESTIC_SUPER_CUP',
  INTERNATIONAL_CUP: 'INTERNATIONAL_CUP',
  INTERNATIONAL_SUPER_CUP: 'INTERNATIONAL_SUPER_CUP'
} as const;

export type CompetitionFormat = typeof CompetitionFormat[keyof typeof CompetitionFormat];
export interface CompetitionGames {
  __typename: 'CompetitionGames';
  competition: Competition;
  games: Array<Game | GameOfBaseball | GameOfBasketball>;
  gamesWithMyCardPreview: Array<GameWithCardsPreview>;
}


export interface CompetitionGamesgamesWithMyCardPreviewArgs {
  rarities?: InputMaybe<Array<Rarity>>;
  withCards?: InputMaybe<Scalars['Boolean']['input']>;
}

export const CompetitionType = {
  CLUB: 'CLUB',
  INTERNATIONAL: 'INTERNATIONAL'
} as const;

export type CompetitionType = typeof CompetitionType[keyof typeof CompetitionType];
export interface CompletablePromotionalEventInterface {
  algoliaFilters: Scalars['String']['output'];
  backgroundPictureUrl?: Maybe<Scalars['String']['output']>;
  bannerAssetsPictureUrl?: Maybe<Scalars['String']['output']>;
  blogUrl?: Maybe<Scalars['String']['output']>;
  completionAmount?: Maybe<MonetaryAmount>;
  completionRules: Scalars['JSON']['output'];
  description: Scalars['String']['output'];
  eligibilityRules: EligibilityRules;
  endDate: Scalars['ISO8601DateTime']['output'];
  filterPictureUrl?: Maybe<Scalars['String']['output']>;
  heroValueProps: Array<HeroValueProp>;
  id: Scalars['ID']['output'];
  logoUrl?: Maybe<Scalars['String']['output']>;
  marketBannerTitle: Scalars['String']['output'];
  mobileBackgroundPictureUrl?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  pictureUrl?: Maybe<Scalars['String']['output']>;
  probableRewardConfigs: Array<ProbableRewardConfig>;
  promotionDetailsRewardDescription?: Maybe<Scalars['String']['output']>;
  promotionDetailsRewardPictureUrl?: Maybe<Scalars['String']['output']>;
  promotionType: PromotionType;
  promotionalEventCompletion?: Maybe<PromotionalEventCompletion>;
  secondaryBannerPictureUrl?: Maybe<Scalars['String']['output']>;
  slug: Scalars['String']['output'];
  sport?: Maybe<Sport>;
  startDate: Scalars['ISO8601DateTime']['output'];
  termsAndConditionsUrl?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
}

export interface CompleteCollectionsCountTargetTask extends ManagerTaskInterface, TaskInterface {
  __typename: 'CompleteCollectionsCountTargetTask';
  aasmState: ManagerProgressionTaskState;
  alternativeRewardConfigs?: Maybe<Array<AlternativeRewardConfig>>;
  /** The `card_collections_with_progress` field cannot be nested within a list. */
  cardCollectionsWithProgress: CardCollectionWithProgressConnection;
  cardSet?: Maybe<CardSet>;
  /** @deprecated Not used anymore */
  cards: Array<BaseballCard | Card | NBACard>;
  claimableAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** @deprecated Not used anymore */
  claimedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  color?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `competitions` instead */
  competition?: Maybe<Competition>;
  competitions: Array<Competition>;
  completedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  completedBy?: Maybe<UserCardCollection>;
  description: Scalars['String']['output'];
  expired: Scalars['Boolean']['output'];
  genre: TaskGenre;
  group?: Maybe<TaskGroup>;
  iconUrl?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  jonumGated: Scalars['Boolean']['output'];
  /** The points this task earned on a ladder leaderboard, empty when it feeds none. */
  ladderContributions: Array<LadderContribution>;
  lastCompletedUserCollection?: Maybe<UserCardCollection>;
  /** The `my_reward_pool_shares` field cannot be nested within a list. */
  myRewardPoolShares?: Maybe<Array<RewardPoolShare>>;
  name: ManagerProgressionTaskSlug;
  parentTask?: Maybe<CardsCountTargetTask | CardsCountTask | CompleteCollectionsCountTargetTask | CompleteCollectionsCountTask | DailyActionTask | DecisivePlayerPickerTask | DropChallengeTask | GameWeeklyTask | GuessTheScoreTask | InviteTaskAsReferrer | So5LeaderboardTask | StarPackTask | Task | TasksTrack | ThresholdPickerTask | ThresholdsDuoConnectionTask | ThresholdsStreakAdditionalLineupTask | ThresholdsStreakTask>;
  periodicity?: Maybe<ManagerTaskPeriodicity>;
  pickOrList: Scalars['Boolean']['output'];
  possibleRewardConfigsIconUrl?: Maybe<Scalars['String']['output']>;
  /** @deprecated Not used anymore */
  probabilisticBundles: Array<ProbabilisticBundle>;
  progress: Scalars['Int']['output'];
  rarity?: Maybe<Rarity>;
  /** The `related_pack_configs` field cannot be nested within a list. */
  relatedPackConfigs: Array<CardPack>;
  rewardConfigs: Array<CardPacksRewardConfig | CardRewardConfig | CardShardRewardConfig | CoinRewardConfig | ConversionCreditRewardConfig | DeliverableItemRewardConfig | ExperienceRewardConfig | InGameCurrencyRewardConfig | MonetaryRewardConfig | ProbabilisticBundleRewardConfig | ShopItemRewardConfig>;
  /** The `reward_pool_shares` field cannot be nested within a list. */
  rewardPoolShares?: Maybe<RewardPoolShareConnection>;
  /** The So5 competitions playable with the competitions targeted by this task */
  so5Competitions: Array<So5Competition>;
  specifiedTeams: Array<Team>;
  startDate?: Maybe<Scalars['ISO8601DateTime']['output']>;
  target: Scalars['Int']['output'];
  taskConfigSlug: Scalars['String']['output'];
  templateIconUrl: Scalars['String']['output'];
  title: Scalars['String']['output'];
  uncapped: Scalars['Boolean']['output'];
  userCollectionClosestToCompletion?: Maybe<UserCardCollection>;
}


export interface CompleteCollectionsCountTargetTaskcardCollectionsWithProgressArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
}


export interface CompleteCollectionsCountTargetTaskcolorArgs {
  variant?: InputMaybe<ColorVariant>;
}


export interface CompleteCollectionsCountTargetTaskrewardConfigsArgs {
  mergedConfigsByType?: InputMaybe<Scalars['Boolean']['input']>;
}


export interface CompleteCollectionsCountTargetTaskrewardPoolSharesArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
}

export interface CompleteCollectionsCountTask extends ManagerTaskInterface, TaskInterface {
  __typename: 'CompleteCollectionsCountTask';
  aasmState: ManagerProgressionTaskState;
  alternativeRewardConfigs?: Maybe<Array<AlternativeRewardConfig>>;
  cardSet?: Maybe<CardSet>;
  /** @deprecated Not used anymore */
  cards: Array<BaseballCard | Card | NBACard>;
  claimableAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** @deprecated Not used anymore */
  claimedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  color?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `competitions` instead */
  competition?: Maybe<Competition>;
  competitions: Array<Competition>;
  completedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  completedBy?: Maybe<UserCardCollection>;
  description: Scalars['String']['output'];
  expired: Scalars['Boolean']['output'];
  genre: TaskGenre;
  group?: Maybe<TaskGroup>;
  iconUrl?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  jonumGated: Scalars['Boolean']['output'];
  /** The points this task earned on a ladder leaderboard, empty when it feeds none. */
  ladderContributions: Array<LadderContribution>;
  lastCompletedUserCollection?: Maybe<UserCardCollection>;
  liveScore: Scalars['Int']['output'];
  /** The `my_reward_pool_shares` field cannot be nested within a list. */
  myRewardPoolShares?: Maybe<Array<RewardPoolShare>>;
  name: ManagerProgressionTaskSlug;
  parentTask?: Maybe<CardsCountTargetTask | CardsCountTask | CompleteCollectionsCountTargetTask | CompleteCollectionsCountTask | DailyActionTask | DecisivePlayerPickerTask | DropChallengeTask | GameWeeklyTask | GuessTheScoreTask | InviteTaskAsReferrer | So5LeaderboardTask | StarPackTask | Task | TasksTrack | ThresholdPickerTask | ThresholdsDuoConnectionTask | ThresholdsStreakAdditionalLineupTask | ThresholdsStreakTask>;
  periodicity?: Maybe<ManagerTaskPeriodicity>;
  pickOrList: Scalars['Boolean']['output'];
  possibleRewardConfigsIconUrl?: Maybe<Scalars['String']['output']>;
  /** @deprecated Not used anymore */
  probabilisticBundles: Array<ProbabilisticBundle>;
  progress: Scalars['Int']['output'];
  rarity?: Maybe<Rarity>;
  /** The `related_pack_configs` field cannot be nested within a list. */
  relatedPackConfigs: Array<CardPack>;
  rewardConfigs: Array<CardPacksRewardConfig | CardRewardConfig | CardShardRewardConfig | CoinRewardConfig | ConversionCreditRewardConfig | DeliverableItemRewardConfig | ExperienceRewardConfig | InGameCurrencyRewardConfig | MonetaryRewardConfig | ProbabilisticBundleRewardConfig | ShopItemRewardConfig>;
  /** The `reward_pool_shares` field cannot be nested within a list. */
  rewardPoolShares?: Maybe<RewardPoolShareConnection>;
  scoreToReach: Scalars['Int']['output'];
  specifiedTeams: Array<Team>;
  startDate?: Maybe<Scalars['ISO8601DateTime']['output']>;
  target: Scalars['Int']['output'];
  taskConfigSlug: Scalars['String']['output'];
  templateIconUrl: Scalars['String']['output'];
  thresholds: Array<CollectionTaskThreshold>;
  title: Scalars['String']['output'];
  uncapped: Scalars['Boolean']['output'];
  userCollectionClosestToCompletion?: Maybe<UserCardCollection>;
}


export interface CompleteCollectionsCountTaskcolorArgs {
  variant?: InputMaybe<ColorVariant>;
}


export interface CompleteCollectionsCountTaskrewardConfigsArgs {
  mergedConfigsByType?: InputMaybe<Scalars['Boolean']['input']>;
}


export interface CompleteCollectionsCountTaskrewardPoolSharesArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
}

/** A Sorare card on the bench */
export interface ComposeTeamBenchCard extends ComposeTeamBenchObjectInterface {
  __typename: 'ComposeTeamBenchCard';
  activeSuspensions: Array<Suspension>;
  anyCard: BaseballCard | Card | NBACard;
  anyCardWithLivePrimaryOffer?: Maybe<BaseballCard | Card | NBACard>;
  anyPlayer: BaseballPlayer | NBAPlayer | Player;
  averageScore?: Maybe<Scalars['Float']['output']>;
  bonus?: Maybe<Scalars['Float']['output']>;
  cardBorderRadius: Scalars['Int']['output'];
  eligiblePlayerGameScores: Array<BaseballPlayerGameScore | BasketballPlayerGameScore | PlayerGameScore | So5Score>;
  /**
   * Projected score minus the lowest score of the player star tier for NBA, minus
   * the L10 average otherwise, from the projection the bench sorts
   * GAIN_ON_PROJECTION on: the next game on a card bench with no fixture, the
   * fixture projection otherwise
   */
  gainOnProjection?: Maybe<Scalars['Float']['output']>;
  id: Scalars['ID']['output'];
  licensed: Scalars['Boolean']['output'];
  /** When a bench object will be locked for a leaderboard */
  lockedAt: Scalars['ISO8601DateTime']['output'];
  /** Wether a bench object can be updated for a leaderboard */
  lockedForLeaderboard: Scalars['Boolean']['output'];
  pictureUrl?: Maybe<Scalars['String']['output']>;
  player: Player;
  position: Position;
  positions: Array<Position>;
  projectedScore?: Maybe<Scalars['Float']['output']>;
  rarity: Rarity;
  /**
   * Number of user-owned cards sharing this card_data after the BenchFilterInput
   * filters. Set on benches that collapse cards by card_data (every surface except
   * career Pro steps); nil otherwise.
   */
  stackedCardsCount?: Maybe<Scalars['Int']['output']>;
  videoUrl?: Maybe<Scalars['String']['output']>;
}


/** A Sorare card on the bench */
export interface ComposeTeamBenchCardactiveSuspensionsArgs {
  so5LeaderboardSlug?: InputMaybe<Scalars['String']['input']>;
}


/** A Sorare card on the bench */
export interface ComposeTeamBenchCardanyCardWithLivePrimaryOfferArgs {
  rarity?: InputMaybe<Rarity>;
}


/** A Sorare card on the bench */
export interface ComposeTeamBenchCardaverageScoreArgs {
  type: AveragePlayerScore;
}


/** A Sorare card on the bench */
export interface ComposeTeamBenchCardeligiblePlayerGameScoresArgs {
  boardId?: InputMaybe<Scalars['String']['input']>;
  gameId?: InputMaybe<Scalars['ID']['input']>;
  so5LeaderboardSlug?: InputMaybe<Scalars['String']['input']>;
  stepId?: InputMaybe<Scalars['String']['input']>;
  taskId?: InputMaybe<Scalars['ID']['input']>;
}


/** A Sorare card on the bench */
export interface ComposeTeamBenchCardlockedAtArgs {
  so5LeaderboardSlug?: InputMaybe<Scalars['String']['input']>;
}


/** A Sorare card on the bench */
export interface ComposeTeamBenchCardlockedForLeaderboardArgs {
  so5LeaderboardSlug?: InputMaybe<Scalars['String']['input']>;
}


/** A Sorare card on the bench */
export interface ComposeTeamBenchCardpictureUrlArgs {
  derivative?: InputMaybe<Scalars['String']['input']>;
}


/** A Sorare card on the bench */
export interface ComposeTeamBenchCardprojectedScoreArgs {
  so5LeaderboardSlug: Scalars['String']['input'];
}


/** A Sorare card on the bench */
export interface ComposeTeamBenchCardvideoUrlArgs {
  derivative?: InputMaybe<Scalars['String']['input']>;
}

/** A Sorare player on the bench */
export interface ComposeTeamBenchCommonPlayer extends ComposeTeamBenchObjectInterface {
  __typename: 'ComposeTeamBenchCommonPlayer';
  activeSuspensions: Array<Suspension>;
  anyCardWithLivePrimaryOffer?: Maybe<BaseballCard | Card | NBACard>;
  anyPlayer: BaseballPlayer | NBAPlayer | Player;
  averageScore?: Maybe<Scalars['Float']['output']>;
  bonus?: Maybe<Scalars['Float']['output']>;
  cardBorderRadius: Scalars['Int']['output'];
  eligiblePlayerGameScores: Array<BaseballPlayerGameScore | BasketballPlayerGameScore | PlayerGameScore | So5Score>;
  /**
   * Projected score minus the lowest score of the player star tier for NBA, minus
   * the L10 average otherwise, from the projection the bench sorts
   * GAIN_ON_PROJECTION on: the next game on a card bench with no fixture, the
   * fixture projection otherwise
   */
  gainOnProjection?: Maybe<Scalars['Float']['output']>;
  id: Scalars['ID']['output'];
  licensed: Scalars['Boolean']['output'];
  /** When a bench object will be locked for a leaderboard */
  lockedAt: Scalars['ISO8601DateTime']['output'];
  /** Wether a bench object can be updated for a leaderboard */
  lockedForLeaderboard: Scalars['Boolean']['output'];
  pictureUrl?: Maybe<Scalars['String']['output']>;
  player: Player;
  position: Position;
  positions: Array<Position>;
  projectedScore?: Maybe<Scalars['Float']['output']>;
  rarity: Rarity;
  videoUrl?: Maybe<Scalars['String']['output']>;
}


/** A Sorare player on the bench */
export interface ComposeTeamBenchCommonPlayeractiveSuspensionsArgs {
  so5LeaderboardSlug?: InputMaybe<Scalars['String']['input']>;
}


/** A Sorare player on the bench */
export interface ComposeTeamBenchCommonPlayeranyCardWithLivePrimaryOfferArgs {
  rarity?: InputMaybe<Rarity>;
}


/** A Sorare player on the bench */
export interface ComposeTeamBenchCommonPlayeraverageScoreArgs {
  type: AveragePlayerScore;
}


/** A Sorare player on the bench */
export interface ComposeTeamBenchCommonPlayereligiblePlayerGameScoresArgs {
  boardId?: InputMaybe<Scalars['String']['input']>;
  gameId?: InputMaybe<Scalars['ID']['input']>;
  so5LeaderboardSlug?: InputMaybe<Scalars['String']['input']>;
  stepId?: InputMaybe<Scalars['String']['input']>;
  taskId?: InputMaybe<Scalars['ID']['input']>;
}


/** A Sorare player on the bench */
export interface ComposeTeamBenchCommonPlayerlockedAtArgs {
  so5LeaderboardSlug?: InputMaybe<Scalars['String']['input']>;
}


/** A Sorare player on the bench */
export interface ComposeTeamBenchCommonPlayerlockedForLeaderboardArgs {
  so5LeaderboardSlug?: InputMaybe<Scalars['String']['input']>;
}


/** A Sorare player on the bench */
export interface ComposeTeamBenchCommonPlayerpictureUrlArgs {
  derivative?: InputMaybe<Scalars['String']['input']>;
}


/** A Sorare player on the bench */
export interface ComposeTeamBenchCommonPlayerprojectedScoreArgs {
  so5LeaderboardSlug: Scalars['String']['input'];
}


/** A Sorare player on the bench */
export interface ComposeTeamBenchCommonPlayervideoUrlArgs {
  derivative?: InputMaybe<Scalars['String']['input']>;
}

/** Compose team Bench object interface */
export interface ComposeTeamBenchObjectInterface {
  activeSuspensions: Array<Suspension>;
  anyCardWithLivePrimaryOffer?: Maybe<BaseballCard | Card | NBACard>;
  anyPlayer: BaseballPlayer | NBAPlayer | Player;
  averageScore?: Maybe<Scalars['Float']['output']>;
  bonus?: Maybe<Scalars['Float']['output']>;
  cardBorderRadius: Scalars['Int']['output'];
  eligiblePlayerGameScores: Array<BaseballPlayerGameScore | BasketballPlayerGameScore | PlayerGameScore | So5Score>;
  /**
   * Projected score minus the lowest score of the player star tier for NBA, minus
   * the L10 average otherwise, from the projection the bench sorts
   * GAIN_ON_PROJECTION on: the next game on a card bench with no fixture, the
   * fixture projection otherwise
   */
  gainOnProjection?: Maybe<Scalars['Float']['output']>;
  id: Scalars['ID']['output'];
  licensed: Scalars['Boolean']['output'];
  /** When a bench object will be locked for a leaderboard */
  lockedAt: Scalars['ISO8601DateTime']['output'];
  /** Wether a bench object can be updated for a leaderboard */
  lockedForLeaderboard: Scalars['Boolean']['output'];
  pictureUrl?: Maybe<Scalars['String']['output']>;
  player: Player;
  position: Position;
  positions: Array<Position>;
  projectedScore?: Maybe<Scalars['Float']['output']>;
  rarity: Rarity;
  videoUrl?: Maybe<Scalars['String']['output']>;
}


/** Compose team Bench object interface */
export interface ComposeTeamBenchObjectInterfaceactiveSuspensionsArgs {
  so5LeaderboardSlug?: InputMaybe<Scalars['String']['input']>;
}


/** Compose team Bench object interface */
export interface ComposeTeamBenchObjectInterfaceanyCardWithLivePrimaryOfferArgs {
  rarity?: InputMaybe<Rarity>;
}


/** Compose team Bench object interface */
export interface ComposeTeamBenchObjectInterfaceaverageScoreArgs {
  type: AveragePlayerScore;
}


/** Compose team Bench object interface */
export interface ComposeTeamBenchObjectInterfaceeligiblePlayerGameScoresArgs {
  boardId?: InputMaybe<Scalars['String']['input']>;
  gameId?: InputMaybe<Scalars['ID']['input']>;
  so5LeaderboardSlug?: InputMaybe<Scalars['String']['input']>;
  stepId?: InputMaybe<Scalars['String']['input']>;
  taskId?: InputMaybe<Scalars['ID']['input']>;
}


/** Compose team Bench object interface */
export interface ComposeTeamBenchObjectInterfacelockedAtArgs {
  so5LeaderboardSlug?: InputMaybe<Scalars['String']['input']>;
}


/** Compose team Bench object interface */
export interface ComposeTeamBenchObjectInterfacelockedForLeaderboardArgs {
  so5LeaderboardSlug?: InputMaybe<Scalars['String']['input']>;
}


/** Compose team Bench object interface */
export interface ComposeTeamBenchObjectInterfacepictureUrlArgs {
  derivative?: InputMaybe<Scalars['String']['input']>;
}


/** Compose team Bench object interface */
export interface ComposeTeamBenchObjectInterfaceprojectedScoreArgs {
  so5LeaderboardSlug: Scalars['String']['input'];
}


/** Compose team Bench object interface */
export interface ComposeTeamBenchObjectInterfacevideoUrlArgs {
  derivative?: InputMaybe<Scalars['String']['input']>;
}

/** The connection type for ComposeTeamBenchObjectInterface. */
export interface ComposeTeamBenchObjectInterfaceConnection {
  __typename: 'ComposeTeamBenchObjectInterfaceConnection';
  /** A list of edges. */
  edges: Array<ComposeTeamBenchObjectInterfaceEdge>;
  /** A list of nodes. */
  nodes: Array<ComposeTeamBenchCard | ComposeTeamBenchCommonPlayer | DecisivePlayerPickerTaskAppearance | MissedAppearance | So5Appearance | TaskAppearance | ThresholdPickerTaskAppearance>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
}

/** An edge in a connection. */
export interface ComposeTeamBenchObjectInterfaceEdge {
  __typename: 'ComposeTeamBenchObjectInterfaceEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<ComposeTeamBenchCard | ComposeTeamBenchCommonPlayer | DecisivePlayerPickerTaskAppearance | MissedAppearance | So5Appearance | TaskAppearance | ThresholdPickerTaskAppearance>;
}

/** Live lineup preview for compose team */
export interface ComposeTeamLineupPreview {
  __typename: 'ComposeTeamLineupPreview';
  bonuses: Array<So5ActiveClubsBonus | So5AverageScoresBonus | So5BoostBonus | So5CaptainBonus | So5CollectionBonus | So5DifferentNationalitiesBonus | So5GradeBonus | So5LineupBonus | So5MalusAfterTransferBonus | So5NationalityBonus | So5PlayerBonus | So5PositionBonus | So5PositionStacksBonus | So5SameActiveClubBonus | So5ScarcityBonus | So5SeasonBonus | So5SpecialEditionCardsBonus>;
  feedbackRules?: Maybe<Array<So5RuleFeedback>>;
  rewardBoosts: Array<So5CardRewardBoost | So5PlayerLoyaltyRewardBoost | So5RarityVaultRewardBoost>;
  rewardMultiplier: Scalars['Float']['output'];
}


/** Live lineup preview for compose team */
export interface ComposeTeamLineupPreviewbonusesArgs {
  highlighted?: InputMaybe<Scalars['Boolean']['input']>;
}

/** The frontend config */
export interface Config {
  __typename: 'Config';
  activeRevealableCardCampaigns: Array<RevealableCardCampaign>;
  algoliaApplicationId: Scalars['String']['output'];
  algoliaIndexSuffix: Scalars['String']['output'];
  algoliaSearchApiKey: Scalars['String']['output'];
  baseBankAddress: Scalars['EthereumAddress']['output'];
  baseCrossDomainDepositAddress: Scalars['EthereumAddress']['output'];
  counts: Counts;
  /** @deprecated Use primaryMarketPaymentFeeRates / secondaryMarketPaymentFeeRates instead */
  creditCardFeesBasisPoints: Scalars['String']['output'];
  currentLocation: Location;
  defaultFiatCurrency: FiatCurrency;
  /** Countries where Sorare can deliver goods */
  deliverableCountries: Array<Country>;
  ethAssetType: Scalars['String']['output'];
  ethQuantum: Scalars['WeiAmount']['output'];
  ethereumBankDepositAddress: Scalars['EthereumAddress']['output'];
  ethereumEndpoint: Scalars['String']['output'];
  ethereumGatewayMinterProxyAddress: Scalars['EthereumAddress']['output'];
  ethereumNetworkId: Scalars['String']['output'];
  exchangeRate: ExchangeRate;
  /** Countries where Sorare's Fiat Wallet is supported. */
  fiatWalletCountries: Array<Country>;
  /** The gameplay tiers available for a sport with their star rating, strongest first */
  gameplayTierRatings: Array<GameplayTierRating>;
  /** The gameplay tiers available for a sport, strongest first */
  gameplayTiers: Array<GameplayTier>;
  giphyApiKey: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  idealDepositFeesAmountMinor: Scalars['Int']['output'];
  l1MessengerAddress: Scalars['EthereumAddress']['output'];
  mangopayApplePayDepositFeesBasisPoints: Scalars['Int']['output'];
  marketFeeRateBasisPoints: Scalars['Int']['output'];
  migratorAddress?: Maybe<Scalars['EthereumAddress']['output']>;
  minimumBidAmount: MonetaryAmount;
  minimumPrimaryMarketAmount: MonetaryAmount;
  minimumReceiveWeiAmount: Scalars['WeiAmount']['output'];
  minimumSecondaryMarketAmount: MonetaryAmount;
  payByBankDepositFeesAmountMinor: Scalars['Int']['output'];
  paypalDepositFeesBasisPoints: Scalars['Int']['output'];
  /**
   * Payment processing fee matrix applied to primary market purchases for the
   * current user. Rows are ordered by priority: apply the first row matching the payment.
   */
  primaryMarketPaymentFeeRates: Array<PaymentMethodFeeRate>;
  referralProgramConfig: ReferralProgramConfig;
  sealingConfig: SealingConfig;
  /**
   * Payment processing fee matrix applied to secondary market purchases. Rows are
   * ordered by priority: apply the first row matching the payment.
   */
  secondaryMarketPaymentFeeRates: Array<PaymentMethodFeeRate>;
  so5: So5Config;
  solanaBankAuthority?: Maybe<Scalars['SolanaAddress']['output']>;
  sorareEncryptionKey: Scalars['String']['output'];
  starkExchangeAddress: Scalars['EthereumAddress']['output'];
  starkwareEscapeHatchEnabled: Scalars['Boolean']['output'];
  starkwareEscapeHatchFeeAmount: Scalars['WeiAmount']['output'];
  starkwareEscapeHatchFeeRecipient: Scalars['EthereumAddress']['output'];
  stripePublicKey: Scalars['String']['output'];
  walletChallenge: Scalars['String']['output'];
}


/** The frontend config */
export interface ConfigactiveRevealableCardCampaignsArgs {
  sport?: InputMaybe<Sport>;
}


/** The frontend config */
export interface ConfigcreditCardFeesBasisPointsArgs {
  creditCardType?: InputMaybe<CreditCardType>;
  provider: PaymentMethodProvider;
}


/** The frontend config */
export interface ConfiggameplayTierRatingsArgs {
  sport: Sport;
}


/** The frontend config */
export interface ConfiggameplayTiersArgs {
  sport: Sport;
}


/** The frontend config */
export interface ConfigminimumBidAmountArgs {
  provider: PaymentProvider;
}


/** The frontend config */
export interface ConfigminimumPrimaryMarketAmountArgs {
  paymentMethod: TokenPaymentMethod;
}


/** The frontend config */
export interface ConfigminimumSecondaryMarketAmountArgs {
  paymentMethod: TokenPaymentMethod;
}


/** The frontend config */
export interface ConfigreferralProgramConfigArgs {
  sport?: InputMaybe<Sport>;
}


/** The frontend config */
export interface ConfigsealingConfigArgs {
  sport?: InputMaybe<Sport>;
}

/** Autogenerated return type of ConfirmDeviceMutation. */
export interface ConfirmDeviceMutationPayload {
  __typename: 'ConfirmDeviceMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  currentUser?: Maybe<CurrentUser>;
  errors: Array<UserError>;
  /** Generate a JWT Token. null if, and only if, currentUser is null. */
  jwtToken?: Maybe<JwtToken>;
}


/** Autogenerated return type of ConfirmDeviceMutation. */
export interface ConfirmDeviceMutationPayloadjwtTokenArgs {
  aud: Scalars['String']['input'];
}

/** Autogenerated return type of ConfirmEmailMutation. */
export interface ConfirmEmailMutationPayload {
  __typename: 'ConfirmEmailMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  currentUser?: Maybe<CurrentUser>;
  errors: Array<UserError>;
  /** Generate a JWT Token. null if, and only if, currentUser is null. */
  jwtToken?: Maybe<JwtToken>;
}


/** Autogenerated return type of ConfirmEmailMutation. */
export interface ConfirmEmailMutationPayloadjwtTokenArgs {
  aud: Scalars['String']['input'];
}

/** OAuth account connected by the user. */
export interface ConnectedOAuth extends Node {
  __typename: 'ConnectedOAuth';
  email: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  provider: OAuthProvider;
}

/** Autogenerated return type of ConsumeEphemeralTokenMutation. */
export interface ConsumeEphemeralTokenMutationPayload {
  __typename: 'ConsumeEphemeralTokenMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  currentUser?: Maybe<CurrentUser>;
  errors: Array<UserError>;
  /** Generate a JWT Token. null if, and only if, currentUser is null. */
  jwtToken?: Maybe<JwtToken>;
  /** Where to redirect the user */
  redirectUrl?: Maybe<Scalars['String']['output']>;
}


/** Autogenerated return type of ConsumeEphemeralTokenMutation. */
export interface ConsumeEphemeralTokenMutationPayloadjwtTokenArgs {
  aud: Scalars['String']['input'];
}

/** A contestant */
export interface Contestant extends Node {
  __typename: 'Contestant';
  anyTeam: Club | NationalTeam;
  goalsAgainst?: Maybe<Scalars['Int']['output']>;
  goalsFor?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  matchesDrawn?: Maybe<Scalars['Int']['output']>;
  matchesLost?: Maybe<Scalars['Int']['output']>;
  matchesPlayed?: Maybe<Scalars['Int']['output']>;
  matchesWon?: Maybe<Scalars['Int']['output']>;
  points?: Maybe<Scalars['Int']['output']>;
  rank?: Maybe<Scalars['Int']['output']>;
  rankStatus?: Maybe<Scalars['String']['output']>;
}

/** A smart contract */
export interface Contract extends Node {
  __typename: 'Contract';
  addressHex: Scalars['String']['output'];
  blockchain: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
}

/** A conversion credit */
export interface ConversionCredit extends Node {
  __typename: 'ConversionCredit';
  endDate: Scalars['ISO8601DateTime']['output'];
  id: Scalars['ID']['output'];
  maxDiscount: MonetaryAmount;
  percentageDiscount: Scalars['Float']['output'];
  purchase?: Maybe<ConversionCreditPurchase>;
  settlementDelay?: Maybe<Scalars['Int']['output']>;
  singleUse: Scalars['Boolean']['output'];
  sport?: Maybe<Sport>;
  status: ConversionCreditStatus;
  totalDiscount: MonetaryAmount;
}

/** A conversion credit campaign */
export interface ConversionCreditCampaign extends Node {
  __typename: 'ConversionCreditCampaign';
  campaignCode: Scalars['String']['output'];
  endDate: Scalars['ISO8601DateTime']['output'];
  id: Scalars['ID']['output'];
  maxDiscount: MonetaryAmount;
  percentageDiscount: Scalars['Float']['output'];
  sport?: Maybe<Sport>;
  status: ConversionCreditCampaignStatus;
}

export const ConversionCreditCampaignStatus = {
  ACTIVE: 'ACTIVE',
  CANCELLED: 'CANCELLED',
  CREATED: 'CREATED',
  EXPIRED: 'EXPIRED'
} as const;

export type ConversionCreditCampaignStatus = typeof ConversionCreditCampaignStatus[keyof typeof ConversionCreditCampaignStatus];
/** The connection type for ConversionCredit. */
export interface ConversionCreditConnection {
  __typename: 'ConversionCreditConnection';
  /** A list of edges. */
  edges: Array<ConversionCreditEdge>;
  /** A list of nodes. */
  nodes: Array<ConversionCredit>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
}

/** An edge in a connection. */
export interface ConversionCreditEdge {
  __typename: 'ConversionCreditEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<ConversionCredit>;
}

/** A market credit notification */
export interface ConversionCreditNotification extends Node, NotificationInterface {
  __typename: 'ConversionCreditNotification';
  body: Scalars['String']['output'];
  conversionCredit?: Maybe<ConversionCredit>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  deeplinkUrl: Scalars['String']['output'];
  iconUrl: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  important: Scalars['Boolean']['output'];
  markdownBody: Scalars['String']['output'];
  name: Scalars['String']['output'];
  pictureUrl?: Maybe<Scalars['String']['output']>;
  read: Scalars['Boolean']['output'];
  sport?: Maybe<SportOrShared>;
  title: Scalars['String']['output'];
  user: CurrentUser;
}

/** Object that can be a purchase of a ConversionCredit */
export type ConversionCreditPurchase = TokenAuction | TokenPrimaryOffer;

/** A Conversion Credit Reward Config */
export interface ConversionCreditRewardConfig extends AnyRewardConfigInterface {
  __typename: 'ConversionCreditRewardConfig';
  boostedRewardConfigs?: Maybe<Array<CardPacksRewardConfig | CardRewardConfig | CardShardRewardConfig | CoinRewardConfig | ConversionCreditRewardConfig | DeliverableItemRewardConfig | ExperienceRewardConfig | InGameCurrencyRewardConfig | MonetaryRewardConfig | ProbabilisticBundleRewardConfig | ShopItemRewardConfig>>;
  id: Scalars['ID']['output'];
  maxDiscount: MonetaryAmount;
  percentageDiscount: Scalars['Float']['output'];
  poolSize: Scalars['Int']['output'];
  sharedPool: Scalars['Boolean']['output'];
}

export const ConversionCreditStatus = {
  CANCELLED: 'CANCELLED',
  CLAIMED: 'CLAIMED',
  CREATED: 'CREATED',
  EXPIRED: 'EXPIRED',
  RECLAIMED: 'RECLAIMED',
  USED: 'USED',
  USING: 'USING'
} as const;

export type ConversionCreditStatus = typeof ConversionCreditStatus[keyof typeof ConversionCreditStatus];
export interface CountByRarity {
  __typename: 'CountByRarity';
  count: Scalars['Int']['output'];
  rarity: Rarity;
}

/** A country */
export interface Country extends Node, WithSubscriptionsInterface {
  __typename: 'Country';
  /** Country code in ISO 3166-1 format. */
  code: Scalars['String']['output'];
  currentUserSubscription?: Maybe<EmailSubscription>;
  flagUrl: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  slug: Scalars['String']['output'];
  subscriptionsCount: Scalars['Int']['output'];
  threeLetterCode?: Maybe<Scalars['String']['output']>;
}


/** A country */
export interface CountryflagUrlArgs {
  shape?: InputMaybe<Scalars['String']['input']>;
  size?: InputMaybe<Scalars['Int']['input']>;
}

/** Some Stats */
export interface Counts {
  __typename: 'Counts';
  usersCount: Scalars['Int']['output'];
}

export const CraftClueBase = {
  BEST_STAR_RANK: 'BEST_STAR_RANK',
  COMPETITION: 'COMPETITION',
  COUNTRY: 'COUNTRY',
  DIVISION: 'DIVISION',
  FIFTY_FIFTY: 'FIFTY_FIFTY',
  POSITION: 'POSITION',
  SPECIAL_EVENT: 'SPECIAL_EVENT'
} as const;

export type CraftClueBase = typeof CraftClueBase[keyof typeof CraftClueBase];
export const CraftGameplayTier = {
  DNP: 'DNP',
  DNP_PLUS: 'DNP_PLUS',
  GOAT: 'GOAT',
  IMPACT: 'IMPACT',
  IMPACT_PLUS: 'IMPACT_PLUS',
  ROSTER: 'ROSTER',
  ROSTER_PLUS: 'ROSTER_PLUS',
  STAR: 'STAR',
  STAR_OR_GOAT: 'STAR_OR_GOAT',
  STAR_PLUS: 'STAR_PLUS'
} as const;

export type CraftGameplayTier = typeof CraftGameplayTier[keyof typeof CraftGameplayTier];
/** Autogenerated return type of CreateMutation. */
export interface CreateMutationPayload {
  __typename: 'CreateMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  currentUser?: Maybe<CurrentUser>;
  errors: Array<UserError>;
  oAuthApplication?: Maybe<OAuthApplication>;
}

/** Autogenerated return type of CreateOrUpdateSo5LineupMutation. */
export interface CreateOrUpdateSo5LineupMutationPayload {
  __typename: 'CreateOrUpdateSo5LineupMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  composeSessionId?: Maybe<Scalars['String']['output']>;
  currentUser?: Maybe<CurrentUser>;
  errors: Array<UserError>;
  so5LeaderboardContender?: Maybe<So5LeaderboardContender>;
  so5Lineup?: Maybe<So5Lineup>;
}

/** Credit Card */
export interface CreditCard {
  __typename: 'CreditCard';
  brand: CreditCardBrand;
  expMonth: Scalars['Int']['output'];
  expYear: Scalars['Int']['output'];
  last4: Scalars['String']['output'];
  type?: Maybe<CreditCardType>;
}

/** A credit card authorization request */
export type CreditCardAuthorizationRequest = MangopayCreditCardAuthorizationRequest | StripeCreditCardAuthorizationRequest;

export const CreditCardBrand = {
  /** American Express */
  AMERICAN_EXPRESS: 'AMERICAN_EXPRESS',
  /** Cartes Bancaires */
  CARTES_BANCAIRES: 'CARTES_BANCAIRES',
  /** Diners Club */
  DINERS_CLUB: 'DINERS_CLUB',
  /** Discover */
  DISCOVER: 'DISCOVER',
  /** JCB */
  JCB: 'JCB',
  /** Maestro */
  MAESTRO: 'MAESTRO',
  /** MasterCard */
  MASTERCARD: 'MASTERCARD',
  /** UnionPay */
  UNION_PAY: 'UNION_PAY',
  /** Unknown */
  UNKNOWN: 'UNKNOWN',
  /** UPI */
  UPI: 'UPI',
  /** Visa */
  VISA: 'VISA'
} as const;

export type CreditCardBrand = typeof CreditCardBrand[keyof typeof CreditCardBrand];
export const CreditCardType = {
  AMEX: 'AMEX',
  CB_VISA_MASTERCARD: 'CB_VISA_MASTERCARD',
  MAESTRO: 'MAESTRO'
} as const;

export type CreditCardType = typeof CreditCardType[keyof typeof CreditCardType];
/** An amount in wei or lamport and its cryptocurrency */
export interface CryptoAmountInput {
  amount: Scalars['String']['input'];
  currency: SupportedCurrency;
}

export const Cryptocurrency = {
  LAMPORT: 'LAMPORT',
  WEI: 'WEI'
} as const;

export type Cryptocurrency = typeof Cryptocurrency[keyof typeof Cryptocurrency];
export const Currency = {
  ETH: 'ETH',
  FIAT: 'FIAT'
} as const;

export type Currency = typeof Currency[keyof typeof Currency];
/** Current Sorare user */
export interface CurrentUser extends PublicUserInfoInterface, So5CurrentUserInterface, UserOffersInterface, UserSocialInterface, WithFavoriteInterface, WithNotifications, WithReferralsInterface {
  __typename: 'CurrentUser';
  accountEntries: UserAccountEntryConnection;
  active?: Maybe<Scalars['Boolean']['output']>;
  activePromotionalEventCompletion?: Maybe<PromotionalEventCompletion>;
  anyNotifications: NotificationInterfaceConnection;
  anyPlayer?: Maybe<BaseballPlayer | NBAPlayer | Player>;
  anyUserSportProfile?: Maybe<BaseballUserSportProfile | FootballUserSportProfile | NBAUserSportProfile>;
  apiKey?: Maybe<Scalars['String']['output']>;
  apiKeys: Array<ApiKey>;
  /** The `auction_reminders` field cannot be nested within a list. */
  auctionReminders: AuctionReminderConnection;
  authorizations: AuthorizationRequestConnection;
  /** Current user available balance, in wei. */
  availableBalance: Scalars['WeiAmount']['output'];
  /** Current user available balance for withdrawal, in wei. */
  availableBalanceForWithdrawal: Scalars['WeiAmount']['output'];
  availableBalances: AvailableBalances;
  availableRaffleTicketsCount: Scalars['Int']['output'];
  availableVoucher?: Maybe<PurchasableItemsVoucher>;
  bankWithdrawals: Array<BankWithdrawal>;
  baseballUserProfile?: Maybe<BaseballUserSportProfile>;
  betaTester: Scalars['Boolean']['output'];
  /** List of current user blockchain cards engaged in lineups (for live or upcoming fixtures) */
  blockchainCardsInLineups: Array<Scalars['String']['output']>;
  blockedUntil?: Maybe<Scalars['ISO8601DateTime']['output']>;
  blockedUsers: UserConnection;
  /** Get a list of all blueprint cards */
  blueprintCards: AnyCardInterfaceConnection;
  board: CareerBoard | SquadBoard;
  boards: Array<CareerBoard | SquadBoard>;
  boardsLineups: LineupInterfaceConnection;
  /** The `bookmarks` field cannot be nested within a list. */
  bookmarks: Array<BoardBookmark | So5LeaderboardBookmark>;
  /** The `bought_primary_offers` field cannot be nested within a list. */
  boughtPrimaryOffers: TokenPrimaryOfferConnection;
  /** The `bought_single_sale_token_offers` field cannot be nested within a list. */
  boughtSingleSaleTokenOffers: TokenOfferConnection;
  /** The `buying_token_auctions` field cannot be nested within a list. */
  buyingTokenAuctions: Array<TokenAuction>;
  calendarTasksTrack?: Maybe<CardsCountTargetTask | CardsCountTask | CompleteCollectionsCountTargetTask | CompleteCollectionsCountTask | DailyActionTask | DecisivePlayerPickerTask | DropChallengeTask | GameWeeklyTask | GuessTheScoreTask | InviteTaskAsReferrer | So5LeaderboardTask | StarPackTask | Task | TasksTrack | ThresholdPickerTask | ThresholdsDuoConnectionTask | ThresholdsStreakAdditionalLineupTask | ThresholdsStreakTask>;
  /** The `card_collections` field cannot be nested within a list. */
  cardCollections?: Maybe<CardCollectionConnection>;
  cardCounts: CardCount;
  cardFilters: Scalars['Json']['output'];
  cardPull?: Maybe<CardPull>;
  cardShardsChest: CardShardsChest;
  cardShardsChests: Array<CardShardsChest>;
  cardShardsHistoryTransactions: HistoryTransactionInterfaceConnection;
  /** Get a list of all cards */
  cards: AnyCardInterfaceConnection;
  cardsCount: Scalars['Int']['output'];
  /** Get the list of cards earned thanks to referrals */
  cardsReferralRewards: ReferralRewardConnection;
  claimablePacks: Array<Pack>;
  commonGemHistoryTransactions: InGameCurrencyTransactionConnection;
  /**
   * The `competition_card_collections` field cannot be nested within a list.
   * @deprecated No longer used
   */
  competitionCardCollections: Array<CompetitionCardCollections>;
  completablePromotionalEvent?: Maybe<DepositPromotionalEvent>;
  /** Whether the user confirmed their email */
  confirmed?: Maybe<Scalars['Boolean']['output']>;
  confirmedDevice: Scalars['Boolean']['output'];
  /** The `connected_o_auth_access_tokens` field cannot be nested within a list. */
  connectedOAuthAccessTokens?: Maybe<Array<OAuthAccessToken>>;
  /** The `connected_o_auth_applications` field cannot be nested within a list. */
  connectedOAuthApplications?: Maybe<Array<OAuthApplication>>;
  connectedOauths?: Maybe<Array<ConnectedOAuth>>;
  conversionCreditsMaxDiscount: MonetaryAmount;
  conversionCreditsSoonestExpiration?: Maybe<Scalars['ISO8601DateTime']['output']>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  cryptocurrency?: Maybe<Cryptocurrency>;
  /** Current device used for this query */
  currentDevice?: Maybe<UserDevice>;
  dailyRunTask?: Maybe<CardsCountTargetTask | CardsCountTask | CompleteCollectionsCountTargetTask | CompleteCollectionsCountTask | DailyActionTask | DecisivePlayerPickerTask | DropChallengeTask | GameWeeklyTask | GuessTheScoreTask | InviteTaskAsReferrer | So5LeaderboardTask | StarPackTask | Task | TasksTrack | ThresholdPickerTask | ThresholdsDuoConnectionTask | ThresholdsStreakAdditionalLineupTask | ThresholdsStreakTask>;
  depositPromotionalEvent?: Maybe<DepositPromotionalEvent>;
  depositedEth: Scalars['Boolean']['output'];
  /** Can only be retrieved from a confirmed device */
  devices?: Maybe<Array<UserDevice>>;
  eip7702Revocations: Array<Eip7702Revocation>;
  email: Scalars['String']['output'];
  endedTokenOffersReceived: TokenOfferConnection;
  endedTokenOffersSent: TokenOfferConnection;
  /** The `ended_with_no_buyer_single_sale_token_offers` field cannot be nested within a list. */
  endedWithNoBuyerSingleSaleTokenOffers: TokenOfferConnection;
  ethVaultId?: Maybe<Scalars['Int']['output']>;
  ethereumAddress?: Maybe<Scalars['EthereumAddress']['output']>;
  fastWithdrawals: Array<FastWithdrawal>;
  fastWithdrawalsWithRates: Array<FastWithdrawalWithRates>;
  featureFlagCustomAttributes: Scalars['Json']['output'];
  featuredTasks: Array<CardsCountTargetTask | CardsCountTask | CompleteCollectionsCountTargetTask | CompleteCollectionsCountTask | DailyActionTask | DecisivePlayerPickerTask | DropChallengeTask | GameWeeklyTask | GuessTheScoreTask | InviteTaskAsReferrer | So5LeaderboardTask | StarPackTask | Task | TasksTrack | ThresholdPickerTask | ThresholdsDuoConnectionTask | ThresholdsStreakAdditionalLineupTask | ThresholdsStreakTask>;
  fiatEnabled: Scalars['Boolean']['output'];
  followed?: Maybe<EmailSubscription>;
  /** The `followers` field cannot be nested within a list. */
  followers: UserWithSubscriptionSlugConnection;
  followersCount: Scalars['Int']['output'];
  /** The `following` field cannot be nested within a list. */
  following: UserWithSubscriptionSlugConnection;
  followingCount: Scalars['Int']['output'];
  footballLast30DaysLineupsCount: Scalars['Int']['output'];
  footballUserProfile?: Maybe<FootballUserSportProfile>;
  forcedIntoOnboarding: Scalars['Boolean']['output'];
  fromPath?: Maybe<Scalars['String']['output']>;
  /** @deprecated Not used anymore */
  hallOfFameSo5LeaderboardContenders?: Maybe<Array<So5LeaderboardContender>>;
  hasPassword: Scalars['Boolean']['output'];
  highScarcityStatus: HighScarcityStatuses;
  /**
   * Number of times the user won each step of the hot streak tracks of the game
   * mode. SET reads the career track of the active card set, or of the previous
   * card set when no set is active. PRO adds up the active career boards of the
   * sport, up to the longest board
   */
  hotStreakStepsWon: Array<StepWonCount>;
  /** Typical number of hours the manager takes to answer trades */
  hoursToAnswerTrades?: Maybe<Scalars['Int']['output']>;
  /**
   * Activities shared by the current user and the managers they follow, or by any
   * manager when a search is given The `hub_activities` field cannot be nested within a list.
   */
  hubActivities: ActivityFeedInterfaceConnection;
  id: Scalars['ID']['output'];
  inGameCurrencyBalances: Array<InGameCurrencyBalance>;
  inboxTasks: TaskInterfaceConnection;
  /** Link to share to invite managers to play on behalf of this referrer */
  inviteLink: Scalars['String']['output'];
  inviteTaskAsReferee?: Maybe<CardsCountTargetTask | CardsCountTask | CompleteCollectionsCountTargetTask | CompleteCollectionsCountTask | DailyActionTask | DecisivePlayerPickerTask | DropChallengeTask | GameWeeklyTask | GuessTheScoreTask | InviteTaskAsReferrer | So5LeaderboardTask | StarPackTask | Task | TasksTrack | ThresholdPickerTask | ThresholdsDuoConnectionTask | ThresholdsStreakAdditionalLineupTask | ThresholdsStreakTask>;
  inviteTasksAsReferee?: Maybe<Array<CardsCountTargetTask | CardsCountTask | CompleteCollectionsCountTargetTask | CompleteCollectionsCountTask | DailyActionTask | DecisivePlayerPickerTask | DropChallengeTask | GameWeeklyTask | GuessTheScoreTask | InviteTaskAsReferrer | So5LeaderboardTask | StarPackTask | Task | TasksTrack | ThresholdPickerTask | ThresholdsDuoConnectionTask | ThresholdsStreakAdditionalLineupTask | ThresholdsStreakTask>>;
  inviteTasksAsReferrer: Array<CardsCountTargetTask | CardsCountTask | CompleteCollectionsCountTargetTask | CompleteCollectionsCountTask | DailyActionTask | DecisivePlayerPickerTask | DropChallengeTask | GameWeeklyTask | GuessTheScoreTask | InviteTaskAsReferrer | So5LeaderboardTask | StarPackTask | Task | TasksTrack | ThresholdPickerTask | ThresholdsDuoConnectionTask | ThresholdsStreakAdditionalLineupTask | ThresholdsStreakTask>;
  /** The `involved_live_token_auctions` field cannot be nested within a list. */
  involvedLiveTokenAuctions: TokenAuctionConnection;
  /** The `involved_lost_token_auctions` field cannot be nested within a list. */
  involvedLostTokenAuctions: TokenAuctionConnection;
  /** The `involved_token_auctions` field cannot be nested within a list. */
  involvedTokenAuctions: TokenAuctionConnection;
  jonumVerification?: Maybe<Verification>;
  ladderLeaderboard: LadderLeaderboard;
  last30DaysLineupsCount: IntegerBySportType;
  /** Get the last notification created_at */
  lastNotificationCreatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /**
   * Latest activity shared by the managers the current user follows since they
   * last read the feed The `last_unread_activity` field cannot be nested within a list.
   */
  lastUnreadActivity?: Maybe<CardPackActivityFeed | LineupActivityFeed | OwnerActivityFeed>;
  /** Get the last unread notification created_at */
  lastUnreadNotificationCreatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** The `live_single_sale_token_offers` field cannot be nested within a list. */
  liveSingleSaleTokenOffers: TokenOfferConnection;
  loan?: Maybe<Loan>;
  loanableConfig?: Maybe<LoanableConfigRoot>;
  /** The `lost_token_auctions` field cannot be nested within a list. */
  lostTokenAuctions: TokenAuctionConnection;
  /** The `manager_teams` field cannot be nested within a list. */
  managerTeams: ManagerTeamConnection;
  mangopayUser?: Maybe<MangopayUser>;
  matchedContactsAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  moonpayParams: Scalars['String']['output'];
  moonpaySupported: Scalars['Boolean']['output'];
  mustAcceptTcus: Scalars['Boolean']['output'];
  myAccounts: Array<PrivateAccount>;
  /** Activities the current user shared The `my_activities` field cannot be nested within a list. */
  myActivities: ActivityFeedInterfaceConnection;
  myCart?: Maybe<Cart>;
  myRecentActiveBids: Array<TokenMyBid>;
  mySetDeliverableItemOrders: Array<DeliverableItemOrder>;
  mySubscriptions: EmailSubscriptionConnection;
  /**
   * Boosted rewards based on eligible reward configs The
   * `my_unclaimed_boosted_reward_configs_by_rarity` field cannot be nested within a list.
   */
  myUnclaimedBoostedRewardConfigsByRarity: Array<RarityRewardConfigs>;
  /** The `my_unclaimed_eligible_reward_configs` field cannot be nested within a list. */
  myUnclaimedEligibleRewardConfigs: Array<CardPacksRewardConfig | CardRewardConfig | CardShardRewardConfig | CoinRewardConfig | ConversionCreditRewardConfig | DeliverableItemRewardConfig | ExperienceRewardConfig | InGameCurrencyRewardConfig | MonetaryRewardConfig | ProbabilisticBundleRewardConfig | ShopItemRewardConfig>;
  myUnclaimedSetRaffleRewards: Array<AnyCardReward | AnyConversionCreditReward | CardPackReward | CardShardsReward | CoinReward | DeliverableItemReward | ExperienceReward | InGameCurrencyReward | MonetaryReward | ProbabilisticBundleReward | ShopItemReward>;
  myUnclaimedSo5RewardsNeedKycVerification: Scalars['Boolean']['output'];
  myUnclaimedSo5RewardsNeedPhoneVerification: Scalars['Boolean']['output'];
  myUnclaimedTasksCount: Scalars['Int']['output'];
  myWatchlists?: Maybe<Array<Watchlist>>;
  myWheelRewards: ProbabilisticBundleRewardConnection;
  nbaUserProfile?: Maybe<NBAUserSportProfile>;
  nickname: Scalars['String']['output'];
  /** If the current user can see the no card routes */
  noCardRouteEnabled: Scalars['Boolean']['output'];
  offRampBridgeAccount?: Maybe<OffRampBridgeAccount>;
  offRampEligible: Scalars['Boolean']['output'];
  onboardingConversionCredit?: Maybe<ConversionCredit>;
  /** @deprecated Not used anymore */
  onboardingTasks: Array<CardsCountTargetTask | CardsCountTask | CompleteCollectionsCountTargetTask | CompleteCollectionsCountTask | DailyActionTask | DecisivePlayerPickerTask | DropChallengeTask | GameWeeklyTask | GuessTheScoreTask | InviteTaskAsReferrer | So5LeaderboardTask | StarPackTask | Task | TasksTrack | ThresholdPickerTask | ThresholdsDuoConnectionTask | ThresholdsStreakAdditionalLineupTask | ThresholdsStreakTask>;
  otpRequiredForLogin: Scalars['Boolean']['output'];
  ownedOAuthApplications: Array<OAuthApplication>;
  ownedPlayersCount: Scalars['Int']['output'];
  packs: PackConnection;
  passkeys: Array<Passkey>;
  payByBankDepositEnabled: Scalars['Boolean']['output'];
  paymentMethods: Array<PaymentMethod>;
  /** Pending & recently failed deposits for the current user */
  pendingDeposits: Array<PendingDeposit>;
  pendingDirectWithdrawalCount: Scalars['Int']['output'];
  pendingSorareRefunds: Array<SorareRefund>;
  pendingTokenOffersReceived: TokenOfferConnection;
  pendingTokenOffersSent: TokenOfferConnection;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  phoneNumberVerificationRequested: Scalars['Boolean']['output'];
  phoneNumberVerified: Scalars['Boolean']['output'];
  pictureUrl?: Maybe<Scalars['String']['output']>;
  player?: Maybe<Player>;
  /**
   * The `podium_rankings` field cannot be nested within a list.
   * @deprecated Use so5_trophies_summary instead
   */
  podiumRankings: So5RankingConnection;
  /**
   * The `podiums` field cannot be nested within a list.
   * @deprecated Use so5_trophies_summary instead
   */
  podiums: Array<So5Podium>;
  /** Get the total of potential conversion credits to be earned thanks to pending referrals */
  potentialReferralConversionCredits: MonetaryAmount;
  probabilisticBundles: ProbabilisticBundleConnection;
  profile: UserProfile;
  /** The `public_watchlists` field cannot be nested within a list. */
  publicWatchlists?: Maybe<WatchlistConnection>;
  pulledCards: AnyCardInterfaceConnection;
  pushNotificationsSupported: Scalars['Boolean']['output'];
  rampSignedUrl?: Maybe<Scalars['String']['output']>;
  rampSupported: Scalars['Boolean']['output'];
  recentActiveBids: Array<TokenBid>;
  /** The `recommended_managers` field cannot be nested within a list. */
  recommendedManagers: UserConnection;
  referee: Scalars['Boolean']['output'];
  refereeRewards: Array<ReferralReward>;
  referralAsReferee?: Maybe<Referral>;
  referralRewardsCount: Scalars['Int']['output'];
  /** @deprecated Use inviteLink instead, which carries the acquisition attribution context. */
  referralUrl: Scalars['String']['output'];
  /** Get the list of referrals */
  referrals: ReferralPaginated;
  referrer?: Maybe<User>;
  referrerCode?: Maybe<Scalars['String']['output']>;
  referrerCodeDeadline?: Maybe<Scalars['ISO8601DateTime']['output']>;
  revealedCardsSummary: RevealedCardsSummary;
  /**
   * The `rewarded_rankings` field cannot be nested within a list.
   * @deprecated Use so5_trophies_summary instead
   */
  rewardedRankings: So5RankingConnection;
  rewards: AnyRewardInterfaceConnection;
  /** List of scopes the user has access to, returns "all" if the user has access to everything */
  scopes: Array<Scalars['String']['output']>;
  /** The `search_card_facet_values` field cannot be nested within a list. */
  searchCardFacetValues: Array<SearchFacetValue>;
  /** The `search_cards` field cannot be nested within a list. */
  searchCards: SearchCards;
  setBoard?: Maybe<CareerBoard | SquadBoard>;
  /** @deprecated Use setCollectionsTaskTracks instead */
  setCollectionTasks?: Maybe<Array<CardsCountTargetTask | CardsCountTask | CompleteCollectionsCountTargetTask | CompleteCollectionsCountTask | DailyActionTask | DecisivePlayerPickerTask | DropChallengeTask | GameWeeklyTask | GuessTheScoreTask | InviteTaskAsReferrer | So5LeaderboardTask | StarPackTask | Task | TasksTrack | ThresholdPickerTask | ThresholdsDuoConnectionTask | ThresholdsStreakAdditionalLineupTask | ThresholdsStreakTask>>;
  setCollectionsTaskTracks: Array<CardsCountTargetTask | CardsCountTask | CompleteCollectionsCountTargetTask | CompleteCollectionsCountTask | DailyActionTask | DecisivePlayerPickerTask | DropChallengeTask | GameWeeklyTask | GuessTheScoreTask | InviteTaskAsReferrer | So5LeaderboardTask | StarPackTask | Task | TasksTrack | ThresholdPickerTask | ThresholdsDuoConnectionTask | ThresholdsStreakAdditionalLineupTask | ThresholdsStreakTask>;
  /** @deprecated Use setPlayTasks instead */
  setDecisiveActionTask?: Maybe<CardsCountTargetTask | CardsCountTask | CompleteCollectionsCountTargetTask | CompleteCollectionsCountTask | DailyActionTask | DecisivePlayerPickerTask | DropChallengeTask | GameWeeklyTask | GuessTheScoreTask | InviteTaskAsReferrer | So5LeaderboardTask | StarPackTask | Task | TasksTrack | ThresholdPickerTask | ThresholdsDuoConnectionTask | ThresholdsStreakAdditionalLineupTask | ThresholdsStreakTask>;
  setEndOfSeasonTasks: Array<CardsCountTargetTask | CardsCountTask | CompleteCollectionsCountTargetTask | CompleteCollectionsCountTask | DailyActionTask | DecisivePlayerPickerTask | DropChallengeTask | GameWeeklyTask | GuessTheScoreTask | InviteTaskAsReferrer | So5LeaderboardTask | StarPackTask | Task | TasksTrack | ThresholdPickerTask | ThresholdsDuoConnectionTask | ThresholdsStreakAdditionalLineupTask | ThresholdsStreakTask>;
  setGuessTheScore?: Maybe<CardsCountTargetTask | CardsCountTask | CompleteCollectionsCountTargetTask | CompleteCollectionsCountTask | DailyActionTask | DecisivePlayerPickerTask | DropChallengeTask | GameWeeklyTask | GuessTheScoreTask | InviteTaskAsReferrer | So5LeaderboardTask | StarPackTask | Task | TasksTrack | ThresholdPickerTask | ThresholdsDuoConnectionTask | ThresholdsStreakAdditionalLineupTask | ThresholdsStreakTask>;
  /**
   * Live step of the set tasks track, falling back to the last claimed step The
   * `set_live_tasks_track_step` field cannot be nested within a list.
   */
  setLiveTasksTrackStep?: Maybe<CardsCountTargetTask | CardsCountTask | CompleteCollectionsCountTargetTask | CompleteCollectionsCountTask | DailyActionTask | DecisivePlayerPickerTask | DropChallengeTask | GameWeeklyTask | GuessTheScoreTask | InviteTaskAsReferrer | So5LeaderboardTask | StarPackTask | Task | TasksTrack | ThresholdPickerTask | ThresholdsDuoConnectionTask | ThresholdsStreakAdditionalLineupTask | ThresholdsStreakTask>;
  /**
   * Headline stats of the user for the active card set, or for the previous card
   * set when no set is active The `set_manager_profile_stats` field cannot be
   * nested within a list.
   */
  setManagerProfileStats: Array<BestScoreManagerProfileStat | CollectionCompletionManagerProfileStat>;
  /** @deprecated Not used anymore */
  setOnboardingTasks: Array<CardsCountTargetTask | CardsCountTask | CompleteCollectionsCountTargetTask | CompleteCollectionsCountTask | DailyActionTask | DecisivePlayerPickerTask | DropChallengeTask | GameWeeklyTask | GuessTheScoreTask | InviteTaskAsReferrer | So5LeaderboardTask | StarPackTask | Task | TasksTrack | ThresholdPickerTask | ThresholdsDuoConnectionTask | ThresholdsStreakAdditionalLineupTask | ThresholdsStreakTask>;
  setPlayTasks: Array<CardsCountTargetTask | CardsCountTask | CompleteCollectionsCountTargetTask | CompleteCollectionsCountTask | DailyActionTask | DecisivePlayerPickerTask | DropChallengeTask | GameWeeklyTask | GuessTheScoreTask | InviteTaskAsReferrer | So5LeaderboardTask | StarPackTask | Task | TasksTrack | ThresholdPickerTask | ThresholdsDuoConnectionTask | ThresholdsStreakAdditionalLineupTask | ThresholdsStreakTask>;
  setTasksTrack?: Maybe<TasksTrack>;
  setWelcomeOfferFeaturedSectionItem?: Maybe<FeaturedMarketSectionItem>;
  /** @deprecated Use setWelcomeOfferFeaturedSectionItem instead */
  setWelcomeOfferVoucher?: Maybe<PurchasableItemsVoucher>;
  shouldMigrateEth: Scalars['Boolean']['output'];
  shouldMigrateEthBeforeWithdrawal: Scalars['Boolean']['output'];
  shouldUseStarkwareEscapeHatch: Scalars['Boolean']['output'];
  /** @deprecated Always true */
  showMissionPage: Scalars['Boolean']['output'];
  /** The `single_sale_token_offers` field cannot be nested within a list. */
  singleSaleTokenOffers: TokenOfferConnection;
  slug: Scalars['String']['output'];
  /** If the so5 no card route is open for submission */
  so5NoCardRouteOpened: Scalars['Boolean']['output'];
  /** The `so5_trophies_summary` field cannot be nested within a list. */
  so5TrophiesSummary: TrophiesSummary;
  /** The `sold_single_sale_token_offers` field cannot be nested within a list. */
  soldSingleSaleTokenOffers: TokenOfferConnection;
  sorareAddress?: Maybe<Scalars['EthereumAddress']['output']>;
  sorareAddressBalance: Scalars['WeiAmount']['output'];
  /** Can only be retrieved from a confirmed device */
  sorarePrivateKey?: Maybe<SorarePrivateKey>;
  sorarePrivateKeyRecovery?: Maybe<Scalars['String']['output']>;
  spentFiatPaymentIntents: PaymentConnection;
  sportConversionCredits?: Maybe<ConversionCreditConnection>;
  /** Live Event Hub spotlights, in the order clients must display them */
  spotlights: Array<GenericSpotlight | So5CompetitionSpotlight>;
  squad?: Maybe<Squad>;
  starkKey?: Maybe<Scalars['String']['output']>;
  /** Number of the user's cards on Starkware, capped at 5,001: a value of 5,001 means more than 5,000. */
  starkwareCardsCount: Scalars['Int']['output'];
  starkwareEscapeHatch?: Maybe<StarkwareEscapeHatch>;
  status?: Maybe<Scalars['String']['output']>;
  step: CareerProStep | CareerStep | SquadStep;
  /** Set to true if the user deleted his account or was suspended */
  suspended: Scalars['Boolean']['output'];
  task: CardsCountTargetTask | CardsCountTask | CompleteCollectionsCountTargetTask | CompleteCollectionsCountTask | DailyActionTask | DecisivePlayerPickerTask | DropChallengeTask | GameWeeklyTask | GuessTheScoreTask | InviteTaskAsReferrer | So5LeaderboardTask | StarPackTask | Task | TasksTrack | ThresholdPickerTask | ThresholdsDuoConnectionTask | ThresholdsStreakAdditionalLineupTask | ThresholdsStreakTask;
  taskCampaign: TaskCampaign;
  taskConfig: TaskConfig;
  taskGroup: TaskGroup;
  taskGroups: Array<TaskGroup>;
  tasks: Array<CardsCountTargetTask | CardsCountTask | CompleteCollectionsCountTargetTask | CompleteCollectionsCountTask | DailyActionTask | DecisivePlayerPickerTask | DropChallengeTask | GameWeeklyTask | GuessTheScoreTask | InviteTaskAsReferrer | So5LeaderboardTask | StarPackTask | Task | TasksTrack | ThresholdPickerTask | ThresholdsDuoConnectionTask | ThresholdsStreakAdditionalLineupTask | ThresholdsStreakTask>;
  tasksTracks: Array<TasksTrack>;
  /** Time left in seconds to confirm email */
  timeLeftForConfirmation?: Maybe<Scalars['Int']['output']>;
  /** The `token_auctions` field cannot be nested within a list. */
  tokenAuctions: TokenAuctionConnection;
  tokenOffers: TokenOfferConnection;
  /** @deprecated Not used anymore */
  topPerformingLineups: So5LineupConnection;
  /** Current user total balance, in wei. */
  totalBalance: Scalars['WeiAmount']['output'];
  totalPlayersCount: Scalars['Int']['output'];
  /** Get the total of conversion credits earned thanks to referrals */
  totalReferralConversionCreditsEarned: MonetaryAmount;
  /** The `trades` field cannot be nested within a list. */
  trades: TokenDealConnection;
  /**
   * The `trophies` field cannot be nested within a list.
   * @deprecated Use so5_trophies_summary instead
   */
  trophies: Array<So5Trophies>;
  unclaimedDeliverableItemOrders: Array<DeliverableItemOrder>;
  unclaimedInboxTasksCount: Scalars['Int']['output'];
  unclaimedReferralRewardsCount: Scalars['Int']['output'];
  unclaimedSo5Rewards: Array<So5Reward>;
  unconfirmedEmail?: Maybe<Scalars['String']['output']>;
  unopenedProbabilisticBundles: ProbabilisticBundleConnection;
  /**
   * Activities shared by the managers the current user follows since they last
   * read the feed The `unread_hub_activities_count` field cannot be nested within a list.
   */
  unreadHubActivitiesCount: Scalars['Int']['output'];
  unreadNotificationsCount: Scalars['Int']['output'];
  unverifiedPhoneNumber?: Maybe<Scalars['String']['output']>;
  userCardCollectionsPresence: Scalars['Boolean']['output'];
  /** The `user_relations` field cannot be nested within a list. */
  userRelations: UserRelationConnection;
  userSettings: UserSettings;
  wallet?: Maybe<UserWallet>;
  warningFlags: Array<UserFlag>;
  withdrawOnBase: Scalars['Boolean']['output'];
  withdrawals: Array<Withdrawal>;
  withdrawalsWithRates: Array<WithdrawalWithRates>;
  /** The `won_token_auctions` field cannot be nested within a list. */
  wonTokenAuctions: TokenAuctionConnection;
}


/** Current Sorare user */
export interface CurrentUseraccountEntriesArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  currencies?: InputMaybe<Array<SupportedCurrency>>;
  currencyType?: InputMaybe<Currency>;
  endDate?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  entryType?: InputMaybe<Array<UserAccountEntryEntry>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  significant?: InputMaybe<Scalars['Boolean']['input']>;
  sortType?: InputMaybe<SortingOption>;
  startDate?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
}


/** Current Sorare user */
export interface CurrentUseranyNotificationsArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  categories?: InputMaybe<Array<NotificationCategoryInput>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sections?: InputMaybe<Array<Scalars['String']['input']>>;
  sports?: InputMaybe<Array<Sport>>;
  subsections?: InputMaybe<Array<Scalars['String']['input']>>;
}


/** Current Sorare user */
export interface CurrentUseranyUserSportProfileArgs {
  sport: Sport;
  variant?: InputMaybe<UserSportProfileVariant>;
}


/** Current Sorare user */
export interface CurrentUserauctionRemindersArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
}


/** Current Sorare user */
export interface CurrentUserauthorizationsArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sortType?: InputMaybe<SortingOption>;
  startDate?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
}


/** Current Sorare user */
export interface CurrentUseravailableRaffleTicketsCountArgs {
  sport?: InputMaybe<Sport>;
}


/** Current Sorare user */
export interface CurrentUseravailableVoucherArgs {
  gameMode?: InputMaybe<PlatformGameMode>;
  so5Competition?: InputMaybe<Scalars['String']['input']>;
  sport: Sport;
}


/** Current Sorare user */
export interface CurrentUserblockchainCardsInLineupsArgs {
  sport?: InputMaybe<Sport>;
}


/** Current Sorare user */
export interface CurrentUserblockedUsersArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
}


/** Current Sorare user */
export interface CurrentUserblueprintCardsArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  age?: InputMaybe<Scalars['Int']['input']>;
  assetIds?: InputMaybe<Array<Scalars['String']['input']>>;
  before?: InputMaybe<Scalars['String']['input']>;
  classicOnly?: InputMaybe<Scalars['Boolean']['input']>;
  customCardEditionName?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  inActiveCompetitions?: InputMaybe<Array<Scalars['String']['input']>>;
  inSeasonEligible?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  owned?: InputMaybe<Scalars['Boolean']['input']>;
  ownedByMe?: InputMaybe<Scalars['Boolean']['input']>;
  ownedSinceAfter?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  playerSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  positions?: InputMaybe<Array<Position>>;
  rarities?: InputMaybe<Array<Rarity>>;
  revealable?: InputMaybe<Scalars['Boolean']['input']>;
  seasonStartYears?: InputMaybe<Array<Scalars['Int']['input']>>;
  serialNumber?: InputMaybe<Scalars['Int']['input']>;
  shirtNumber?: InputMaybe<Scalars['Int']['input']>;
  slugs?: InputMaybe<Array<Scalars['String']['input']>>;
  sorts?: InputMaybe<Array<CardSort>>;
  sport?: InputMaybe<Sport>;
  teamSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  withinDeckFirst?: InputMaybe<Scalars['String']['input']>;
}


/** Current Sorare user */
export interface CurrentUserboardArgs {
  configSlug?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
}


/** Current Sorare user */
export interface CurrentUserboardsArgs {
  engaged?: InputMaybe<Scalars['Boolean']['input']>;
  mode: BoardMode;
  rarities?: InputMaybe<Array<Rarity>>;
  rarity?: InputMaybe<Rarity>;
  so5Competition?: InputMaybe<Scalars['String']['input']>;
  sport: Sport;
}


/** Current Sorare user */
export interface CurrentUserboardsLineupsArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  mode: BoardMode;
  rarity?: InputMaybe<Rarity>;
  sport: Sport;
}


/** Current Sorare user */
export interface CurrentUserbookmarksArgs {
  sport: Sport;
}


/** Current Sorare user */
export interface CurrentUserboughtPrimaryOffersArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sortByEndDate?: InputMaybe<SortingOption>;
  sport?: InputMaybe<Array<Sport>>;
}


/** Current Sorare user */
export interface CurrentUserboughtSingleSaleTokenOffersArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sortByEndDate?: InputMaybe<SortingOption>;
  sport?: InputMaybe<Array<Sport>>;
}


/** Current Sorare user */
export interface CurrentUserbuyingTokenAuctionsArgs {
  newlyListed?: InputMaybe<Scalars['Boolean']['input']>;
  sport?: InputMaybe<Array<Sport>>;
}


/** Current Sorare user */
export interface CurrentUsercalendarTasksTrackArgs {
  sport: Sport;
}


/** Current Sorare user */
export interface CurrentUsercardCollectionsArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  cardSetSlug?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forCompetitions?: InputMaybe<Array<Scalars['String']['input']>>;
  inSeasonOnly?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  rarities?: InputMaybe<Array<InputMaybe<Rarity>>>;
  seasonStartYears?: InputMaybe<Array<Scalars['Int']['input']>>;
  sortType?: InputMaybe<CardCollectionSortingOption>;
  sport?: InputMaybe<Sport>;
  startedOnly?: InputMaybe<Scalars['Boolean']['input']>;
  teamSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
}


/** Current Sorare user */
export interface CurrentUsercardCountsArgs {
  sport: Sport;
}


/** Current Sorare user */
export interface CurrentUsercardFiltersArgs {
  sport: Sport;
}


/** Current Sorare user */
export interface CurrentUsercardPullArgs {
  sport: Sport;
}


/** Current Sorare user */
export interface CurrentUsercardShardsChestArgs {
  id: Scalars['ID']['input'];
}


/** Current Sorare user */
export interface CurrentUsercardShardsChestsArgs {
  cardSetSlug?: InputMaybe<Scalars['String']['input']>;
  rarities?: InputMaybe<Array<Rarity>>;
  spent?: InputMaybe<Scalars['Boolean']['input']>;
  sport: Sport;
}


/** Current Sorare user */
export interface CurrentUsercardShardsHistoryTransactionsArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filterBy?: InputMaybe<CardShardsHistoryTransactionFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<SortingOption>;
  rarity: Rarity;
  sport: Sport;
}


/** Current Sorare user */
export interface CurrentUsercardsArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  age?: InputMaybe<Scalars['Int']['input']>;
  assetIds?: InputMaybe<Array<Scalars['String']['input']>>;
  before?: InputMaybe<Scalars['String']['input']>;
  classicOnly?: InputMaybe<Scalars['Boolean']['input']>;
  customCardEditionName?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  inActiveCompetitions?: InputMaybe<Array<Scalars['String']['input']>>;
  inSeasonEligible?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  owned?: InputMaybe<Scalars['Boolean']['input']>;
  ownedByMe?: InputMaybe<Scalars['Boolean']['input']>;
  ownedSinceAfter?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  playerSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  positions?: InputMaybe<Array<Position>>;
  rarities?: InputMaybe<Array<Rarity>>;
  revealable?: InputMaybe<Scalars['Boolean']['input']>;
  seasonStartYears?: InputMaybe<Array<Scalars['Int']['input']>>;
  serialNumber?: InputMaybe<Scalars['Int']['input']>;
  shirtNumber?: InputMaybe<Scalars['Int']['input']>;
  slugs?: InputMaybe<Array<Scalars['String']['input']>>;
  sorts?: InputMaybe<Array<CardSort>>;
  sport?: InputMaybe<Sport>;
  teamSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  transferredOutAfter?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  withinDeckFirst?: InputMaybe<Scalars['String']['input']>;
}


/** Current Sorare user */
export interface CurrentUsercardsReferralRewardsArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sport: Sport;
}


/** Current Sorare user */
export interface CurrentUserclaimablePacksArgs {
  sport: Sport;
}


/** Current Sorare user */
export interface CurrentUsercommonGemHistoryTransactionsArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
}


/** Current Sorare user */
export interface CurrentUsercompetitionCardCollectionsArgs {
  cardSetSlug: Scalars['String']['input'];
  competitionSlug?: InputMaybe<Scalars['String']['input']>;
  competitionSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  sport: Sport;
}


/** Current Sorare user */
export interface CurrentUserconversionCreditsMaxDiscountArgs {
  sport?: InputMaybe<Sport>;
}


/** Current Sorare user */
export interface CurrentUserconversionCreditsSoonestExpirationArgs {
  sport?: InputMaybe<Sport>;
}


/** Current Sorare user */
export interface CurrentUserdailyRunTaskArgs {
  sport: Sport;
}


/** Current Sorare user */
export interface CurrentUserendedTokenOffersReceivedArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sortType?: InputMaybe<SortingOption>;
  sport?: InputMaybe<Array<Sport>>;
  states?: InputMaybe<Array<OfferState>>;
}


/** Current Sorare user */
export interface CurrentUserendedTokenOffersSentArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sortType?: InputMaybe<SortingOption>;
  sport?: InputMaybe<Array<Sport>>;
  states?: InputMaybe<Array<OfferState>>;
}


/** Current Sorare user */
export interface CurrentUserendedWithNoBuyerSingleSaleTokenOffersArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sortByEndDate?: InputMaybe<SortingOption>;
  sport?: InputMaybe<Array<Sport>>;
}


/** Current Sorare user */
export interface CurrentUserfeaturedTasksArgs {
  rarity?: InputMaybe<Rarity>;
  sport: Sport;
}


/** Current Sorare user */
export interface CurrentUserfollowersArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
}


/** Current Sorare user */
export interface CurrentUserfollowingArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
}


/** Current Sorare user */
export interface CurrentUserfootballUserProfileArgs {
  variant?: InputMaybe<UserSportProfileVariant>;
}


/** Current Sorare user */
export interface CurrentUserforcedIntoOnboardingArgs {
  sport?: InputMaybe<Sport>;
}


/** Current Sorare user */
export interface CurrentUserhallOfFameSo5LeaderboardContendersArgs {
  rarity?: InputMaybe<Rarity>;
  seasonStartYear: Scalars['Int']['input'];
  sport: Sport;
}


/** Current Sorare user */
export interface CurrentUserhotStreakStepsWonArgs {
  configSlug?: InputMaybe<Scalars['String']['input']>;
  gameMode: PlatformGameMode;
  sport: Sport;
}


/** Current Sorare user */
export interface CurrentUserhubActivitiesArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  gameMode?: InputMaybe<PlatformGameMode>;
  last?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sport?: InputMaybe<Sport>;
}


/** Current Sorare user */
export interface CurrentUserinGameCurrencyBalancesArgs {
  inGameCurrencies?: InputMaybe<Array<InGameCurrency>>;
  sport: Sport;
}


/** Current Sorare user */
export interface CurrentUserinboxTasksArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sport: Sport;
}


/** Current Sorare user */
export interface CurrentUserinviteLinkArgs {
  gameMode: PlatformGameMode;
  sport: Sport;
}


/** Current Sorare user */
export interface CurrentUserinviteTaskAsRefereeArgs {
  sport: Sport;
}


/** Current Sorare user */
export interface CurrentUserinviteTasksAsRefereeArgs {
  sport: Sport;
}


/** Current Sorare user */
export interface CurrentUserinviteTasksAsReferrerArgs {
  sport: Sport;
}


/** Current Sorare user */
export interface CurrentUserinvolvedLiveTokenAuctionsArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  newlyListed?: InputMaybe<Scalars['Boolean']['input']>;
  sortByEndDate?: InputMaybe<SortingOption>;
  sport?: InputMaybe<Array<Sport>>;
}


/** Current Sorare user */
export interface CurrentUserinvolvedLostTokenAuctionsArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sortByEndDate?: InputMaybe<SortingOption>;
  sport?: InputMaybe<Array<Sport>>;
}


/** Current Sorare user */
export interface CurrentUserinvolvedTokenAuctionsArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sortByEndDate?: InputMaybe<SortingOption>;
  sport?: InputMaybe<Array<Sport>>;
}


/** Current Sorare user */
export interface CurrentUserladderLeaderboardArgs {
  slug: Scalars['String']['input'];
}


/** Current Sorare user */
export interface CurrentUserlastUnreadActivityArgs {
  gameMode?: InputMaybe<PlatformGameMode>;
  sport: Sport;
}


/** Current Sorare user */
export interface CurrentUserliveSingleSaleTokenOffersArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sortByEndDate?: InputMaybe<SortingOption>;
  sport?: InputMaybe<Array<Sport>>;
}


/** Current Sorare user */
export interface CurrentUserlostTokenAuctionsArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sortByEndDate?: InputMaybe<SortingOption>;
  sport?: InputMaybe<Array<Sport>>;
}


/** Current Sorare user */
export interface CurrentUsermanagerTeamsArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
}


/** Current Sorare user */
export interface CurrentUsermyActivitiesArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  gameMode?: InputMaybe<PlatformGameMode>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sport?: InputMaybe<Sport>;
}


/** Current Sorare user */
export interface CurrentUsermyCartArgs {
  sport: Sport;
}


/** Current Sorare user */
export interface CurrentUsermySetDeliverableItemOrdersArgs {
  sport: Sport;
}


/** Current Sorare user */
export interface CurrentUsermySubscriptionsArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sortType?: InputMaybe<SortingOption>;
  types?: InputMaybe<Array<SubscribableType>>;
}


/** Current Sorare user */
export interface CurrentUsermyUnclaimedBoostedRewardConfigsByRarityArgs {
  sport: Sport;
}


/** Current Sorare user */
export interface CurrentUsermyUnclaimedEligibleRewardConfigsArgs {
  multiplyBaseRewards?: InputMaybe<Scalars['Boolean']['input']>;
  sport: Sport;
}


/** Current Sorare user */
export interface CurrentUsermyUnclaimedSetRaffleRewardsArgs {
  sport: Sport;
}


/** Current Sorare user */
export interface CurrentUsermyUnclaimedSo5RewardsNeedKycVerificationArgs {
  sport: Sport;
}


/** Current Sorare user */
export interface CurrentUsermyUnclaimedSo5RewardsNeedPhoneVerificationArgs {
  sport: Sport;
}


/** Current Sorare user */
export interface CurrentUsermyUnclaimedTasksCountArgs {
  group?: InputMaybe<Scalars['String']['input']>;
  rarity?: InputMaybe<Rarity>;
  sport: Sport;
}


/** Current Sorare user */
export interface CurrentUsermyWatchlistsArgs {
  filter?: InputMaybe<WatchlistFilter>;
  query?: InputMaybe<Scalars['String']['input']>;
  sport: Sport;
}


/** Current Sorare user */
export interface CurrentUsermyWheelRewardsArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  rarity?: InputMaybe<Rarity>;
  sortType?: InputMaybe<SortingOption>;
  sport: Sport;
}


/** Current Sorare user */
export interface CurrentUseronboardingConversionCreditArgs {
  sport: Sport;
}


/** Current Sorare user */
export interface CurrentUseronboardingTasksArgs {
  sport: Sport;
}


/** Current Sorare user */
export interface CurrentUserownedPlayersCountArgs {
  cardSetSlug: Scalars['String']['input'];
  sport: Sport;
}


/** Current Sorare user */
export interface CurrentUserpacksArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sport: Sport;
}


/** Current Sorare user */
export interface CurrentUserpaymentMethodsArgs {
  provider?: InputMaybe<PaymentMethodProvider>;
}


/** Current Sorare user */
export interface CurrentUserpendingTokenOffersReceivedArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sortType?: InputMaybe<SortingOption>;
  sport?: InputMaybe<Array<Sport>>;
}


/** Current Sorare user */
export interface CurrentUserpendingTokenOffersSentArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sortType?: InputMaybe<SortingOption>;
  sport?: InputMaybe<Array<Sport>>;
}


/** Current Sorare user */
export interface CurrentUserpictureUrlArgs {
  derivative?: InputMaybe<Scalars['String']['input']>;
}


/** Current Sorare user */
export interface CurrentUserpodiumRankingsArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  ranking?: InputMaybe<Scalars['Int']['input']>;
  so5LeaderboardType?: InputMaybe<So5LeaderboardType>;
  sport?: InputMaybe<Sport>;
}


/** Current Sorare user */
export interface CurrentUserpodiumsArgs {
  sport?: InputMaybe<Sport>;
}


/** Current Sorare user */
export interface CurrentUserpotentialReferralConversionCreditsArgs {
  sport: Sport;
}


/** Current Sorare user */
export interface CurrentUserprobabilisticBundlesArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sortType?: InputMaybe<SortingOption>;
  sport?: InputMaybe<Sport>;
}


/** Current Sorare user */
export interface CurrentUserpublicWatchlistsArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sport: Sport;
}


/** Current Sorare user */
export interface CurrentUserpulledCardsArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sport?: InputMaybe<Sport>;
}


/** Current Sorare user */
export interface CurrentUserrecommendedManagersArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sport?: InputMaybe<Sport>;
}


/** Current Sorare user */
export interface CurrentUserreferralAsRefereeArgs {
  sport?: InputMaybe<Sport>;
}


/** Current Sorare user */
export interface CurrentUserreferralsArgs {
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  sport?: InputMaybe<Sport>;
  state?: InputMaybe<ReferralState>;
}


/** Current Sorare user */
export interface CurrentUserrevealedCardsSummaryArgs {
  seasonStartYear: Scalars['Int']['input'];
  sport: Sport;
}


/** Current Sorare user */
export interface CurrentUserrewardedRankingsArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  so5LeaderboardType?: InputMaybe<So5LeaderboardType>;
  sport?: InputMaybe<Sport>;
}


/** Current Sorare user */
export interface CurrentUserrewardsArgs {
  aasmState?: InputMaybe<RewardState>;
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sport?: InputMaybe<Sport>;
}


/** Current Sorare user */
export interface CurrentUsersearchCardFacetValuesArgs {
  advancedFilters?: InputMaybe<Scalars['String']['input']>;
  cardSetSlug?: InputMaybe<Scalars['String']['input']>;
  facetQuery: Scalars['String']['input'];
  field: Scalars['String']['input'];
  filters?: InputMaybe<Array<SearchFilterInput>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  rarity?: InputMaybe<Rarity>;
  refinements?: InputMaybe<Array<SearchRefinementInput>>;
  sport?: InputMaybe<Sport>;
}


/** Current Sorare user */
export interface CurrentUsersearchCardsArgs {
  advancedFilters?: InputMaybe<Scalars['String']['input']>;
  cardSetSlug?: InputMaybe<Scalars['String']['input']>;
  duplicatedKey?: InputMaybe<Scalars['String']['input']>;
  facets?: InputMaybe<Array<SearchFacetDefinitionInput>>;
  filters?: InputMaybe<Array<SearchFilterInput>>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  rarity?: InputMaybe<Rarity>;
  refinements?: InputMaybe<Array<SearchRefinementInput>>;
  sorts?: InputMaybe<Array<SearchSortInput>>;
  sport?: InputMaybe<Sport>;
}


/** Current Sorare user */
export interface CurrentUsersetBoardArgs {
  mode: BoardMode;
  sport: Sport;
}


/** Current Sorare user */
export interface CurrentUsersetCollectionTasksArgs {
  sport: Sport;
}


/** Current Sorare user */
export interface CurrentUsersetCollectionsTaskTracksArgs {
  first?: InputMaybe<Scalars['Int']['input']>;
  sport: Sport;
}


/** Current Sorare user */
export interface CurrentUsersetDecisiveActionTaskArgs {
  sport: Sport;
}


/** Current Sorare user */
export interface CurrentUsersetEndOfSeasonTasksArgs {
  sport: Sport;
}


/** Current Sorare user */
export interface CurrentUsersetGuessTheScoreArgs {
  sport: Sport;
}


/** Current Sorare user */
export interface CurrentUsersetLiveTasksTrackStepArgs {
  sport: Sport;
}


/** Current Sorare user */
export interface CurrentUsersetManagerProfileStatsArgs {
  sport: Sport;
}


/** Current Sorare user */
export interface CurrentUsersetOnboardingTasksArgs {
  sport: Sport;
}


/** Current Sorare user */
export interface CurrentUsersetPlayTasksArgs {
  first?: InputMaybe<Scalars['Int']['input']>;
  sport: Sport;
}


/** Current Sorare user */
export interface CurrentUsersetTasksTrackArgs {
  sport: Sport;
}


/** Current Sorare user */
export interface CurrentUsersetWelcomeOfferFeaturedSectionItemArgs {
  sport: Sport;
}


/** Current Sorare user */
export interface CurrentUsersetWelcomeOfferVoucherArgs {
  sport: Sport;
}


/** Current Sorare user */
export interface CurrentUsershowMissionPageArgs {
  sport: Sport;
}


/** Current Sorare user */
export interface CurrentUsersingleSaleTokenOffersArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sortByEndDate?: InputMaybe<SortingOption>;
  sport?: InputMaybe<Array<Sport>>;
}


/** Current Sorare user */
export interface CurrentUserso5NoCardRouteOpenedArgs {
  sport?: InputMaybe<Sport>;
}


/** Current Sorare user */
export interface CurrentUserso5TrophiesSummaryArgs {
  sport?: InputMaybe<Sport>;
}


/** Current Sorare user */
export interface CurrentUsersoldSingleSaleTokenOffersArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sortByEndDate?: InputMaybe<SortingOption>;
  sport?: InputMaybe<Array<Sport>>;
}


/** Current Sorare user */
export interface CurrentUserspentFiatPaymentIntentsArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sortType?: InputMaybe<SortingOption>;
  startDate?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
}


/** Current Sorare user */
export interface CurrentUsersportConversionCreditsArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  includeUsing?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sport?: InputMaybe<Sport>;
}


/** Current Sorare user */
export interface CurrentUserspotlightsArgs {
  sport?: InputMaybe<Sport>;
}


/** Current Sorare user */
export interface CurrentUsersquadArgs {
  sport: Sport;
}


/** Current Sorare user */
export interface CurrentUserstepArgs {
  id: Scalars['String']['input'];
}


/** Current Sorare user */
export interface CurrentUsertaskArgs {
  bypassRebuildCollectionTask?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['ID']['input'];
}


/** Current Sorare user */
export interface CurrentUsertaskCampaignArgs {
  slug: Scalars['String']['input'];
}


/** Current Sorare user */
export interface CurrentUsertaskConfigArgs {
  slug: Scalars['String']['input'];
}


/** Current Sorare user */
export interface CurrentUsertaskGroupArgs {
  slug: Scalars['String']['input'];
}


/** Current Sorare user */
export interface CurrentUsertasksArgs {
  periodicity: ManagerTaskPeriodicity;
  sport: Sport;
}


/** Current Sorare user */
export interface CurrentUsertasksTracksArgs {
  rarity?: InputMaybe<Rarity>;
  sport: Sport;
}


/** Current Sorare user */
export interface CurrentUsertokenAuctionsArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sortByEndDate?: InputMaybe<SortingOption>;
  sport?: InputMaybe<Array<Sport>>;
}


/** Current Sorare user */
export interface CurrentUsertokenOffersArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  direction: OfferDirection;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sortType?: InputMaybe<SortingOption>;
  sport?: InputMaybe<Array<Sport>>;
  states?: InputMaybe<Array<OfferState>>;
}


/** Current Sorare user */
export interface CurrentUsertopPerformingLineupsArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sport: Sport;
}


/** Current Sorare user */
export interface CurrentUsertotalPlayersCountArgs {
  cardSetSlug: Scalars['String']['input'];
  sport: Sport;
}


/** Current Sorare user */
export interface CurrentUsertotalReferralConversionCreditsEarnedArgs {
  sport: Sport;
}


/** Current Sorare user */
export interface CurrentUsertradesArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sortByEndDate?: InputMaybe<SortingOption>;
  sport?: InputMaybe<Array<Sport>>;
}


/** Current Sorare user */
export interface CurrentUsertrophiesArgs {
  sport?: InputMaybe<Sport>;
}


/** Current Sorare user */
export interface CurrentUserunclaimedDeliverableItemOrdersArgs {
  deliverableItemId?: InputMaybe<Scalars['ID']['input']>;
  sport?: InputMaybe<Sport>;
}


/** Current Sorare user */
export interface CurrentUserunclaimedInboxTasksCountArgs {
  sport: Sport;
}


/** Current Sorare user */
export interface CurrentUserunclaimedSo5RewardsArgs {
  sport?: InputMaybe<Sport>;
}


/** Current Sorare user */
export interface CurrentUserunopenedProbabilisticBundlesArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  design?: InputMaybe<ProbabilisticBundleDesign>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  rarity?: InputMaybe<Rarity>;
  sport?: InputMaybe<Sport>;
}


/** Current Sorare user */
export interface CurrentUserunreadHubActivitiesCountArgs {
  gameMode?: InputMaybe<PlatformGameMode>;
  sport?: InputMaybe<Sport>;
}


/** Current Sorare user */
export interface CurrentUserunreadNotificationsCountArgs {
  categories?: InputMaybe<Array<NotificationCategoryInput>>;
  sports?: InputMaybe<Array<Sport>>;
}


/** Current Sorare user */
export interface CurrentUseruserCardCollectionsPresenceArgs {
  rarity: Rarity;
  sport: Sport;
}


/** Current Sorare user */
export interface CurrentUseruserRelationsArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  knownUserOnly?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
}


/** Current Sorare user */
export interface CurrentUserwonTokenAuctionsArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sortByEndDate?: InputMaybe<SortingOption>;
  sport?: InputMaybe<Array<Sport>>;
}

/** Autogenerated return type of CurrentUserTaskWasUpdated. */
export interface CurrentUserTaskWasUpdatedPayload {
  __typename: 'CurrentUserTaskWasUpdatedPayload';
  previousProgress?: Maybe<Scalars['Int']['output']>;
  task: CardsCountTargetTask | CardsCountTask | CompleteCollectionsCountTargetTask | CompleteCollectionsCountTask | DailyActionTask | DecisivePlayerPickerTask | DropChallengeTask | GameWeeklyTask | GuessTheScoreTask | InviteTaskAsReferrer | So5LeaderboardTask | StarPackTask | Task | TasksTrack | ThresholdPickerTask | ThresholdsDuoConnectionTask | ThresholdsStreakAdditionalLineupTask | ThresholdsStreakTask;
}

export const CustomRewardExperience = {
  EVENT: 'EVENT',
  JERSEY: 'JERSEY',
  MERCH: 'MERCH',
  TICKET: 'TICKET'
} as const;

export type CustomRewardExperience = typeof CustomRewardExperience[keyof typeof CustomRewardExperience];
export const CustomSortingOption = {
  CUSTOM: 'CUSTOM',
  DEFAULT: 'DEFAULT'
} as const;

export type CustomSortingOption = typeof CustomSortingOption[keyof typeof CustomSortingOption];
export interface DailyActionTask extends ManagerTaskInterface, TaskInterface {
  __typename: 'DailyActionTask';
  aasmState: ManagerProgressionTaskState;
  alternativeRewardConfigs?: Maybe<Array<AlternativeRewardConfig>>;
  /** @deprecated Not used anymore */
  cards: Array<BaseballCard | Card | NBACard>;
  claimableAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** @deprecated Not used anymore */
  claimedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  color?: Maybe<Scalars['String']['output']>;
  completedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  description: Scalars['String']['output'];
  expired: Scalars['Boolean']['output'];
  genre: TaskGenre;
  group?: Maybe<TaskGroup>;
  iconUrl?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  jonumGated: Scalars['Boolean']['output'];
  /** The points this task earned on a ladder leaderboard, empty when it feeds none. */
  ladderContributions: Array<LadderContribution>;
  liveScore: Scalars['Int']['output'];
  /** The `my_reward_pool_shares` field cannot be nested within a list. */
  myRewardPoolShares?: Maybe<Array<RewardPoolShare>>;
  name: ManagerProgressionTaskSlug;
  parentTask?: Maybe<CardsCountTargetTask | CardsCountTask | CompleteCollectionsCountTargetTask | CompleteCollectionsCountTask | DailyActionTask | DecisivePlayerPickerTask | DropChallengeTask | GameWeeklyTask | GuessTheScoreTask | InviteTaskAsReferrer | So5LeaderboardTask | StarPackTask | Task | TasksTrack | ThresholdPickerTask | ThresholdsDuoConnectionTask | ThresholdsStreakAdditionalLineupTask | ThresholdsStreakTask>;
  periodicity?: Maybe<ManagerTaskPeriodicity>;
  pickOrList: Scalars['Boolean']['output'];
  possibleRewardConfigsIconUrl?: Maybe<Scalars['String']['output']>;
  /** @deprecated Not used anymore */
  probabilisticBundles: Array<ProbabilisticBundle>;
  progress: Scalars['Int']['output'];
  rarity?: Maybe<Rarity>;
  rewardConfigs: Array<CardPacksRewardConfig | CardRewardConfig | CardShardRewardConfig | CoinRewardConfig | ConversionCreditRewardConfig | DeliverableItemRewardConfig | ExperienceRewardConfig | InGameCurrencyRewardConfig | MonetaryRewardConfig | ProbabilisticBundleRewardConfig | ShopItemRewardConfig>;
  /** The `reward_pool_shares` field cannot be nested within a list. */
  rewardPoolShares?: Maybe<RewardPoolShareConnection>;
  scoreToReach: Scalars['Int']['output'];
  startDate?: Maybe<Scalars['ISO8601DateTime']['output']>;
  subtasks: Array<CardsCountTargetTask | CardsCountTask | CompleteCollectionsCountTargetTask | CompleteCollectionsCountTask | DailyActionTask | DecisivePlayerPickerTask | DropChallengeTask | GameWeeklyTask | GuessTheScoreTask | InviteTaskAsReferrer | So5LeaderboardTask | StarPackTask | Task | TasksTrack | ThresholdPickerTask | ThresholdsDuoConnectionTask | ThresholdsStreakAdditionalLineupTask | ThresholdsStreakTask>;
  target: Scalars['Int']['output'];
  taskConfigSlug: Scalars['String']['output'];
  templateIconUrl: Scalars['String']['output'];
  thresholds: Array<CollectionTaskThreshold>;
  title: Scalars['String']['output'];
  uncapped: Scalars['Boolean']['output'];
}


export interface DailyActionTaskcolorArgs {
  variant?: InputMaybe<ColorVariant>;
}


export interface DailyActionTaskrewardConfigsArgs {
  mergedConfigsByType?: InputMaybe<Scalars['Boolean']['input']>;
}


export interface DailyActionTaskrewardPoolSharesArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
}

/** A data partner */
export interface DataPartner extends Node {
  __typename: 'DataPartner';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  slug: Scalars['String']['output'];
  termsUrl: Scalars['String']['output'];
}

export interface DateRangeInput {
  maxDate?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  minDate?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
}

export interface DateRangeSpecific {
  __typename: 'DateRangeSpecific';
  endDate: Scalars['ISO8601DateTime']['output'];
  max?: Maybe<Scalars['Int']['output']>;
  min?: Maybe<Scalars['Int']['output']>;
  startDate: Scalars['ISO8601DateTime']['output'];
}

export interface DealInterface {
  dealStatus: DealStatus;
}

export const DealStatus = {
  PENDING_REVIEW: 'PENDING_REVIEW',
  SETTLED: 'SETTLED',
  UNKNOWN: 'UNKNOWN'
} as const;

export type DealStatus = typeof DealStatus[keyof typeof DealStatus];
/** A decisive action notification */
export interface DecisiveActionNotification extends Node, NotificationInterface {
  __typename: 'DecisiveActionNotification';
  body: Scalars['String']['output'];
  createdAt: Scalars['ISO8601DateTime']['output'];
  deeplinkUrl: Scalars['String']['output'];
  iconUrl: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  important: Scalars['Boolean']['output'];
  lineup: GuessTheScoreTaskLineup | So5Lineup | TaskLineup | ThresholdPickerTaskLineup;
  markdownBody: Scalars['String']['output'];
  name: Scalars['String']['output'];
  pictureUrl?: Maybe<Scalars['String']['output']>;
  player: BaseballPlayer | NBAPlayer | Player;
  read: Scalars['Boolean']['output'];
  rendering?: Maybe<TitleBodyNotificationRendering>;
  so5Lineup?: Maybe<So5Lineup>;
  sport?: Maybe<SportOrShared>;
  title: Scalars['String']['output'];
  user: CurrentUser;
}

export interface DecisiveEventInterface {
  addedTime?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  minute: Scalars['Int']['output'];
  occurredAt: Scalars['ISO8601DateTime']['output'];
  period?: Maybe<Period>;
  player: BaseballPlayer | NBAPlayer | Player;
  stat?: Maybe<Scalars['String']['output']>;
}

export const DecisivePlayerPickerMode = {
  DECISIVE: 'DECISIVE',
  SCORE: 'SCORE'
} as const;

export type DecisivePlayerPickerMode = typeof DecisivePlayerPickerMode[keyof typeof DecisivePlayerPickerMode];
/** Decisive Player Picker Task */
export interface DecisivePlayerPickerTask extends ManagerTaskInterface, TaskInterface {
  __typename: 'DecisivePlayerPickerTask';
  aasmState: ManagerProgressionTaskState;
  alternativeRewardConfigs?: Maybe<Array<AlternativeRewardConfig>>;
  /** Card packs printing players eligible for the pickable games The `card_packs` field cannot be nested within a list. */
  cardPacks: Array<CardPack>;
  /** @deprecated Not used anymore */
  cards: Array<BaseballCard | Card | NBACard>;
  claimableAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** @deprecated Not used anymore */
  claimedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  color?: Maybe<Scalars['String']['output']>;
  completedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  decisiveActions: Array<Scalars['String']['output']>;
  decisiveStats: Array<Stat>;
  defaultAverageType: AveragePlayerScore;
  description: Scalars['String']['output'];
  displayedTypedRules: Array<CardsCountAsFirstOwnerRule | OwnedSinceRule | PlayerHeightRule | SeasonsRule | So5ActiveClubsRule | So5ActiveNationalTeamsRule | So5AgeRule | So5AppearancesRule | So5AtLeastOfClubs | So5AtLeastOfCompetitions | So5AverageScoresRule | So5CaptainRule | So5CaptainScarcityRule | So5CardEditionsCountRule | So5CompetitionsRule | So5EntryItemRule | So5MaximumPlayersAverageScoreRule | So5MinimumPlayersAverageScoreRule | So5NationalityRule | So5NotNationalityRule | So5SameActiveClubRule | So5ScarcityRule | So5SeasonBonusRule | VaultPointsRule>;
  expired: Scalars['Boolean']['output'];
  genre: TaskGenre;
  group?: Maybe<TaskGroup>;
  iconUrl?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  jonumGated: Scalars['Boolean']['output'];
  /** The points this task earned on a ladder leaderboard, empty when it feeds none. */
  ladderContributions: Array<LadderContribution>;
  marketSections: Array<CardPackGroup | FeaturedCardPack | FeaturedMarketSection | GemsShop | LegacyPacks | MarketLiveOps | MarketSetSpecialBundles | MarketSetWelcomeOffer | SpecialOffers | WeeklyDeals>;
  maxAppearancesCount: Scalars['Int']['output'];
  mode: DecisivePlayerPickerMode;
  /** The `my_reward_pool_shares` field cannot be nested within a list. */
  myRewardPoolShares?: Maybe<Array<RewardPoolShare>>;
  name: ManagerProgressionTaskSlug;
  /** The `next_pickable_game` field cannot be nested within a list. */
  nextPickableGame?: Maybe<GameWithCardsPreview>;
  overperform?: Maybe<OverperformAverageScoreConfig>;
  parentTask?: Maybe<CardsCountTargetTask | CardsCountTask | CompleteCollectionsCountTargetTask | CompleteCollectionsCountTask | DailyActionTask | DecisivePlayerPickerTask | DropChallengeTask | GameWeeklyTask | GuessTheScoreTask | InviteTaskAsReferrer | So5LeaderboardTask | StarPackTask | Task | TasksTrack | ThresholdPickerTask | ThresholdsDuoConnectionTask | ThresholdsStreakAdditionalLineupTask | ThresholdsStreakTask>;
  periodicity?: Maybe<ManagerTaskPeriodicity>;
  pickOrList: Scalars['Boolean']['output'];
  /** The `pickable_cards` field cannot be nested within a list. */
  pickableCards: AnyCardInterfaceConnection;
  pickableDays: GameDayConnection;
  /** The `pickable_games` field cannot be nested within a list. */
  pickableGames: GameWithCardsPreviewConnection;
  /** The `pickable_teams` field cannot be nested within a list. */
  pickableTeams: Array<PickableTeam>;
  possibleRewardConfigsIconUrl?: Maybe<Scalars['String']['output']>;
  /** @deprecated Not used anymore */
  probabilisticBundles: Array<ProbabilisticBundle>;
  progress: Scalars['Int']['output'];
  rarity?: Maybe<Rarity>;
  rewardConfigs: Array<CardPacksRewardConfig | CardRewardConfig | CardShardRewardConfig | CoinRewardConfig | ConversionCreditRewardConfig | DeliverableItemRewardConfig | ExperienceRewardConfig | InGameCurrencyRewardConfig | MonetaryRewardConfig | ProbabilisticBundleRewardConfig | ShopItemRewardConfig>;
  /** The `reward_pool_shares` field cannot be nested within a list. */
  rewardPoolShares?: Maybe<RewardPoolShareConnection>;
  sealed?: Maybe<Scalars['Boolean']['output']>;
  startDate?: Maybe<Scalars['ISO8601DateTime']['output']>;
  statThresholds?: Maybe<Array<TaskStatThreshold>>;
  target: Scalars['Int']['output'];
  taskAppearances: Array<DecisivePlayerPickerTaskAppearance>;
  taskConfigSlug: Scalars['String']['output'];
  templateIconUrl: Scalars['String']['output'];
  title: Scalars['String']['output'];
  uncapped: Scalars['Boolean']['output'];
}


/** Decisive Player Picker Task */
export interface DecisivePlayerPickerTaskcolorArgs {
  variant?: InputMaybe<ColorVariant>;
}


/** Decisive Player Picker Task */
export interface DecisivePlayerPickerTaskpickableCardsArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  age?: InputMaybe<Scalars['Int']['input']>;
  assetIds?: InputMaybe<Array<Scalars['String']['input']>>;
  before?: InputMaybe<Scalars['String']['input']>;
  classicOnly?: InputMaybe<Scalars['Boolean']['input']>;
  customCardEditionName?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  gameId: Scalars['ID']['input'];
  inActiveCompetitions?: InputMaybe<Array<Scalars['String']['input']>>;
  inSeasonEligible?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  owned?: InputMaybe<Scalars['Boolean']['input']>;
  ownedByMe?: InputMaybe<Scalars['Boolean']['input']>;
  ownedSinceAfter?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  playerSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  positions?: InputMaybe<Array<Position>>;
  rarities?: InputMaybe<Array<Rarity>>;
  revealable?: InputMaybe<Scalars['Boolean']['input']>;
  seasonStartYears?: InputMaybe<Array<Scalars['Int']['input']>>;
  serialNumber?: InputMaybe<Scalars['Int']['input']>;
  shirtNumber?: InputMaybe<Scalars['Int']['input']>;
  slugs?: InputMaybe<Array<Scalars['String']['input']>>;
  sorts?: InputMaybe<Array<CardSort>>;
  sport?: InputMaybe<Sport>;
  teamSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  withinDeckFirst?: InputMaybe<Scalars['String']['input']>;
}


/** Decisive Player Picker Task */
export interface DecisivePlayerPickerTaskpickableDaysArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  timeZone: Scalars['String']['input'];
}


/** Decisive Player Picker Task */
export interface DecisivePlayerPickerTaskpickableGamesArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  fromDate?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  toDate?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
}


/** Decisive Player Picker Task */
export interface DecisivePlayerPickerTaskpickableTeamsArgs {
  gameId: Scalars['ID']['input'];
}


/** Decisive Player Picker Task */
export interface DecisivePlayerPickerTaskrewardConfigsArgs {
  mergedConfigsByType?: InputMaybe<Scalars['Boolean']['input']>;
}


/** Decisive Player Picker Task */
export interface DecisivePlayerPickerTaskrewardPoolSharesArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
}

/** Decisive Player Picker Task Appearance */
export interface DecisivePlayerPickerTaskAppearance extends AppearanceInterface, ComposeTeamBenchObjectInterface, TaskAppearanceInterface {
  __typename: 'DecisivePlayerPickerTaskAppearance';
  activeSuspensions: Array<Suspension>;
  anyCard?: Maybe<BaseballCard | Card | NBACard>;
  anyCardWithLivePrimaryOffer?: Maybe<BaseballCard | Card | NBACard>;
  anyPlayer: BaseballPlayer | NBAPlayer | Player;
  averageScore?: Maybe<Scalars['Float']['output']>;
  bonus?: Maybe<Scalars['Float']['output']>;
  bonusPoints?: Maybe<Scalars['Float']['output']>;
  bonusRating?: Maybe<BonusOrdinalRatingEnum>;
  captain: Scalars['Boolean']['output'];
  card: BaseballCard | Card | NBACard;
  cardBorderRadius: Scalars['Int']['output'];
  completedTask?: Maybe<CardsCountTargetTask | CardsCountTask | CompleteCollectionsCountTargetTask | CompleteCollectionsCountTask | DailyActionTask | DecisivePlayerPickerTask | DropChallengeTask | GameWeeklyTask | GuessTheScoreTask | InviteTaskAsReferrer | So5LeaderboardTask | StarPackTask | Task | TasksTrack | ThresholdPickerTask | ThresholdsDuoConnectionTask | ThresholdsStreakAdditionalLineupTask | ThresholdsStreakTask>;
  contributor?: Maybe<User>;
  decisiveStats: Array<StatScore>;
  eligiblePlayerGameScores: Array<BaseballPlayerGameScore | BasketballPlayerGameScore | PlayerGameScore | So5Score>;
  /**
   * Projected score minus the lowest score of the player star tier for NBA, minus
   * the L10 average otherwise, from the projection the bench sorts
   * GAIN_ON_PROJECTION on: the next game on a card bench with no fixture, the
   * fixture projection otherwise
   */
  gainOnProjection?: Maybe<Scalars['Float']['output']>;
  game?: Maybe<Game | GameOfBaseball | GameOfBasketball>;
  id: Scalars['ID']['output'];
  index: Scalars['Int']['output'];
  licensed: Scalars['Boolean']['output'];
  locked: Scalars['Boolean']['output'];
  /** When a bench object will be locked for a leaderboard */
  lockedAt: Scalars['ISO8601DateTime']['output'];
  /** Wether a bench object can be updated for a leaderboard */
  lockedForLeaderboard: Scalars['Boolean']['output'];
  pictureUrl?: Maybe<Scalars['String']['output']>;
  playedGames: Array<Game | GameOfBaseball | GameOfBasketball>;
  player: Player;
  playerGameScore?: Maybe<BaseballPlayerGameScore | BasketballPlayerGameScore | PlayerGameScore | So5Score>;
  position: Position;
  positions: Array<Position>;
  powerBreakdown: PowerBreakdown;
  /** PowerBreakdown as long as leaderboard is playable. PowerPointsBreakdown after */
  powerBreakdownOrPowerPointsBreakdown?: Maybe<PowerBreakdownOrPowerPointsBreakdown>;
  projectedScore?: Maybe<Scalars['Float']['output']>;
  rarity: Rarity;
  reachedStatThreshold?: Maybe<TaskStatThreshold>;
  score: Scalars['Float']['output'];
  scoreStatus: ScoreStatus;
  status: DecisivePlayerPickerTaskAppearanceStatus;
  target: Scalars['Int']['output'];
  task: CardsCountTargetTask | CardsCountTask | CompleteCollectionsCountTargetTask | CompleteCollectionsCountTask | DailyActionTask | DecisivePlayerPickerTask | DropChallengeTask | GameWeeklyTask | GuessTheScoreTask | InviteTaskAsReferrer | So5LeaderboardTask | StarPackTask | Task | TasksTrack | ThresholdPickerTask | ThresholdsDuoConnectionTask | ThresholdsStreakAdditionalLineupTask | ThresholdsStreakTask;
  upcomingGame?: Maybe<Game | GameOfBaseball | GameOfBasketball>;
  videoUrl?: Maybe<Scalars['String']['output']>;
}


/** Decisive Player Picker Task Appearance */
export interface DecisivePlayerPickerTaskAppearanceactiveSuspensionsArgs {
  so5LeaderboardSlug?: InputMaybe<Scalars['String']['input']>;
}


/** Decisive Player Picker Task Appearance */
export interface DecisivePlayerPickerTaskAppearanceanyCardWithLivePrimaryOfferArgs {
  rarity?: InputMaybe<Rarity>;
}


/** Decisive Player Picker Task Appearance */
export interface DecisivePlayerPickerTaskAppearanceaverageScoreArgs {
  type: AveragePlayerScore;
}


/** Decisive Player Picker Task Appearance */
export interface DecisivePlayerPickerTaskAppearanceeligiblePlayerGameScoresArgs {
  boardId?: InputMaybe<Scalars['String']['input']>;
  gameId?: InputMaybe<Scalars['ID']['input']>;
  so5LeaderboardSlug?: InputMaybe<Scalars['String']['input']>;
  stepId?: InputMaybe<Scalars['String']['input']>;
  taskId?: InputMaybe<Scalars['ID']['input']>;
}


/** Decisive Player Picker Task Appearance */
export interface DecisivePlayerPickerTaskAppearancelockedAtArgs {
  so5LeaderboardSlug?: InputMaybe<Scalars['String']['input']>;
}


/** Decisive Player Picker Task Appearance */
export interface DecisivePlayerPickerTaskAppearancelockedForLeaderboardArgs {
  so5LeaderboardSlug?: InputMaybe<Scalars['String']['input']>;
}


/** Decisive Player Picker Task Appearance */
export interface DecisivePlayerPickerTaskAppearancepictureUrlArgs {
  derivative?: InputMaybe<Scalars['String']['input']>;
}


/** Decisive Player Picker Task Appearance */
export interface DecisivePlayerPickerTaskAppearanceprojectedScoreArgs {
  so5LeaderboardSlug: Scalars['String']['input'];
}


/** Decisive Player Picker Task Appearance */
export interface DecisivePlayerPickerTaskAppearancescoreArgs {
  withBonus?: InputMaybe<Scalars['Boolean']['input']>;
}


/** Decisive Player Picker Task Appearance */
export interface DecisivePlayerPickerTaskAppearancevideoUrlArgs {
  derivative?: InputMaybe<Scalars['String']['input']>;
}

export const DecisivePlayerPickerTaskAppearanceStatus = {
  FAILURE: 'FAILURE',
  READY: 'READY',
  SUCCESS: 'SUCCESS'
} as const;

export type DecisivePlayerPickerTaskAppearanceStatus = typeof DecisivePlayerPickerTaskAppearanceStatus[keyof typeof DecisivePlayerPickerTaskAppearanceStatus];
/** A decisive purchase notification */
export interface DecisivePurchaseNotification extends Node, NotificationInterface {
  __typename: 'DecisivePurchaseNotification';
  body: Scalars['String']['output'];
  card: BaseballCard | Card | NBACard;
  createdAt: Scalars['ISO8601DateTime']['output'];
  deeplinkUrl: Scalars['String']['output'];
  game: Game | GameOfBaseball | GameOfBasketball;
  iconUrl: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  important: Scalars['Boolean']['output'];
  markdownBody: Scalars['String']['output'];
  name: Scalars['String']['output'];
  pictureUrl?: Maybe<Scalars['String']['output']>;
  read: Scalars['Boolean']['output'];
  rendering?: Maybe<TitleBodyNotificationRendering>;
  reward: AnyCardReward | AnyConversionCreditReward | CardPackReward | CardShardsReward | CoinReward | DeliverableItemReward | ExperienceReward | InGameCurrencyReward | MonetaryReward | ProbabilisticBundleReward | ShopItemReward;
  sport?: Maybe<SportOrShared>;
  title: Scalars['String']['output'];
  user: CurrentUser;
}

/** A set of cards */
export interface Deck extends Node, SocialPicturesInterface {
  __typename: 'Deck';
  /** The `cards` field cannot be nested within a list. */
  cards: AnyCardInterfaceConnection;
  deckIndex: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  slug: Scalars['String']['output'];
  socialPictureFingerprint: Scalars['String']['output'];
  socialPictureUrls: SocialPictureDerivative;
  sport: Sport;
  tokensCount: Scalars['Int']['output'];
  user?: Maybe<User>;
  visible: Scalars['Boolean']['output'];
}


/** A set of cards */
export interface DeckcardsArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
}

/** The connection type for Deck. */
export interface DeckConnection {
  __typename: 'DeckConnection';
  /** A list of edges. */
  edges: Array<DeckEdge>;
  /** A list of nodes. */
  nodes: Array<Deck>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
}

/** An edge in a connection. */
export interface DeckEdge {
  __typename: 'DeckEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<Deck>;
}

export const DeliverableItemDerivative = {
  MOBILE: 'MOBILE',
  TINIFIED: 'TINIFIED'
} as const;

export type DeliverableItemDerivative = typeof DeliverableItemDerivative[keyof typeof DeliverableItemDerivative];
export interface DeliverableItemInterface {
  id: Scalars['ID']['output'];
  mandatoryWearableSizeInput: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  pictureUrl: Scalars['String']['output'];
  slug: Scalars['String']['output'];
  sport: Sport;
  threeDimensionalAssetUrl?: Maybe<Scalars['String']['output']>;
}


export interface DeliverableItemInterfacepictureUrlArgs {
  derivative?: InputMaybe<DeliverableItemDerivative>;
}


export interface DeliverableItemInterfacethreeDimensionalAssetUrlArgs {
  format?: InputMaybe<DeliverableItemThreeDimensionalAssetFormat>;
}

export interface DeliverableItemOrder extends Node {
  __typename: 'DeliverableItemOrder';
  aasmState: DeliverableItemStatus;
  claimedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  deliverableItem: ExperienceDeliverableItem | JerseyDeliverableItem | TicketsDeliverableItem | WearableDeliverableItem;
  expiresAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  id: Scalars['ID']['output'];
  user: User;
}

/** A Deliverable Item Reward */
export interface DeliverableItemReward extends AnyRewardInterface, Node {
  __typename: 'DeliverableItemReward';
  aasmState: RewardState;
  config: DeliverableItemRewardConfig;
  deliverableItem: ExperienceDeliverableItem | JerseyDeliverableItem | TicketsDeliverableItem | WearableDeliverableItem;
  detailedName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  team?: Maybe<Club | NationalTeam>;
}

/** A Deliverable Item Reward Config */
export interface DeliverableItemRewardConfig extends AnyRewardConfigInterface {
  __typename: 'DeliverableItemRewardConfig';
  boostedRewardConfigs?: Maybe<Array<CardPacksRewardConfig | CardRewardConfig | CardShardRewardConfig | CoinRewardConfig | ConversionCreditRewardConfig | DeliverableItemRewardConfig | ExperienceRewardConfig | InGameCurrencyRewardConfig | MonetaryRewardConfig | ProbabilisticBundleRewardConfig | ShopItemRewardConfig>>;
  deliverableItem: ExperienceDeliverableItem | JerseyDeliverableItem | TicketsDeliverableItem | WearableDeliverableItem;
  id: Scalars['ID']['output'];
}

export const DeliverableItemStatus = {
  CLAIMED: 'CLAIMED',
  EXPIRED: 'EXPIRED',
  READY: 'READY',
  SHIPPED: 'SHIPPED'
} as const;

export type DeliverableItemStatus = typeof DeliverableItemStatus[keyof typeof DeliverableItemStatus];
export const DeliverableItemThreeDimensionalAssetFormat = {
  USDZ: 'USDZ'
} as const;

export type DeliverableItemThreeDimensionalAssetFormat = typeof DeliverableItemThreeDimensionalAssetFormat[keyof typeof DeliverableItemThreeDimensionalAssetFormat];
export interface DeliverableItemVariantsStocks {
  __typename: 'DeliverableItemVariantsStocks';
  deliverableItem: ExperienceDeliverableItem | JerseyDeliverableItem | TicketsDeliverableItem | WearableDeliverableItem;
  id: Scalars['String']['output'];
  teamVariants?: Maybe<Array<TeamVariantStock>>;
}

/** Aggregated deliverable items rewards overview */
export interface DeliverableItemsRewardsOverview {
  __typename: 'DeliverableItemsRewardsOverview';
  experience: Scalars['Int']['output'];
  jersey: Scalars['Int']['output'];
  tickets: Scalars['Int']['output'];
  wearable: Scalars['Int']['output'];
}

/** A physical Merch Deliverable buyable through the club shop */
export interface DeliverableWithCustomVariantShopItem extends Node, ShopItemInterface {
  __typename: 'DeliverableWithCustomVariantShopItem';
  cardCollectionRequirements: Array<CardCollectionRequirement>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  currentStockCount: Scalars['Int']['output'];
  description?: Maybe<Scalars['String']['output']>;
  disabled: Scalars['Boolean']['output'];
  expirationDate?: Maybe<Scalars['ISO8601DateTime']['output']>;
  id: Scalars['ID']['output'];
  infoLink?: Maybe<Scalars['String']['output']>;
  initialStockCount: Scalars['Int']['output'];
  limitPerUser: Scalars['Int']['output'];
  myAvailableTotalPurchasesCount: Scalars['Int']['output'];
  myAvailableUserShopItems?: Maybe<Array<UserShopItem>>;
  myBalance: Scalars['Int']['output'];
  myLimitResetAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  myPurchasesCount: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  pictureUrl: Scalars['String']['output'];
  position: ShopItemType;
  price: Scalars['Int']['output'];
  requirementsRulesLink?: Maybe<Scalars['String']['output']>;
  salePrice?: Maybe<Scalars['Int']['output']>;
  shopItemsRequired: Array<ShopItem>;
  threeDimensionalAssetUrl?: Maybe<Scalars['String']['output']>;
  unlocked: Scalars['Boolean']['output'];
  variantStockCounts: Array<VariantStockCount>;
}


/** A physical Merch Deliverable buyable through the club shop */
export interface DeliverableWithCustomVariantShopItempictureUrlArgs {
  derivative?: InputMaybe<ShopItemDerivative>;
}


/** A physical Merch Deliverable buyable through the club shop */
export interface DeliverableWithCustomVariantShopItemthreeDimensionalAssetUrlArgs {
  format?: InputMaybe<ShopItemThreeDimensionalAssetFormat>;
}

/** A physical Merch Deliverable buyable through the club shop */
export interface DeliverableWithNoVariantShopItem extends Node, ShopItemInterface {
  __typename: 'DeliverableWithNoVariantShopItem';
  cardCollectionRequirements: Array<CardCollectionRequirement>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  currentStockCount: Scalars['Int']['output'];
  description?: Maybe<Scalars['String']['output']>;
  disabled: Scalars['Boolean']['output'];
  expirationDate?: Maybe<Scalars['ISO8601DateTime']['output']>;
  id: Scalars['ID']['output'];
  infoLink?: Maybe<Scalars['String']['output']>;
  initialStockCount: Scalars['Int']['output'];
  limitPerUser: Scalars['Int']['output'];
  myAvailableTotalPurchasesCount: Scalars['Int']['output'];
  myAvailableUserShopItems?: Maybe<Array<UserShopItem>>;
  myBalance: Scalars['Int']['output'];
  myLimitResetAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  myPurchasesCount: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  pictureUrl: Scalars['String']['output'];
  position: ShopItemType;
  price: Scalars['Int']['output'];
  requirementsRulesLink?: Maybe<Scalars['String']['output']>;
  salePrice?: Maybe<Scalars['Int']['output']>;
  shopItemsRequired: Array<ShopItem>;
  threeDimensionalAssetUrl?: Maybe<Scalars['String']['output']>;
  unlocked: Scalars['Boolean']['output'];
}


/** A physical Merch Deliverable buyable through the club shop */
export interface DeliverableWithNoVariantShopItempictureUrlArgs {
  derivative?: InputMaybe<ShopItemDerivative>;
}


/** A physical Merch Deliverable buyable through the club shop */
export interface DeliverableWithNoVariantShopItemthreeDimensionalAssetUrlArgs {
  format?: InputMaybe<ShopItemThreeDimensionalAssetFormat>;
}

export const Delivery = {
  EMAIL: 'EMAIL',
  PHONE: 'PHONE'
} as const;

export type Delivery = typeof Delivery[keyof typeof Delivery];
export const DepositOperationStatus = {
  COMPLETED: 'COMPLETED',
  EXPIRED: 'EXPIRED',
  FAILED: 'FAILED',
  NOT_PROCESSED: 'NOT_PROCESSED',
  PENDING: 'PENDING',
  UNKNOWN: 'UNKNOWN'
} as const;

export type DepositOperationStatus = typeof DepositOperationStatus[keyof typeof DepositOperationStatus];
/** A promotional event taking place in the wallet and related to deposits */
export interface DepositPromotionalEvent extends CompletablePromotionalEventInterface, Node, PromotionalEventInterface {
  __typename: 'DepositPromotionalEvent';
  algoliaFilters: Scalars['String']['output'];
  backgroundPictureUrl?: Maybe<Scalars['String']['output']>;
  bannerAssetsPictureUrl?: Maybe<Scalars['String']['output']>;
  blogUrl?: Maybe<Scalars['String']['output']>;
  completedParticipants: Scalars['Int']['output'];
  completionAmount?: Maybe<MonetaryAmount>;
  completionRules: Scalars['JSON']['output'];
  description: Scalars['String']['output'];
  eligibilityRules: EligibilityRules;
  endDate: Scalars['ISO8601DateTime']['output'];
  filterPictureUrl?: Maybe<Scalars['String']['output']>;
  heroValueProps: Array<HeroValueProp>;
  id: Scalars['ID']['output'];
  logoUrl?: Maybe<Scalars['String']['output']>;
  marketBannerTitle: Scalars['String']['output'];
  mobileBackgroundPictureUrl?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  pictureUrl?: Maybe<Scalars['String']['output']>;
  probableRewardConfigs: Array<ProbableRewardConfig>;
  promotionDetailsRewardDescription?: Maybe<Scalars['String']['output']>;
  promotionDetailsRewardPictureUrl?: Maybe<Scalars['String']['output']>;
  promotionType: PromotionType;
  promotionalEventCompletion?: Maybe<PromotionalEventCompletion>;
  secondaryBannerPictureUrl?: Maybe<Scalars['String']['output']>;
  slug: Scalars['String']['output'];
  sport?: Maybe<Sport>;
  startDate: Scalars['ISO8601DateTime']['output'];
  termsAndConditionsUrl?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
}

export const DepositProvider = {
  CHECKOUT_CREDIT_CARD: 'CHECKOUT_CREDIT_CARD',
  ETH_WALLET: 'ETH_WALLET',
  EXTERNAL: 'EXTERNAL',
  MANGOPAY_APPLE_PAY: 'MANGOPAY_APPLE_PAY',
  MANGOPAY_BANK_WIRE: 'MANGOPAY_BANK_WIRE',
  MANGOPAY_CREDIT_CARD: 'MANGOPAY_CREDIT_CARD',
  MANGOPAY_IDEAL_DEPOSIT: 'MANGOPAY_IDEAL_DEPOSIT',
  MANGOPAY_PAYPAL_DEPOSIT: 'MANGOPAY_PAYPAL_DEPOSIT',
  MANGOPAY_PAY_BY_BANK_DEPOSIT: 'MANGOPAY_PAY_BY_BANK_DEPOSIT',
  MOONPAY: 'MOONPAY',
  RAMP: 'RAMP',
  SOL_WALLET: 'SOL_WALLET',
  WORLDPAY_CREDIT_CARD: 'WORLDPAY_CREDIT_CARD'
} as const;

export type DepositProvider = typeof DepositProvider[keyof typeof DepositProvider];
export const DepositStatus = {
  COMPLETED: 'COMPLETED',
  EXPIRED: 'EXPIRED',
  FAILED: 'FAILED',
  PENDING: 'PENDING'
} as const;

export type DepositStatus = typeof DepositStatus[keyof typeof DepositStatus];
export const DeviceVerificationMode = {
  CODE: 'CODE',
  LINK: 'LINK'
} as const;

export type DeviceVerificationMode = typeof DeviceVerificationMode[keyof typeof DeviceVerificationMode];
export const DeviceWasUpdatedEvent = {
  /** When a device is confirmed */
  confirmed: 'confirmed',
  /** When a device is revoked */
  revoked: 'revoked'
} as const;

export type DeviceWasUpdatedEvent = typeof DeviceWasUpdatedEvent[keyof typeof DeviceWasUpdatedEvent];
export const DivisionChange = {
  PROMOTED: 'PROMOTED',
  RELEGATED: 'RELEGATED',
  STABLE: 'STABLE'
} as const;

export type DivisionChange = typeof DivisionChange[keyof typeof DivisionChange];
/** A division change configuration */
export interface DivisionChangeConfiguration {
  __typename: 'DivisionChangeConfiguration';
  id: Scalars['ID']['output'];
  lastPromotedSo5Ranking?: Maybe<So5Ranking>;
  lastStableSo5Ranking?: Maybe<So5Ranking>;
  promotionRankBasisPoint: Scalars['Int']['output'];
  relegationRankBasisPoint: Scalars['Int']['output'];
}

/** A division */
export interface DivisionInterface {
  /** The name of the division */
  name: Scalars['String']['output'];
}

/** Mangopay Document Input */
export interface DocumentInput {
  backPagePresignedKey?: InputMaybe<Scalars['String']['input']>;
  documentType: DocumentType;
  frontPagePresignedKey: Scalars['String']['input'];
}

export const DocumentType = {
  BANK_STATEMENT: 'BANK_STATEMENT',
  POTENTIAL_POLITICALLY_EXPOSED_PERSON_DECLARATION: 'POTENTIAL_POLITICALLY_EXPOSED_PERSON_DECLARATION',
  PROOF_OF_ADDRESS: 'PROOF_OF_ADDRESS',
  PROOF_OF_IDENTITY: 'PROOF_OF_IDENTITY'
} as const;

export type DocumentType = typeof DocumentType[keyof typeof DocumentType];
export interface DropCardInput {
  cardSlug: Scalars['String']['input'];
  signedPrice: Scalars['String']['input'];
}

export interface DropChallengeTask extends ManagerTaskInterface, TaskInterface {
  __typename: 'DropChallengeTask';
  aasmState: ManagerProgressionTaskState;
  alternativeRewardConfigs?: Maybe<Array<AlternativeRewardConfig>>;
  /** The `available_cards` field cannot be nested within a list. */
  availableCards: AnyCardInterfaceConnection;
  /** @deprecated Not used anymore */
  cards: Array<BaseballCard | Card | NBACard>;
  cardsCount: Scalars['Int']['output'];
  claimableAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** @deprecated Not used anymore */
  claimedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  color?: Maybe<Scalars['String']['output']>;
  completedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  description: Scalars['String']['output'];
  displayedTypedRules: Array<CardsCountAsFirstOwnerRule | OwnedSinceRule | PlayerHeightRule | SeasonsRule | So5ActiveClubsRule | So5ActiveNationalTeamsRule | So5AgeRule | So5AppearancesRule | So5AtLeastOfClubs | So5AtLeastOfCompetitions | So5AverageScoresRule | So5CaptainRule | So5CaptainScarcityRule | So5CardEditionsCountRule | So5CompetitionsRule | So5EntryItemRule | So5MaximumPlayersAverageScoreRule | So5MinimumPlayersAverageScoreRule | So5NationalityRule | So5NotNationalityRule | So5SameActiveClubRule | So5ScarcityRule | So5SeasonBonusRule | VaultPointsRule>;
  expired: Scalars['Boolean']['output'];
  genre: TaskGenre;
  group?: Maybe<TaskGroup>;
  iconUrl?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  jonumGated: Scalars['Boolean']['output'];
  /** The points this task earned on a ladder leaderboard, empty when it feeds none. */
  ladderContributions: Array<LadderContribution>;
  /** The `my_reward_pool_shares` field cannot be nested within a list. */
  myRewardPoolShares?: Maybe<Array<RewardPoolShare>>;
  name: ManagerProgressionTaskSlug;
  parentTask?: Maybe<CardsCountTargetTask | CardsCountTask | CompleteCollectionsCountTargetTask | CompleteCollectionsCountTask | DailyActionTask | DecisivePlayerPickerTask | DropChallengeTask | GameWeeklyTask | GuessTheScoreTask | InviteTaskAsReferrer | So5LeaderboardTask | StarPackTask | Task | TasksTrack | ThresholdPickerTask | ThresholdsDuoConnectionTask | ThresholdsStreakAdditionalLineupTask | ThresholdsStreakTask>;
  periodicity?: Maybe<ManagerTaskPeriodicity>;
  pickOrList: Scalars['Boolean']['output'];
  possibleRewardConfigsIconUrl?: Maybe<Scalars['String']['output']>;
  /** @deprecated Not used anymore */
  probabilisticBundles: Array<ProbabilisticBundle>;
  progress: Scalars['Int']['output'];
  rarity?: Maybe<Rarity>;
  rewardConfigs: Array<CardPacksRewardConfig | CardRewardConfig | CardShardRewardConfig | CoinRewardConfig | ConversionCreditRewardConfig | DeliverableItemRewardConfig | ExperienceRewardConfig | InGameCurrencyRewardConfig | MonetaryRewardConfig | ProbabilisticBundleRewardConfig | ShopItemRewardConfig>;
  /** The `reward_pool_shares` field cannot be nested within a list. */
  rewardPoolShares?: Maybe<RewardPoolShareConnection>;
  startDate?: Maybe<Scalars['ISO8601DateTime']['output']>;
  target: Scalars['Int']['output'];
  taskConfigSlug: Scalars['String']['output'];
  templateIconUrl: Scalars['String']['output'];
  title: Scalars['String']['output'];
  uncapped: Scalars['Boolean']['output'];
}


export interface DropChallengeTaskavailableCardsArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  onlyDuplicate?: InputMaybe<Scalars['Boolean']['input']>;
}


export interface DropChallengeTaskcolorArgs {
  variant?: InputMaybe<ColorVariant>;
}


export interface DropChallengeTaskrewardConfigsArgs {
  mergedConfigsByType?: InputMaybe<Scalars['Boolean']['input']>;
}


export interface DropChallengeTaskrewardPoolSharesArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
}

/** The variant of a common card edition */
export const EditionVariant = {
  BASE: 'BASE',
  VARIANT_1: 'VARIANT_1',
  VARIANT_2: 'VARIANT_2'
} as const;

export type EditionVariant = typeof EditionVariant[keyof typeof EditionVariant];
export interface Eip7702AuthorizationInput {
  address: Scalars['EthereumAddress']['input'];
  chainId: Scalars['Int']['input'];
  nonce: Scalars['Int']['input'];
  r: Scalars['String']['input'];
  s: Scalars['String']['input'];
  yParity: Scalars['Int']['input'];
}

/** An EIP-7702 delegation revocation */
export interface Eip7702Revocation extends Node {
  __typename: 'Eip7702Revocation';
  createdAt: Scalars['ISO8601DateTime']['output'];
  failureReason?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  status: Eip7702RevocationStatus;
  transactionHash?: Maybe<Scalars['String']['output']>;
}

export const Eip7702RevocationStatus = {
  CREATED: 'CREATED',
  FAILED: 'FAILED',
  FINALIZED: 'FINALIZED'
} as const;

export type Eip7702RevocationStatus = typeof Eip7702RevocationStatus[keyof typeof Eip7702RevocationStatus];
/** The eligibility rule set of a PromotionalEvent */
export interface EligibilityRules extends CardEligibilityRulesInterface {
  __typename: 'EligibilityRules';
  anyEligibleTeams: Array<Club | NationalTeam>;
  eligibleCardEditions?: Maybe<Array<Scalars['String']['output']>>;
  eligibleCartCardsCount?: Maybe<Scalars['Int']['output']>;
  eligibleCartMonetaryAmount?: Maybe<MonetaryAmount>;
  eligibleCollections?: Maybe<EligibleCollectionRule>;
  eligibleCompetitions?: Maybe<Array<Competition>>;
  eligibleRarities?: Maybe<Array<Rarity>>;
  eligibleSerialNumbers?: Maybe<Array<Scalars['String']['output']>>;
  eligibleSo5Leagues?: Maybe<Array<Scalars['String']['output']>>;
  eligibleTeams?: Maybe<Array<Team>>;
  id: Scalars['String']['output'];
  minimumDepositAmount?: Maybe<Scalars['Int']['output']>;
}

export interface EligibleCardsSort {
  direction: SortingOption;
  type: BenchSortType;
}

export interface EligibleCollectionRule {
  __typename: 'EligibleCollectionRule';
  cardCollections?: Maybe<Array<CardCollection>>;
  cartCardsCount: Scalars['Int']['output'];
}

/** A subscription to a Card/Club/Player/Country/User/CardCollection/Watchlist */
export interface EmailSubscription extends Node {
  __typename: 'EmailSubscription';
  anySubscribable: BaseballCard | BaseballPlayer | Card | Club | Competition | Country | NBACard | NBAPlayer | NationalTeam | Player | User | Watchlist;
  id: Scalars['ID']['output'];
  preferences: EmailSubscriptionPreferences;
  slug: Scalars['String']['output'];
  subscriber?: Maybe<Subscriber>;
  updatedAt: Scalars['ISO8601DateTime']['output'];
}

/** The connection type for EmailSubscription. */
export interface EmailSubscriptionConnection {
  __typename: 'EmailSubscriptionConnection';
  /** A list of edges. */
  edges: Array<EmailSubscriptionEdge>;
  hasAny: Scalars['Boolean']['output'];
  /** A list of nodes. */
  nodes: Array<EmailSubscription>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
}

/** An edge in a connection. */
export interface EmailSubscriptionEdge {
  __typename: 'EmailSubscriptionEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<EmailSubscription>;
}

/** A subscription preferences */
export interface EmailSubscriptionPreferences {
  __typename: 'EmailSubscriptionPreferences';
  notifyForRarities: Array<Scalars['String']['output']>;
  slug: Scalars['String']['output'];
}

export const EnabledWallet = {
  ETH: 'ETH',
  FIAT: 'FIAT'
} as const;

export type EnabledWallet = typeof EnabledWallet[keyof typeof EnabledWallet];
/** An engine configuration */
export interface EngineConfiguration {
  __typename: 'EngineConfiguration';
  activeClubs?: Maybe<Scalars['Json']['output']>;
  averageScores?: Maybe<Scalars['Json']['output']>;
  boost?: Maybe<Scalars['Float']['output']>;
  captain?: Maybe<Scalars['Float']['output']>;
  collection?: Maybe<Scalars['Boolean']['output']>;
  differentNationalities?: Maybe<Scalars['Json']['output']>;
  grade?: Maybe<Scalars['Float']['output']>;
  lineup?: Maybe<Scalars['Json']['output']>;
  multiGameScoreAggregator?: Maybe<Scalars['String']['output']>;
  nationality?: Maybe<Scalars['Json']['output']>;
  player?: Maybe<Scalars['Json']['output']>;
  positionStacks?: Maybe<Scalars['Json']['output']>;
  positions?: Maybe<Scalars['Json']['output']>;
  sameActiveClub?: Maybe<Scalars['Json']['output']>;
  scarcity?: Maybe<Scalars['Json']['output']>;
  season?: Maybe<Scalars['Float']['output']>;
  specialEditionCard?: Maybe<Scalars['Json']['output']>;
  specialEditionCards?: Maybe<Scalars['Json']['output']>;
  xpMultiplier?: Maybe<Scalars['Float']['output']>;
}

export interface EnglishAuctionSource extends HistoryTransactionInterface {
  __typename: 'EnglishAuctionSource';
  date: Scalars['ISO8601DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  label: Scalars['String']['output'];
  logoUrl?: Maybe<Scalars['String']['output']>;
  quantityByFlavour: Array<PoolKeyShardsCount>;
  totalQuantity: Scalars['Int']['output'];
}

export const EscapeHatchState = {
  CREATED: 'CREATED',
  FAILED: 'FAILED',
  WITHDRAWN: 'WITHDRAWN'
} as const;

export type EscapeHatchState = typeof EscapeHatchState[keyof typeof EscapeHatchState];
/** A withdrawal signature */
export interface EthBankWithdrawalIntent {
  __typename: 'EthBankWithdrawalIntent';
  amount: Scalars['String']['output'];
  nonce: Scalars['Int']['output'];
  signature: Scalars['String']['output'];
  user: CurrentUser;
}

/** Payload required to make a Starkware deposit */
export interface EthDeposit {
  __typename: 'EthDeposit';
  assetType: Scalars['String']['output'];
  starkKey: Scalars['String']['output'];
  vaultId: Scalars['Int']['output'];
  weiAmount: Scalars['WeiAmount']['output'];
}

/** An ETH migration */
export interface EthMigration extends Node {
  __typename: 'EthMigration';
  aasmState: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  nonce: Scalars['String']['output'];
  weiAmount: Scalars['String']['output'];
}

/** An Ethereum Account */
export interface EthereumAccount extends Node {
  __typename: 'EthereumAccount';
  address: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  migratorApproved?: Maybe<Scalars['Boolean']['output']>;
}

export interface EthereumBankConditionalTransferApprovalInput {
  conditionalSalt: Scalars['String']['input'];
  deadline: Scalars['String']['input'];
  salt: Scalars['String']['input'];
  signature: Scalars['String']['input'];
}

/** An Ethereum bank conditional transfer authorization request */
export interface EthereumBankConditionalTransferAuthorizationRequest {
  __typename: 'EthereumBankConditionalTransferAuthorizationRequest';
  amount: Scalars['CryptocurrencyAmount']['output'];
  conditionalAmount: Scalars['CryptocurrencyAmount']['output'];
  conditionalCurrency: Cryptocurrency;
  conditionalNetwork: Blockchain;
  conditionalReceiverAddress: Scalars['String']['output'];
  conditionalSalt: Scalars['String']['output'];
  contractAddress: Scalars['String']['output'];
  deadline: Scalars['String']['output'];
  feeAmount: Scalars['CryptocurrencyAmount']['output'];
  proxyAddress: Scalars['String']['output'];
  receiverAddress: Scalars['String']['output'];
  salt: Scalars['String']['output'];
  senderAddress: Scalars['String']['output'];
}

export interface EthereumBankTransferApprovalInput {
  deadline: Scalars['String']['input'];
  salt: Scalars['String']['input'];
  signature: Scalars['String']['input'];
}

/** An Ethereum bank transfer authorization request */
export interface EthereumBankTransferAuthorizationRequest {
  __typename: 'EthereumBankTransferAuthorizationRequest';
  amount: Scalars['CryptocurrencyAmount']['output'];
  contractAddress: Scalars['String']['output'];
  deadline: Scalars['String']['output'];
  feeAmount: Scalars['CryptocurrencyAmount']['output'];
  proxyAddress: Scalars['String']['output'];
  receiverAddress: Scalars['String']['output'];
  salt: Scalars['String']['output'];
  senderAddress: Scalars['String']['output'];
}

/** An Ethereum Transaction */
export interface EthereumTransaction extends Node {
  __typename: 'EthereumTransaction';
  confirmedAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['ID']['output'];
  status?: Maybe<TransactionStatus>;
  transactionHash: Scalars['String']['output'];
}

export interface Event {
  __typename: 'Event';
  bannerUrl: Scalars['String']['output'];
  description: Scalars['String']['output'];
  title: Scalars['String']['output'];
}


export interface EventbannerUrlArgs {
  large: Scalars['Boolean']['input'];
}

/** A ETH/EUR exchange rate */
export interface ExchangeRate extends Node {
  __typename: 'ExchangeRate';
  ethRates: Rates;
  id: Scalars['ID']['output'];
  rates: Scalars['Json']['output'];
  time: Scalars['ISO8601DateTime']['output'];
}

/** A experience deliverable item interface */
export interface ExperienceDeliverableItem extends DeliverableItemInterface {
  __typename: 'ExperienceDeliverableItem';
  id: Scalars['ID']['output'];
  mandatoryWearableSizeInput: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  pictureUrl: Scalars['String']['output'];
  slug: Scalars['String']['output'];
  sport: Sport;
  threeDimensionalAssetUrl?: Maybe<Scalars['String']['output']>;
}


/** A experience deliverable item interface */
export interface ExperienceDeliverableItempictureUrlArgs {
  derivative?: InputMaybe<DeliverableItemDerivative>;
}


/** A experience deliverable item interface */
export interface ExperienceDeliverableItemthreeDimensionalAssetUrlArgs {
  format?: InputMaybe<DeliverableItemThreeDimensionalAssetFormat>;
}

/** An Experience Reward */
export interface ExperienceReward extends AnyRewardInterface, Node {
  __typename: 'ExperienceReward';
  aasmState: RewardState;
  config: ExperienceRewardConfig;
  id: Scalars['ID']['output'];
}

/** An Experience Reward Config */
export interface ExperienceRewardConfig extends AnyRewardConfigInterface {
  __typename: 'ExperienceRewardConfig';
  boostedRewardConfigs?: Maybe<Array<CardPacksRewardConfig | CardRewardConfig | CardShardRewardConfig | CoinRewardConfig | ConversionCreditRewardConfig | DeliverableItemRewardConfig | ExperienceRewardConfig | InGameCurrencyRewardConfig | MonetaryRewardConfig | ProbabilisticBundleRewardConfig | ShopItemRewardConfig>>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  pictureUrl?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  type: CustomRewardExperience;
}

/** An external deposit notification */
export interface ExternalDepositNotification extends Node, NotificationInterface {
  __typename: 'ExternalDepositNotification';
  amount: Scalars['WeiAmount']['output'];
  body: Scalars['String']['output'];
  createdAt: Scalars['ISO8601DateTime']['output'];
  deeplinkUrl: Scalars['String']['output'];
  iconUrl: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  important: Scalars['Boolean']['output'];
  markdownBody: Scalars['String']['output'];
  name: Scalars['String']['output'];
  pictureUrl?: Maybe<Scalars['String']['output']>;
  read: Scalars['Boolean']['output'];
  sport?: Maybe<SportOrShared>;
  status: ExternalDepositNotificationStatus;
  title: Scalars['String']['output'];
  user: CurrentUser;
}

export const ExternalDepositNotificationStatus = {
  FINALIZED: 'FINALIZED',
  PENDING: 'PENDING'
} as const;

export type ExternalDepositNotificationStatus = typeof ExternalDepositNotificationStatus[keyof typeof ExternalDepositNotificationStatus];
export const ExternalProvider = {
  API_FOOTBALL: 'API_FOOTBALL',
  BEPRO: 'BEPRO',
  BEPRO_ROOT: 'BEPRO_ROOT',
  OPTA: 'OPTA',
  ROTOWIRE: 'ROTOWIRE',
  SPORTRADAR: 'SPORTRADAR'
} as const;

export type ExternalProvider = typeof ExternalProvider[keyof typeof ExternalProvider];
export interface ExternalProviderIdInput {
  id: Scalars['String']['input'];
  name: ExternalProvider;
}

/** An extra swap shop item to add a swap to a user */
export interface ExtraSwapShopItem extends Node, ShopItemInterface {
  __typename: 'ExtraSwapShopItem';
  cardCollectionRequirements: Array<CardCollectionRequirement>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  disabled: Scalars['Boolean']['output'];
  expirationDate?: Maybe<Scalars['ISO8601DateTime']['output']>;
  id: Scalars['ID']['output'];
  infoLink?: Maybe<Scalars['String']['output']>;
  limitPerUser: Scalars['Int']['output'];
  myAvailableTotalPurchasesCount: Scalars['Int']['output'];
  myAvailableUserShopItems?: Maybe<Array<UserShopItem>>;
  myBalance: Scalars['Int']['output'];
  myLimitResetAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  myPurchasesCount: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  pictureUrl: Scalars['String']['output'];
  position: ShopItemType;
  price: Scalars['Int']['output'];
  requirementsRulesLink?: Maybe<Scalars['String']['output']>;
  salePrice?: Maybe<Scalars['Int']['output']>;
  shopItemsRequired: Array<ShopItem>;
  so5Leaderboard?: Maybe<So5Leaderboard>;
  so5Leaderboards?: Maybe<Array<So5Leaderboard>>;
  threeDimensionalAssetUrl?: Maybe<Scalars['String']['output']>;
  unlocked: Scalars['Boolean']['output'];
}


/** An extra swap shop item to add a swap to a user */
export interface ExtraSwapShopItempictureUrlArgs {
  derivative?: InputMaybe<ShopItemDerivative>;
}


/** An extra swap shop item to add a swap to a user */
export interface ExtraSwapShopItemthreeDimensionalAssetUrlArgs {
  format?: InputMaybe<ShopItemThreeDimensionalAssetFormat>;
}

/** A landmark as detected on a Player picture by face recognition */
export interface FaceLandmark {
  __typename: 'FaceLandmark';
  type: Scalars['String']['output'];
  x: Scalars['Float']['output'];
  xInPx: Scalars['Float']['output'];
  y: Scalars['Float']['output'];
  yInPx: Scalars['Float']['output'];
}

/** The starkware fast withdrawal as a ConditionalTransferRequest */
export interface FastWithdrawal extends Node {
  __typename: 'FastWithdrawal';
  condition: Scalars['String']['output'];
  createdAt: Scalars['ISO8601DateTime']['output'];
  expirationTimestamp: Scalars['Int']['output'];
  feeInfoUser?: Maybe<Fee>;
  id: Scalars['ID']['output'];
  nonce: Scalars['Int']['output'];
  /** amount expressed in multiples of 10e10 (quantum) wei */
  quantizedAmount: Scalars['String']['output'];
  receiverPublicKey: Scalars['String']['output'];
  receiverVaultId: Scalars['Int']['output'];
  salt: Scalars['String']['output'];
  senderVaultId: Scalars['Int']['output'];
  status: WithdrawalStatus;
  to: Scalars['String']['output'];
  token: Scalars['String']['output'];
  transactionHash?: Maybe<Scalars['String']['output']>;
}

/** The starkware fast withdrawal with rates as a ConditionalTransferRequest */
export interface FastWithdrawalWithRates extends Node {
  __typename: 'FastWithdrawalWithRates';
  amounts: MonetaryAmount;
  condition: Scalars['String']['output'];
  createdAt: Scalars['ISO8601DateTime']['output'];
  expirationTimestamp: Scalars['Int']['output'];
  feeInfoUser?: Maybe<Fee>;
  id: Scalars['ID']['output'];
  nonce: Scalars['Int']['output'];
  /** amount expressed in multiples of 10e10 (quantum) wei */
  quantizedAmount: Scalars['String']['output'];
  receiverPublicKey: Scalars['String']['output'];
  receiverVaultId: Scalars['Int']['output'];
  salt: Scalars['String']['output'];
  senderVaultId: Scalars['Int']['output'];
  status: WithdrawalStatus;
  to: Scalars['String']['output'];
  token: Scalars['String']['output'];
  transactionHash?: Maybe<Scalars['String']['output']>;
}

/** A featured card pack market set section */
export interface FeaturedCardPack extends MarketSetSection {
  __typename: 'FeaturedCardPack';
  backgroundUrl?: Maybe<Scalars['String']['output']>;
  endsAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** @deprecated Not used anymore */
  hoverColor?: Maybe<Scalars['String']['output']>;
  leftImageUrl?: Maybe<Scalars['String']['output']>;
  mainColor?: Maybe<Scalars['String']['output']>;
  pack: CardPack;
  resetAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  rightImageUrl?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  titleBackgroundUrl?: Maybe<Scalars['String']['output']>;
}

export interface FeaturedLeagues {
  __typename: 'FeaturedLeagues';
  latest: So5League;
  upcoming?: Maybe<So5League>;
}

/** A featured market set section listing the offers the user is eligible to */
export interface FeaturedMarketSection extends MarketSetSection {
  __typename: 'FeaturedMarketSection';
  backgroundUrl?: Maybe<Scalars['String']['output']>;
  endsAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** @deprecated Not used anymore */
  hoverColor?: Maybe<Scalars['String']['output']>;
  items: Array<FeaturedMarketSectionItem>;
  mainColor?: Maybe<Scalars['String']['output']>;
  resetAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  title: Scalars['String']['output'];
  titleBackgroundUrl?: Maybe<Scalars['String']['output']>;
}

/** An offer of the featured market set section */
export interface FeaturedMarketSectionItem {
  __typename: 'FeaturedMarketSectionItem';
  backgroundUrl?: Maybe<Scalars['String']['output']>;
  desktopBackgroundUrl?: Maybe<Scalars['String']['output']>;
  marketItem: CardPack | PurchasableItemsVoucher;
  pictureUrl?: Maybe<Scalars['String']['output']>;
  tag?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  valueProps: Array<FeaturedMarketSectionValueProp>;
}

/** A value prop of an offer of the featured market set section */
export interface FeaturedMarketSectionValueProp {
  __typename: 'FeaturedMarketSectionValueProp';
  colors: Array<Scalars['String']['output']>;
  iconUrl?: Maybe<Scalars['String']['output']>;
  text: Scalars['String']['output'];
}

/** An object representing featured So5 leaderboard contenders */
export interface FeaturedSo5LeaderboardContenders {
  __typename: 'FeaturedSo5LeaderboardContenders';
  so5Fixture: So5Fixture;
  so5LeaderboardContenders: Array<So5LeaderboardContender>;
  so5LeaderboardContendersPaginated: So5LeaderboardContenderConnection;
}


/** An object representing featured So5 leaderboard contenders */
export interface FeaturedSo5LeaderboardContendersso5LeaderboardContendersPaginatedArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
}

/** An object representing featured So5 leaderboard groups */
export interface FeaturedSo5LeaderboardGroups {
  __typename: 'FeaturedSo5LeaderboardGroups';
  so5Fixture: So5Fixture;
  so5LeaderboardGroups: Array<So5LeaderboardGroup | So5League>;
  so5LeaderboardGroupsPaginated: So5LeaderboardGroupInterfaceConnection;
}


/** An object representing featured So5 leaderboard groups */
export interface FeaturedSo5LeaderboardGroupsso5LeaderboardGroupsPaginatedArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
}

/** Starkware fee representation */
export interface Fee {
  __typename: 'Fee';
  feeLimit: Scalars['WeiAmount']['output'];
  sourceVaultId: Scalars['Int']['output'];
  tokenId: Scalars['String']['output'];
}

export interface Fiat {
  __typename: 'Fiat';
  eur: Scalars['Float']['output'];
  gbp: Scalars['Float']['output'];
  usd: Scalars['Float']['output'];
}

export const FiatCurrency = {
  EUR: 'EUR',
  GBP: 'GBP',
  USD: 'USD'
} as const;

export type FiatCurrency = typeof FiatCurrency[keyof typeof FiatCurrency];
/** A Fiat Wallet Account */
export interface FiatWalletAccount extends Node {
  __typename: 'FiatWalletAccount';
  currency?: Maybe<FiatCurrency>;
  id: Scalars['ID']['output'];
}

export const FiatWalletAccountState = {
  OWNER: 'OWNER',
  PAYER: 'PAYER',
  VALIDATED_OWNER: 'VALIDATED_OWNER'
} as const;

export type FiatWalletAccountState = typeof FiatWalletAccountState[keyof typeof FiatWalletAccountState];
export const FiatWalletKycRefusedReason = {
  DOCUMENT_DO_NOT_MATCH_USER_DATA: 'DOCUMENT_DO_NOT_MATCH_USER_DATA',
  DOCUMENT_HAS_EXPIRED: 'DOCUMENT_HAS_EXPIRED',
  DOCUMENT_INCOMPLETE: 'DOCUMENT_INCOMPLETE',
  DOCUMENT_NOT_ACCEPTED: 'DOCUMENT_NOT_ACCEPTED',
  DOCUMENT_UNREADABLE: 'DOCUMENT_UNREADABLE',
  FACE_MATCH_FAIL: 'FACE_MATCH_FAIL',
  UNDERAGE_PERSON: 'UNDERAGE_PERSON'
} as const;

export type FiatWalletKycRefusedReason = typeof FiatWalletKycRefusedReason[keyof typeof FiatWalletKycRefusedReason];
export const FiatWalletKycState = {
  CREATED: 'CREATED',
  OUT_OF_DATE: 'OUT_OF_DATE',
  REFUSED: 'REFUSED',
  VALIDATED: 'VALIDATED',
  VALIDATION_ASKED: 'VALIDATION_ASKED'
} as const;

export type FiatWalletKycState = typeof FiatWalletKycState[keyof typeof FiatWalletKycState];
/** A SO5 player in a fixture */
export interface FixturePlayer extends Node {
  __typename: 'FixturePlayer';
  averageScore?: Maybe<Scalars['Float']['output']>;
  eligibleSo5Scores: Array<BaseballPlayerGameScore | BasketballPlayerGameScore | PlayerGameScore | So5Score>;
  id: Scalars['ID']['output'];
  mainSo5Score?: Maybe<BaseballPlayerGameScore | BasketballPlayerGameScore | PlayerGameScore | So5Score>;
  player: BaseballPlayer | NBAPlayer | Player;
  position: Position;
  projectedScore?: Maybe<Scalars['Float']['output']>;
  score?: Maybe<Scalars['Float']['output']>;
}


/** A SO5 player in a fixture */
export interface FixturePlayeraverageScoreArgs {
  position?: InputMaybe<Position>;
  type: AveragePlayerScore;
}

/** The connection type for FixturePlayer. */
export interface FixturePlayerConnection {
  __typename: 'FixturePlayerConnection';
  /** A list of edges. */
  edges: Array<FixturePlayerEdge>;
  /** A list of nodes. */
  nodes: Array<FixturePlayer>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
}

/** An edge in a connection. */
export interface FixturePlayerEdge {
  __typename: 'FixturePlayerEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<FixturePlayer>;
}

/** Flash sale picks matching the marketplace filters */
export interface FlashSalePicks extends SearchInterface {
  __typename: 'FlashSalePicks';
  campaigns: Array<InstantBuyCampaign>;
  facets: Array<SearchFacet>;
  hitIds: Array<Scalars['String']['output']>;
  nbHits: Scalars['Int']['output'];
  nbPages: Scalars['Int']['output'];
  page: Scalars['Int']['output'];
  processingTimeMs: SearchProcessingTime;
}

export interface FloatRangeInput {
  max?: InputMaybe<Scalars['Float']['input']>;
  min?: InputMaybe<Scalars['Float']['input']>;
}

export interface FootballAverageStatWithValueType extends AnyAverageStatWithValueInterface {
  __typename: 'FootballAverageStatWithValueType';
  lastValues?: Maybe<Array<Scalars['Float']['output']>>;
  stat: AverageStat;
  value?: Maybe<Scalars['Float']['output']>;
}

/** A Football team in a competition */
export interface FootballContestantType extends AnyContestantInterface, Node {
  __typename: 'FootballContestantType';
  gamesDrawn: Scalars['Int']['output'];
  gamesLost: Scalars['Int']['output'];
  gamesPlayed: Scalars['Int']['output'];
  gamesWon: Scalars['Int']['output'];
  goalsAgainst: Scalars['Int']['output'];
  goalsFor: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  matchesDrawn: Scalars['Int']['output'];
  matchesLost: Scalars['Int']['output'];
  matchesPlayed: Scalars['Int']['output'];
  matchesWon: Scalars['Int']['output'];
  points: Scalars['Int']['output'];
  rank?: Maybe<Scalars['Int']['output']>;
  rankStatus?: Maybe<Scalars['String']['output']>;
  rankType?: Maybe<TournamentCalendarRankType>;
  team: Club | NationalTeam;
}

/** A rewardable conversion credit */
export interface FootballConversionCredit {
  __typename: 'FootballConversionCredit';
  durationInDays: Scalars['Int']['output'];
  maxDiscount: MonetaryAmount;
  percentageDiscount: Scalars['Float']['output'];
  singleUse: Scalars['Boolean']['output'];
}

/** A goal within a game */
export interface FootballGoalEvent extends DecisiveEventInterface {
  __typename: 'FootballGoalEvent';
  addedTime?: Maybe<Scalars['Int']['output']>;
  assistPlayer?: Maybe<BaseballPlayer | NBAPlayer | Player>;
  goalType?: Maybe<FootballGoalType>;
  id: Scalars['ID']['output'];
  minute: Scalars['Int']['output'];
  occurredAt: Scalars['ISO8601DateTime']['output'];
  period?: Maybe<Period>;
  player: BaseballPlayer | NBAPlayer | Player;
  stat?: Maybe<Scalars['String']['output']>;
}

export const FootballGoalType = {
  GOAL: 'GOAL',
  OWN_GOAL: 'OWN_GOAL',
  PENALTY_GOAL: 'PENALTY_GOAL'
} as const;

export type FootballGoalType = typeof FootballGoalType[keyof typeof FootballGoalType];
export const FootballPosition = {
  COACH: 'COACH',
  DEFENDER: 'DEFENDER',
  FORWARD: 'FORWARD',
  GOALKEEPER: 'GOALKEEPER',
  MIDFIELDER: 'MIDFIELDER',
  UNKNOWN: 'UNKNOWN'
} as const;

export type FootballPosition = typeof FootballPosition[keyof typeof FootballPosition];
/** A reward shop item */
export interface FootballRewardShopItem {
  __typename: 'FootballRewardShopItem';
  quantity: Scalars['Int']['output'];
  shopItem: ShopItem;
}

/** The Football fields */
export interface FootballRoot {
  __typename: 'FootballRoot';
  /** Get a list of all cards */
  allCards: CardConnection;
  /** Get a card */
  card: Card;
  /** Get a card with its asset ID */
  cardByAssetId: Card;
  /** Get a card with its blockchain ID */
  cardByBlockchainId: Card;
  /** Get a list of cards */
  cards: Array<Card>;
  /** Get a club */
  club: Club;
  /** Get a list of clubs */
  clubs: Array<Club>;
  /** Get the list of clubs that are released and minted */
  clubsReady: Array<Club>;
  /** Get a Competition */
  competition: Competition;
  /** Get Competitions */
  competitions: Array<Competition>;
  currentManagerHasLiveGames: Scalars['Boolean']['output'];
  /** Get a list of cards owned by an ethereum account */
  ethereumCards: Array<Card>;
  /** Get a Game */
  game: Game;
  id: Scalars['ID']['output'];
  leaguesOpenForGameStats: Array<Competition>;
  myLiveGames: Array<Game>;
  myOngoingAndRecentGames: Array<Game>;
  /** Get a national team */
  nationalTeam: NationalTeam;
  /** Get a list of national teams */
  nationalTeams: Array<NationalTeam>;
}


/** The Football fields */
export interface FootballRootallCardsArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  age?: InputMaybe<Scalars['Int']['input']>;
  assetIds?: InputMaybe<Array<Scalars['String']['input']>>;
  before?: InputMaybe<Scalars['String']['input']>;
  classicOnly?: InputMaybe<Scalars['Boolean']['input']>;
  customCardEditionName?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  inActiveCompetitions?: InputMaybe<Array<Scalars['String']['input']>>;
  inSeasonEligible?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  owned?: InputMaybe<Scalars['Boolean']['input']>;
  ownedByMe?: InputMaybe<Scalars['Boolean']['input']>;
  ownedSinceAfter?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  playerSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  positions?: InputMaybe<Array<Position>>;
  rarities?: InputMaybe<Array<Rarity>>;
  revealable?: InputMaybe<Scalars['Boolean']['input']>;
  seasonStartYears?: InputMaybe<Array<Scalars['Int']['input']>>;
  serialNumber?: InputMaybe<Scalars['Int']['input']>;
  shirtNumber?: InputMaybe<Scalars['Int']['input']>;
  slugs?: InputMaybe<Array<Scalars['String']['input']>>;
  sorts?: InputMaybe<Array<CardSort>>;
  sport?: InputMaybe<Sport>;
  teamSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  withinDeckFirst?: InputMaybe<Scalars['String']['input']>;
}


/** The Football fields */
export interface FootballRootcardArgs {
  slug: Scalars['String']['input'];
}


/** The Football fields */
export interface FootballRootcardByAssetIdArgs {
  assetId: Scalars['String']['input'];
}


/** The Football fields */
export interface FootballRootcardByBlockchainIdArgs {
  blockchainId: Scalars['String']['input'];
}


/** The Football fields */
export interface FootballRootcardsArgs {
  age?: InputMaybe<Scalars['Int']['input']>;
  assetIds?: InputMaybe<Array<Scalars['String']['input']>>;
  classicOnly?: InputMaybe<Scalars['Boolean']['input']>;
  customCardEditionName?: InputMaybe<Scalars['String']['input']>;
  inActiveCompetitions?: InputMaybe<Array<Scalars['String']['input']>>;
  inSeasonEligible?: InputMaybe<Scalars['Boolean']['input']>;
  owned?: InputMaybe<Scalars['Boolean']['input']>;
  ownedByMe?: InputMaybe<Scalars['Boolean']['input']>;
  ownedSinceAfter?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  playerSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  positions?: InputMaybe<Array<Position>>;
  rarities?: InputMaybe<Array<Rarity>>;
  revealable?: InputMaybe<Scalars['Boolean']['input']>;
  seasonStartYears?: InputMaybe<Array<Scalars['Int']['input']>>;
  serialNumber?: InputMaybe<Scalars['Int']['input']>;
  shirtNumber?: InputMaybe<Scalars['Int']['input']>;
  slugs?: InputMaybe<Array<Scalars['String']['input']>>;
  sorts?: InputMaybe<Array<CardSort>>;
  sport?: InputMaybe<Sport>;
  teamSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  withinDeckFirst?: InputMaybe<Scalars['String']['input']>;
}


/** The Football fields */
export interface FootballRootclubArgs {
  slug: Scalars['String']['input'];
}


/** The Football fields */
export interface FootballRootclubsArgs {
  slugs: Array<Scalars['String']['input']>;
}


/** The Football fields */
export interface FootballRootcompetitionArgs {
  slug: Scalars['String']['input'];
}


/** The Football fields */
export interface FootballRootcompetitionsArgs {
  slugs: Array<Scalars['String']['input']>;
}


/** The Football fields */
export interface FootballRootcurrentManagerHasLiveGamesArgs {
  sport?: InputMaybe<Sport>;
}


/** The Football fields */
export interface FootballRootethereumCardsArgs {
  address: Scalars['String']['input'];
}


/** The Football fields */
export interface FootballRootgameArgs {
  id: Scalars['ID']['input'];
}


/** The Football fields */
export interface FootballRootleaguesOpenForGameStatsArgs {
  sortType?: InputMaybe<LeaguesSortInput>;
}


/** The Football fields */
export interface FootballRootnationalTeamArgs {
  countryCode?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
}


/** The Football fields */
export interface FootballRootnationalTeamsArgs {
  slugs: Array<Scalars['String']['input']>;
}

export const FootballSanctionCard = {
  RED_CARD: 'RED_CARD',
  SECOND_YELLOW_CARD: 'SECOND_YELLOW_CARD',
  YELLOW_CARD: 'YELLOW_CARD'
} as const;

export type FootballSanctionCard = typeof FootballSanctionCard[keyof typeof FootballSanctionCard];
/** A sanction card given during a game */
export interface FootballSanctionCardEvent extends DecisiveEventInterface {
  __typename: 'FootballSanctionCardEvent';
  addedTime?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  minute: Scalars['Int']['output'];
  occurredAt: Scalars['ISO8601DateTime']['output'];
  period?: Maybe<Period>;
  player: BaseballPlayer | NBAPlayer | Player;
  stat?: Maybe<Scalars['String']['output']>;
  type: FootballSanctionCard;
}

/** So5 No Card Route */
export interface FootballSo5NoCardRouteRoot {
  __typename: 'FootballSo5NoCardRouteRoot';
  /** Get a draftable appearance for the No Card route */
  draftableAppearance?: Maybe<So5NoCardDraftableAppearance>;
  id: Scalars['ID']['output'];
}


/** So5 No Card Route */
export interface FootballSo5NoCardRouteRootdraftableAppearanceArgs {
  so5FixtureId?: InputMaybe<Scalars['ID']['input']>;
}

/** Stats of a team in a game */
export interface FootballTeamGameStats extends TeamGameStatsInterface {
  __typename: 'FootballTeamGameStats';
  accuratePass?: Maybe<Scalars['Int']['output']>;
  blockedScoringAtt?: Maybe<Scalars['Int']['output']>;
  cleanSheet?: Maybe<Scalars['Int']['output']>;
  cleanSheetOdds?: Maybe<Scalars['Float']['output']>;
  cornerTaken?: Maybe<Scalars['Int']['output']>;
  decisiveEvents: Array<FootballGoalEvent | FootballSanctionCardEvent | SubstitutionEvent>;
  drawOddsBasisPoints?: Maybe<Scalars['Int']['output']>;
  foulLost?: Maybe<Scalars['Int']['output']>;
  foulWon?: Maybe<Scalars['Int']['output']>;
  goalAssist?: Maybe<Scalars['Int']['output']>;
  goalKicks?: Maybe<Scalars['Int']['output']>;
  goals: Scalars['Int']['output'];
  goalsConceded: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  loseOddsBasisPoints?: Maybe<Scalars['Int']['output']>;
  lostCorners?: Maybe<Scalars['Int']['output']>;
  midfielderGoals?: Maybe<Scalars['Int']['output']>;
  ontargetScoringAtt?: Maybe<Scalars['Int']['output']>;
  overturnedRedCard?: Maybe<Scalars['Int']['output']>;
  ownGoals?: Maybe<Scalars['Int']['output']>;
  penGoalsConceded?: Maybe<Scalars['Int']['output']>;
  penaltyConceded?: Maybe<Scalars['Int']['output']>;
  penaltyFaced?: Maybe<Scalars['Int']['output']>;
  penaltySave?: Maybe<Scalars['Int']['output']>;
  penaltyWon?: Maybe<Scalars['Int']['output']>;
  possessionPercentageBasisPoints?: Maybe<Scalars['Int']['output']>;
  saves?: Maybe<Scalars['Int']['output']>;
  secondYellow?: Maybe<Scalars['Int']['output']>;
  shotOffTarget?: Maybe<Scalars['Int']['output']>;
  stats?: Maybe<Array<SportStat>>;
  subsMade?: Maybe<Scalars['Int']['output']>;
  threeGoalsOdds?: Maybe<Scalars['Float']['output']>;
  totalClearance?: Maybe<Scalars['Int']['output']>;
  totalOffside?: Maybe<Scalars['Int']['output']>;
  totalPass?: Maybe<Scalars['Int']['output']>;
  totalRedCard?: Maybe<Scalars['Int']['output']>;
  totalScoringAtt?: Maybe<Scalars['Int']['output']>;
  totalSubOn?: Maybe<Scalars['Int']['output']>;
  totalTackle?: Maybe<Scalars['Int']['output']>;
  totalThrows?: Maybe<Scalars['Int']['output']>;
  totalYellowCard?: Maybe<Scalars['Int']['output']>;
  winOddsBasisPoints?: Maybe<Scalars['Int']['output']>;
  wonCorners?: Maybe<Scalars['Int']['output']>;
  wonTackle?: Maybe<Scalars['Int']['output']>;
}

/** A Sorare Football user sport specific profile */
export interface FootballUserSportProfile extends Node, UserSportProfileInterface {
  __typename: 'FootballUserSportProfile';
  achievementBadges?: Maybe<Array<Maybe<SkinShopItem>>>;
  /** @deprecated Not used anymore */
  availableOnboardingLeaderboards: Scalars['Boolean']['output'];
  background?: Maybe<SkinShopItem>;
  bannerColor?: Maybe<Scalars['String']['output']>;
  bannerUrl?: Maybe<Scalars['String']['output']>;
  /**
   * Up to five cards owned in the current set, or in the previous set when no set
   * is active, best gameplay tier and last ten average score first, with a single
   * card per player keeping the rarest edition owned The `best_cards` field cannot
   * be nested within a list.
   */
  bestCards: Array<BaseballCard | Card | NBACard>;
  blueprintCardsCount: Scalars['Int']['output'];
  clubBadge?: Maybe<SkinShopItem>;
  clubName?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use CardSet.starterPackClaimed instead */
  commonGameOnboarded: Scalars['Boolean']['output'];
  /** Get a deck of cards */
  deck?: Maybe<Deck>;
  /** The `decks` field cannot be nested within a list. */
  decks: DeckConnection;
  favoriteTeam?: Maybe<Club | NationalTeam>;
  forceToProOnboarding: Scalars['Boolean']['output'];
  gallerySocialPictureUrls: SocialPictureDerivative;
  highlightPro: Scalars['Boolean']['output'];
  /** The `highlighted_deck` field cannot be nested within a list. */
  highlightedDeck?: Maybe<Deck>;
  id: Scalars['ID']['output'];
  managerProfileSocialPictureUrls: SocialPictureDerivative;
  onboarded: Scalars['Boolean']['output'];
  onboardingCompetitions: Array<Competition>;
  /** @deprecated Not used anymore */
  onboardingLeaderboards: Array<OnboardingLeaderboard>;
  onboardingSo5Fixture?: Maybe<So5Fixture>;
  /**
   * The `onboarding_so5_leaderboard` field cannot be nested within a list.
   * @deprecated Not used anymore
   */
  onboardingSo5Leaderboard?: Maybe<So5Leaderboard>;
  /** A frame to apply on top of user profile picture */
  pictureFrame?: Maybe<PictureFrameShopItem>;
  /** @deprecated Player loyalty is no longer used */
  playerLoyaltyBoost: RewardBoost;
  /** @deprecated Use highlightPro instead */
  proOnboarded: Scalars['Boolean']['output'];
  proUnlocked: Scalars['Boolean']['output'];
  rarityVaultBoost: RewardBoost;
  remainingUnsealsInPeriod: Scalars['Int']['output'];
  selectedUserSportStatistics: Array<Maybe<UserSportStatistic>>;
  shieldUrl?: Maybe<Scalars['String']['output']>;
  socialPictureFingerprint: Scalars['String']['output'];
  tournamentEligibilities: Array<TournamentEligibility>;
  userSportStatistics: Array<UserSportStatistic>;
  variant: UserSportProfileVariant;
}


/** A Sorare Football user sport specific profile */
export interface FootballUserSportProfileavailableOnboardingLeaderboardsArgs {
  rarity?: InputMaybe<Rarity>;
}


/** A Sorare Football user sport specific profile */
export interface FootballUserSportProfilebestCardsArgs {
  skins?: InputMaybe<Array<Skin>>;
}


/** A Sorare Football user sport specific profile */
export interface FootballUserSportProfiledeckArgs {
  name?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
}


/** A Sorare Football user sport specific profile */
export interface FootballUserSportProfiledecksArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
}


/** A Sorare Football user sport specific profile */
export interface FootballUserSportProfileonboardingLeaderboardsArgs {
  rarity?: InputMaybe<Rarity>;
}


/** A Sorare Football user sport specific profile */
export interface FootballUserSportProfileplayerLoyaltyBoostArgs {
  editedSeasonsCount: Scalars['Int']['input'];
  sealedCards: Scalars['Int']['input'];
}


/** A Sorare Football user sport specific profile */
export interface FootballUserSportProfilerarityVaultBoostArgs {
  rarity: Rarity;
  sport: Sport;
  unseals?: InputMaybe<Scalars['Int']['input']>;
}


/** A Sorare Football user sport specific profile */
export interface FootballUserSportProfileremainingUnsealsInPeriodArgs {
  rarity: Rarity;
}

/** The For You fields */
export interface ForYouRoot {
  __typename: 'ForYouRoot';
  featuredLeagues: Array<So5League>;
  featuredLeaguesWithUpcoming: Array<FeaturedLeagues>;
  friendsRecentPurchases: Array<TokenOwner>;
  myIncompleteCardCollectionsPaginated: IncompleteCardCollectionConnection;
  winningLineup?: Maybe<WinningLineup>;
}


/** The For You fields */
export interface ForYouRootfeaturedLeaguesArgs {
  sport: Sport;
}


/** The For You fields */
export interface ForYouRootfeaturedLeaguesWithUpcomingArgs {
  sport: Sport;
}


/** The For You fields */
export interface ForYouRootfriendsRecentPurchasesArgs {
  rarity?: InputMaybe<Rarity>;
  so5CompetitionSlug?: InputMaybe<Scalars['String']['input']>;
  sport?: InputMaybe<Sport>;
}


/** The For You fields */
export interface ForYouRootmyIncompleteCardCollectionsPaginatedArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  so5LeagueSlug: Scalars['String']['input'];
}


/** The For You fields */
export interface ForYouRootwinningLineupArgs {
  so5LeagueSlug: Scalars['String']['input'];
}

/** The starkware Full withdrawal */
export interface FullWithdrawalRequest extends Node {
  __typename: 'FullWithdrawalRequest';
  id: Scalars['ID']['output'];
  served: Scalars['Boolean']['output'];
  valid: Scalars['Boolean']['output'];
}

/** The currentUserGallery cards rule of a So5Leaderboard */
export interface GalleryCards {
  __typename: 'GalleryCards';
  common?: Maybe<ValueOpenBoundaries>;
  customSeries?: Maybe<ValueOpenBoundaries>;
  limited?: Maybe<ValueOpenBoundaries>;
  pro?: Maybe<ValueOpenBoundaries>;
  rare?: Maybe<ValueOpenBoundaries>;
  superRare?: Maybe<ValueOpenBoundaries>;
  unique?: Maybe<ValueOpenBoundaries>;
}

/** A professional football game */
export interface Game extends AnyGameInterface, Node {
  __typename: 'Game';
  /** The `any_players` field cannot be nested within a list. */
  anyPlayers: Array<BaseballPlayer | NBAPlayer | Player>;
  awayFormation: TeamFormation;
  awayGoals: Scalars['Int']['output'];
  awayScore: Scalars['Int']['output'];
  awayStats?: Maybe<BaseballTeamGameStats | BasketballTeamGameStats | FootballTeamGameStats>;
  awayTeam?: Maybe<Club | NationalTeam>;
  competition: Competition;
  coverageStatus: GameCoverageStatus;
  date: Scalars['ISO8601DateTime']['output'];
  extraTimeScoreAway?: Maybe<Scalars['Int']['output']>;
  extraTimeScoreHome?: Maybe<Scalars['Int']['output']>;
  homeFormation: TeamFormation;
  homeGoals: Scalars['Int']['output'];
  homeScore: Scalars['Int']['output'];
  homeStats?: Maybe<BaseballTeamGameStats | BasketballTeamGameStats | FootballTeamGameStats>;
  homeTeam?: Maybe<Club | NationalTeam>;
  id: Scalars['ID']['output'];
  lowCoverage: Scalars['Boolean']['output'];
  minute: Scalars['Int']['output'];
  /** The `my_best_by_player_cards` field cannot be nested within a list. */
  myBestByPlayerCards: AnyCardWithPlayerGameScoreConnection;
  /** The `my_cards` field cannot be nested within a list. */
  myCards: AnyCardInterfaceConnection;
  mySo5Appearances: Array<So5Appearance>;
  mySo5AppearancesPaginated: So5AppearanceConnection;
  mySo5LeaderboardContenders: Array<So5LeaderboardContender>;
  mySo5Lineups: Array<So5Lineup>;
  penaltyScoreAway?: Maybe<Scalars['Int']['output']>;
  penaltyScoreHome?: Maybe<Scalars['Int']['output']>;
  periodType: Period;
  /** Score for a Game for a specific player and his current position */
  playerGameScore?: Maybe<BaseballPlayerGameScore | BasketballPlayerGameScore | PlayerGameScore | So5Score>;
  /** The `player_game_scores` field cannot be nested within a list. */
  playerGameScores: Array<BaseballPlayerGameScore | BasketballPlayerGameScore | PlayerGameScore | So5Score>;
  /** The `players` field cannot be nested within a list. */
  players: Array<Player>;
  scored: Scalars['Boolean']['output'];
  so5Fixture?: Maybe<So5Fixture>;
  /** So5Score of a Game for a specific player and his current position */
  so5Score?: Maybe<So5Score>;
  sport: Sport;
  statusTyped: GameStatus;
  venue?: Maybe<Scalars['String']['output']>;
  venueTyped?: Maybe<Venue>;
  winner?: Maybe<Club | NationalTeam>;
}


/** A professional football game */
export interface GamemyBestByPlayerCardsArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  rarities?: InputMaybe<Array<Rarity>>;
}


/** A professional football game */
export interface GamemyCardsArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  age?: InputMaybe<Scalars['Int']['input']>;
  assetIds?: InputMaybe<Array<Scalars['String']['input']>>;
  before?: InputMaybe<Scalars['String']['input']>;
  classicOnly?: InputMaybe<Scalars['Boolean']['input']>;
  customCardEditionName?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  inActiveCompetitions?: InputMaybe<Array<Scalars['String']['input']>>;
  inSeasonEligible?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  owned?: InputMaybe<Scalars['Boolean']['input']>;
  ownedByMe?: InputMaybe<Scalars['Boolean']['input']>;
  ownedSinceAfter?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  playerSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  positions?: InputMaybe<Array<Position>>;
  rarities?: InputMaybe<Array<Rarity>>;
  revealable?: InputMaybe<Scalars['Boolean']['input']>;
  seasonStartYears?: InputMaybe<Array<Scalars['Int']['input']>>;
  serialNumber?: InputMaybe<Scalars['Int']['input']>;
  shirtNumber?: InputMaybe<Scalars['Int']['input']>;
  slugs?: InputMaybe<Array<Scalars['String']['input']>>;
  sorts?: InputMaybe<Array<CardSort>>;
  sport?: InputMaybe<Sport>;
  teamSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  withinDeckFirst?: InputMaybe<Scalars['String']['input']>;
}


/** A professional football game */
export interface GamemySo5AppearancesPaginatedArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
}


/** A professional football game */
export interface GameplayerGameScoreArgs {
  playerSlug: Scalars['String']['input'];
  position?: InputMaybe<Position>;
}


/** A professional football game */
export interface GameplayerGameScoresArgs {
  includingLegends?: InputMaybe<Scalars['Boolean']['input']>;
}


/** A professional football game */
export interface Gameso5FixtureArgs {
  so5FixtureType?: InputMaybe<So5FixtureEvent>;
}


/** A professional football game */
export interface Gameso5ScoreArgs {
  playerSlug: Scalars['String']['input'];
  position?: InputMaybe<Position>;
}

/** The connection type for Game. */
export interface GameConnection {
  __typename: 'GameConnection';
  /** A list of edges. */
  edges: Array<GameEdge>;
  /** A list of nodes. */
  nodes: Array<Game>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
}

export const GameCoverageStatus = {
  FULL: 'FULL',
  LOW: 'LOW',
  NOT_COVERED: 'NOT_COVERED',
  UNCERTAIN: 'UNCERTAIN'
} as const;

export type GameCoverageStatus = typeof GameCoverageStatus[keyof typeof GameCoverageStatus];
/** A game day */
export interface GameDay extends Node {
  __typename: 'GameDay';
  date: Scalars['ISO8601Date']['output'];
  id: Scalars['ID']['output'];
}

/** The connection type for GameDay. */
export interface GameDayConnection {
  __typename: 'GameDayConnection';
  /** A list of edges. */
  edges: Array<GameDayEdge>;
  /** A list of nodes. */
  nodes: Array<GameDay>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
}

/** An edge in a connection. */
export interface GameDayEdge {
  __typename: 'GameDayEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<GameDay>;
}

/** An edge in a connection. */
export interface GameEdge {
  __typename: 'GameEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<Game>;
}

export const GameMode = {
  PRO: 'PRO',
  RIVALS: 'RIVALS',
  RIVALS_SQUAD: 'RIVALS_SQUAD'
} as const;

export type GameMode = typeof GameMode[keyof typeof GameMode];
/** A baseball game */
export interface GameOfBaseball extends AnyGameInterface {
  __typename: 'GameOfBaseball';
  /** The `any_players` field cannot be nested within a list. */
  anyPlayers: Array<BaseballPlayer | NBAPlayer | Player>;
  awayErrors?: Maybe<Scalars['Int']['output']>;
  awayHits?: Maybe<Scalars['Int']['output']>;
  awayProbablePitcher?: Maybe<BaseballPlayer>;
  awayScore: Scalars['Int']['output'];
  awayStats?: Maybe<BaseballTeamGameStats | BasketballTeamGameStats | FootballTeamGameStats>;
  awayTeam?: Maybe<Club | NationalTeam>;
  competition: Competition;
  date: Scalars['ISO8601DateTime']['output'];
  hitterPlayerGameScore?: Maybe<BaseballPlayerGameScore>;
  homeErrors?: Maybe<Scalars['Int']['output']>;
  homeHits?: Maybe<Scalars['Int']['output']>;
  homeProbablePitcher?: Maybe<BaseballPlayer>;
  homeScore: Scalars['Int']['output'];
  homeStats?: Maybe<BaseballTeamGameStats | BasketballTeamGameStats | FootballTeamGameStats>;
  homeTeam?: Maybe<Club | NationalTeam>;
  id: Scalars['ID']['output'];
  inning: Inning;
  losingPitcher?: Maybe<BaseballPlayer>;
  lowCoverage: Scalars['Boolean']['output'];
  /** The `my_best_by_player_cards` field cannot be nested within a list. */
  myBestByPlayerCards: AnyCardWithPlayerGameScoreConnection;
  /** The `my_cards` field cannot be nested within a list. */
  myCards: AnyCardInterfaceConnection;
  mySo5Appearances: Array<So5Appearance>;
  mySo5AppearancesPaginated: So5AppearanceConnection;
  mySo5LeaderboardContenders: Array<So5LeaderboardContender>;
  mySo5Lineups: Array<So5Lineup>;
  pitcherPlayerGameScore?: Maybe<BaseballPlayerGameScore>;
  /** Score for a Game for a specific player and his current position */
  playerGameScore?: Maybe<BaseballPlayerGameScore | BasketballPlayerGameScore | PlayerGameScore | So5Score>;
  /** The `player_game_scores` field cannot be nested within a list. */
  playerGameScores: Array<BaseballPlayerGameScore | BasketballPlayerGameScore | PlayerGameScore | So5Score>;
  probablePitchers: Array<BaseballPlayer>;
  scored: Scalars['Boolean']['output'];
  scoresByInning?: Maybe<Array<PeriodScore>>;
  so5Fixture?: Maybe<So5Fixture>;
  sport: Sport;
  statusTyped: GameStatus;
  venue?: Maybe<Scalars['String']['output']>;
  venueTyped?: Maybe<Venue>;
  winner?: Maybe<Club | NationalTeam>;
  winningPitcher?: Maybe<BaseballPlayer>;
}


/** A baseball game */
export interface GameOfBaseballhitterPlayerGameScoreArgs {
  playerSlug: Scalars['String']['input'];
}


/** A baseball game */
export interface GameOfBaseballmyBestByPlayerCardsArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  rarities?: InputMaybe<Array<Rarity>>;
}


/** A baseball game */
export interface GameOfBaseballmyCardsArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  age?: InputMaybe<Scalars['Int']['input']>;
  assetIds?: InputMaybe<Array<Scalars['String']['input']>>;
  before?: InputMaybe<Scalars['String']['input']>;
  classicOnly?: InputMaybe<Scalars['Boolean']['input']>;
  customCardEditionName?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  inActiveCompetitions?: InputMaybe<Array<Scalars['String']['input']>>;
  inSeasonEligible?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  owned?: InputMaybe<Scalars['Boolean']['input']>;
  ownedByMe?: InputMaybe<Scalars['Boolean']['input']>;
  ownedSinceAfter?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  playerSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  positions?: InputMaybe<Array<Position>>;
  rarities?: InputMaybe<Array<Rarity>>;
  revealable?: InputMaybe<Scalars['Boolean']['input']>;
  seasonStartYears?: InputMaybe<Array<Scalars['Int']['input']>>;
  serialNumber?: InputMaybe<Scalars['Int']['input']>;
  shirtNumber?: InputMaybe<Scalars['Int']['input']>;
  slugs?: InputMaybe<Array<Scalars['String']['input']>>;
  sorts?: InputMaybe<Array<CardSort>>;
  sport?: InputMaybe<Sport>;
  teamSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  withinDeckFirst?: InputMaybe<Scalars['String']['input']>;
}


/** A baseball game */
export interface GameOfBaseballmySo5AppearancesPaginatedArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
}


/** A baseball game */
export interface GameOfBaseballpitcherPlayerGameScoreArgs {
  playerSlug: Scalars['String']['input'];
}


/** A baseball game */
export interface GameOfBaseballplayerGameScoreArgs {
  playerSlug: Scalars['String']['input'];
  position?: InputMaybe<Position>;
}


/** A baseball game */
export interface GameOfBaseballplayerGameScoresArgs {
  includingLegends?: InputMaybe<Scalars['Boolean']['input']>;
}


/** A baseball game */
export interface GameOfBaseballso5FixtureArgs {
  so5FixtureType?: InputMaybe<So5FixtureEvent>;
}

/** A basketball game */
export interface GameOfBasketball extends AnyGameInterface {
  __typename: 'GameOfBasketball';
  /** The `any_players` field cannot be nested within a list. */
  anyPlayers: Array<BaseballPlayer | NBAPlayer | Player>;
  awayScore: Scalars['Int']['output'];
  awayStats?: Maybe<BaseballTeamGameStats | BasketballTeamGameStats | FootballTeamGameStats>;
  awayTeam?: Maybe<Club | NationalTeam>;
  competition: Competition;
  date: Scalars['ISO8601DateTime']['output'];
  homeScore: Scalars['Int']['output'];
  homeStats?: Maybe<BaseballTeamGameStats | BasketballTeamGameStats | FootballTeamGameStats>;
  homeTeam?: Maybe<Club | NationalTeam>;
  id: Scalars['ID']['output'];
  isHalftime: Scalars['Boolean']['output'];
  lowCoverage: Scalars['Boolean']['output'];
  /** The `my_best_by_player_cards` field cannot be nested within a list. */
  myBestByPlayerCards: AnyCardWithPlayerGameScoreConnection;
  /** The `my_cards` field cannot be nested within a list. */
  myCards: AnyCardInterfaceConnection;
  mySo5Appearances: Array<So5Appearance>;
  mySo5AppearancesPaginated: So5AppearanceConnection;
  mySo5LeaderboardContenders: Array<So5LeaderboardContender>;
  mySo5Lineups: Array<So5Lineup>;
  /** Score for a Game for a specific player and his current position */
  playerGameScore?: Maybe<BaseballPlayerGameScore | BasketballPlayerGameScore | PlayerGameScore | So5Score>;
  /** The `player_game_scores` field cannot be nested within a list. */
  playerGameScores: Array<BaseballPlayerGameScore | BasketballPlayerGameScore | PlayerGameScore | So5Score>;
  quarter: Scalars['Int']['output'];
  scored: Scalars['Boolean']['output'];
  scoresByQuarter?: Maybe<Array<PeriodScore>>;
  so5Fixture?: Maybe<So5Fixture>;
  sport: Sport;
  statusTyped: GameStatus;
  venue?: Maybe<Scalars['String']['output']>;
  venueTyped?: Maybe<Venue>;
  winner?: Maybe<Club | NationalTeam>;
}


/** A basketball game */
export interface GameOfBasketballmyBestByPlayerCardsArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  rarities?: InputMaybe<Array<Rarity>>;
}


/** A basketball game */
export interface GameOfBasketballmyCardsArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  age?: InputMaybe<Scalars['Int']['input']>;
  assetIds?: InputMaybe<Array<Scalars['String']['input']>>;
  before?: InputMaybe<Scalars['String']['input']>;
  classicOnly?: InputMaybe<Scalars['Boolean']['input']>;
  customCardEditionName?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  inActiveCompetitions?: InputMaybe<Array<Scalars['String']['input']>>;
  inSeasonEligible?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  owned?: InputMaybe<Scalars['Boolean']['input']>;
  ownedByMe?: InputMaybe<Scalars['Boolean']['input']>;
  ownedSinceAfter?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  playerSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  positions?: InputMaybe<Array<Position>>;
  rarities?: InputMaybe<Array<Rarity>>;
  revealable?: InputMaybe<Scalars['Boolean']['input']>;
  seasonStartYears?: InputMaybe<Array<Scalars['Int']['input']>>;
  serialNumber?: InputMaybe<Scalars['Int']['input']>;
  shirtNumber?: InputMaybe<Scalars['Int']['input']>;
  slugs?: InputMaybe<Array<Scalars['String']['input']>>;
  sorts?: InputMaybe<Array<CardSort>>;
  sport?: InputMaybe<Sport>;
  teamSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  withinDeckFirst?: InputMaybe<Scalars['String']['input']>;
}


/** A basketball game */
export interface GameOfBasketballmySo5AppearancesPaginatedArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
}


/** A basketball game */
export interface GameOfBasketballplayerGameScoreArgs {
  playerSlug: Scalars['String']['input'];
  position?: InputMaybe<Position>;
}


/** A basketball game */
export interface GameOfBasketballplayerGameScoresArgs {
  includingLegends?: InputMaybe<Scalars['Boolean']['input']>;
}


/** A basketball game */
export interface GameOfBasketballso5FixtureArgs {
  so5FixtureType?: InputMaybe<So5FixtureEvent>;
}

export const GameStatus = {
  cancelled: 'cancelled',
  played: 'played',
  playing: 'playing',
  postponed: 'postponed',
  scheduled: 'scheduled',
  suspended: 'suspended'
} as const;

export type GameStatus = typeof GameStatus[keyof typeof GameStatus];
/** Game Weekly Task */
export interface GameWeeklyTask extends GameWeeklyTaskInterface, ManagerTaskInterface, TaskInterface {
  __typename: 'GameWeeklyTask';
  aasmState: ManagerProgressionTaskState;
  alternativeRewardConfigs?: Maybe<Array<AlternativeRewardConfig>>;
  /** @deprecated Not used anymore */
  cards: Array<BaseballCard | Card | NBACard>;
  claimableAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** @deprecated Not used anymore */
  claimedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  color?: Maybe<Scalars['String']['output']>;
  completedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  description: Scalars['String']['output'];
  expired: Scalars['Boolean']['output'];
  genre: TaskGenre;
  group?: Maybe<TaskGroup>;
  iconUrl?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  jonumGated: Scalars['Boolean']['output'];
  /** The points this task earned on a ladder leaderboard, empty when it feeds none. */
  ladderContributions: Array<LadderContribution>;
  /** The `my_reward_pool_shares` field cannot be nested within a list. */
  myRewardPoolShares?: Maybe<Array<RewardPoolShare>>;
  name: ManagerProgressionTaskSlug;
  parentTask?: Maybe<CardsCountTargetTask | CardsCountTask | CompleteCollectionsCountTargetTask | CompleteCollectionsCountTask | DailyActionTask | DecisivePlayerPickerTask | DropChallengeTask | GameWeeklyTask | GuessTheScoreTask | InviteTaskAsReferrer | So5LeaderboardTask | StarPackTask | Task | TasksTrack | ThresholdPickerTask | ThresholdsDuoConnectionTask | ThresholdsStreakAdditionalLineupTask | ThresholdsStreakTask>;
  periodicity?: Maybe<ManagerTaskPeriodicity>;
  pickOrList: Scalars['Boolean']['output'];
  possibleRewardConfigsIconUrl?: Maybe<Scalars['String']['output']>;
  /** @deprecated Not used anymore */
  probabilisticBundles: Array<ProbabilisticBundle>;
  progress: Scalars['Int']['output'];
  rarity?: Maybe<Rarity>;
  rewardConfigs: Array<CardPacksRewardConfig | CardRewardConfig | CardShardRewardConfig | CoinRewardConfig | ConversionCreditRewardConfig | DeliverableItemRewardConfig | ExperienceRewardConfig | InGameCurrencyRewardConfig | MonetaryRewardConfig | ProbabilisticBundleRewardConfig | ShopItemRewardConfig>;
  /** The `reward_pool_shares` field cannot be nested within a list. */
  rewardPoolShares?: Maybe<RewardPoolShareConnection>;
  so5Fixture: So5Fixture;
  startDate?: Maybe<Scalars['ISO8601DateTime']['output']>;
  target: Scalars['Int']['output'];
  taskConfigSlug: Scalars['String']['output'];
  templateIconUrl: Scalars['String']['output'];
  title: Scalars['String']['output'];
  uncapped: Scalars['Boolean']['output'];
}


/** Game Weekly Task */
export interface GameWeeklyTaskcolorArgs {
  variant?: InputMaybe<ColorVariant>;
}


/** Game Weekly Task */
export interface GameWeeklyTaskrewardConfigsArgs {
  mergedConfigsByType?: InputMaybe<Scalars['Boolean']['input']>;
}


/** Game Weekly Task */
export interface GameWeeklyTaskrewardPoolSharesArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
}

/** Manager Task */
export interface GameWeeklyTaskInterface {
  aasmState: ManagerProgressionTaskState;
  alternativeRewardConfigs?: Maybe<Array<AlternativeRewardConfig>>;
  /** @deprecated Not used anymore */
  cards: Array<BaseballCard | Card | NBACard>;
  claimableAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** @deprecated Not used anymore */
  claimedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  color?: Maybe<Scalars['String']['output']>;
  completedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  description: Scalars['String']['output'];
  expired: Scalars['Boolean']['output'];
  genre: TaskGenre;
  group?: Maybe<TaskGroup>;
  iconUrl?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  jonumGated: Scalars['Boolean']['output'];
  /** The points this task earned on a ladder leaderboard, empty when it feeds none. */
  ladderContributions: Array<LadderContribution>;
  /** The `my_reward_pool_shares` field cannot be nested within a list. */
  myRewardPoolShares?: Maybe<Array<RewardPoolShare>>;
  name: ManagerProgressionTaskSlug;
  parentTask?: Maybe<CardsCountTargetTask | CardsCountTask | CompleteCollectionsCountTargetTask | CompleteCollectionsCountTask | DailyActionTask | DecisivePlayerPickerTask | DropChallengeTask | GameWeeklyTask | GuessTheScoreTask | InviteTaskAsReferrer | So5LeaderboardTask | StarPackTask | Task | TasksTrack | ThresholdPickerTask | ThresholdsDuoConnectionTask | ThresholdsStreakAdditionalLineupTask | ThresholdsStreakTask>;
  periodicity?: Maybe<ManagerTaskPeriodicity>;
  pickOrList: Scalars['Boolean']['output'];
  possibleRewardConfigsIconUrl?: Maybe<Scalars['String']['output']>;
  /** @deprecated Not used anymore */
  probabilisticBundles: Array<ProbabilisticBundle>;
  progress: Scalars['Int']['output'];
  rarity?: Maybe<Rarity>;
  rewardConfigs: Array<CardPacksRewardConfig | CardRewardConfig | CardShardRewardConfig | CoinRewardConfig | ConversionCreditRewardConfig | DeliverableItemRewardConfig | ExperienceRewardConfig | InGameCurrencyRewardConfig | MonetaryRewardConfig | ProbabilisticBundleRewardConfig | ShopItemRewardConfig>;
  /** The `reward_pool_shares` field cannot be nested within a list. */
  rewardPoolShares?: Maybe<RewardPoolShareConnection>;
  so5Fixture: So5Fixture;
  startDate?: Maybe<Scalars['ISO8601DateTime']['output']>;
  target: Scalars['Int']['output'];
  taskConfigSlug: Scalars['String']['output'];
  templateIconUrl: Scalars['String']['output'];
  title: Scalars['String']['output'];
  uncapped: Scalars['Boolean']['output'];
}


/** Manager Task */
export interface GameWeeklyTaskInterfacecolorArgs {
  variant?: InputMaybe<ColorVariant>;
}


/** Manager Task */
export interface GameWeeklyTaskInterfacerewardConfigsArgs {
  mergedConfigsByType?: InputMaybe<Scalars['Boolean']['input']>;
}


/** Manager Task */
export interface GameWeeklyTaskInterfacerewardPoolSharesArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
}

export interface GameWithCardsPreview {
  __typename: 'GameWithCardsPreview';
  cards: Array<BaseballCard | Card | NBACard>;
  cardsWithPlayerGameScores: Array<AnyCardWithPlayerGameScore>;
  game: Game | GameOfBaseball | GameOfBasketball;
  id: Scalars['String']['output'];
  totalCount: Scalars['Int']['output'];
}

/** The connection type for GameWithCardsPreview. */
export interface GameWithCardsPreviewConnection {
  __typename: 'GameWithCardsPreviewConnection';
  /** A list of edges. */
  edges: Array<GameWithCardsPreviewEdge>;
  hasAny: Scalars['Boolean']['output'];
  /** A list of nodes. */
  nodes: Array<GameWithCardsPreview>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
}

/** An edge in a connection. */
export interface GameWithCardsPreviewEdge {
  __typename: 'GameWithCardsPreviewEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<GameWithCardsPreview>;
}

export const GameWithCardsPreviewSortType = {
  CARDS_TOTAL_COUNT: 'CARDS_TOTAL_COUNT',
  GAME_DATE: 'GAME_DATE'
} as const;

export type GameWithCardsPreviewSortType = typeof GameWithCardsPreviewSortType[keyof typeof GameWithCardsPreviewSortType];
export interface GameWithPlayerGameScoresPreview {
  __typename: 'GameWithPlayerGameScoresPreview';
  game: Game | GameOfBaseball | GameOfBasketball;
  playerGameScores: Array<BaseballPlayerGameScore | BasketballPlayerGameScore | PlayerGameScore | So5Score>;
  totalCount: Scalars['Int']['output'];
}

/** The connection type for GameWithPlayerGameScoresPreview. */
export interface GameWithPlayerGameScoresPreviewConnection {
  __typename: 'GameWithPlayerGameScoresPreviewConnection';
  /** A list of edges. */
  edges: Array<GameWithPlayerGameScoresPreviewEdge>;
  hasAny: Scalars['Boolean']['output'];
  /** A list of nodes. */
  nodes: Array<GameWithPlayerGameScoresPreview>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
}

/** An edge in a connection. */
export interface GameWithPlayerGameScoresPreviewEdge {
  __typename: 'GameWithPlayerGameScoresPreviewEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<GameWithPlayerGameScoresPreview>;
}

export const GameplayTier = {
  DNP: 'DNP',
  DNP_PLUS: 'DNP_PLUS',
  GOAT: 'GOAT',
  IMPACT: 'IMPACT',
  IMPACT_PLUS: 'IMPACT_PLUS',
  ROSTER: 'ROSTER',
  ROSTER_PLUS: 'ROSTER_PLUS',
  STAR: 'STAR',
  STAR_PLUS: 'STAR_PLUS'
} as const;

export type GameplayTier = typeof GameplayTier[keyof typeof GameplayTier];
/** The aggregated draw odds of a gameplay tier within a pack slot */
export interface GameplayTierOdds {
  __typename: 'GameplayTierOdds';
  gameplayTier: GameplayTier;
  /** Flat, rarity-agnostic per-player odds of this tier (use instead of skinOdds) */
  playerOdds: Array<PackPlayerOdds>;
  /** Sum of this tier players draw probability in basis points (1 bp = 0.01%) */
  probabilityBasisPoint: Scalars['Float']['output'];
  /** @deprecated Use playerOdds instead */
  skinOdds: Array<SkinTierOdds>;
}

/** The star rating a gameplay tier stands for */
export interface GameplayTierRating {
  __typename: 'GameplayTierRating';
  gameplayTier: GameplayTier;
  stars: Scalars['Float']['output'];
}

/** A Mangopay GB bank account type */
export interface GbBankAccount extends BankAccountInterface, Node {
  __typename: 'GbBankAccount';
  /** Account number (last 4 digits) */
  accountNumber: Scalars['String']['output'];
  country: Country;
  id: Scalars['ID']['output'];
  minimumWithdrawalAmounts: MonetaryAmount;
  ownerAddress?: Maybe<MangopayBankAccountOwnerAddress>;
  ownerName?: Maybe<Scalars['String']['output']>;
  /** Sort code */
  sortCode: Scalars['String']['output'];
  status?: Maybe<MangopayBankAccountStatus>;
  withdrawalFeeAmounts: MonetaryAmount;
  withdrawalFeeType: MangopayBankAccountWithdrawalFeeType;
}

/** A gems shop market set section */
export interface GemsShop extends MarketSetSection {
  __typename: 'GemsShop';
  backgroundUrl?: Maybe<Scalars['String']['output']>;
  endsAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** @deprecated Not used anymore */
  hoverColor?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use purchasableItems instead */
  inGameCurrencyPurchasableItems: Array<InGameCurrencyPurchasableItem>;
  mainColor?: Maybe<Scalars['String']['output']>;
  purchasableItems: Array<BundledPurchasableItem | CardShardsPurchasableItem | InGameCurrencyPurchasableItem | PackConfigPurchasableItem>;
  resetAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  title: Scalars['String']['output'];
  titleBackgroundUrl?: Maybe<Scalars['String']['output']>;
}

/** A spotlight with no typed subject beyond its own copy and assets */
export interface GenericSpotlight extends Node, Spotlight {
  __typename: 'GenericSpotlight';
  backgroundUrl?: Maybe<Scalars['String']['output']>;
  body?: Maybe<Scalars['String']['output']>;
  category: SpotlightCategory;
  /** Card accent as a #RRGGBB hex code */
  color?: Maybe<Scalars['String']['output']>;
  ctaLabel?: Maybe<Scalars['String']['output']>;
  /** Deep link to open on tap */
  ctaUrl?: Maybe<Scalars['String']['output']>;
  /** Deep link to open on tap, when the spotlight targets the app */
  deeplinkUrl?: Maybe<Scalars['String']['output']>;
  endDate: Scalars['ISO8601DateTime']['output'];
  featured: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  /** Optional callout artwork displayed alongside the shortcut badge */
  shortcutBadgeCalloutUrl?: Maybe<Scalars['String']['output']>;
  /** Featured-only badge for the Play entry point */
  shortcutBadgeUrl?: Maybe<Scalars['String']['output']>;
  /** Accessibility and analytics label for the shortcut badge */
  shortcutName?: Maybe<Scalars['String']['output']>;
  /** Whether to count down to endDate rather than label the spotlight as live */
  showCountdown: Scalars['Boolean']['output'];
  startDate: Scalars['ISO8601DateTime']['output'];
  statTiles: Array<SpotlightStatTile>;
  tagChips: Array<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  /** Whether the current user already tapped this spotlight, false when anonymous */
  viewed: Scalars['Boolean']['output'];
}

/** Guess The Score Task */
export interface GuessTheScoreTask extends ManagerTaskInterface, TaskInterface, WithComposeTeamInterface {
  __typename: 'GuessTheScoreTask';
  aasmState: ManagerProgressionTaskState;
  alternativeRewardConfigs?: Maybe<Array<AlternativeRewardConfig>>;
  /** @deprecated Not used anymore */
  cards: Array<BaseballCard | Card | NBACard>;
  claimableAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** @deprecated Not used anymore */
  claimedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Whether some appearances are filled by a contributor rather than the lineup owner. */
  collaborative: Scalars['Boolean']['output'];
  color?: Maybe<Scalars['String']['output']>;
  completedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  defaultSortType: BenchSort;
  description: Scalars['String']['output'];
  displayedTypedRules: Array<CardsCountAsFirstOwnerRule | OwnedSinceRule | PlayerHeightRule | SeasonsRule | So5ActiveClubsRule | So5ActiveNationalTeamsRule | So5AgeRule | So5AppearancesRule | So5AtLeastOfClubs | So5AtLeastOfCompetitions | So5AverageScoresRule | So5CaptainRule | So5CaptainScarcityRule | So5CardEditionsCountRule | So5CompetitionsRule | So5EntryItemRule | So5MaximumPlayersAverageScoreRule | So5MinimumPlayersAverageScoreRule | So5NationalityRule | So5NotNationalityRule | So5SameActiveClubRule | So5ScarcityRule | So5SeasonBonusRule | VaultPointsRule>;
  engineConfiguration: EngineConfiguration;
  expired: Scalars['Boolean']['output'];
  game: Game | GameOfBaseball | GameOfBasketball;
  genre: TaskGenre;
  group?: Maybe<TaskGroup>;
  /** The `highlighted_recommendations` field cannot be nested within a list. */
  highlightedRecommendations: Array<PlayerRecommendation>;
  iconUrl?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  jonumGated: Scalars['Boolean']['output'];
  /** The points this task earned on a ladder leaderboard, empty when it feeds none. */
  ladderContributions: Array<LadderContribution>;
  leftPlayer?: Maybe<BaseballPlayer | NBAPlayer | Player>;
  maxTargetScore: Scalars['Int']['output'];
  minTargetScore: Scalars['Int']['output'];
  /** The `my_filtered_bench` field cannot be nested within a list. */
  myFilteredBench: ComposeTeamBenchObjectInterfaceConnection;
  myLineups: Array<GuessTheScoreTaskLineup | So5Lineup | TaskLineup | ThresholdPickerTaskLineup>;
  /** The `my_reward_pool_shares` field cannot be nested within a list. */
  myRewardPoolShares?: Maybe<Array<RewardPoolShare>>;
  name: ManagerProgressionTaskSlug;
  parentTask?: Maybe<CardsCountTargetTask | CardsCountTask | CompleteCollectionsCountTargetTask | CompleteCollectionsCountTask | DailyActionTask | DecisivePlayerPickerTask | DropChallengeTask | GameWeeklyTask | GuessTheScoreTask | InviteTaskAsReferrer | So5LeaderboardTask | StarPackTask | Task | TasksTrack | ThresholdPickerTask | ThresholdsDuoConnectionTask | ThresholdsStreakAdditionalLineupTask | ThresholdsStreakTask>;
  periodicity?: Maybe<ManagerTaskPeriodicity>;
  pickOrList: Scalars['Boolean']['output'];
  possibleBenchSortingTypes: Array<SortingType>;
  possibleRewardConfigsIconUrl?: Maybe<Scalars['String']['output']>;
  previewSo5Lineup: ComposeTeamLineupPreview;
  /** @deprecated Not used anymore */
  probabilisticBundles: Array<ProbabilisticBundle>;
  progress: Scalars['Int']['output'];
  rarity?: Maybe<Rarity>;
  rewardConfigs: Array<CardPacksRewardConfig | CardRewardConfig | CardShardRewardConfig | CoinRewardConfig | ConversionCreditRewardConfig | DeliverableItemRewardConfig | ExperienceRewardConfig | InGameCurrencyRewardConfig | MonetaryRewardConfig | ProbabilisticBundleRewardConfig | ShopItemRewardConfig>;
  rewardMultiplierConfiguration?: Maybe<RewardMultiplierConfiguration>;
  /** The `reward_pool_shares` field cannot be nested within a list. */
  rewardPoolShares?: Maybe<RewardPoolShareConnection>;
  rightPlayer?: Maybe<BaseballPlayer | NBAPlayer | Player>;
  startDate?: Maybe<Scalars['ISO8601DateTime']['output']>;
  target: Scalars['Int']['output'];
  taskConfigSlug: Scalars['String']['output'];
  taskLineups: Array<GuessTheScoreTaskLineup>;
  templateIconUrl: Scalars['String']['output'];
  title: Scalars['String']['output'];
  /** The `top_recommendations` field cannot be nested within a list. */
  topRecommendations: Array<PlayerRecommendation>;
  uncapped: Scalars['Boolean']['output'];
}


/** Guess The Score Task */
export interface GuessTheScoreTaskcolorArgs {
  variant?: InputMaybe<ColorVariant>;
}


/** Guess The Score Task */
export interface GuessTheScoreTaskhighlightedRecommendationsArgs {
  positions?: InputMaybe<Array<Position>>;
  recommendationEngine: RecommendationEngine;
  sport: Sport;
}


/** Guess The Score Task */
export interface GuessTheScoreTaskmyFilteredBenchArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filters: BenchFilterInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  stackByCardData?: InputMaybe<Scalars['Boolean']['input']>;
  topByPosition?: InputMaybe<Scalars['Int']['input']>;
}


/** Guess The Score Task */
export interface GuessTheScoreTaskpreviewSo5LineupArgs {
  appearances: Array<So5AppearanceInput>;
}


/** Guess The Score Task */
export interface GuessTheScoreTaskrewardConfigsArgs {
  mergedConfigsByType?: InputMaybe<Scalars['Boolean']['input']>;
}


/** Guess The Score Task */
export interface GuessTheScoreTaskrewardPoolSharesArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
}


/** Guess The Score Task */
export interface GuessTheScoreTasktopRecommendationsArgs {
  filters?: InputMaybe<BenchFilterInput>;
  playingHomeOnly?: InputMaybe<Scalars['Boolean']['input']>;
  positions?: InputMaybe<Array<Position>>;
  query?: InputMaybe<Scalars['String']['input']>;
  recommendationEngine: RecommendationEngine;
  sortType?: InputMaybe<EligibleCardsSort>;
  sport: Sport;
  starterOddsBasisPointsRange?: InputMaybe<RangeInput>;
}

/** Guess The Score Task Lineup */
export interface GuessTheScoreTaskLineup extends LineupInterface, TaskLineupInterface {
  __typename: 'GuessTheScoreTaskLineup';
  aasmState: TaskLineupType;
  board?: Maybe<CareerBoard | SquadBoard>;
  bonusPoints?: Maybe<Scalars['Float']['output']>;
  bonusRating?: Maybe<BonusOrdinalRatingEnum>;
  bonuses: Array<So5ActiveClubsBonus | So5AverageScoresBonus | So5BoostBonus | So5CaptainBonus | So5CollectionBonus | So5DifferentNationalitiesBonus | So5GradeBonus | So5LineupBonus | So5MalusAfterTransferBonus | So5NationalityBonus | So5PlayerBonus | So5PositionBonus | So5PositionStacksBonus | So5SameActiveClubBonus | So5ScarcityBonus | So5SeasonBonus | So5SpecialEditionCardsBonus>;
  cancelledAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  cancelledReason?: Maybe<Scalars['String']['output']>;
  confirmable: Scalars['Boolean']['output'];
  deletable: Scalars['Boolean']['output'];
  draft: Scalars['Boolean']['output'];
  forfeitable: Scalars['Boolean']['output'];
  hasLiveGames: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  rewardMultiplier: Scalars['Float']['output'];
  score: Scalars['Float']['output'];
  /** Whether the current user can share this lineup */
  shareable: Scalars['Boolean']['output'];
  /** Whether the current user already shared this lineup */
  shared: Scalars['Boolean']['output'];
  step?: Maybe<CareerProStep | CareerStep | SquadStep>;
  targetScore: Scalars['Int']['output'];
  taskAppearances: Array<DecisivePlayerPickerTaskAppearance | TaskAppearance | ThresholdPickerTaskAppearance>;
  updatable: Scalars['Boolean']['output'];
  user: User;
}


/** Guess The Score Task Lineup */
export interface GuessTheScoreTaskLineupbonusesArgs {
  highlighted?: InputMaybe<Scalars['Boolean']['input']>;
}

/** A hero value proposition of a PromotionalEvent */
export interface HeroValueProp {
  __typename: 'HeroValueProp';
  iconUrl?: Maybe<Scalars['String']['output']>;
  text: Scalars['String']['output'];
}

export interface HighScarcity {
  __typename: 'HighScarcity';
  spend: MonetaryAmount;
  status?: Maybe<HighScarcityStatus>;
}

export const HighScarcityStatus = {
  GOLD: 'GOLD',
  PLATINUM: 'PLATINUM',
  SILVER: 'SILVER'
} as const;

export type HighScarcityStatus = typeof HighScarcityStatus[keyof typeof HighScarcityStatus];
export interface HighScarcityStatuses {
  __typename: 'HighScarcityStatuses';
  current: HighScarcity;
  previous: HighScarcity;
  spendLeftToNextStatus?: Maybe<MonetaryAmount>;
  spendLeftToPreviousPeriodStatus?: Maybe<MonetaryAmount>;
}

export interface HighlightedStat {
  __typename: 'HighlightedStat';
  name: Scalars['String']['output'];
  type: HighlightedStatType;
  value: Scalars['Int']['output'];
}

export const HighlightedStatType = {
  BEAT_L10: 'BEAT_L10',
  BIG_CHANCE_CREATED: 'BIG_CHANCE_CREATED',
  CLEAN_SHEET_60: 'CLEAN_SHEET_60',
  GOALS: 'GOALS',
  GOAL_ASSIST: 'GOAL_ASSIST',
  HITTING_HOME_RUNS: 'HITTING_HOME_RUNS',
  HITTING_RUNS: 'HITTING_RUNS',
  HITTING_STOLEN_BASES: 'HITTING_STOLEN_BASES',
  LAST_MAN_TACKLE: 'LAST_MAN_TACKLE',
  ONTARGET_SCORING_ATT: 'ONTARGET_SCORING_ATT',
  PENALTY_SAVE: 'PENALTY_SAVE',
  PITCHING_INNINGS_PITCHED: 'PITCHING_INNINGS_PITCHED',
  PITCHING_PITCH_COUNT: 'PITCHING_PITCH_COUNT',
  PITCHING_STRIKEOUTS: 'PITCHING_STRIKEOUTS',
  SAVES: 'SAVES'
} as const;

export type HighlightedStatType = typeof HighlightedStatType[keyof typeof HighlightedStatType];
export interface HistoryTransactionInterface {
  date: Scalars['ISO8601DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  label: Scalars['String']['output'];
  logoUrl?: Maybe<Scalars['String']['output']>;
  quantityByFlavour: Array<PoolKeyShardsCount>;
  totalQuantity: Scalars['Int']['output'];
}

/** The connection type for HistoryTransactionInterface. */
export interface HistoryTransactionInterfaceConnection {
  __typename: 'HistoryTransactionInterfaceConnection';
  /** A list of edges. */
  edges: Array<HistoryTransactionInterfaceEdge>;
  /** A list of nodes. */
  nodes: Array<BidSource | CardPullSource | CardSource | EnglishAuctionSource | InGameCurrencySource | PackSource | PrimaryOfferSource | PrintablePlayerSource | ProbabilisticBundleSource | RejectedCraftSource | So5LeaderboardEntryItemSource | So5RewardSource | TaskSource | UnknownSource>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
}

/** An edge in a connection. */
export interface HistoryTransactionInterfaceEdge {
  __typename: 'HistoryTransactionInterfaceEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<BidSource | CardPullSource | CardSource | EnglishAuctionSource | InGameCurrencySource | PackSource | PrimaryOfferSource | PrintablePlayerSource | ProbabilisticBundleSource | RejectedCraftSource | So5LeaderboardEntryItemSource | So5RewardSource | TaskSource | UnknownSource>;
}

/** A Mangopay IBAN bank account type */
export interface IbanBankAccount extends BankAccountInterface, Node {
  __typename: 'IbanBankAccount';
  /** Bank Identifier Code, null until a PENDING virtual account is activated by Mangopay */
  bic?: Maybe<Scalars['String']['output']>;
  country: Country;
  /** IBAN, null until a PENDING virtual account is activated by Mangopay */
  iban?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  minimumWithdrawalAmounts: MonetaryAmount;
  ownerAddress?: Maybe<MangopayBankAccountOwnerAddress>;
  ownerName?: Maybe<Scalars['String']['output']>;
  status?: Maybe<MangopayBankAccountStatus>;
  withdrawalFeeAmounts: MonetaryAmount;
  withdrawalFeeType: MangopayBankAccountWithdrawalFeeType;
}

/** A So5 lineup import appearance */
export interface ImportedSo5Appearance {
  __typename: 'ImportedSo5Appearance';
  boost?: Maybe<Scalars['Boolean']['output']>;
  captain: Scalars['Boolean']['output'];
  composeTeamObject: ComposeTeamBenchCard | ComposeTeamBenchCommonPlayer | DecisivePlayerPickerTaskAppearance | MissedAppearance | So5Appearance | TaskAppearance | ThresholdPickerTaskAppearance;
  index: Scalars['Int']['output'];
}

export const InGameCurrency = {
  BEST_STAR_RANK_CRAFT_CLUE: 'BEST_STAR_RANK_CRAFT_CLUE',
  COMMON_GEM: 'COMMON_GEM',
  COMMON_GOLDEN_WHEEL_TICKET: 'COMMON_GOLDEN_WHEEL_TICKET',
  COMMON_WHEEL_TICKET: 'COMMON_WHEEL_TICKET',
  COMMON_XP: 'COMMON_XP',
  COMPETITION_CRAFT_CLUE: 'COMPETITION_CRAFT_CLUE',
  COUNTRY_CRAFT_CLUE: 'COUNTRY_CRAFT_CLUE',
  DIVISION_CRAFT_CLUE: 'DIVISION_CRAFT_CLUE',
  FIFTY_FIFTY_CRAFT_CLUE: 'FIFTY_FIFTY_CRAFT_CLUE',
  GOLDEN_WHEEL_TICKET: 'GOLDEN_WHEEL_TICKET',
  LIMITED_BEST_STAR_RANK_CRAFT_CLUE: 'LIMITED_BEST_STAR_RANK_CRAFT_CLUE',
  LIMITED_COMPETITION_CRAFT_CLUE: 'LIMITED_COMPETITION_CRAFT_CLUE',
  LIMITED_COUNTRY_CRAFT_CLUE: 'LIMITED_COUNTRY_CRAFT_CLUE',
  LIMITED_DIVISION_CRAFT_CLUE: 'LIMITED_DIVISION_CRAFT_CLUE',
  LIMITED_ENERGY: 'LIMITED_ENERGY',
  LIMITED_FIFTY_FIFTY_CRAFT_CLUE: 'LIMITED_FIFTY_FIFTY_CRAFT_CLUE',
  LIMITED_POSITION_CRAFT_CLUE: 'LIMITED_POSITION_CRAFT_CLUE',
  LIMITED_SPECIAL_EVENT_CRAFT_CLUE: 'LIMITED_SPECIAL_EVENT_CRAFT_CLUE',
  LIMITED_XP: 'LIMITED_XP',
  OLD_CLUB_SHOP_COIN: 'OLD_CLUB_SHOP_COIN',
  POSITION_CRAFT_CLUE: 'POSITION_CRAFT_CLUE',
  RARE_BEST_STAR_RANK_CRAFT_CLUE: 'RARE_BEST_STAR_RANK_CRAFT_CLUE',
  RARE_COMPETITION_CRAFT_CLUE: 'RARE_COMPETITION_CRAFT_CLUE',
  RARE_COUNTRY_CRAFT_CLUE: 'RARE_COUNTRY_CRAFT_CLUE',
  RARE_DIVISION_CRAFT_CLUE: 'RARE_DIVISION_CRAFT_CLUE',
  RARE_ENERGY: 'RARE_ENERGY',
  RARE_FIFTY_FIFTY_CRAFT_CLUE: 'RARE_FIFTY_FIFTY_CRAFT_CLUE',
  RARE_GOLDEN_WHEEL_TICKET: 'RARE_GOLDEN_WHEEL_TICKET',
  RARE_POSITION_CRAFT_CLUE: 'RARE_POSITION_CRAFT_CLUE',
  RARE_SPECIAL_EVENT_CRAFT_CLUE: 'RARE_SPECIAL_EVENT_CRAFT_CLUE',
  RARE_WHEEL_TICKET: 'RARE_WHEEL_TICKET',
  RARE_XP: 'RARE_XP',
  SET_RAFFLE_TICKET: 'SET_RAFFLE_TICKET',
  SPECIAL_EVENT_CRAFT_CLUE: 'SPECIAL_EVENT_CRAFT_CLUE',
  SUPER_RARE_BEST_STAR_RANK_CRAFT_CLUE: 'SUPER_RARE_BEST_STAR_RANK_CRAFT_CLUE',
  SUPER_RARE_COMPETITION_CRAFT_CLUE: 'SUPER_RARE_COMPETITION_CRAFT_CLUE',
  SUPER_RARE_COUNTRY_CRAFT_CLUE: 'SUPER_RARE_COUNTRY_CRAFT_CLUE',
  SUPER_RARE_DIVISION_CRAFT_CLUE: 'SUPER_RARE_DIVISION_CRAFT_CLUE',
  SUPER_RARE_ENERGY: 'SUPER_RARE_ENERGY',
  SUPER_RARE_FIFTY_FIFTY_CRAFT_CLUE: 'SUPER_RARE_FIFTY_FIFTY_CRAFT_CLUE',
  SUPER_RARE_GOLDEN_WHEEL_TICKET: 'SUPER_RARE_GOLDEN_WHEEL_TICKET',
  SUPER_RARE_POSITION_CRAFT_CLUE: 'SUPER_RARE_POSITION_CRAFT_CLUE',
  SUPER_RARE_SPECIAL_EVENT_CRAFT_CLUE: 'SUPER_RARE_SPECIAL_EVENT_CRAFT_CLUE',
  SUPER_RARE_WHEEL_TICKET: 'SUPER_RARE_WHEEL_TICKET',
  SUPER_RARE_XP: 'SUPER_RARE_XP',
  UNIQUE_BEST_STAR_RANK_CRAFT_CLUE: 'UNIQUE_BEST_STAR_RANK_CRAFT_CLUE',
  UNIQUE_COMPETITION_CRAFT_CLUE: 'UNIQUE_COMPETITION_CRAFT_CLUE',
  UNIQUE_COUNTRY_CRAFT_CLUE: 'UNIQUE_COUNTRY_CRAFT_CLUE',
  UNIQUE_ENERGY: 'UNIQUE_ENERGY',
  UNIQUE_FIFTY_FIFTY_CRAFT_CLUE: 'UNIQUE_FIFTY_FIFTY_CRAFT_CLUE',
  UNIQUE_GOLDEN_WHEEL_TICKET: 'UNIQUE_GOLDEN_WHEEL_TICKET',
  UNIQUE_SPECIAL_EVENT_CRAFT_CLUE: 'UNIQUE_SPECIAL_EVENT_CRAFT_CLUE',
  UNIQUE_WHEEL_TICKET: 'UNIQUE_WHEEL_TICKET',
  UNIQUE_XP: 'UNIQUE_XP',
  WHEEL_TICKET: 'WHEEL_TICKET'
} as const;

export type InGameCurrency = typeof InGameCurrency[keyof typeof InGameCurrency];
/** In Game Currency Balance */
export interface InGameCurrencyBalance {
  __typename: 'InGameCurrencyBalance';
  amount: Scalars['Int']['output'];
  cap?: Maybe<Scalars['Int']['output']>;
  capAlmostReached: Scalars['Boolean']['output'];
  currency: InGameCurrency;
}

/** A user notification regarding his currency balance */
export interface InGameCurrencyNotification extends Node, NotificationInterface {
  __typename: 'InGameCurrencyNotification';
  body: Scalars['String']['output'];
  cap?: Maybe<Scalars['Int']['output']>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  deeplinkUrl: Scalars['String']['output'];
  iconUrl: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  important: Scalars['Boolean']['output'];
  inGameCurrencyBalance: InGameCurrencyBalance;
  markdownBody: Scalars['String']['output'];
  name: Scalars['String']['output'];
  pictureUrl?: Maybe<Scalars['String']['output']>;
  read: Scalars['Boolean']['output'];
  sport?: Maybe<SportOrShared>;
  title: Scalars['String']['output'];
  user: CurrentUser;
}

export interface InGameCurrencyPack extends Node {
  __typename: 'InGameCurrencyPack';
  applePrice?: Maybe<MonetaryAmount>;
  appleProductId?: Maybe<Scalars['String']['output']>;
  baseAmount: Scalars['Int']['output'];
  bonusAmount: Scalars['Int']['output'];
  currency: InGameCurrency;
  displayName: Scalars['String']['output'];
  googlePrice?: Maybe<Scalars['String']['output']>;
  googleProductId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  pictureUrl: Scalars['String']['output'];
  price: MonetaryAmount;
}


export interface InGameCurrencyPackgooglePriceArgs {
  countryCode?: InputMaybe<Scalars['String']['input']>;
}

/** A purchasable item that is in game currency */
export interface InGameCurrencyPurchasableItem extends Node, PurchasableItemInterface {
  __typename: 'InGameCurrencyPurchasableItem';
  baseAmount: Scalars['Int']['output'];
  bonusAmount: Scalars['Int']['output'];
  cardPaymentProvider: PaymentMethodProvider;
  currency: InGameCurrency;
  id: Scalars['ID']['output'];
  nextPriceUpdateAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  oldPrice?: Maybe<MonetaryAmount>;
  pictureUrl?: Maybe<Scalars['String']['output']>;
  price: MonetaryAmount;
  slug: Scalars['String']['output'];
  sport?: Maybe<Sport>;
  totalAmount: Scalars['Int']['output'];
}


/** A purchasable item that is in game currency */
export interface InGameCurrencyPurchasableItempictureUrlArgs {
  derivative?: InputMaybe<PurchasableItemDerivative>;
}

/** A In Game Currency Reward */
export interface InGameCurrencyReward extends AnyRewardInterface, Node {
  __typename: 'InGameCurrencyReward';
  aasmState: RewardState;
  coinAmount: Scalars['Int']['output'];
  config: InGameCurrencyRewardConfig;
  id: Scalars['ID']['output'];
}

/** A InGameCurrency Reward Config */
export interface InGameCurrencyRewardConfig extends AnyRewardConfigInterface {
  __typename: 'InGameCurrencyRewardConfig';
  amount: Scalars['Int']['output'];
  boostedRewardConfigs?: Maybe<Array<CardPacksRewardConfig | CardRewardConfig | CardShardRewardConfig | CoinRewardConfig | ConversionCreditRewardConfig | DeliverableItemRewardConfig | ExperienceRewardConfig | InGameCurrencyRewardConfig | MonetaryRewardConfig | ProbabilisticBundleRewardConfig | ShopItemRewardConfig>>;
  currency: InGameCurrency;
  id: Scalars['ID']['output'];
}

export interface InGameCurrencySource extends HistoryTransactionInterface {
  __typename: 'InGameCurrencySource';
  date: Scalars['ISO8601DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  label: Scalars['String']['output'];
  logoUrl?: Maybe<Scalars['String']['output']>;
  quantityByFlavour: Array<PoolKeyShardsCount>;
  totalQuantity: Scalars['Int']['output'];
}

/** In Game Currency Transaction */
export interface InGameCurrencyTransaction {
  __typename: 'InGameCurrencyTransaction';
  amount: Scalars['Int']['output'];
  createdAt: Scalars['ISO8601DateTime']['output'];
  currency: InGameCurrency;
  id: Scalars['ID']['output'];
  label: Scalars['String']['output'];
  pictureUrl?: Maybe<Scalars['String']['output']>;
}

/** The connection type for InGameCurrencyTransaction. */
export interface InGameCurrencyTransactionConnection {
  __typename: 'InGameCurrencyTransactionConnection';
  /** A list of edges. */
  edges: Array<InGameCurrencyTransactionEdge>;
  /** A list of nodes. */
  nodes: Array<InGameCurrencyTransaction>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
}

/** An edge in a connection. */
export interface InGameCurrencyTransactionEdge {
  __typename: 'InGameCurrencyTransactionEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<InGameCurrencyTransaction>;
}

export interface IncompleteCardCollection {
  __typename: 'IncompleteCardCollection';
  cardCollection: CardCollection;
  recommendedSlots: Array<CardCollectionSlot>;
}

/** The connection type for IncompleteCardCollection. */
export interface IncompleteCardCollectionConnection {
  __typename: 'IncompleteCardCollectionConnection';
  /** A list of edges. */
  edges: Array<IncompleteCardCollectionEdge>;
  /** A list of nodes. */
  nodes: Array<IncompleteCardCollection>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
}

/** An edge in a connection. */
export interface IncompleteCardCollectionEdge {
  __typename: 'IncompleteCardCollectionEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<IncompleteCardCollection>;
}

/** A player injury */
export interface Injury extends Node {
  __typename: 'Injury';
  active: Scalars['Boolean']['output'];
  details?: Maybe<Scalars['String']['output']>;
  expectedEndDate?: Maybe<Scalars['ISO8601DateTime']['output']>;
  id: Scalars['ID']['output'];
  kind?: Maybe<Scalars['String']['output']>;
  startDate?: Maybe<Scalars['ISO8601DateTime']['output']>;
  status?: Maybe<Scalars['String']['output']>;
}

/** A baseball inning */
export interface Inning {
  __typename: 'Inning';
  half: InningHalf;
  number: Scalars['Int']['output'];
}

export const InningHalf = {
  BOTTOM: 'BOTTOM',
  TOP: 'TOP'
} as const;

export type InningHalf = typeof InningHalf[keyof typeof InningHalf];
/** An instant buy campaign */
export interface InstantBuyCampaign extends Node {
  __typename: 'InstantBuyCampaign';
  endDate: Scalars['ISO8601DateTime']['output'];
  id: Scalars['ID']['output'];
  player?: Maybe<Player>;
  /** The live primary offer of the campaign, or the last sold one when none is on sale */
  primaryOffer?: Maybe<TokenPrimaryOffer>;
  quantityPerStep?: Maybe<Scalars['Int']['output']>;
  rarity: Rarity;
  remainingAtCurrentPrice?: Maybe<Scalars['Int']['output']>;
  remainingSupply?: Maybe<Scalars['Int']['output']>;
  soldOut?: Maybe<Scalars['Boolean']['output']>;
}

/** The connection type for InstantBuyCampaign. */
export interface InstantBuyCampaignConnection {
  __typename: 'InstantBuyCampaignConnection';
  /** A list of edges. */
  edges: Array<InstantBuyCampaignEdge>;
  /** A list of nodes. */
  nodes: Array<InstantBuyCampaign>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
}

/** An edge in a connection. */
export interface InstantBuyCampaignEdge {
  __typename: 'InstantBuyCampaignEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<InstantBuyCampaign>;
}

/** A Integer value by sport */
export interface IntegerBySportType {
  __typename: 'IntegerBySportType';
  baseball: Scalars['Int']['output'];
  football: Scalars['Int']['output'];
  nba: Scalars['Int']['output'];
}

export const InternalTransferState = {
  CREATED: 'CREATED',
  FAILED: 'FAILED',
  FINALIZED: 'FINALIZED'
} as const;

export type InternalTransferState = typeof InternalTransferState[keyof typeof InternalTransferState];
export interface InviteTaskAsReferrer extends ManagerTaskInterface, TaskInterface {
  __typename: 'InviteTaskAsReferrer';
  aasmState: ManagerProgressionTaskState;
  alternativeRewardConfigs?: Maybe<Array<AlternativeRewardConfig>>;
  /** @deprecated Not used anymore */
  cards: Array<BaseballCard | Card | NBACard>;
  claimableAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** @deprecated Not used anymore */
  claimedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  color?: Maybe<Scalars['String']['output']>;
  completedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /**
   * The first completed step, or the first ready step if none are completed. When
   * all steps are claimed, returns the last step; otherwise falls back to the first step.
   */
  currentStep?: Maybe<CardsCountTargetTask | CardsCountTask | CompleteCollectionsCountTargetTask | CompleteCollectionsCountTask | DailyActionTask | DecisivePlayerPickerTask | DropChallengeTask | GameWeeklyTask | GuessTheScoreTask | InviteTaskAsReferrer | So5LeaderboardTask | StarPackTask | Task | TasksTrack | ThresholdPickerTask | ThresholdsDuoConnectionTask | ThresholdsStreakAdditionalLineupTask | ThresholdsStreakTask>;
  description: Scalars['String']['output'];
  endDate?: Maybe<Scalars['ISO8601DateTime']['output']>;
  expired: Scalars['Boolean']['output'];
  genre: TaskGenre;
  group?: Maybe<TaskGroup>;
  iconUrl?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  jonumGated: Scalars['Boolean']['output'];
  /** The points this task earned on a ladder leaderboard, empty when it feeds none. */
  ladderContributions: Array<LadderContribution>;
  /** The `my_reward_pool_shares` field cannot be nested within a list. */
  myRewardPoolShares?: Maybe<Array<RewardPoolShare>>;
  name: ManagerProgressionTaskSlug;
  parentTask?: Maybe<CardsCountTargetTask | CardsCountTask | CompleteCollectionsCountTargetTask | CompleteCollectionsCountTask | DailyActionTask | DecisivePlayerPickerTask | DropChallengeTask | GameWeeklyTask | GuessTheScoreTask | InviteTaskAsReferrer | So5LeaderboardTask | StarPackTask | Task | TasksTrack | ThresholdPickerTask | ThresholdsDuoConnectionTask | ThresholdsStreakAdditionalLineupTask | ThresholdsStreakTask>;
  periodicity?: Maybe<ManagerTaskPeriodicity>;
  pickOrList: Scalars['Boolean']['output'];
  possibleRewardConfigsIconUrl?: Maybe<Scalars['String']['output']>;
  /** @deprecated Not used anymore */
  probabilisticBundles: Array<ProbabilisticBundle>;
  progress: Scalars['Int']['output'];
  rarity?: Maybe<Rarity>;
  referral: Referral;
  rewardConfigs: Array<CardPacksRewardConfig | CardRewardConfig | CardShardRewardConfig | CoinRewardConfig | ConversionCreditRewardConfig | DeliverableItemRewardConfig | ExperienceRewardConfig | InGameCurrencyRewardConfig | MonetaryRewardConfig | ProbabilisticBundleRewardConfig | ShopItemRewardConfig>;
  /** The `reward_pool_shares` field cannot be nested within a list. */
  rewardPoolShares?: Maybe<RewardPoolShareConnection>;
  startDate?: Maybe<Scalars['ISO8601DateTime']['output']>;
  steps: Array<CardsCountTargetTask | CardsCountTask | CompleteCollectionsCountTargetTask | CompleteCollectionsCountTask | DailyActionTask | DecisivePlayerPickerTask | DropChallengeTask | GameWeeklyTask | GuessTheScoreTask | InviteTaskAsReferrer | So5LeaderboardTask | StarPackTask | Task | TasksTrack | ThresholdPickerTask | ThresholdsDuoConnectionTask | ThresholdsStreakAdditionalLineupTask | ThresholdsStreakTask>;
  target: Scalars['Int']['output'];
  taskConfigSlug: Scalars['String']['output'];
  templateIconUrl: Scalars['String']['output'];
  title: Scalars['String']['output'];
  uncapped: Scalars['Boolean']['output'];
  /** The task unlocked on completing this track. */
  unlockableTask?: Maybe<CardsCountTargetTask | CardsCountTask | CompleteCollectionsCountTargetTask | CompleteCollectionsCountTask | DailyActionTask | DecisivePlayerPickerTask | DropChallengeTask | GameWeeklyTask | GuessTheScoreTask | InviteTaskAsReferrer | So5LeaderboardTask | StarPackTask | Task | TasksTrack | ThresholdPickerTask | ThresholdsDuoConnectionTask | ThresholdsStreakAdditionalLineupTask | ThresholdsStreakTask>;
}


export interface InviteTaskAsReferrercolorArgs {
  variant?: InputMaybe<ColorVariant>;
}


export interface InviteTaskAsReferrerrewardConfigsArgs {
  mergedConfigsByType?: InputMaybe<Scalars['Boolean']['input']>;
}


export interface InviteTaskAsReferrerrewardPoolSharesArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
}

/** A jersey deliverable item interface */
export interface JerseyDeliverableItem extends DeliverableItemInterface {
  __typename: 'JerseyDeliverableItem';
  anyTeam?: Maybe<Club | NationalTeam>;
  competition?: Maybe<Competition>;
  id: Scalars['ID']['output'];
  mandatoryWearableSizeInput: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  pictureUrl: Scalars['String']['output'];
  signed: Scalars['Boolean']['output'];
  slug: Scalars['String']['output'];
  sport: Sport;
  threeDimensionalAssetUrl?: Maybe<Scalars['String']['output']>;
}


/** A jersey deliverable item interface */
export interface JerseyDeliverableItempictureUrlArgs {
  derivative?: InputMaybe<DeliverableItemDerivative>;
}


/** A jersey deliverable item interface */
export interface JerseyDeliverableItemthreeDimensionalAssetUrlArgs {
  format?: InputMaybe<DeliverableItemThreeDimensionalAssetFormat>;
}

/** A physical Jersey buyable through the club shop */
export interface JerseyShopItem extends Node, ShopItemInterface {
  __typename: 'JerseyShopItem';
  cardCollectionRequirements: Array<CardCollectionRequirement>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  currentStockCount: Scalars['Int']['output'];
  description?: Maybe<Scalars['String']['output']>;
  disabled: Scalars['Boolean']['output'];
  expirationDate?: Maybe<Scalars['ISO8601DateTime']['output']>;
  id: Scalars['ID']['output'];
  infoLink?: Maybe<Scalars['String']['output']>;
  initialStockCount: Scalars['Int']['output'];
  limitPerUser: Scalars['Int']['output'];
  myAvailableTotalPurchasesCount: Scalars['Int']['output'];
  myAvailableUserShopItems?: Maybe<Array<UserShopItem>>;
  myBalance: Scalars['Int']['output'];
  myLimitResetAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  myPurchasesCount: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  pictureUrl: Scalars['String']['output'];
  position: ShopItemType;
  price: Scalars['Int']['output'];
  requirementsRulesLink?: Maybe<Scalars['String']['output']>;
  salePrice?: Maybe<Scalars['Int']['output']>;
  shopItemsRequired: Array<ShopItem>;
  threeDimensionalAssetUrl?: Maybe<Scalars['String']['output']>;
  unlocked: Scalars['Boolean']['output'];
  variantStockCounts: Array<VariantStockCount>;
  variantType?: Maybe<VariantStockCountType>;
}


/** A physical Jersey buyable through the club shop */
export interface JerseyShopItempictureUrlArgs {
  derivative?: InputMaybe<ShopItemDerivative>;
}


/** A physical Jersey buyable through the club shop */
export interface JerseyShopItemthreeDimensionalAssetUrlArgs {
  format?: InputMaybe<ShopItemThreeDimensionalAssetFormat>;
}

export const JonumBlockingReason = {
  FROZEN: 'FROZEN',
  NOT_VERIFIED: 'NOT_VERIFIED',
  NO_VERIFICATION: 'NO_VERIFICATION',
  PLAYTIME_EXHAUSTED: 'PLAYTIME_EXHAUSTED',
  REMEDIATION: 'REMEDIATION',
  SELF_EXCLUDED: 'SELF_EXCLUDED',
  SPENDING_EXHAUSTED: 'SPENDING_EXHAUSTED',
  UNDERAGE: 'UNDERAGE'
} as const;

export type JonumBlockingReason = typeof JonumBlockingReason[keyof typeof JonumBlockingReason];
export interface JonumBlockingStatus {
  __typename: 'JonumBlockingStatus';
  blocked: Scalars['Boolean']['output'];
  reason?: Maybe<JonumBlockingReason>;
}

export const JonumMissingUserInfo = {
  DATE_OF_BIRTH: 'DATE_OF_BIRTH',
  FIAT_WALLET: 'FIAT_WALLET',
  FIRST_NAME: 'FIRST_NAME',
  KYC: 'KYC',
  LAST_NAME: 'LAST_NAME',
  PLAYTIME_LIMIT: 'PLAYTIME_LIMIT',
  SPENDING_LIMIT: 'SPENDING_LIMIT'
} as const;

export type JonumMissingUserInfo = typeof JonumMissingUserInfo[keyof typeof JonumMissingUserInfo];
export interface JonumRestrictions {
  __typename: 'JonumRestrictions';
  compose: JonumBlockingStatus;
  marketplace: JonumBlockingStatus;
}

/** A JONUM identity verification notification */
export interface JonumVerificationNotification extends Node, NotificationInterface {
  __typename: 'JonumVerificationNotification';
  body: Scalars['String']['output'];
  createdAt: Scalars['ISO8601DateTime']['output'];
  deeplinkUrl: Scalars['String']['output'];
  iconUrl: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  important: Scalars['Boolean']['output'];
  markdownBody: Scalars['String']['output'];
  name: Scalars['String']['output'];
  pictureUrl?: Maybe<Scalars['String']['output']>;
  read: Scalars['Boolean']['output'];
  sport?: Maybe<SportOrShared>;
  title: Scalars['String']['output'];
  user: CurrentUser;
}

export const JonumVerificationStatus = {
  ACCOUNT_FROZEN: 'ACCOUNT_FROZEN',
  EXEMPT: 'EXEMPT',
  EXEMPTION_EXPIRED: 'EXEMPTION_EXPIRED',
  INFO_COLLECTING: 'INFO_COLLECTING',
  IN_REMEDIATION: 'IN_REMEDIATION',
  PROVISIONALLY_VERIFIED: 'PROVISIONALLY_VERIFIED',
  UNDERAGE: 'UNDERAGE',
  UNVERIFIED: 'UNVERIFIED',
  VERIFIED: 'VERIFIED'
} as const;

export type JonumVerificationStatus = typeof JonumVerificationStatus[keyof typeof JonumVerificationStatus];
/** Represents a jwt token */
export interface JwtToken {
  __typename: 'JwtToken';
  /** JWT token expiration time. */
  expiredAt: Scalars['ISO8601DateTime']['output'];
  /** JWT token, usable through a `Authorization: Bearer <token>` HTTP header. */
  token: Scalars['String']['output'];
}

export interface KlarnaAdditionalInfoInput {
  billing: BillingAddressInput;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  /** Whether the billing address should be saved for future use */
  saveBillingAddress?: InputMaybe<Scalars['Boolean']['input']>;
}

/** Configuration for Klarna Payin for a specific currency */
export interface KlarnaPayinConfig {
  __typename: 'KlarnaPayinConfig';
  currency: FiatCurrency;
  enabled: Scalars['Boolean']['output'];
  minimumAmount?: Maybe<Scalars['Int']['output']>;
}

/** A Mangopay KYC Document requirement */
export interface KycDocumentRequirement {
  __typename: 'KycDocumentRequirement';
  documentType: KycDocumentType;
  nbPages: Scalars['Int']['output'];
}

/** A Mangopay KYC Document type */
export const KycDocumentType = {
  DRIVING_LICENSE: 'DRIVING_LICENSE',
  NATIONAL_HEALTH_INSURANCE_CARD: 'NATIONAL_HEALTH_INSURANCE_CARD',
  NATIONAL_ID: 'NATIONAL_ID',
  PASSPORT: 'PASSPORT',
  RESIDENCE_PERMIT: 'RESIDENCE_PERMIT',
  TAX_ID: 'TAX_ID'
} as const;

export type KycDocumentType = typeof KycDocumentType[keyof typeof KycDocumentType];
/** An KYC request notification */
export interface KycRequestNotification extends Node, NotificationInterface {
  __typename: 'KycRequestNotification';
  body: Scalars['String']['output'];
  createdAt: Scalars['ISO8601DateTime']['output'];
  deeplinkUrl: Scalars['String']['output'];
  iconUrl: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  important: Scalars['Boolean']['output'];
  markdownBody: Scalars['String']['output'];
  name: Scalars['String']['output'];
  pictureUrl?: Maybe<Scalars['String']['output']>;
  read: Scalars['Boolean']['output'];
  refusedReason?: Maybe<FiatWalletKycRefusedReason>;
  sport?: Maybe<SportOrShared>;
  status: KycRequestNotificationStatus;
  title: Scalars['String']['output'];
  user: CurrentUser;
}

export const KycRequestNotificationStatus = {
  REFUSED: 'REFUSED',
  RENEWAL_REQUIRED: 'RENEWAL_REQUIRED',
  VALIDATED: 'VALIDATED'
} as const;

export type KycRequestNotificationStatus = typeof KycRequestNotificationStatus[keyof typeof KycRequestNotificationStatus];
export const KycRequestState = {
  CREATED: 'CREATED',
  OUT_OF_DATE: 'OUT_OF_DATE',
  REFUSED: 'REFUSED',
  VALIDATED: 'VALIDATED',
  VALIDATION_ASKED: 'VALIDATION_ASKED'
} as const;

export type KycRequestState = typeof KycRequestState[keyof typeof KycRequestState];
/** The points a task earned its manager on a ladder leaderboard */
export interface LadderContribution {
  __typename: 'LadderContribution';
  /** The board of the step that earned these points. */
  board?: Maybe<CareerBoard | SquadBoard>;
  earnedAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['ID']['output'];
  leaderboard: LadderLeaderboard;
  /** The lineup that won the step that earned these points. */
  lineup?: Maybe<GuessTheScoreTaskLineup | So5Lineup | TaskLineup | ThresholdPickerTaskLineup>;
  points: Scalars['Int']['output'];
  /** The level of the board step that earned these points. */
  stepLevel?: Maybe<Scalars['Int']['output']>;
}

/** One time-boxed run of a ladder, with its standings and its reward brackets */
export interface LadderLeaderboard {
  __typename: 'LadderLeaderboard';
  displayName: Scalars['String']['output'];
  endDate: Scalars['ISO8601DateTime']['output'];
  myRanking?: Maybe<LadderRanking>;
  /**
   * The rewards this manager won on this run and has not claimed yet. Empty for a
   * signed-out viewer, and once every reward has been claimed.
   */
  myUnclaimedRewards: Array<AnyCardReward | AnyConversionCreditReward | CardPackReward | CardShardsReward | CoinReward | DeliverableItemReward | ExperienceReward | InGameCurrencyReward | MonetaryReward | ProbabilisticBundleReward | ShopItemReward>;
  /** The standings, best rank first. The `rankings` field cannot be nested within a list. */
  rankings: LadderRankingConnection;
  rewardBrackets: Array<LadderRewardBracket>;
  slug: Scalars['String']['output'];
}


/** One time-boxed run of a ladder, with its standings and its reward brackets */
export interface LadderLeaderboardrankingsArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  onlyFollowed?: InputMaybe<Scalars['Boolean']['input']>;
}

/** The connection type for LadderLeaderboard. */
export interface LadderLeaderboardConnection {
  __typename: 'LadderLeaderboardConnection';
  /** A list of edges. */
  edges: Array<LadderLeaderboardEdge>;
  /** A list of nodes. */
  nodes: Array<LadderLeaderboard>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
}

/** An edge in a connection. */
export interface LadderLeaderboardEdge {
  __typename: 'LadderLeaderboardEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<LadderLeaderboard>;
}

/** A manager's standing on a ladder leaderboard */
export interface LadderRanking {
  __typename: 'LadderRanking';
  id: Scalars['ID']['output'];
  /** The points this manager earned on this run, oldest first. */
  ladderContributions: Array<LadderContribution>;
  points: Scalars['Int']['output'];
  /** Null until the manager has scored a single point. */
  rank?: Maybe<Scalars['Int']['output']>;
  /** The rewards this manager receives if the leaderboard closes on this rank. */
  rewardConfigs: Array<CardPacksRewardConfig | CardRewardConfig | CardShardRewardConfig | CoinRewardConfig | ConversionCreditRewardConfig | DeliverableItemRewardConfig | ExperienceRewardConfig | InGameCurrencyRewardConfig | MonetaryRewardConfig | ProbabilisticBundleRewardConfig | ShopItemRewardConfig>;
  user: User;
}


/** A manager's standing on a ladder leaderboard */
export interface LadderRankingladderContributionsArgs {
  stepLevel?: InputMaybe<Scalars['Int']['input']>;
}

/** The connection type for LadderRanking. */
export interface LadderRankingConnection {
  __typename: 'LadderRankingConnection';
  /** A list of edges. */
  edges: Array<LadderRankingEdge>;
  /** A list of nodes. */
  nodes: Array<LadderRanking>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
}

/** An edge in a connection. */
export interface LadderRankingEdge {
  __typename: 'LadderRankingEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<LadderRanking>;
}

/** The rewards every manager finishing within a rank bracket of a ladder leaderboard receives */
export interface LadderRewardBracket {
  __typename: 'LadderRewardBracket';
  fromRank: Scalars['Int']['output'];
  /** The manager holding the first rank of the bracket, null while nobody has reached it. */
  fromRanking?: Maybe<LadderRanking>;
  rewardConfigs: Array<CardPacksRewardConfig | CardRewardConfig | CardShardRewardConfig | CoinRewardConfig | ConversionCreditRewardConfig | DeliverableItemRewardConfig | ExperienceRewardConfig | InGameCurrencyRewardConfig | MonetaryRewardConfig | ProbabilisticBundleRewardConfig | ShopItemRewardConfig>;
  toRank: Scalars['Int']['output'];
  /** The manager holding the last rank of the bracket, null while nobody has reached it. */
  toRanking?: Maybe<LadderRanking>;
}

/** A So5 Leaderboard rewards config */
export interface LeaderboardRewardsConfig {
  __typename: 'LeaderboardRewardsConfig';
  carriedOver?: Maybe<Array<So5RewardConfig>>;
  conditional?: Maybe<Array<So5RewardConfig>>;
  prizePoolCurrency?: Maybe<PaymentCurrency>;
  ranking?: Maybe<Array<So5RewardConfig>>;
  targetable?: Maybe<Array<So5RewardConfig>>;
  unlockable?: Maybe<Array<So5RewardConfig>>;
}

export interface LeaguesSortInput {
  direction: SortingOption;
  type: LeaguesSorting;
}

export const LeaguesSorting = {
  NAME: 'NAME',
  PRIORITY: 'PRIORITY'
} as const;

export type LeaguesSorting = typeof LeaguesSorting[keyof typeof LeaguesSorting];
/** A legacy packs market set section */
export interface LegacyPacks extends MarketSetSection {
  __typename: 'LegacyPacks';
  backgroundUrl?: Maybe<Scalars['String']['output']>;
  cardPackGroups: Array<CardPackGroup>;
  endsAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** @deprecated Not used anymore */
  hoverColor?: Maybe<Scalars['String']['output']>;
  mainColor?: Maybe<Scalars['String']['output']>;
  resetAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  title: Scalars['String']['output'];
  titleBackgroundUrl?: Maybe<Scalars['String']['output']>;
}

/** A XP needed by card input to level up */
export interface LevelUpCardInput {
  cardSlug: Scalars['String']['input'];
  xpNeeded: Scalars['Int']['input'];
}

/** A level up shop item to level up the xp of a card */
export interface LevelUpShopItem extends Node, ShopItemInterface, XPBoosterShopItemInterface {
  __typename: 'LevelUpShopItem';
  cardCollectionRequirements: Array<CardCollectionRequirement>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  disabled: Scalars['Boolean']['output'];
  endLevel: Scalars['Int']['output'];
  expirationDate?: Maybe<Scalars['ISO8601DateTime']['output']>;
  id: Scalars['ID']['output'];
  infoLink?: Maybe<Scalars['String']['output']>;
  limitPerUser: Scalars['Int']['output'];
  myAvailableTotalPurchasesCount: Scalars['Int']['output'];
  myAvailableUserShopItems?: Maybe<Array<UserShopItem>>;
  myBalance: Scalars['Int']['output'];
  myLimitResetAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  myPurchasesCount: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  pictureUrl: Scalars['String']['output'];
  position: ShopItemType;
  price: Scalars['Int']['output'];
  rarity: Rarity;
  requirementsRulesLink?: Maybe<Scalars['String']['output']>;
  salePrice?: Maybe<Scalars['Int']['output']>;
  shopItemsRequired: Array<ShopItem>;
  startLevel: Scalars['Int']['output'];
  threeDimensionalAssetUrl?: Maybe<Scalars['String']['output']>;
  unlocked: Scalars['Boolean']['output'];
}


/** A level up shop item to level up the xp of a card */
export interface LevelUpShopItempictureUrlArgs {
  derivative?: InputMaybe<ShopItemDerivative>;
}


/** A level up shop item to level up the xp of a card */
export interface LevelUpShopItemthreeDimensionalAssetUrlArgs {
  format?: InputMaybe<ShopItemThreeDimensionalAssetFormat>;
}

/** A leveled up card is a card that leveled up with its xp gain amount */
export interface LeveledUpCard {
  __typename: 'LeveledUpCard';
  card: BaseballCard | Card | NBACard;
  id: Scalars['String']['output'];
  xpGain: Scalars['Int']['output'];
}

/** A lineup a manager shared */
export interface LineupActivityFeed extends ActivityFeedInterface, Node {
  __typename: 'LineupActivityFeed';
  backgroundUrl?: Maybe<Scalars['String']['output']>;
  /**
   * The most recent reaction the current user left on this activity
   * @deprecated Use currentUserReactions instead
   */
  currentUserReaction?: Maybe<ActivityReaction>;
  /** The reactions the current user left on this activity, the oldest first */
  currentUserReactions: Array<ActivityReaction>;
  id: Scalars['ID']['output'];
  /** The reactions left on this activity, the most recent first The `reactions` field cannot be nested within a list. */
  reactions: ActivityReactionConnection;
  /** How many managers left each emoji, in the order the emojis were first used */
  reactionsCount: Array<ActivityReactionCount>;
  sharedAt: Scalars['ISO8601DateTime']['output'];
  taskLineup: GuessTheScoreTaskLineup | TaskLineup | ThresholdPickerTaskLineup;
  user: User;
}


/** A lineup a manager shared */
export interface LineupActivityFeedreactionsArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  emoji?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
}

/** Lineup interface */
export interface LineupInterface {
  bonusPoints?: Maybe<Scalars['Float']['output']>;
  bonusRating?: Maybe<BonusOrdinalRatingEnum>;
  bonuses: Array<So5ActiveClubsBonus | So5AverageScoresBonus | So5BoostBonus | So5CaptainBonus | So5CollectionBonus | So5DifferentNationalitiesBonus | So5GradeBonus | So5LineupBonus | So5MalusAfterTransferBonus | So5NationalityBonus | So5PlayerBonus | So5PositionBonus | So5PositionStacksBonus | So5SameActiveClubBonus | So5ScarcityBonus | So5SeasonBonus | So5SpecialEditionCardsBonus>;
  cancelledAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  cancelledReason?: Maybe<Scalars['String']['output']>;
  confirmable: Scalars['Boolean']['output'];
  deletable: Scalars['Boolean']['output'];
  draft: Scalars['Boolean']['output'];
  hasLiveGames: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  rewardMultiplier: Scalars['Float']['output'];
  updatable: Scalars['Boolean']['output'];
  user: User;
}


/** Lineup interface */
export interface LineupInterfacebonusesArgs {
  highlighted?: InputMaybe<Scalars['Boolean']['input']>;
}

/** The connection type for LineupInterface. */
export interface LineupInterfaceConnection {
  __typename: 'LineupInterfaceConnection';
  /** A list of edges. */
  edges: Array<LineupInterfaceEdge>;
  /** A list of nodes. */
  nodes: Array<GuessTheScoreTaskLineup | So5Lineup | TaskLineup | ThresholdPickerTaskLineup>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
}

/** An edge in a connection. */
export interface LineupInterfaceEdge {
  __typename: 'LineupInterfaceEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<GuessTheScoreTaskLineup | So5Lineup | TaskLineup | ThresholdPickerTaskLineup>;
}

export interface ListedOnMarket extends CardUsageInterface {
  __typename: 'ListedOnMarket';
  offers: Array<TokenOffer>;
  slug: Scalars['String']['output'];
}

/** A loan */
export interface Loan extends Node {
  __typename: 'Loan';
  endDate: Scalars['ISO8601DateTime']['output'];
  extraCard?: Maybe<BaseballCard | Card | NBACard>;
  id: Scalars['ID']['output'];
  loanableRoster: LoanableRoster;
  nextEligibleLeaderboard?: Maybe<So5Leaderboard>;
  status: LoanStatus;
}

/** A Loan notification */
export interface LoanNotification extends Node, NotificationInterface {
  __typename: 'LoanNotification';
  body: Scalars['String']['output'];
  createdAt: Scalars['ISO8601DateTime']['output'];
  deeplinkUrl: Scalars['String']['output'];
  /** The date until which the user is eligible for a loan */
  eligibleUntil?: Maybe<Scalars['ISO8601DateTime']['output']>;
  iconUrl: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  important: Scalars['Boolean']['output'];
  loan?: Maybe<Loan>;
  markdownBody: Scalars['String']['output'];
  name: Scalars['String']['output'];
  pictureUrl?: Maybe<Scalars['String']['output']>;
  read: Scalars['Boolean']['output'];
  sport?: Maybe<SportOrShared>;
  title: Scalars['String']['output'];
  user: CurrentUser;
}

export const LoanStatus = {
  ACTIVE: 'ACTIVE',
  CANCELLED: 'CANCELLED',
  CREATED: 'CREATED',
  EXPIRED: 'EXPIRED'
} as const;

export type LoanStatus = typeof LoanStatus[keyof typeof LoanStatus];
/** Queries related to loanable rosters and players */
export interface LoanableConfigRoot {
  __typename: 'LoanableConfigRoot';
  eligibleUntil?: Maybe<Scalars['ISO8601DateTime']['output']>;
  loanableRosters: Array<LoanableRoster>;
  nextEligibleLeaderboard?: Maybe<So5Leaderboard>;
  so5Competition: So5Competition;
}

/** A loanable player group */
export interface LoanableRoster extends Node {
  __typename: 'LoanableRoster';
  id: Scalars['ID']['output'];
  primaryOffers: Array<TokenPrimaryOffer>;
}

/** A loaned tokend */
export interface LoanedToken extends Node {
  __typename: 'LoanedToken';
  gameWeekLeft: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  loan: Loan;
}

export interface LobbySection {
  __typename: 'LobbySection';
  slug: Scalars['String']['output'];
  so5LeaderboardGroups: Array<So5LeaderboardGroup | So5League>;
  title: Scalars['String']['output'];
}


export interface LobbySectionso5LeaderboardGroupsArgs {
  includeClosed?: InputMaybe<Scalars['Boolean']['input']>;
}

export const LobbySectionType = {
  ALL_SEASONS: 'ALL_SEASONS',
  FEATURED: 'FEATURED',
  IN_SEASON: 'IN_SEASON',
  SPECIALS: 'SPECIALS'
} as const;

export type LobbySectionType = typeof LobbySectionType[keyof typeof LobbySectionType];
/** A location */
export interface Location {
  __typename: 'Location';
  countryCode?: Maybe<Scalars['String']['output']>;
  regionCode?: Maybe<Scalars['String']['output']>;
}

export const LockTypeEnum = {
  FIXTURE_CUT_OFF: 'FIXTURE_CUT_OFF',
  LEAGUE_CUT_OFF: 'LEAGUE_CUT_OFF',
  LINEUP_CUT_OFF: 'LINEUP_CUT_OFF',
  PLAYER_CUT_OFF: 'PLAYER_CUT_OFF'
} as const;

export type LockTypeEnum = typeof LockTypeEnum[keyof typeof LockTypeEnum];
/** A Loom Account */
export interface LoomAccount extends Node {
  __typename: 'LoomAccount';
  address: Scalars['String']['output'];
  id: Scalars['ID']['output'];
}

/** A headline stat displayed on a manager profile */
export interface ManagerProfileStat {
  label: Scalars['String']['output'];
}

export const ManagerProgressionTaskSlug = {
  ANY_REFEREE_SPENT_GEMS: 'ANY_REFEREE_SPENT_GEMS',
  BOUGHT_PACKS_COUNT: 'BOUGHT_PACKS_COUNT',
  BUY_CARD_PACK: 'BUY_CARD_PACK',
  CARDS_COUNT: 'CARDS_COUNT',
  CARDS_COUNT_TARGET: 'CARDS_COUNT_TARGET',
  CLAIM_TASK: 'CLAIM_TASK',
  COLLECTION_POINTS: 'COLLECTION_POINTS',
  COLLECT_CARD_BY_TIER: 'COLLECT_CARD_BY_TIER',
  COMPLETE_COLLECTIONS_COUNT: 'COMPLETE_COLLECTIONS_COUNT',
  COMPLETE_COLLECTIONS_COUNT_TARGET: 'COMPLETE_COLLECTIONS_COUNT_TARGET',
  COMPLETE_TASK: 'COMPLETE_TASK',
  COMPOSE_TEAM: 'COMPOSE_TEAM',
  DAILY_ACTION: 'DAILY_ACTION',
  DAILY_CLAIM: 'DAILY_CLAIM',
  DECISIVE_PLAYER_PICKER: 'DECISIVE_PLAYER_PICKER',
  DECISIVE_SO5_APPEARANCE: 'DECISIVE_SO5_APPEARANCE',
  DROP_CHALLENGE: 'DROP_CHALLENGE',
  DROP_COMMON_CARD: 'DROP_COMMON_CARD',
  END_OF_SEASON: 'END_OF_SEASON',
  FOLLOW_USER: 'FOLLOW_USER',
  GUESS_THE_SCORE: 'GUESS_THE_SCORE',
  LEADERBOARD_RANK_PERCENTAGE_THRESHOLD: 'LEADERBOARD_RANK_PERCENTAGE_THRESHOLD',
  LEVEL_UP_CARD: 'LEVEL_UP_CARD',
  NO_ACTION: 'NO_ACTION',
  ONBOARD_ON_SET: 'ONBOARD_ON_SET',
  PRO_THRESHOLD_PICKER: 'PRO_THRESHOLD_PICKER',
  REFEREE_COMPLETED_TASK: 'REFEREE_COMPLETED_TASK',
  REFEREE_SIGNED_UP: 'REFEREE_SIGNED_UP',
  SO5_APPEARANCE_SCORE: 'SO5_APPEARANCE_SCORE',
  SO5_LINEUP_SCORE: 'SO5_LINEUP_SCORE',
  SQUAD_THRESHOLD_PICKER: 'SQUAD_THRESHOLD_PICKER',
  STAR_PACK: 'STAR_PACK',
  TASKS_TRACK: 'TASKS_TRACK',
  TASK_APPEARANCE_SCORE: 'TASK_APPEARANCE_SCORE',
  THRESHOLDS_DUO_CONNECTION: 'THRESHOLDS_DUO_CONNECTION',
  THRESHOLDS_STREAK: 'THRESHOLDS_STREAK',
  THRESHOLDS_STREAK_ADDITIONAL_LINEUP: 'THRESHOLDS_STREAK_ADDITIONAL_LINEUP',
  THRESHOLD_PICKER: 'THRESHOLD_PICKER',
  UPDATE_MANAGER_PROFILE: 'UPDATE_MANAGER_PROFILE',
  UPSERT_TASK_APPEARANCES: 'UPSERT_TASK_APPEARANCES',
  UPSERT_TASK_LINEUP: 'UPSERT_TASK_LINEUP'
} as const;

export type ManagerProgressionTaskSlug = typeof ManagerProgressionTaskSlug[keyof typeof ManagerProgressionTaskSlug];
export const ManagerProgressionTaskState = {
  ARCHIVED: 'ARCHIVED',
  ASSIGNED: 'ASSIGNED',
  CANCELED: 'CANCELED',
  CLAIMED: 'CLAIMED',
  COMPLETED: 'COMPLETED',
  FAILED: 'FAILED',
  READY: 'READY'
} as const;

export type ManagerProgressionTaskState = typeof ManagerProgressionTaskState[keyof typeof ManagerProgressionTaskState];
/** Manager Task */
export interface ManagerTaskInterface {
  aasmState: ManagerProgressionTaskState;
  /** @deprecated Not used anymore */
  cards: Array<BaseballCard | Card | NBACard>;
  /** @deprecated Not used anymore */
  claimedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  completedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  description: Scalars['String']['output'];
  id: Scalars['String']['output'];
  name: ManagerProgressionTaskSlug;
  /** @deprecated Not used anymore */
  probabilisticBundles: Array<ProbabilisticBundle>;
  progress: Scalars['Int']['output'];
  rarity?: Maybe<Rarity>;
  target: Scalars['Int']['output'];
  title: Scalars['String']['output'];
}

export const ManagerTaskPeriodicity = {
  DAILY: 'DAILY',
  GAME_WEEKLY: 'GAME_WEEKLY',
  SEASONAL: 'SEASONAL',
  WEEKLY: 'WEEKLY'
} as const;

export type ManagerTaskPeriodicity = typeof ManagerTaskPeriodicity[keyof typeof ManagerTaskPeriodicity];
/** A manager team */
export interface ManagerTeam extends Node {
  __typename: 'ManagerTeam';
  activeDivision: Scalars['Int']['output'];
  activeDivisionIconUrl: Scalars['String']['output'];
  divisionChangingSo5Lineup?: Maybe<So5Lineup>;
  hidable: Scalars['Boolean']['output'];
  hidden: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  lastPreviousSo5Lineup?: Maybe<So5Lineup>;
  mainRarityType?: Maybe<Rarity>;
  mySo5Lineup?: Maybe<So5Lineup>;
  myTasks: Array<CardsCountTargetTask | CardsCountTask | CompleteCollectionsCountTargetTask | CompleteCollectionsCountTask | DailyActionTask | DecisivePlayerPickerTask | DropChallengeTask | GameWeeklyTask | GuessTheScoreTask | InviteTaskAsReferrer | So5LeaderboardTask | StarPackTask | Task | TasksTrack | ThresholdPickerTask | ThresholdsDuoConnectionTask | ThresholdsStreakAdditionalLineupTask | ThresholdsStreakTask>;
  name: Scalars['String']['output'];
  rarityType: Scalars['String']['output'];
  seasonality?: Maybe<So5LeaderboardSeasonality>;
  seasonalityInYears?: Maybe<Array<Scalars['Int']['output']>>;
  seasonalityName?: Maybe<Scalars['String']['output']>;
  so5Leaderboard?: Maybe<So5Leaderboard>;
  so5LeaderboardType: So5LeaderboardType;
  so5TournamentType: So5Tournament;
  svgLogoUrl: Scalars['String']['output'];
  tournamentType: Scalars['String']['output'];
  user: User;
}


/** A manager team */
export interface ManagerTeammySo5LineupArgs {
  so5LeagueSlug: Scalars['String']['input'];
}


/** A manager team */
export interface ManagerTeamso5LeaderboardArgs {
  so5FixtureSlug?: InputMaybe<Scalars['String']['input']>;
}

/** The connection type for ManagerTeam. */
export interface ManagerTeamConnection {
  __typename: 'ManagerTeamConnection';
  /** A list of edges. */
  edges: Array<ManagerTeamEdge>;
  /** A list of nodes. */
  nodes: Array<ManagerTeam>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
}

/** An edge in a connection. */
export interface ManagerTeamEdge {
  __typename: 'ManagerTeamEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<ManagerTeam>;
}

export interface MangopayApplePayApprovalInput {
  /** ApplePay payment data */
  applePaymentData: ApplePayPaymentDataInput;
}

/** A Mangopay Apple Pay authorization request */
export interface MangopayApplePayAuthorizationRequest {
  __typename: 'MangopayApplePayAuthorizationRequest';
  id: Scalars['String']['output'];
}

/** A Mangopay bank account owner address type */
export interface MangopayBankAccountOwnerAddress {
  __typename: 'MangopayBankAccountOwnerAddress';
  addressLine1?: Maybe<Scalars['String']['output']>;
  addressLine2?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  postalCode?: Maybe<Scalars['String']['output']>;
  region?: Maybe<Scalars['String']['output']>;
}

/** A Mangopay bank account status */
export const MangopayBankAccountStatus = {
  /** Active status */
  ACTIVE: 'ACTIVE',
  /** Canceled status */
  CANCELED: 'CANCELED',
  /** Deactivated status */
  DEACTIVATED: 'DEACTIVATED',
  /** Pending status */
  PENDING: 'PENDING'
} as const;

export type MangopayBankAccountStatus = typeof MangopayBankAccountStatus[keyof typeof MangopayBankAccountStatus];
/** A Mangopay bank account withdrawal fee type */
export const MangopayBankAccountWithdrawalFeeType = {
  /** Bank account currency differs from the wallet currency */
  INTERNATIONAL: 'INTERNATIONAL',
  /** Bank account currency matches the wallet currency */
  LOCAL: 'LOCAL'
} as const;

export type MangopayBankAccountWithdrawalFeeType = typeof MangopayBankAccountWithdrawalFeeType[keyof typeof MangopayBankAccountWithdrawalFeeType];
/** A Mangopay credit card authorization request */
export interface MangopayCreditCardAuthorizationRequest {
  __typename: 'MangopayCreditCardAuthorizationRequest';
  amount: Scalars['Int']['output'];
  currency: FiatCurrency;
  id: Scalars['String']['output'];
}

/** A Mangopay hosted identity verification session */
export interface MangopayIdentityVerification extends Node {
  __typename: 'MangopayIdentityVerification';
  hostedUrl: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  status: MangopayIdentityVerificationStatus;
}

export const MangopayIdentityVerificationStatus = {
  EXPIRED: 'EXPIRED',
  OUT_OF_DATE: 'OUT_OF_DATE',
  PENDING: 'PENDING',
  REFUSED: 'REFUSED',
  VALIDATED: 'VALIDATED'
} as const;

export type MangopayIdentityVerificationStatus = typeof MangopayIdentityVerificationStatus[keyof typeof MangopayIdentityVerificationStatus];
/** A Mangopay Internal Transfer */
export interface MangopayInternalTransfer extends Node {
  __typename: 'MangopayInternalTransfer';
  amounts: MonetaryAmount;
  id: Scalars['ID']['output'];
  status: InternalTransferState;
  withSorare: Scalars['Boolean']['output'];
}

/** A klarna authorization request */
export interface MangopayKlarnaAuthorizationRequest {
  __typename: 'MangopayKlarnaAuthorizationRequest';
  amount: Scalars['Int']['output'];
  currency: FiatCurrency;
  id: Scalars['String']['output'];
  redirectUrl: Scalars['String']['output'];
}

/** A Mangopay KYC Request */
export interface MangopayKycDocument extends Node {
  __typename: 'MangopayKycDocument';
  aasmState: KycRequestState;
  id: Scalars['ID']['output'];
}

/** A Mangopay KYC Request */
export interface MangopayKycRequest extends Node {
  __typename: 'MangopayKycRequest';
  aasmState: AdditionalKycRequestState;
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['ID']['output'];
  kycDocuments: Array<MangopayKycDocument>;
  outOfDateAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  refusedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  requestType: AdditionalKycRequestRequestType;
  validatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  validationAskedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
}

export interface MangopayNaturalUserAddressInput {
  city: Scalars['String']['input'];
  /** ISO 3166-1 alpha-2 country code */
  country: Scalars['String']['input'];
  postalCode: Scalars['String']['input'];
  state?: InputMaybe<Scalars['String']['input']>;
  streetLine1: Scalars['String']['input'];
  streetLine2?: InputMaybe<Scalars['String']['input']>;
}

/** A Mangopay pre-authorization status */
export const MangopayPreAuthorizationStatus = {
  CREATED: 'CREATED',
  FAILED: 'FAILED',
  SUCCEEDED: 'SUCCEEDED'
} as const;

export type MangopayPreAuthorizationStatus = typeof MangopayPreAuthorizationStatus[keyof typeof MangopayPreAuthorizationStatus];
/** A preAuthorization status fetched from Mangopay */
export interface MangopayRemotePreAuthorizationStatus {
  __typename: 'MangopayRemotePreAuthorizationStatus';
  message?: Maybe<Scalars['String']['output']>;
  preAuthorizationId?: Maybe<Scalars['String']['output']>;
  status?: Maybe<MangopayPreAuthorizationStatus>;
}

/** A Mangopay fetched transaction status */
export interface MangopayRemoteTransactionStatus {
  __typename: 'MangopayRemoteTransactionStatus';
  message?: Maybe<Scalars['String']['output']>;
  status?: Maybe<MangopayTransactionStatus>;
  transactionId?: Maybe<Scalars['String']['output']>;
}

/** The Mangopay fields */
export interface MangopayRoot {
  __typename: 'MangopayRoot';
  bankAccountType: BankAccountType;
  countryCurrency?: Maybe<FiatCurrency>;
  id: Scalars['ID']['output'];
  klarnaPayinConfig: Array<KlarnaPayinConfig>;
  kycDocumentRequirements: Array<KycDocumentRequirement>;
  ownerRegionRequired: Scalars['Boolean']['output'];
  remotePreAuthorizationStatus: MangopayRemotePreAuthorizationStatus;
  remoteTransactionStatus: MangopayRemoteTransactionStatus;
}


/** The Mangopay fields */
export interface MangopayRootbankAccountTypeArgs {
  countryCode: Scalars['String']['input'];
  currency?: InputMaybe<FiatCurrency>;
}


/** The Mangopay fields */
export interface MangopayRootcountryCurrencyArgs {
  countryCode: Scalars['String']['input'];
}


/** The Mangopay fields */
export interface MangopayRootkycDocumentRequirementsArgs {
  countryCode: Scalars['String']['input'];
}


/** The Mangopay fields */
export interface MangopayRootownerRegionRequiredArgs {
  countryCode: Scalars['String']['input'];
}


/** The Mangopay fields */
export interface MangopayRootremotePreAuthorizationStatusArgs {
  preAuthorizationId: Scalars['String']['input'];
}


/** The Mangopay fields */
export interface MangopayRootremoteTransactionStatusArgs {
  transactionId: Scalars['String']['input'];
}

/** A Mangopay transaction status */
export const MangopayTransactionStatus = {
  CREATED: 'CREATED',
  FAILED: 'FAILED',
  SUCCEEDED: 'SUCCEEDED'
} as const;

export type MangopayTransactionStatus = typeof MangopayTransactionStatus[keyof typeof MangopayTransactionStatus];
/** A Mangopay User */
export interface MangopayUser extends Node {
  __typename: 'MangopayUser';
  additionalKycRequests?: Maybe<Array<MangopayKycRequest>>;
  blocked: Scalars['Boolean']['output'];
  blockingCode?: Maybe<Scalars['String']['output']>;
  consentGiven: Scalars['Boolean']['output'];
  countryOfResidence?: Maybe<Country>;
  dob?: Maybe<Scalars['ISO8601Date']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  hostedIdentityVerificationRequired: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  inflowsBlocked: Scalars['Boolean']['output'];
  kycRenewalDeadline?: Maybe<Scalars['ISO8601Date']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  mangopayTermsAndConditionsAccepted?: Maybe<Scalars['Boolean']['output']>;
  mangopayUserId: Scalars['String']['output'];
  nationality?: Maybe<Country>;
  outflowsBlocked: Scalars['Boolean']['output'];
  requiredDocuments?: Maybe<Array<DocumentType>>;
  scaEnrollmentState?: Maybe<SCAEnrollmentState>;
}

export interface MangopayWalletTransferApprovalInput {
  nonce: Scalars['Int']['input'];
  signature: StarkwareSignatureInput;
}

/** A Mangopay wallet transfer authorization request */
export interface MangopayWalletTransferAuthorizationRequest {
  __typename: 'MangopayWalletTransferAuthorizationRequest';
  amount: Scalars['Int']['output'];
  currency: FiatCurrency;
  mangopayWalletId: Scalars['String']['output'];
  nonce: Scalars['Int']['output'];
  operationHash: Scalars['String']['output'];
}

/** A Mangopay Withdrawal */
export interface MangopayWithdrawal extends Node {
  __typename: 'MangopayWithdrawal';
  amounts: MonetaryAmount;
  bankAccount: BankAccount;
  id: Scalars['ID']['output'];
  status: WithdrawalState;
  to: Scalars['String']['output'];
}

export interface MarketItem {
  endDate?: Maybe<Scalars['ISO8601DateTime']['output']>;
}

/** A live ops market set section */
export interface MarketLiveOps extends MarketSetSection {
  __typename: 'MarketLiveOps';
  backgroundUrl?: Maybe<Scalars['String']['output']>;
  cardPacks: Array<CardPack>;
  endsAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  games: Array<Game | GameOfBaseball | GameOfBasketball>;
  /** @deprecated Not used anymore */
  hoverColor?: Maybe<Scalars['String']['output']>;
  mainColor?: Maybe<Scalars['String']['output']>;
  resetAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  title: Scalars['String']['output'];
  titleBackgroundUrl?: Maybe<Scalars['String']['output']>;
}

/** A promotional event taking place in the marketplace */
export interface MarketPromotionalEvent extends Node, PromotionalEventInterface {
  __typename: 'MarketPromotionalEvent';
  algoliaFilters: Scalars['String']['output'];
  backgroundPictureUrl?: Maybe<Scalars['String']['output']>;
  bannerAssetsPictureUrl?: Maybe<Scalars['String']['output']>;
  blogUrl?: Maybe<Scalars['String']['output']>;
  cardFromDomesticLeague?: Maybe<Scalars['Boolean']['output']>;
  cardFromSameTeam?: Maybe<Scalars['Boolean']['output']>;
  description: Scalars['String']['output'];
  eligibilityRules: EligibilityRules;
  endDate: Scalars['ISO8601DateTime']['output'];
  filterPictureUrl?: Maybe<Scalars['String']['output']>;
  hasInstantBuy: Scalars['Boolean']['output'];
  heroValueProps: Array<HeroValueProp>;
  id: Scalars['ID']['output'];
  logoUrl?: Maybe<Scalars['String']['output']>;
  marketBannerTitle: Scalars['String']['output'];
  mobileBackgroundPictureUrl?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  pictureUrl?: Maybe<Scalars['String']['output']>;
  probableRewardConfigs: Array<ProbableRewardConfig>;
  promotionType: PromotionType;
  secondaryBannerPictureUrl?: Maybe<Scalars['String']['output']>;
  slug: Scalars['String']['output'];
  sport: Sport;
  startDate: Scalars['ISO8601DateTime']['output'];
  termsAndConditionsUrl?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
}

/** The Market fields */
export interface MarketRoot {
  __typename: 'MarketRoot';
  activeSteppedDynamicCampaigns: InstantBuyCampaignConnection;
  activeWheelConfig?: Maybe<WheelConfig>;
  /** @deprecated Not used anymore */
  availableCardPackGroups: Array<CardPackGroup>;
  cardPack: CardPack;
  cardPackGroup: CardPackGroup;
  /** @deprecated Not used anymore */
  cardPackGroups: Array<CardPackGroup>;
  /** The `flash_sale_picks` field cannot be nested within a list. */
  flashSalePicks: FlashSalePicks;
  /** The gems shop set section, also available through setSections */
  gemsShop?: Maybe<GemsShop>;
  id: Scalars['ID']['output'];
  inGameCurrencyPack: InGameCurrencyPack;
  inGameCurrencyPacks: Array<InGameCurrencyPack>;
  myCommonDailyClaimTask?: Maybe<CardsCountTargetTask | CardsCountTask | CompleteCollectionsCountTargetTask | CompleteCollectionsCountTask | DailyActionTask | DecisivePlayerPickerTask | DropChallengeTask | GameWeeklyTask | GuessTheScoreTask | InviteTaskAsReferrer | So5LeaderboardTask | StarPackTask | Task | TasksTrack | ThresholdPickerTask | ThresholdsDuoConnectionTask | ThresholdsStreakAdditionalLineupTask | ThresholdsStreakTask>;
  myWheelTasks: Array<CardsCountTargetTask | CardsCountTask | CompleteCollectionsCountTargetTask | CompleteCollectionsCountTask | DailyActionTask | DecisivePlayerPickerTask | DropChallengeTask | GameWeeklyTask | GuessTheScoreTask | InviteTaskAsReferrer | So5LeaderboardTask | StarPackTask | Task | TasksTrack | ThresholdPickerTask | ThresholdsDuoConnectionTask | ThresholdsStreakAdditionalLineupTask | ThresholdsStreakTask>;
  onboardingConversionCredit?: Maybe<ConversionCredit>;
  potentialDiscount?: Maybe<Scalars['String']['output']>;
  potentialDiscountBreakdown?: Maybe<Array<PotentialDiscountBreakdown>>;
  publicWatchlists: WatchlistConnection;
  /** The essence pack to offer first, from the highest ranked available pack group selling one */
  recommendedCardPack?: Maybe<CardPack>;
  setSections: Array<CardPackGroup | FeaturedCardPack | FeaturedMarketSection | GemsShop | LegacyPacks | MarketLiveOps | MarketSetSpecialBundles | MarketSetWelcomeOffer | SpecialOffers | WeeklyDeals>;
  sorareWatchlists: Array<Watchlist>;
  /** @deprecated Use commonDailyClaimTask & wheelTasks instead */
  tasks: Array<CardsCountTargetTask | CardsCountTask | CompleteCollectionsCountTargetTask | CompleteCollectionsCountTask | DailyActionTask | DecisivePlayerPickerTask | DropChallengeTask | GameWeeklyTask | GuessTheScoreTask | InviteTaskAsReferrer | So5LeaderboardTask | StarPackTask | Task | TasksTrack | ThresholdPickerTask | ThresholdsDuoConnectionTask | ThresholdsStreakAdditionalLineupTask | ThresholdsStreakTask>;
  trendingPlayers: TradedPlayerConnection;
  voucher: PurchasableItemsVoucher;
  watchlist?: Maybe<Watchlist>;
}


/** The Market fields */
export interface MarketRootactiveSteppedDynamicCampaignsArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
}


/** The Market fields */
export interface MarketRootactiveWheelConfigArgs {
  rarity: Rarity;
  sport: Sport;
}


/** The Market fields */
export interface MarketRootavailableCardPackGroupsArgs {
  legacy?: InputMaybe<Scalars['Boolean']['input']>;
  sport: Sport;
}


/** The Market fields */
export interface MarketRootcardPackArgs {
  slug: Scalars['String']['input'];
}


/** The Market fields */
export interface MarketRootcardPackGroupArgs {
  slug: Scalars['String']['input'];
}


/** The Market fields */
export interface MarketRootcardPackGroupsArgs {
  so5LeaderboardSlug?: InputMaybe<Scalars['String']['input']>;
  sport: Sport;
}


/** The Market fields */
export interface MarketRootflashSalePicksArgs {
  advancedFilters?: InputMaybe<Scalars['String']['input']>;
  facets?: InputMaybe<Array<InputMaybe<SearchFacetDefinitionInput>>>;
  filters?: InputMaybe<Array<InputMaybe<SearchFilterInput>>>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  refinements?: InputMaybe<Array<InputMaybe<SearchRefinementInput>>>;
  sorts?: InputMaybe<Array<InputMaybe<SearchSortInput>>>;
  sport?: InputMaybe<Sport>;
}


/** The Market fields */
export interface MarketRootgemsShopArgs {
  sport: Sport;
}


/** The Market fields */
export interface MarketRootinGameCurrencyPackArgs {
  id: Scalars['ID']['input'];
}


/** The Market fields */
export interface MarketRootinGameCurrencyPacksArgs {
  currency: InGameCurrency;
}


/** The Market fields */
export interface MarketRootmyCommonDailyClaimTaskArgs {
  sport: Sport;
}


/** The Market fields */
export interface MarketRootmyWheelTasksArgs {
  rarity: Rarity;
  sport: Sport;
}


/** The Market fields */
export interface MarketRootonboardingConversionCreditArgs {
  affiliate?: InputMaybe<Scalars['Boolean']['input']>;
  sport: Sport;
}


/** The Market fields */
export interface MarketRootpotentialDiscountArgs {
  amount: AmountInput;
  auctionId?: InputMaybe<Scalars['ID']['input']>;
  exchangeRateId: Scalars['ID']['input'];
  sport?: InputMaybe<Sport>;
}


/** The Market fields */
export interface MarketRootpotentialDiscountBreakdownArgs {
  amount: AmountInput;
  auctionId?: InputMaybe<Scalars['ID']['input']>;
  exchangeRateId: Scalars['ID']['input'];
  sport?: InputMaybe<Sport>;
}


/** The Market fields */
export interface MarketRootpublicWatchlistsArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  so5CompetitionSlug?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<WatchlistSorting>;
  sport: Sport;
}


/** The Market fields */
export interface MarketRootrecommendedCardPackArgs {
  sport: Sport;
}


/** The Market fields */
export interface MarketRootsetSectionsArgs {
  sport: Sport;
}


/** The Market fields */
export interface MarketRootsorareWatchlistsArgs {
  sport: Sport;
}


/** The Market fields */
export interface MarketRoottasksArgs {
  genre?: InputMaybe<TaskGenre>;
  sport: Sport;
}


/** The Market fields */
export interface MarketRoottrendingPlayersArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  so5CompetitionSlug: Scalars['String']['input'];
}


/** The Market fields */
export interface MarketRootvoucherArgs {
  id: Scalars['ID']['input'];
}


/** The Market fields */
export interface MarketRootwatchlistArgs {
  id: Scalars['ID']['input'];
}

export interface MarketSetSection {
  backgroundUrl?: Maybe<Scalars['String']['output']>;
  endsAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** @deprecated Not used anymore */
  hoverColor?: Maybe<Scalars['String']['output']>;
  mainColor?: Maybe<Scalars['String']['output']>;
  resetAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  title: Scalars['String']['output'];
  titleBackgroundUrl?: Maybe<Scalars['String']['output']>;
}

/** DEPRECATED: A special bundles market set section. Bundles are now part of the Gems Shop section. */
export interface MarketSetSpecialBundles extends MarketSetSection {
  __typename: 'MarketSetSpecialBundles';
  backgroundUrl?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use GemsShop.purchasableItems instead */
  bundledPurchasableItems: Array<BundledPurchasableItem>;
  endsAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** @deprecated Not used anymore */
  hoverColor?: Maybe<Scalars['String']['output']>;
  mainColor?: Maybe<Scalars['String']['output']>;
  resetAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  title: Scalars['String']['output'];
  titleBackgroundUrl?: Maybe<Scalars['String']['output']>;
}

/** A welcome offer market set section */
export interface MarketSetWelcomeOffer extends MarketSetSection {
  __typename: 'MarketSetWelcomeOffer';
  backgroundUrl?: Maybe<Scalars['String']['output']>;
  endsAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** @deprecated Not used anymore */
  hoverColor?: Maybe<Scalars['String']['output']>;
  mainColor?: Maybe<Scalars['String']['output']>;
  resetAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  title: Scalars['String']['output'];
  titleBackgroundUrl?: Maybe<Scalars['String']['output']>;
  voucher: PurchasableItemsVoucher;
}

/** A Marketing Notification */
export interface MarketingNotification extends Node, NotificationInterface {
  __typename: 'MarketingNotification';
  body: Scalars['String']['output'];
  createdAt: Scalars['ISO8601DateTime']['output'];
  deeplinkUrl: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  iconUrl: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  imageUrl?: Maybe<Scalars['String']['output']>;
  important: Scalars['Boolean']['output'];
  markdownBody: Scalars['String']['output'];
  name: Scalars['String']['output'];
  pictureUrl?: Maybe<Scalars['String']['output']>;
  read: Scalars['Boolean']['output'];
  sport?: Maybe<SportOrShared>;
  title: Scalars['String']['output'];
  url: Scalars['String']['output'];
  user: CurrentUser;
}

/** A single marketplace preference */
export interface MarketplacePreference {
  __typename: 'MarketplacePreference';
  defaultValue?: Maybe<Scalars['Json']['output']>;
  name: Scalars['String']['output'];
  value: Scalars['Json']['output'];
  values: Array<Scalars['Json']['output']>;
}

/** A marketplace preference */
export interface MarketplacePreferenceInput {
  name: Scalars['String']['input'];
  sports: Array<Sport>;
  value: Scalars['Json']['input'];
}

/** Marketplace preferences specific to a sport */
export interface MarketplaceSportPreferences {
  __typename: 'MarketplaceSportPreferences';
  preferences: Array<MarketplacePreference>;
  sport: Sport;
}

/** Enforces restrictions on the number of card that own the user of submitted lineups */
export interface MaximumCardsCountOwnedByUser {
  __typename: 'MaximumCardsCountOwnedByUser';
  maximumCards: Scalars['Int']['output'];
  scarcity?: Maybe<Scalars['String']['output']>;
}

/** An object representing a club for which a player has played during a certain time. */
export interface Membership extends Node {
  __typename: 'Membership';
  aggregatedStats: Stats;
  club?: Maybe<Club>;
  endDate?: Maybe<Scalars['ISO8601DateTime']['output']>;
  id: Scalars['ID']['output'];
  player: Player;
  startDate: Scalars['ISO8601DateTime']['output'];
  stats: Array<Stats>;
  team: Club | NationalTeam;
}

/** The connection type for Membership. */
export interface MembershipConnection {
  __typename: 'MembershipConnection';
  /** A list of edges. */
  edges: Array<MembershipEdge>;
  /** A list of nodes. */
  nodes: Array<Membership>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
}

/** An edge in a connection. */
export interface MembershipEdge {
  __typename: 'MembershipEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<Membership>;
}

export interface MissedAppearance extends AppearanceInterface, ComposeTeamBenchObjectInterface, So5AppearanceInterface {
  __typename: 'MissedAppearance';
  activeSuspensions: Array<Suspension>;
  anyCard?: Maybe<BaseballCard | Card | NBACard>;
  anyCardWithLivePrimaryOffer?: Maybe<BaseballCard | Card | NBACard>;
  anyPlayer: BaseballPlayer | NBAPlayer | Player;
  anyPlayerGameStats?: Maybe<PlayerGameStats | PlayerGameStatsBaseball | PlayerGameStatsBasketball>;
  anyTeam: Club | NationalTeam;
  averageScore?: Maybe<Scalars['Float']['output']>;
  bonus?: Maybe<Scalars['Float']['output']>;
  bonusPoints?: Maybe<Scalars['Float']['output']>;
  bonusRating?: Maybe<BonusOrdinalRatingEnum>;
  bonuses: Array<So5ActiveClubsBonus | So5AverageScoresBonus | So5BoostBonus | So5CaptainBonus | So5CollectionBonus | So5DifferentNationalitiesBonus | So5GradeBonus | So5LineupBonus | So5MalusAfterTransferBonus | So5NationalityBonus | So5PlayerBonus | So5PositionBonus | So5PositionStacksBonus | So5SameActiveClubBonus | So5ScarcityBonus | So5SeasonBonus | So5SpecialEditionCardsBonus>;
  boosted: Scalars['Boolean']['output'];
  captain: Scalars['Boolean']['output'];
  cardBorderRadius: Scalars['Int']['output'];
  cleanScore?: Maybe<Scalars['Float']['output']>;
  eligiblePlayerGameScores: Array<BaseballPlayerGameScore | BasketballPlayerGameScore | PlayerGameScore | So5Score>;
  eligibleSo5Scores: Array<So5Score>;
  /** @deprecated Energy is deprecated */
  energized: Scalars['Boolean']['output'];
  firstGame?: Maybe<Game | GameOfBaseball | GameOfBasketball>;
  /**
   * Projected score minus the lowest score of the player star tier for NBA, minus
   * the L10 average otherwise, from the projection the bench sorts
   * GAIN_ON_PROJECTION on: the next game on a card bench with no fixture, the
   * fixture projection otherwise
   */
  gainOnProjection?: Maybe<Scalars['Float']['output']>;
  /** Appearance card level at that time */
  grade: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  index: Scalars['Int']['output'];
  licensed: Scalars['Boolean']['output'];
  /** When a bench object will be locked for a leaderboard */
  lockedAt: Scalars['ISO8601DateTime']['output'];
  /** Wether a bench object can be updated for a leaderboard */
  lockedForLeaderboard: Scalars['Boolean']['output'];
  pictureUrl?: Maybe<Scalars['String']['output']>;
  playedGames: Array<Game | GameOfBaseball | GameOfBasketball>;
  player: Player;
  playerGameScore?: Maybe<BaseballPlayerGameScore | BasketballPlayerGameScore | PlayerGameScore | So5Score>;
  position: Position;
  positions: Array<Position>;
  powerBreakdown: PowerBreakdown;
  /** PowerBreakdown as long as leaderboard is playable. PowerPointsBreakdown after */
  powerBreakdownOrPowerPointsBreakdown?: Maybe<PowerBreakdownOrPowerPointsBreakdown>;
  projectedScore?: Maybe<Scalars['Float']['output']>;
  rarity: Rarity;
  relevantStats: Scalars['Json']['output'];
  score: Scalars['Float']['output'];
  scoreStatus: ScoreStatus;
  so5Fixture: So5Fixture;
  status: Scalars['String']['output'];
  upcomingGame?: Maybe<Game | GameOfBaseball | GameOfBasketball>;
  videoUrl?: Maybe<Scalars['String']['output']>;
  /** Appearance card XP at that time */
  xp: Scalars['Int']['output'];
  /** XP end range of appearance card level at that time */
  xpNeededForNextGrade?: Maybe<Scalars['Int']['output']>;
}


export interface MissedAppearanceactiveSuspensionsArgs {
  so5LeaderboardSlug?: InputMaybe<Scalars['String']['input']>;
}


export interface MissedAppearanceanyCardWithLivePrimaryOfferArgs {
  rarity?: InputMaybe<Rarity>;
}


export interface MissedAppearanceaverageScoreArgs {
  type: AveragePlayerScore;
}


export interface MissedAppearancebonusesArgs {
  highlighted?: InputMaybe<Scalars['Boolean']['input']>;
}


export interface MissedAppearanceeligiblePlayerGameScoresArgs {
  boardId?: InputMaybe<Scalars['String']['input']>;
  gameId?: InputMaybe<Scalars['ID']['input']>;
  so5LeaderboardSlug?: InputMaybe<Scalars['String']['input']>;
  stepId?: InputMaybe<Scalars['String']['input']>;
  taskId?: InputMaybe<Scalars['ID']['input']>;
}


export interface MissedAppearancelockedAtArgs {
  so5LeaderboardSlug?: InputMaybe<Scalars['String']['input']>;
}


export interface MissedAppearancelockedForLeaderboardArgs {
  so5LeaderboardSlug?: InputMaybe<Scalars['String']['input']>;
}


export interface MissedAppearancepictureUrlArgs {
  derivative?: InputMaybe<Scalars['String']['input']>;
}


export interface MissedAppearanceprojectedScoreArgs {
  so5LeaderboardSlug: Scalars['String']['input'];
}


export interface MissedAppearancescoreArgs {
  withBonus?: InputMaybe<Scalars['Boolean']['input']>;
}


export interface MissedAppearancevideoUrlArgs {
  derivative?: InputMaybe<Scalars['String']['input']>;
}

/** A missed So5Lineup */
export interface MissedLineup {
  __typename: 'MissedLineup';
  appearances: Array<MissedAppearance>;
  name: Scalars['String']['output'];
  slug: Scalars['String']['output'];
  so5Leaderboard?: Maybe<So5Leaderboard>;
}

export interface MonetaryAmount {
  __typename: 'MonetaryAmount';
  eurCents?: Maybe<Scalars['Int']['output']>;
  gbpCents?: Maybe<Scalars['Int']['output']>;
  lamport?: Maybe<Scalars['CryptocurrencyAmount']['output']>;
  referenceCurrency: SupportedCurrency;
  usdCents?: Maybe<Scalars['Int']['output']>;
  wei?: Maybe<Scalars['WeiAmount']['output']>;
}

/** An Monetary Reward */
export interface MonetaryReward extends AnyRewardInterface, Node {
  __typename: 'MonetaryReward';
  aasmState: RewardState;
  amount: MonetaryAmount;
  config: MonetaryRewardConfig;
  id: Scalars['ID']['output'];
  poolSize: Scalars['Int']['output'];
  sharedPool: Scalars['Boolean']['output'];
}

/** A Monetary Reward Config */
export interface MonetaryRewardConfig extends AnyRewardConfigInterface {
  __typename: 'MonetaryRewardConfig';
  amount: MonetaryAmount;
  boostedRewardConfigs?: Maybe<Array<CardPacksRewardConfig | CardRewardConfig | CardShardRewardConfig | CoinRewardConfig | ConversionCreditRewardConfig | DeliverableItemRewardConfig | ExperienceRewardConfig | InGameCurrencyRewardConfig | MonetaryRewardConfig | ProbabilisticBundleRewardConfig | ShopItemRewardConfig>>;
  id: Scalars['ID']['output'];
  poolSize: Scalars['Int']['output'];
  sharedPool: Scalars['Boolean']['output'];
}

export interface Mutation {
  __typename: 'Mutation';
  /** Accept an offer */
  acceptOffer?: Maybe<acceptOfferPayload>;
  /** Accept proposed draftable appearance for the Pro game mode */
  acceptSo5NoCardBoardDraftableAppearance?: Maybe<acceptSo5NoCardBoardDraftableAppearancePayload>;
  /** Accept proposed draftable appearance for a So5NoCardLineup */
  acceptSo5NoCardDraftableAppearance?: Maybe<acceptSo5NoCardDraftableAppearancePayload>;
  /** Accept a So5NoCardLineup */
  acceptSo5NoCardLineup?: Maybe<acceptSo5NoCardLineupPayload>;
  /** Accept terms of service */
  acceptTerms?: Maybe<AcceptTermsMutationPayload>;
  /** Acknowledge a step for the current user */
  acknowledgeStep?: Maybe<acknowledgeStepPayload>;
  activateWalletRecovery?: Maybe<activateWalletRecoveryPayload>;
  /** Allows a user to configure a reminder on an auction */
  addAuctionReminder?: Maybe<addAuctionReminderPayload>;
  addDevice?: Maybe<addDevicePayload>;
  /** Attach a referrer code to the current user after signup */
  addReferrerCode?: Maybe<addReferrerCodePayload>;
  addSolanaAddress?: Maybe<addSolanaAddressPayload>;
  /** Add cards to the cart */
  addToCart?: Maybe<addToCartPayload>;
  /** add a player to a watchlist */
  addToWatchlist?: Maybe<addToWatchlistPayload>;
  /** Allows a user to add tokens to a deck */
  addTokensToDeck?: Maybe<addTokensToDeckPayload>;
  addWalletRecovery?: Maybe<addWalletRecoveryPayload>;
  /** Approve Migrator contract */
  approveMigrator?: Maybe<approveMigratorPayload>;
  /** Request proxy consent for Mangopay actions */
  askForProxyConsent?: Maybe<askForProxyConsentPayload>;
  /** Bid on an auction */
  bid?: Maybe<bidPayload>;
  /** Block another user from sending offers */
  blockUserOffers?: Maybe<blockUserOffersPayload>;
  /** Buys a card pack */
  buyCardPack?: Maybe<buyCardPackPayload>;
  cancelBankWithdrawal?: Maybe<cancelBankWithdrawalPayload>;
  /** Cancel a mobile payment */
  cancelMobilePurchase?: Maybe<cancelMobilePurchasePayload>;
  /** Cancel an offer */
  cancelOffer?: Maybe<cancelOfferPayload>;
  changePassword?: Maybe<changePasswordPayload>;
  /** Check phone number verification code */
  checkPhoneNumberVerificationCode?: Maybe<checkPhoneNumberVerificationCodePayload>;
  /** Claim the current user's completed set_raffle tasks of a sport, 100 tasks at a time */
  claimAllSetRaffleTasks?: Maybe<claimAllSetRaffleTasksPayload>;
  /** Claim a reward */
  claimAnyReward?: Maybe<claimAnyRewardPayload>;
  /** Claim specific cards from a card pack */
  claimCardsFromPack?: Maybe<claimCardsFromPackPayload>;
  claimConversionCredit?: Maybe<claimConversionCreditPayload>;
  /** Claim an deliverable item order */
  claimDeliverableItemOrder?: Maybe<claimDeliverableItemOrderPayload>;
  /** Claims the onboarding conversion credit */
  claimOnboardingConversionCredit?: Maybe<claimOnboardingConversionCreditPayload>;
  /**
   * Claim onboarding energy gift
   * @deprecated Energy is deprecated
   */
  claimOnboardingEnergyGift?: Maybe<claimOnboardingEnergyGiftPayload>;
  /** Claim the airdrop of a promotional event */
  claimPromotionalEventAirdrop?: Maybe<claimPromotionalEventAirdropPayload>;
  /** Claim a referral reward */
  claimReferralReward?: Maybe<claimReferralRewardPayload>;
  /** Claim a reward */
  claimReward?: Maybe<claimRewardPayload>;
  /** Claim rewards */
  claimRewards?: Maybe<claimRewardsPayload>;
  /** Claim starter pack of common cards during onboarding */
  claimStarterPack?: Maybe<claimStarterPackPayload>;
  /**
   * Claim a step
   * @deprecated Use acknowledgeStep instead
   */
  claimStep?: Maybe<claimStepPayload>;
  /** Claim a task */
  claimTask?: Maybe<claimTaskPayload>;
  /** Submits personal information for JONUM verification. */
  collectJonumPersonalInfo?: Maybe<collectJonumPersonalInfoPayload>;
  /** Completes a drop challenge */
  completeDropChallenge?: Maybe<completeDropChallengePayload>;
  /** Confirm the picked card from a card pull */
  confirmCardPull?: Maybe<confirmCardPullPayload>;
  /** Confirm Device */
  confirmDevice?: Maybe<ConfirmDeviceMutationPayload>;
  /** Confirm Device With Code */
  confirmDeviceWithCode?: Maybe<confirmDeviceWithCodePayload>;
  /** Confirm Email address */
  confirmEmail?: Maybe<ConfirmEmailMutationPayload>;
  confirmSo5LineupImportsBatch?: Maybe<confirmSo5LineupImportsBatchPayload>;
  /** Confirms user Lineups */
  confirmSo5Lineups?: Maybe<confirmSo5LineupsPayload>;
  /** Confirm a So5NoCardLineup */
  confirmSo5NoCardLineup?: Maybe<confirmSo5NoCardLineupPayload>;
  /** Consume Ephemeral Token */
  consumeEphemeralToken?: Maybe<ConsumeEphemeralTokenMutationPayload>;
  /** Convert craft clues between rarities for a given clue base */
  convertCraftClues?: Maybe<convertCraftCluesPayload>;
  /** Create an API key for the current user */
  createApiKey?: Maybe<createApiKeyPayload>;
  createBankWithdrawal?: Maybe<createBankWithdrawalPayload>;
  /** Bookmark a so5 leaderboard type or a pro board, keeping the existing bookmark if any */
  createBookmark?: Maybe<createBookmarkPayload>;
  /** Create a Mangopay credit card authorization */
  createCardAuthorization?: Maybe<createCardAuthorizationPayload>;
  /** Create a Mangopay Card Registration */
  createCardRegistration?: Maybe<createCardRegistrationPayload>;
  /** Create connected tasks for a campaign */
  createConnectedTasks?: Maybe<createConnectedTasksPayload>;
  /** Store user-initiated crypto deposits */
  createCryptoDeposit?: Maybe<createCryptoDepositPayload>;
  /** Allows a user to create a deck. */
  createDeck?: Maybe<createDeckPayload>;
  /** Create a dedicated bank account to enable user deposits */
  createDepositBankAccount?: Maybe<createDepositBankAccountMutationPayload>;
  /** Send a Direct Offer to another manager */
  createDirectOffer?: Maybe<createDirectOfferPayload>;
  /** Creates an ephemeral link */
  createEphemeralLink?: Maybe<createEphemeralLinkPayload>;
  createEthBankWithdrawalIntent?: Maybe<createEthBankWithdrawalIntentPayload>;
  /**
   * Store user-initiated ETH deposits
   * @deprecated Use createCryptoDeposit instead
   */
  createEthDeposit?: Maybe<createEthDepositPayload>;
  /**
   * Creates an eth vault
   * @deprecated Legacy
   */
  createEthVault?: Maybe<createEthVaultPayload>;
  createFiatPayer?: Maybe<createFiatPayerPayload>;
  createFiatWallet?: Maybe<createFiatWalletPayload>;
  /** Create a fiat withdrawal to a bank account */
  createFiatWithdrawal?: Maybe<createFiatWithdrawalPayload>;
  /** create an identity verification session */
  createIdentityVerificationSession?: Maybe<createIdentityVerificationSessionPayload>;
  /** Creates a JONUM verification record for a user based on IP geolocation. */
  createJonumVerification?: Maybe<createJonumVerificationPayload>;
  /** Creates a JWT token */
  createJwtToken?: Maybe<createJwtTokenPayload>;
  /** Request a new OAuth application, pending admin review */
  createOAuthApplication?: Maybe<CreateMutationPayload>;
  /** Creates a Bridge.xyz off-ramp customer for the current user. */
  createOffRampBridgeCustomer?: Maybe<createOffRampBridgeCustomerPayload>;
  /** Generates a Bridge-hosted Terms of Service URL for the current user. */
  createOffRampBridgeTosLink?: Maybe<createOffRampBridgeTosLinkPayload>;
  /** Create an onboarding user Lineup (first compose) */
  createOnboardingSo5Lineup?: Maybe<createOnboardingSo5LineupPayload>;
  /** Fix a minimum price for a card or token */
  createOrUpdateSingleBuyOfferMinPrice?: Maybe<createOrUpdateSingleBuyOfferMinPricePayload>;
  /** Create or update a user Lineup */
  createOrUpdateSo5Lineup?: Maybe<CreateOrUpdateSo5LineupMutationPayload>;
  /** Create a new passkey */
  createPasskey?: Maybe<createPasskeyPayload>;
  /** Sell a single card for a fixed price */
  createSingleSaleOffer?: Maybe<createSingleSaleOfferPayload>;
  createSo5LineupImportsBatch?: Maybe<createSo5LineupImportsBatchPayload>;
  /** Submit a So5NoCard lineup on the Pro game mode */
  createSo5NoCardBoardLineup?: Maybe<createSo5NoCardBoardLineupPayload>;
  /** Create a User Group */
  createSo5UserGroup?: Maybe<createSo5UserGroupPayload>;
  /** Create a squad */
  createSquad?: Maybe<createSquadPayload>;
  createStarkwareEscapeHatch?: Maybe<createStarkwareEscapeHatchPayload>;
  /** Add Cards, Players, Clubs, Competitions, Countries, Users, Watchlists or CardCollection as favourites */
  createSubscription?: Maybe<createSubscriptionPayload>;
  /** Create a prepared lineup for the next step of a tasks track from an existing lineup */
  createTaskPreparedLineupFromTaskLineup?: Maybe<createTaskPreparedLineupFromTaskLineupPayload>;
  createWallet?: Maybe<createWalletPayload>;
  /** Deposit funds to a Cash wallet with a wire transfer */
  createWireTransferDeposit?: Maybe<createWireTransferDepositPayload>;
  /** Create a bank account to withdraw to */
  createWithdrawalBankAccount?: Maybe<createWithdrawalBankAccountPayload>;
  deactivateWalletRecovery?: Maybe<deactivateWalletRecoveryPayload>;
  declineSo5LineupImportsBatch?: Maybe<declineSo5LineupImportsBatchPayload>;
  /** Decline a So5NoCardLineup */
  declineSo5NoCardLineup?: Maybe<declineSo5NoCardLineupPayload>;
  /** Delete one of the current user API keys */
  deleteApiKey?: Maybe<deleteApiKeyPayload>;
  /** Remove a bookmark on a so5 leaderboard type or a pro board, succeeding if there is none */
  deleteBookmark?: Maybe<deleteBookmarkPayload>;
  /** Delete a task played with a friend, for every member of the group */
  deleteConnectedTask?: Maybe<deleteConnectedTaskPayload>;
  /** Allows a user to delete a deck. */
  deleteDeck?: Maybe<deleteDeckPayload>;
  /** Delete one of the current user OAuth applications */
  deleteOAuthApplication?: Maybe<deleteOAuthApplicationPayload>;
  /** Delete a passkey */
  deletePasskey?: Maybe<deletePasskeyPayload>;
  /** Delete postal address */
  deletePostalAddress?: Maybe<deletePostalAddressPayload>;
  /** Deletes a user Lineup */
  deleteSo5Lineup?: Maybe<deleteSo5LineupPayload>;
  /** Delete a User Group */
  deleteSo5UserGroup?: Maybe<deleteSo5UserGroupPayload>;
  /** Delete a subscription to new auctions on a Card, a Player, a Club, a Watchlist or a Country */
  deleteSubscription?: Maybe<deleteSubscriptionPayload>;
  /** Delete a lineup for a task */
  deleteTaskLineup?: Maybe<deleteTaskLineupPayload>;
  /** Delete a withdrawal bank account */
  deleteWithdrawalBankAccount?: Maybe<deleteWithdrawalBankAccountPayload>;
  /** Deposit to a Cash wallet through ApplePay */
  depositWithApplePay?: Maybe<depositWithApplePayPayload>;
  /** Destroy my Sorare account */
  destroyAccount?: Maybe<destroyAccountPayload>;
  /** Destroy an expired referral */
  destroyReferral?: Maybe<destroyReferralPayload>;
  /** Destroy a pending prepared lineup */
  destroyTaskPreparedLineup?: Maybe<destroyTaskPreparedLineupPayload>;
  /** Destroys a watchlist */
  destroyWatchlist?: Maybe<destroyWatchlistPayload>;
  detachPaymentMethod?: Maybe<detachPaymentMethodPayload>;
  /** Disable 2FA requirement for login */
  disable2Fa?: Maybe<disable2faPayload>;
  /** Disconnect from a social auth */
  disconnectOmniauthProvider?: Maybe<disconnectOmniauthProviderPayload>;
  /** Drop and add cards to the user collection */
  dropAndAddCards?: Maybe<dropAndAddCardsPayload>;
  /** Allows a user to edit a deck. */
  editDeck?: Maybe<editDeckPayload>;
  /** Enable 2FA requirement for login */
  enable2Fa?: Maybe<enable2faPayload>;
  /** Enroll for Strong Customer Authentication (SCA) */
  enrollSCA?: Maybe<enrollSCAPayload>;
  /** Fetch encrypted private key */
  fetchEncryptedPrivateKey?: Maybe<fetchEncryptedPrivateKeyPayload>;
  /** Request a CSV accounting extract by email */
  generateAccountingExtract?: Maybe<generateAccountingExtractPayload>;
  /** Generate OTP backup codes */
  generateOtpBackupCodes?: Maybe<generateOtpBackupCodesPayload>;
  /** Generate OTP provisioning URI */
  generateOtpProvisioningUri?: Maybe<generateOtpProvisioningUriPayload>;
  /** Generate a passkey challenge for adding a new passkey */
  generatePasskeyChallengeForCreate?: Maybe<generatePasskeyChallengeForCreatePayload>;
  /** Generate a passkey challenge for signing in */
  generatePasskeyChallengeForSignIn?: Maybe<generatePasskeyChallengeForSignInPayload>;
  /** Generate a referrer code for the current user */
  generateReferrerCode?: Maybe<generateReferrerCodePayload>;
  /** Create a So5NoCardLineup */
  generateSo5NoCardLineup?: Maybe<generateSo5NoCardLineupPayload>;
  /** Hide my featured so5 leaderboard group */
  hideMyFeaturedSo5LeaderboardGroup?: Maybe<hideMyFeaturedSo5LeaderboardGroupPayload>;
  /** Join a User Group */
  joinSo5UserGroup?: Maybe<joinSo5UserGroupPayload>;
  /** Join a squad using its invite secret or its id */
  joinSquad?: Maybe<joinSquadPayload>;
  /**
   * Leave a squad
   * @deprecated Use removeMemberFromSquad with the current user instead.
   */
  leaveSquad?: Maybe<leaveSquadPayload>;
  /** Level up a card with user xp currency */
  levelUpCardWithXpCurrency?: Maybe<levelUpCardWithXpCurrencyPayload>;
  /** Level up a bench of cards with user xp currency */
  levelUpCardsWithXpCurrency?: Maybe<levelUpCardsWithXpCurrencyPayload>;
  /** Link an Ethereum address to your Sorare account */
  linkEthereumAddress?: Maybe<linkEthereumAddressPayload>;
  /** load a previous lineup for a manager team */
  loadPreviousLineup?: Maybe<loadPreviousLineupPayload>;
  /** load a suggested lineup */
  loadSuggestedLineup?: Maybe<loadSuggestedLineupPayload>;
  /** Locks the Pro Mode */
  lockProMode?: Maybe<lockProModePayload>;
  /** Marks the Pro mode onboarding as completed */
  markAsProOnboarded?: Maybe<markAsProOnboardedPayload>;
  /** Mark a card shards chest unlocked threshold as seen */
  markCardShardsChestUnlockedThresholdAsSeen?: Maybe<markCardShardsChestUnlockedThresholdAsSeenPayload>;
  /** Mark notifications as read */
  markNotificationsAsRead?: Maybe<markNotificationsAsReadPayload>;
  /** Mark the social feed of a sport as read */
  markSocialFeedAsRead?: Maybe<markSocialFeedAsReadPayload>;
  /** Mark a spotlight as engaged with by the current user */
  markSpotlightAsSeen?: Maybe<markSpotlightAsSeenPayload>;
  /** Mark stories as read */
  markStoriesAsRead?: Maybe<markStoriesAsReadPayload>;
  /** @deprecated Legacy */
  migrateEth?: Maybe<migrateEthPayload>;
  /** Execute an ETH → EUR off-ramp using a signed authorization from prepareOffRamp */
  offRamp?: Maybe<offRampPayload>;
  /** Pick a card from a set of pulled cards */
  pickPulledCard?: Maybe<pickPulledCardPayload>;
  /** Get the limit orders that need to be signed in order to accept an offer */
  prepareAcceptOffer?: Maybe<prepareAcceptOfferPayload>;
  /** forwards the wallet approvals as part of the wallet + credit card payment flow */
  prepareAcceptTradeWithWalletAndCreditCard?: Maybe<prepareAcceptTradeWithWalletAndCreditCardPayload>;
  prepareBankWithdrawal?: Maybe<prepareBankWithdrawalPayload>;
  /** Get the authorizations that need to be signed in order to bid on an english auction */
  prepareBid?: Maybe<prepareBidPayload>;
  /**
   * Prepare a Payment Intent for a InGameCurrencyPack purchase with a Credit Card
   * @deprecated Not used anymore
   */
  prepareBuyInGameCurrencyPackWithCreditCard?: Maybe<prepareBuyInGameCurrencyPackWithCreditCardPayload>;
  /** Authorize a deposit to fund a Cash wallet with a credit card */
  prepareDeposit?: Maybe<prepareDepositPayload>;
  /** Get the payload to make an ETH deposit */
  prepareEthDeposit?: Maybe<prepareEthDepositPayload>;
  /** Initiate a deposit to a Cash wallet through Ideal */
  prepareIdealDeposit?: Maybe<prepareIdealDepositPayload>;
  /** @deprecated Legacy */
  prepareMigrateEth?: Maybe<prepareMigrateEthPayload>;
  /** Get the authorization and EUR quote needed to off-ramp ETH to a Bridge.xyz bank account */
  prepareOffRamp?: Maybe<prepareOffRampPayload>;
  /** Get the limit orders that need to be signed in order to be able to create an offer */
  prepareOffer?: Maybe<prepareOfferPayload>;
  /** Initiate a deposit to a Cash wallet through Pay by Bank */
  preparePayByBankDeposit?: Maybe<preparePayByBankDepositPayload>;
  /** Initiate a deposit to a Cash wallet through Paypal */
  preparePaypalDeposit?: Maybe<preparePaypalDepositPayload>;
  /** Get the authorization that needs to be signed in order to execute a Sorare refund */
  prepareSorareRefund?: Maybe<prepareSorareRefundPayload>;
  /** Get the payload to deposit an NFT into Layer 2 */
  prepareTokenDeposit?: Maybe<prepareTokenDepositPayload>;
  /** Open a probabilistic bundle */
  probabilisticBundlesOpen?: Maybe<probabilisticBundlesOpenPayload>;
  /** Spend essences to pull a set of cards to pick from */
  pullCards?: Maybe<pullCardsPayload>;
  /** Add a reaction of the current user on an activity, or drop it when they had already reacted with that emoji */
  reactToActivity?: Maybe<reactToActivityPayload>;
  /** Refresh the cart */
  refreshCart?: Maybe<refreshCartPayload>;
  /** Execute a Sorare refund */
  refundSorare?: Maybe<refundSorarePayload>;
  /** Reject the picked card from a card pull and receive back part of the spent essence */
  rejectCardPull?: Maybe<rejectCardPullPayload>;
  /** Reject an Offer */
  rejectOffer?: Maybe<rejectOfferPayload>;
  /** Remove an activity the current user shared with their followers */
  removeActivity?: Maybe<removeActivityPayload>;
  /** Allows a user to remove a reminder on an auction */
  removeAuctionReminder?: Maybe<removeAuctionReminderPayload>;
  /** Remove cart items from the cart */
  removeFromCart?: Maybe<removeFromCartPayload>;
  /** remove a player from a watchlist */
  removeFromWatchlist?: Maybe<removeFromWatchlistPayload>;
  /** Remove a member from a squad: the captain can remove anyone, any member can remove themselves */
  removeMemberFromSquad?: Maybe<removeMemberFromSquadPayload>;
  /** Allows a user to remove a token from a deck. */
  removeTokenFromDeck?: Maybe<removeTokenFromDeckPayload>;
  /** Remove a User from a User Group */
  removeUserFromSo5UserGroup?: Maybe<removeUserFromSo5UserGroupPayload>;
  /** Reorder a pending prepared lineup within its tasks track */
  reorderTaskPreparedLineup?: Maybe<reorderTaskPreparedLineupPayload>;
  /** For web and mobile clients to report metrics */
  reportTelemetry?: Maybe<reportTelemetryPayload>;
  /** Report a user for suspicious or abusive behavior */
  reportUser?: Maybe<reportUserPayload>;
  /** Request voluntary self-exclusion from compose and marketplace for a chosen period. */
  requestJonumSelfExclusion?: Maybe<requestJonumSelfExclusionPayload>;
  /** Request a So5NoCard draftable appearance for the Pro game mode */
  requestSo5NoCardBoardDraftableAppearance?: Maybe<requestSo5NoCardBoardDraftableAppearancePayload>;
  /** Request a So5NoCard draftable appearance */
  requestSo5NoCardDraftableAppearance?: Maybe<requestSo5NoCardDraftableAppearancePayload>;
  /** Request to choose another leaderboard for a So5NoCardLineup */
  requestSo5NoCardLineupEligibleLeaderboards?: Maybe<requestSo5NoCardLineupEligibleLeaderboardsPayload>;
  resendConfirmationInstructions?: Maybe<resendConfirmationInstructionsPayload>;
  resendVerificationCode?: Maybe<resendVerificationCodePayload>;
  resetPrivateKey?: Maybe<resetPrivateKeyPayload>;
  /** Reset drafted appearances for the Pro game mode */
  resetSo5NoCardBoardDraftedAppearances?: Maybe<resetSo5NoCardBoardDraftedAppearancesPayload>;
  /** Reset drafted appearances for a So5NoCardLineup */
  resetSo5NoCardDraftedAppearances?: Maybe<resetSo5NoCardDraftedAppearancesPayload>;
  /** Restart a tasks track */
  restartTasksTrack?: Maybe<restartTasksTrackPayload>;
  restoreWallet?: Maybe<restoreWalletPayload>;
  /** Reveal blueprint cards */
  revealBlueprints?: Maybe<revealBlueprintsPayload>;
  /** Reveal a property on all pulled cards */
  revealProperty?: Maybe<revealPropertyPayload>;
  /** Revoke Device */
  revokeDevice?: Maybe<revokeDevicePayload>;
  revokeEip7702Delegation?: Maybe<revokeEip7702DelegationPayload>;
  /** Revokes the specified token */
  revokeOAuthAccessToken?: Maybe<revokeOAuthAccessTokenPayload>;
  /** Revokes all tokens for specified application_id */
  revokeOAuthAccessTokenForApplication?: Maybe<revokeOAuthAccessTokenForApplicationPayload>;
  /** Save a cart item for later in cart */
  saveForLater?: Maybe<saveForLaterPayload>;
  sealCards?: Maybe<sealCardsPayload>;
  sendWalletRecovery?: Maybe<sendWalletRecoveryPayload>;
  /** Add or update the given device token for push notifications */
  setDeviceToken?: Maybe<setDeviceTokenPayload>;
  /** Sets the weekly playtime limit for JONUM verification. */
  setJonumPlaytimeLimit?: Maybe<setJonumPlaytimeLimitPayload>;
  /** Sets the weekly spending limit for JONUM verification. */
  setJonumSpendingLimit?: Maybe<setJonumSpendingLimitPayload>;
  /** Update a token trade status */
  setTokenTradeStatus?: Maybe<setTokenTradeStatusPayload>;
  /** Shares a Pro card the current user owns with the managers following them */
  shareCard?: Maybe<shareCardPayload>;
  /** Shares a card the current user pulled from a card pack */
  shareCardPack?: Maybe<shareCardPackPayload>;
  /** Shares a finished lineup of the current user */
  shareLineup?: Maybe<shareLineupPayload>;
  /** Sign in */
  signIn?: Maybe<SignInMutationPayload>;
  /** Sign in with OAuth */
  signInWithOauth?: Maybe<SignInWithOAuthMutationPayload>;
  /** Sign out from all sessions except the current one */
  signOutFromAllDevices?: Maybe<signOutFromAllDevicesPayload>;
  /** Sign up */
  signUp?: Maybe<SignUpMutationPayload>;
  /** Skips the onboarding */
  skipOnboarding?: Maybe<skipOnboardingPayload>;
  spinWheel?: Maybe<spinWheelPayload>;
  /** Start a Mangopay hosted identity verification for the current user Cash Wallet. */
  startFiatWalletIdentityVerification?: Maybe<startFiatWalletIdentityVerificationPayload>;
  /** Generates a Bridge.xyz hosted KYC link for the current user off-ramp account. */
  startOffRampBridgeKyc?: Maybe<startOffRampBridgeKycPayload>;
  /** Stop current auto bid on an auction */
  stopAutoBid?: Maybe<stopAutoBidPayload>;
  /** Store an Apple purchase token for the current user */
  storeApplePurchaseToken?: Maybe<storeApplePurchaseTokenPayload>;
  /** suggest a lineup */
  suggestLineup?: Maybe<suggestLineupPayload>;
  /** Swap cards between two task appearances */
  swapTaskAppearances?: Maybe<swapTaskAppearancesPayload>;
  /** Unblock email */
  unblockEmail?: Maybe<UnblockEmailPayload>;
  unblockFiatWallet?: Maybe<unblockFiatWalletPayload>;
  /** Unblock another user from sending offers */
  unblockUserOffers?: Maybe<unblockUserOffersPayload>;
  /** Claim a career track to unlock the board that follows it */
  unlockNextBoard?: Maybe<unlockNextBoardPayload>;
  /** Unlocks the Pro Mode */
  unlockProMode?: Maybe<unlockProModePayload>;
  unsealCards?: Maybe<unsealCardsPayload>;
  /** Unsubscribe from all emails using a signed token */
  unsubscribeFromEmails?: Maybe<unsubscribeFromEmailsPayload>;
  /** Set filters for the current user */
  updateCardFilters?: Maybe<updateCardFiltersPayload>;
  /** Set an external deposit ETH transaction hash */
  updateExternalEthDeposit?: Maybe<updateExternalEthDepositPayload>;
  /**
   * Set favorite team of the current user
   * @deprecated Favorite team is deprecated
   */
  updateFavoriteTeam?: Maybe<updateFavoriteTeamPayload>;
  updateFiatWallet?: Maybe<updateFiatWalletPayload>;
  /** Update the highlightedCard in a collection */
  updateHighlightedCard?: Maybe<updateHighlightedCardPayload>;
  /** Update a manager team */
  updateManagerTeam?: Maybe<updateManagerTeamPayload>;
  /** Update the redirect URIs and logo of an OAuth application */
  updateOAuthApplication?: Maybe<UpdateMutationPayload>;
  /** @deprecated Not supported anymore */
  updateOnboardingSo5Leaderboard?: Maybe<updateOnboardingSo5LeaderboardPayload>;
  /** Update partner offers agreement */
  updatePartnerOffersAgreement?: Maybe<updatePartnerOffersAgreementPayload>;
  /** Update user notification preferences for a section */
  updateSectionNotificationPreferences?: Maybe<updateSectionNotificationPreferencesPayload>;
  /** Update a SO5 lineup hidden status */
  updateSo5LineupSettings?: Maybe<updateSo5LineupSettingsPayload>;
  /** Update a User Group */
  updateSo5UserGroup?: Maybe<updateSo5UserGroupPayload>;
  /** Set club name, banner, and shield for the current user */
  updateSportProfile?: Maybe<updateSportProfilePayload>;
  /** Toggle a squad between public and private (captain only) */
  updateSquadPrivacy?: Maybe<updateSquadPrivacyPayload>;
  /** Update a subscription notification preferences */
  updateSubscription?: Maybe<updateSubscriptionPayload>;
  /** Update the preferences of the current user for a tasks track */
  updateTaskConfigPreferences?: Maybe<updateTaskConfigPreferencesPayload>;
  /** Opt pending prepared lineups in or out of being carried over to the following step once submitted */
  updateTaskPreparedLineupsCarryOver?: Maybe<updateTaskPreparedLineupsCarryOverPayload>;
  /** Update user email */
  updateUserEmail?: Maybe<updateUserEmailPayload>;
  /** Update user profile */
  updateUserProfile?: Maybe<updateUserProfilePayload>;
  /** Update user settings */
  updateUserSettings?: Maybe<updateUserSettingsPayload>;
  /** Upsert a lineup for a step */
  upsertStepLineup?: Maybe<upsertStepLineupPayload>;
  /** Upsert appearances for a task */
  upsertTaskAppearances?: Maybe<upsertTaskAppearancesPayload>;
  /** Upsert a lineup for a task */
  upsertTaskLineup?: Maybe<upsertTaskLineupPayload>;
  /** Upsert a prepared lineup for a step of a tasks track */
  upsertTaskPreparedLineup?: Maybe<upsertTaskPreparedLineupPayload>;
  /** Creates or updates a watchlist */
  upsertWatchlist?: Maybe<upsertWatchlistPayload>;
  /** Validate an ApplePay merchant session prior to payment process */
  validateApplePayMerchantSession?: Maybe<validateApplePayMerchantSessionPayload>;
  validateFiatWallet?: Maybe<validateFiatWalletPayload>;
  /**
   * Verify a purchase of an InGameCurrencyPack done through IAP
   * @deprecated Not used anymore
   */
  verifyInGameCurrencyPackMobilePurchase?: Maybe<verifyInGameCurrencyPackMobilePurchasePayload>;
  /** Verify a purchase done through IAP */
  verifyMobilePurchase?: Maybe<verifyMobilePurchasePayload>;
  /** Verify phone number */
  verifyPhoneNumber?: Maybe<verifyPhoneNumberPayload>;
  /** Track when a campaign page is visited */
  visitCampaignPage?: Maybe<visitCampaignPagePayload>;
}


export interface MutationacceptOfferArgs {
  input: acceptOfferInput;
}


export interface MutationacceptSo5NoCardBoardDraftableAppearanceArgs {
  input: acceptSo5NoCardBoardDraftableAppearanceInput;
}


export interface MutationacceptSo5NoCardDraftableAppearanceArgs {
  input: acceptSo5NoCardDraftableAppearanceInput;
}


export interface MutationacceptSo5NoCardLineupArgs {
  input: acceptSo5NoCardLineupInput;
}


export interface MutationacceptTermsArgs {
  input: acceptTermsInput;
}


export interface MutationacknowledgeStepArgs {
  input: acknowledgeStepInput;
}


export interface MutationactivateWalletRecoveryArgs {
  input: activateWalletRecoveryInput;
}


export interface MutationaddAuctionReminderArgs {
  input: addAuctionReminderInput;
}


export interface MutationaddDeviceArgs {
  input: addDeviceInput;
}


export interface MutationaddReferrerCodeArgs {
  input: addReferrerCodeInput;
}


export interface MutationaddSolanaAddressArgs {
  input: addSolanaAddressInput;
}


export interface MutationaddToCartArgs {
  input: addToCartInput;
}


export interface MutationaddToWatchlistArgs {
  input: addToWatchlistInput;
}


export interface MutationaddTokensToDeckArgs {
  input: addTokensToDeckInput;
}


export interface MutationaddWalletRecoveryArgs {
  input: addWalletRecoveryInput;
}


export interface MutationapproveMigratorArgs {
  input: approveMigratorInput;
}


export interface MutationaskForProxyConsentArgs {
  input: askForProxyConsentInput;
}


export interface MutationbidArgs {
  input: bidInput;
}


export interface MutationblockUserOffersArgs {
  input: blockUserOffersInput;
}


export interface MutationbuyCardPackArgs {
  input: buyCardPackInput;
}


export interface MutationcancelBankWithdrawalArgs {
  input: cancelBankWithdrawalInput;
}


export interface MutationcancelMobilePurchaseArgs {
  input: cancelMobilePurchaseInput;
}


export interface MutationcancelOfferArgs {
  input: cancelOfferInput;
}


export interface MutationchangePasswordArgs {
  input: changePasswordInput;
}


export interface MutationcheckPhoneNumberVerificationCodeArgs {
  input: checkPhoneNumberVerificationCodeInput;
}


export interface MutationclaimAllSetRaffleTasksArgs {
  input: claimAllSetRaffleTasksInput;
}


export interface MutationclaimAnyRewardArgs {
  input: claimAnyRewardInput;
}


export interface MutationclaimCardsFromPackArgs {
  input: claimCardsFromPackInput;
}


export interface MutationclaimConversionCreditArgs {
  input: claimConversionCreditInput;
}


export interface MutationclaimDeliverableItemOrderArgs {
  input: claimDeliverableItemOrderInput;
}


export interface MutationclaimOnboardingConversionCreditArgs {
  input: claimOnboardingConversionCreditInput;
}


export interface MutationclaimOnboardingEnergyGiftArgs {
  input: claimOnboardingEnergyGiftInput;
}


export interface MutationclaimPromotionalEventAirdropArgs {
  input: claimPromotionalEventAirdropInput;
}


export interface MutationclaimReferralRewardArgs {
  input: claimReferralRewardInput;
}


export interface MutationclaimRewardArgs {
  input: claimRewardInput;
}


export interface MutationclaimRewardsArgs {
  input: claimRewardsInput;
}


export interface MutationclaimStarterPackArgs {
  input: claimStarterPackInput;
}


export interface MutationclaimStepArgs {
  input: claimStepInput;
}


export interface MutationclaimTaskArgs {
  input: claimTaskInput;
}


export interface MutationcollectJonumPersonalInfoArgs {
  input: collectJonumPersonalInfoInput;
}


export interface MutationcompleteDropChallengeArgs {
  input: completeDropChallengeInput;
}


export interface MutationconfirmCardPullArgs {
  input: confirmCardPullInput;
}


export interface MutationconfirmDeviceArgs {
  input: confirmDeviceInput;
}


export interface MutationconfirmDeviceWithCodeArgs {
  input: confirmDeviceWithCodeInput;
}


export interface MutationconfirmEmailArgs {
  input: confirmEmailInput;
}


export interface MutationconfirmSo5LineupImportsBatchArgs {
  input: confirmSo5LineupImportsBatchInput;
}


export interface MutationconfirmSo5LineupsArgs {
  input: confirmSo5LineupsInput;
}


export interface MutationconfirmSo5NoCardLineupArgs {
  input: confirmSo5NoCardLineupInput;
}


export interface MutationconsumeEphemeralTokenArgs {
  input: consumeEphemeralTokenInput;
}


export interface MutationconvertCraftCluesArgs {
  input: convertCraftCluesInput;
}


export interface MutationcreateApiKeyArgs {
  input: createApiKeyInput;
}


export interface MutationcreateBankWithdrawalArgs {
  input: createBankWithdrawalInput;
}


export interface MutationcreateBookmarkArgs {
  input: createBookmarkInput;
}


export interface MutationcreateCardAuthorizationArgs {
  input: createCardAuthorizationInput;
}


export interface MutationcreateCardRegistrationArgs {
  input: createCardRegistrationInput;
}


export interface MutationcreateConnectedTasksArgs {
  input: createConnectedTasksInput;
}


export interface MutationcreateCryptoDepositArgs {
  input: createCryptoDepositInput;
}


export interface MutationcreateDeckArgs {
  input: createDeckInput;
}


export interface MutationcreateDepositBankAccountArgs {
  input: createDepositBankAccountMutationInput;
}


export interface MutationcreateDirectOfferArgs {
  input: createDirectOfferInput;
}


export interface MutationcreateEphemeralLinkArgs {
  input: createEphemeralLinkInput;
}


export interface MutationcreateEthBankWithdrawalIntentArgs {
  input: createEthBankWithdrawalIntentInput;
}


export interface MutationcreateEthDepositArgs {
  input: createEthDepositInput;
}


export interface MutationcreateEthVaultArgs {
  input: createEthVaultInput;
}


export interface MutationcreateFiatPayerArgs {
  input: createFiatPayerInput;
}


export interface MutationcreateFiatWalletArgs {
  input: createFiatWalletInput;
}


export interface MutationcreateFiatWithdrawalArgs {
  input: createFiatWithdrawalInput;
}


export interface MutationcreateIdentityVerificationSessionArgs {
  input: createIdentityVerificationSessionInput;
}


export interface MutationcreateJonumVerificationArgs {
  input: createJonumVerificationInput;
}


export interface MutationcreateJwtTokenArgs {
  input: createJwtTokenInput;
}


export interface MutationcreateOAuthApplicationArgs {
  input: createOAuthApplicationInput;
}


export interface MutationcreateOffRampBridgeCustomerArgs {
  input: createOffRampBridgeCustomerInput;
}


export interface MutationcreateOffRampBridgeTosLinkArgs {
  input: createOffRampBridgeTosLinkInput;
}


export interface MutationcreateOnboardingSo5LineupArgs {
  input: createOnboardingSo5LineupInput;
}


export interface MutationcreateOrUpdateSingleBuyOfferMinPriceArgs {
  input: createOrUpdateSingleBuyOfferMinPriceInput;
}


export interface MutationcreateOrUpdateSo5LineupArgs {
  input: createOrUpdateSo5LineupInput;
}


export interface MutationcreatePasskeyArgs {
  input: createPasskeyInput;
}


export interface MutationcreateSingleSaleOfferArgs {
  input: createSingleSaleOfferInput;
}


export interface MutationcreateSo5LineupImportsBatchArgs {
  input: createSo5LineupImportsBatchInput;
}


export interface MutationcreateSo5NoCardBoardLineupArgs {
  input: createSo5NoCardBoardLineupInput;
}


export interface MutationcreateSo5UserGroupArgs {
  input: createSo5UserGroupInput;
}


export interface MutationcreateSquadArgs {
  input: createSquadInput;
}


export interface MutationcreateStarkwareEscapeHatchArgs {
  input: createStarkwareEscapeHatchInput;
}


export interface MutationcreateSubscriptionArgs {
  input: createSubscriptionInput;
}


export interface MutationcreateTaskPreparedLineupFromTaskLineupArgs {
  input: createTaskPreparedLineupFromTaskLineupInput;
}


export interface MutationcreateWalletArgs {
  input: createWalletInput;
}


export interface MutationcreateWireTransferDepositArgs {
  input: createWireTransferDepositInput;
}


export interface MutationcreateWithdrawalBankAccountArgs {
  input: createWithdrawalBankAccountInput;
}


export interface MutationdeactivateWalletRecoveryArgs {
  input: deactivateWalletRecoveryInput;
}


export interface MutationdeclineSo5LineupImportsBatchArgs {
  input: declineSo5LineupImportsBatchInput;
}


export interface MutationdeclineSo5NoCardLineupArgs {
  input: declineSo5NoCardLineupInput;
}


export interface MutationdeleteApiKeyArgs {
  input: deleteApiKeyInput;
}


export interface MutationdeleteBookmarkArgs {
  input: deleteBookmarkInput;
}


export interface MutationdeleteConnectedTaskArgs {
  input: deleteConnectedTaskInput;
}


export interface MutationdeleteDeckArgs {
  input: deleteDeckInput;
}


export interface MutationdeleteOAuthApplicationArgs {
  input: deleteOAuthApplicationInput;
}


export interface MutationdeletePasskeyArgs {
  input: deletePasskeyInput;
}


export interface MutationdeletePostalAddressArgs {
  input: deletePostalAddressInput;
}


export interface MutationdeleteSo5LineupArgs {
  input: deleteSo5LineupInput;
}


export interface MutationdeleteSo5UserGroupArgs {
  input: deleteSo5UserGroupInput;
}


export interface MutationdeleteSubscriptionArgs {
  input: deleteSubscriptionInput;
}


export interface MutationdeleteTaskLineupArgs {
  input: deleteTaskLineupInput;
}


export interface MutationdeleteWithdrawalBankAccountArgs {
  input: deleteWithdrawalBankAccountInput;
}


export interface MutationdepositWithApplePayArgs {
  input: depositWithApplePayInput;
}


export interface MutationdestroyAccountArgs {
  input: destroyAccountInput;
}


export interface MutationdestroyReferralArgs {
  input: destroyReferralInput;
}


export interface MutationdestroyTaskPreparedLineupArgs {
  input: destroyTaskPreparedLineupInput;
}


export interface MutationdestroyWatchlistArgs {
  input: destroyWatchlistInput;
}


export interface MutationdetachPaymentMethodArgs {
  input: detachPaymentMethodInput;
}


export interface Mutationdisable2FaArgs {
  input: disable2faInput;
}


export interface MutationdisconnectOmniauthProviderArgs {
  input: disconnectOmniauthProviderInput;
}


export interface MutationdropAndAddCardsArgs {
  input: dropAndAddCardsInput;
}


export interface MutationeditDeckArgs {
  input: editDeckInput;
}


export interface Mutationenable2FaArgs {
  input: enable2faInput;
}


export interface MutationenrollSCAArgs {
  input: enrollSCAInput;
}


export interface MutationfetchEncryptedPrivateKeyArgs {
  input: fetchEncryptedPrivateKeyInput;
}


export interface MutationgenerateAccountingExtractArgs {
  input: generateAccountingExtractInput;
}


export interface MutationgenerateOtpBackupCodesArgs {
  input: generateOtpBackupCodesInput;
}


export interface MutationgenerateOtpProvisioningUriArgs {
  input: generateOtpProvisioningUriInput;
}


export interface MutationgeneratePasskeyChallengeForCreateArgs {
  input: generatePasskeyChallengeForCreateInput;
}


export interface MutationgeneratePasskeyChallengeForSignInArgs {
  input: generatePasskeyChallengeForSignInInput;
}


export interface MutationgenerateReferrerCodeArgs {
  input: generateReferrerCodeInput;
}


export interface MutationgenerateSo5NoCardLineupArgs {
  input: generateSo5NoCardLineupInput;
}


export interface MutationhideMyFeaturedSo5LeaderboardGroupArgs {
  input: hideMyFeaturedSo5LeaderboardGroupInput;
}


export interface MutationjoinSo5UserGroupArgs {
  input: joinSo5UserGroupInput;
}


export interface MutationjoinSquadArgs {
  input: joinSquadInput;
}


export interface MutationleaveSquadArgs {
  input: leaveSquadInput;
}


export interface MutationlevelUpCardWithXpCurrencyArgs {
  input: levelUpCardWithXpCurrencyInput;
}


export interface MutationlevelUpCardsWithXpCurrencyArgs {
  input: levelUpCardsWithXpCurrencyInput;
}


export interface MutationlinkEthereumAddressArgs {
  input: linkEthereumAddressInput;
}


export interface MutationloadPreviousLineupArgs {
  input: loadPreviousLineupInput;
}


export interface MutationloadSuggestedLineupArgs {
  input: loadSuggestedLineupInput;
}


export interface MutationlockProModeArgs {
  input: lockProModeInput;
}


export interface MutationmarkAsProOnboardedArgs {
  input: markAsProOnboardedInput;
}


export interface MutationmarkCardShardsChestUnlockedThresholdAsSeenArgs {
  input: markCardShardsChestUnlockedThresholdAsSeenInput;
}


export interface MutationmarkNotificationsAsReadArgs {
  input: markNotificationsAsReadInput;
}


export interface MutationmarkSocialFeedAsReadArgs {
  input: markSocialFeedAsReadInput;
}


export interface MutationmarkSpotlightAsSeenArgs {
  input: markSpotlightAsSeenInput;
}


export interface MutationmarkStoriesAsReadArgs {
  input: markStoriesAsReadInput;
}


export interface MutationmigrateEthArgs {
  input: migrateEthInput;
}


export interface MutationoffRampArgs {
  input: offRampInput;
}


export interface MutationpickPulledCardArgs {
  input: pickPulledCardInput;
}


export interface MutationprepareAcceptOfferArgs {
  input: prepareAcceptOfferInput;
}


export interface MutationprepareAcceptTradeWithWalletAndCreditCardArgs {
  input: prepareAcceptTradeWithWalletAndCreditCardInput;
}


export interface MutationprepareBankWithdrawalArgs {
  input: prepareBankWithdrawalInput;
}


export interface MutationprepareBidArgs {
  input: prepareBidInput;
}


export interface MutationprepareBuyInGameCurrencyPackWithCreditCardArgs {
  input: prepareBuyInGameCurrencyPackWithCreditCardInput;
}


export interface MutationprepareDepositArgs {
  input: prepareDepositInput;
}


export interface MutationprepareEthDepositArgs {
  input: prepareEthDepositInput;
}


export interface MutationprepareIdealDepositArgs {
  input: prepareIdealDepositInput;
}


export interface MutationprepareMigrateEthArgs {
  input: prepareMigrateEthInput;
}


export interface MutationprepareOffRampArgs {
  input: prepareOffRampInput;
}


export interface MutationprepareOfferArgs {
  input: prepareOfferInput;
}


export interface MutationpreparePayByBankDepositArgs {
  input: preparePayByBankDepositInput;
}


export interface MutationpreparePaypalDepositArgs {
  input: preparePaypalDepositInput;
}


export interface MutationprepareSorareRefundArgs {
  input: prepareSorareRefundInput;
}


export interface MutationprepareTokenDepositArgs {
  input: prepareTokenDepositInput;
}


export interface MutationprobabilisticBundlesOpenArgs {
  input: probabilisticBundlesOpenInput;
}


export interface MutationpullCardsArgs {
  input: pullCardsInput;
}


export interface MutationreactToActivityArgs {
  input: reactToActivityInput;
}


export interface MutationrefreshCartArgs {
  input: refreshCartInput;
}


export interface MutationrefundSorareArgs {
  input: refundSorareInput;
}


export interface MutationrejectCardPullArgs {
  input: rejectCardPullInput;
}


export interface MutationrejectOfferArgs {
  input: rejectOfferInput;
}


export interface MutationremoveActivityArgs {
  input: removeActivityInput;
}


export interface MutationremoveAuctionReminderArgs {
  input: removeAuctionReminderInput;
}


export interface MutationremoveFromCartArgs {
  input: removeFromCartInput;
}


export interface MutationremoveFromWatchlistArgs {
  input: removeFromWatchlistInput;
}


export interface MutationremoveMemberFromSquadArgs {
  input: removeMemberFromSquadInput;
}


export interface MutationremoveTokenFromDeckArgs {
  input: removeTokenFromDeckInput;
}


export interface MutationremoveUserFromSo5UserGroupArgs {
  input: removeUserFromSo5UserGroupInput;
}


export interface MutationreorderTaskPreparedLineupArgs {
  input: reorderTaskPreparedLineupInput;
}


export interface MutationreportTelemetryArgs {
  input: reportTelemetryInput;
}


export interface MutationreportUserArgs {
  input: reportUserInput;
}


export interface MutationrequestJonumSelfExclusionArgs {
  input: requestJonumSelfExclusionInput;
}


export interface MutationrequestSo5NoCardBoardDraftableAppearanceArgs {
  input: requestSo5NoCardBoardDraftableAppearanceInput;
}


export interface MutationrequestSo5NoCardDraftableAppearanceArgs {
  input: requestSo5NoCardDraftableAppearanceInput;
}


export interface MutationrequestSo5NoCardLineupEligibleLeaderboardsArgs {
  input: requestSo5NoCardLineupEligibleLeaderboardsInput;
}


export interface MutationresendConfirmationInstructionsArgs {
  input: resendConfirmationInstructionsInput;
}


export interface MutationresendVerificationCodeArgs {
  input: resendVerificationCodeInput;
}


export interface MutationresetPrivateKeyArgs {
  input: resetPrivateKeyInput;
}


export interface MutationresetSo5NoCardBoardDraftedAppearancesArgs {
  input: resetSo5NoCardBoardDraftedAppearancesInput;
}


export interface MutationresetSo5NoCardDraftedAppearancesArgs {
  input: resetSo5NoCardDraftedAppearancesInput;
}


export interface MutationrestartTasksTrackArgs {
  input: restartTasksTrackInput;
}


export interface MutationrestoreWalletArgs {
  input: restoreWalletInput;
}


export interface MutationrevealBlueprintsArgs {
  input: revealBlueprintsInput;
}


export interface MutationrevealPropertyArgs {
  input: revealPropertyInput;
}


export interface MutationrevokeDeviceArgs {
  input: revokeDeviceInput;
}


export interface MutationrevokeEip7702DelegationArgs {
  input: revokeEip7702DelegationInput;
}


export interface MutationrevokeOAuthAccessTokenArgs {
  input: revokeOAuthAccessTokenInput;
}


export interface MutationrevokeOAuthAccessTokenForApplicationArgs {
  input: revokeOAuthAccessTokenForApplicationInput;
}


export interface MutationsaveForLaterArgs {
  input: saveForLaterInput;
}


export interface MutationsealCardsArgs {
  input: sealCardsInput;
}


export interface MutationsendWalletRecoveryArgs {
  input: sendWalletRecoveryInput;
}


export interface MutationsetDeviceTokenArgs {
  input: setDeviceTokenInput;
}


export interface MutationsetJonumPlaytimeLimitArgs {
  input: setJonumPlaytimeLimitInput;
}


export interface MutationsetJonumSpendingLimitArgs {
  input: setJonumSpendingLimitInput;
}


export interface MutationsetTokenTradeStatusArgs {
  input: setTokenTradeStatusInput;
}


export interface MutationshareCardArgs {
  input: shareCardInput;
}


export interface MutationshareCardPackArgs {
  input: shareCardPackInput;
}


export interface MutationshareLineupArgs {
  input: shareLineupInput;
}


export interface MutationsignInArgs {
  input: signInInput;
}


export interface MutationsignInWithOauthArgs {
  input: signInWithOAuthInput;
}


export interface MutationsignOutFromAllDevicesArgs {
  input: signOutFromAllDevicesInput;
}


export interface MutationsignUpArgs {
  input: signUpInput;
}


export interface MutationskipOnboardingArgs {
  input: skipOnboardingInput;
}


export interface MutationspinWheelArgs {
  input: spinWheelInput;
}


export interface MutationstartFiatWalletIdentityVerificationArgs {
  input: startFiatWalletIdentityVerificationInput;
}


export interface MutationstartOffRampBridgeKycArgs {
  input: startOffRampBridgeKycInput;
}


export interface MutationstopAutoBidArgs {
  input: stopAutoBidInput;
}


export interface MutationstoreApplePurchaseTokenArgs {
  input: storeApplePurchaseTokenInput;
}


export interface MutationsuggestLineupArgs {
  input: suggestLineupInput;
}


export interface MutationswapTaskAppearancesArgs {
  input: swapTaskAppearancesInput;
}


export interface MutationunblockEmailArgs {
  input: UnblockEmailInput;
}


export interface MutationunblockFiatWalletArgs {
  input: unblockFiatWalletInput;
}


export interface MutationunblockUserOffersArgs {
  input: unblockUserOffersInput;
}


export interface MutationunlockNextBoardArgs {
  input: unlockNextBoardInput;
}


export interface MutationunlockProModeArgs {
  input: unlockProModeInput;
}


export interface MutationunsealCardsArgs {
  input: unsealCardsInput;
}


export interface MutationunsubscribeFromEmailsArgs {
  input: unsubscribeFromEmailsInput;
}


export interface MutationupdateCardFiltersArgs {
  input: updateCardFiltersInput;
}


export interface MutationupdateExternalEthDepositArgs {
  input: updateExternalEthDepositInput;
}


export interface MutationupdateFavoriteTeamArgs {
  input: updateFavoriteTeamInput;
}


export interface MutationupdateFiatWalletArgs {
  input: updateFiatWalletInput;
}


export interface MutationupdateHighlightedCardArgs {
  input: updateHighlightedCardInput;
}


export interface MutationupdateManagerTeamArgs {
  input: updateManagerTeamInput;
}


export interface MutationupdateOAuthApplicationArgs {
  input: updateOAuthApplicationInput;
}


export interface MutationupdateOnboardingSo5LeaderboardArgs {
  input: updateOnboardingSo5LeaderboardInput;
}


export interface MutationupdatePartnerOffersAgreementArgs {
  input: updatePartnerOffersAgreementInput;
}


export interface MutationupdateSectionNotificationPreferencesArgs {
  input: updateSectionNotificationPreferencesInput;
}


export interface MutationupdateSo5LineupSettingsArgs {
  input: updateSo5LineupSettingsInput;
}


export interface MutationupdateSo5UserGroupArgs {
  input: updateSo5UserGroupInput;
}


export interface MutationupdateSportProfileArgs {
  input: updateSportProfileInput;
}


export interface MutationupdateSquadPrivacyArgs {
  input: updateSquadPrivacyInput;
}


export interface MutationupdateSubscriptionArgs {
  input: updateSubscriptionInput;
}


export interface MutationupdateTaskConfigPreferencesArgs {
  input: updateTaskConfigPreferencesInput;
}


export interface MutationupdateTaskPreparedLineupsCarryOverArgs {
  input: updateTaskPreparedLineupsCarryOverInput;
}


export interface MutationupdateUserEmailArgs {
  input: updateUserEmailInput;
}


export interface MutationupdateUserProfileArgs {
  input: updateUserProfileInput;
}


export interface MutationupdateUserSettingsArgs {
  input: updateUserSettingsInput;
}


export interface MutationupsertStepLineupArgs {
  input: upsertStepLineupInput;
}


export interface MutationupsertTaskAppearancesArgs {
  input: upsertTaskAppearancesInput;
}


export interface MutationupsertTaskLineupArgs {
  input: upsertTaskLineupInput;
}


export interface MutationupsertTaskPreparedLineupArgs {
  input: upsertTaskPreparedLineupInput;
}


export interface MutationupsertWatchlistArgs {
  input: upsertWatchlistInput;
}


export interface MutationvalidateApplePayMerchantSessionArgs {
  input: validateApplePayMerchantSessionInput;
}


export interface MutationvalidateFiatWalletArgs {
  input: validateFiatWalletInput;
}


export interface MutationverifyInGameCurrencyPackMobilePurchaseArgs {
  input: verifyInGameCurrencyPackMobilePurchaseInput;
}


export interface MutationverifyMobilePurchaseArgs {
  input: verifyMobilePurchaseInput;
}


export interface MutationverifyPhoneNumberArgs {
  input: verifyPhoneNumberInput;
}


export interface MutationvisitCampaignPageArgs {
  input: visitCampaignPageInput;
}

/** A NBA card */
export interface NBACard extends AnyCardInterface, Node, WithSubscriptionsInterface {
  __typename: 'NBACard';
  activeSuspensions: Array<Suspension>;
  activeTaskAppearances: Array<DecisivePlayerPickerTaskAppearance | TaskAppearance | ThresholdPickerTaskAppearance>;
  anyPlayer: BaseballPlayer | NBAPlayer | Player;
  anyPositions: Array<Position>;
  anyTeam: Club | NationalTeam;
  assetId: Scalars['ID']['output'];
  availableCardBoosts: Array<CardBoost>;
  averageScore?: Maybe<Scalars['Float']['output']>;
  backPictureUrl: Scalars['String']['output'];
  basketballPlayer: NBAPlayer;
  blueprint?: Maybe<Blueprint>;
  bonuses: Array<So5ActiveClubsBonus | So5AverageScoresBonus | So5BoostBonus | So5CaptainBonus | So5CollectionBonus | So5DifferentNationalitiesBonus | So5GradeBonus | So5LineupBonus | So5MalusAfterTransferBonus | So5NationalityBonus | So5PlayerBonus | So5PositionBonus | So5PositionStacksBonus | So5SameActiveClubBonus | So5ScarcityBonus | So5SeasonBonus | So5SpecialEditionCardsBonus>;
  bonusesAfterTransfer: Array<So5ActiveClubsBonus | So5AverageScoresBonus | So5BoostBonus | So5CaptainBonus | So5CollectionBonus | So5DifferentNationalitiesBonus | So5GradeBonus | So5LineupBonus | So5MalusAfterTransferBonus | So5NationalityBonus | So5PlayerBonus | So5PositionBonus | So5PositionStacksBonus | So5SameActiveClubBonus | So5ScarcityBonus | So5SeasonBonus | So5SpecialEditionCardsBonus>;
  borderRadius: Scalars['Int']['output'];
  cardBackgroundUrl?: Maybe<Scalars['String']['output']>;
  cardBackgroundVideoUrl?: Maybe<Scalars['String']['output']>;
  cardCollectionCards: Array<CardCollectionCard>;
  cardEditionName?: Maybe<Scalars['String']['output']>;
  /** @deprecated Not used anymore */
  cardPrice?: Maybe<Scalars['Int']['output']>;
  cardSet?: Maybe<CardSet>;
  cardStats?: Maybe<CardStats>;
  collection?: Maybe<Collection>;
  collectionIncreaseScoreBreakdownAfterTransfer?: Maybe<CardCollectionCardScoreBreakdown>;
  collectionScoringMatrix: Array<CardCollectionScoringMatrix>;
  concurrentSo5Lineups: Array<So5Lineup>;
  contractAddress?: Maybe<Scalars['EthereumAddress']['output']>;
  currentUserSubscription?: Maybe<EmailSubscription>;
  decks: Array<Deck>;
  delayedReveal?: Maybe<Scalars['Boolean']['output']>;
  displayRarity: Scalars['String']['output'];
  /** @deprecated Not used anymore */
  dropRank?: Maybe<Scalars['Int']['output']>;
  eligibleBoards: Array<CareerBoard | SquadBoard>;
  /** Eligible boards on which the card earns a special edition cards bonus */
  eligibleBoardsWithSpecialEditionBonus: Array<BoardWithSpecialEditionBonus>;
  eligiblePlayerGameScores: Array<BaseballPlayerGameScore | BasketballPlayerGameScore | PlayerGameScore | So5Score>;
  eligibleUpcomingLeagueTracks: Array<So5LeagueTrack>;
  ethereumId: Scalars['String']['output'];
  ethereumOwner?: Maybe<TokenOwner>;
  formattedCardEditionName?: Maybe<Scalars['String']['output']>;
  /** Current card level */
  grade: Scalars['Int']['output'];
  gradeAfterTransfer: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  inSeasonEligible: Scalars['Boolean']['output'];
  inSeasonUntil?: Maybe<Scalars['ISO8601DateTime']['output']>;
  ipfsPictureUrl?: Maybe<Scalars['String']['output']>;
  ipfsUrl?: Maybe<Scalars['String']['output']>;
  lastLeveledUpAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  latestEnglishAuction?: Maybe<TokenAuction>;
  latestPrimaryOffer?: Maybe<TokenPrimaryOffer>;
  levelUpAppliedCount: Scalars['Int']['output'];
  livePrimaryOffer?: Maybe<TokenPrimaryOffer>;
  liveSingleBuyOffers: Array<TokenOffer>;
  liveSingleSaleOffer?: Maybe<TokenOffer>;
  /** So5Lineup that this card is being used in for the live So5Fixture */
  liveSo5Lineup?: Maybe<So5Lineup>;
  loanedToken?: Maybe<LoanedToken>;
  /** Returns the lowest price card of the same player, rarity, season and print batch */
  lowestPriceCard?: Maybe<BaseballCard | Card | NBACard>;
  /** Returns the lowest price card of the same player and rarity */
  lowestPriceCardAnySeason?: Maybe<BaseballCard | Card | NBACard>;
  maxLevelUpAppliedCount: Scalars['Int']['output'];
  myCardCollectionSlot?: Maybe<UserCardCollectionSlot>;
  myMintedSingleSaleOffer?: Maybe<TokenOffer>;
  name: Scalars['String']['output'];
  nextLevelUpAvailableAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** So5Lineups that this card is being used in for the opened So5Fixtures */
  openedSo5Lineups: Array<So5Lineup>;
  ownerSince?: Maybe<Scalars['ISO8601DateTime']['output']>;
  ownershipHistory: Array<TokenOwner>;
  pack?: Maybe<Pack>;
  pendingWithdrawal?: Maybe<TokenWithdrawal>;
  pictureUrl?: Maybe<Scalars['String']['output']>;
  /** @deprecated Player loyalty is no longer used */
  playerLoyaltyBoost: RewardBoost;
  /** Total card bonus (XP + Season bonus) */
  power: Scalars['String']['output'];
  /** Total card bonus after transfer */
  powerAfterTransfer: Scalars['String']['output'];
  powerBreakdown: PowerBreakdown;
  powerMalusAfterTransfer: Scalars['String']['output'];
  previouslyOwnedCard?: Maybe<Scalars['Boolean']['output']>;
  previouslyOwnedPlayer?: Maybe<Scalars['Boolean']['output']>;
  priceRange?: Maybe<Range>;
  /** Print batch of the card, 0 for the original print of that player, rarity and season */
  printBatch: Scalars['Int']['output'];
  privateMinPrices?: Maybe<MonetaryAmount>;
  publicMinPrices?: Maybe<MonetaryAmount>;
  rarityTyped: Rarity;
  /**
   * The `related_card_edition_slots` field cannot be nested within a list.
   * @deprecated Use myCardCollectionSlot.relatedCardEditionSlots instead
   */
  relatedCardEditionSlots?: Maybe<Array<UserCardCollectionSlot>>;
  revealableCardCampaign?: Maybe<RevealableCardCampaign>;
  sealable: Scalars['Boolean']['output'];
  sealableFor?: Maybe<Scalars['Int']['output']>;
  sealed: Scalars['Boolean']['output'];
  sealedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  sealedFor?: Maybe<Scalars['Int']['output']>;
  /** @deprecated Player loyalty is no longer used */
  sealedPlayerLoyaltyBoost: RewardBoost;
  seasonYear: Scalars['Int']['output'];
  secondaryMarketFeeEnabled: Scalars['Boolean']['output'];
  /**
   * Returns all live or minted offers where this token is included in the sender
   * side. Returns only if authenticated and sender of the offers.
   */
  sentInLiveOffers?: Maybe<Array<TokenOffer>>;
  serialNumber: Scalars['Int']['output'];
  /** Whether this card qualifies for the social feed */
  shareable: Scalars['Boolean']['output'];
  /** Whether the current user already shared this card */
  shared: Scalars['Boolean']['output'];
  /** @deprecated Not used anymore */
  signedAddCardPrice?: Maybe<SignedCardPrice>;
  signedDropCardPrice?: Maybe<SignedCardPrice>;
  singleCivilYear: Scalars['Boolean']['output'];
  skinEdition?: Maybe<SkinEdition>;
  slug: Scalars['String']['output'];
  solanaAddress?: Maybe<Scalars['String']['output']>;
  solanaBlockExplorerUrl?: Maybe<Scalars['String']['output']>;
  specialEdition?: Maybe<Scalars['String']['output']>;
  sport: Sport;
  sportSeason: SportSeason;
  subscriptionsCount: Scalars['Int']['output'];
  supply: Scalars['Int']['output'];
  threeDimensional: Scalars['Boolean']['output'];
  threeDimensionalAsset?: Maybe<ThreeDimensionalAsset>;
  tokenOwner?: Maybe<TokenOwner>;
  tradeableStatus: Tradeable;
  unsealableAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  unsealedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** @deprecated Player loyalty is no longer used */
  unsealedPlayerLoyaltyBoost: RewardBoost;
  usedIn?: Maybe<ListedOnMarket | UsedInSo5Lineups | UsedInTaskLineups | UsedInTaskPreparedLineups | UsedInTasks>;
  user?: Maybe<User>;
  videoUrl?: Maybe<Scalars['String']['output']>;
  walletStatus: WalletStatus;
  xp: Scalars['Int']['output'];
  xpAfterTransfer: Scalars['Int']['output'];
  /** XP start range of current card level */
  xpNeededForCurrentGrade: Scalars['Int']['output'];
  /** XP end range of current card level */
  xpNeededForNextGrade?: Maybe<Scalars['Int']['output']>;
}


/** A NBA card */
export interface NBACardactiveSuspensionsArgs {
  so5LeaderboardSlug?: InputMaybe<Scalars['String']['input']>;
}


/** A NBA card */
export interface NBACardaverageScoreArgs {
  type: AveragePlayerScore;
}


/** A NBA card */
export interface NBACardbonusesArgs {
  highlighted?: InputMaybe<Scalars['Boolean']['input']>;
  so5LeaderboardSlug?: InputMaybe<Scalars['String']['input']>;
}


/** A NBA card */
export interface NBACardbonusesAfterTransferArgs {
  so5LeaderboardSlug?: InputMaybe<Scalars['String']['input']>;
}


/** A NBA card */
export interface NBACardcardBackgroundVideoUrlArgs {
  derivative?: InputMaybe<Scalars['String']['input']>;
}


/** A NBA card */
export interface NBACardconcurrentSo5LineupsArgs {
  so5FixtureSlug?: InputMaybe<Scalars['String']['input']>;
  so5LeaderboardSlug?: InputMaybe<Scalars['String']['input']>;
}


/** A NBA card */
export interface NBACardeligiblePlayerGameScoresArgs {
  boardId?: InputMaybe<Scalars['String']['input']>;
  gameId?: InputMaybe<Scalars['ID']['input']>;
  so5LeaderboardSlug?: InputMaybe<Scalars['String']['input']>;
  stepId?: InputMaybe<Scalars['String']['input']>;
  taskId?: InputMaybe<Scalars['ID']['input']>;
}


/** A NBA card */
export interface NBACardpictureUrlArgs {
  derivative?: InputMaybe<Scalars['String']['input']>;
}


/** A NBA card */
export interface NBACardpowerArgs {
  so5LeaderboardSlug?: InputMaybe<Scalars['String']['input']>;
}


/** A NBA card */
export interface NBACardpowerAfterTransferArgs {
  so5LeaderboardSlug?: InputMaybe<Scalars['String']['input']>;
}


/** A NBA card */
export interface NBACardpowerBreakdownArgs {
  so5LeaderboardSlug?: InputMaybe<Scalars['String']['input']>;
}


/** A NBA card */
export interface NBACardusedInArgs {
  gameId?: InputMaybe<Scalars['ID']['input']>;
  so5LeaderboardSlug?: InputMaybe<Scalars['String']['input']>;
  taskId?: InputMaybe<Scalars['ID']['input']>;
  taskLineupId?: InputMaybe<Scalars['ID']['input']>;
  taskPreparedLineupId?: InputMaybe<Scalars['ID']['input']>;
}


/** A NBA card */
export interface NBACardvideoUrlArgs {
  derivative?: InputMaybe<Scalars['String']['input']>;
}

/** A NBA player */
export interface NBAPlayer extends AnyPlayerInterface, WithSubscriptionsInterface {
  __typename: 'NBAPlayer';
  abbreviatedName: Scalars['String']['output'];
  activeClub?: Maybe<Club>;
  activeClubMembership?: Maybe<Membership>;
  activeInjuries: Array<Injury>;
  activeNationalTeam?: Maybe<NationalTeam>;
  activeSuspensions: Array<Suspension>;
  age: Scalars['Int']['output'];
  allAverageStats: Array<BasketballAverageStatWithValueType>;
  /** All player So5Scores ordered by descending game date */
  allPlayerGameScores: PlayerGameScoreInterfaceConnection;
  allTotalStats: Array<BasketballAverageStatWithValueType>;
  anyCardWithLiveAuction?: Maybe<BaseballCard | Card | NBACard>;
  anyCardWithLivePrimaryOffer?: Maybe<BaseballCard | Card | NBACard>;
  /** The `any_cards` field cannot be nested within a list. */
  anyCards: AnyCardInterfaceConnection;
  /** Stats of the upcoming games of the player, closest game first */
  anyFutureGameStats: Array<PlayerGameStats | PlayerGameStatsBaseball | PlayerGameStatsBasketball>;
  /** The `any_future_games` field cannot be nested within a list. */
  anyFutureGames: AnyGameInterfaceConnection;
  anyGameStats: Array<Maybe<PlayerGameStats | PlayerGameStatsBaseball | PlayerGameStatsBasketball>>;
  anyGamesForFixture: Array<Game | GameOfBaseball | GameOfBasketball>;
  anyGamesForLeaderboard: Array<Game | GameOfBaseball | GameOfBasketball>;
  /** The `any_past_games` field cannot be nested within a list. */
  anyPastGames: AnyGameInterfaceConnection;
  anyPositions: Array<Position>;
  /** Returns the 3 most followed players in the player's club The `any_related_players` field cannot be nested within a list. */
  anyRelatedPlayers: Array<BaseballPlayer | NBAPlayer | Player>;
  /** The `any_so5_average_last_score` field cannot be nested within a list. */
  anySo5AverageLastScore?: Maybe<AverageLastScore | BaseAverageLastScore>;
  appearances: Scalars['Int']['output'];
  avatarPictureUrl: Scalars['String']['output'];
  averageScore?: Maybe<Scalars['Float']['output']>;
  averageStats?: Maybe<Scalars['Float']['output']>;
  beforeLastOwningMembership?: Maybe<Membership>;
  birthDay?: Maybe<Scalars['ISO8601Date']['output']>;
  cardPositions: Array<Position>;
  /** @deprecated Not used anymore */
  cardPrice?: Maybe<Scalars['Int']['output']>;
  /** Cards of this player that are owned by a manager. Updated once a day. */
  cardSupply: Array<CardSeasonSupply>;
  careerSeasons: Array<Season>;
  clubMemberships: Array<Membership>;
  commonPlayer?: Maybe<CommonPlayer>;
  country: Country;
  currentSeason?: Maybe<Season>;
  currentUserSubscription?: Maybe<EmailSubscription>;
  /** @deprecated Use gainOnProjection */
  differenceLastTenAndClassicProjection?: Maybe<Scalars['Float']['output']>;
  /** @deprecated Use gainOnProjection(eventType: DAILY) */
  differenceLastTenAndDailyProjection?: Maybe<Scalars['Float']['output']>;
  displayName: Scalars['String']['output'];
  /** The `eligible_so5_competitions` field cannot be nested within a list. */
  eligibleSo5Competitions: Array<So5Competition>;
  firstName: Scalars['String']['output'];
  fullPictureUrl: Scalars['String']['output'];
  /** @deprecated Use gainOnProjection */
  gainOnClassicProjection?: Maybe<Scalars['Float']['output']>;
  /** @deprecated Use gainOnProjection */
  gainOnDailyProjection?: Maybe<Scalars['Float']['output']>;
  gainOnProjection?: Maybe<Scalars['Float']['output']>;
  gameplayTier?: Maybe<GameplayTier>;
  /** The star rating of the player gameplay tier */
  gameplayTierStars?: Maybe<Scalars['Float']['output']>;
  hasSo5LineupForFixture: Scalars['Boolean']['output'];
  height?: Maybe<Scalars['Int']['output']>;
  injuries: Array<Injury>;
  isActive: Scalars['Boolean']['output'];
  lastClub?: Maybe<Club>;
  lastFifteenSo5Appearances?: Maybe<Scalars['Int']['output']>;
  lastFiveSo5Appearances?: Maybe<Scalars['Int']['output']>;
  lastFortySo5Appearances?: Maybe<Scalars['Int']['output']>;
  lastName: Scalars['String']['output'];
  /** Get the last 2 cards you own of the player */
  lastOwnedCards: Array<BaseballCard | Card | NBACard>;
  lastTenSo5Appearances?: Maybe<Scalars['Int']['output']>;
  lowestPriceAnyCard?: Maybe<BaseballCard | Card | NBACard>;
  mainCardCollectionSlot?: Maybe<CardCollectionSlot>;
  matchName: Scalars['String']['output'];
  memberships: Array<Membership>;
  mySo5LeaderboardContendersForFixture: Array<So5LeaderboardContender>;
  news: Array<AnyPlayerNewsUpdate>;
  nextClassicFixtureProjectedGrade?: Maybe<PlayerGameScoreProjection>;
  nextClassicFixtureProjectedScore?: Maybe<Scalars['Float']['output']>;
  nextDailyFixtureProjectedGrade?: Maybe<PlayerGameScoreProjection>;
  nextDailyFixtureProjectedScore?: Maybe<Scalars['Float']['output']>;
  nextGame?: Maybe<Game | GameOfBaseball | GameOfBasketball>;
  ownedCardsCount: Scalars['Int']['output'];
  playerGameScore?: Maybe<BaseballPlayerGameScore | BasketballPlayerGameScore | PlayerGameScore | So5Score>;
  /** Up to 15 last So5Scores used in a So5Fixture */
  playerGameScores: Array<Maybe<BaseballPlayerGameScore | BasketballPlayerGameScore | PlayerGameScore | So5Score>>;
  printablePlayer?: Maybe<CommonPlayer>;
  /** The `public_watchlists` field cannot be nested within a list. */
  publicWatchlists?: Maybe<WatchlistConnection>;
  /** Up to 15 last So5Scores.score used in a So5Fixture */
  rawPlayerGameScores: Array<Maybe<Scalars['Float']['output']>>;
  seasonAppearances?: Maybe<Scalars['Int']['output']>;
  shirtNumber: Scalars['Int']['output'];
  /** @deprecated Not used anymore */
  signedAddCardPrice?: Maybe<SignedCardPrice>;
  signedDropCardPrice?: Maybe<SignedCardPrice>;
  slug: Scalars['String']['output'];
  sport: Sport;
  squaredPictureUrl: Scalars['String']['output'];
  subscriptionsCount: Scalars['Int']['output'];
  suspensions: Array<Suspension>;
  /** The `token_prices` field cannot be nested within a list. */
  tokenPrices: TokenPriceConnection;
  totalStats?: Maybe<Scalars['Float']['output']>;
  user?: Maybe<User>;
  weight?: Maybe<Scalars['Int']['output']>;
}


/** A NBA player */
export interface NBAPlayerallAverageStatsArgs {
  limit?: InputMaybe<AverageLimit>;
}


/** A NBA player */
export interface NBAPlayerallPlayerGameScoresArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  position?: InputMaybe<Position>;
  to?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
}


/** A NBA player */
export interface NBAPlayeranyCardWithLiveAuctionArgs {
  inSeason?: InputMaybe<Scalars['Boolean']['input']>;
  rarity?: InputMaybe<Rarity>;
}


/** A NBA player */
export interface NBAPlayeranyCardWithLivePrimaryOfferArgs {
  rarity?: InputMaybe<Rarity>;
}


/** A NBA player */
export interface NBAPlayeranyCardsArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  age?: InputMaybe<Scalars['Int']['input']>;
  assetIds?: InputMaybe<Array<Scalars['String']['input']>>;
  before?: InputMaybe<Scalars['String']['input']>;
  classicOnly?: InputMaybe<Scalars['Boolean']['input']>;
  customCardEditionName?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  inActiveCompetitions?: InputMaybe<Array<Scalars['String']['input']>>;
  inSeasonEligible?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  owned?: InputMaybe<Scalars['Boolean']['input']>;
  ownedByMe?: InputMaybe<Scalars['Boolean']['input']>;
  ownedSinceAfter?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  playerSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  positions?: InputMaybe<Array<Position>>;
  rarities?: InputMaybe<Array<Rarity>>;
  revealable?: InputMaybe<Scalars['Boolean']['input']>;
  seasonStartYears?: InputMaybe<Array<Scalars['Int']['input']>>;
  serialNumber?: InputMaybe<Scalars['Int']['input']>;
  shirtNumber?: InputMaybe<Scalars['Int']['input']>;
  slugs?: InputMaybe<Array<Scalars['String']['input']>>;
  sorts?: InputMaybe<Array<CardSort>>;
  sport?: InputMaybe<Sport>;
  teamSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  withinDeckFirst?: InputMaybe<Scalars['String']['input']>;
}


/** A NBA player */
export interface NBAPlayeranyFutureGameStatsArgs {
  first: Scalars['Int']['input'];
  teamMode?: InputMaybe<AverageScoreTeamMode>;
}


/** A NBA player */
export interface NBAPlayeranyFutureGamesArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  so5FixtureEligible?: InputMaybe<Scalars['Boolean']['input']>;
}


/** A NBA player */
export interface NBAPlayeranyGameStatsArgs {
  last: Scalars['Int']['input'];
  lowCoverage?: InputMaybe<Scalars['Boolean']['input']>;
  so5FixtureSlug?: InputMaybe<Scalars['String']['input']>;
  teamMode?: InputMaybe<AverageScoreTeamMode>;
}


/** A NBA player */
export interface NBAPlayeranyGamesForFixtureArgs {
  so5FixtureSlug: Scalars['String']['input'];
}


/** A NBA player */
export interface NBAPlayeranyGamesForLeaderboardArgs {
  so5LeaderboardSlug: Scalars['String']['input'];
}


/** A NBA player */
export interface NBAPlayeranyPastGamesArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
}


/** A NBA player */
export interface NBAPlayeranySo5AverageLastScoreArgs {
  competitionSlug?: InputMaybe<Scalars['String']['input']>;
  location?: InputMaybe<AverageLastScoreLocation>;
  position: Position;
  span: AverageLastScoreSpan;
  teamSlug?: InputMaybe<Scalars['String']['input']>;
}


/** A NBA player */
export interface NBAPlayeraverageScoreArgs {
  position?: InputMaybe<Position>;
  teamMode?: InputMaybe<AverageScoreTeamMode>;
  type: AveragePlayerScore;
}


/** A NBA player */
export interface NBAPlayeraverageStatsArgs {
  limit?: InputMaybe<AverageLimit>;
  type: BasketballAverageStatType;
}


/** A NBA player */
export interface NBAPlayercardPriceArgs {
  rarity: Rarity;
}


/** A NBA player */
export interface NBAPlayercareerSeasonsArgs {
  type?: InputMaybe<CompetitionType>;
}


/** A NBA player */
export interface NBAPlayercommonPlayerArgs {
  rarity: Rarity;
}


/** A NBA player */
export interface NBAPlayergainOnProjectionArgs {
  eventType?: InputMaybe<So5FixtureEvent>;
}


/** A NBA player */
export interface NBAPlayerhasSo5LineupForFixtureArgs {
  so5FixtureSlug: Scalars['String']['input'];
}


/** A NBA player */
export interface NBAPlayerlastFifteenSo5AppearancesArgs {
  teamMode?: InputMaybe<AverageScoreTeamMode>;
}


/** A NBA player */
export interface NBAPlayerlastFiveSo5AppearancesArgs {
  teamMode?: InputMaybe<AverageScoreTeamMode>;
}


/** A NBA player */
export interface NBAPlayerlastFortySo5AppearancesArgs {
  teamMode?: InputMaybe<AverageScoreTeamMode>;
}


/** A NBA player */
export interface NBAPlayerlastOwnedCardsArgs {
  inSeasonEligible?: InputMaybe<Scalars['Boolean']['input']>;
  rarities?: InputMaybe<Array<Rarity>>;
}


/** A NBA player */
export interface NBAPlayerlastTenSo5AppearancesArgs {
  teamMode?: InputMaybe<AverageScoreTeamMode>;
}


/** A NBA player */
export interface NBAPlayerlowestPriceAnyCardArgs {
  inSeason?: InputMaybe<Scalars['Boolean']['input']>;
  rarity?: InputMaybe<Rarity>;
}


/** A NBA player */
export interface NBAPlayermainCardCollectionSlotArgs {
  rarity: Rarity;
}


/** A NBA player */
export interface NBAPlayermySo5LeaderboardContendersForFixtureArgs {
  so5FixtureSlug: Scalars['String']['input'];
}


/** A NBA player */
export interface NBAPlayernewsArgs {
  last: Scalars['Int']['input'];
}


/** A NBA player */
export interface NBAPlayernextGameArgs {
  so5FixtureEligible?: InputMaybe<Scalars['Boolean']['input']>;
}


/** A NBA player */
export interface NBAPlayerownedCardsCountArgs {
  rarities?: InputMaybe<Array<Rarity>>;
  rarity?: InputMaybe<Rarity>;
  seasonEligibility?: InputMaybe<SeasonEligibility>;
}


/** A NBA player */
export interface NBAPlayerplayerGameScoreArgs {
  gameId: Scalars['ID']['input'];
  position?: InputMaybe<Position>;
}


/** A NBA player */
export interface NBAPlayerplayerGameScoresArgs {
  last: Scalars['Int']['input'];
  lowCoverage?: InputMaybe<Scalars['Boolean']['input']>;
  position?: InputMaybe<Position>;
}


/** A NBA player */
export interface NBAPlayerpublicWatchlistsArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
}


/** A NBA player */
export interface NBAPlayerrawPlayerGameScoresArgs {
  last: Scalars['Int']['input'];
  lowCoverage?: InputMaybe<Scalars['Boolean']['input']>;
  position?: InputMaybe<Position>;
}


/** A NBA player */
export interface NBAPlayerseasonAppearancesArgs {
  teamMode?: InputMaybe<AverageScoreTeamMode>;
}


/** A NBA player */
export interface NBAPlayersignedAddCardPriceArgs {
  rarity: Rarity;
}


/** A NBA player */
export interface NBAPlayersignedDropCardPriceArgs {
  rarity: Rarity;
}


/** A NBA player */
export interface NBAPlayertokenPricesArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  includePrivateSales?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  rarity: Rarity;
  season?: InputMaybe<Scalars['Int']['input']>;
  seasonEligibility?: InputMaybe<SeasonEligibility>;
  since?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
}


/** A NBA player */
export interface NBAPlayertotalStatsArgs {
  type: BasketballAverageStatType;
}

export const NBAPosition = {
  CENTER: 'CENTER',
  FORWARD: 'FORWARD',
  GUARD: 'GUARD',
  UNKNOWN: 'UNKNOWN'
} as const;

export type NBAPosition = typeof NBAPosition[keyof typeof NBAPosition];
/** A Sorare NBA user sport specific profile */
export interface NBAUserSportProfile extends Node, UserSportProfileInterface {
  __typename: 'NBAUserSportProfile';
  achievementBadges?: Maybe<Array<Maybe<SkinShopItem>>>;
  /** @deprecated Not used anymore */
  availableOnboardingLeaderboards: Scalars['Boolean']['output'];
  background?: Maybe<SkinShopItem>;
  bannerColor?: Maybe<Scalars['String']['output']>;
  bannerUrl?: Maybe<Scalars['String']['output']>;
  /**
   * Up to five cards owned in the current set, or in the previous set when no set
   * is active, best gameplay tier and last ten average score first, with a single
   * card per player keeping the rarest edition owned The `best_cards` field cannot
   * be nested within a list.
   */
  bestCards: Array<BaseballCard | Card | NBACard>;
  blueprintCardsCount: Scalars['Int']['output'];
  clubBadge?: Maybe<SkinShopItem>;
  clubName?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use CardSet.starterPackClaimed instead */
  commonGameOnboarded: Scalars['Boolean']['output'];
  /** Get a deck of cards */
  deck?: Maybe<Deck>;
  /** The `decks` field cannot be nested within a list. */
  decks: DeckConnection;
  favoriteTeam?: Maybe<Club | NationalTeam>;
  forceToProOnboarding: Scalars['Boolean']['output'];
  gallerySocialPictureUrls: SocialPictureDerivative;
  highlightPro: Scalars['Boolean']['output'];
  /** The `highlighted_deck` field cannot be nested within a list. */
  highlightedDeck?: Maybe<Deck>;
  id: Scalars['ID']['output'];
  managerProfileSocialPictureUrls: SocialPictureDerivative;
  onboarded: Scalars['Boolean']['output'];
  onboardingCompetitions: Array<Competition>;
  /** @deprecated Not used anymore */
  onboardingLeaderboards: Array<OnboardingLeaderboard>;
  onboardingSo5Fixture?: Maybe<So5Fixture>;
  /**
   * The `onboarding_so5_leaderboard` field cannot be nested within a list.
   * @deprecated Not used anymore
   */
  onboardingSo5Leaderboard?: Maybe<So5Leaderboard>;
  /** A frame to apply on top of user profile picture */
  pictureFrame?: Maybe<PictureFrameShopItem>;
  /** @deprecated Player loyalty is no longer used */
  playerLoyaltyBoost: RewardBoost;
  /** @deprecated Use highlightPro instead */
  proOnboarded: Scalars['Boolean']['output'];
  proUnlocked: Scalars['Boolean']['output'];
  rarityVaultBoost: RewardBoost;
  remainingUnsealsInPeriod: Scalars['Int']['output'];
  selectedUserSportStatistics: Array<Maybe<UserSportStatistic>>;
  shieldUrl?: Maybe<Scalars['String']['output']>;
  socialPictureFingerprint: Scalars['String']['output'];
  tournamentEligibilities: Array<TournamentEligibility>;
  userSportStatistics: Array<UserSportStatistic>;
  variant: UserSportProfileVariant;
}


/** A Sorare NBA user sport specific profile */
export interface NBAUserSportProfileavailableOnboardingLeaderboardsArgs {
  rarity?: InputMaybe<Rarity>;
}


/** A Sorare NBA user sport specific profile */
export interface NBAUserSportProfilebestCardsArgs {
  skins?: InputMaybe<Array<Skin>>;
}


/** A Sorare NBA user sport specific profile */
export interface NBAUserSportProfiledeckArgs {
  name?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
}


/** A Sorare NBA user sport specific profile */
export interface NBAUserSportProfiledecksArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
}


/** A Sorare NBA user sport specific profile */
export interface NBAUserSportProfileonboardingLeaderboardsArgs {
  rarity?: InputMaybe<Rarity>;
}


/** A Sorare NBA user sport specific profile */
export interface NBAUserSportProfileplayerLoyaltyBoostArgs {
  editedSeasonsCount: Scalars['Int']['input'];
  sealedCards: Scalars['Int']['input'];
}


/** A Sorare NBA user sport specific profile */
export interface NBAUserSportProfilerarityVaultBoostArgs {
  rarity: Rarity;
  sport: Sport;
  unseals?: InputMaybe<Scalars['Int']['input']>;
}


/** A Sorare NBA user sport specific profile */
export interface NBAUserSportProfileremainingUnsealsInPeriodArgs {
  rarity: Rarity;
}

export interface NationalTeam extends Node, TeamInterface, WithSubscriptionsInterface {
  __typename: 'NationalTeam';
  activeCompetitions: Array<Competition>;
  /** The `active_memberships` field cannot be nested within a list. */
  activeMemberships: MembershipConnection;
  /** The `active_players` field cannot be nested within a list. */
  activePlayers: PlayerConnection;
  /** The `any_active_players` field cannot be nested within a list. */
  anyActivePlayers: AnyPlayerInterfaceConnection;
  /** The `any_cards` field cannot be nested within a list. */
  anyCards: AnyCardInterfaceConnection;
  /** The `any_games` field cannot be nested within a list. */
  anyGames: AnyGameInterfaceConnection;
  /** The `any_players` field cannot be nested within a list. */
  anyPlayers: AnyPlayerInterfaceConnection;
  /** The `any_recent_departures` field cannot be nested within a list. */
  anyRecentDepartures: AnyPlayerInterfaceConnection;
  code?: Maybe<Scalars['String']['output']>;
  country: Country;
  currentUserSubscription?: Maybe<EmailSubscription>;
  dataPartner?: Maybe<DataPartner>;
  founded?: Maybe<Scalars['String']['output']>;
  /** The `games` field cannot be nested within a list. */
  games: GameConnection;
  id: Scalars['ID']['output'];
  internationalCompetition?: Maybe<Competition>;
  lastFiveAnyGames: Array<Game | GameOfBaseball | GameOfBasketball>;
  lastFiveGames: Array<Game>;
  /** The `latest_any_games` field cannot be nested within a list. */
  latestAnyGames: AnyGameInterfaceConnection;
  /** The `latest_games` field cannot be nested within a list. */
  latestGames: GameConnection;
  name: Scalars['String']['output'];
  officialName: Scalars['String']['output'];
  optaId?: Maybe<Scalars['String']['output']>;
  pictureSecondaryUrl?: Maybe<Scalars['String']['output']>;
  pictureUrl?: Maybe<Scalars['String']['output']>;
  /** The `players` field cannot be nested within a list. */
  players: PlayerConnection;
  ready: Scalars['Boolean']['output'];
  /** The `recent_departures` field cannot be nested within a list. */
  recentDepartures: PlayerConnection;
  shortName: Scalars['String']['output'];
  slug: Scalars['String']['output'];
  styleGuideColor?: Maybe<Scalars['String']['output']>;
  subscriptionsCount: Scalars['Int']['output'];
  /** Returns top 5 players of the national team based on L15 */
  topPlayers: Array<Player>;
  upcomingAnyGames: Array<Maybe<Game | GameOfBaseball | GameOfBasketball>>;
  upcomingGames: Array<Maybe<Game>>;
  withSellablePlayers: Scalars['Boolean']['output'];
}


export interface NationalTeamactiveMembershipsArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
}


export interface NationalTeamactivePlayersArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
}


export interface NationalTeamanyActivePlayersArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
}


export interface NationalTeamanyCardsArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  age?: InputMaybe<Scalars['Int']['input']>;
  assetIds?: InputMaybe<Array<Scalars['String']['input']>>;
  before?: InputMaybe<Scalars['String']['input']>;
  classicOnly?: InputMaybe<Scalars['Boolean']['input']>;
  customCardEditionName?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  inActiveCompetitions?: InputMaybe<Array<Scalars['String']['input']>>;
  inSeasonEligible?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  owned?: InputMaybe<Scalars['Boolean']['input']>;
  ownedByMe?: InputMaybe<Scalars['Boolean']['input']>;
  ownedSinceAfter?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  playerSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  positions?: InputMaybe<Array<Position>>;
  rarities?: InputMaybe<Array<Rarity>>;
  revealable?: InputMaybe<Scalars['Boolean']['input']>;
  seasonStartYears?: InputMaybe<Array<Scalars['Int']['input']>>;
  serialNumber?: InputMaybe<Scalars['Int']['input']>;
  shirtNumber?: InputMaybe<Scalars['Int']['input']>;
  slugs?: InputMaybe<Array<Scalars['String']['input']>>;
  sorts?: InputMaybe<Array<CardSort>>;
  sport?: InputMaybe<Sport>;
  teamSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  withinDeckFirst?: InputMaybe<Scalars['String']['input']>;
}


export interface NationalTeamanyGamesArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  endDate: Scalars['ISO8601DateTime']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  startDate: Scalars['ISO8601DateTime']['input'];
}


export interface NationalTeamanyPlayersArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
}


export interface NationalTeamanyRecentDeparturesArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
}


export interface NationalTeamgamesArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  endDate: Scalars['ISO8601DateTime']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  startDate: Scalars['ISO8601DateTime']['input'];
}


export interface NationalTeamlatestAnyGamesArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  includingLive?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
}


export interface NationalTeamlatestGamesArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  includingLive?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
}


export interface NationalTeampictureUrlArgs {
  derivative?: InputMaybe<Scalars['String']['input']>;
}


export interface NationalTeamplayersArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
}


export interface NationalTeamrecentDeparturesArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
}


export interface NationalTeamupcomingAnyGamesArgs {
  first: Scalars['Int']['input'];
}


export interface NationalTeamupcomingGamesArgs {
  first: Scalars['Int']['input'];
}


export interface NationalTeamwithSellablePlayersArgs {
  withSingleSales?: InputMaybe<Scalars['Boolean']['input']>;
}

/** The nationality rule of a So5Leaderboard */
export interface Nationality {
  __typename: 'Nationality';
  countries: Array<Country>;
  max?: Maybe<Scalars['Int']['output']>;
  min?: Maybe<Scalars['Int']['output']>;
}

/** So5 No Card Route Config */
export interface NoCardRoute {
  __typename: 'NoCardRoute';
  arenaLineupSize: Scalars['Int']['output'];
  /** Game modes the user can choose from once the entry form is submitted */
  availableEntryRoutes: Array<NoCardRouteEntryRoute>;
  /** Lineup shape drafted for the Pro game mode, null when no board step is open */
  boardPickConfig?: Maybe<So5NoCardRouteFixturePickConfig>;
  cardCountsByRarity: CardCount;
  emailAddress: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  maxLineupsPerUser: Scalars['Int']['output'];
  nextCloseDate?: Maybe<Scalars['ISO8601DateTime']['output']>;
  nextOpenDate?: Maybe<Scalars['ISO8601DateTime']['output']>;
  version: Scalars['Int']['output'];
}


/** So5 No Card Route Config */
export interface NoCardRoutemaxLineupsPerUserArgs {
  rarity?: InputMaybe<Rarity>;
}

export const NoCardRouteEntryRoute = {
  ARENA: 'ARENA',
  PRO: 'PRO'
} as const;

export type NoCardRouteEntryRoute = typeof NoCardRouteEntryRoute[keyof typeof NoCardRouteEntryRoute];
/** An object with an ID. */
export interface Node {
  /** ID of the object. */
  id: Scalars['ID']['output'];
}

/** User notification */
export type Notification = AnnouncementNotification | AuctionNotification | AutoClaimNotification | CardCollectionNotification | CardNotification | ConversionCreditNotification | DecisiveActionNotification | DecisivePurchaseNotification | ExternalDepositNotification | InGameCurrencyNotification | JonumVerificationNotification | KycRequestNotification | LoanNotification | MarketingNotification | OffRampKycNotification | OfferNotification | ReferralRewardNotification | ReminderNotification | SaleNotification | So5LineupNotification | So5UserGroupNotification | TaskNotification | UserRelationNotification;

/** A notification filter */
export interface NotificationCategoryInput {
  name: Scalars['String']['input'];
  type: Scalars['String']['input'];
}

/** User Notification */
export interface NotificationInterface {
  body: Scalars['String']['output'];
  createdAt: Scalars['ISO8601DateTime']['output'];
  deeplinkUrl: Scalars['String']['output'];
  iconUrl: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  important: Scalars['Boolean']['output'];
  markdownBody: Scalars['String']['output'];
  name: Scalars['String']['output'];
  pictureUrl?: Maybe<Scalars['String']['output']>;
  read: Scalars['Boolean']['output'];
  sport?: Maybe<SportOrShared>;
  title: Scalars['String']['output'];
  user: CurrentUser;
}

/** The connection type for NotificationInterface. */
export interface NotificationInterfaceConnection {
  __typename: 'NotificationInterfaceConnection';
  /** A list of edges. */
  edges: Array<NotificationInterfaceEdge>;
  /** A list of nodes. */
  nodes: Array<AnnouncementNotification | AuctionNotification | AutoClaimNotification | CardCollectionNotification | CardNotification | ConversionCreditNotification | DecisiveActionNotification | DecisivePurchaseNotification | ExternalDepositNotification | InGameCurrencyNotification | JonumVerificationNotification | KycRequestNotification | LoanNotification | MarketingNotification | OffRampKycNotification | OfferNotification | ReferralRewardNotification | ReminderNotification | SaleNotification | So5LineupNotification | So5UserGroupNotification | TaskNotification | UserRelationNotification>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
}

/** An edge in a connection. */
export interface NotificationInterfaceEdge {
  __typename: 'NotificationInterfaceEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<AnnouncementNotification | AuctionNotification | AutoClaimNotification | CardCollectionNotification | CardNotification | ConversionCreditNotification | DecisiveActionNotification | DecisivePurchaseNotification | ExternalDepositNotification | InGameCurrencyNotification | JonumVerificationNotification | KycRequestNotification | LoanNotification | MarketingNotification | OffRampKycNotification | OfferNotification | ReferralRewardNotification | ReminderNotification | SaleNotification | So5LineupNotification | So5UserGroupNotification | TaskNotification | UserRelationNotification>;
}

/** A Sorare user notification preference */
export interface NotificationPreference {
  __typename: 'NotificationPreference';
  /** The channels available for the notification preference */
  availableChannels: Array<NotificationPreferenceChannel>;
  /** The channels configured for the notification preference */
  channels?: Maybe<Array<NotificationPreferenceChannel>>;
  /** The channels used by default for the notification dispatch */
  defaultChannels: Array<NotificationPreferenceChannel>;
  defaultValue: Scalars['Json']['output'];
  /** The description of the notification preference */
  description: Scalars['String']['output'];
  /** The labels corresponding to each value. May be missing when not relevant. */
  labels?: Maybe<Array<Scalars['String']['output']>>;
  name: Scalars['String']['output'];
  /** The title of the notification preference */
  title: Scalars['String']['output'];
  value?: Maybe<Scalars['Json']['output']>;
  values: Array<Scalars['Json']['output']>;
}

export const NotificationPreferenceChannel = {
  EMAIL: 'EMAIL',
  IN_APP: 'IN_APP',
  PUSH: 'PUSH'
} as const;

export type NotificationPreferenceChannel = typeof NotificationPreferenceChannel[keyof typeof NotificationPreferenceChannel];
/** A notification preference */
export interface NotificationPreferenceInput {
  name: Scalars['String']['input'];
  /** Sport whose notification settings is to be updated. */
  sport: SportOrShared;
  value: Scalars['Json']['input'];
}

/** Notification Section */
export interface NotificationSection {
  __typename: 'NotificationSection';
  /** Get notification settings. If no sport parameter is provided the football one will be returned */
  myNotificationPreferences: Array<NotificationPreference>;
  name: Scalars['String']['output'];
  slug: Scalars['String']['output'];
  subsections: Array<NotificationSubsection>;
}


/** Notification Section */
export interface NotificationSectionmyNotificationPreferencesArgs {
  sport?: InputMaybe<SportOrShared>;
}

/** Notification Subsection */
export interface NotificationSubsection {
  __typename: 'NotificationSubsection';
  name: Scalars['String']['output'];
  section: NotificationSection;
  slug: Scalars['String']['output'];
}

/** An OAuth access token */
export interface OAuthAccessToken {
  __typename: 'OAuthAccessToken';
  application: OAuthApplication;
  createdAt: Scalars['ISO8601DateTime']['output'];
  expiresAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  id: Scalars['String']['output'];
  scopes: Array<Scalars['String']['output']>;
}

/** An OAuth application */
export interface OAuthApplication {
  __typename: 'OAuthApplication';
  clientId: Scalars['String']['output'];
  clientSecret?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  grantTypes: Array<OAuthGrantType>;
  id: Scalars['String']['output'];
  myAccessToken?: Maybe<OAuthAccessToken>;
  name: Scalars['String']['output'];
  pictureUrl?: Maybe<Scalars['String']['output']>;
  redirectUris: Array<Scalars['String']['output']>;
  rejectionReason?: Maybe<Scalars['String']['output']>;
  scopes?: Maybe<Scalars['String']['output']>;
  status: OAuthApplicationStatus;
}


/** An OAuth application */
export interface OAuthApplicationpictureUrlArgs {
  derivative?: InputMaybe<Scalars['String']['input']>;
}

export const OAuthApplicationStatus = {
  APPROVED: 'APPROVED',
  DISABLED: 'DISABLED',
  PENDING: 'PENDING',
  REJECTED: 'REJECTED'
} as const;

export type OAuthApplicationStatus = typeof OAuthApplicationStatus[keyof typeof OAuthApplicationStatus];
export const OAuthGrantType = {
  AUTHORIZATION_CODE: 'AUTHORIZATION_CODE',
  CLIENT_CREDENTIALS: 'CLIENT_CREDENTIALS'
} as const;

export type OAuthGrantType = typeof OAuthGrantType[keyof typeof OAuthGrantType];
export const OAuthProvider = {
  APPLE: 'APPLE',
  FACEBOOK: 'FACEBOOK',
  GOOGLE_OAUTH2: 'GOOGLE_OAUTH2'
} as const;

export type OAuthProvider = typeof OAuthProvider[keyof typeof OAuthProvider];
export interface OffRampAuthorizationApprovalInput {
  ethereumBankTransferApproval: EthereumBankTransferApprovalInput;
  fingerprint: Scalars['String']['input'];
}

/** An off-ramp authorization request (EthLiquidator on Base) */
export interface OffRampAuthorizationRequest {
  __typename: 'OffRampAuthorizationRequest';
  amount: Scalars['CryptocurrencyAmount']['output'];
  amountOutMinimum: Scalars['String']['output'];
  bridgeRecipient: Scalars['String']['output'];
  contractAddress: Scalars['String']['output'];
  data: Scalars['String']['output'];
  deadline: Scalars['String']['output'];
  feeAmount: Scalars['CryptocurrencyAmount']['output'];
  proxyAddress: Scalars['String']['output'];
  receiverAddress: Scalars['String']['output'];
  salt: Scalars['String']['output'];
  senderAddress: Scalars['String']['output'];
}

/** Bridge.xyz off-ramp customer mapped to a Sorare user */
export interface OffRampBridgeAccount {
  __typename: 'OffRampBridgeAccount';
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['ID']['output'];
  kycStatus: OffRampBridgeKycStatus;
  /** User-facing reason the KYC was rejected, if any */
  rejectionReason?: Maybe<Scalars['String']['output']>;
}

export const OffRampBridgeKycStatus = {
  ACTIVE: 'ACTIVE',
  BLOCKED: 'BLOCKED',
  CLOSED: 'CLOSED',
  PENDING: 'PENDING',
  REJECTED: 'REJECTED'
} as const;

export type OffRampBridgeKycStatus = typeof OffRampBridgeKycStatus[keyof typeof OffRampBridgeKycStatus];
export interface OffRampBridgeResidentialAddressInput {
  city: Scalars['String']['input'];
  /** ISO 3166-1 alpha-2 country code */
  country: Scalars['String']['input'];
  postalCode: Scalars['String']['input'];
  state?: InputMaybe<Scalars['String']['input']>;
  streetLine1: Scalars['String']['input'];
  streetLine2?: InputMaybe<Scalars['String']['input']>;
}

/** An off-ramp KYC notification */
export interface OffRampKycNotification extends Node, NotificationInterface {
  __typename: 'OffRampKycNotification';
  body: Scalars['String']['output'];
  createdAt: Scalars['ISO8601DateTime']['output'];
  deeplinkUrl: Scalars['String']['output'];
  iconUrl: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  important: Scalars['Boolean']['output'];
  markdownBody: Scalars['String']['output'];
  name: Scalars['String']['output'];
  pictureUrl?: Maybe<Scalars['String']['output']>;
  read: Scalars['Boolean']['output'];
  sport?: Maybe<SportOrShared>;
  title: Scalars['String']['output'];
  user: CurrentUser;
}

/** Off-ramp pricing breakdown: ETH → USDC → EUR with the Uniswap fee, plus expected and minimum payout. */
export interface OffRampQuote {
  __typename: 'OffRampQuote';
  /** Expected EUR payout at the mid-market rate. */
  estimatedAmount: MonetaryAmount;
  /** Expected USDC received from the ETH→USDC swap, before the USDC→EUR conversion. */
  estimatedUsdcAmount: MonetaryAmount;
  /** USD→EUR mid-market rate applied to the USDC→EUR conversion. */
  midMarketUsdEurRate: Scalars['Float']['output'];
  /** Guaranteed-minimum EUR payout in the worst-case Uniswap slippage scenario. */
  minimumAmount: MonetaryAmount;
  /** ETH amount the user is off-ramping (the swap input). */
  sourceAmount: MonetaryAmount;
  /** Uniswap LP fee charged on the ETH→USDC swap, deducted from the ETH input. */
  uniswapFeeAmount: MonetaryAmount;
}

/** An ETH → EUR off-ramp through Bridge.xyz */
export interface OffRampWithdrawal extends Node {
  __typename: 'OffRampWithdrawal';
  amountOutMicros?: Maybe<Scalars['CryptocurrencyAmount']['output']>;
  amountOutMinimumMicros: Scalars['CryptocurrencyAmount']['output'];
  amountWei: Scalars['WeiAmount']['output'];
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['ID']['output'];
  /** @deprecated Use transactionHash */
  onChainTransactionHash?: Maybe<Scalars['String']['output']>;
  status: OffRampWithdrawalStatus;
  to: Scalars['String']['output'];
  transactionHash?: Maybe<Scalars['String']['output']>;
}

export const OffRampWithdrawalStatus = {
  COMPLETED: 'COMPLETED',
  CREATED: 'CREATED',
  FAILED: 'FAILED'
} as const;

export type OffRampWithdrawalStatus = typeof OffRampWithdrawalStatus[keyof typeof OffRampWithdrawalStatus];
export const OfferDirection = {
  RECEIVED: 'RECEIVED',
  SENT: 'SENT'
} as const;

export type OfferDirection = typeof OfferDirection[keyof typeof OfferDirection];
/** An object including all arguments to migrate an offer */
export interface OfferMigrationInput {
  expirationBlock: Scalars['Int']['input'];
  migrateInternalCardsSignature?: InputMaybe<Scalars['String']['input']>;
  migrateMappedCardsSignature?: InputMaybe<Scalars['String']['input']>;
}

/** A user notification regarding an Offer */
export interface OfferNotification extends Node, NotificationInterface {
  __typename: 'OfferNotification';
  body: Scalars['String']['output'];
  createdAt: Scalars['ISO8601DateTime']['output'];
  deeplinkUrl: Scalars['String']['output'];
  iconUrl: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  important: Scalars['Boolean']['output'];
  markdownBody: Scalars['String']['output'];
  name: Scalars['String']['output'];
  pictureUrl?: Maybe<Scalars['String']['output']>;
  read: Scalars['Boolean']['output'];
  sport?: Maybe<SportOrShared>;
  title: Scalars['String']['output'];
  tokenOffer: TokenOffer;
  user: CurrentUser;
}

export const OfferState = {
  ACCEPTED: 'ACCEPTED',
  BLOCKED: 'BLOCKED',
  CANCELLED: 'CANCELLED',
  ENDED: 'ENDED',
  FLAGGED: 'FLAGGED',
  MINTED: 'MINTED',
  OPENED: 'OPENED',
  PENDING_MIGRATION: 'PENDING_MIGRATION',
  PENDING_REJECTION: 'PENDING_REJECTION',
  PENDING_REVIEW: 'PENDING_REVIEW',
  READY_FOR_SCORING: 'READY_FOR_SCORING',
  REJECTED: 'REJECTED',
  SCORED: 'SCORED',
  SETTLABLE: 'SETTLABLE',
  SETTLEMENT_FAILED: 'SETTLEMENT_FAILED',
  SETTLEMENT_PUBLISHED: 'SETTLEMENT_PUBLISHED'
} as const;

export type OfferState = typeof OfferState[keyof typeof OfferState];
export const OfferType = {
  DIRECT_OFFER: 'DIRECT_OFFER',
  SINGLE_BUY_OFFER: 'SINGLE_BUY_OFFER',
  SINGLE_SALE_OFFER: 'SINGLE_SALE_OFFER'
} as const;

export type OfferType = typeof OfferType[keyof typeof OfferType];
export interface OnboardingLeaderboard {
  __typename: 'OnboardingLeaderboard';
  /** @deprecated Not used anymore */
  color: Scalars['String']['output'];
  /** @deprecated Not used anymore */
  description?: Maybe<Scalars['String']['output']>;
  /** @deprecated Not used anymore */
  displayName: Scalars['String']['output'];
  /** @deprecated Not used anymore */
  id: Scalars['String']['output'];
  /** @deprecated Not used anymore */
  nextPlayableLeaderboard?: Maybe<So5Leaderboard>;
  /** @deprecated Not used anymore */
  pictureUrl: Scalars['String']['output'];
  /** @deprecated Not used anymore */
  playableLeaderboard?: Maybe<So5Leaderboard>;
}

export interface OperationInput {
  name: Scalars['String']['input'];
  path: Scalars['String']['input'];
  timeMs: Scalars['Int']['input'];
}

/** A list of best PlayerGameScore by position */
export interface OrderedPlayerGameScores {
  __typename: 'OrderedPlayerGameScores';
  playerGameScores: Array<BaseballPlayerGameScore | BasketballPlayerGameScore | PlayerGameScore | So5Score>;
  position: Position;
}

/** A list of best So5Score by position */
export interface OrderedSo5Scores {
  __typename: 'OrderedSo5Scores';
  position: Scalars['String']['output'];
  positionTyped: Position;
  so5Scores: Array<So5Score>;
}

export const OrdinalRatingEnum = {
  HIGH: 'HIGH',
  LOW: 'LOW',
  MEDIUM: 'MEDIUM'
} as const;

export type OrdinalRatingEnum = typeof OrdinalRatingEnum[keyof typeof OrdinalRatingEnum];
export const Orientation = {
  LANDSCAPE: 'LANDSCAPE',
  PORTRAIT: 'PORTRAIT'
} as const;

export type Orientation = typeof Orientation[keyof typeof Orientation];
/** A Mangopay other bank account type */
export interface OtherBankAccount extends BankAccountInterface, Node {
  __typename: 'OtherBankAccount';
  /** Account number (last 4 digits) */
  accountNumber: Scalars['String']['output'];
  /** Bank Identifier Code */
  bic: Scalars['String']['output'];
  country: Country;
  id: Scalars['ID']['output'];
  minimumWithdrawalAmounts: MonetaryAmount;
  ownerAddress?: Maybe<MangopayBankAccountOwnerAddress>;
  ownerName?: Maybe<Scalars['String']['output']>;
  status?: Maybe<MangopayBankAccountStatus>;
  withdrawalFeeAmounts: MonetaryAmount;
  withdrawalFeeType: MangopayBankAccountWithdrawalFeeType;
}

export interface OverperformAverageScoreConfig {
  __typename: 'OverperformAverageScoreConfig';
  averageType: AveragePlayerScore;
  by: Scalars['Int']['output'];
}

export interface OwnedSinceRule extends So5RuleInterface {
  __typename: 'OwnedSinceRule';
  descriptions: Array<So5RuleDescription>;
  from?: Maybe<Scalars['ISO8601DateTime']['output']>;
  id: Scalars['String']['output'];
  key: Scalars['String']['output'];
  to?: Maybe<Scalars['ISO8601DateTime']['output']>;
}

/** An object representing the past or present ownership of a card by a user or a contract */
export interface Owner extends Node, OwnerInterface {
  __typename: 'Owner';
  account?: Maybe<Account>;
  address: Scalars['String']['output'];
  amounts?: Maybe<MonetaryAmount>;
  blockchain: Scalars['String']['output'];
  card: Card;
  from: Scalars['ISO8601DateTime']['output'];
  id: Scalars['ID']['output'];
  optimistic: Scalars['Boolean']['output'];
  /** Card price, in wei. */
  price: Scalars['String']['output'];
  referenceId?: Maybe<Scalars['String']['output']>;
  settleAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  transferType: Scalars['String']['output'];
}

/** A Pro card a manager shared, along with how they acquired it */
export interface OwnerActivityFeed extends ActivityFeedInterface, Node {
  __typename: 'OwnerActivityFeed';
  acquiredAt: Scalars['ISO8601DateTime']['output'];
  backgroundUrl?: Maybe<Scalars['String']['output']>;
  card: BaseballCard | Card | NBACard;
  /**
   * The most recent reaction the current user left on this activity
   * @deprecated Use currentUserReactions instead
   */
  currentUserReaction?: Maybe<ActivityReaction>;
  /** The reactions the current user left on this activity, the oldest first */
  currentUserReactions: Array<ActivityReaction>;
  gameMode: PlatformGameMode;
  id: Scalars['ID']['output'];
  /** The reactions left on this activity, the most recent first The `reactions` field cannot be nested within a list. */
  reactions: ActivityReactionConnection;
  /** How many managers left each emoji, in the order the emojis were first used */
  reactionsCount: Array<ActivityReactionCount>;
  sharedAt: Scalars['ISO8601DateTime']['output'];
  transferType: OwnerTransfer;
  user: User;
}


/** A Pro card a manager shared, along with how they acquired it */
export interface OwnerActivityFeedreactionsArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  emoji?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
}

/** Card owner (contract or user) */
export interface OwnerInterface {
  account?: Maybe<Account>;
  address: Scalars['String']['output'];
  amounts?: Maybe<MonetaryAmount>;
  blockchain: Scalars['String']['output'];
  card: Card;
  from: Scalars['ISO8601DateTime']['output'];
  id: Scalars['ID']['output'];
  optimistic: Scalars['Boolean']['output'];
  /** Card price, in wei. */
  price: Scalars['String']['output'];
  referenceId?: Maybe<Scalars['String']['output']>;
  settleAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  transferType: Scalars['String']['output'];
}

export const OwnerTransfer = {
  BUNDLED_ENGLISH_AUCTION: 'BUNDLED_ENGLISH_AUCTION',
  DEPOSIT: 'DEPOSIT',
  DIRECT_OFFER: 'DIRECT_OFFER',
  ENGLISH_AUCTION: 'ENGLISH_AUCTION',
  INSTANT_BUY: 'INSTANT_BUY',
  LOAN: 'LOAN',
  MINT: 'MINT',
  PACK: 'PACK',
  REFERRAL: 'REFERRAL',
  REWARD: 'REWARD',
  SHARDS: 'SHARDS',
  SINGLE_BUY_OFFER: 'SINGLE_BUY_OFFER',
  SINGLE_SALE_OFFER: 'SINGLE_SALE_OFFER',
  TRANSFER: 'TRANSFER',
  WITHDRAWAL: 'WITHDRAWAL'
} as const;

export type OwnerTransfer = typeof OwnerTransfer[keyof typeof OwnerTransfer];
/** An owner with conversion rates */
export interface OwnerWithRates extends Node, OwnerInterface {
  __typename: 'OwnerWithRates';
  account?: Maybe<Account>;
  address: Scalars['String']['output'];
  amounts?: Maybe<MonetaryAmount>;
  blockchain: Scalars['String']['output'];
  card: Card;
  from: Scalars['ISO8601DateTime']['output'];
  id: Scalars['ID']['output'];
  optimistic: Scalars['Boolean']['output'];
  /** Card price, in wei. */
  price: Scalars['String']['output'];
  priceInFiat: Fiat;
  referenceId?: Maybe<Scalars['String']['output']>;
  settleAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  transferType: Scalars['String']['output'];
}

/** A pack */
export interface Pack extends Node {
  __typename: 'Pack';
  buyingDate: Scalars['ISO8601DateTime']['output'];
  cardPack?: Maybe<CardPack>;
  cards: Array<BaseballCard | Card | NBACard>;
  claimed: Scalars['Boolean']['output'];
  /** @deprecated No longer used by Sorare clients */
  commonPlayers: Array<CommonPlayer>;
  id: Scalars['ID']['output'];
}

export const PackConfigGroup = {
  DAILY_DEAL: 'DAILY_DEAL',
  MARKET: 'MARKET',
  SPECIAL_EVENT: 'SPECIAL_EVENT'
} as const;

export type PackConfigGroup = typeof PackConfigGroup[keyof typeof PackConfigGroup];
/** A purchasable item that is a pack config */
export interface PackConfigPurchasableItem extends Node, PurchasableItemInterface {
  __typename: 'PackConfigPurchasableItem';
  cardPack: CardPack;
  cardPaymentProvider: PaymentMethodProvider;
  highlightedPlayer?: Maybe<BaseballPlayer | NBAPlayer | Player>;
  id: Scalars['ID']['output'];
  nextPriceUpdateAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  oldPrice?: Maybe<MonetaryAmount>;
  pack?: Maybe<Pack>;
  pictureUrl?: Maybe<Scalars['String']['output']>;
  price: MonetaryAmount;
  slug: Scalars['String']['output'];
  sport?: Maybe<Sport>;
}


/** A purchasable item that is a pack config */
export interface PackConfigPurchasableItempictureUrlArgs {
  derivative?: InputMaybe<PurchasableItemDerivative>;
}

/** The connection type for Pack. */
export interface PackConnection {
  __typename: 'PackConnection';
  /** A list of edges. */
  edges: Array<PackEdge>;
  /** A list of nodes. */
  nodes: Array<Pack>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
}

/** An edge in a connection. */
export interface PackEdge {
  __typename: 'PackEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<Pack>;
}

/** The draw odds of a single player within a pack slot */
export interface PackPlayerOdds {
  __typename: 'PackPlayerOdds';
  pictureUrl?: Maybe<Scalars['String']['output']>;
  player: BaseballPlayer | NBAPlayer | Player;
  positions: Array<Position>;
  /** Draw probability in basis points (1 bp = 0.01%); fractional */
  probabilityBasisPoint: Scalars['Float']['output'];
  /** The skin edition of a common card; null for non-skinned cards */
  skinEdition?: Maybe<SkinEdition>;
  team: Club | NationalTeam;
}


/** The draw odds of a single player within a pack slot */
export interface PackPlayerOddspictureUrlArgs {
  derivative?: InputMaybe<Scalars['String']['input']>;
}

export interface PackSource extends HistoryTransactionInterface {
  __typename: 'PackSource';
  date: Scalars['ISO8601DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  label: Scalars['String']['output'];
  logoUrl?: Maybe<Scalars['String']['output']>;
  quantityByFlavour: Array<PoolKeyShardsCount>;
  totalQuantity: Scalars['Int']['output'];
}

/** Information about pagination in a connection. */
export interface PageInfo {
  __typename: 'PageInfo';
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']['output']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean']['output'];
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']['output']>;
}

/** A webauthn passkey */
export interface Passkey extends Node {
  __typename: 'Passkey';
  createdAt: Scalars['ISO8601DateTime']['output'];
  externalId: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  lastUsedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  nickname?: Maybe<Scalars['String']['output']>;
  publicKey: Scalars['String']['output'];
  signCount: Scalars['Int']['output'];
  sorarePrivateKey?: Maybe<SorarePrivateKey>;
  user: User;
}

export interface PasskeyChallenge {
  __typename: 'PasskeyChallenge';
  challenge: Scalars['String']['output'];
  timeout: Scalars['Int']['output'];
}

/** Input for passkey credential */
export interface PasskeyCredentialForCreateInput {
  authenticatorAttachment?: InputMaybe<Scalars['String']['input']>;
  clientExtensionResults?: InputMaybe<Scalars['Json']['input']>;
  id: Scalars['String']['input'];
  rawId: Scalars['String']['input'];
  response: PasskeyCredentialResponseForCreateInput;
  type: Scalars['String']['input'];
  user?: InputMaybe<PasskeyCredentialUserInput>;
}

/** Input for passkey credential */
export interface PasskeyCredentialForGetInput {
  authenticatorAttachment?: InputMaybe<Scalars['String']['input']>;
  clientExtensionResults?: InputMaybe<Scalars['Json']['input']>;
  id: Scalars['String']['input'];
  rawId: Scalars['String']['input'];
  response: PasskeyCredentialResponseForGetInput;
  type: Scalars['String']['input'];
  user?: InputMaybe<PasskeyCredentialUserInput>;
}

/** Input for passkey credential response */
export interface PasskeyCredentialResponseForCreateInput {
  attestationObject: Scalars['String']['input'];
  clientDataJSON: Scalars['String']['input'];
  publicKey?: InputMaybe<Scalars['String']['input']>;
  publicKeyAlgorithm?: InputMaybe<Scalars['Int']['input']>;
  signature?: InputMaybe<Scalars['String']['input']>;
  transports?: InputMaybe<Array<Scalars['String']['input']>>;
  userHandle?: InputMaybe<Scalars['String']['input']>;
}

/** Input for passkey credential response */
export interface PasskeyCredentialResponseForGetInput {
  authenticatorData: Scalars['String']['input'];
  clientDataJSON: Scalars['String']['input'];
  publicKey?: InputMaybe<Scalars['String']['input']>;
  publicKeyAlgorithm?: InputMaybe<Scalars['Int']['input']>;
  signature?: InputMaybe<Scalars['String']['input']>;
  transports?: InputMaybe<Array<Scalars['String']['input']>>;
  userHandle?: InputMaybe<Scalars['String']['input']>;
}

/** Input for passkey credential user */
export interface PasskeyCredentialUserInput {
  id?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
}

export interface PasswordEncryptedPrivateKey {
  __typename: 'PasswordEncryptedPrivateKey';
  iv: Scalars['String']['output'];
  payload: Scalars['String']['output'];
  salt: Scalars['String']['output'];
}

export interface PasswordEncryptedPrivateKeyInput {
  iv: Scalars['String']['input'];
  payload: Scalars['String']['input'];
  salt: Scalars['String']['input'];
}

/** A payment intent */
export interface Payment extends Node {
  __typename: 'Payment';
  aasmState: PaymentIntentState;
  amount: Scalars['WeiAmount']['output'];
  creditCardReceiptAvailable: Scalars['Boolean']['output'];
  creditCardReceiptSent: Scalars['Boolean']['output'];
  fiat: Scalars['Boolean']['output'];
  fiatAmount?: Maybe<Scalars['Int']['output']>;
  fiatCurrency?: Maybe<FiatCurrency>;
  fiatReceiptUrl?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  spentAt: Scalars['ISO8601DateTime']['output'];
  tokenOperation?: Maybe<PaymentIntentTokenOperation>;
  user: User;
}

/** The connection type for Payment. */
export interface PaymentConnection {
  __typename: 'PaymentConnection';
  /** A list of edges. */
  edges: Array<PaymentEdge>;
  /** A list of nodes. */
  nodes: Array<Payment>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
}

export const PaymentCurrency = {
  ETH: 'ETH',
  EUR: 'EUR',
  GBP: 'GBP',
  USD: 'USD'
} as const;

export type PaymentCurrency = typeof PaymentCurrency[keyof typeof PaymentCurrency];
/** Information about the status of a pre authorization */
export interface PaymentDepositStatus {
  __typename: 'PaymentDepositStatus';
  depositStatus?: Maybe<DepositOperationStatus>;
  provider?: Maybe<PaymentProvider>;
  providerId?: Maybe<Scalars['String']['output']>;
}

/** An edge in a connection. */
export interface PaymentEdge {
  __typename: 'PaymentEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<Payment>;
}

export const PaymentIntentState = {
  CANCELLED: 'CANCELLED',
  FAILED: 'FAILED',
  PENDING_REFUND: 'PENDING_REFUND',
  READY: 'READY',
  REFUNDED: 'REFUNDED',
  SPENT: 'SPENT'
} as const;

export type PaymentIntentState = typeof PaymentIntentState[keyof typeof PaymentIntentState];
/** Object that can be a tokenOperation of a PaymentIntent */
export type PaymentIntentTokenOperation = TokenBid | TokenOffer | TokenPrimaryOffer;

/** Payment Method */
export interface PaymentMethod {
  __typename: 'PaymentMethod';
  card: CreditCard;
  id: Scalars['String']['output'];
}

/**
 * One row of a payment processing fee matrix. Matrices are ordered by priority:
 * take the first row matching the payment (equal paymentMethod; null
 * creditCardType/currency match any value). No matching row means no fee.
 */
export interface PaymentMethodFeeRate {
  __typename: 'PaymentMethodFeeRate';
  creditCardType?: Maybe<CreditCardType>;
  currency?: Maybe<FiatCurrency>;
  feeBasisPoints: Scalars['Int']['output'];
  paymentMethod: TokenPaymentMethod;
}

export const PaymentMethodProvider = {
  MANGOPAY: 'MANGOPAY',
  STRIPE: 'STRIPE',
  /** Stripe micropayment account, bound to its own publishable key */
  STRIPE_MICRO: 'STRIPE_MICRO'
} as const;

export type PaymentMethodProvider = typeof PaymentMethodProvider[keyof typeof PaymentMethodProvider];
export const PaymentProvider = {
  APPLE_PAY: 'APPLE_PAY',
  IDEAL: 'IDEAL',
  MANGOPAY: 'MANGOPAY',
  PAYPAL: 'PAYPAL'
} as const;

export type PaymentProvider = typeof PaymentProvider[keyof typeof PaymentProvider];
/** Queries concerning payments */
export interface PaymentRoot {
  __typename: 'PaymentRoot';
  depositStatus: PaymentDepositStatus;
}


/** Queries concerning payments */
export interface PaymentRootdepositStatusArgs {
  provider: PaymentProvider;
  providerId: Scalars['String']['input'];
}

/** A paypal authorization request */
export interface PaypalAuthorizationRequest {
  __typename: 'PaypalAuthorizationRequest';
  amount: Scalars['Int']['output'];
  currency: FiatCurrency;
  id: Scalars['String']['output'];
  redirectUrl: Scalars['String']['output'];
}

/** A pending deposit to user's wallet */
export interface PendingDeposit {
  __typename: 'PendingDeposit';
  amounts: MonetaryAmount;
  date: Scalars['ISO8601DateTime']['output'];
  feeAmounts?: Maybe<MonetaryAmount>;
  id: Scalars['String']['output'];
  providerType: DepositProvider;
  status: DepositStatus;
  /** Will be null if deposit is not external */
  transactionHash?: Maybe<Scalars['String']['output']>;
}

/** A pending JONUM playtime limit change */
export interface PendingPlaytimeLimit {
  __typename: 'PendingPlaytimeLimit';
  effectiveAt: Scalars['ISO8601DateTime']['output'];
  limitMinutes: Scalars['Float']['output'];
}

/** A pending JONUM spending limit change */
export interface PendingSpendingLimit {
  __typename: 'PendingSpendingLimit';
  effectiveAt: Scalars['ISO8601DateTime']['output'];
  limit: MonetaryAmount;
}

export const Period = {
  END_OF_EXTRA_TIME_BEFORE_PENALTIES: 'END_OF_EXTRA_TIME_BEFORE_PENALTIES',
  END_OF_SECOND_HALF_BEFORE_EXTRA_TIME: 'END_OF_SECOND_HALF_BEFORE_EXTRA_TIME',
  EXTRA_TIME_FIRST_HALF: 'EXTRA_TIME_FIRST_HALF',
  EXTRA_TIME_HALF_TIME: 'EXTRA_TIME_HALF_TIME',
  EXTRA_TIME_SECOND_HALF: 'EXTRA_TIME_SECOND_HALF',
  FIRST_HALF: 'FIRST_HALF',
  FULL_TIME: 'FULL_TIME',
  HALF_TIME: 'HALF_TIME',
  PENALTY_SHOOTOUT: 'PENALTY_SHOOTOUT',
  PRE_MATCH: 'PRE_MATCH',
  SECOND_HALF: 'SECOND_HALF'
} as const;

export type Period = typeof Period[keyof typeof Period];
/** A score for a game period */
export interface PeriodScore {
  __typename: 'PeriodScore';
  awayScore: Scalars['Int']['output'];
  homeScore: Scalars['Int']['output'];
  periodNumber: Scalars['Int']['output'];
}

export interface PickableCard {
  __typename: 'PickableCard';
  card: BaseballCard | Card | NBACard;
  slug: Scalars['String']['output'];
  target?: Maybe<Scalars['Int']['output']>;
}

export interface PickablePlayer {
  __typename: 'PickablePlayer';
  /** Average stats of a player for the task targeted stat */
  averageStat?: Maybe<Scalars['Float']['output']>;
  pickableCardWithLivePrimaryOffer?: Maybe<PickableCard>;
  pickableCards: Array<PickableCard>;
  player: BaseballPlayer | NBAPlayer | Player;
  /** Projected stat of a player on a game for the task targeted stat */
  projectedStat?: Maybe<Scalars['Float']['output']>;
  slug: Scalars['String']['output'];
}


export interface PickablePlayeraverageStatArgs {
  limit?: InputMaybe<AverageLimit>;
}


export interface PickablePlayerprojectedStatArgs {
  gameId: Scalars['ID']['input'];
}

export interface PickableTeam {
  __typename: 'PickableTeam';
  pickablePlayers: Array<PickablePlayer>;
  slug: Scalars['String']['output'];
  team: Club | NationalTeam;
}

export interface PictureFrameShopItem extends Node, ShopItemInterface {
  __typename: 'PictureFrameShopItem';
  cardCollectionRequirements: Array<CardCollectionRequirement>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  disabled: Scalars['Boolean']['output'];
  expirationDate?: Maybe<Scalars['ISO8601DateTime']['output']>;
  id: Scalars['ID']['output'];
  infoLink?: Maybe<Scalars['String']['output']>;
  limitPerUser: Scalars['Int']['output'];
  myAvailableTotalPurchasesCount: Scalars['Int']['output'];
  myAvailableUserShopItems?: Maybe<Array<UserShopItem>>;
  myBalance: Scalars['Int']['output'];
  myLimitResetAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  myPurchasesCount: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  pictureUrl: Scalars['String']['output'];
  position: ShopItemType;
  price: Scalars['Int']['output'];
  requirementsRulesLink?: Maybe<Scalars['String']['output']>;
  salePrice?: Maybe<Scalars['Int']['output']>;
  shopItemsRequired: Array<ShopItem>;
  threeDimensionalAssetUrl?: Maybe<Scalars['String']['output']>;
  unlocked: Scalars['Boolean']['output'];
}


export interface PictureFrameShopItempictureUrlArgs {
  derivative?: InputMaybe<ShopItemDerivative>;
}


export interface PictureFrameShopItemthreeDimensionalAssetUrlArgs {
  format?: InputMaybe<ShopItemThreeDimensionalAssetFormat>;
}

export const PicturePositioning = {
  AS_IS: 'AS_IS',
  AUTO: 'AUTO'
} as const;

export type PicturePositioning = typeof PicturePositioning[keyof typeof PicturePositioning];
export const Platform = {
  ANDROID: 'ANDROID',
  IOS: 'IOS',
  MOBILE_WEB: 'MOBILE_WEB',
  WEB: 'WEB'
} as const;

export type Platform = typeof Platform[keyof typeof Platform];
export const PlatformGameMode = {
  NO_CARD_ENTRY: 'NO_CARD_ENTRY',
  PRO: 'PRO',
  RIVALS: 'RIVALS',
  SET: 'SET'
} as const;

export type PlatformGameMode = typeof PlatformGameMode[keyof typeof PlatformGameMode];
/** A professional football player */
export interface Player extends AnyPlayerInterface, Node, WithSubscriptionsInterface {
  __typename: 'Player';
  abbreviatedName: Scalars['String']['output'];
  activeClub?: Maybe<Club>;
  activeClubMembership?: Maybe<Membership>;
  activeInjuries: Array<Injury>;
  activeNationalTeam?: Maybe<NationalTeam>;
  activeSuspensions: Array<Suspension>;
  age: Scalars['Int']['output'];
  allAverageStats: Array<FootballAverageStatWithValueType>;
  /** All player So5Scores ordered by descending game date */
  allPlayerGameScores: PlayerGameScoreInterfaceConnection;
  /** All player So5Scores ordered by descending game date */
  allSo5Scores: So5ScoreConnection;
  allTotalStats: Array<FootballAverageStatWithValueType>;
  anyCardWithLiveAuction?: Maybe<BaseballCard | Card | NBACard>;
  anyCardWithLivePrimaryOffer?: Maybe<BaseballCard | Card | NBACard>;
  /** The `any_cards` field cannot be nested within a list. */
  anyCards: AnyCardInterfaceConnection;
  /** Stats of the upcoming games of the player, closest game first */
  anyFutureGameStats: Array<PlayerGameStats | PlayerGameStatsBaseball | PlayerGameStatsBasketball>;
  /** The `any_future_games` field cannot be nested within a list. */
  anyFutureGames: AnyGameInterfaceConnection;
  anyGameStats: Array<Maybe<PlayerGameStats | PlayerGameStatsBaseball | PlayerGameStatsBasketball>>;
  anyGamesForFixture: Array<Game | GameOfBaseball | GameOfBasketball>;
  anyGamesForLeaderboard: Array<Game | GameOfBaseball | GameOfBasketball>;
  /** The `any_past_games` field cannot be nested within a list. */
  anyPastGames: AnyGameInterfaceConnection;
  anyPositions: Array<Position>;
  /** Returns the 3 most followed players in the player's club The `any_related_players` field cannot be nested within a list. */
  anyRelatedPlayers: Array<BaseballPlayer | NBAPlayer | Player>;
  /** The `any_so5_average_last_score` field cannot be nested within a list. */
  anySo5AverageLastScore?: Maybe<AverageLastScore | BaseAverageLastScore>;
  appearances: Scalars['Int']['output'];
  avatarPictureUrl: Scalars['String']['output'];
  averageScore?: Maybe<Scalars['Float']['output']>;
  averageStats?: Maybe<Scalars['Float']['output']>;
  beforeLastOwningMembership?: Maybe<Membership>;
  bestFoot?: Maybe<Scalars['String']['output']>;
  birthDate?: Maybe<Scalars['ISO8601DateTime']['output']>;
  birthDay?: Maybe<Scalars['ISO8601Date']['output']>;
  cardPositions: Array<Position>;
  /** @deprecated Not used anymore */
  cardPrice?: Maybe<Scalars['Int']['output']>;
  /** Cards of this player that are owned by a manager. Updated once a day. */
  cardSupply: Array<CardSeasonSupply>;
  careerSeasons: Array<Season>;
  clubMemberships: Array<Membership>;
  commonPlayer?: Maybe<CommonPlayer>;
  country: Country;
  currentSeason?: Maybe<Season>;
  currentUserSubscription?: Maybe<EmailSubscription>;
  /** @deprecated Use gainOnProjection */
  differenceLastTenAndClassicProjection?: Maybe<Scalars['Float']['output']>;
  /** @deprecated Use gainOnProjection(eventType: DAILY) */
  differenceLastTenAndDailyProjection?: Maybe<Scalars['Float']['output']>;
  displayName: Scalars['String']['output'];
  /** The `eligible_so5_competitions` field cannot be nested within a list. */
  eligibleSo5Competitions: Array<So5Competition>;
  firstName: Scalars['String']['output'];
  fullPictureUrl: Scalars['String']['output'];
  /** The `future_games` field cannot be nested within a list. */
  futureGames: GameConnection;
  /** @deprecated Use gainOnProjection */
  gainOnClassicProjection?: Maybe<Scalars['Float']['output']>;
  /** @deprecated Use gainOnProjection */
  gainOnDailyProjection?: Maybe<Scalars['Float']['output']>;
  gainOnProjection?: Maybe<Scalars['Float']['output']>;
  gameForLeaderboard?: Maybe<Game>;
  gameStats: Array<Maybe<PlayerGameStats>>;
  gameplayTier?: Maybe<GameplayTier>;
  /** The star rating of the player gameplay tier */
  gameplayTierStars?: Maybe<Scalars['Float']['output']>;
  gamesForLeaderboard: Array<Game>;
  hasSo5LineupForFixture: Scalars['Boolean']['output'];
  height?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  injuries: Array<Injury>;
  lastClub?: Maybe<Club>;
  lastFifteenSo5Appearances?: Maybe<Scalars['Int']['output']>;
  lastFiveSo5Appearances?: Maybe<Scalars['Int']['output']>;
  lastFortySo5Appearances?: Maybe<Scalars['Int']['output']>;
  lastName: Scalars['String']['output'];
  /** Get the last 2 cards you own of the player */
  lastOwnedCards: Array<BaseballCard | Card | NBACard>;
  lastTenSo5Appearances?: Maybe<Scalars['Int']['output']>;
  lowestPriceAnyCard?: Maybe<BaseballCard | Card | NBACard>;
  mainCardCollectionSlot?: Maybe<CardCollectionSlot>;
  matchName: Scalars['String']['output'];
  memberships: Array<Membership>;
  mySo5LeaderboardContendersForFixture: Array<So5LeaderboardContender>;
  news: Array<AnyPlayerNewsUpdate>;
  nextClassicFixturePlayingStatusOdds?: Maybe<PlayingStatusOdds>;
  nextClassicFixtureProjectedGrade?: Maybe<PlayerGameScoreProjection>;
  nextClassicFixtureProjectedScore?: Maybe<Scalars['Float']['output']>;
  nextDailyFixtureProjectedGrade?: Maybe<PlayerGameScoreProjection>;
  nextDailyFixtureProjectedScore?: Maybe<Scalars['Float']['output']>;
  nextGame?: Maybe<Game | GameOfBaseball | GameOfBasketball>;
  optaId?: Maybe<Scalars['String']['output']>;
  ownedCardsCount: Scalars['Int']['output'];
  /** The `past_games` field cannot be nested within a list. */
  pastGames: GameConnection;
  pictureUrl?: Maybe<Scalars['String']['output']>;
  playerGameScore?: Maybe<BaseballPlayerGameScore | BasketballPlayerGameScore | PlayerGameScore | So5Score>;
  /** Up to 15 last So5Scores used in a So5Fixture */
  playerGameScores: Array<Maybe<BaseballPlayerGameScore | BasketballPlayerGameScore | PlayerGameScore | So5Score>>;
  playingStatus?: Maybe<PlayerPlayingStatus>;
  position: Position;
  printablePlayer?: Maybe<CommonPlayer>;
  /** The `public_watchlists` field cannot be nested within a list. */
  publicWatchlists?: Maybe<WatchlistConnection>;
  rankingForPositionLeague?: Maybe<Scalars['Int']['output']>;
  /** Up to 15 last So5Scores.score used in a So5Fixture */
  rawPlayerGameScores: Array<Maybe<Scalars['Float']['output']>>;
  /** Up to 10 last So5Scores.score used in a So5Fixture */
  rawSo5Scores: Array<Maybe<Scalars['Float']['output']>>;
  /** Returns the 3 most followed players in the player's club The `related_players` field cannot be nested within a list. */
  relatedPlayers: Array<Player>;
  seasonAppearances?: Maybe<Scalars['Int']['output']>;
  shirtNumber: Scalars['Int']['output'];
  /** @deprecated Not used anymore */
  signedAddCardPrice?: Maybe<SignedCardPrice>;
  signedDropCardPrice?: Maybe<SignedCardPrice>;
  slug: Scalars['String']['output'];
  /** So5Score of a player with his current position for a specific Game */
  so5Score?: Maybe<So5Score>;
  /** Up to 10 last So5Scores used in a So5Fixture */
  so5Scores: Array<Maybe<So5Score>>;
  sport: Sport;
  squaredPictureUrl: Scalars['String']['output'];
  stats?: Maybe<Stats>;
  subscriptionsCount: Scalars['Int']['output'];
  suspensions: Array<Suspension>;
  /** The `token_prices` field cannot be nested within a list. */
  tokenPrices: TokenPriceConnection;
  totalStats?: Maybe<Scalars['Float']['output']>;
  u23Eligible: Scalars['Boolean']['output'];
  u23EligibleUntil?: Maybe<Scalars['ISO8601Date']['output']>;
  user?: Maybe<User>;
  weight?: Maybe<Scalars['Int']['output']>;
}


/** A professional football player */
export interface PlayerallAverageStatsArgs {
  limit?: InputMaybe<AverageLimit>;
  teamMode?: InputMaybe<AverageScoreTeamMode>;
}


/** A professional football player */
export interface PlayerallPlayerGameScoresArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  position?: InputMaybe<Position>;
  to?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
}


/** A professional football player */
export interface PlayerallSo5ScoresArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  position?: InputMaybe<Position>;
}


/** A professional football player */
export interface PlayerallTotalStatsArgs {
  teamMode?: InputMaybe<AverageScoreTeamMode>;
}


/** A professional football player */
export interface PlayeranyCardWithLiveAuctionArgs {
  inSeason?: InputMaybe<Scalars['Boolean']['input']>;
  rarity?: InputMaybe<Rarity>;
}


/** A professional football player */
export interface PlayeranyCardWithLivePrimaryOfferArgs {
  rarity?: InputMaybe<Rarity>;
}


/** A professional football player */
export interface PlayeranyCardsArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  age?: InputMaybe<Scalars['Int']['input']>;
  assetIds?: InputMaybe<Array<Scalars['String']['input']>>;
  before?: InputMaybe<Scalars['String']['input']>;
  classicOnly?: InputMaybe<Scalars['Boolean']['input']>;
  customCardEditionName?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  inActiveCompetitions?: InputMaybe<Array<Scalars['String']['input']>>;
  inSeasonEligible?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  owned?: InputMaybe<Scalars['Boolean']['input']>;
  ownedByMe?: InputMaybe<Scalars['Boolean']['input']>;
  ownedSinceAfter?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  playerSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  positions?: InputMaybe<Array<Position>>;
  rarities?: InputMaybe<Array<Rarity>>;
  revealable?: InputMaybe<Scalars['Boolean']['input']>;
  seasonStartYears?: InputMaybe<Array<Scalars['Int']['input']>>;
  serialNumber?: InputMaybe<Scalars['Int']['input']>;
  shirtNumber?: InputMaybe<Scalars['Int']['input']>;
  slugs?: InputMaybe<Array<Scalars['String']['input']>>;
  sorts?: InputMaybe<Array<CardSort>>;
  sport?: InputMaybe<Sport>;
  teamSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  withinDeckFirst?: InputMaybe<Scalars['String']['input']>;
}


/** A professional football player */
export interface PlayeranyFutureGameStatsArgs {
  first: Scalars['Int']['input'];
  teamMode?: InputMaybe<AverageScoreTeamMode>;
}


/** A professional football player */
export interface PlayeranyFutureGamesArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  so5FixtureEligible?: InputMaybe<Scalars['Boolean']['input']>;
}


/** A professional football player */
export interface PlayeranyGameStatsArgs {
  last: Scalars['Int']['input'];
  lowCoverage?: InputMaybe<Scalars['Boolean']['input']>;
  so5FixtureSlug?: InputMaybe<Scalars['String']['input']>;
  teamMode?: InputMaybe<AverageScoreTeamMode>;
}


/** A professional football player */
export interface PlayeranyGamesForFixtureArgs {
  so5FixtureSlug: Scalars['String']['input'];
}


/** A professional football player */
export interface PlayeranyGamesForLeaderboardArgs {
  so5LeaderboardSlug: Scalars['String']['input'];
}


/** A professional football player */
export interface PlayeranyPastGamesArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
}


/** A professional football player */
export interface PlayeranySo5AverageLastScoreArgs {
  competitionSlug?: InputMaybe<Scalars['String']['input']>;
  location?: InputMaybe<AverageLastScoreLocation>;
  position: Position;
  span: AverageLastScoreSpan;
  teamSlug?: InputMaybe<Scalars['String']['input']>;
}


/** A professional football player */
export interface PlayeraverageScoreArgs {
  position?: InputMaybe<Position>;
  teamMode?: InputMaybe<AverageScoreTeamMode>;
  type: AveragePlayerScore;
}


/** A professional football player */
export interface PlayeraverageStatsArgs {
  limit: AverageLimit;
  type: AverageStat;
}


/** A professional football player */
export interface PlayercardPriceArgs {
  rarity: Rarity;
}


/** A professional football player */
export interface PlayercareerSeasonsArgs {
  type?: InputMaybe<CompetitionType>;
}


/** A professional football player */
export interface PlayercommonPlayerArgs {
  rarity: Rarity;
}


/** A professional football player */
export interface PlayerfutureGamesArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
}


/** A professional football player */
export interface PlayergainOnProjectionArgs {
  eventType?: InputMaybe<So5FixtureEvent>;
}


/** A professional football player */
export interface PlayergameForLeaderboardArgs {
  so5LeaderboardSlug: Scalars['String']['input'];
}


/** A professional football player */
export interface PlayergameStatsArgs {
  last: Scalars['Int']['input'];
  lowCoverage?: InputMaybe<Scalars['Boolean']['input']>;
}


/** A professional football player */
export interface PlayergamesForLeaderboardArgs {
  so5LeaderboardSlug: Scalars['String']['input'];
}


/** A professional football player */
export interface PlayerhasSo5LineupForFixtureArgs {
  so5FixtureSlug: Scalars['String']['input'];
}


/** A professional football player */
export interface PlayerlastFifteenSo5AppearancesArgs {
  teamMode?: InputMaybe<AverageScoreTeamMode>;
}


/** A professional football player */
export interface PlayerlastFiveSo5AppearancesArgs {
  teamMode?: InputMaybe<AverageScoreTeamMode>;
}


/** A professional football player */
export interface PlayerlastFortySo5AppearancesArgs {
  teamMode?: InputMaybe<AverageScoreTeamMode>;
}


/** A professional football player */
export interface PlayerlastOwnedCardsArgs {
  inSeasonEligible?: InputMaybe<Scalars['Boolean']['input']>;
  rarities?: InputMaybe<Array<Rarity>>;
}


/** A professional football player */
export interface PlayerlastTenSo5AppearancesArgs {
  teamMode?: InputMaybe<AverageScoreTeamMode>;
}


/** A professional football player */
export interface PlayerlowestPriceAnyCardArgs {
  inSeason?: InputMaybe<Scalars['Boolean']['input']>;
  rarity?: InputMaybe<Rarity>;
}


/** A professional football player */
export interface PlayermainCardCollectionSlotArgs {
  rarity: Rarity;
}


/** A professional football player */
export interface PlayermySo5LeaderboardContendersForFixtureArgs {
  so5FixtureSlug: Scalars['String']['input'];
}


/** A professional football player */
export interface PlayernewsArgs {
  last: Scalars['Int']['input'];
}


/** A professional football player */
export interface PlayernextGameArgs {
  so5FixtureEligible?: InputMaybe<Scalars['Boolean']['input']>;
}


/** A professional football player */
export interface PlayerownedCardsCountArgs {
  rarities?: InputMaybe<Array<Rarity>>;
  rarity?: InputMaybe<Rarity>;
  seasonEligibility?: InputMaybe<SeasonEligibility>;
}


/** A professional football player */
export interface PlayerpastGamesArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
}


/** A professional football player */
export interface PlayerpictureUrlArgs {
  derivative?: InputMaybe<Scalars['String']['input']>;
}


/** A professional football player */
export interface PlayerplayerGameScoreArgs {
  gameId: Scalars['ID']['input'];
  position?: InputMaybe<Position>;
}


/** A professional football player */
export interface PlayerplayerGameScoresArgs {
  last: Scalars['Int']['input'];
  lowCoverage?: InputMaybe<Scalars['Boolean']['input']>;
  position?: InputMaybe<Position>;
}


/** A professional football player */
export interface PlayerpublicWatchlistsArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
}


/** A professional football player */
export interface PlayerrawPlayerGameScoresArgs {
  last: Scalars['Int']['input'];
  lowCoverage?: InputMaybe<Scalars['Boolean']['input']>;
  position?: InputMaybe<Position>;
}


/** A professional football player */
export interface PlayerrawSo5ScoresArgs {
  last: Scalars['Int']['input'];
  lowCoverage?: InputMaybe<Scalars['Boolean']['input']>;
  position?: InputMaybe<Position>;
}


/** A professional football player */
export interface PlayerseasonAppearancesArgs {
  teamMode?: InputMaybe<AverageScoreTeamMode>;
}


/** A professional football player */
export interface PlayersignedAddCardPriceArgs {
  rarity: Rarity;
}


/** A professional football player */
export interface PlayersignedDropCardPriceArgs {
  rarity: Rarity;
}


/** A professional football player */
export interface Playerso5ScoreArgs {
  gameId: Scalars['ID']['input'];
  position?: InputMaybe<Position>;
}


/** A professional football player */
export interface Playerso5ScoresArgs {
  last: Scalars['Int']['input'];
  lowCoverage?: InputMaybe<Scalars['Boolean']['input']>;
  position?: InputMaybe<Position>;
}


/** A professional football player */
export interface PlayerstatsArgs {
  seasonStartYear: Scalars['Int']['input'];
}


/** A professional football player */
export interface PlayertokenPricesArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  includePrivateSales?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  rarity: Rarity;
  season?: InputMaybe<Scalars['Int']['input']>;
  seasonEligibility?: InputMaybe<SeasonEligibility>;
  since?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
}


/** A professional football player */
export interface PlayertotalStatsArgs {
  type: AverageStat;
}

/** The connection type for Player. */
export interface PlayerConnection {
  __typename: 'PlayerConnection';
  /** A list of edges. */
  edges: Array<PlayerEdge>;
  /** A list of nodes. */
  nodes: Array<Player>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
}

/** An edge in a connection. */
export interface PlayerEdge {
  __typename: 'PlayerEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<Player>;
}

export const PlayerFieldStatus = {
  /** The player is not on the game sheet */
  NOT_ON_GAME_SHEET: 'NOT_ON_GAME_SHEET',
  /** The player is on the bench */
  ON_BENCH: 'ON_BENCH',
  /** The player is on the field */
  ON_FIELD: 'ON_FIELD',
  /** The player has been substituted */
  SUBSTITUTED: 'SUBSTITUTED',
  /** No information */
  UNKNOWN: 'UNKNOWN'
} as const;

export type PlayerFieldStatus = typeof PlayerFieldStatus[keyof typeof PlayerFieldStatus];
/** A football player game score */
export interface PlayerGameScore extends Node, PlayerGameScoreInterface {
  __typename: 'PlayerGameScore';
  activeSuspensions: Array<Suspension>;
  allAroundScore: Scalars['Float']['output'];
  allAroundStats: Array<StatScore>;
  anyGame: Game | GameOfBaseball | GameOfBasketball;
  anyPlayer: BaseballPlayer | NBAPlayer | Player;
  anyPlayerGameStats: PlayerGameStats | PlayerGameStatsBaseball | PlayerGameStatsBasketball;
  averageScore?: Maybe<Scalars['Float']['output']>;
  decisiveScore?: Maybe<StatScore>;
  detailedScore: Array<StatScore>;
  footballGame: Game;
  footballPlayer: Player;
  footballPlayerGameStats: PlayerGameStats;
  id: Scalars['ID']['output'];
  negativeDecisiveStats: Array<StatScore>;
  position: Scalars['String']['output'];
  positionTyped: Position;
  positiveDecisiveStats: Array<StatScore>;
  projectedScore: Scalars['Float']['output'];
  projection?: Maybe<PlayerGameScoreProjection>;
  score: Scalars['Float']['output'];
  scoreStatus: ScoreStatus;
  scoringVersion: Scalars['Int']['output'];
}


/** A football player game score */
export interface PlayerGameScoreaverageScoreArgs {
  type: AveragePlayerScore;
}

/** Player game score */
export interface PlayerGameScoreInterface {
  activeSuspensions: Array<Suspension>;
  anyGame: Game | GameOfBaseball | GameOfBasketball;
  anyPlayer: BaseballPlayer | NBAPlayer | Player;
  anyPlayerGameStats: PlayerGameStats | PlayerGameStatsBaseball | PlayerGameStatsBasketball;
  averageScore?: Maybe<Scalars['Float']['output']>;
  detailedScore: Array<StatScore>;
  id: Scalars['ID']['output'];
  position: Scalars['String']['output'];
  positionTyped: Position;
  projectedScore: Scalars['Float']['output'];
  projection?: Maybe<PlayerGameScoreProjection>;
  score: Scalars['Float']['output'];
  scoreStatus: ScoreStatus;
  scoringVersion: Scalars['Int']['output'];
}


/** Player game score */
export interface PlayerGameScoreInterfaceaverageScoreArgs {
  type: AveragePlayerScore;
}

/** The connection type for PlayerGameScoreInterface. */
export interface PlayerGameScoreInterfaceConnection {
  __typename: 'PlayerGameScoreInterfaceConnection';
  /** A list of edges. */
  edges: Array<PlayerGameScoreInterfaceEdge>;
  /** A list of nodes. */
  nodes: Array<BaseballPlayerGameScore | BasketballPlayerGameScore | PlayerGameScore | So5Score>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
}

/** An edge in a connection. */
export interface PlayerGameScoreInterfaceEdge {
  __typename: 'PlayerGameScoreInterfaceEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<BaseballPlayerGameScore | BasketballPlayerGameScore | PlayerGameScore | So5Score>;
}

/** Projection of a player game score */
export interface PlayerGameScoreProjection {
  __typename: 'PlayerGameScoreProjection';
  grade: PlayerGameScoreProjectionGrade;
  id: Scalars['ID']['output'];
  reliabilityBasisPoints: Scalars['Int']['output'];
  score: Scalars['Float']['output'];
}

export const PlayerGameScoreProjectionGrade = {
  A: 'A',
  B: 'B',
  C: 'C',
  D: 'D',
  E: 'E',
  F: 'F'
} as const;

export type PlayerGameScoreProjectionGrade = typeof PlayerGameScoreProjectionGrade[keyof typeof PlayerGameScoreProjectionGrade];
/** Stats of a player for a game */
export interface PlayerGameStats extends AnyPlayerGameStatsInterface, Node {
  __typename: 'PlayerGameStats';
  accurateKeeperSweeper?: Maybe<Scalars['Int']['output']>;
  accurateLongBalls?: Maybe<Scalars['Int']['output']>;
  accuratePass?: Maybe<Scalars['Int']['output']>;
  anyGame: Game | GameOfBaseball | GameOfBasketball;
  anyPlayer: BaseballPlayer | NBAPlayer | Player;
  anyTeam: Club | NationalTeam;
  assistPenaltyWon?: Maybe<Scalars['Int']['output']>;
  attFreekickTotal?: Maybe<Scalars['Int']['output']>;
  attPenGoal?: Maybe<Scalars['Int']['output']>;
  attPenMiss?: Maybe<Scalars['Int']['output']>;
  attPenPost?: Maybe<Scalars['Int']['output']>;
  attPenTarget?: Maybe<Scalars['Int']['output']>;
  bigChanceCreated?: Maybe<Scalars['Int']['output']>;
  bigChanceMissed?: Maybe<Scalars['Int']['output']>;
  cleanSheet?: Maybe<Scalars['Int']['output']>;
  cleanSheet60?: Maybe<Scalars['Int']['output']>;
  clearanceOffLine?: Maybe<Scalars['Int']['output']>;
  cornerTaken?: Maybe<Scalars['Int']['output']>;
  crossAccuracy?: Maybe<Scalars['Int']['output']>;
  crossNotClaimed?: Maybe<Scalars['Int']['output']>;
  diveCatch?: Maybe<Scalars['Int']['output']>;
  diveSave?: Maybe<Scalars['Int']['output']>;
  duelLost?: Maybe<Scalars['Int']['output']>;
  duelWon?: Maybe<Scalars['Int']['output']>;
  effectiveClearance?: Maybe<Scalars['Int']['output']>;
  errorLeadToGoal?: Maybe<Scalars['Int']['output']>;
  errorLeadToShot?: Maybe<Scalars['Int']['output']>;
  fieldStatus: PlayerFieldStatus;
  footballGame: Game;
  footballPlayer: Player;
  footballPlayerGameScore?: Maybe<PlayerGameScore>;
  /**
   * Playing status odds are provided by SorareInside and are only available within
   * Sorare products. Contact them if you are interested in fetching this data.
   */
  footballPlayingStatusOdds?: Maybe<PlayingStatusOdds>;
  formationPlace?: Maybe<Scalars['Int']['output']>;
  fouls?: Maybe<Scalars['Int']['output']>;
  freekickCross?: Maybe<Scalars['Int']['output']>;
  game: Game;
  gameStarted?: Maybe<Scalars['Int']['output']>;
  gkSmother?: Maybe<Scalars['Int']['output']>;
  goalAssist?: Maybe<Scalars['Int']['output']>;
  goalKicks?: Maybe<Scalars['Int']['output']>;
  goals?: Maybe<Scalars['Int']['output']>;
  goalsConceded?: Maybe<Scalars['Int']['output']>;
  goodHighClaim?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  interceptionWon?: Maybe<Scalars['Int']['output']>;
  lastManTackle?: Maybe<Scalars['Int']['output']>;
  live: Scalars['Boolean']['output'];
  lostCorners?: Maybe<Scalars['Int']['output']>;
  minsPlayed?: Maybe<Scalars['Int']['output']>;
  missedPass?: Maybe<Scalars['Int']['output']>;
  myBestSo5Appearance?: Maybe<So5Appearance>;
  onGameSheet: Scalars['Boolean']['output'];
  ontargetScoringAtt?: Maybe<Scalars['Int']['output']>;
  ownGoals?: Maybe<Scalars['Int']['output']>;
  parries?: Maybe<Scalars['Int']['output']>;
  passAccuracy?: Maybe<Scalars['Int']['output']>;
  penAreaEntries?: Maybe<Scalars['Int']['output']>;
  penaltiesSaved?: Maybe<Scalars['Int']['output']>;
  penaltyConceded?: Maybe<Scalars['Int']['output']>;
  penaltyKickMissed?: Maybe<Scalars['Int']['output']>;
  penaltySave?: Maybe<Scalars['Int']['output']>;
  penaltyTaken: Scalars['Int']['output'];
  penaltyWon?: Maybe<Scalars['Int']['output']>;
  playedInGame: Scalars['Boolean']['output'];
  /** Whether the current user aligned a card for this player game in any lineup (So5 or task) */
  playedInLineup: Scalars['Boolean']['output'];
  player: Player;
  playerGameScore?: Maybe<BaseballPlayerGameScore | BasketballPlayerGameScore | PlayerGameScore | So5Score>;
  possLostCtrl?: Maybe<Scalars['Int']['output']>;
  possWon?: Maybe<Scalars['Int']['output']>;
  punches?: Maybe<Scalars['Int']['output']>;
  redCard?: Maybe<Scalars['Int']['output']>;
  reviewed: Scalars['Boolean']['output'];
  savedIbox?: Maybe<Scalars['Int']['output']>;
  saves?: Maybe<Scalars['Int']['output']>;
  setPieceTaken: Scalars['Int']['output'];
  shotAccuracy?: Maybe<Scalars['Int']['output']>;
  shotEfficiency?: Maybe<Scalars['Int']['output']>;
  singleGoalGame?: Maybe<Scalars['Int']['output']>;
  sixSecondViolation?: Maybe<Scalars['Int']['output']>;
  so5Score?: Maybe<So5Score>;
  successfulFinalThirdPasses?: Maybe<Scalars['Int']['output']>;
  threeGoalsConceded?: Maybe<Scalars['Int']['output']>;
  totalClearance?: Maybe<Scalars['Int']['output']>;
  totalPass?: Maybe<Scalars['Int']['output']>;
  totalScoringAtt?: Maybe<Scalars['Int']['output']>;
  totalTackle?: Maybe<Scalars['Int']['output']>;
  wasFouled?: Maybe<Scalars['Int']['output']>;
  wonContest?: Maybe<Scalars['Int']['output']>;
  wonTackle?: Maybe<Scalars['Int']['output']>;
  yellowCard?: Maybe<Scalars['Int']['output']>;
}


/** Stats of a player for a game */
export interface PlayerGameStatsfootballPlayerGameScoreArgs {
  position?: InputMaybe<Scalars['String']['input']>;
}


/** Stats of a player for a game */
export interface PlayerGameStatsfootballPlayingStatusOddsArgs {
  newVersion?: InputMaybe<Scalars['Boolean']['input']>;
}


/** Stats of a player for a game */
export interface PlayerGameStatsplayerGameScoreArgs {
  position?: InputMaybe<Scalars['String']['input']>;
}


/** Stats of a player for a game */
export interface PlayerGameStatsso5ScoreArgs {
  position?: InputMaybe<Scalars['String']['input']>;
}

/** Stats of a player for a game */
export interface PlayerGameStatsBaseball extends AnyPlayerGameStatsInterface, Node {
  __typename: 'PlayerGameStatsBaseball';
  anyGame: Game | GameOfBaseball | GameOfBasketball;
  anyPlayer: BaseballPlayer | NBAPlayer | Player;
  anyTeam: Club | NationalTeam;
  baseballGame: GameOfBaseball;
  baseballPlayer: BaseballPlayer;
  baseballPlayerGameScore?: Maybe<BaseballPlayerGameScore>;
  hittingAtBase?: Maybe<Scalars['Int']['output']>;
  hittingAtPlate?: Maybe<Scalars['Int']['output']>;
  hittingCaughtStealing?: Maybe<Scalars['Int']['output']>;
  hittingDoubles?: Maybe<Scalars['Int']['output']>;
  hittingHitByPitch?: Maybe<Scalars['Int']['output']>;
  hittingHomeRuns?: Maybe<Scalars['Int']['output']>;
  hittingRuns?: Maybe<Scalars['Int']['output']>;
  hittingRunsBattedIn?: Maybe<Scalars['Int']['output']>;
  hittingSingles?: Maybe<Scalars['Int']['output']>;
  hittingStolenBases?: Maybe<Scalars['Int']['output']>;
  hittingStrikeouts?: Maybe<Scalars['Int']['output']>;
  hittingTriples?: Maybe<Scalars['Int']['output']>;
  hittingWalks?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  live: Scalars['Boolean']['output'];
  myBestSo5Appearance?: Maybe<So5Appearance>;
  onGameSheet: Scalars['Boolean']['output'];
  pitchingEarnedRuns?: Maybe<Scalars['Int']['output']>;
  pitchingHitBatsmen?: Maybe<Scalars['Int']['output']>;
  pitchingHitsAllowed?: Maybe<Scalars['Int']['output']>;
  pitchingHolds?: Maybe<Scalars['Int']['output']>;
  pitchingInningsPitched?: Maybe<Scalars['Int']['output']>;
  pitchingNoHitters?: Maybe<Scalars['Int']['output']>;
  pitchingPitchCount?: Maybe<Scalars['Int']['output']>;
  pitchingReliefAppearance?: Maybe<Scalars['Int']['output']>;
  pitchingSaves?: Maybe<Scalars['Int']['output']>;
  pitchingStrikeouts?: Maybe<Scalars['Int']['output']>;
  pitchingWalks?: Maybe<Scalars['Int']['output']>;
  pitchingWins?: Maybe<Scalars['Int']['output']>;
  playedInGame: Scalars['Boolean']['output'];
  /** Whether the current user aligned a card for this player game in any lineup (So5 or task) */
  playedInLineup: Scalars['Boolean']['output'];
  playerGameScore?: Maybe<BaseballPlayerGameScore | BasketballPlayerGameScore | PlayerGameScore | So5Score>;
  probablePitcher: Scalars['Boolean']['output'];
  projectedHittingAtBase?: Maybe<Scalars['Float']['output']>;
  projectedHittingAtPlate?: Maybe<Scalars['Float']['output']>;
  projectedHittingCaughtStealing?: Maybe<Scalars['Float']['output']>;
  projectedHittingDoubles?: Maybe<Scalars['Float']['output']>;
  projectedHittingHitByPitch?: Maybe<Scalars['Float']['output']>;
  projectedHittingHomeRuns?: Maybe<Scalars['Float']['output']>;
  projectedHittingRuns?: Maybe<Scalars['Float']['output']>;
  projectedHittingRunsBattedIn?: Maybe<Scalars['Float']['output']>;
  projectedHittingSingles?: Maybe<Scalars['Float']['output']>;
  projectedHittingStolenBases?: Maybe<Scalars['Float']['output']>;
  projectedHittingStrikeouts?: Maybe<Scalars['Float']['output']>;
  projectedHittingTriples?: Maybe<Scalars['Float']['output']>;
  projectedHittingWalks?: Maybe<Scalars['Float']['output']>;
  projectedPitchingEarnedRuns?: Maybe<Scalars['Float']['output']>;
  projectedPitchingHitBatsmen?: Maybe<Scalars['Float']['output']>;
  projectedPitchingHitsAllowed?: Maybe<Scalars['Float']['output']>;
  projectedPitchingHolds?: Maybe<Scalars['Float']['output']>;
  projectedPitchingInningsPitched?: Maybe<Scalars['Float']['output']>;
  projectedPitchingNoHitters?: Maybe<Scalars['Float']['output']>;
  projectedPitchingPitchCount?: Maybe<Scalars['Float']['output']>;
  projectedPitchingReliefAppearance?: Maybe<Scalars['Float']['output']>;
  projectedPitchingSaves?: Maybe<Scalars['Float']['output']>;
  projectedPitchingStrikeouts?: Maybe<Scalars['Float']['output']>;
  projectedPitchingWalks?: Maybe<Scalars['Float']['output']>;
  projectedPitchingWins?: Maybe<Scalars['Float']['output']>;
  projectedStat?: Maybe<Scalars['Float']['output']>;
  reviewed: Scalars['Boolean']['output'];
}


/** Stats of a player for a game */
export interface PlayerGameStatsBaseballbaseballPlayerGameScoreArgs {
  position?: InputMaybe<Scalars['String']['input']>;
}


/** Stats of a player for a game */
export interface PlayerGameStatsBaseballplayerGameScoreArgs {
  position?: InputMaybe<Scalars['String']['input']>;
}


/** Stats of a player for a game */
export interface PlayerGameStatsBaseballprojectedStatArgs {
  stat: BaseballAverageStatType;
}

/** Stats of a player for a game */
export interface PlayerGameStatsBasketball extends AnyPlayerGameStatsInterface, Node {
  __typename: 'PlayerGameStatsBasketball';
  anyGame: Game | GameOfBaseball | GameOfBasketball;
  anyPlayer: BaseballPlayer | NBAPlayer | Player;
  anyTeam: Club | NationalTeam;
  assists?: Maybe<Scalars['Int']['output']>;
  basketballGame: GameOfBasketball;
  basketballPlayer: NBAPlayer;
  basketballPlayerGameScore?: Maybe<BasketballPlayerGameScore>;
  blocks?: Maybe<Scalars['Int']['output']>;
  doubleDouble?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  live: Scalars['Boolean']['output'];
  minsPlayed?: Maybe<Scalars['Int']['output']>;
  myBestSo5Appearance?: Maybe<So5Appearance>;
  onGameSheet: Scalars['Boolean']['output'];
  playedInGame: Scalars['Boolean']['output'];
  /** Whether the current user aligned a card for this player game in any lineup (So5 or task) */
  playedInLineup: Scalars['Boolean']['output'];
  playerGameScore?: Maybe<BaseballPlayerGameScore | BasketballPlayerGameScore | PlayerGameScore | So5Score>;
  points?: Maybe<Scalars['Int']['output']>;
  projectedAssists?: Maybe<Scalars['Float']['output']>;
  projectedBlocks?: Maybe<Scalars['Float']['output']>;
  projectedDoubleDouble?: Maybe<Scalars['Float']['output']>;
  projectedMinsPlayed?: Maybe<Scalars['Float']['output']>;
  projectedPoints?: Maybe<Scalars['Float']['output']>;
  projectedRebounds?: Maybe<Scalars['Float']['output']>;
  projectedStat?: Maybe<Scalars['Float']['output']>;
  projectedSteals?: Maybe<Scalars['Float']['output']>;
  projectedThreePointsMade?: Maybe<Scalars['Float']['output']>;
  projectedTripleDouble?: Maybe<Scalars['Float']['output']>;
  projectedTurnovers?: Maybe<Scalars['Float']['output']>;
  rebounds?: Maybe<Scalars['Int']['output']>;
  reviewed: Scalars['Boolean']['output'];
  steals?: Maybe<Scalars['Int']['output']>;
  threePointsMade?: Maybe<Scalars['Int']['output']>;
  tripleDouble?: Maybe<Scalars['Int']['output']>;
  turnovers?: Maybe<Scalars['Int']['output']>;
}


/** Stats of a player for a game */
export interface PlayerGameStatsBasketballbasketballPlayerGameScoreArgs {
  position?: InputMaybe<Scalars['String']['input']>;
}


/** Stats of a player for a game */
export interface PlayerGameStatsBasketballplayerGameScoreArgs {
  position?: InputMaybe<Scalars['String']['input']>;
}


/** Stats of a player for a game */
export interface PlayerGameStatsBasketballprojectedStatArgs {
  stat: BasketballAverageStatType;
}

export interface PlayerHeightRule extends So5RuleInterface {
  __typename: 'PlayerHeightRule';
  boundaries?: Maybe<ValueOpenBoundaries>;
  descriptions: Array<So5RuleDescription>;
  id: Scalars['String']['output'];
  key: Scalars['String']['output'];
  maxHeight?: Maybe<Scalars['Int']['output']>;
  minHeight?: Maybe<Scalars['Int']['output']>;
}

export const PlayerPlayingStatus = {
  NOT_PLAYING: 'NOT_PLAYING',
  REGULAR: 'REGULAR',
  RETIRED: 'RETIRED',
  STARTER: 'STARTER',
  SUBSTITUTE: 'SUBSTITUTE',
  SUPER_SUBSTITUTE: 'SUPER_SUBSTITUTE'
} as const;

export type PlayerPlayingStatus = typeof PlayerPlayingStatus[keyof typeof PlayerPlayingStatus];
/** Recommended cards for a manager */
export interface PlayerRecommendation extends Node {
  __typename: 'PlayerRecommendation';
  anyCardWithLivePrimaryOffer?: Maybe<BaseballCard | Card | NBACard>;
  anyPlayer: BaseballPlayer | NBAPlayer | Player;
  id: Scalars['ID']['output'];
  lowestPriceAnyCard?: Maybe<BaseballCard | Card | NBACard>;
  playerSlug: Scalars['String']['output'];
  ranking: Scalars['Int']['output'];
  sport: Sport;
}


/** Recommended cards for a manager */
export interface PlayerRecommendationanyCardWithLivePrimaryOfferArgs {
  rarity?: InputMaybe<Rarity>;
}


/** Recommended cards for a manager */
export interface PlayerRecommendationlowestPriceAnyCardArgs {
  inSeason?: InputMaybe<Scalars['Boolean']['input']>;
  rarity?: InputMaybe<Rarity>;
}

/** A professional football player with current season supply */
export interface PlayerWithSupply {
  __typename: 'PlayerWithSupply';
  anyPlayer: BaseballPlayer | NBAPlayer | Player;
  availableSupply?: Maybe<Scalars['Int']['output']>;
  slug: Scalars['String']['output'];
}

/** Playing status odds of a player for a game */
export interface PlayingStatusOdds {
  __typename: 'PlayingStatusOdds';
  nonPlayingOddsBasisPoints: Scalars['Int']['output'];
  providerIconUrl: Scalars['String']['output'];
  providerRedirectUrl: Scalars['String']['output'];
  reliability: OrdinalRatingEnum;
  starterOddsBasisPoints: Scalars['Int']['output'];
  substituteOddsBasisPoints: Scalars['Int']['output'];
}

/** JONUM playtime period usage */
export interface PlaytimeUsage {
  __typename: 'PlaytimeUsage';
  limitMinutes?: Maybe<Scalars['Float']['output']>;
  pendingLimitChange?: Maybe<PendingPlaytimeLimit>;
  periodResetsAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  usedMinutes: Scalars['Float']['output'];
}

/** A pool key share */
export interface PoolKeyShardsCount {
  __typename: 'PoolKeyShardsCount';
  count: Scalars['Int']['output'];
  displayName: Scalars['String']['output'];
  iconUrl?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  logoUrl?: Maybe<Scalars['String']['output']>;
  slug: Scalars['String']['output'];
  so5League?: Maybe<So5League>;
}

export const PopularSortingOption = {
  ALPHABETICAL: 'ALPHABETICAL',
  POPULARITY: 'POPULARITY'
} as const;

export type PopularSortingOption = typeof PopularSortingOption[keyof typeof PopularSortingOption];
export const Position = {
  Coach: 'Coach',
  Defender: 'Defender',
  Forward: 'Forward',
  Goalkeeper: 'Goalkeeper',
  Midfielder: 'Midfielder',
  Unknown: 'Unknown',
  baseball_catcher: 'baseball_catcher',
  baseball_designated_hitter: 'baseball_designated_hitter',
  baseball_first_base: 'baseball_first_base',
  baseball_outfield: 'baseball_outfield',
  baseball_relief_pitcher: 'baseball_relief_pitcher',
  baseball_second_base: 'baseball_second_base',
  baseball_shortstop: 'baseball_shortstop',
  baseball_starting_pitcher: 'baseball_starting_pitcher',
  baseball_third_base: 'baseball_third_base',
  basketball_center: 'basketball_center',
  basketball_forward: 'basketball_forward',
  basketball_guard: 'basketball_guard'
} as const;

export type Position = typeof Position[keyof typeof Position];
/** An amount in cents or wei and its currency. Amount must be strictly positive. */
export interface PositiveAmountInput {
  amount: Scalars['String']['input'];
  currency: SupportedCurrency;
}

export const PostSnapshotCompletionProbability = {
  IMPOSSIBLE: 'IMPOSSIBLE',
  POSSIBLE: 'POSSIBLE',
  UNLIKELY: 'UNLIKELY'
} as const;

export type PostSnapshotCompletionProbability = typeof PostSnapshotCompletionProbability[keyof typeof PostSnapshotCompletionProbability];
/** A Sorare user postal address */
export interface PostalAddress {
  __typename: 'PostalAddress';
  additionalAddress?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  company?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Country>;
  countryCode?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  region?: Maybe<Scalars['String']['output']>;
  streetAddress?: Maybe<Scalars['String']['output']>;
  zipcode?: Maybe<Scalars['String']['output']>;
}

export interface PostalAddressInput {
  additionalAddress?: InputMaybe<Scalars['String']['input']>;
  city: Scalars['String']['input'];
  company?: InputMaybe<Scalars['String']['input']>;
  countryCode: Scalars['String']['input'];
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  streetAddress: Scalars['String']['input'];
  zipcode: Scalars['String']['input'];
}

export interface PotentialDiscountBreakdown {
  __typename: 'PotentialDiscountBreakdown';
  conversionCredit: ConversionCredit;
  discountAmount: Scalars['String']['output'];
}

/** An object representing the breakdown of the power of a Card */
export interface PowerBreakdown {
  __typename: 'PowerBreakdown';
  activeClubsBasisPoints: Scalars['Int']['output'];
  averageScoresBasisPoints: Scalars['Int']['output'];
  boost: Scalars['String']['output'];
  boostBasisPoints: Scalars['Int']['output'];
  captain: Scalars['String']['output'];
  captainBasisPoints: Scalars['Int']['output'];
  collection: Scalars['String']['output'];
  collectionBasisPoints: Scalars['Int']['output'];
  differentNationalitiesBasisPoints: Scalars['Int']['output'];
  fidelity: Scalars['String']['output'];
  fidelityBasisPoints: Scalars['Int']['output'];
  lineup: Scalars['String']['output'];
  lineupBasisPoints: Scalars['Int']['output'];
  malusAfterTransferBasisPoints: Scalars['Int']['output'];
  nationalityBasisPoints: Scalars['Int']['output'];
  /** legacy bonuses are stored in this field */
  otherBonusBasisPoints: Scalars['Int']['output'];
  playerBasisPoints: Scalars['Int']['output'];
  positionStacksBasisPoints: Scalars['Int']['output'];
  positionsBasisPoints: Scalars['Int']['output'];
  sameActiveClubBasisPoints: Scalars['Int']['output'];
  scarcity: Scalars['String']['output'];
  scarcityBasisPoints: Scalars['Int']['output'];
  season: Scalars['String']['output'];
  seasonBasisPoints: Scalars['Int']['output'];
  /** @deprecated Use specialEditionCardsBasisPoints instead */
  specialEditionCardBasisPoints: Scalars['Int']['output'];
  specialEditionCardsBasisPoints: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
  xp: Scalars['String']['output'];
  xpBasisPoints: Scalars['Int']['output'];
}

export type PowerBreakdownOrPowerPointsBreakdown = PowerBreakdown | PowerPointsBreakdown;

/** An object representing the breakdown of the gain power of an appearance */
export interface PowerPointsBreakdown {
  __typename: 'PowerPointsBreakdown';
  activeClubsPoints: Scalars['Float']['output'];
  averageScoresPoints: Scalars['Float']['output'];
  boostPoints: Scalars['Float']['output'];
  captainPoints: Scalars['Float']['output'];
  collectionPoints: Scalars['Float']['output'];
  differentNationalitiesPoints: Scalars['Float']['output'];
  lineupPoints: Scalars['Float']['output'];
  malusAfterTransferPoints: Scalars['Float']['output'];
  nationalityPoints: Scalars['Float']['output'];
  playerPoints: Scalars['Float']['output'];
  positionStacksPoints: Scalars['Float']['output'];
  positionsPoints: Scalars['Float']['output'];
  sameActiveClubPoints: Scalars['Float']['output'];
  scarcityPoints: Scalars['Float']['output'];
  seasonPoints: Scalars['Float']['output'];
  specialEditionCardPoints: Scalars['Float']['output'];
  specialEditionCardsPoints: Scalars['Float']['output'];
  xpPoints: Scalars['Float']['output'];
}

/** A Mangopay Pre Registration Data */
export interface PreRegistrationData {
  __typename: 'PreRegistrationData';
  accessKey: Scalars['String']['output'];
  cardRegistrationUrl: Scalars['String']['output'];
  data: Scalars['String']['output'];
  id: Scalars['String']['output'];
}

export const PreferredSide = {
  BOTH: 'BOTH',
  LEFT: 'LEFT',
  RIGHT: 'RIGHT'
} as const;

export type PreferredSide = typeof PreferredSide[keyof typeof PreferredSide];
export interface PrimaryOfferSource extends HistoryTransactionInterface {
  __typename: 'PrimaryOfferSource';
  date: Scalars['ISO8601DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  label: Scalars['String']['output'];
  logoUrl?: Maybe<Scalars['String']['output']>;
  quantityByFlavour: Array<PoolKeyShardsCount>;
  totalQuantity: Scalars['Int']['output'];
}

export interface PrintablePlayerSource extends HistoryTransactionInterface {
  __typename: 'PrintablePlayerSource';
  date: Scalars['ISO8601DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  label: Scalars['String']['output'];
  logoUrl?: Maybe<Scalars['String']['output']>;
  quantityByFlavour: Array<PoolKeyShardsCount>;
  totalQuantity: Scalars['Int']['output'];
}

/** An Account */
export interface PrivateAccount extends Node {
  __typename: 'PrivateAccount';
  account: Account;
  accountable: PrivateAccountable;
  id: Scalars['ID']['output'];
}

/** Object that can be an account accountable */
export type PrivateAccountable = PrivateEmptyAccount | PrivateFiatWalletAccount | StarkwarePrivateAccount;

/** An Account with no private info */
export interface PrivateEmptyAccount extends Node {
  __typename: 'PrivateEmptyAccount';
  id: Scalars['ID']['output'];
}

/** A Fiat Wallet Account */
export interface PrivateFiatWalletAccount extends Node {
  __typename: 'PrivateFiatWalletAccount';
  /** Whether a residential address must be submitted with createDepositBankAccountMutation */
  addressRequired: Scalars['Boolean']['output'];
  availableBalance: Scalars['Int']['output'];
  countryOfResidence?: Maybe<Scalars['String']['output']>;
  countryOfResidenceCode?: Maybe<Scalars['String']['output']>;
  depositBankAccount?: Maybe<BankAccount>;
  dob?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  kycRefusedReason?: Maybe<FiatWalletKycRefusedReason>;
  kycStatus?: Maybe<FiatWalletKycState>;
  lastName?: Maybe<Scalars['String']['output']>;
  nationality?: Maybe<Scalars['String']['output']>;
  nationalityCode?: Maybe<Scalars['String']['output']>;
  publicInfo: FiatWalletAccount;
  state: FiatWalletAccountState;
  totalBalance: Scalars['Int']['output'];
  withdrawalBankAccounts?: Maybe<BankAccountConnection>;
}


/** A Fiat Wallet Account */
export interface PrivateFiatWalletAccountwithdrawalBankAccountsArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
}

export interface PrivateKeyRecoveryInput {
  appId: Scalars['String']['input'];
  email?: InputMaybe<Scalars['String']['input']>;
  encryptionKey: Scalars['String']['input'];
  iv: Scalars['String']['input'];
  payload: Scalars['String']['input'];
  phone?: InputMaybe<Scalars['String']['input']>;
  teamId: Scalars['String']['input'];
}

/** Recovery option for a UserWallet. */
export interface PrivateKeyRecoveryOption extends Node {
  __typename: 'PrivateKeyRecoveryOption';
  destination: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  method: PrivateKeyRecoveryOptionMethodEnum;
  nextRecoveryKeyRequestableAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  status: PrivateKeyRecoveryOptionStatusEnum;
}

export const PrivateKeyRecoveryOptionMethodEnum = {
  EMAIL: 'EMAIL',
  PHONE: 'PHONE'
} as const;

export type PrivateKeyRecoveryOptionMethodEnum = typeof PrivateKeyRecoveryOptionMethodEnum[keyof typeof PrivateKeyRecoveryOptionMethodEnum];
export const PrivateKeyRecoveryOptionStatusEnum = {
  ACTIVE: 'ACTIVE',
  INACTIVE: 'INACTIVE',
  PENDING_VALIDATION: 'PENDING_VALIDATION'
} as const;

export type PrivateKeyRecoveryOptionStatusEnum = typeof PrivateKeyRecoveryOptionStatusEnum[keyof typeof PrivateKeyRecoveryOptionStatusEnum];
export interface PrivateKeyRecoveryPayload {
  __typename: 'PrivateKeyRecoveryPayload';
  encryptionKey: Scalars['String']['output'];
  iv: Scalars['String']['output'];
  ivTemp: Scalars['String']['output'];
  payload: Scalars['String']['output'];
}

/** A probabilistic bundle */
export interface ProbabilisticBundle extends Node {
  __typename: 'ProbabilisticBundle';
  config: ProbabilisticBundleConfig;
  drawnSlotConfigIds: Array<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isOpenable: Scalars['Boolean']['output'];
  items: Array<ProbabilisticBundleSlotArenaTicketItem | ProbabilisticBundleSlotCardItem | ProbabilisticBundleSlotCardShardItem | ProbabilisticBundleSlotConversionCreditItem | ProbabilisticBundleSlotDeliverableItem | ProbabilisticBundleSlotInGameCurrencyItem | ProbabilisticBundleSlotPackItem | ProbabilisticBundleSlotRewardShopItem>;
  openableAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  opened: Scalars['Boolean']['output'];
  openedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  openingDisclaimers: Array<ProbabilisticBundleOpeningDisclaimer>;
  so5Reward?: Maybe<So5Reward>;
}

/** A probabilistic bundle config */
export interface ProbabilisticBundleConfig {
  __typename: 'ProbabilisticBundleConfig';
  description: Scalars['String']['output'];
  design: ProbabilisticBundleDesign;
  division?: Maybe<Scalars['Int']['output']>;
  iconUrl: Scalars['String']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  neonColor: Scalars['String']['output'];
  openableAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  openingScnUrl: Scalars['String']['output'];
  pictureUrl: Scalars['String']['output'];
  quality: ProbabilisticBundleQuality;
  rarity: Rarity;
  slots: Array<ProbabilisticBundleConfigSlot>;
  stars?: Maybe<Scalars['Int']['output']>;
}

/** A probabilistic bundle config slot */
export interface ProbabilisticBundleConfigSlot {
  __typename: 'ProbabilisticBundleConfigSlot';
  probableConfigs: Array<ProbabilisticBundleSlotConfig>;
}

/** The connection type for ProbabilisticBundle. */
export interface ProbabilisticBundleConnection {
  __typename: 'ProbabilisticBundleConnection';
  /** A list of edges. */
  edges: Array<ProbabilisticBundleEdge>;
  hasAny: Scalars['Boolean']['output'];
  /** A list of nodes. */
  nodes: Array<ProbabilisticBundle>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  raritiesCount: Array<RarityCount>;
  totalCount: Scalars['Int']['output'];
}

export const ProbabilisticBundleDesign = {
  LOYALTY: 'LOYALTY',
  NEON_CHRISTMAS: 'NEON_CHRISTMAS',
  PRO: 'PRO',
  RIVALS: 'RIVALS'
} as const;

export type ProbabilisticBundleDesign = typeof ProbabilisticBundleDesign[keyof typeof ProbabilisticBundleDesign];
/** An edge in a connection. */
export interface ProbabilisticBundleEdge {
  __typename: 'ProbabilisticBundleEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<ProbabilisticBundle>;
}

export const ProbabilisticBundleIntensity = {
  BRIGHT: 'BRIGHT',
  DEFAULT: 'DEFAULT',
  HIGH: 'HIGH',
  INTENSE: 'INTENSE',
  MODERATE: 'MODERATE'
} as const;

export type ProbabilisticBundleIntensity = typeof ProbabilisticBundleIntensity[keyof typeof ProbabilisticBundleIntensity];
/** A probabilistic bundle opening disclaimer */
export interface ProbabilisticBundleOpeningDisclaimer {
  __typename: 'ProbabilisticBundleOpeningDisclaimer';
  message?: Maybe<Scalars['String']['output']>;
  slug: Scalars['String']['output'];
}

export const ProbabilisticBundleQuality = {
  LITE: 'LITE',
  PREMIUM: 'PREMIUM',
  STANDARD: 'STANDARD'
} as const;

export type ProbabilisticBundleQuality = typeof ProbabilisticBundleQuality[keyof typeof ProbabilisticBundleQuality];
/** A Probabilistic Bundle Reward */
export interface ProbabilisticBundleReward extends AnyRewardInterface, Node {
  __typename: 'ProbabilisticBundleReward';
  aasmState: RewardState;
  config: ProbabilisticBundleRewardConfig;
  id: Scalars['ID']['output'];
  probabilisticBundle: ProbabilisticBundle;
}

export interface ProbabilisticBundleRewardConfig extends AnyRewardConfigInterface {
  __typename: 'ProbabilisticBundleRewardConfig';
  boostedRewardConfigs?: Maybe<Array<CardPacksRewardConfig | CardRewardConfig | CardShardRewardConfig | CoinRewardConfig | ConversionCreditRewardConfig | DeliverableItemRewardConfig | ExperienceRewardConfig | InGameCurrencyRewardConfig | MonetaryRewardConfig | ProbabilisticBundleRewardConfig | ShopItemRewardConfig>>;
  id: Scalars['ID']['output'];
  probabilisticBundleConfig: ProbabilisticBundleConfig;
}

/** The connection type for ProbabilisticBundleReward. */
export interface ProbabilisticBundleRewardConnection {
  __typename: 'ProbabilisticBundleRewardConnection';
  /** A list of edges. */
  edges: Array<ProbabilisticBundleRewardEdge>;
  /** A list of nodes. */
  nodes: Array<ProbabilisticBundleReward>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
}

/** An edge in a connection. */
export interface ProbabilisticBundleRewardEdge {
  __typename: 'ProbabilisticBundleRewardEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<ProbabilisticBundleReward>;
}

/** A probabilistic bundle slot arena tickets item */
export interface ProbabilisticBundleSlotArenaTicketItem extends ProbabilisticBundleSlotItemInterface {
  __typename: 'ProbabilisticBundleSlotArenaTicketItem';
  id: Scalars['ID']['output'];
  intensity?: Maybe<ProbabilisticBundleIntensity>;
  neonColor?: Maybe<Scalars['String']['output']>;
  quantity: Scalars['Int']['output'];
}

/** A probabilistic bundle slot card item */
export interface ProbabilisticBundleSlotCardItem extends ProbabilisticBundleSlotItemInterface {
  __typename: 'ProbabilisticBundleSlotCardItem';
  anyCard?: Maybe<BaseballCard | Card | NBACard>;
  id: Scalars['ID']['output'];
  intensity?: Maybe<ProbabilisticBundleIntensity>;
  neonColor?: Maybe<Scalars['String']['output']>;
}

/** A probabilistic bundle slot card shards item */
export interface ProbabilisticBundleSlotCardShardItem extends ProbabilisticBundleSlotItemInterface {
  __typename: 'ProbabilisticBundleSlotCardShardItem';
  id: Scalars['ID']['output'];
  intensity?: Maybe<ProbabilisticBundleIntensity>;
  neonColor?: Maybe<Scalars['String']['output']>;
  quantity: Scalars['Int']['output'];
  rarity: Rarity;
}

/** A probabilistic bundle slot config */
export interface ProbabilisticBundleSlotConfig {
  __typename: 'ProbabilisticBundleSlotConfig';
  arenaTickets: Scalars['Int']['output'];
  cardPack?: Maybe<CardPack>;
  cardShards: Array<CardShardRewardConfig>;
  cards: Array<So5RewardCardConfig>;
  conversionCredit?: Maybe<ConversionCreditRewardConfig>;
  deliverableItems: Array<RewardDeliverableItem>;
  id: Scalars['String']['output'];
  inGameCurrencies: Array<InGameCurrencyRewardConfig>;
  probability: Scalars['Float']['output'];
  rewardShopItems: Array<FootballRewardShopItem>;
}

/** A probabilistic bundle slot conversion credit item */
export interface ProbabilisticBundleSlotConversionCreditItem extends ProbabilisticBundleSlotItemInterface {
  __typename: 'ProbabilisticBundleSlotConversionCreditItem';
  id: Scalars['ID']['output'];
  intensity?: Maybe<ProbabilisticBundleIntensity>;
  maxDiscount: MonetaryAmount;
  neonColor?: Maybe<Scalars['String']['output']>;
  percentageDiscount: Scalars['Float']['output'];
}

/** A probabilistic bundle slot deliverable item */
export interface ProbabilisticBundleSlotDeliverableItem extends ProbabilisticBundleSlotItemInterface {
  __typename: 'ProbabilisticBundleSlotDeliverableItem';
  id: Scalars['ID']['output'];
  intensity?: Maybe<ProbabilisticBundleIntensity>;
  neonColor?: Maybe<Scalars['String']['output']>;
  rewardDeliverableItem?: Maybe<RewardDeliverableItem>;
}

/** A probabilistic bundle slot in game currency item */
export interface ProbabilisticBundleSlotInGameCurrencyItem extends ProbabilisticBundleSlotItemInterface {
  __typename: 'ProbabilisticBundleSlotInGameCurrencyItem';
  amount: Scalars['Int']['output'];
  currency: InGameCurrency;
  id: Scalars['ID']['output'];
  intensity?: Maybe<ProbabilisticBundleIntensity>;
  neonColor?: Maybe<Scalars['String']['output']>;
}

export interface ProbabilisticBundleSlotItemInterface {
  id: Scalars['ID']['output'];
  intensity?: Maybe<ProbabilisticBundleIntensity>;
  neonColor?: Maybe<Scalars['String']['output']>;
}

/** A probabilistic bundle slot pack item */
export interface ProbabilisticBundleSlotPackItem extends ProbabilisticBundleSlotItemInterface {
  __typename: 'ProbabilisticBundleSlotPackItem';
  count: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  intensity?: Maybe<ProbabilisticBundleIntensity>;
  neonColor?: Maybe<Scalars['String']['output']>;
  pack?: Maybe<Pack>;
}

/** A probabilistic bundle slot reward shop item */
export interface ProbabilisticBundleSlotRewardShopItem extends ProbabilisticBundleSlotItemInterface {
  __typename: 'ProbabilisticBundleSlotRewardShopItem';
  id: Scalars['ID']['output'];
  intensity?: Maybe<ProbabilisticBundleIntensity>;
  neonColor?: Maybe<Scalars['String']['output']>;
  rewardShopItem: FootballRewardShopItem;
}

export interface ProbabilisticBundleSource extends HistoryTransactionInterface {
  __typename: 'ProbabilisticBundleSource';
  date: Scalars['ISO8601DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  label: Scalars['String']['output'];
  logoUrl?: Maybe<Scalars['String']['output']>;
  quantityByFlavour: Array<PoolKeyShardsCount>;
  totalQuantity: Scalars['Int']['output'];
}

/** Aggregated rewards overview */
export interface ProbabilisticBundlesRewardsOverview {
  __typename: 'ProbabilisticBundlesRewardsOverview';
  rarities: Array<RarityCount>;
}

/** Probable pitchers of a given game week */
export interface ProbablePitchersForGameWeek {
  __typename: 'ProbablePitchersForGameWeek';
  endDate: Scalars['ISO8601DateTime']['output'];
  gameWeek: Scalars['Int']['output'];
  longDisplayName: Scalars['String']['output'];
  playerSlugs: Array<Scalars['String']['output']>;
  shortDisplayName: Scalars['String']['output'];
  slug: Scalars['String']['output'];
  startDate: Scalars['ISO8601DateTime']['output'];
}

/** A probable reward config of a PromotionalEvent */
export interface ProbableRewardConfig {
  __typename: 'ProbableRewardConfig';
  id: Scalars['String']['output'];
  probabilityBasisPoint: Scalars['Int']['output'];
  rewardConfigs: Array<CardPacksRewardConfig | CardRewardConfig | CardShardRewardConfig | CoinRewardConfig | ConversionCreditRewardConfig | DeliverableItemRewardConfig | ExperienceRewardConfig | InGameCurrencyRewardConfig | MonetaryRewardConfig | ProbabilisticBundleRewardConfig | ShopItemRewardConfig>;
}

/** A probable reward config  thresholds of a PromotionalEvent */
export interface ProgressionForRewardConfigThresholds {
  __typename: 'ProgressionForRewardConfigThresholds';
  id: Scalars['String']['output'];
  monetaryAmountScore?: Maybe<MonetaryAmount>;
  score?: Maybe<Scalars['Float']['output']>;
  thresholds: Array<RewardConfigThreshold>;
}

export const PromotionType = {
  AIRDROP: 'AIRDROP',
  BID_TO_EARN: 'BID_TO_EARN',
  CARD_SHARD_THRESHOLDS: 'CARD_SHARD_THRESHOLDS',
  CART_PURCHASE_REWARD: 'CART_PURCHASE_REWARD',
  COMPLETABLE: 'COMPLETABLE',
  DEPOSIT: 'DEPOSIT',
  MARKET: 'MARKET',
  REACTIVATION: 'REACTIVATION',
  SPECIAL_EDITION: 'SPECIAL_EDITION',
  WHEEL_COST: 'WHEEL_COST',
  XP_COOLDOWN: 'XP_COOLDOWN'
} as const;

export type PromotionType = typeof PromotionType[keyof typeof PromotionType];
/** A promotional event completion for a user. */
export interface PromotionalEventCompletion extends Node {
  __typename: 'PromotionalEventCompletion';
  aasmState: PromotionalEventCompletionState;
  actualAmounts: MonetaryAmount;
  expiresAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['ID']['output'];
  promotionalEvent: DepositPromotionalEvent;
  rarity?: Maybe<Rarity>;
  targetAmount: MonetaryAmount;
  user: User;
}

export const PromotionalEventCompletionState = {
  COMPLETED: 'COMPLETED',
  EXPIRED: 'EXPIRED',
  PENDING: 'PENDING'
} as const;

export type PromotionalEventCompletionState = typeof PromotionalEventCompletionState[keyof typeof PromotionalEventCompletionState];
export interface PromotionalEventInterface {
  algoliaFilters: Scalars['String']['output'];
  backgroundPictureUrl?: Maybe<Scalars['String']['output']>;
  bannerAssetsPictureUrl?: Maybe<Scalars['String']['output']>;
  blogUrl?: Maybe<Scalars['String']['output']>;
  description: Scalars['String']['output'];
  eligibilityRules: EligibilityRules;
  endDate: Scalars['ISO8601DateTime']['output'];
  filterPictureUrl?: Maybe<Scalars['String']['output']>;
  heroValueProps: Array<HeroValueProp>;
  id: Scalars['ID']['output'];
  logoUrl?: Maybe<Scalars['String']['output']>;
  marketBannerTitle: Scalars['String']['output'];
  mobileBackgroundPictureUrl?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  pictureUrl?: Maybe<Scalars['String']['output']>;
  probableRewardConfigs: Array<ProbableRewardConfig>;
  promotionType: PromotionType;
  secondaryBannerPictureUrl?: Maybe<Scalars['String']['output']>;
  slug: Scalars['String']['output'];
  sport?: Maybe<Sport>;
  startDate: Scalars['ISO8601DateTime']['output'];
  termsAndConditionsUrl?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
}

export interface PromotionalEventsInterface {
  eligiblePromotionalEvents: Array<AirdropPromotionalEvent | BidToEarnPromotionalEvent | CardShardThresholdsPromotionalEvent | CartPurchaseRewardPromotionalEvent | DepositPromotionalEvent | MarketPromotionalEvent | SpecialEditionPromotionalEvent | XPCooldownPromotionalEvent>;
  eligiblePromotionalEventsProbableRewards: Array<ProbableRewardConfig>;
  eligibleRewardsProbabilisticBundleConfigs: Array<ProbabilisticBundleConfig>;
}

/** Public user information */
export interface PublicUserInfoInterface {
  active?: Maybe<Scalars['Boolean']['output']>;
  anyPlayer?: Maybe<BaseballPlayer | NBAPlayer | Player>;
  anyUserSportProfile?: Maybe<BaseballUserSportProfile | FootballUserSportProfile | NBAUserSportProfile>;
  baseballUserProfile?: Maybe<BaseballUserSportProfile>;
  /** Get a list of all blueprint cards */
  blueprintCards: AnyCardInterfaceConnection;
  /** The `bought_primary_offers` field cannot be nested within a list. */
  boughtPrimaryOffers: TokenPrimaryOfferConnection;
  /** The `bought_single_sale_token_offers` field cannot be nested within a list. */
  boughtSingleSaleTokenOffers: TokenOfferConnection;
  /** The `buying_token_auctions` field cannot be nested within a list. */
  buyingTokenAuctions: Array<TokenAuction>;
  /** The `card_collections` field cannot be nested within a list. */
  cardCollections?: Maybe<CardCollectionConnection>;
  cardCounts: CardCount;
  /** Get a list of all cards */
  cards: AnyCardInterfaceConnection;
  cardsCount: Scalars['Int']['output'];
  /**
   * The `competition_card_collections` field cannot be nested within a list.
   * @deprecated No longer used
   */
  competitionCardCollections: Array<CompetitionCardCollections>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  cryptocurrency?: Maybe<Cryptocurrency>;
  /** The `ended_with_no_buyer_single_sale_token_offers` field cannot be nested within a list. */
  endedWithNoBuyerSingleSaleTokenOffers: TokenOfferConnection;
  ethVaultId?: Maybe<Scalars['Int']['output']>;
  ethereumAddress?: Maybe<Scalars['EthereumAddress']['output']>;
  followed?: Maybe<EmailSubscription>;
  /** The `followers` field cannot be nested within a list. */
  followers: UserWithSubscriptionSlugConnection;
  followersCount: Scalars['Int']['output'];
  /** The `following` field cannot be nested within a list. */
  following: UserWithSubscriptionSlugConnection;
  followingCount: Scalars['Int']['output'];
  footballUserProfile?: Maybe<FootballUserSportProfile>;
  /**
   * Number of times the user won each step of the hot streak tracks of the game
   * mode. SET reads the career track of the active card set, or of the previous
   * card set when no set is active. PRO adds up the active career boards of the
   * sport, up to the longest board
   */
  hotStreakStepsWon: Array<StepWonCount>;
  /** Typical number of hours the manager takes to answer trades */
  hoursToAnswerTrades?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  /** The `live_single_sale_token_offers` field cannot be nested within a list. */
  liveSingleSaleTokenOffers: TokenOfferConnection;
  /** The `lost_token_auctions` field cannot be nested within a list. */
  lostTokenAuctions: TokenAuctionConnection;
  /** The `manager_teams` field cannot be nested within a list. */
  managerTeams: ManagerTeamConnection;
  nbaUserProfile?: Maybe<NBAUserSportProfile>;
  nickname: Scalars['String']['output'];
  ownedPlayersCount: Scalars['Int']['output'];
  pictureUrl?: Maybe<Scalars['String']['output']>;
  player?: Maybe<Player>;
  /**
   * The `podium_rankings` field cannot be nested within a list.
   * @deprecated Use so5_trophies_summary instead
   */
  podiumRankings: So5RankingConnection;
  /**
   * The `podiums` field cannot be nested within a list.
   * @deprecated Use so5_trophies_summary instead
   */
  podiums: Array<So5Podium>;
  profile: UserProfile;
  /** The `public_watchlists` field cannot be nested within a list. */
  publicWatchlists?: Maybe<WatchlistConnection>;
  /** The `recommended_managers` field cannot be nested within a list. */
  recommendedManagers: UserConnection;
  /**
   * The `rewarded_rankings` field cannot be nested within a list.
   * @deprecated Use so5_trophies_summary instead
   */
  rewardedRankings: So5RankingConnection;
  /** The `search_card_facet_values` field cannot be nested within a list. */
  searchCardFacetValues: Array<SearchFacetValue>;
  /** The `search_cards` field cannot be nested within a list. */
  searchCards: SearchCards;
  setBoard?: Maybe<CareerBoard | SquadBoard>;
  /**
   * Live step of the set tasks track, falling back to the last claimed step The
   * `set_live_tasks_track_step` field cannot be nested within a list.
   */
  setLiveTasksTrackStep?: Maybe<CardsCountTargetTask | CardsCountTask | CompleteCollectionsCountTargetTask | CompleteCollectionsCountTask | DailyActionTask | DecisivePlayerPickerTask | DropChallengeTask | GameWeeklyTask | GuessTheScoreTask | InviteTaskAsReferrer | So5LeaderboardTask | StarPackTask | Task | TasksTrack | ThresholdPickerTask | ThresholdsDuoConnectionTask | ThresholdsStreakAdditionalLineupTask | ThresholdsStreakTask>;
  /**
   * Headline stats of the user for the active card set, or for the previous card
   * set when no set is active The `set_manager_profile_stats` field cannot be
   * nested within a list.
   */
  setManagerProfileStats: Array<BestScoreManagerProfileStat | CollectionCompletionManagerProfileStat>;
  setTasksTrack?: Maybe<TasksTrack>;
  /** The `single_sale_token_offers` field cannot be nested within a list. */
  singleSaleTokenOffers: TokenOfferConnection;
  slug: Scalars['String']['output'];
  /** The `so5_trophies_summary` field cannot be nested within a list. */
  so5TrophiesSummary: TrophiesSummary;
  /** The `sold_single_sale_token_offers` field cannot be nested within a list. */
  soldSingleSaleTokenOffers: TokenOfferConnection;
  sorareAddress?: Maybe<Scalars['EthereumAddress']['output']>;
  squad?: Maybe<Squad>;
  starkKey?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  /** Set to true if the user deleted his account or was suspended */
  suspended: Scalars['Boolean']['output'];
  tasksTracks: Array<TasksTrack>;
  /** The `token_auctions` field cannot be nested within a list. */
  tokenAuctions: TokenAuctionConnection;
  totalPlayersCount: Scalars['Int']['output'];
  /** The `trades` field cannot be nested within a list. */
  trades: TokenDealConnection;
  /**
   * The `trophies` field cannot be nested within a list.
   * @deprecated Use so5_trophies_summary instead
   */
  trophies: Array<So5Trophies>;
  userCardCollectionsPresence: Scalars['Boolean']['output'];
  /** The `won_token_auctions` field cannot be nested within a list. */
  wonTokenAuctions: TokenAuctionConnection;
}


/** Public user information */
export interface PublicUserInfoInterfaceanyUserSportProfileArgs {
  sport: Sport;
  variant?: InputMaybe<UserSportProfileVariant>;
}


/** Public user information */
export interface PublicUserInfoInterfaceblueprintCardsArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  age?: InputMaybe<Scalars['Int']['input']>;
  assetIds?: InputMaybe<Array<Scalars['String']['input']>>;
  before?: InputMaybe<Scalars['String']['input']>;
  classicOnly?: InputMaybe<Scalars['Boolean']['input']>;
  customCardEditionName?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  inActiveCompetitions?: InputMaybe<Array<Scalars['String']['input']>>;
  inSeasonEligible?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  owned?: InputMaybe<Scalars['Boolean']['input']>;
  ownedByMe?: InputMaybe<Scalars['Boolean']['input']>;
  ownedSinceAfter?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  playerSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  positions?: InputMaybe<Array<Position>>;
  rarities?: InputMaybe<Array<Rarity>>;
  revealable?: InputMaybe<Scalars['Boolean']['input']>;
  seasonStartYears?: InputMaybe<Array<Scalars['Int']['input']>>;
  serialNumber?: InputMaybe<Scalars['Int']['input']>;
  shirtNumber?: InputMaybe<Scalars['Int']['input']>;
  slugs?: InputMaybe<Array<Scalars['String']['input']>>;
  sorts?: InputMaybe<Array<CardSort>>;
  sport?: InputMaybe<Sport>;
  teamSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  withinDeckFirst?: InputMaybe<Scalars['String']['input']>;
}


/** Public user information */
export interface PublicUserInfoInterfaceboughtPrimaryOffersArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sortByEndDate?: InputMaybe<SortingOption>;
  sport?: InputMaybe<Array<Sport>>;
}


/** Public user information */
export interface PublicUserInfoInterfaceboughtSingleSaleTokenOffersArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sortByEndDate?: InputMaybe<SortingOption>;
  sport?: InputMaybe<Array<Sport>>;
}


/** Public user information */
export interface PublicUserInfoInterfacebuyingTokenAuctionsArgs {
  newlyListed?: InputMaybe<Scalars['Boolean']['input']>;
  sport?: InputMaybe<Array<Sport>>;
}


/** Public user information */
export interface PublicUserInfoInterfacecardCollectionsArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  cardSetSlug?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forCompetitions?: InputMaybe<Array<Scalars['String']['input']>>;
  inSeasonOnly?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  rarities?: InputMaybe<Array<InputMaybe<Rarity>>>;
  seasonStartYears?: InputMaybe<Array<Scalars['Int']['input']>>;
  sortType?: InputMaybe<CardCollectionSortingOption>;
  sport?: InputMaybe<Sport>;
  startedOnly?: InputMaybe<Scalars['Boolean']['input']>;
  teamSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
}


/** Public user information */
export interface PublicUserInfoInterfacecardCountsArgs {
  sport: Sport;
}


/** Public user information */
export interface PublicUserInfoInterfacecardsArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  age?: InputMaybe<Scalars['Int']['input']>;
  assetIds?: InputMaybe<Array<Scalars['String']['input']>>;
  before?: InputMaybe<Scalars['String']['input']>;
  classicOnly?: InputMaybe<Scalars['Boolean']['input']>;
  customCardEditionName?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  inActiveCompetitions?: InputMaybe<Array<Scalars['String']['input']>>;
  inSeasonEligible?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  owned?: InputMaybe<Scalars['Boolean']['input']>;
  ownedByMe?: InputMaybe<Scalars['Boolean']['input']>;
  ownedSinceAfter?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  playerSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  positions?: InputMaybe<Array<Position>>;
  rarities?: InputMaybe<Array<Rarity>>;
  revealable?: InputMaybe<Scalars['Boolean']['input']>;
  seasonStartYears?: InputMaybe<Array<Scalars['Int']['input']>>;
  serialNumber?: InputMaybe<Scalars['Int']['input']>;
  shirtNumber?: InputMaybe<Scalars['Int']['input']>;
  slugs?: InputMaybe<Array<Scalars['String']['input']>>;
  sorts?: InputMaybe<Array<CardSort>>;
  sport?: InputMaybe<Sport>;
  teamSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  transferredOutAfter?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  withinDeckFirst?: InputMaybe<Scalars['String']['input']>;
}


/** Public user information */
export interface PublicUserInfoInterfacecompetitionCardCollectionsArgs {
  cardSetSlug: Scalars['String']['input'];
  competitionSlug?: InputMaybe<Scalars['String']['input']>;
  competitionSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  sport: Sport;
}


/** Public user information */
export interface PublicUserInfoInterfaceendedWithNoBuyerSingleSaleTokenOffersArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sortByEndDate?: InputMaybe<SortingOption>;
  sport?: InputMaybe<Array<Sport>>;
}


/** Public user information */
export interface PublicUserInfoInterfacefollowersArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
}


/** Public user information */
export interface PublicUserInfoInterfacefollowingArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
}


/** Public user information */
export interface PublicUserInfoInterfacefootballUserProfileArgs {
  variant?: InputMaybe<UserSportProfileVariant>;
}


/** Public user information */
export interface PublicUserInfoInterfacehotStreakStepsWonArgs {
  configSlug?: InputMaybe<Scalars['String']['input']>;
  gameMode: PlatformGameMode;
  sport: Sport;
}


/** Public user information */
export interface PublicUserInfoInterfaceliveSingleSaleTokenOffersArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sortByEndDate?: InputMaybe<SortingOption>;
  sport?: InputMaybe<Array<Sport>>;
}


/** Public user information */
export interface PublicUserInfoInterfacelostTokenAuctionsArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sortByEndDate?: InputMaybe<SortingOption>;
  sport?: InputMaybe<Array<Sport>>;
}


/** Public user information */
export interface PublicUserInfoInterfacemanagerTeamsArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
}


/** Public user information */
export interface PublicUserInfoInterfaceownedPlayersCountArgs {
  cardSetSlug: Scalars['String']['input'];
  sport: Sport;
}


/** Public user information */
export interface PublicUserInfoInterfacepictureUrlArgs {
  derivative?: InputMaybe<Scalars['String']['input']>;
}


/** Public user information */
export interface PublicUserInfoInterfacepodiumRankingsArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  ranking?: InputMaybe<Scalars['Int']['input']>;
  so5LeaderboardType?: InputMaybe<So5LeaderboardType>;
  sport?: InputMaybe<Sport>;
}


/** Public user information */
export interface PublicUserInfoInterfacepodiumsArgs {
  sport?: InputMaybe<Sport>;
}


/** Public user information */
export interface PublicUserInfoInterfacepublicWatchlistsArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sport: Sport;
}


/** Public user information */
export interface PublicUserInfoInterfacerecommendedManagersArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sport?: InputMaybe<Sport>;
}


/** Public user information */
export interface PublicUserInfoInterfacerewardedRankingsArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  so5LeaderboardType?: InputMaybe<So5LeaderboardType>;
  sport?: InputMaybe<Sport>;
}


/** Public user information */
export interface PublicUserInfoInterfacesearchCardFacetValuesArgs {
  advancedFilters?: InputMaybe<Scalars['String']['input']>;
  cardSetSlug?: InputMaybe<Scalars['String']['input']>;
  facetQuery: Scalars['String']['input'];
  field: Scalars['String']['input'];
  filters?: InputMaybe<Array<SearchFilterInput>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  rarity?: InputMaybe<Rarity>;
  refinements?: InputMaybe<Array<SearchRefinementInput>>;
  sport?: InputMaybe<Sport>;
}


/** Public user information */
export interface PublicUserInfoInterfacesearchCardsArgs {
  advancedFilters?: InputMaybe<Scalars['String']['input']>;
  cardSetSlug?: InputMaybe<Scalars['String']['input']>;
  duplicatedKey?: InputMaybe<Scalars['String']['input']>;
  facets?: InputMaybe<Array<SearchFacetDefinitionInput>>;
  filters?: InputMaybe<Array<SearchFilterInput>>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  rarity?: InputMaybe<Rarity>;
  refinements?: InputMaybe<Array<SearchRefinementInput>>;
  sorts?: InputMaybe<Array<SearchSortInput>>;
  sport?: InputMaybe<Sport>;
}


/** Public user information */
export interface PublicUserInfoInterfacesetBoardArgs {
  mode: BoardMode;
  sport: Sport;
}


/** Public user information */
export interface PublicUserInfoInterfacesetLiveTasksTrackStepArgs {
  sport: Sport;
}


/** Public user information */
export interface PublicUserInfoInterfacesetManagerProfileStatsArgs {
  sport: Sport;
}


/** Public user information */
export interface PublicUserInfoInterfacesetTasksTrackArgs {
  sport: Sport;
}


/** Public user information */
export interface PublicUserInfoInterfacesingleSaleTokenOffersArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sortByEndDate?: InputMaybe<SortingOption>;
  sport?: InputMaybe<Array<Sport>>;
}


/** Public user information */
export interface PublicUserInfoInterfaceso5TrophiesSummaryArgs {
  sport?: InputMaybe<Sport>;
}


/** Public user information */
export interface PublicUserInfoInterfacesoldSingleSaleTokenOffersArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sortByEndDate?: InputMaybe<SortingOption>;
  sport?: InputMaybe<Array<Sport>>;
}


/** Public user information */
export interface PublicUserInfoInterfacesquadArgs {
  sport: Sport;
}


/** Public user information */
export interface PublicUserInfoInterfacetasksTracksArgs {
  rarity?: InputMaybe<Rarity>;
  sport: Sport;
}


/** Public user information */
export interface PublicUserInfoInterfacetokenAuctionsArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sortByEndDate?: InputMaybe<SortingOption>;
  sport?: InputMaybe<Array<Sport>>;
}


/** Public user information */
export interface PublicUserInfoInterfacetotalPlayersCountArgs {
  cardSetSlug: Scalars['String']['input'];
  sport: Sport;
}


/** Public user information */
export interface PublicUserInfoInterfacetradesArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sortByEndDate?: InputMaybe<SortingOption>;
  sport?: InputMaybe<Array<Sport>>;
}


/** Public user information */
export interface PublicUserInfoInterfacetrophiesArgs {
  sport?: InputMaybe<Sport>;
}


/** Public user information */
export interface PublicUserInfoInterfaceuserCardCollectionsPresenceArgs {
  rarity: Rarity;
  sport: Sport;
}


/** Public user information */
export interface PublicUserInfoInterfacewonTokenAuctionsArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sortByEndDate?: InputMaybe<SortingOption>;
  sport?: InputMaybe<Array<Sport>>;
}

export const PurchasableItemDerivative = {
  LOW_RES: 'LOW_RES'
} as const;

export type PurchasableItemDerivative = typeof PurchasableItemDerivative[keyof typeof PurchasableItemDerivative];
export interface PurchasableItemInterface {
  cardPaymentProvider: PaymentMethodProvider;
  id: Scalars['ID']['output'];
  nextPriceUpdateAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  oldPrice?: Maybe<MonetaryAmount>;
  pictureUrl?: Maybe<Scalars['String']['output']>;
  price: MonetaryAmount;
  slug: Scalars['String']['output'];
  sport?: Maybe<Sport>;
}


export interface PurchasableItemInterfacepictureUrlArgs {
  derivative?: InputMaybe<PurchasableItemDerivative>;
}

/** A voucher to buy purchasable items with */
export interface PurchasableItemsVoucher extends MarketItem, Node {
  __typename: 'PurchasableItemsVoucher';
  buyAllPurchasableItem?: Maybe<BundledPurchasableItem | CardShardsPurchasableItem | InGameCurrencyPurchasableItem | PackConfigPurchasableItem>;
  discountedOffer: Scalars['Boolean']['output'];
  displayName: Scalars['String']['output'];
  endDate?: Maybe<Scalars['ISO8601DateTime']['output']>;
  id: Scalars['ID']['output'];
  primaryOffer?: Maybe<TokenPrimaryOffer>;
  purchasableItems: Array<BundledPurchasableItem | CardShardsPurchasableItem | InGameCurrencyPurchasableItem | PackConfigPurchasableItem>;
  setWelcomeOffer: Scalars['Boolean']['output'];
}

export interface Query {
  __typename: 'Query';
  /** Get latest announcements */
  announcements: AnnouncementConnection;
  /** Get a blockchain card. */
  anyCard: BaseballCard | Card | NBACard;
  /** Get a list of cards */
  anyCards: Array<BaseballCard | Card | NBACard>;
  /** Get a sport game. */
  anyGame: Game | GameOfBaseball | GameOfBasketball;
  anyPlayer: BaseballPlayer | NBAPlayer | Player;
  /** The emojis a manager can react to an activity with */
  availableEmojis: Array<Scalars['String']['output']>;
  cardCollection: CardCollection;
  cardCollectionSlot: CardCollectionSlot;
  cardPullConfigs: Array<CardPullConfig>;
  cardSet: CardSetRoot;
  cardSets: CardSetConnection;
  cardShardsPool: Array<PlayerWithSupply>;
  /** Get the domestic league competitions the crafting pool players can be filtered on */
  cardShardsPoolCompetitions: Array<Competition>;
  cardShardsPoolComputedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Get a list of all cards */
  cardsWhere: AnyCardInterfaceConnection;
  /** @deprecated No longer used by Sorare clients */
  commonPlayers: CommonPlayerConnection;
  /** Get sport games for a window of maximum 2 days. */
  competitionGames: Array<CompetitionGames>;
  /** Get config */
  config: Config;
  /** Get a list of countries */
  countries: Array<Country>;
  /** Get a country */
  country: Country;
  /** Get the current block height of Ethereum blockchain */
  currentBlockHeight: Scalars['Int']['output'];
  /** Fetch the current user. */
  currentUser?: Maybe<CurrentUser>;
  /** Get a deck of cards */
  deck: Deck;
  /** Get a list of cards owned by an ethereum account */
  ethereumCards: Array<BaseballCard | Card | NBACard>;
  football: FootballRoot;
  forYou: ForYouRoot;
  /** Get a potential referrer for a given name or referrer code */
  fullReferrer?: Maybe<Referrer>;
  isNicknameAvailable: Scalars['Boolean']['output'];
  /** Get the standing of a manager on one run of a ladder. */
  ladderRanking: LadderRanking;
  mangopay: MangopayRoot;
  market: MarketRoot;
  /** Get the next batch nonce for a given address */
  nextRelayBatchNonce: Scalars['Int']['output'];
  /** Fetches an object given its ID. */
  node?: Maybe<Account | ActivityReaction | AirdropPromotionalEvent | Announcement | AnnouncementNotification | AnonymousUser | AnyCardReward | AnyConversionCreditReward | ApiKey | AppearanceBoostShopItem | ApplePurchaseToken | AuctionNotification | AuctionReminder | AuthorizationRequest | AutoClaimNotification | AverageLastScore | BankWithdrawal | BaseAverageLastScore | BaseballCard | BaseballContestantType | BaseballPlayerGameScore | BaseballUserSportProfile | BasketballContestantType | BasketballPlayerGameScore | BidToEarnPromotionalEvent | BidToEarnReward | BundledPurchasableItem | CaBankAccount | Card | CardCollection | CardCollectionCard | CardCollectionNotification | CardCollectionSlot | CardNotification | CardPackActivityFeed | CardPackReward | CardPull | CardPullCard | CardSample | CardShardThresholdsPromotionalEvent | CardShardsChest | CardShardsPurchasableItem | CardShardsReward | CardStats | Cart | CartItem | CartPurchaseRewardPromotionalEvent | Club | CoinReward | CommonAccount | CommonCardSwapShopItem | CommonPlayer | Competition | ConnectedOAuth | Contestant | Contract | ConversionCredit | ConversionCreditCampaign | ConversionCreditNotification | Country | DataPartner | DecisiveActionNotification | DecisivePurchaseNotification | Deck | DeliverableItemOrder | DeliverableItemReward | DeliverableWithCustomVariantShopItem | DeliverableWithNoVariantShopItem | DepositPromotionalEvent | Eip7702Revocation | EmailSubscription | EthMigration | EthereumAccount | EthereumTransaction | ExchangeRate | ExperienceReward | ExternalDepositNotification | ExtraSwapShopItem | FastWithdrawal | FastWithdrawalWithRates | FiatWalletAccount | FixturePlayer | FootballContestantType | FootballUserSportProfile | FullWithdrawalRequest | Game | GameDay | GbBankAccount | GenericSpotlight | IbanBankAccount | InGameCurrencyNotification | InGameCurrencyPack | InGameCurrencyPurchasableItem | InGameCurrencyReward | Injury | InstantBuyCampaign | JerseyShopItem | JonumVerificationNotification | KycRequestNotification | LevelUpShopItem | LineupActivityFeed | Loan | LoanNotification | LoanableRoster | LoanedToken | LoomAccount | ManagerTeam | MangopayIdentityVerification | MangopayInternalTransfer | MangopayKycDocument | MangopayKycRequest | MangopayUser | MangopayWithdrawal | MarketPromotionalEvent | MarketingNotification | Membership | MonetaryReward | NBACard | NBAUserSportProfile | NationalTeam | OffRampKycNotification | OffRampWithdrawal | OfferNotification | OtherBankAccount | Owner | OwnerActivityFeed | OwnerWithRates | Pack | PackConfigPurchasableItem | Passkey | Payment | PictureFrameShopItem | Player | PlayerGameScore | PlayerGameStats | PlayerGameStatsBaseball | PlayerGameStatsBasketball | PlayerRecommendation | PrivateAccount | PrivateEmptyAccount | PrivateFiatWalletAccount | PrivateKeyRecoveryOption | ProbabilisticBundle | ProbabilisticBundleReward | PromotionalEventCompletion | PurchasableItemsVoucher | Raffle | RaffleShopItem | Referral | ReferralReward | ReferralRewardNotification | ReminderNotification | RevealableCardCampaign | RewardCard | SaleNotification | ScoringMatrix | Season | SeasonPicture | ShopItem | ShopItemReward | SkinShopItem | So5Appearance | So5CompetitionSpotlight | So5Fixture | So5FixturePreparing | So5Leaderboard | So5League | So5Lineup | So5LineupImport | So5LineupNotification | So5NoCardLineup | So5Ranking | So5Reward | So5Score | So5UserGroup | So5UserGroupMembership | So5UserGroupNotification | SolanaAccount | SolanaRentFunding | SorareRefund | SpecialEditionPromotionalEvent | SpecialWeeklyBanner | Squad | StageGroup | StarkwareAccount | StarkwareEscapeHatch | StarkwarePrivateAccount | StarkwareWithdrawal | Story | Suspension | TaskNotification | TaskPreparedLineup | TokenAuction | TokenBid | TokenMonetaryReward | TokenMyBid | TokenOffer | TokenOwner | TokenPrice | TokenPrimaryOffer | TokenWithdrawal | TournamentCalendarStage | UsBankAccount | User | UserAccountEntry | UserCardCollection | UserDevice | UserDeviceEvent | UserFlag | UserProfile | UserRelation | UserRelationNotification | UserShopItem | UserSource | UserSportStatistic | UserWallet | Venue | Watchlist | WheelConfig | Withdrawal | WithdrawalWithRates | XPCooldownPromotionalEvent>;
  /** Fetches a list of objects given a list of IDs. */
  nodes: Array<Maybe<Account | ActivityReaction | AirdropPromotionalEvent | Announcement | AnnouncementNotification | AnonymousUser | AnyCardReward | AnyConversionCreditReward | ApiKey | AppearanceBoostShopItem | ApplePurchaseToken | AuctionNotification | AuctionReminder | AuthorizationRequest | AutoClaimNotification | AverageLastScore | BankWithdrawal | BaseAverageLastScore | BaseballCard | BaseballContestantType | BaseballPlayerGameScore | BaseballUserSportProfile | BasketballContestantType | BasketballPlayerGameScore | BidToEarnPromotionalEvent | BidToEarnReward | BundledPurchasableItem | CaBankAccount | Card | CardCollection | CardCollectionCard | CardCollectionNotification | CardCollectionSlot | CardNotification | CardPackActivityFeed | CardPackReward | CardPull | CardPullCard | CardSample | CardShardThresholdsPromotionalEvent | CardShardsChest | CardShardsPurchasableItem | CardShardsReward | CardStats | Cart | CartItem | CartPurchaseRewardPromotionalEvent | Club | CoinReward | CommonAccount | CommonCardSwapShopItem | CommonPlayer | Competition | ConnectedOAuth | Contestant | Contract | ConversionCredit | ConversionCreditCampaign | ConversionCreditNotification | Country | DataPartner | DecisiveActionNotification | DecisivePurchaseNotification | Deck | DeliverableItemOrder | DeliverableItemReward | DeliverableWithCustomVariantShopItem | DeliverableWithNoVariantShopItem | DepositPromotionalEvent | Eip7702Revocation | EmailSubscription | EthMigration | EthereumAccount | EthereumTransaction | ExchangeRate | ExperienceReward | ExternalDepositNotification | ExtraSwapShopItem | FastWithdrawal | FastWithdrawalWithRates | FiatWalletAccount | FixturePlayer | FootballContestantType | FootballUserSportProfile | FullWithdrawalRequest | Game | GameDay | GbBankAccount | GenericSpotlight | IbanBankAccount | InGameCurrencyNotification | InGameCurrencyPack | InGameCurrencyPurchasableItem | InGameCurrencyReward | Injury | InstantBuyCampaign | JerseyShopItem | JonumVerificationNotification | KycRequestNotification | LevelUpShopItem | LineupActivityFeed | Loan | LoanNotification | LoanableRoster | LoanedToken | LoomAccount | ManagerTeam | MangopayIdentityVerification | MangopayInternalTransfer | MangopayKycDocument | MangopayKycRequest | MangopayUser | MangopayWithdrawal | MarketPromotionalEvent | MarketingNotification | Membership | MonetaryReward | NBACard | NBAUserSportProfile | NationalTeam | OffRampKycNotification | OffRampWithdrawal | OfferNotification | OtherBankAccount | Owner | OwnerActivityFeed | OwnerWithRates | Pack | PackConfigPurchasableItem | Passkey | Payment | PictureFrameShopItem | Player | PlayerGameScore | PlayerGameStats | PlayerGameStatsBaseball | PlayerGameStatsBasketball | PlayerRecommendation | PrivateAccount | PrivateEmptyAccount | PrivateFiatWalletAccount | PrivateKeyRecoveryOption | ProbabilisticBundle | ProbabilisticBundleReward | PromotionalEventCompletion | PurchasableItemsVoucher | Raffle | RaffleShopItem | Referral | ReferralReward | ReferralRewardNotification | ReminderNotification | RevealableCardCampaign | RewardCard | SaleNotification | ScoringMatrix | Season | SeasonPicture | ShopItem | ShopItemReward | SkinShopItem | So5Appearance | So5CompetitionSpotlight | So5Fixture | So5FixturePreparing | So5Leaderboard | So5League | So5Lineup | So5LineupImport | So5LineupNotification | So5NoCardLineup | So5Ranking | So5Reward | So5Score | So5UserGroup | So5UserGroupMembership | So5UserGroupNotification | SolanaAccount | SolanaRentFunding | SorareRefund | SpecialEditionPromotionalEvent | SpecialWeeklyBanner | Squad | StageGroup | StarkwareAccount | StarkwareEscapeHatch | StarkwarePrivateAccount | StarkwareWithdrawal | Story | Suspension | TaskNotification | TaskPreparedLineup | TokenAuction | TokenBid | TokenMonetaryReward | TokenMyBid | TokenOffer | TokenOwner | TokenPrice | TokenPrimaryOffer | TokenWithdrawal | TournamentCalendarStage | UsBankAccount | User | UserAccountEntry | UserCardCollection | UserDevice | UserDeviceEvent | UserFlag | UserProfile | UserRelation | UserRelationNotification | UserShopItem | UserSource | UserSportStatistic | UserWallet | Venue | Watchlist | WheelConfig | Withdrawal | WithdrawalWithRates | XPCooldownPromotionalEvent>>;
  /** Lists every sections of notifications */
  notificationSections: Array<NotificationSection>;
  /** Lists subsections of a notification section */
  notificationSubsections: Array<NotificationSubsection>;
  /** Get an OAuth application from the client id */
  oauthApplication: OAuthApplication;
  payments: PaymentRoot;
  players: Array<BaseballPlayer | NBAPlayer | Player>;
  probabilisticBundle: ProbabilisticBundle;
  probabilisticBundleConfig: ProbabilisticBundleConfig;
  /** Get a potential referrer for a given name */
  referrer?: Maybe<Scalars['String']['output']>;
  revealableCardCampaign: RevealableCardCampaign;
  /** Get information needed to screenshot a card */
  screenshottableCard: ScreenshottableCard;
  /** The `search_card_facet_values` field cannot be nested within a list. */
  searchCardFacetValues: Array<SearchFacetValue>;
  /** The `search_cards` field cannot be nested within a list. */
  searchCards: SearchCardHits;
  /** The `search_grouped_cards` field cannot be nested within a list. */
  searchGroupedCards: SearchGroupedCards;
  /** The `search_player_facet_values` field cannot be nested within a list. */
  searchPlayerFacetValues: Array<SearchFacetValue>;
  /** The `search_players` field cannot be nested within a list. */
  searchPlayers: SearchPlayers;
  /** Get a season */
  season: Season;
  /** Get paginated available shop items */
  shopItems: ClubShopItemConnection;
  so5: So5Root;
  /** Get a Starkware account. */
  starkwareAccount: StarkwareAccount;
  taskCampaignsHomepage: TaskCampaignsHomepage;
  team: Club | NationalTeam;
  teams: TeamInterfaceConnection;
  tokens: TokenRoot;
  /** Get a user. */
  user: User;
  /** Get a user by ID. */
  userById: User;
  userCardCollection: UserCardCollection;
  /** Get a UserGroup */
  userGroup: So5UserGroup;
  /** Get a list of users. */
  users: Array<User>;
  usersPaginated: UserConnection;
}


export interface QueryannouncementsArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  announcementIds?: InputMaybe<Array<Scalars['String']['input']>>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sports?: InputMaybe<Array<Sport>>;
}


export interface QueryanyCardArgs {
  assetId?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
}


export interface QueryanyCardsArgs {
  age?: InputMaybe<Scalars['Int']['input']>;
  assetIds?: InputMaybe<Array<Scalars['String']['input']>>;
  classicOnly?: InputMaybe<Scalars['Boolean']['input']>;
  customCardEditionName?: InputMaybe<Scalars['String']['input']>;
  inActiveCompetitions?: InputMaybe<Array<Scalars['String']['input']>>;
  inSeasonEligible?: InputMaybe<Scalars['Boolean']['input']>;
  owned?: InputMaybe<Scalars['Boolean']['input']>;
  ownedByMe?: InputMaybe<Scalars['Boolean']['input']>;
  ownedSinceAfter?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  playerSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  positions?: InputMaybe<Array<Position>>;
  rarities?: InputMaybe<Array<Rarity>>;
  revealable?: InputMaybe<Scalars['Boolean']['input']>;
  seasonStartYears?: InputMaybe<Array<Scalars['Int']['input']>>;
  serialNumber?: InputMaybe<Scalars['Int']['input']>;
  shirtNumber?: InputMaybe<Scalars['Int']['input']>;
  slugs?: InputMaybe<Array<Scalars['String']['input']>>;
  sorts?: InputMaybe<Array<CardSort>>;
  sport?: InputMaybe<Sport>;
  teamSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  withinDeckFirst?: InputMaybe<Scalars['String']['input']>;
}


export interface QueryanyGameArgs {
  id: Scalars['ID']['input'];
}


export interface QueryanyPlayerArgs {
  providerId?: InputMaybe<ExternalProviderIdInput>;
  slug?: InputMaybe<Scalars['String']['input']>;
}


export interface QuerycardCollectionArgs {
  slug: Scalars['String']['input'];
}


export interface QuerycardCollectionSlotArgs {
  id: Scalars['ID']['input'];
}


export interface QuerycardPullConfigsArgs {
  rarity: Rarity;
  sport: Sport;
}


export interface QuerycardSetsArgs {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  onlyWithOwnedCards?: InputMaybe<Scalars['Boolean']['input']>;
  sport?: InputMaybe<Sport>;
  withOwnedCards?: InputMaybe<WithOwnedCardsScope>;
}


export interface QuerycardShardsPoolArgs {
  competitionSlug?: InputMaybe<Scalars['String']['input']>;
  gameplayTier?: InputMaybe<GameplayTier>;
  quality?: InputMaybe<CardQuality>;
  rarity: Rarity;
  sport?: InputMaybe<Sport>;
}


export interface QuerycardShardsPoolCompetitionsArgs {
  rarity: Rarity;
  sport?: InputMaybe<Sport>;
}


export interface QuerycardShardsPoolComputedAtArgs {
  sport?: InputMaybe<Sport>;
}


export interface QuerycardsWhereArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  age?: InputMaybe<Scalars['Int']['input']>;
  assetIds?: InputMaybe<Array<Scalars['String']['input']>>;
  before?: InputMaybe<Scalars['String']['input']>;
  classicOnly?: InputMaybe<Scalars['Boolean']['input']>;
  customCardEditionName?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  inActiveCompetitions?: InputMaybe<Array<Scalars['String']['input']>>;
  inSeasonEligible?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  owned?: InputMaybe<Scalars['Boolean']['input']>;
  ownedByMe?: InputMaybe<Scalars['Boolean']['input']>;
  ownedSinceAfter?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  playerSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  positions?: InputMaybe<Array<Position>>;
  rarities?: InputMaybe<Array<Rarity>>;
  revealable?: InputMaybe<Scalars['Boolean']['input']>;
  seasonStartYears?: InputMaybe<Array<Scalars['Int']['input']>>;
  serialNumber?: InputMaybe<Scalars['Int']['input']>;
  shirtNumber?: InputMaybe<Scalars['Int']['input']>;
  slugs?: InputMaybe<Array<Scalars['String']['input']>>;
  sorts?: InputMaybe<Array<CardSort>>;
  sport?: InputMaybe<Sport>;
  teamSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  withinDeckFirst?: InputMaybe<Scalars['String']['input']>;
}


export interface QuerycommonPlayersArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  playerSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  quality?: InputMaybe<CardQuality>;
  query?: InputMaybe<Scalars['String']['input']>;
  sport?: InputMaybe<Sport>;
}


export interface QuerycompetitionGamesArgs {
  fromDate?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  sport: Sport;
  toDate?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
}


export interface QuerycountriesArgs {
  slugs: Array<Scalars['String']['input']>;
}


export interface QuerycountryArgs {
  slug: Scalars['String']['input'];
}


export interface QuerydeckArgs {
  slug: Scalars['String']['input'];
}


export interface QueryethereumCardsArgs {
  address: Scalars['String']['input'];
}


export interface QueryfullReferrerArgs {
  name?: InputMaybe<Scalars['String']['input']>;
  referrerCode?: InputMaybe<Scalars['String']['input']>;
}


export interface QueryisNicknameAvailableArgs {
  nickname: Scalars['String']['input'];
}


export interface QueryladderRankingArgs {
  id: Scalars['String']['input'];
}


export interface QuerynextRelayBatchNonceArgs {
  address: Scalars['String']['input'];
}


export interface QuerynodeArgs {
  id: Scalars['ID']['input'];
}


export interface QuerynodesArgs {
  ids: Array<Scalars['ID']['input']>;
}


export interface QuerynotificationSectionsArgs {
  forSettings?: InputMaybe<Scalars['Boolean']['input']>;
}


export interface QuerynotificationSubsectionsArgs {
  sectionSlug: Scalars['String']['input'];
}


export interface QueryoauthApplicationArgs {
  clientId: Scalars['String']['input'];
}


export interface QueryplayersArgs {
  providerIds?: InputMaybe<Array<ExternalProviderIdInput>>;
  slugs?: InputMaybe<Array<Scalars['String']['input']>>;
}


export interface QueryprobabilisticBundleArgs {
  id: Scalars['ID']['input'];
}


export interface QueryprobabilisticBundleConfigArgs {
  id: Scalars['ID']['input'];
}


export interface QueryreferrerArgs {
  name: Scalars['String']['input'];
}


export interface QueryrevealableCardCampaignArgs {
  slug: Scalars['String']['input'];
}


export interface QueryscreenshottableCardArgs {
  id: Scalars['ID']['input'];
  serialNumber?: InputMaybe<Scalars['Int']['input']>;
}


export interface QuerysearchCardFacetValuesArgs {
  advancedFilters?: InputMaybe<Scalars['String']['input']>;
  facetQuery: Scalars['String']['input'];
  favoritesOnly?: InputMaybe<Scalars['Boolean']['input']>;
  field: Scalars['String']['input'];
  filters?: InputMaybe<Array<SearchFilterInput>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  onSaleOnly?: InputMaybe<Scalars['Boolean']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  refinements?: InputMaybe<Array<SearchRefinementInput>>;
}


export interface QuerysearchCardsArgs {
  advancedFilters?: InputMaybe<Scalars['String']['input']>;
  facets?: InputMaybe<Array<SearchFacetDefinitionInput>>;
  favoritesOnly?: InputMaybe<Scalars['Boolean']['input']>;
  filters?: InputMaybe<Array<SearchFilterInput>>;
  onSaleOnly?: InputMaybe<Scalars['Boolean']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  refinements?: InputMaybe<Array<SearchRefinementInput>>;
  sorts?: InputMaybe<Array<SearchSortInput>>;
}


export interface QuerysearchGroupedCardsArgs {
  advancedFilters?: InputMaybe<Scalars['String']['input']>;
  cheapestWithinGroup?: InputMaybe<Scalars['Boolean']['input']>;
  facets?: InputMaybe<Array<SearchFacetDefinitionInput>>;
  favoritesOnly?: InputMaybe<Scalars['Boolean']['input']>;
  filters?: InputMaybe<Array<SearchFilterInput>>;
  groupBy: Array<SearchCardGroupBy>;
  groupLimit?: InputMaybe<Scalars['Int']['input']>;
  onSaleOnly?: InputMaybe<Scalars['Boolean']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  refinements?: InputMaybe<Array<SearchRefinementInput>>;
  sorts?: InputMaybe<Array<SearchSortInput>>;
}


export interface QuerysearchPlayerFacetValuesArgs {
  advancedFilters?: InputMaybe<Scalars['String']['input']>;
  facetQuery: Scalars['String']['input'];
  field: Scalars['String']['input'];
  filters?: InputMaybe<Array<SearchFilterInput>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  onlyFollowed?: InputMaybe<Scalars['Boolean']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  refinements?: InputMaybe<Array<SearchRefinementInput>>;
}


export interface QuerysearchPlayersArgs {
  advancedFilters?: InputMaybe<Scalars['String']['input']>;
  facets?: InputMaybe<Array<SearchFacetDefinitionInput>>;
  filters?: InputMaybe<Array<SearchFilterInput>>;
  onlyFollowed?: InputMaybe<Scalars['Boolean']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  refinements?: InputMaybe<Array<SearchRefinementInput>>;
  so5LeaderboardSlug?: InputMaybe<Scalars['String']['input']>;
  sorts?: InputMaybe<Array<SearchSortInput>>;
}


export interface QueryseasonArgs {
  startYear: Scalars['Int']['input'];
}


export interface QueryshopItemsArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sortType?: InputMaybe<ShopItemsSortInput>;
  sport?: InputMaybe<Sport>;
  types?: InputMaybe<Array<ShopItemType>>;
  unlockedOnly?: InputMaybe<Scalars['Boolean']['input']>;
}


export interface QuerystarkwareAccountArgs {
  starkKey: Scalars['String']['input'];
}


export interface QueryteamArgs {
  slug: Scalars['String']['input'];
}


export interface QueryteamsArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sport?: InputMaybe<Sport>;
}


export interface QueryuserArgs {
  slug: Scalars['String']['input'];
}


export interface QueryuserByIdArgs {
  id: Scalars['String']['input'];
}


export interface QueryuserCardCollectionArgs {
  id: Scalars['String']['input'];
}


export interface QueryuserGroupArgs {
  joinSecret?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
}


export interface QueryusersArgs {
  slugs: Array<Scalars['String']['input']>;
}


export interface QueryusersPaginatedArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  followingOnly?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
}

/** A raffle the current user can participate in */
export interface Raffle extends Node {
  __typename: 'Raffle';
  endDate: Scalars['ISO8601DateTime']['output'];
  id: Scalars['ID']['output'];
  myRaffleTasks: Array<CardsCountTargetTask | CardsCountTask | CompleteCollectionsCountTargetTask | CompleteCollectionsCountTask | DailyActionTask | DecisivePlayerPickerTask | DropChallengeTask | GameWeeklyTask | GuessTheScoreTask | InviteTaskAsReferrer | So5LeaderboardTask | StarPackTask | Task | TasksTrack | ThresholdPickerTask | ThresholdsDuoConnectionTask | ThresholdsStreakAdditionalLineupTask | ThresholdsStreakTask>;
  myRaffleTicketBalance: Scalars['Int']['output'];
  myRankingRatio: Scalars['Int']['output'];
  myUnclaimedTasksCount: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  pictureUrl?: Maybe<Scalars['String']['output']>;
  slug: Scalars['String']['output'];
  state: RaffleState;
}

export interface RaffleShopItem extends Node, ShopItemInterface {
  __typename: 'RaffleShopItem';
  cardCollectionRequirements: Array<CardCollectionRequirement>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  currentStockCount: Scalars['Int']['output'];
  description?: Maybe<Scalars['String']['output']>;
  disabled: Scalars['Boolean']['output'];
  expirationDate?: Maybe<Scalars['ISO8601DateTime']['output']>;
  id: Scalars['ID']['output'];
  infoLink?: Maybe<Scalars['String']['output']>;
  initialStockCount: Scalars['Int']['output'];
  limitPerUser: Scalars['Int']['output'];
  myAvailableTotalPurchasesCount: Scalars['Int']['output'];
  myAvailableUserShopItems?: Maybe<Array<UserShopItem>>;
  myBalance: Scalars['Int']['output'];
  myLimitResetAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  myPurchasesCount: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  pictureUrl: Scalars['String']['output'];
  position: ShopItemType;
  price: Scalars['Int']['output'];
  requirementsRulesLink?: Maybe<Scalars['String']['output']>;
  salePrice?: Maybe<Scalars['Int']['output']>;
  shopItemsRequired: Array<ShopItem>;
  threeDimensionalAssetUrl?: Maybe<Scalars['String']['output']>;
  unlocked: Scalars['Boolean']['output'];
}


export interface RaffleShopItempictureUrlArgs {
  derivative?: InputMaybe<ShopItemDerivative>;
}


export interface RaffleShopItemthreeDimensionalAssetUrlArgs {
  format?: InputMaybe<ShopItemThreeDimensionalAssetFormat>;
}

export const RaffleState = {
  DRAWING: 'DRAWING',
  LIVE: 'LIVE'
} as const;

export type RaffleState = typeof RaffleState[keyof typeof RaffleState];
export interface Range {
  __typename: 'Range';
  /** Max price, in wei. */
  max: Scalars['WeiAmount']['output'];
  /** Min price, in wei. */
  min: Scalars['WeiAmount']['output'];
}

export interface RangeInput {
  max?: InputMaybe<Scalars['Int']['input']>;
  min?: InputMaybe<Scalars['Int']['input']>;
}

export const RankingRatioRange = {
  LOW: 'LOW',
  MEDIUM: 'MEDIUM',
  TOP: 'TOP'
} as const;

export type RankingRatioRange = typeof RankingRatioRange[keyof typeof RankingRatioRange];
export const Rarity = {
  common: 'common',
  custom_series: 'custom_series',
  limited: 'limited',
  rare: 'rare',
  super_rare: 'super_rare',
  unique: 'unique'
} as const;

export type Rarity = typeof Rarity[keyof typeof Rarity];
export interface RarityCount {
  __typename: 'RarityCount';
  count: Scalars['Int']['output'];
  rarity: Rarity;
}

/** A rarity and its associated reward configs */
export interface RarityRewardConfigs {
  __typename: 'RarityRewardConfigs';
  rarity?: Maybe<Rarity>;
  rewardConfigs: Array<CardPacksRewardConfig | CardRewardConfig | CardShardRewardConfig | CoinRewardConfig | ConversionCreditRewardConfig | DeliverableItemRewardConfig | ExperienceRewardConfig | InGameCurrencyRewardConfig | MonetaryRewardConfig | ProbabilisticBundleRewardConfig | ShopItemRewardConfig>;
}

export interface Rates {
  __typename: 'Rates';
  /** Conversion rate to Cents (EUR) */
  eurCents: Scalars['Int']['output'];
  /** Conversion rate to Cents (GBP) */
  gbpCents: Scalars['Int']['output'];
  /** Conversion rate to Lamports */
  lamport: Scalars['CryptocurrencyAmount']['output'];
  /** Conversion rate to Cents (USD) */
  usdCents: Scalars['Int']['output'];
}

export const RecommendationEngine = {
  BEST_F2P: 'BEST_F2P',
  HOT_STREAK: 'HOT_STREAK',
  POPULAR: 'POPULAR',
  POPULAR_OR_HOT_STREAK: 'POPULAR_OR_HOT_STREAK'
} as const;

export type RecommendationEngine = typeof RecommendationEngine[keyof typeof RecommendationEngine];
/** A referral */
export interface Referral extends Node {
  __typename: 'Referral';
  aasmState: Scalars['String']['output'];
  completedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  expirationDate: Scalars['ISO8601DateTime']['output'];
  id: Scalars['ID']['output'];
  referee: User;
  refereeCardsBoughtAtAuctionCount: Scalars['Int']['output'];
  refereeConfirmedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  refereeIdentification?: Maybe<Scalars['String']['output']>;
  refereeInvitationSentAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  refereeSportCardsBoughtFromPrimaryMarketCount: Scalars['Int']['output'];
  referrer: Referrer;
  referrerRewards: Array<ReferralReward>;
  sport: Sport;
  state: ReferralState;
}


/** A referral */
export interface ReferralrefereeSportCardsBoughtFromPrimaryMarketCountArgs {
  sport: Sport;
}

export interface ReferralPaginated {
  __typename: 'ReferralPaginated';
  currentPage: Scalars['Int']['output'];
  nodes: Array<Referral>;
  pages: Scalars['Int']['output'];
  referrals: Array<Referral>;
  totalCount: Scalars['Int']['output'];
}

/** Referral configuration object */
export interface ReferralProgramConfig {
  __typename: 'ReferralProgramConfig';
  id: Scalars['ID']['output'];
  maxDiscount: MonetaryAmount;
  nature: ReferralProgramNature;
  numberCardsToBuy: Scalars['Int']['output'];
  percentageDiscountBasisPoints: Scalars['Int']['output'];
}

export const ReferralProgramNature = {
  REGULAR: 'REGULAR'
} as const;

export type ReferralProgramNature = typeof ReferralProgramNature[keyof typeof ReferralProgramNature];
/** A referral reward */
export interface ReferralReward extends Node {
  __typename: 'ReferralReward';
  anyCard?: Maybe<BaseballCard | Card | NBACard>;
  claimableAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  claimableState: ReferralRewardState;
  conversionCredit?: Maybe<ConversionCredit>;
  conversionCreditId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  shippingState: ShippingState;
}

/** The connection type for ReferralReward. */
export interface ReferralRewardConnection {
  __typename: 'ReferralRewardConnection';
  /** A list of edges. */
  edges: Array<ReferralRewardEdge>;
  hasAny: Scalars['Boolean']['output'];
  /** A list of nodes. */
  nodes: Array<ReferralReward>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
}

/** An edge in a connection. */
export interface ReferralRewardEdge {
  __typename: 'ReferralRewardEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<ReferralReward>;
}

/** A user notification regarding a referral reward */
export interface ReferralRewardNotification extends Node, NotificationInterface {
  __typename: 'ReferralRewardNotification';
  body: Scalars['String']['output'];
  createdAt: Scalars['ISO8601DateTime']['output'];
  deeplinkUrl: Scalars['String']['output'];
  iconUrl: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  important: Scalars['Boolean']['output'];
  markdownBody: Scalars['String']['output'];
  name: Scalars['String']['output'];
  pictureUrl?: Maybe<Scalars['String']['output']>;
  read: Scalars['Boolean']['output'];
  referralReward: ReferralReward;
  sport?: Maybe<SportOrShared>;
  title: Scalars['String']['output'];
  user: CurrentUser;
}

export const ReferralRewardState = {
  CLAIMABLE: 'CLAIMABLE',
  CLAIMED: 'CLAIMED',
  NOT_CLAIMABLE_YET: 'NOT_CLAIMABLE_YET',
  NOT_CLAIMABLE_YET_1_GW_MISSING: 'NOT_CLAIMABLE_YET_1_GW_MISSING',
  NOT_CLAIMABLE_YET_2_GW_MISSING: 'NOT_CLAIMABLE_YET_2_GW_MISSING',
  NOT_CLAIMABLE_YET_PRO_BOARD_STEP_MISSING: 'NOT_CLAIMABLE_YET_PRO_BOARD_STEP_MISSING'
} as const;

export type ReferralRewardState = typeof ReferralRewardState[keyof typeof ReferralRewardState];
export const ReferralState = {
  ALL: 'ALL',
  BLOCKED: 'BLOCKED',
  COMPLETED: 'COMPLETED',
  EXPIRED: 'EXPIRED',
  IN_PROGRESS: 'IN_PROGRESS',
  PENDING_REFEREE_CONFIRMATION: 'PENDING_REFEREE_CONFIRMATION',
  PENDING_REVIEW: 'PENDING_REVIEW'
} as const;

export type ReferralState = typeof ReferralState[keyof typeof ReferralState];
/** Object that can be a referrer */
export type Referrer = User | UserSource;

export interface RejectedCraftSource extends HistoryTransactionInterface {
  __typename: 'RejectedCraftSource';
  date: Scalars['ISO8601DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  label: Scalars['String']['output'];
  logoUrl?: Maybe<Scalars['String']['output']>;
  quantityByFlavour: Array<PoolKeyShardsCount>;
  totalQuantity: Scalars['Int']['output'];
}

/** A remindable element */
export type Remindable = TokenAuction;

/** A user notification regarding an reminder */
export interface ReminderNotification extends Node, NotificationInterface {
  __typename: 'ReminderNotification';
  body: Scalars['String']['output'];
  createdAt: Scalars['ISO8601DateTime']['output'];
  deeplinkUrl: Scalars['String']['output'];
  iconUrl: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  important: Scalars['Boolean']['output'];
  markdownBody: Scalars['String']['output'];
  name: Scalars['String']['output'];
  pictureUrl?: Maybe<Scalars['String']['output']>;
  read: Scalars['Boolean']['output'];
  remindable: Remindable;
  similar?: Maybe<Remindable>;
  sport?: Maybe<SportOrShared>;
  title: Scalars['String']['output'];
  user: CurrentUser;
}

/** An authorization to move assets */
export type Request = BaseWithdrawalAuthorizationRequest | CheckoutCreditCardAuthorizationRequest | EthereumBankConditionalTransferAuthorizationRequest | EthereumBankTransferAuthorizationRequest | MangopayApplePayAuthorizationRequest | MangopayCreditCardAuthorizationRequest | MangopayKlarnaAuthorizationRequest | MangopayWalletTransferAuthorizationRequest | OffRampAuthorizationRequest | PaypalAuthorizationRequest | SolanaBankConditionalTransferAuthorizationRequest | SolanaBankTransferAuthorizationRequest | SolanaBankWithdrawalAuthorizationRequest | SolanaTokenTransferAuthorizationRequest | StarkexLimitOrderAuthorizationRequest | StarkexTransferAuthorizationRequest | StarkexV6TokenTransferAuthorizationRequest | StripeCreditCardAuthorizationRequest;

/** The cost in in-game currency or essence to reveal a property on pulled cards */
export interface RevealCost {
  __typename: 'RevealCost';
  amountInCurrency: Scalars['Int']['output'];
  amountInShards: Scalars['Int']['output'];
  currency: InGameCurrency;
  propertyName: RevealableProperty;
}

export const RevealPropertyCurrency = {
  /** Force payment using card shards only */
  CARD_SHARDS: 'CARD_SHARDS',
  /** Force payment using in-game currency only */
  IN_GAME_CURRENCY: 'IN_GAME_CURRENCY'
} as const;

export type RevealPropertyCurrency = typeof RevealPropertyCurrency[keyof typeof RevealPropertyCurrency];
/** A configuration of revealable card campaign */
export interface RevealableCardCampaign extends Node {
  __typename: 'RevealableCardCampaign';
  active: Scalars['Boolean']['output'];
  backgroundImagePortraitUrl?: Maybe<Scalars['String']['output']>;
  blueprintCardEditions: Array<Scalars['String']['output']>;
  cardRotationY: Scalars['Int']['output'];
  classicCardEditions: Array<Scalars['String']['output']>;
  environmentPictureUrl?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  logoUrl?: Maybe<Scalars['String']['output']>;
  /** Get a list of all blueprint cards */
  myBlueprintCards: AnyCardInterfaceConnection;
  myRevealedCardsSummary?: Maybe<RevealedCardsSummary>;
  name: Scalars['String']['output'];
  season?: Maybe<Season>;
  slug: Scalars['String']['output'];
  specialCardEditions: Array<Scalars['String']['output']>;
  sport: Sport;
}


/** A configuration of revealable card campaign */
export interface RevealableCardCampaignmyBlueprintCardsArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  age?: InputMaybe<Scalars['Int']['input']>;
  assetIds?: InputMaybe<Array<Scalars['String']['input']>>;
  before?: InputMaybe<Scalars['String']['input']>;
  classicOnly?: InputMaybe<Scalars['Boolean']['input']>;
  customCardEditionName?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  inActiveCompetitions?: InputMaybe<Array<Scalars['String']['input']>>;
  inSeasonEligible?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  owned?: InputMaybe<Scalars['Boolean']['input']>;
  ownedByMe?: InputMaybe<Scalars['Boolean']['input']>;
  ownedSinceAfter?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  playerSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  positions?: InputMaybe<Array<Position>>;
  rarities?: InputMaybe<Array<Rarity>>;
  revealable?: InputMaybe<Scalars['Boolean']['input']>;
  seasonStartYears?: InputMaybe<Array<Scalars['Int']['input']>>;
  serialNumber?: InputMaybe<Scalars['Int']['input']>;
  shirtNumber?: InputMaybe<Scalars['Int']['input']>;
  slugs?: InputMaybe<Array<Scalars['String']['input']>>;
  sorts?: InputMaybe<Array<CardSort>>;
  sport?: InputMaybe<Sport>;
  teamSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  withinDeckFirst?: InputMaybe<Scalars['String']['input']>;
}


/** A configuration of revealable card campaign */
export interface RevealableCardCampaignmyRevealedCardsSummaryArgs {
  seasonStartYear?: InputMaybe<Scalars['Int']['input']>;
  sport: Sport;
}

export interface RevealableCardConfig {
  __typename: 'RevealableCardConfig';
  blueprintEdition: Scalars['String']['output'];
  revealedEditionsConfig: Array<RevealedEditionsConfig>;
}

export const RevealableProperty = {
  AT_GLOBAL_CUP: 'AT_GLOBAL_CUP',
  BEST_STAR_RANK: 'BEST_STAR_RANK',
  COMPETITION: 'COMPETITION',
  COUNTRY: 'COUNTRY',
  DIVISION: 'DIVISION',
  FIFTY_FIFTY: 'FIFTY_FIFTY',
  HALLOWEEN_FIFTY_FIFTY: 'HALLOWEEN_FIFTY_FIFTY',
  POSITION: 'POSITION',
  RESHUFFLE: 'RESHUFFLE'
} as const;

export type RevealableProperty = typeof RevealableProperty[keyof typeof RevealableProperty];
/** Revealed cards summary */
export interface RevealedCardsSummary {
  __typename: 'RevealedCardsSummary';
  cards: AnyCardInterfaceConnection;
  id: Scalars['String']['output'];
  season?: Maybe<Season>;
  sport: Sport;
  totalCards: Scalars['Int']['output'];
  totalSpecialEditionCards: Scalars['Int']['output'];
}


/** Revealed cards summary */
export interface RevealedCardsSummarycardsArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
}

export interface RevealedEditionsConfig {
  __typename: 'RevealedEditionsConfig';
  edition: Array<Scalars['String']['output']>;
  odds: Scalars['Float']['output'];
  oddsPercent: Scalars['Float']['output'];
}

export interface RewardBoost {
  __typename: 'RewardBoost';
  boostLevel: BoostLevel;
  maximumBoostLevel: BoostLevel;
  nextBoostLevel?: Maybe<BoostLevel>;
  points: Scalars['Int']['output'];
}

/** A rewarded card */
export interface RewardCard extends Node {
  __typename: 'RewardCard';
  anyCard?: Maybe<BaseballCard | Card | NBACard>;
  backPictureUrl?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  pictureUrl?: Maybe<Scalars['String']['output']>;
  quality?: Maybe<Scalars['String']['output']>;
  so5Reward?: Maybe<So5Reward>;
  upgradedQuality?: Maybe<Scalars['String']['output']>;
}

export const RewardConfigRarity = {
  common: 'common',
  custom_series: 'custom_series',
  limited: 'limited',
  rare: 'rare',
  super_rare: 'super_rare',
  unique: 'unique',
  unknown_rarity: 'unknown_rarity'
} as const;

export type RewardConfigRarity = typeof RewardConfigRarity[keyof typeof RewardConfigRarity];
export interface RewardConfigThreshold {
  __typename: 'RewardConfigThreshold';
  monetaryThreshold?: Maybe<MonetaryAmount>;
  probableRewards: Array<ProbableRewardConfig>;
  threshold?: Maybe<Scalars['Float']['output']>;
}

export interface RewardDeliverableItem {
  __typename: 'RewardDeliverableItem';
  deliverableItem: ExperienceDeliverableItem | JerseyDeliverableItem | TicketsDeliverableItem | WearableDeliverableItem;
  quantity: Scalars['Int']['output'];
}

/** RewardMultiplierConfiguration is the graphQL Type for a leaderboard reward multiplier configuration. */
export interface RewardMultiplierConfiguration {
  __typename: 'RewardMultiplierConfiguration';
  cardBoosts: Array<CardBoostConfig>;
}

/** A Reward Pool Share */
export interface RewardPoolShare {
  __typename: 'RewardPoolShare';
  completedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  id: Scalars['ID']['output'];
  rewardConfigs: Array<CardPacksRewardConfig | CardRewardConfig | CardShardRewardConfig | CoinRewardConfig | ConversionCreditRewardConfig | DeliverableItemRewardConfig | ExperienceRewardConfig | InGameCurrencyRewardConfig | MonetaryRewardConfig | ProbabilisticBundleRewardConfig | ShopItemRewardConfig>;
  user: User;
}

/** The connection type for RewardPoolShare. */
export interface RewardPoolShareConnection {
  __typename: 'RewardPoolShareConnection';
  /** A list of edges. */
  edges: Array<RewardPoolShareEdge>;
  /** A list of nodes. */
  nodes: Array<RewardPoolShare>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
}

/** An edge in a connection. */
export interface RewardPoolShareEdge {
  __typename: 'RewardPoolShareEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<RewardPoolShare>;
}

export const RewardState = {
  CLAIMED: 'CLAIMED',
  UNCLAIMED: 'UNCLAIMED'
} as const;

export type RewardState = typeof RewardState[keyof typeof RewardState];
/** JONUM yearly reward usage */
export interface RewardUsage {
  __typename: 'RewardUsage';
  limit: MonetaryAmount;
  periodResetsAt: Scalars['ISO8601DateTime']['output'];
  remaining: MonetaryAmount;
  used: MonetaryAmount;
}

/** Aggregated rewards overview */
export interface RewardsOverview {
  __typename: 'RewardsOverview';
  cards: Scalars['Json']['output'];
  deliverableItems: DeliverableItemsRewardsOverview;
  experiences?: Maybe<Scalars['Json']['output']>;
  experiencesDetails: Array<So5RewardExperience>;
  prizePool: Scalars['Float']['output'];
  prizePoolCurrency: PaymentCurrency;
  probabilisticBundles: ProbabilisticBundlesRewardsOverview;
}

/** RoomsConfig is the graphQL Type for a rooms configuration. */
export interface RoomsConfig {
  __typename: 'RoomsConfig';
  boostedRewardsRoomsName?: Maybe<Scalars['String']['output']>;
  boostedRewardsRoomsSo5RewardConfigs?: Maybe<Array<So5RewardConfig>>;
  roomsSize: Scalars['Int']['output'];
  roomsWithBoostedRewardsBasisPoint?: Maybe<Scalars['Int']['output']>;
  roomsWithBoostedRewardsCount?: Maybe<Scalars['Int']['output']>;
  slug: Scalars['String']['output'];
}

export const SCAEnrollmentState = {
  SCA_ENROLLED: 'SCA_ENROLLED',
  SCA_NOT_ENROLLED: 'SCA_NOT_ENROLLED',
  SCA_PENDING_CONFIRMATION: 'SCA_PENDING_CONFIRMATION'
} as const;

export type SCAEnrollmentState = typeof SCAEnrollmentState[keyof typeof SCAEnrollmentState];
/** A user notification regarding a Sale */
export interface SaleNotification extends Node, NotificationInterface {
  __typename: 'SaleNotification';
  amounts?: Maybe<MonetaryAmount>;
  anyCard?: Maybe<BaseballCard | Card | NBACard>;
  body: Scalars['String']['output'];
  buyer?: Maybe<User>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  deeplinkUrl: Scalars['String']['output'];
  iconUrl: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  important: Scalars['Boolean']['output'];
  markdownBody: Scalars['String']['output'];
  name: Scalars['String']['output'];
  pictureUrl?: Maybe<Scalars['String']['output']>;
  priceInWei: Scalars['String']['output'];
  read: Scalars['Boolean']['output'];
  seller: User;
  sport?: Maybe<SportOrShared>;
  title: Scalars['String']['output'];
  user: CurrentUser;
}

export const ScoreStatus = {
  DID_NOT_PLAY: 'DID_NOT_PLAY',
  FINAL: 'FINAL',
  NO_GAME: 'NO_GAME',
  PENDING: 'PENDING',
  REVIEWING: 'REVIEWING'
} as const;

export type ScoreStatus = typeof ScoreStatus[keyof typeof ScoreStatus];
/** A So5 Scoring Matrix */
export interface ScoringMatrix extends Node {
  __typename: 'ScoringMatrix';
  customMatrix?: Maybe<Scalars['JSON']['output']>;
  id: Scalars['ID']['output'];
  statCustomScorings: Array<StatCustomScoring>;
}

/** Information needed for a card screenshot */
export interface ScreenshottableCard {
  __typename: 'ScreenshottableCard';
  age: Scalars['Int']['output'];
  baseballPositions?: Maybe<Array<BaseballPosition>>;
  birthPlaceCountry: Scalars['String']['output'];
  cardEditionName: Scalars['String']['output'];
  cardSample: CardSample;
  cropped: Scalars['Boolean']['output'];
  footballPosition?: Maybe<FootballPosition>;
  layout: CardLayout;
  locale: Scalars['String']['output'];
  nbaPositions?: Maybe<Array<NBAPosition>>;
  playerDisplayName: Scalars['String']['output'];
  playerPicture?: Maybe<SeasonPicture>;
  rarity: Rarity;
  rookie: Scalars['Boolean']['output'];
  season: Scalars['Int']['output'];
  serialNumber: Scalars['Int']['output'];
  shirtNumber: Scalars['Int']['output'];
  singleCivilYear: Scalars['Boolean']['output'];
  sport: Sport;
  teamPictureUrl?: Maybe<Scalars['String']['output']>;
  teamShortName: Scalars['String']['output'];
  teamSlug: Scalars['String']['output'];
  threeDimensionalLayout: ThreeDimensionalCardLayout;
}


/** Information needed for a card screenshot */
export interface ScreenshottableCardteamPictureUrlArgs {
  derivative?: InputMaybe<Scalars['String']['input']>;
}

/** Sealing configuration object */
export interface SealingConfig {
  __typename: 'SealingConfig';
  fullRarityVaultMatrix: Array<BoostLevel>;
  unsealCooldownDays: Scalars['Int']['output'];
  unsealPeriodDays: Scalars['Int']['output'];
  unsealsPerPeriod: Scalars['Int']['output'];
}


/** Sealing configuration object */
export interface SealingConfigfullRarityVaultMatrixArgs {
  rarity: Rarity;
  sport: Sport;
}

export const SearchCardGroupBy = {
  /** Group cards of the same player and rarity. */
  PLAYER_AND_RARITY: 'PLAYER_AND_RARITY'
} as const;

export type SearchCardGroupBy = typeof SearchCardGroupBy[keyof typeof SearchCardGroupBy];
export interface SearchCardHit {
  __typename: 'SearchCardHit';
  card?: Maybe<BaseballCard | Card | NBACard>;
  rarity: Rarity;
  sale?: Maybe<SearchCardSale>;
  season: Scalars['String']['output'];
  slug: Scalars['String']['output'];
}

/** Card search results enriched with result from search engine */
export interface SearchCardHits extends SearchInterface {
  __typename: 'SearchCardHits';
  facets: Array<SearchFacet>;
  hitIds: Array<Scalars['String']['output']>;
  hits: Array<SearchCardHit>;
  nbHits: Scalars['Int']['output'];
  nbPages: Scalars['Int']['output'];
  page: Scalars['Int']['output'];
  processingTimeMs: SearchProcessingTime;
}

export interface SearchCardSale {
  __typename: 'SearchCardSale';
  distinctKey?: Maybe<Scalars['String']['output']>;
  price: Scalars['Int']['output'];
  type: Scalars['String']['output'];
}

/** Card search results */
export interface SearchCards extends SearchInterface {
  __typename: 'SearchCards';
  facets: Array<SearchFacet>;
  hitIds: Array<Scalars['String']['output']>;
  hits: Array<BaseballCard | Card | NBACard>;
  nbHits: Scalars['Int']['output'];
  nbPages: Scalars['Int']['output'];
  page: Scalars['Int']['output'];
  processingTimeMs: SearchProcessingTime;
}

export interface SearchFacet {
  __typename: 'SearchFacet';
  field: Scalars['String']['output'];
  max?: Maybe<SearchFacetValue>;
  min?: Maybe<SearchFacetValue>;
  values: Array<SearchFacetValue>;
}

export interface SearchFacetDefinitionInput {
  field: Scalars['String']['input'];
  limit: Scalars['Int']['input'];
  type: SearchFaceting;
}

export interface SearchFacetValue {
  __typename: 'SearchFacetValue';
  count: Scalars['Int']['output'];
  value: Scalars['String']['output'];
}

export const SearchFaceting = {
  CONJUNCTIVE: 'CONJUNCTIVE',
  DISJUNCTIVE: 'DISJUNCTIVE'
} as const;

export type SearchFaceting = typeof SearchFaceting[keyof typeof SearchFaceting];
export interface SearchFilterInput {
  field: Scalars['String']['input'];
  operator: SearchOperator;
  values: Array<SearchValueInput>;
}

export interface SearchGroup {
  __typename: 'SearchGroup';
  hits: Array<SearchCardHit>;
  /** The group's key, one entry per `groupBy` dimension. */
  keys: Array<SearchGroupKey>;
  /** Number of cards in the group. May be approximate for large groups, and slow to compute. */
  stackSize?: Maybe<Scalars['Int']['output']>;
}

export interface SearchGroupKey {
  __typename: 'SearchGroupKey';
  dimension: SearchCardGroupBy;
  value: Scalars['String']['output'];
}

export interface SearchGroupedCards extends SearchInterface {
  __typename: 'SearchGroupedCards';
  facets: Array<SearchFacet>;
  groups: Array<SearchGroup>;
  hitIds: Array<Scalars['String']['output']>;
  nbHits: Scalars['Int']['output'];
  nbPages: Scalars['Int']['output'];
  page: Scalars['Int']['output'];
  processingTimeMs: SearchProcessingTime;
}

export interface SearchInterface {
  facets: Array<SearchFacet>;
  hitIds: Array<Scalars['String']['output']>;
  nbHits: Scalars['Int']['output'];
  nbPages: Scalars['Int']['output'];
  page: Scalars['Int']['output'];
  processingTimeMs: SearchProcessingTime;
}

export const SearchOperator = {
  EQUAL: 'EQUAL',
  GREATER_THAN: 'GREATER_THAN',
  GREATER_THAN_OR_EQUAL: 'GREATER_THAN_OR_EQUAL',
  LESS_THAN: 'LESS_THAN',
  LESS_THAN_OR_EQUAL: 'LESS_THAN_OR_EQUAL',
  NOT_EQUAL: 'NOT_EQUAL'
} as const;

export type SearchOperator = typeof SearchOperator[keyof typeof SearchOperator];
/** Player search results */
export interface SearchPlayers extends SearchInterface {
  __typename: 'SearchPlayers';
  commonPlayerHits: Array<CommonPlayer>;
  facets: Array<SearchFacet>;
  hitIds: Array<Scalars['String']['output']>;
  hits: Array<ComposeTeamBenchCard | ComposeTeamBenchCommonPlayer | DecisivePlayerPickerTaskAppearance | MissedAppearance | So5Appearance | TaskAppearance | ThresholdPickerTaskAppearance>;
  nbHits: Scalars['Int']['output'];
  nbPages: Scalars['Int']['output'];
  page: Scalars['Int']['output'];
  processingTimeMs: SearchProcessingTime;
}

export interface SearchProcessingTime {
  __typename: 'SearchProcessingTime';
  facetValuesFts: Scalars['Int']['output'];
  faceting: Scalars['Int']['output'];
  filtering: Scalars['Int']['output'];
  fts: Scalars['Int']['output'];
  sorting: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
}

export interface SearchRefinementInput {
  field: Scalars['String']['input'];
  operator: SearchOperator;
  values: Array<SearchValueInput>;
}

export const SearchSortDirection = {
  ASC: 'ASC',
  DESC: 'DESC'
} as const;

export type SearchSortDirection = typeof SearchSortDirection[keyof typeof SearchSortDirection];
export interface SearchSortInput {
  direction: SearchSortDirection;
  field: Scalars['String']['input'];
}

export interface SearchValueInput {
  booleanValue?: InputMaybe<Scalars['Boolean']['input']>;
  floatValue?: InputMaybe<Scalars['Float']['input']>;
  integerValue?: InputMaybe<Scalars['Int']['input']>;
  nullValue?: InputMaybe<Scalars['Boolean']['input']>;
  stringValue?: InputMaybe<Scalars['String']['input']>;
}

/** A football season */
export interface Season extends Node {
  __typename: 'Season';
  /** The `any_cards` field cannot be nested within a list. */
  anyCards: AnyCardInterfaceConnection;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  startYear: Scalars['Int']['output'];
}


/** A football season */
export interface SeasonanyCardsArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  age?: InputMaybe<Scalars['Int']['input']>;
  assetIds?: InputMaybe<Array<Scalars['String']['input']>>;
  before?: InputMaybe<Scalars['String']['input']>;
  classicOnly?: InputMaybe<Scalars['Boolean']['input']>;
  customCardEditionName?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  inActiveCompetitions?: InputMaybe<Array<Scalars['String']['input']>>;
  inSeasonEligible?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  owned?: InputMaybe<Scalars['Boolean']['input']>;
  ownedByMe?: InputMaybe<Scalars['Boolean']['input']>;
  ownedSinceAfter?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  playerSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  positions?: InputMaybe<Array<Position>>;
  rarities?: InputMaybe<Array<Rarity>>;
  revealable?: InputMaybe<Scalars['Boolean']['input']>;
  seasonStartYears?: InputMaybe<Array<Scalars['Int']['input']>>;
  serialNumber?: InputMaybe<Scalars['Int']['input']>;
  shirtNumber?: InputMaybe<Scalars['Int']['input']>;
  slugs?: InputMaybe<Array<Scalars['String']['input']>>;
  sorts?: InputMaybe<Array<CardSort>>;
  sport?: InputMaybe<Sport>;
  teamSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  withinDeckFirst?: InputMaybe<Scalars['String']['input']>;
}

/** The season bonus rule of a So5Leaderboard */
export interface SeasonBonus {
  __typename: 'SeasonBonus';
  max?: Maybe<Scalars['Int']['output']>;
  min?: Maybe<Scalars['Int']['output']>;
  season?: Maybe<Season>;
  teams: Array<Club>;
}

export interface SeasonCount {
  __typename: 'SeasonCount';
  count: Scalars['Int']['output'];
  season: Season;
  snapshotted: Scalars['Boolean']['output'];
}

export const SeasonEligibility = {
  CLASSIC: 'CLASSIC',
  IN_SEASON: 'IN_SEASON'
} as const;

export type SeasonEligibility = typeof SeasonEligibility[keyof typeof SeasonEligibility];
/** A player season picture */
export interface SeasonPicture extends Node {
  __typename: 'SeasonPicture';
  backgroundUrl?: Maybe<Scalars['String']['output']>;
  chinY?: Maybe<Scalars['Float']['output']>;
  chinYTarget?: Maybe<Scalars['Int']['output']>;
  eyeLeft?: Maybe<FaceLandmark>;
  eyeRight?: Maybe<FaceLandmark>;
  height: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  kit?: Maybe<Scalars['String']['output']>;
  nose?: Maybe<FaceLandmark>;
  offsetX: Scalars['Int']['output'];
  offsetY: Scalars['Int']['output'];
  pictureUrl?: Maybe<Scalars['String']['output']>;
  positioning: PicturePositioning;
  rotation?: Maybe<Scalars['Float']['output']>;
  width: Scalars['Int']['output'];
  zoom?: Maybe<Scalars['Float']['output']>;
}


/** A player season picture */
export interface SeasonPicturepictureUrlArgs {
  derivative?: InputMaybe<Scalars['String']['input']>;
}

export interface SeasonsRule extends So5RuleInterface {
  __typename: 'SeasonsRule';
  descriptions: Array<So5RuleDescription>;
  id: Scalars['String']['output'];
  key: Scalars['String']['output'];
  seasons: Array<Season>;
}

export const SettlementDelayReason = {
  /** The token was bought using Apple IAP */
  APPLE_IAP: 'APPLE_IAP',
  /** A conversion credit was used to buy the token */
  CONVERSION_CREDIT_USED: 'CONVERSION_CREDIT_USED',
  /** The token was bought using Google IAP */
  GOOGLE_IAP: 'GOOGLE_IAP',
  /** The token was bought using Klarna */
  KLARNA: 'KLARNA',
  /** The token was delivered through a welcome-offer pack */
  WELCOME_OFFER_PACK: 'WELCOME_OFFER_PACK'
} as const;

export type SettlementDelayReason = typeof SettlementDelayReason[keyof typeof SettlementDelayReason];
export const ShippingState = {
  CLAIMED: 'CLAIMED',
  READY_TO_CLAIM: 'READY_TO_CLAIM'
} as const;

export type ShippingState = typeof ShippingState[keyof typeof ShippingState];
export const ShirtSize = {
  L: 'L',
  M: 'M',
  S: 'S',
  XL: 'XL',
  XS: 'XS',
  XXL: 'XXL'
} as const;

export type ShirtSize = typeof ShirtSize[keyof typeof ShirtSize];
/** A shop item to customize a user gallery */
export interface ShopItem extends Node, ShopItemInterface {
  __typename: 'ShopItem';
  cardCollectionRequirements: Array<CardCollectionRequirement>;
  color?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  disabled: Scalars['Boolean']['output'];
  expirationDate?: Maybe<Scalars['ISO8601DateTime']['output']>;
  id: Scalars['ID']['output'];
  infoLink?: Maybe<Scalars['String']['output']>;
  limitPerUser: Scalars['Int']['output'];
  myAvailableTotalPurchasesCount: Scalars['Int']['output'];
  myAvailableUserShopItems?: Maybe<Array<UserShopItem>>;
  myBalance: Scalars['Int']['output'];
  myLimitResetAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  myPurchasesCount: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  pictureUrl: Scalars['String']['output'];
  position: ShopItemType;
  price: Scalars['Int']['output'];
  requirementsRulesLink?: Maybe<Scalars['String']['output']>;
  salePrice?: Maybe<Scalars['Int']['output']>;
  shopItemsRequired: Array<ShopItem>;
  threeDimensionalAssetUrl?: Maybe<Scalars['String']['output']>;
  unlocked: Scalars['Boolean']['output'];
}


/** A shop item to customize a user gallery */
export interface ShopItempictureUrlArgs {
  derivative?: InputMaybe<ShopItemDerivative>;
}


/** A shop item to customize a user gallery */
export interface ShopItemthreeDimensionalAssetUrlArgs {
  format?: InputMaybe<ShopItemThreeDimensionalAssetFormat>;
}

export const ShopItemDerivative = {
  MOBILE: 'MOBILE',
  TINIFIED: 'TINIFIED'
} as const;

export type ShopItemDerivative = typeof ShopItemDerivative[keyof typeof ShopItemDerivative];
export interface ShopItemInterface {
  cardCollectionRequirements: Array<CardCollectionRequirement>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  disabled: Scalars['Boolean']['output'];
  expirationDate?: Maybe<Scalars['ISO8601DateTime']['output']>;
  id: Scalars['ID']['output'];
  infoLink?: Maybe<Scalars['String']['output']>;
  limitPerUser: Scalars['Int']['output'];
  myAvailableTotalPurchasesCount: Scalars['Int']['output'];
  myAvailableUserShopItems?: Maybe<Array<UserShopItem>>;
  myBalance: Scalars['Int']['output'];
  myLimitResetAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  myPurchasesCount: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  pictureUrl: Scalars['String']['output'];
  position: ShopItemType;
  price: Scalars['Int']['output'];
  requirementsRulesLink?: Maybe<Scalars['String']['output']>;
  salePrice?: Maybe<Scalars['Int']['output']>;
  shopItemsRequired: Array<ShopItem>;
  threeDimensionalAssetUrl?: Maybe<Scalars['String']['output']>;
  unlocked: Scalars['Boolean']['output'];
}


export interface ShopItemInterfacepictureUrlArgs {
  derivative?: InputMaybe<ShopItemDerivative>;
}


export interface ShopItemInterfacethreeDimensionalAssetUrlArgs {
  format?: InputMaybe<ShopItemThreeDimensionalAssetFormat>;
}

/** A Shop Item Reward */
export interface ShopItemReward extends AnyRewardInterface, Node {
  __typename: 'ShopItemReward';
  aasmState: RewardState;
  config: CardPacksRewardConfig | CardRewardConfig | CardShardRewardConfig | CoinRewardConfig | ConversionCreditRewardConfig | DeliverableItemRewardConfig | ExperienceRewardConfig | InGameCurrencyRewardConfig | MonetaryRewardConfig | ProbabilisticBundleRewardConfig | ShopItemRewardConfig;
  id: Scalars['ID']['output'];
  shopItem: ShopItem;
}

/** A Shop Item Reward Config */
export interface ShopItemRewardConfig extends AnyRewardConfigInterface {
  __typename: 'ShopItemRewardConfig';
  boostedRewardConfigs?: Maybe<Array<CardPacksRewardConfig | CardRewardConfig | CardShardRewardConfig | CoinRewardConfig | ConversionCreditRewardConfig | DeliverableItemRewardConfig | ExperienceRewardConfig | InGameCurrencyRewardConfig | MonetaryRewardConfig | ProbabilisticBundleRewardConfig | ShopItemRewardConfig>>;
  id: Scalars['ID']['output'];
  shopItem: ShopItem;
}

export const ShopItemThreeDimensionalAssetFormat = {
  USDZ: 'USDZ'
} as const;

export type ShopItemThreeDimensionalAssetFormat = typeof ShopItemThreeDimensionalAssetFormat[keyof typeof ShopItemThreeDimensionalAssetFormat];
export const ShopItemType = {
  ACHIEVEMENT_BADGE: 'ACHIEVEMENT_BADGE',
  APPEARANCE_BOOST: 'APPEARANCE_BOOST',
  BACKGROUND: 'BACKGROUND',
  BANNER: 'BANNER',
  CARD_XP_BOOST: 'CARD_XP_BOOST',
  CHALLENGES_BADGE: 'CHALLENGES_BADGE',
  CLUB_BADGE: 'CLUB_BADGE',
  COLLECTION_BADGE: 'COLLECTION_BADGE',
  COMMON_CARD_SWAP: 'COMMON_CARD_SWAP',
  COUNTRY_BADGE: 'COUNTRY_BADGE',
  DELIVERABLE_WITH_CUSTOM_VARIANT: 'DELIVERABLE_WITH_CUSTOM_VARIANT',
  DELIVERABLE_WITH_NO_VARIANT: 'DELIVERABLE_WITH_NO_VARIANT',
  EVENT_BADGE: 'EVENT_BADGE',
  EXTRA_SWAP: 'EXTRA_SWAP',
  EXTRA_TEAMS_CAP: 'EXTRA_TEAMS_CAP',
  JERSEY: 'JERSEY',
  LEVEL_UP: 'LEVEL_UP',
  LOGO: 'LOGO',
  MANAGER_PROGRESSION_BADGE: 'MANAGER_PROGRESSION_BADGE',
  RAFFLE: 'RAFFLE',
  SHIELD: 'SHIELD',
  SHOP_BADGE: 'SHOP_BADGE'
} as const;

export type ShopItemType = typeof ShopItemType[keyof typeof ShopItemType];
export interface ShopItemsSortInput {
  direction: SortingOption;
  type: ShopItemsSorting;
}

export const ShopItemsSorting = {
  DATE: 'DATE',
  NAME: 'NAME',
  PRICE: 'PRICE',
  UNLOCKED: 'UNLOCKED'
} as const;

export type ShopItemsSorting = typeof ShopItemsSorting[keyof typeof ShopItemsSorting];
/** Autogenerated return type of SignInMutation. */
export interface SignInMutationPayload {
  __typename: 'SignInMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  currentUser?: Maybe<CurrentUser>;
  errors: Array<UserError>;
  /** Generate a JWT Token. null if, and only if, currentUser is null. */
  jwtToken?: Maybe<JwtToken>;
  otpSessionChallenge?: Maybe<Scalars['String']['output']>;
  /** tcuToken is returned when the user must accept the TCUs before signing in */
  tcuToken?: Maybe<Scalars['String']['output']>;
}


/** Autogenerated return type of SignInMutation. */
export interface SignInMutationPayloadjwtTokenArgs {
  aud: Scalars['String']['input'];
}

/** Autogenerated return type of SignInWithOAuthMutation. */
export interface SignInWithOAuthMutationPayload {
  __typename: 'SignInWithOAuthMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  currentUser?: Maybe<CurrentUser>;
  errors: Array<UserError>;
  isSignUp?: Maybe<Scalars['Boolean']['output']>;
  /** Generate a JWT Token. null if, and only if, currentUser is null. */
  jwtToken?: Maybe<JwtToken>;
  /** otpSessionChallenge is returned when the user has 2FA enabled, to be completed with signIn */
  otpSessionChallenge?: Maybe<Scalars['String']['output']>;
  /** tcuToken is returned when the user must accept the TCUs before signing in */
  tcuToken?: Maybe<Scalars['String']['output']>;
}


/** Autogenerated return type of SignInWithOAuthMutation. */
export interface SignInWithOAuthMutationPayloadjwtTokenArgs {
  aud: Scalars['String']['input'];
}

/** Autogenerated return type of SignUpMutation. */
export interface SignUpMutationPayload {
  __typename: 'SignUpMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  currentUser?: Maybe<CurrentUser>;
  errors: Array<UserError>;
  /** Generate a JWT Token. null if, and only if, currentUser is null. */
  jwtToken?: Maybe<JwtToken>;
}


/** Autogenerated return type of SignUpMutation. */
export interface SignUpMutationPayloadjwtTokenArgs {
  aud: Scalars['String']['input'];
}

export interface SignedCardPrice {
  __typename: 'SignedCardPrice';
  player: BaseballPlayer | NBAPlayer | Player;
  price: Scalars['Int']['output'];
  rarity: Rarity;
  signedPrice: Scalars['String']['output'];
  team: Club | NationalTeam;
  validUntil: Scalars['ISO8601DateTime']['output'];
}

export const SignupPlatform = {
  ANDROID: 'ANDROID',
  IOS: 'IOS',
  MOBILE_WEB: 'MOBILE_WEB',
  WEB: 'WEB'
} as const;

export type SignupPlatform = typeof SignupPlatform[keyof typeof SignupPlatform];
/** The skin of a common card edition */
export const Skin = {
  FULL_ART: 'FULL_ART',
  HOLO: 'HOLO',
  SHINY: 'SHINY',
  STANDARD: 'STANDARD'
} as const;

export type Skin = typeof Skin[keyof typeof Skin];
/** The skin and variant of a card skin edition */
export interface SkinEdition {
  __typename: 'SkinEdition';
  bonus?: Maybe<Scalars['Float']['output']>;
  skin: Skin;
  skinName: Scalars['String']['output'];
  variant: EditionVariant;
  variantName?: Maybe<Scalars['String']['output']>;
}

export interface SkinShopItem extends Node, ShopItemInterface {
  __typename: 'SkinShopItem';
  cardCollectionRequirements: Array<CardCollectionRequirement>;
  color?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  disabled: Scalars['Boolean']['output'];
  expirationDate?: Maybe<Scalars['ISO8601DateTime']['output']>;
  id: Scalars['ID']['output'];
  infoLink?: Maybe<Scalars['String']['output']>;
  limitPerUser: Scalars['Int']['output'];
  myAvailableTotalPurchasesCount: Scalars['Int']['output'];
  myAvailableUserShopItems?: Maybe<Array<UserShopItem>>;
  myBalance: Scalars['Int']['output'];
  myLimitResetAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  myPurchasesCount: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  pictureUrl: Scalars['String']['output'];
  position: ShopItemType;
  price: Scalars['Int']['output'];
  requirementsRulesLink?: Maybe<Scalars['String']['output']>;
  salePrice?: Maybe<Scalars['Int']['output']>;
  shopItemsRequired: Array<ShopItem>;
  threeDimensionalAssetUrl?: Maybe<Scalars['String']['output']>;
  unlocked: Scalars['Boolean']['output'];
}


export interface SkinShopItempictureUrlArgs {
  derivative?: InputMaybe<ShopItemDerivative>;
}


export interface SkinShopItemthreeDimensionalAssetUrlArgs {
  format?: InputMaybe<ShopItemThreeDimensionalAssetFormat>;
}

/** The aggregated draw odds of a skin edition within a gameplay tier of a pack slot */
export interface SkinTierOdds {
  __typename: 'SkinTierOdds';
  playerOdds: Array<CommonPlayerOdds>;
  /** Sum of this skin edition players draw probability in basis points (1 bp = 0.01%) */
  probabilityBasisPoint: Scalars['Float']['output'];
  /** The skin of this skin edition */
  skin: Skin;
  skinEdition: SkinEdition;
}

/** The active clubs bonus of an appearance */
export interface So5ActiveClubsBonus extends So5AppearanceBonusInterface {
  __typename: 'So5ActiveClubsBonus';
  bonusBasisPoints: Scalars['Int']['output'];
  description?: Maybe<Scalars['String']['output']>;
  iconUrl: Scalars['String']['output'];
  key: Scalars['String']['output'];
  maxBonusBasisPoints: Scalars['Int']['output'];
  smallIconUrl: Scalars['String']['output'];
  title: Scalars['String']['output'];
}

/** The active clubs rule of a So5Leaderboard */
export interface So5ActiveClubsRule extends So5RuleInterface {
  __typename: 'So5ActiveClubsRule';
  clubs: Array<Club>;
  descriptions: Array<So5RuleDescription>;
  id: Scalars['String']['output'];
  key: Scalars['String']['output'];
}

/** The active national teams rule of a So5Leaderboard */
export interface So5ActiveNationalTeamsRule extends So5RuleInterface {
  __typename: 'So5ActiveNationalTeamsRule';
  descriptions: Array<So5RuleDescription>;
  id: Scalars['String']['output'];
  key: Scalars['String']['output'];
  nationalTeams: Array<NationalTeam>;
}

export interface So5AgeRule extends So5RuleInterface {
  __typename: 'So5AgeRule';
  age: Age;
  descriptions: Array<So5RuleDescription>;
  id: Scalars['String']['output'];
  key: Scalars['String']['output'];
}

/** A SO5 Appearance - a card selected in a team for a SO5 fixture */
export interface So5Appearance extends AppearanceInterface, ComposeTeamBenchObjectInterface, Node, So5AppearanceInterface {
  __typename: 'So5Appearance';
  activeSuspensions: Array<Suspension>;
  anyCard?: Maybe<BaseballCard | Card | NBACard>;
  anyCardWithLivePrimaryOffer?: Maybe<BaseballCard | Card | NBACard>;
  anyPlayer: BaseballPlayer | NBAPlayer | Player;
  anyPlayerGameStats?: Maybe<PlayerGameStats | PlayerGameStatsBaseball | PlayerGameStatsBasketball>;
  anyTeam: Club | NationalTeam;
  averageScore?: Maybe<Scalars['Float']['output']>;
  bonus?: Maybe<Scalars['Float']['output']>;
  bonusPoints?: Maybe<Scalars['Float']['output']>;
  bonusRating?: Maybe<BonusOrdinalRatingEnum>;
  bonuses: Array<So5ActiveClubsBonus | So5AverageScoresBonus | So5BoostBonus | So5CaptainBonus | So5CollectionBonus | So5DifferentNationalitiesBonus | So5GradeBonus | So5LineupBonus | So5MalusAfterTransferBonus | So5NationalityBonus | So5PlayerBonus | So5PositionBonus | So5PositionStacksBonus | So5SameActiveClubBonus | So5ScarcityBonus | So5SeasonBonus | So5SpecialEditionCardsBonus>;
  boosted: Scalars['Boolean']['output'];
  captain: Scalars['Boolean']['output'];
  cardBorderRadius: Scalars['Int']['output'];
  cleanScore?: Maybe<Scalars['Float']['output']>;
  eligiblePlayerGameScores: Array<BaseballPlayerGameScore | BasketballPlayerGameScore | PlayerGameScore | So5Score>;
  eligibleSo5Scores: Array<So5Score>;
  /** @deprecated Energy is deprecated */
  energized: Scalars['Boolean']['output'];
  firstGame?: Maybe<Game | GameOfBaseball | GameOfBasketball>;
  /**
   * Projected score minus the lowest score of the player star tier for NBA, minus
   * the L10 average otherwise, from the projection the bench sorts
   * GAIN_ON_PROJECTION on: the next game on a card bench with no fixture, the
   * fixture projection otherwise
   */
  gainOnProjection?: Maybe<Scalars['Float']['output']>;
  /** Appearance card level at that time */
  grade: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  index: Scalars['Int']['output'];
  licensed: Scalars['Boolean']['output'];
  /** When a bench object will be locked for a leaderboard */
  lockedAt: Scalars['ISO8601DateTime']['output'];
  /** Wether a bench object can be updated for a leaderboard */
  lockedForLeaderboard: Scalars['Boolean']['output'];
  pictureUrl?: Maybe<Scalars['String']['output']>;
  playedGames: Array<Game | GameOfBaseball | GameOfBasketball>;
  player: Player;
  playerGameScore?: Maybe<BaseballPlayerGameScore | BasketballPlayerGameScore | PlayerGameScore | So5Score>;
  position: Position;
  positions: Array<Position>;
  powerBreakdown: PowerBreakdown;
  /** PowerBreakdown as long as leaderboard is playable. PowerPointsBreakdown after */
  powerBreakdownOrPowerPointsBreakdown?: Maybe<PowerBreakdownOrPowerPointsBreakdown>;
  projectedScore?: Maybe<Scalars['Float']['output']>;
  rarity: Rarity;
  relevantStats: Scalars['Json']['output'];
  score: Scalars['Float']['output'];
  scoreStatus: ScoreStatus;
  so5Fixture: So5Fixture;
  so5Lineup: So5Lineup;
  status: Scalars['String']['output'];
  substitutionState: So5AppearanceSubstitutionState;
  upcomingGame?: Maybe<Game | GameOfBaseball | GameOfBasketball>;
  videoUrl?: Maybe<Scalars['String']['output']>;
  /** Appearance card XP at that time */
  xp: Scalars['Int']['output'];
  /** XP end range of appearance card level at that time */
  xpNeededForNextGrade?: Maybe<Scalars['Int']['output']>;
}


/** A SO5 Appearance - a card selected in a team for a SO5 fixture */
export interface So5AppearanceactiveSuspensionsArgs {
  so5LeaderboardSlug?: InputMaybe<Scalars['String']['input']>;
}


/** A SO5 Appearance - a card selected in a team for a SO5 fixture */
export interface So5AppearanceanyCardWithLivePrimaryOfferArgs {
  rarity?: InputMaybe<Rarity>;
}


/** A SO5 Appearance - a card selected in a team for a SO5 fixture */
export interface So5AppearanceaverageScoreArgs {
  type: AveragePlayerScore;
}


/** A SO5 Appearance - a card selected in a team for a SO5 fixture */
export interface So5AppearancebonusesArgs {
  highlighted?: InputMaybe<Scalars['Boolean']['input']>;
}


/** A SO5 Appearance - a card selected in a team for a SO5 fixture */
export interface So5AppearanceeligiblePlayerGameScoresArgs {
  boardId?: InputMaybe<Scalars['String']['input']>;
  gameId?: InputMaybe<Scalars['ID']['input']>;
  so5LeaderboardSlug?: InputMaybe<Scalars['String']['input']>;
  stepId?: InputMaybe<Scalars['String']['input']>;
  taskId?: InputMaybe<Scalars['ID']['input']>;
}


/** A SO5 Appearance - a card selected in a team for a SO5 fixture */
export interface So5AppearancelockedAtArgs {
  so5LeaderboardSlug?: InputMaybe<Scalars['String']['input']>;
}


/** A SO5 Appearance - a card selected in a team for a SO5 fixture */
export interface So5AppearancelockedForLeaderboardArgs {
  so5LeaderboardSlug?: InputMaybe<Scalars['String']['input']>;
}


/** A SO5 Appearance - a card selected in a team for a SO5 fixture */
export interface So5AppearancepictureUrlArgs {
  derivative?: InputMaybe<Scalars['String']['input']>;
}


/** A SO5 Appearance - a card selected in a team for a SO5 fixture */
export interface So5AppearanceprojectedScoreArgs {
  so5LeaderboardSlug: Scalars['String']['input'];
}


/** A SO5 Appearance - a card selected in a team for a SO5 fixture */
export interface So5AppearancescoreArgs {
  withBonus?: InputMaybe<Scalars['Boolean']['input']>;
}


/** A SO5 Appearance - a card selected in a team for a SO5 fixture */
export interface So5AppearancevideoUrlArgs {
  derivative?: InputMaybe<Scalars['String']['input']>;
}

export interface So5AppearanceBonusInterface {
  bonusBasisPoints: Scalars['Int']['output'];
  description?: Maybe<Scalars['String']['output']>;
  iconUrl: Scalars['String']['output'];
  key: Scalars['String']['output'];
  maxBonusBasisPoints: Scalars['Int']['output'];
  smallIconUrl: Scalars['String']['output'];
  title: Scalars['String']['output'];
}

/** The connection type for So5Appearance. */
export interface So5AppearanceConnection {
  __typename: 'So5AppearanceConnection';
  /** A list of edges. */
  edges: Array<So5AppearanceEdge>;
  hasAny: Scalars['Boolean']['output'];
  /** A list of nodes. */
  nodes: Array<So5Appearance>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
}

/** An edge in a connection. */
export interface So5AppearanceEdge {
  __typename: 'So5AppearanceEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<So5Appearance>;
}

/** A SO5 Appearance - a compose team bench object selected in a team for a SO5 fixture */
export interface So5AppearanceInput {
  boost?: InputMaybe<Scalars['Boolean']['input']>;
  captain: Scalars['Boolean']['input'];
  cardSlug?: InputMaybe<Scalars['String']['input']>;
  composeTeamBenchObjectId?: InputMaybe<Scalars['ID']['input']>;
  index?: InputMaybe<Scalars['Int']['input']>;
}

/** Shared interface between So5Appearance and MissedAppearance */
export interface So5AppearanceInterface {
  activeSuspensions: Array<Suspension>;
  anyCard?: Maybe<BaseballCard | Card | NBACard>;
  anyCardWithLivePrimaryOffer?: Maybe<BaseballCard | Card | NBACard>;
  anyPlayer: BaseballPlayer | NBAPlayer | Player;
  anyPlayerGameStats?: Maybe<PlayerGameStats | PlayerGameStatsBaseball | PlayerGameStatsBasketball>;
  anyTeam: Club | NationalTeam;
  averageScore?: Maybe<Scalars['Float']['output']>;
  bonus?: Maybe<Scalars['Float']['output']>;
  bonusPoints?: Maybe<Scalars['Float']['output']>;
  bonusRating?: Maybe<BonusOrdinalRatingEnum>;
  bonuses: Array<So5ActiveClubsBonus | So5AverageScoresBonus | So5BoostBonus | So5CaptainBonus | So5CollectionBonus | So5DifferentNationalitiesBonus | So5GradeBonus | So5LineupBonus | So5MalusAfterTransferBonus | So5NationalityBonus | So5PlayerBonus | So5PositionBonus | So5PositionStacksBonus | So5SameActiveClubBonus | So5ScarcityBonus | So5SeasonBonus | So5SpecialEditionCardsBonus>;
  boosted: Scalars['Boolean']['output'];
  captain: Scalars['Boolean']['output'];
  cardBorderRadius: Scalars['Int']['output'];
  cleanScore?: Maybe<Scalars['Float']['output']>;
  eligiblePlayerGameScores: Array<BaseballPlayerGameScore | BasketballPlayerGameScore | PlayerGameScore | So5Score>;
  eligibleSo5Scores: Array<So5Score>;
  /** @deprecated Energy is deprecated */
  energized: Scalars['Boolean']['output'];
  firstGame?: Maybe<Game | GameOfBaseball | GameOfBasketball>;
  /**
   * Projected score minus the lowest score of the player star tier for NBA, minus
   * the L10 average otherwise, from the projection the bench sorts
   * GAIN_ON_PROJECTION on: the next game on a card bench with no fixture, the
   * fixture projection otherwise
   */
  gainOnProjection?: Maybe<Scalars['Float']['output']>;
  /** Appearance card level at that time */
  grade: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  index: Scalars['Int']['output'];
  licensed: Scalars['Boolean']['output'];
  /** When a bench object will be locked for a leaderboard */
  lockedAt: Scalars['ISO8601DateTime']['output'];
  /** Wether a bench object can be updated for a leaderboard */
  lockedForLeaderboard: Scalars['Boolean']['output'];
  pictureUrl?: Maybe<Scalars['String']['output']>;
  playedGames: Array<Game | GameOfBaseball | GameOfBasketball>;
  player: Player;
  playerGameScore?: Maybe<BaseballPlayerGameScore | BasketballPlayerGameScore | PlayerGameScore | So5Score>;
  position: Position;
  positions: Array<Position>;
  powerBreakdown: PowerBreakdown;
  /** PowerBreakdown as long as leaderboard is playable. PowerPointsBreakdown after */
  powerBreakdownOrPowerPointsBreakdown?: Maybe<PowerBreakdownOrPowerPointsBreakdown>;
  projectedScore?: Maybe<Scalars['Float']['output']>;
  rarity: Rarity;
  relevantStats: Scalars['Json']['output'];
  score: Scalars['Float']['output'];
  scoreStatus: ScoreStatus;
  so5Fixture: So5Fixture;
  status: Scalars['String']['output'];
  upcomingGame?: Maybe<Game | GameOfBaseball | GameOfBasketball>;
  videoUrl?: Maybe<Scalars['String']['output']>;
  /** Appearance card XP at that time */
  xp: Scalars['Int']['output'];
  /** XP end range of appearance card level at that time */
  xpNeededForNextGrade?: Maybe<Scalars['Int']['output']>;
}


/** Shared interface between So5Appearance and MissedAppearance */
export interface So5AppearanceInterfaceactiveSuspensionsArgs {
  so5LeaderboardSlug?: InputMaybe<Scalars['String']['input']>;
}


/** Shared interface between So5Appearance and MissedAppearance */
export interface So5AppearanceInterfaceanyCardWithLivePrimaryOfferArgs {
  rarity?: InputMaybe<Rarity>;
}


/** Shared interface between So5Appearance and MissedAppearance */
export interface So5AppearanceInterfaceaverageScoreArgs {
  type: AveragePlayerScore;
}


/** Shared interface between So5Appearance and MissedAppearance */
export interface So5AppearanceInterfacebonusesArgs {
  highlighted?: InputMaybe<Scalars['Boolean']['input']>;
}


/** Shared interface between So5Appearance and MissedAppearance */
export interface So5AppearanceInterfaceeligiblePlayerGameScoresArgs {
  boardId?: InputMaybe<Scalars['String']['input']>;
  gameId?: InputMaybe<Scalars['ID']['input']>;
  so5LeaderboardSlug?: InputMaybe<Scalars['String']['input']>;
  stepId?: InputMaybe<Scalars['String']['input']>;
  taskId?: InputMaybe<Scalars['ID']['input']>;
}


/** Shared interface between So5Appearance and MissedAppearance */
export interface So5AppearanceInterfacelockedAtArgs {
  so5LeaderboardSlug?: InputMaybe<Scalars['String']['input']>;
}


/** Shared interface between So5Appearance and MissedAppearance */
export interface So5AppearanceInterfacelockedForLeaderboardArgs {
  so5LeaderboardSlug?: InputMaybe<Scalars['String']['input']>;
}


/** Shared interface between So5Appearance and MissedAppearance */
export interface So5AppearanceInterfacepictureUrlArgs {
  derivative?: InputMaybe<Scalars['String']['input']>;
}


/** Shared interface between So5Appearance and MissedAppearance */
export interface So5AppearanceInterfaceprojectedScoreArgs {
  so5LeaderboardSlug: Scalars['String']['input'];
}


/** Shared interface between So5Appearance and MissedAppearance */
export interface So5AppearanceInterfacescoreArgs {
  withBonus?: InputMaybe<Scalars['Boolean']['input']>;
}


/** Shared interface between So5Appearance and MissedAppearance */
export interface So5AppearanceInterfacevideoUrlArgs {
  derivative?: InputMaybe<Scalars['String']['input']>;
}

/** Preview appearance information */
export interface So5AppearancePreview {
  __typename: 'So5AppearancePreview';
  bonuses: Array<So5ActiveClubsBonus | So5AverageScoresBonus | So5BoostBonus | So5CaptainBonus | So5CollectionBonus | So5DifferentNationalitiesBonus | So5GradeBonus | So5LineupBonus | So5MalusAfterTransferBonus | So5NationalityBonus | So5PlayerBonus | So5PositionBonus | So5PositionStacksBonus | So5SameActiveClubBonus | So5ScarcityBonus | So5SeasonBonus | So5SpecialEditionCardsBonus>;
  /** @deprecated Energy is deprecated */
  energized: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  /** Total card bonus (XP + Season bonus) */
  power: Scalars['String']['output'];
  powerBreakdown: PowerBreakdown;
}


/** Preview appearance information */
export interface So5AppearancePreviewbonusesArgs {
  highlighted?: InputMaybe<Scalars['Boolean']['input']>;
}

export const So5AppearanceSubstitutionState = {
  ON_BENCH: 'ON_BENCH',
  STARTER: 'STARTER',
  SUBBED_IN: 'SUBBED_IN',
  SUBBED_OUT: 'SUBBED_OUT'
} as const;

export type So5AppearanceSubstitutionState = typeof So5AppearanceSubstitutionState[keyof typeof So5AppearanceSubstitutionState];
export interface So5AppearancesRule extends So5RuleInterface {
  __typename: 'So5AppearancesRule';
  appearances?: Maybe<Array<AppearanceRule>>;
  descriptions: Array<So5RuleDescription>;
  id: Scalars['String']['output'];
  key: Scalars['String']['output'];
}


export interface So5AppearancesRuleappearancesArgs {
  includeSubs?: InputMaybe<Scalars['Boolean']['input']>;
}

/** The at least of clubs rule of a So5Leaderboard */
export interface So5AtLeastOfClubs extends So5RuleInterface {
  __typename: 'So5AtLeastOfClubs';
  clubs: Array<Club>;
  descriptions: Array<So5RuleDescription>;
  id: Scalars['String']['output'];
  key: Scalars['String']['output'];
  min: Scalars['Int']['output'];
}

/** The at least of competitions rule of a So5Leaderboard */
export interface So5AtLeastOfCompetitions extends So5RuleInterface {
  __typename: 'So5AtLeastOfCompetitions';
  competitions: Array<Competition>;
  descriptions: Array<So5RuleDescription>;
  id: Scalars['String']['output'];
  key: Scalars['String']['output'];
  min: Scalars['Int']['output'];
}

/** The average scores bonus of an appearance */
export interface So5AverageScoresBonus extends So5AppearanceBonusInterface {
  __typename: 'So5AverageScoresBonus';
  bonusBasisPoints: Scalars['Int']['output'];
  description?: Maybe<Scalars['String']['output']>;
  iconUrl: Scalars['String']['output'];
  key: Scalars['String']['output'];
  max: Scalars['Int']['output'];
  maxBonusBasisPoints: Scalars['Int']['output'];
  smallIconUrl: Scalars['String']['output'];
  title: Scalars['String']['output'];
}

export interface So5AverageScoresRule extends So5RuleInterface {
  __typename: 'So5AverageScoresRule';
  averageType: BudgetType;
  descriptions: Array<So5RuleDescription>;
  id: Scalars['String']['output'];
  immuneAppearances: Scalars['Int']['output'];
  key: Scalars['String']['output'];
  max: Scalars['Int']['output'];
}

/** The boost bonus of an appearance */
export interface So5BoostBonus extends So5AppearanceBonusInterface {
  __typename: 'So5BoostBonus';
  bonusBasisPoints: Scalars['Int']['output'];
  description?: Maybe<Scalars['String']['output']>;
  iconUrl: Scalars['String']['output'];
  key: Scalars['String']['output'];
  maxBonusBasisPoints: Scalars['Int']['output'];
  smallIconUrl: Scalars['String']['output'];
  title: Scalars['String']['output'];
}

/** The captain bonus of an appearance */
export interface So5CaptainBonus extends So5AppearanceBonusInterface {
  __typename: 'So5CaptainBonus';
  bonusBasisPoints: Scalars['Int']['output'];
  description?: Maybe<Scalars['String']['output']>;
  iconUrl: Scalars['String']['output'];
  key: Scalars['String']['output'];
  maxBonusBasisPoints: Scalars['Int']['output'];
  smallIconUrl: Scalars['String']['output'];
  title: Scalars['String']['output'];
}

export interface So5CaptainRule extends So5RuleInterface {
  __typename: 'So5CaptainRule';
  bonus: Scalars['Float']['output'];
  descriptions: Array<So5RuleDescription>;
  id: Scalars['String']['output'];
  inSeason?: Maybe<Scalars['Boolean']['output']>;
  key: Scalars['String']['output'];
  rarities: Array<Rarity>;
}

export interface So5CaptainScarcityRule extends So5RuleInterface {
  __typename: 'So5CaptainScarcityRule';
  bonus: Scalars['Float']['output'];
  descriptions: Array<So5RuleDescription>;
  id: Scalars['String']['output'];
  inSeason?: Maybe<Scalars['Boolean']['output']>;
  key: Scalars['String']['output'];
  rarities: Array<Rarity>;
}

export interface So5CardEditionsCountRule extends So5RuleInterface {
  __typename: 'So5CardEditionsCountRule';
  customCardEditionNames: Array<Scalars['String']['output']>;
  descriptions: Array<So5RuleDescription>;
  id: Scalars['String']['output'];
  key: Scalars['String']['output'];
}

export interface So5CardRewardBoost extends So5RewardBoostInterface {
  __typename: 'So5CardRewardBoost';
  boostLevel: BoostLevel;
  maximumBoostLevel: BoostLevel;
  mvp: Scalars['Boolean']['output'];
  nbCards: Scalars['Int']['output'];
  nextBoostLevel?: Maybe<BoostLevel>;
  points: Scalars['Int']['output'];
  rarity: Rarity;
  seasonality: So5LeaderboardSeasonality;
}

/** A card shards entry item */
export interface So5CardShardsEntryItem extends So5EntryItemInterface {
  __typename: 'So5CardShardsEntryItem';
  cardSet?: Maybe<CardSet>;
  id: Scalars['ID']['output'];
  myCardShardsChest?: Maybe<CardShardsChest>;
  myEntryItemId?: Maybe<Scalars['ID']['output']>;
  quantity: Scalars['Int']['output'];
  rarity: Rarity;
}

/** The collection bonus of an appearance */
export interface So5CollectionBonus extends So5AppearanceBonusInterface {
  __typename: 'So5CollectionBonus';
  bonusBasisPoints: Scalars['Int']['output'];
  description?: Maybe<Scalars['String']['output']>;
  iconUrl: Scalars['String']['output'];
  key: Scalars['String']['output'];
  maxBonusBasisPoints: Scalars['Int']['output'];
  smallIconUrl: Scalars['String']['output'];
  title: Scalars['String']['output'];
}

/** A So5 Competition */
export interface So5Competition {
  __typename: 'So5Competition';
  algoliaFilters: Scalars['String']['output'];
  backgroundUrl: Scalars['String']['output'];
  /** The `cards` field cannot be nested within a list. */
  cards: AnyCardInterfaceConnection;
  color: Scalars['String']['output'];
  /** @deprecated Not maintained anymore */
  commonGameAvailable: Scalars['Boolean']['output'];
  competitions: Array<Competition>;
  displayName: Scalars['String']['output'];
  headerBackgroundDesktopUrl: Scalars['String']['output'];
  headerBackgroundUrl: Scalars['String']['output'];
  iconUrl: Scalars['String']['output'];
  logoUrl: Scalars['String']['output'];
  /** The `playable_so5_leaderboard_group_interfaces` field cannot be nested within a list. */
  playableSo5LeaderboardGroupInterfaces: Array<So5LeaderboardGroup | So5League>;
  scoutable: Scalars['Boolean']['output'];
  seasonalityInYears: Array<Scalars['Int']['output']>;
  seasonalityName: Scalars['String']['output'];
  slug: Scalars['String']['output'];
}


/** A So5 Competition */
export interface So5CompetitioncardsArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  age?: InputMaybe<Scalars['Int']['input']>;
  assetIds?: InputMaybe<Array<Scalars['String']['input']>>;
  before?: InputMaybe<Scalars['String']['input']>;
  classicOnly?: InputMaybe<Scalars['Boolean']['input']>;
  customCardEditionName?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  inActiveCompetitions?: InputMaybe<Array<Scalars['String']['input']>>;
  inSeasonEligible?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  owned?: InputMaybe<Scalars['Boolean']['input']>;
  ownedByMe?: InputMaybe<Scalars['Boolean']['input']>;
  ownedSinceAfter?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  playerSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  positions?: InputMaybe<Array<Position>>;
  rarities?: InputMaybe<Array<Rarity>>;
  revealable?: InputMaybe<Scalars['Boolean']['input']>;
  seasonStartYears?: InputMaybe<Array<Scalars['Int']['input']>>;
  serialNumber?: InputMaybe<Scalars['Int']['input']>;
  shirtNumber?: InputMaybe<Scalars['Int']['input']>;
  slugs?: InputMaybe<Array<Scalars['String']['input']>>;
  sorts?: InputMaybe<Array<CardSort>>;
  sport?: InputMaybe<Sport>;
  teamSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  withinDeckFirst?: InputMaybe<Scalars['String']['input']>;
}


/** A So5 Competition */
export interface So5CompetitioncolorArgs {
  variant?: InputMaybe<ColorVariant>;
}


/** A So5 Competition */
export interface So5CompetitionseasonalityNameArgs {
  seasonality: So5LeaderboardSeasonality;
}

/** A spotlight promoting a So5 competition */
export interface So5CompetitionSpotlight extends Node, Spotlight {
  __typename: 'So5CompetitionSpotlight';
  backgroundUrl?: Maybe<Scalars['String']['output']>;
  /** The current user board for the spotlighted tasks track */
  board?: Maybe<CareerBoard | SquadBoard>;
  body?: Maybe<Scalars['String']['output']>;
  category: SpotlightCategory;
  /** Card accent as a #RRGGBB hex code */
  color?: Maybe<Scalars['String']['output']>;
  ctaLabel?: Maybe<Scalars['String']['output']>;
  /** Deep link to open on tap */
  ctaUrl?: Maybe<Scalars['String']['output']>;
  /** Deep link to open on tap, when the spotlight targets the app */
  deeplinkUrl?: Maybe<Scalars['String']['output']>;
  endDate: Scalars['ISO8601DateTime']['output'];
  featured: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  /** Optional callout artwork displayed alongside the shortcut badge */
  shortcutBadgeCalloutUrl?: Maybe<Scalars['String']['output']>;
  /** Featured-only badge for the Play entry point */
  shortcutBadgeUrl?: Maybe<Scalars['String']['output']>;
  /** Accessibility and analytics label for the shortcut badge */
  shortcutName?: Maybe<Scalars['String']['output']>;
  /** Whether to count down to endDate rather than label the spotlight as live */
  showCountdown: Scalars['Boolean']['output'];
  so5Leaderboard?: Maybe<So5Leaderboard>;
  startDate: Scalars['ISO8601DateTime']['output'];
  statTiles: Array<SpotlightStatTile>;
  tagChips: Array<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  /** Whether the current user already tapped this spotlight, false when anonymous */
  viewed: Scalars['Boolean']['output'];
}

export interface So5CompetitionsRule extends So5RuleInterface {
  __typename: 'So5CompetitionsRule';
  competitions: Array<Competition>;
  descriptions: Array<So5RuleDescription>;
  id: Scalars['String']['output'];
  key: Scalars['String']['output'];
}

/** So5 Global Config */
export interface So5Config {
  __typename: 'So5Config';
  cardCollections: Array<CardCollection>;
  /** @deprecated Energy is deprecated */
  energyCostPerAppearance?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  leaguesAlgoliaFilters: Scalars['Json']['output'];
  noCardRoute: NoCardRoute;
  probablePitchersForNextGameWeeks: Array<ProbablePitchersForGameWeek>;
  tasksExpiresAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  teamsPlayingNextGameWeeks: Array<TeamsPlayingNextGameWeek>;
  /** List of all the possible tournament rarity types */
  tournamentRarityTypes: Array<Scalars['String']['output']>;
  /** List of all the possible tournament types */
  tournamentTypes: Array<Scalars['String']['output']>;
}


/** So5 Global Config */
export interface So5ConfigenergyCostPerAppearanceArgs {
  eventType: So5FixtureEvent;
  sport: Sport;
}


/** So5 Global Config */
export interface So5ConfigleaguesAlgoliaFiltersArgs {
  sport: Sport;
}


/** So5 Global Config */
export interface So5ConfignoCardRouteArgs {
  eventType?: InputMaybe<So5FixtureEvent>;
  sport?: InputMaybe<Sport>;
}


/** So5 Global Config */
export interface So5ConfigtasksExpiresAtArgs {
  periodicity: ManagerTaskPeriodicity;
}


/** So5 Global Config */
export interface So5ConfigteamsPlayingNextGameWeeksArgs {
  eventType?: InputMaybe<So5FixtureEvent>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sport: Sport;
}

/** Object that can be a So5 cover */
export type So5Cover = FeaturedSo5LeaderboardContenders | FeaturedSo5LeaderboardGroups | So5Leaderboard;

export interface So5CurrentUserInterface {
  /** List of current user blockchain cards engaged in lineups (for live or upcoming fixtures) */
  blockchainCardsInLineups: Array<Scalars['String']['output']>;
  footballLast30DaysLineupsCount: Scalars['Int']['output'];
  forcedIntoOnboarding: Scalars['Boolean']['output'];
  last30DaysLineupsCount: IntegerBySportType;
  /**
   * Boosted rewards based on eligible reward configs The
   * `my_unclaimed_boosted_reward_configs_by_rarity` field cannot be nested within a list.
   */
  myUnclaimedBoostedRewardConfigsByRarity: Array<RarityRewardConfigs>;
  /** The `my_unclaimed_eligible_reward_configs` field cannot be nested within a list. */
  myUnclaimedEligibleRewardConfigs: Array<CardPacksRewardConfig | CardRewardConfig | CardShardRewardConfig | CoinRewardConfig | ConversionCreditRewardConfig | DeliverableItemRewardConfig | ExperienceRewardConfig | InGameCurrencyRewardConfig | MonetaryRewardConfig | ProbabilisticBundleRewardConfig | ShopItemRewardConfig>;
  myUnclaimedSo5RewardsNeedKycVerification: Scalars['Boolean']['output'];
  myUnclaimedSo5RewardsNeedPhoneVerification: Scalars['Boolean']['output'];
  /** If the so5 no card route is open for submission */
  so5NoCardRouteOpened: Scalars['Boolean']['output'];
  unclaimedSo5Rewards: Array<So5Reward>;
}


export interface So5CurrentUserInterfaceblockchainCardsInLineupsArgs {
  sport?: InputMaybe<Sport>;
}


export interface So5CurrentUserInterfaceforcedIntoOnboardingArgs {
  sport?: InputMaybe<Sport>;
}


export interface So5CurrentUserInterfacemyUnclaimedBoostedRewardConfigsByRarityArgs {
  sport: Sport;
}


export interface So5CurrentUserInterfacemyUnclaimedEligibleRewardConfigsArgs {
  multiplyBaseRewards?: InputMaybe<Scalars['Boolean']['input']>;
  sport: Sport;
}


export interface So5CurrentUserInterfacemyUnclaimedSo5RewardsNeedKycVerificationArgs {
  sport: Sport;
}


export interface So5CurrentUserInterfacemyUnclaimedSo5RewardsNeedPhoneVerificationArgs {
  sport: Sport;
}


export interface So5CurrentUserInterfaceso5NoCardRouteOpenedArgs {
  sport?: InputMaybe<Sport>;
}


export interface So5CurrentUserInterfaceunclaimedSo5RewardsArgs {
  sport?: InputMaybe<Sport>;
}

/** A SO5 Deliverable Item Reward */
export interface So5DeliverableItemReward {
  __typename: 'So5DeliverableItemReward';
  deliverableItem?: Maybe<ExperienceDeliverableItem | JerseyDeliverableItem | TicketsDeliverableItem | WearableDeliverableItem>;
  quantity: Scalars['Int']['output'];
}

/** The different nationalities bonus of an appearance */
export interface So5DifferentNationalitiesBonus extends So5AppearanceBonusInterface {
  __typename: 'So5DifferentNationalitiesBonus';
  bonusBasisPoints: Scalars['Int']['output'];
  description?: Maybe<Scalars['String']['output']>;
  iconUrl: Scalars['String']['output'];
  key: Scalars['String']['output'];
  maxBonusBasisPoints: Scalars['Int']['output'];
  smallIconUrl: Scalars['String']['output'];
  title: Scalars['String']['output'];
}

export interface So5EntryItemInterface {
  id: Scalars['ID']['output'];
  myEntryItemId?: Maybe<Scalars['ID']['output']>;
}

/** The entry item rule of a So5Leaderboard */
export interface So5EntryItemRule extends So5RuleInterface {
  __typename: 'So5EntryItemRule';
  descriptions: Array<So5RuleDescription>;
  entryItem: So5CardShardsEntryItem;
  id: Scalars['String']['output'];
  key: Scalars['String']['output'];
}

/** A SO5 fixture */
export interface So5Fixture extends Node, So5FixturePublicInterface {
  __typename: 'So5Fixture';
  aasmState: Scalars['String']['output'];
  /** The `any_games` field cannot be nested within a list. */
  anyGames: Array<Game | GameOfBaseball | GameOfBasketball>;
  canCompose: Scalars['Boolean']['output'];
  /** The `competitions` field cannot be nested within a list. */
  competitions: Array<Competition>;
  cutOffDate: Scalars['ISO8601DateTime']['output'];
  displayName: Scalars['String']['output'];
  endDate: Scalars['ISO8601DateTime']['output'];
  event?: Maybe<Event>;
  eventName?: Maybe<Scalars['String']['output']>;
  eventType: Scalars['String']['output'];
  expectedRewardsDistributionDate?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** The `fixture_games_with_player_game_scores_preview` field cannot be nested within a list. */
  fixtureGamesWithPlayerGameScoresPreview: GameWithPlayerGameScoresPreviewConnection;
  gameWeek: Scalars['Int']['output'];
  /** The `games` field cannot be nested within a list. */
  games: Array<Game>;
  /** The `games_with_my_player_game_scores_preview` field cannot be nested within a list. */
  gamesWithMyPlayerGameScoresPreview: GameWithPlayerGameScoresPreviewConnection;
  id: Scalars['ID']['output'];
  live: Scalars['Boolean']['output'];
  longDisplayName: Scalars['String']['output'];
  /**
   * Boosted rewards based on eligible reward configs The
   * `my_boosted_reward_configs_by_rarity` field cannot be nested within a list.
   */
  myBoostedRewardConfigsByRarity: Array<RarityRewardConfigs>;
  /** The `my_completed_thresholds_streak_tasks_count` field cannot be nested within a list. */
  myCompletedThresholdsStreakTasksCount: Scalars['Int']['output'];
  /**
   * Eligible rewards until so5 fixture is closed, actual so5 rewards after The
   * `my_eligible_or_so5_rewards` field cannot be nested within a list.
   */
  myEligibleOrSo5Rewards: Array<So5RewardOrConfig>;
  /** The `my_eligible_reward_configs` field cannot be nested within a list. */
  myEligibleRewardConfigs: Array<CardPacksRewardConfig | CardRewardConfig | CardShardRewardConfig | CoinRewardConfig | ConversionCreditRewardConfig | DeliverableItemRewardConfig | ExperienceRewardConfig | InGameCurrencyRewardConfig | MonetaryRewardConfig | ProbabilisticBundleRewardConfig | ShopItemRewardConfig>;
  /** The `my_featured_so5_leaderboard_group` field cannot be nested within a list. */
  myFeaturedSo5LeaderboardGroup?: Maybe<So5LeaderboardGroup | So5League>;
  /** The `my_friends_fixture_results` field cannot be nested within a list. */
  myFriendsFixtureResults?: Maybe<UserFixtureResultsConnection>;
  myFriendsFixtureResultsPreview: UsersFixtureResultsPreview;
  /** The `my_live_player_game_scores_count` field cannot be nested within a list. */
  myLivePlayerGameScoresCount: Scalars['Int']['output'];
  /** The `my_lobby_section` field cannot be nested within a list. */
  myLobbySection: LobbySection;
  myMissedLineup: MissedLineup;
  /** The `my_missed_lineups` field cannot be nested within a list. */
  myMissedLineups: Array<MissedLineup>;
  /** The `my_so5_games` field cannot be nested within a list. */
  mySo5Games: Array<Game>;
  /** The `my_so5_leaderboard_contenders` field cannot be nested within a list. */
  mySo5LeaderboardContenders: So5LeaderboardContenderConnection;
  /** The `my_so5_league_tracks` field cannot be nested within a list. */
  mySo5LeagueTracks: Array<So5LeagueTrack>;
  mySo5Lineups: Array<So5Lineup>;
  /** The `my_so5_lineups_count` field cannot be nested within a list. */
  mySo5LineupsCount: Scalars['Int']['output'];
  mySo5LineupsPaginated: So5LineupConnection;
  mySo5Rankings: Array<So5Ranking>;
  mySo5Rewards: Array<So5Reward>;
  /** The `my_so5_user_groups` field cannot be nested within a list. */
  mySo5UserGroups: So5UserGroupConnection;
  myTotalXpWon: Scalars['Int']['output'];
  myUnclaimedSo5RewardsNeedKycVerification: Scalars['Boolean']['output'];
  myUnclaimedSo5RewardsNeedPhoneVerification: Scalars['Boolean']['output'];
  /** The `my_user_groups` field cannot be nested within a list. */
  myUserGroups: UserGroupInterfaceConnection;
  /** The `next` field cannot be nested within a list. */
  next?: Maybe<So5Fixture>;
  /** The `no_card_route_pick_configs` field cannot be nested within a list. */
  noCardRoutePickConfigs: Array<So5NoCardRouteFixturePickConfig>;
  /** The `ordered_player_game_scores` field cannot be nested within a list. */
  orderedPlayerGameScores: Array<OrderedPlayerGameScores>;
  /** Get ordered PlayerGameScore by position (default to all positions) */
  orderedPlayerGameScoresByPosition: PlayerGameScoreInterfaceConnection;
  /** The `ordered_so5_scores` field cannot be nested within a list. */
  orderedSo5Scores: Array<OrderedSo5Scores>;
  /** Get ordered So5Score by position (default to all positions) */
  orderedSo5ScoresByPosition: So5ScoreConnection;
  /** The `players` field cannot be nested within a list. */
  players: AnyPlayerInterfaceConnection;
  /** The `previous` field cannot be nested within a list. */
  previous?: Maybe<So5Fixture>;
  projectedLineupsReadyAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  replayedFixture?: Maybe<So5Fixture>;
  rewardsDeliveryDate: Scalars['ISO8601DateTime']['output'];
  seasonGameWeek?: Maybe<Scalars['Int']['output']>;
  shortDisplayName: Scalars['String']['output'];
  slug: Scalars['String']['output'];
  /** The `so5_fixture_players` field cannot be nested within a list. */
  so5FixturePlayers: FixturePlayerConnection;
  /** The `so5_leaderboard` field cannot be nested within a list. */
  so5Leaderboard?: Maybe<So5Leaderboard>;
  /** The `so5_leaderboard_contenders` field cannot be nested within a list. */
  so5LeaderboardContenders: So5LeaderboardContenderConnection;
  so5LeaderboardGroups: Array<So5LeaderboardGroup | So5League>;
  /** The `so5_leaderboards` field cannot be nested within a list. */
  so5Leaderboards: Array<So5Leaderboard>;
  /** The `so5_leaderboards_paginated` field cannot be nested within a list. */
  so5LeaderboardsPaginated: So5LeaderboardConnection;
  /** The `so5_leagues` field cannot be nested within a list. */
  so5Leagues: Array<So5League>;
  so5LineupsPaginated: So5LineupConnection;
  specialWeeklyBanner?: Maybe<SpecialWeeklyBanner>;
  sport: Sport;
  startDate: Scalars['ISO8601DateTime']['output'];
  timeZone: Scalars['String']['output'];
  totalRewards: RewardsOverview;
  type: So5FixtureEvent;
  userFixtureResults?: Maybe<UserFixtureResults>;
}


/** A SO5 fixture */
export interface So5FixtureanyGamesArgs {
  fromDate?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  toDate?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
}


/** A SO5 fixture */
export interface So5FixturefixtureGamesWithPlayerGameScoresPreviewArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  fromDate?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  myGamesOnly?: InputMaybe<Scalars['Boolean']['input']>;
  toDate?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
}


/** A SO5 fixture */
export interface So5FixturegamesArgs {
  fromDate?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  toDate?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
}


/** A SO5 fixture */
export interface So5FixturegamesWithMyPlayerGameScoresPreviewArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  fromDate?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  includeWithoutPlayerGameScores?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  toDate?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
}


/** A SO5 fixture */
export interface So5FixturemyCompletedThresholdsStreakTasksCountArgs {
  rarities?: InputMaybe<Array<Rarity>>;
}


/** A SO5 fixture */
export interface So5FixturemyEligibleOrSo5RewardsArgs {
  multiplyBaseRewards?: InputMaybe<Scalars['Boolean']['input']>;
}


/** A SO5 fixture */
export interface So5FixturemyEligibleRewardConfigsArgs {
  includeThresholdsStreakTasks?: InputMaybe<Scalars['Boolean']['input']>;
  multiplyBaseRewards?: InputMaybe<Scalars['Boolean']['input']>;
}


/** A SO5 fixture */
export interface So5FixturemyFeaturedSo5LeaderboardGroupArgs {
  includingHidden?: InputMaybe<Scalars['Boolean']['input']>;
}


/** A SO5 fixture */
export interface So5FixturemyFriendsFixtureResultsArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
}


/** A SO5 fixture */
export interface So5FixturemyLobbySectionArgs {
  section: LobbySectionType;
}


/** A SO5 fixture */
export interface So5FixturemyMissedLineupArgs {
  slug: Scalars['String']['input'];
}


/** A SO5 fixture */
export interface So5FixturemySo5LeaderboardContendersArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sortType?: InputMaybe<So5LeaderboardContenderSort>;
  withTraining?: InputMaybe<Scalars['Boolean']['input']>;
}


/** A SO5 fixture */
export interface So5FixturemySo5LineupsArgs {
  draft?: InputMaybe<Scalars['Boolean']['input']>;
  so5LeaderboardSlug?: InputMaybe<Scalars['String']['input']>;
  sortType?: InputMaybe<CustomSortingOption>;
  withTraining?: InputMaybe<Scalars['Boolean']['input']>;
}


/** A SO5 fixture */
export interface So5FixturemySo5LineupsCountArgs {
  draft?: InputMaybe<Scalars['Boolean']['input']>;
  so5LeaderboardSlug?: InputMaybe<Scalars['String']['input']>;
  training?: InputMaybe<Scalars['Boolean']['input']>;
}


/** A SO5 fixture */
export interface So5FixturemySo5LineupsPaginatedArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  draft?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  so5LeaderboardSlug?: InputMaybe<Scalars['String']['input']>;
  sortType?: InputMaybe<CustomSortingOption>;
  withTraining?: InputMaybe<Scalars['Boolean']['input']>;
}


/** A SO5 fixture */
export interface So5FixturemySo5RankingsArgs {
  first?: InputMaybe<Scalars['Int']['input']>;
  withDraft?: InputMaybe<Scalars['Boolean']['input']>;
  withTraining?: InputMaybe<Scalars['Boolean']['input']>;
}


/** A SO5 fixture */
export interface So5FixturemySo5UserGroupsArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  statuses?: InputMaybe<Array<UserGroupStatus>>;
}


/** A SO5 fixture */
export interface So5FixturemyUserGroupsArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  statuses?: InputMaybe<Array<UserGroupStatus>>;
}


/** A SO5 fixture */
export interface So5FixtureorderedPlayerGameScoresArgs {
  first: Scalars['Int']['input'];
}


/** A SO5 fixture */
export interface So5FixtureorderedPlayerGameScoresByPositionArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  minScore?: InputMaybe<Scalars['Int']['input']>;
  positionsTyped?: InputMaybe<Array<Position>>;
  sellable?: InputMaybe<Scalars['Boolean']['input']>;
}


/** A SO5 fixture */
export interface So5FixtureorderedSo5ScoresArgs {
  first: Scalars['Int']['input'];
}


/** A SO5 fixture */
export interface So5FixtureorderedSo5ScoresByPositionArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  minScore?: InputMaybe<Scalars['Int']['input']>;
  myCardsRarities?: InputMaybe<Array<Rarity>>;
  positionsTyped?: InputMaybe<Array<Position>>;
  sellable?: InputMaybe<Scalars['Boolean']['input']>;
}


/** A SO5 fixture */
export interface So5FixtureplayersArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<BenchFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
}


/** A SO5 fixture */
export interface So5Fixtureso5FixturePlayersArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  competitionSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  excludingSealed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  myCardsRarities?: InputMaybe<Array<Rarity>>;
  positions?: InputMaybe<Array<Position>>;
}


/** A SO5 fixture */
export interface So5Fixtureso5LeaderboardArgs {
  so5LeaderboardType: So5LeaderboardType;
}


/** A SO5 fixture */
export interface So5Fixtureso5LeaderboardContendersArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  userSlug: Scalars['String']['input'];
  withTraining?: InputMaybe<Scalars['Boolean']['input']>;
}


/** A SO5 fixture */
export interface So5Fixtureso5LeaderboardGroupsArgs {
  groupType?: InputMaybe<So5LeaderboardGroupType>;
  includeClosed?: InputMaybe<Scalars['Boolean']['input']>;
}


/** A SO5 fixture */
export interface So5Fixtureso5LeaderboardsArgs {
  sortType?: InputMaybe<CustomSortingOption>;
}


/** A SO5 fixture */
export interface So5Fixtureso5LeaderboardsPaginatedArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sortType?: InputMaybe<CustomSortingOption>;
}


/** A SO5 fixture */
export interface So5Fixtureso5LineupsPaginatedArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  draft?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  so5LeaderboardSlug?: InputMaybe<Scalars['String']['input']>;
  sortType?: InputMaybe<CustomSortingOption>;
  userSlug: Scalars['String']['input'];
  withTraining?: InputMaybe<Scalars['Boolean']['input']>;
}


/** A SO5 fixture */
export interface So5FixtureuserFixtureResultsArgs {
  groupType?: InputMaybe<So5LeaderboardGroupType>;
  userSlug: Scalars['String']['input'];
}

/** The connection type for So5Fixture. */
export interface So5FixtureConnection {
  __typename: 'So5FixtureConnection';
  /** A list of edges. */
  edges: Array<So5FixtureEdge>;
  /** A list of nodes. */
  nodes: Array<So5Fixture>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
}

/** An edge in a connection. */
export interface So5FixtureEdge {
  __typename: 'So5FixtureEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<So5Fixture>;
}

export const So5FixtureEvent = {
  CLASSIC: 'CLASSIC',
  DAILY: 'DAILY',
  MEDIA_LEAGUE: 'MEDIA_LEAGUE',
  RANDOMIZED: 'RANDOMIZED'
} as const;

export type So5FixtureEvent = typeof So5FixtureEvent[keyof typeof So5FixtureEvent];
export interface So5FixturePreparing extends Node, So5FixturePublicInterface {
  __typename: 'So5FixturePreparing';
  cutOffDate: Scalars['ISO8601DateTime']['output'];
  displayName: Scalars['String']['output'];
  endDate: Scalars['ISO8601DateTime']['output'];
  eventName?: Maybe<Scalars['String']['output']>;
  expectedRewardsDistributionDate?: Maybe<Scalars['ISO8601DateTime']['output']>;
  gameWeek: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  longDisplayName: Scalars['String']['output'];
  seasonGameWeek?: Maybe<Scalars['Int']['output']>;
  shortDisplayName: Scalars['String']['output'];
  slug: Scalars['String']['output'];
  sport: Sport;
  startDate: Scalars['ISO8601DateTime']['output'];
  timeZone: Scalars['String']['output'];
}

export interface So5FixturePublicInterface {
  cutOffDate: Scalars['ISO8601DateTime']['output'];
  displayName: Scalars['String']['output'];
  endDate: Scalars['ISO8601DateTime']['output'];
  eventName?: Maybe<Scalars['String']['output']>;
  expectedRewardsDistributionDate?: Maybe<Scalars['ISO8601DateTime']['output']>;
  gameWeek: Scalars['Int']['output'];
  longDisplayName: Scalars['String']['output'];
  seasonGameWeek?: Maybe<Scalars['Int']['output']>;
  shortDisplayName: Scalars['String']['output'];
  slug: Scalars['String']['output'];
  sport: Sport;
  startDate: Scalars['ISO8601DateTime']['output'];
  timeZone: Scalars['String']['output'];
}

/** The connection type for So5FixturePublicInterface. */
export interface So5FixturePublicInterfaceConnection {
  __typename: 'So5FixturePublicInterfaceConnection';
  /** A list of edges. */
  edges: Array<So5FixturePublicInterfaceEdge>;
  /** A list of nodes. */
  nodes: Array<So5Fixture | So5FixturePreparing>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
}

/** An edge in a connection. */
export interface So5FixturePublicInterfaceEdge {
  __typename: 'So5FixturePublicInterfaceEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<So5Fixture | So5FixturePreparing>;
}

/** The grade bonus of an appearance */
export interface So5GradeBonus extends So5AppearanceBonusInterface {
  __typename: 'So5GradeBonus';
  bonusBasisPoints: Scalars['Int']['output'];
  description?: Maybe<Scalars['String']['output']>;
  iconUrl: Scalars['String']['output'];
  key: Scalars['String']['output'];
  maxBonusBasisPoints: Scalars['Int']['output'];
  smallIconUrl: Scalars['String']['output'];
  title: Scalars['String']['output'];
}

/** A So5 Leaderboard */
export interface So5Leaderboard extends Node, So5LeaderboardRulesInterface {
  __typename: 'So5Leaderboard';
  algoliaFilters?: Maybe<Scalars['String']['output']>;
  canCompose: Validity;
  composeBuy: Scalars['Boolean']['output'];
  composeDisclaimer?: Maybe<Scalars['String']['output']>;
  cutOffDate: Scalars['ISO8601DateTime']['output'];
  defaultAverageScore?: Maybe<AveragePlayerScore>;
  defaultSortType: BenchSort;
  description?: Maybe<Scalars['String']['output']>;
  displayName: Scalars['String']['output'];
  displayedRules?: Maybe<So5Rules>;
  displayedTypedRules: Array<CardsCountAsFirstOwnerRule | OwnedSinceRule | PlayerHeightRule | SeasonsRule | So5ActiveClubsRule | So5ActiveNationalTeamsRule | So5AgeRule | So5AppearancesRule | So5AtLeastOfClubs | So5AtLeastOfCompetitions | So5AverageScoresRule | So5CaptainRule | So5CaptainScarcityRule | So5CardEditionsCountRule | So5CompetitionsRule | So5EntryItemRule | So5MaximumPlayersAverageScoreRule | So5MinimumPlayersAverageScoreRule | So5NationalityRule | So5NotNationalityRule | So5SameActiveClubRule | So5ScarcityRule | So5SeasonBonusRule | VaultPointsRule>;
  division: Scalars['Int']['output'];
  divisionChangeConfiguration?: Maybe<DivisionChangeConfiguration>;
  divisionIconUrl: Scalars['String']['output'];
  eligibleCardsCountByPosition: Array<UserCardsCount>;
  eligibleToPreviousLineupLoader: Scalars['Boolean']['output'];
  eligibleToSuggestedLineupLoader: Scalars['Boolean']['output'];
  endDate: Scalars['ISO8601DateTime']['output'];
  engineConfiguration: EngineConfiguration;
  /** The `fixture_games_with_player_game_scores_preview` field cannot be nested within a list. */
  fixtureGamesWithPlayerGameScoresPreview: GameWithPlayerGameScoresPreviewConnection;
  format: So5LeaderboardFormat;
  gameWeek: Scalars['Int']['output'];
  /** The `games_with_my_cards_preview` field cannot be nested within a list. */
  gamesWithMyCardsPreview: GameWithCardsPreviewConnection;
  /** The `games_with_my_player_game_scores_preview` field cannot be nested within a list. */
  gamesWithMyPlayerGameScoresPreview: GameWithPlayerGameScoresPreviewConnection;
  /** The `highlighted_recommendations` field cannot be nested within a list. */
  highlightedRecommendations: Array<PlayerRecommendation>;
  iconUrl?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isArena: Scalars['Boolean']['output'];
  jonumGated: Scalars['Boolean']['output'];
  lineupLiveFeedbacksRules?: Maybe<Array<So5RuleFeedback>>;
  mainRarityType?: Maybe<Rarity>;
  /**
   * The `my_bench` field cannot be nested within a list.
   * @deprecated Use myFilteredBench instead
   */
  myBench: ComposeTeamBenchObjectInterfaceConnection;
  /** Get a list of ComposeTeamBenchObject by ids */
  myComposeTeamBenchObjects: Array<ComposeTeamBenchCard | ComposeTeamBenchCommonPlayer | DecisivePlayerPickerTaskAppearance | MissedAppearance | So5Appearance | TaskAppearance | ThresholdPickerTaskAppearance>;
  /** The `my_filtered_bench` field cannot be nested within a list. */
  myFilteredBench: ComposeTeamBenchObjectInterfaceConnection;
  /** The `my_live_player_game_scores_count` field cannot be nested within a list. */
  myLivePlayerGameScoresCount: Scalars['Int']['output'];
  myManagerTeams: Array<ManagerTeam>;
  mySo5LeaderboardContenders: Array<So5LeaderboardContender>;
  mySo5Lineups: Array<So5Lineup>;
  mySo5LineupsCount: Scalars['Int']['output'];
  mySo5Rankings: Array<So5Ranking>;
  /** The `my_so5_user_groups` field cannot be nested within a list. */
  mySo5UserGroups: So5UserGroupConnection;
  myTasks: Array<CardsCountTargetTask | CardsCountTask | CompleteCollectionsCountTargetTask | CompleteCollectionsCountTask | DailyActionTask | DecisivePlayerPickerTask | DropChallengeTask | GameWeeklyTask | GuessTheScoreTask | InviteTaskAsReferrer | So5LeaderboardTask | StarPackTask | Task | TasksTrack | ThresholdPickerTask | ThresholdsDuoConnectionTask | ThresholdsStreakAdditionalLineupTask | ThresholdsStreakTask>;
  /** The `my_user_groups` field cannot be nested within a list. */
  myUserGroups: UserGroupInterfaceConnection;
  nextGame?: Maybe<Game | GameOfBaseball | GameOfBasketball>;
  onboardingTasks: Array<CardsCountTargetTask | CardsCountTask | CompleteCollectionsCountTargetTask | CompleteCollectionsCountTask | DailyActionTask | DecisivePlayerPickerTask | DropChallengeTask | GameWeeklyTask | GuessTheScoreTask | InviteTaskAsReferrer | So5LeaderboardTask | StarPackTask | Task | TasksTrack | ThresholdPickerTask | ThresholdsDuoConnectionTask | ThresholdsStreakAdditionalLineupTask | ThresholdsStreakTask>;
  played: Scalars['Boolean']['output'];
  possibleBenchSortingTypes: Array<SortingType>;
  powerCap?: Maybe<Scalars['Float']['output']>;
  previewSo5Lineup: So5LineupPreview;
  projectedLineupsReadyAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  pveOnly: Scalars['Boolean']['output'];
  rarityType: Scalars['String']['output'];
  /** Slug to suffix with the position to filter PlayerRecommendation */
  recommendableSlug?: Maybe<Scalars['String']['output']>;
  requiresManagerTeam: Scalars['Boolean']['output'];
  rewardMultiplierConfiguration?: Maybe<RewardMultiplierConfiguration>;
  rewardPool: Array<PlayerWithSupply>;
  rewardedLineupsCount: Scalars['Int']['output'];
  rewardsConfig: LeaderboardRewardsConfig;
  roomWithBoostedRewards: Scalars['Boolean']['output'];
  roomsConfig?: Maybe<RoomsConfig>;
  rules?: Maybe<So5Rules>;
  rulesSummary: Scalars['String']['output'];
  seasonality?: Maybe<So5LeaderboardSeasonality>;
  seasonalityInYears?: Maybe<Array<Scalars['Int']['output']>>;
  seasonalityName?: Maybe<Scalars['String']['output']>;
  showDropAndAddCommonCards: Scalars['Boolean']['output'];
  slug: Scalars['String']['output'];
  so5Fixture: So5Fixture;
  so5LeaderboardGroup: So5LeaderboardGroup | So5League;
  so5LeaderboardType: So5LeaderboardType;
  so5League: So5League;
  so5LeagueTrack: So5LeagueTrack;
  so5Lineup?: Maybe<So5Lineup>;
  so5LineupsCount: Scalars['Int']['output'];
  /** The `so5_lineups_paginated` field cannot be nested within a list. */
  so5LineupsPaginated: So5LineupConnection;
  /**
   * Get associated rankings, sorted by rank in ascending order. Empty until
   * fixture has started. The `so5_rankings` field cannot be nested within a list.
   */
  so5Rankings: So5RankingConnection;
  /**
   * Get associated rankings, sorted by rank in ascending order. Empty until
   * fixture has started. The `so5_rankings_paginated` field cannot be nested within a list.
   */
  so5RankingsPaginated: So5RankingsPaginated;
  /**
   * Get associated rankings, sorted by rank in ascending order. Unlike
   * so5Rankings, it is nestable, though limited to 5. Empty until fixture has started.
   */
  so5RankingsPreview: Array<So5Ranking>;
  /** Get associated rewards. Empty until fixture is closed. The `so5_rewards` field cannot be nested within a list. */
  so5Rewards: So5RewardConnection;
  so5TournamentType: So5Tournament;
  stadiumUrl?: Maybe<Scalars['String']['output']>;
  startDate: Scalars['ISO8601DateTime']['output'];
  svgLogoUrl: Scalars['String']['output'];
  teamsCap?: Maybe<Scalars['Int']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  /** The `top_recommendations` field cannot be nested within a list. */
  topRecommendations: Array<PlayerRecommendation>;
  totalRewardConfigs: Array<CardPacksRewardConfig | CardRewardConfig | CardShardRewardConfig | CoinRewardConfig | ConversionCreditRewardConfig | DeliverableItemRewardConfig | ExperienceRewardConfig | InGameCurrencyRewardConfig | MonetaryRewardConfig | ProbabilisticBundleRewardConfig | ShopItemRewardConfig>;
  /** High level overview of the rewards for the leaderboard */
  totalRewards: RewardsOverview;
  tournamentType: Scalars['String']['output'];
  trainingCenter: Scalars['Boolean']['output'];
  universalSo5UserGroups: Array<So5UserGroup>;
  universalUserGroups: Array<So5UserGroup>;
  upsellSo5Leaderboard?: Maybe<So5Leaderboard>;
}


/** A So5 Leaderboard */
export interface So5LeaderboarddisplayNameArgs {
  short?: InputMaybe<Scalars['Boolean']['input']>;
  withSeasonality?: InputMaybe<Scalars['Boolean']['input']>;
}


/** A So5 Leaderboard */
export interface So5LeaderboardfixtureGamesWithPlayerGameScoresPreviewArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  fromDate?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  myGamesOnly?: InputMaybe<Scalars['Boolean']['input']>;
  toDate?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
}


/** A So5 Leaderboard */
export interface So5LeaderboardgamesWithMyCardsPreviewArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<GameWithCardsPreviewSortType>;
  withCards?: InputMaybe<Scalars['Boolean']['input']>;
}


/** A So5 Leaderboard */
export interface So5LeaderboardgamesWithMyPlayerGameScoresPreviewArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  fromDate?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  includeWithoutPlayerGameScores?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  toDate?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
}


/** A So5 Leaderboard */
export interface So5LeaderboardhighlightedRecommendationsArgs {
  positions?: InputMaybe<Array<Position>>;
  recommendationEngine: RecommendationEngine;
  sport: Sport;
}


/** A So5 Leaderboard */
export interface So5LeaderboardlineupLiveFeedbacksRulesArgs {
  appearances: Array<So5AppearanceInput>;
}


/** A So5 Leaderboard */
export interface So5LeaderboardmyBenchArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  deckId?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  gameplayTierStars?: InputMaybe<FloatRangeInput>;
  grades?: InputMaybe<RangeInput>;
  inSeasonEligible?: InputMaybe<Scalars['Boolean']['input']>;
  includeNoGame?: InputMaybe<Scalars['Boolean']['input']>;
  includeUnavailablePlayers?: InputMaybe<Scalars['Boolean']['input']>;
  includeUsed?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  lastFifteenSo5AverageScore?: InputMaybe<RangeInput>;
  lastTenPlayedSo5AverageScore?: InputMaybe<RangeInput>;
  lineupId?: InputMaybe<Scalars['String']['input']>;
  playingHomeOnly?: InputMaybe<Scalars['Boolean']['input']>;
  positions?: InputMaybe<Array<Position>>;
  query?: InputMaybe<Scalars['String']['input']>;
  rarities?: InputMaybe<Array<Rarity>>;
  selectedObjectIds?: InputMaybe<Array<Scalars['String']['input']>>;
  so5LineupId?: InputMaybe<Scalars['String']['input']>;
  sortType?: InputMaybe<EligibleCardsSort>;
  starterOddsBasisPointsRange?: InputMaybe<RangeInput>;
}


/** A So5 Leaderboard */
export interface So5LeaderboardmyComposeTeamBenchObjectsArgs {
  ids: Array<Scalars['String']['input']>;
}


/** A So5 Leaderboard */
export interface So5LeaderboardmyFilteredBenchArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filters: BenchFilterInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
}


/** A So5 Leaderboard */
export interface So5LeaderboardmySo5LeaderboardContendersArgs {
  includeHiddenManagerTeam?: InputMaybe<Scalars['Boolean']['input']>;
  includeRooms?: InputMaybe<Scalars['Boolean']['input']>;
}


/** A So5 Leaderboard */
export interface So5LeaderboardmySo5LineupsArgs {
  includeRooms?: InputMaybe<Scalars['Boolean']['input']>;
}


/** A So5 Leaderboard */
export interface So5LeaderboardmySo5LineupsCountArgs {
  includeRooms?: InputMaybe<Scalars['Boolean']['input']>;
}


/** A So5 Leaderboard */
export interface So5LeaderboardmySo5RankingsArgs {
  first?: InputMaybe<Scalars['Int']['input']>;
  so5UserGroupSlug?: InputMaybe<Scalars['String']['input']>;
}


/** A So5 Leaderboard */
export interface So5LeaderboardmySo5UserGroupsArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  statuses?: InputMaybe<Array<UserGroupStatus>>;
}


/** A So5 Leaderboard */
export interface So5LeaderboardmyUserGroupsArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  statuses?: InputMaybe<Array<UserGroupStatus>>;
}


/** A So5 Leaderboard */
export interface So5LeaderboardpreviewSo5LineupArgs {
  appearances: Array<So5AppearanceInput>;
  lineupId?: InputMaybe<Scalars['String']['input']>;
  so5LineupId?: InputMaybe<Scalars['ID']['input']>;
}


/** A So5 Leaderboard */
export interface So5LeaderboardrewardPoolArgs {
  first?: InputMaybe<Scalars['Int']['input']>;
  gameplayTier?: InputMaybe<GameplayTier>;
  quality?: InputMaybe<Scalars['String']['input']>;
}


/** A So5 Leaderboard */
export interface So5Leaderboardso5LeaderboardGroupArgs {
  groupType?: InputMaybe<So5LeaderboardGroupType>;
}


/** A So5 Leaderboard */
export interface So5Leaderboardso5LineupArgs {
  id?: InputMaybe<Scalars['String']['input']>;
}


/** A So5 Leaderboard */
export interface So5Leaderboardso5LineupsPaginatedArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  userSlug?: InputMaybe<Scalars['String']['input']>;
}


/** A So5 Leaderboard */
export interface So5Leaderboardso5RankingsArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  onlyFollowed?: InputMaybe<Scalars['Boolean']['input']>;
}


/** A So5 Leaderboard */
export interface So5Leaderboardso5RankingsPaginatedArgs {
  canBeatSo5LineupId?: InputMaybe<Scalars['ID']['input']>;
  onlyFollowed?: InputMaybe<Scalars['Boolean']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  so5UserGroupSlug?: InputMaybe<Scalars['String']['input']>;
}


/** A So5 Leaderboard */
export interface So5Leaderboardso5RankingsPreviewArgs {
  size?: InputMaybe<Scalars['Int']['input']>;
}


/** A So5 Leaderboard */
export interface So5Leaderboardso5RewardsArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
}


/** A So5 Leaderboard */
export interface So5LeaderboardtopRecommendationsArgs {
  filters?: InputMaybe<BenchFilterInput>;
  playingHomeOnly?: InputMaybe<Scalars['Boolean']['input']>;
  positions?: InputMaybe<Array<Position>>;
  query?: InputMaybe<Scalars['String']['input']>;
  recommendationEngine: RecommendationEngine;
  sortType?: InputMaybe<EligibleCardsSort>;
  sport: Sport;
  starterOddsBasisPointsRange?: InputMaybe<RangeInput>;
}


/** A So5 Leaderboard */
export interface So5LeaderboardtotalRewardConfigsArgs {
  highestConfigByType?: InputMaybe<Scalars['Boolean']['input']>;
}

export interface So5LeaderboardBookmark extends Bookmark {
  __typename: 'So5LeaderboardBookmark';
  id: Scalars['ID']['output'];
  /** The leaderboard of this type in the earliest open fixture, if any */
  so5Leaderboard?: Maybe<So5Leaderboard>;
  so5LeaderboardType: So5LeaderboardType;
  sport: Sport;
}

/** The connection type for So5Leaderboard. */
export interface So5LeaderboardConnection {
  __typename: 'So5LeaderboardConnection';
  /** A list of edges. */
  edges: Array<So5LeaderboardEdge>;
  /** A list of nodes. */
  nodes: Array<So5Leaderboard>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
}

/** A ManagerTeam with optional So5Lineup, or a So5Lineup without ManagerTeam */
export interface So5LeaderboardContender {
  __typename: 'So5LeaderboardContender';
  managerTeam?: Maybe<ManagerTeam>;
  slug: Scalars['String']['output'];
  so5Leaderboard: So5Leaderboard;
  so5Lineup?: Maybe<So5Lineup>;
}

/** The connection type for So5LeaderboardContender. */
export interface So5LeaderboardContenderConnection {
  __typename: 'So5LeaderboardContenderConnection';
  /** A list of edges. */
  edges: Array<So5LeaderboardContenderEdge>;
  hasAny: Scalars['Boolean']['output'];
  /** A list of nodes. */
  nodes: Array<So5LeaderboardContender>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
}

/** An edge in a connection. */
export interface So5LeaderboardContenderEdge {
  __typename: 'So5LeaderboardContenderEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<So5LeaderboardContender>;
}

export const So5LeaderboardContenderSort = {
  BEST_REWARDS: 'BEST_REWARDS',
  LEADERBOARD: 'LEADERBOARD',
  PROJECTED_RANK: 'PROJECTED_RANK',
  RANK: 'RANK',
  RANK_RATIO: 'RANK_RATIO'
} as const;

export type So5LeaderboardContenderSort = typeof So5LeaderboardContenderSort[keyof typeof So5LeaderboardContenderSort];
/** An edge in a connection. */
export interface So5LeaderboardEdge {
  __typename: 'So5LeaderboardEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<So5Leaderboard>;
}

export interface So5LeaderboardEntryItemSource extends HistoryTransactionInterface {
  __typename: 'So5LeaderboardEntryItemSource';
  date: Scalars['ISO8601DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  label: Scalars['String']['output'];
  logoUrl?: Maybe<Scalars['String']['output']>;
  quantityByFlavour: Array<PoolKeyShardsCount>;
  totalQuantity: Scalars['Int']['output'];
}

/** Display format of a So5 Leaderboard */
export interface So5LeaderboardFormat {
  __typename: 'So5LeaderboardFormat';
  entryItem?: Maybe<So5CardShardsEntryItem>;
  iconUrl?: Maybe<Scalars['String']['output']>;
  /** @deprecated Unused, will be removed */
  subtitle?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
}

export interface So5LeaderboardGroup extends So5LeaderboardGroupInterface {
  __typename: 'So5LeaderboardGroup';
  backgroundUrl?: Maybe<Scalars['String']['output']>;
  bannerUrl: Scalars['String']['output'];
  canCompose: Validity;
  color: Scalars['String']['output'];
  compactBannerUrl?: Maybe<Scalars['String']['output']>;
  /** Get sport games for a window of maximum 2 days. */
  competitionGames: Array<CompetitionGames>;
  cutOffDate: Scalars['ISO8601DateTime']['output'];
  description: Scalars['String']['output'];
  displayName: Scalars['String']['output'];
  eligibleCardsCountByPosition: Array<UserCardsCount>;
  featured: Scalars['Boolean']['output'];
  featuredBannerUrl: Scalars['String']['output'];
  hasLeaderboards: Scalars['Boolean']['output'];
  hasMyCollectionTasks: Scalars['Boolean']['output'];
  headerBackgroundUrl: Scalars['String']['output'];
  headerUrl: Scalars['String']['output'];
  iconUrl: Scalars['String']['output'];
  leagueSummary?: Maybe<Scalars['String']['output']>;
  lockType?: Maybe<LockTypeEnum>;
  logoUrl: Scalars['String']['output'];
  /** The `my_collection_tasks` field cannot be nested within a list. */
  myCollectionTasks: Array<CardsCountTargetTask | CardsCountTask | CompleteCollectionsCountTargetTask | CompleteCollectionsCountTask | DailyActionTask | DecisivePlayerPickerTask | DropChallengeTask | GameWeeklyTask | GuessTheScoreTask | InviteTaskAsReferrer | So5LeaderboardTask | StarPackTask | Task | TasksTrack | ThresholdPickerTask | ThresholdsDuoConnectionTask | ThresholdsStreakAdditionalLineupTask | ThresholdsStreakTask>;
  /** Eligible rewards until so5 fixture is closed, actual so5 rewards after */
  myEligibleOrSo5Rewards: Array<So5RewardOrConfig>;
  myEligibleRewardConfigs: Array<CardPacksRewardConfig | CardRewardConfig | CardShardRewardConfig | CoinRewardConfig | ConversionCreditRewardConfig | DeliverableItemRewardConfig | ExperienceRewardConfig | InGameCurrencyRewardConfig | MonetaryRewardConfig | ProbabilisticBundleRewardConfig | ShopItemRewardConfig>;
  mySo5LeaderboardContenders: Array<So5LeaderboardContender>;
  mySo5Leaderboards: Array<So5Leaderboard>;
  mySo5LineupsCount: Scalars['Int']['output'];
  myThresholdsStreakTasks: Array<ThresholdsStreakTask>;
  myUnclaimedCollectionTasksCount: Scalars['Int']['output'];
  nextOpenedSo5LeaderboardGroup?: Maybe<So5LeaderboardGroup | So5League>;
  percentageOfGamesPlayed: Scalars['Float']['output'];
  pictureUrl?: Maybe<Scalars['String']['output']>;
  seasonalities: Array<So5LeaderboardSeasonality>;
  shortDescription?: Maybe<Scalars['String']['output']>;
  slug: Scalars['String']['output'];
  so5Competition: So5Competition;
  so5Fixture: So5Fixture;
  so5LeaderboardContenders: Array<So5LeaderboardContender>;
  so5Leaderboards: Array<So5Leaderboard>;
  so5LeagueTrack?: Maybe<So5LeagueTrack>;
  so5LeagueTrackGroup?: Maybe<So5LeagueTrackGroup>;
  so5LeagueTrackGroups: Array<So5LeagueTrackGroup>;
  so5LeagueTracks: Array<So5LeagueTrack>;
  so5LineupsCount: Scalars['Int']['output'];
  soleSo5Leaderboard?: Maybe<So5Leaderboard>;
  stadiumUrl?: Maybe<Scalars['String']['output']>;
  tileBackgroundUrl?: Maybe<Scalars['String']['output']>;
  totalRewardConfigs: Array<CardPacksRewardConfig | CardRewardConfig | CardShardRewardConfig | CoinRewardConfig | ConversionCreditRewardConfig | DeliverableItemRewardConfig | ExperienceRewardConfig | InGameCurrencyRewardConfig | MonetaryRewardConfig | ProbabilisticBundleRewardConfig | ShopItemRewardConfig>;
  totalRewards: RewardsOverview;
  vaultPointsRequired: Scalars['Boolean']['output'];
}


export interface So5LeaderboardGroupbackgroundUrlArgs {
  seasonality?: InputMaybe<So5LeaderboardSeasonality>;
  variant?: InputMaybe<AssetVariant>;
}


export interface So5LeaderboardGroupcolorArgs {
  variant?: InputMaybe<ColorVariant>;
}


export interface So5LeaderboardGroupcompetitionGamesArgs {
  fromDate?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  toDate?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
}


export interface So5LeaderboardGrouphasMyCollectionTasksArgs {
  rarity?: InputMaybe<Rarity>;
}


export interface So5LeaderboardGroupheaderBackgroundUrlArgs {
  seasonality?: InputMaybe<So5LeaderboardSeasonality>;
}


export interface So5LeaderboardGroupmyCollectionTasksArgs {
  rarity?: InputMaybe<Rarity>;
}


export interface So5LeaderboardGroupmyEligibleOrSo5RewardsArgs {
  multiplyBaseRewards?: InputMaybe<Scalars['Boolean']['input']>;
}


export interface So5LeaderboardGroupmyEligibleRewardConfigsArgs {
  multiplyBaseRewards?: InputMaybe<Scalars['Boolean']['input']>;
}


export interface So5LeaderboardGroupmySo5LeaderboardContendersArgs {
  includeHiddenManagerTeam?: InputMaybe<Scalars['Boolean']['input']>;
  sortType?: InputMaybe<So5LeaderboardContenderSort>;
}


export interface So5LeaderboardGroupmyUnclaimedCollectionTasksCountArgs {
  rarity?: InputMaybe<Rarity>;
}


export interface So5LeaderboardGrouppictureUrlArgs {
  seasonality?: InputMaybe<So5LeaderboardSeasonality>;
}


export interface So5LeaderboardGroupso5LeaderboardContendersArgs {
  includeHiddenManagerTeam?: InputMaybe<Scalars['Boolean']['input']>;
  sortType?: InputMaybe<So5LeaderboardContenderSort>;
  userSlug: Scalars['String']['input'];
}


export interface So5LeaderboardGroupso5LeaderboardsArgs {
  notRooms?: InputMaybe<Scalars['Boolean']['input']>;
  rarity?: InputMaybe<Rarity>;
}


export interface So5LeaderboardGroupso5LeagueTrackArgs {
  slug: Scalars['String']['input'];
}


export interface So5LeaderboardGroupso5LeagueTrackGroupArgs {
  slug: Scalars['String']['input'];
}


export interface So5LeaderboardGroupsoleSo5LeaderboardArgs {
  rarity?: InputMaybe<Rarity>;
}


export interface So5LeaderboardGroupstadiumUrlArgs {
  boostedRewards?: InputMaybe<Scalars['Boolean']['input']>;
  seasonality?: InputMaybe<So5LeaderboardSeasonality>;
}


export interface So5LeaderboardGrouptotalRewardConfigsArgs {
  highestConfigByType?: InputMaybe<Scalars['Boolean']['input']>;
  onlyPlayable?: InputMaybe<Scalars['Boolean']['input']>;
  seasonality?: InputMaybe<So5LeaderboardSeasonality>;
}


export interface So5LeaderboardGrouptotalRewardsArgs {
  seasonality?: InputMaybe<So5LeaderboardSeasonality>;
}

/** So5LeaderboardGroupInterface */
export interface So5LeaderboardGroupInterface {
  backgroundUrl?: Maybe<Scalars['String']['output']>;
  bannerUrl: Scalars['String']['output'];
  canCompose: Validity;
  color: Scalars['String']['output'];
  compactBannerUrl?: Maybe<Scalars['String']['output']>;
  /** Get sport games for a window of maximum 2 days. */
  competitionGames: Array<CompetitionGames>;
  cutOffDate: Scalars['ISO8601DateTime']['output'];
  description: Scalars['String']['output'];
  displayName: Scalars['String']['output'];
  eligibleCardsCountByPosition: Array<UserCardsCount>;
  featured: Scalars['Boolean']['output'];
  featuredBannerUrl: Scalars['String']['output'];
  hasLeaderboards: Scalars['Boolean']['output'];
  hasMyCollectionTasks: Scalars['Boolean']['output'];
  headerBackgroundUrl: Scalars['String']['output'];
  headerUrl: Scalars['String']['output'];
  iconUrl: Scalars['String']['output'];
  leagueSummary?: Maybe<Scalars['String']['output']>;
  lockType?: Maybe<LockTypeEnum>;
  logoUrl: Scalars['String']['output'];
  /** The `my_collection_tasks` field cannot be nested within a list. */
  myCollectionTasks: Array<CardsCountTargetTask | CardsCountTask | CompleteCollectionsCountTargetTask | CompleteCollectionsCountTask | DailyActionTask | DecisivePlayerPickerTask | DropChallengeTask | GameWeeklyTask | GuessTheScoreTask | InviteTaskAsReferrer | So5LeaderboardTask | StarPackTask | Task | TasksTrack | ThresholdPickerTask | ThresholdsDuoConnectionTask | ThresholdsStreakAdditionalLineupTask | ThresholdsStreakTask>;
  /** Eligible rewards until so5 fixture is closed, actual so5 rewards after */
  myEligibleOrSo5Rewards: Array<So5RewardOrConfig>;
  myEligibleRewardConfigs: Array<CardPacksRewardConfig | CardRewardConfig | CardShardRewardConfig | CoinRewardConfig | ConversionCreditRewardConfig | DeliverableItemRewardConfig | ExperienceRewardConfig | InGameCurrencyRewardConfig | MonetaryRewardConfig | ProbabilisticBundleRewardConfig | ShopItemRewardConfig>;
  mySo5LeaderboardContenders: Array<So5LeaderboardContender>;
  mySo5Leaderboards: Array<So5Leaderboard>;
  mySo5LineupsCount: Scalars['Int']['output'];
  myThresholdsStreakTasks: Array<ThresholdsStreakTask>;
  myUnclaimedCollectionTasksCount: Scalars['Int']['output'];
  nextOpenedSo5LeaderboardGroup?: Maybe<So5LeaderboardGroup | So5League>;
  percentageOfGamesPlayed: Scalars['Float']['output'];
  pictureUrl?: Maybe<Scalars['String']['output']>;
  seasonalities: Array<So5LeaderboardSeasonality>;
  shortDescription?: Maybe<Scalars['String']['output']>;
  slug: Scalars['String']['output'];
  so5Competition: So5Competition;
  so5Fixture: So5Fixture;
  so5LeaderboardContenders: Array<So5LeaderboardContender>;
  so5Leaderboards: Array<So5Leaderboard>;
  so5LeagueTrack?: Maybe<So5LeagueTrack>;
  so5LeagueTrackGroup?: Maybe<So5LeagueTrackGroup>;
  so5LeagueTrackGroups: Array<So5LeagueTrackGroup>;
  so5LeagueTracks: Array<So5LeagueTrack>;
  so5LineupsCount: Scalars['Int']['output'];
  soleSo5Leaderboard?: Maybe<So5Leaderboard>;
  stadiumUrl?: Maybe<Scalars['String']['output']>;
  tileBackgroundUrl?: Maybe<Scalars['String']['output']>;
  totalRewardConfigs: Array<CardPacksRewardConfig | CardRewardConfig | CardShardRewardConfig | CoinRewardConfig | ConversionCreditRewardConfig | DeliverableItemRewardConfig | ExperienceRewardConfig | InGameCurrencyRewardConfig | MonetaryRewardConfig | ProbabilisticBundleRewardConfig | ShopItemRewardConfig>;
  totalRewards: RewardsOverview;
  vaultPointsRequired: Scalars['Boolean']['output'];
}


/** So5LeaderboardGroupInterface */
export interface So5LeaderboardGroupInterfacebackgroundUrlArgs {
  seasonality?: InputMaybe<So5LeaderboardSeasonality>;
  variant?: InputMaybe<AssetVariant>;
}


/** So5LeaderboardGroupInterface */
export interface So5LeaderboardGroupInterfacecolorArgs {
  variant?: InputMaybe<ColorVariant>;
}


/** So5LeaderboardGroupInterface */
export interface So5LeaderboardGroupInterfacecompetitionGamesArgs {
  fromDate?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  toDate?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
}


/** So5LeaderboardGroupInterface */
export interface So5LeaderboardGroupInterfacehasMyCollectionTasksArgs {
  rarity?: InputMaybe<Rarity>;
}


/** So5LeaderboardGroupInterface */
export interface So5LeaderboardGroupInterfaceheaderBackgroundUrlArgs {
  seasonality?: InputMaybe<So5LeaderboardSeasonality>;
}


/** So5LeaderboardGroupInterface */
export interface So5LeaderboardGroupInterfacemyCollectionTasksArgs {
  rarity?: InputMaybe<Rarity>;
}


/** So5LeaderboardGroupInterface */
export interface So5LeaderboardGroupInterfacemyEligibleOrSo5RewardsArgs {
  multiplyBaseRewards?: InputMaybe<Scalars['Boolean']['input']>;
}


/** So5LeaderboardGroupInterface */
export interface So5LeaderboardGroupInterfacemyEligibleRewardConfigsArgs {
  multiplyBaseRewards?: InputMaybe<Scalars['Boolean']['input']>;
}


/** So5LeaderboardGroupInterface */
export interface So5LeaderboardGroupInterfacemySo5LeaderboardContendersArgs {
  includeHiddenManagerTeam?: InputMaybe<Scalars['Boolean']['input']>;
  sortType?: InputMaybe<So5LeaderboardContenderSort>;
}


/** So5LeaderboardGroupInterface */
export interface So5LeaderboardGroupInterfacemyUnclaimedCollectionTasksCountArgs {
  rarity?: InputMaybe<Rarity>;
}


/** So5LeaderboardGroupInterface */
export interface So5LeaderboardGroupInterfacepictureUrlArgs {
  seasonality?: InputMaybe<So5LeaderboardSeasonality>;
}


/** So5LeaderboardGroupInterface */
export interface So5LeaderboardGroupInterfaceso5LeaderboardContendersArgs {
  includeHiddenManagerTeam?: InputMaybe<Scalars['Boolean']['input']>;
  sortType?: InputMaybe<So5LeaderboardContenderSort>;
  userSlug: Scalars['String']['input'];
}


/** So5LeaderboardGroupInterface */
export interface So5LeaderboardGroupInterfaceso5LeaderboardsArgs {
  notRooms?: InputMaybe<Scalars['Boolean']['input']>;
  rarity?: InputMaybe<Rarity>;
}


/** So5LeaderboardGroupInterface */
export interface So5LeaderboardGroupInterfaceso5LeagueTrackArgs {
  slug: Scalars['String']['input'];
}


/** So5LeaderboardGroupInterface */
export interface So5LeaderboardGroupInterfaceso5LeagueTrackGroupArgs {
  slug: Scalars['String']['input'];
}


/** So5LeaderboardGroupInterface */
export interface So5LeaderboardGroupInterfacesoleSo5LeaderboardArgs {
  rarity?: InputMaybe<Rarity>;
}


/** So5LeaderboardGroupInterface */
export interface So5LeaderboardGroupInterfacestadiumUrlArgs {
  boostedRewards?: InputMaybe<Scalars['Boolean']['input']>;
  seasonality?: InputMaybe<So5LeaderboardSeasonality>;
}


/** So5LeaderboardGroupInterface */
export interface So5LeaderboardGroupInterfacetotalRewardConfigsArgs {
  highestConfigByType?: InputMaybe<Scalars['Boolean']['input']>;
  onlyPlayable?: InputMaybe<Scalars['Boolean']['input']>;
  seasonality?: InputMaybe<So5LeaderboardSeasonality>;
}


/** So5LeaderboardGroupInterface */
export interface So5LeaderboardGroupInterfacetotalRewardsArgs {
  seasonality?: InputMaybe<So5LeaderboardSeasonality>;
}

/** The connection type for So5LeaderboardGroupInterface. */
export interface So5LeaderboardGroupInterfaceConnection {
  __typename: 'So5LeaderboardGroupInterfaceConnection';
  /** A list of edges. */
  edges: Array<So5LeaderboardGroupInterfaceEdge>;
  hasAny: Scalars['Boolean']['output'];
  /** A list of nodes. */
  nodes: Array<So5LeaderboardGroup | So5League>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
}

/** An edge in a connection. */
export interface So5LeaderboardGroupInterfaceEdge {
  __typename: 'So5LeaderboardGroupInterfaceEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<So5LeaderboardGroup | So5League>;
}

export const So5LeaderboardGroupType = {
  ARENA: 'ARENA',
  ARENA_CLASSIC: 'ARENA_CLASSIC',
  ARENA_CLASSIC_NOT_ROOMS: 'ARENA_CLASSIC_NOT_ROOMS',
  ARENA_CLASSIC_ROOMS: 'ARENA_CLASSIC_ROOMS',
  ARENA_IN_SEASON: 'ARENA_IN_SEASON',
  COMPETITION: 'COMPETITION',
  COMPETITION_WITH_ARENA: 'COMPETITION_WITH_ARENA',
  RARITY: 'RARITY'
} as const;

export type So5LeaderboardGroupType = typeof So5LeaderboardGroupType[keyof typeof So5LeaderboardGroupType];
export const So5LeaderboardRarity = {
  COMMON: 'COMMON',
  LIMITED: 'LIMITED',
  MIX: 'MIX',
  RARE: 'RARE',
  RARE_PRO: 'RARE_PRO',
  SUPER_RARE: 'SUPER_RARE',
  UNIQUE: 'UNIQUE'
} as const;

export type So5LeaderboardRarity = typeof So5LeaderboardRarity[keyof typeof So5LeaderboardRarity];
/** So5Leaderboard Rules */
export interface So5LeaderboardRulesInterface {
  canCompose: Validity;
  defaultAverageScore?: Maybe<AveragePlayerScore>;
  displayedRules?: Maybe<So5Rules>;
  displayedTypedRules: Array<CardsCountAsFirstOwnerRule | OwnedSinceRule | PlayerHeightRule | SeasonsRule | So5ActiveClubsRule | So5ActiveNationalTeamsRule | So5AgeRule | So5AppearancesRule | So5AtLeastOfClubs | So5AtLeastOfCompetitions | So5AverageScoresRule | So5CaptainRule | So5CaptainScarcityRule | So5CardEditionsCountRule | So5CompetitionsRule | So5EntryItemRule | So5MaximumPlayersAverageScoreRule | So5MinimumPlayersAverageScoreRule | So5NationalityRule | So5NotNationalityRule | So5SameActiveClubRule | So5ScarcityRule | So5SeasonBonusRule | VaultPointsRule>;
  rules?: Maybe<So5Rules>;
  rulesSummary: Scalars['String']['output'];
}

export const So5LeaderboardSeasonality = {
  ALL_SEASONS: 'ALL_SEASONS',
  IN_SEASON: 'IN_SEASON'
} as const;

export type So5LeaderboardSeasonality = typeof So5LeaderboardSeasonality[keyof typeof So5LeaderboardSeasonality];
/** So5 Leaderboard Task */
export interface So5LeaderboardTask extends ManagerTaskInterface, So5LeaderboardTaskInterface, TaskInterface {
  __typename: 'So5LeaderboardTask';
  aasmState: ManagerProgressionTaskState;
  alternativeRewardConfigs?: Maybe<Array<AlternativeRewardConfig>>;
  /** @deprecated Not used anymore */
  cards: Array<BaseballCard | Card | NBACard>;
  claimableAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** @deprecated Not used anymore */
  claimedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  color?: Maybe<Scalars['String']['output']>;
  completedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  description: Scalars['String']['output'];
  expired: Scalars['Boolean']['output'];
  genre: TaskGenre;
  group?: Maybe<TaskGroup>;
  iconUrl?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  jonumGated: Scalars['Boolean']['output'];
  /** The points this task earned on a ladder leaderboard, empty when it feeds none. */
  ladderContributions: Array<LadderContribution>;
  /** The `my_reward_pool_shares` field cannot be nested within a list. */
  myRewardPoolShares?: Maybe<Array<RewardPoolShare>>;
  name: ManagerProgressionTaskSlug;
  parentTask?: Maybe<CardsCountTargetTask | CardsCountTask | CompleteCollectionsCountTargetTask | CompleteCollectionsCountTask | DailyActionTask | DecisivePlayerPickerTask | DropChallengeTask | GameWeeklyTask | GuessTheScoreTask | InviteTaskAsReferrer | So5LeaderboardTask | StarPackTask | Task | TasksTrack | ThresholdPickerTask | ThresholdsDuoConnectionTask | ThresholdsStreakAdditionalLineupTask | ThresholdsStreakTask>;
  periodicity?: Maybe<ManagerTaskPeriodicity>;
  pickOrList: Scalars['Boolean']['output'];
  playableSo5Leaderboard?: Maybe<So5Leaderboard>;
  possibleRewardConfigsIconUrl?: Maybe<Scalars['String']['output']>;
  /** @deprecated Not used anymore */
  probabilisticBundles: Array<ProbabilisticBundle>;
  progress: Scalars['Int']['output'];
  rarity?: Maybe<Rarity>;
  rewardConfigs: Array<CardPacksRewardConfig | CardRewardConfig | CardShardRewardConfig | CoinRewardConfig | ConversionCreditRewardConfig | DeliverableItemRewardConfig | ExperienceRewardConfig | InGameCurrencyRewardConfig | MonetaryRewardConfig | ProbabilisticBundleRewardConfig | ShopItemRewardConfig>;
  /** The `reward_pool_shares` field cannot be nested within a list. */
  rewardPoolShares?: Maybe<RewardPoolShareConnection>;
  startDate?: Maybe<Scalars['ISO8601DateTime']['output']>;
  target: Scalars['Int']['output'];
  taskConfigSlug: Scalars['String']['output'];
  templateIconUrl: Scalars['String']['output'];
  title: Scalars['String']['output'];
  uncapped: Scalars['Boolean']['output'];
}


/** So5 Leaderboard Task */
export interface So5LeaderboardTaskcolorArgs {
  variant?: InputMaybe<ColorVariant>;
}


/** So5 Leaderboard Task */
export interface So5LeaderboardTaskrewardConfigsArgs {
  mergedConfigsByType?: InputMaybe<Scalars['Boolean']['input']>;
}


/** So5 Leaderboard Task */
export interface So5LeaderboardTaskrewardPoolSharesArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
}

/** Manager Task */
export interface So5LeaderboardTaskInterface {
  aasmState: ManagerProgressionTaskState;
  alternativeRewardConfigs?: Maybe<Array<AlternativeRewardConfig>>;
  /** @deprecated Not used anymore */
  cards: Array<BaseballCard | Card | NBACard>;
  claimableAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** @deprecated Not used anymore */
  claimedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  color?: Maybe<Scalars['String']['output']>;
  completedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  description: Scalars['String']['output'];
  expired: Scalars['Boolean']['output'];
  genre: TaskGenre;
  group?: Maybe<TaskGroup>;
  iconUrl?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  jonumGated: Scalars['Boolean']['output'];
  /** The points this task earned on a ladder leaderboard, empty when it feeds none. */
  ladderContributions: Array<LadderContribution>;
  /** The `my_reward_pool_shares` field cannot be nested within a list. */
  myRewardPoolShares?: Maybe<Array<RewardPoolShare>>;
  name: ManagerProgressionTaskSlug;
  parentTask?: Maybe<CardsCountTargetTask | CardsCountTask | CompleteCollectionsCountTargetTask | CompleteCollectionsCountTask | DailyActionTask | DecisivePlayerPickerTask | DropChallengeTask | GameWeeklyTask | GuessTheScoreTask | InviteTaskAsReferrer | So5LeaderboardTask | StarPackTask | Task | TasksTrack | ThresholdPickerTask | ThresholdsDuoConnectionTask | ThresholdsStreakAdditionalLineupTask | ThresholdsStreakTask>;
  periodicity?: Maybe<ManagerTaskPeriodicity>;
  pickOrList: Scalars['Boolean']['output'];
  playableSo5Leaderboard?: Maybe<So5Leaderboard>;
  possibleRewardConfigsIconUrl?: Maybe<Scalars['String']['output']>;
  /** @deprecated Not used anymore */
  probabilisticBundles: Array<ProbabilisticBundle>;
  progress: Scalars['Int']['output'];
  rarity?: Maybe<Rarity>;
  rewardConfigs: Array<CardPacksRewardConfig | CardRewardConfig | CardShardRewardConfig | CoinRewardConfig | ConversionCreditRewardConfig | DeliverableItemRewardConfig | ExperienceRewardConfig | InGameCurrencyRewardConfig | MonetaryRewardConfig | ProbabilisticBundleRewardConfig | ShopItemRewardConfig>;
  /** The `reward_pool_shares` field cannot be nested within a list. */
  rewardPoolShares?: Maybe<RewardPoolShareConnection>;
  startDate?: Maybe<Scalars['ISO8601DateTime']['output']>;
  target: Scalars['Int']['output'];
  taskConfigSlug: Scalars['String']['output'];
  templateIconUrl: Scalars['String']['output'];
  title: Scalars['String']['output'];
  uncapped: Scalars['Boolean']['output'];
}


/** Manager Task */
export interface So5LeaderboardTaskInterfacecolorArgs {
  variant?: InputMaybe<ColorVariant>;
}


/** Manager Task */
export interface So5LeaderboardTaskInterfacerewardConfigsArgs {
  mergedConfigsByType?: InputMaybe<Scalars['Boolean']['input']>;
}


/** Manager Task */
export interface So5LeaderboardTaskInterfacerewardPoolSharesArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
}

export const So5LeaderboardType = {
  ALL_SEASONS_ALL_STAR_ARENA_LIMITED: 'ALL_SEASONS_ALL_STAR_ARENA_LIMITED',
  ALL_SEASONS_ALL_STAR_ARENA_LIMITED_BEGINNER: 'ALL_SEASONS_ALL_STAR_ARENA_LIMITED_BEGINNER',
  ALL_SEASONS_ALL_STAR_ARENA_LIMITED_CAP_220: 'ALL_SEASONS_ALL_STAR_ARENA_LIMITED_CAP_220',
  ALL_SEASONS_ALL_STAR_ARENA_LIMITED_ELITE: 'ALL_SEASONS_ALL_STAR_ARENA_LIMITED_ELITE',
  ALL_SEASONS_ALL_STAR_ARENA_LIMITED_UNCAPPED: 'ALL_SEASONS_ALL_STAR_ARENA_LIMITED_UNCAPPED',
  ALL_SEASONS_ALL_STAR_ARENA_RARE: 'ALL_SEASONS_ALL_STAR_ARENA_RARE',
  ALL_SEASONS_ALL_STAR_ARENA_RARE_BEGINNER: 'ALL_SEASONS_ALL_STAR_ARENA_RARE_BEGINNER',
  ALL_SEASONS_ALL_STAR_ARENA_RARE_CAP_220: 'ALL_SEASONS_ALL_STAR_ARENA_RARE_CAP_220',
  ALL_SEASONS_ALL_STAR_ARENA_RARE_ELITE: 'ALL_SEASONS_ALL_STAR_ARENA_RARE_ELITE',
  ALL_SEASONS_ALL_STAR_ARENA_RARE_UNCAPPED: 'ALL_SEASONS_ALL_STAR_ARENA_RARE_UNCAPPED',
  ALL_SEASONS_ALL_STAR_ARENA_SUPER_RARE: 'ALL_SEASONS_ALL_STAR_ARENA_SUPER_RARE',
  ALL_SEASONS_ALL_STAR_ARENA_SUPER_RARE_CAP_220: 'ALL_SEASONS_ALL_STAR_ARENA_SUPER_RARE_CAP_220',
  ALL_SEASONS_ALL_STAR_ARENA_SUPER_RARE_ELITE: 'ALL_SEASONS_ALL_STAR_ARENA_SUPER_RARE_ELITE',
  ALL_SEASONS_ALL_STAR_ARENA_SUPER_RARE_UNCAPPED: 'ALL_SEASONS_ALL_STAR_ARENA_SUPER_RARE_UNCAPPED',
  ALL_SEASONS_ALL_STAR_ARENA_UNIQUE: 'ALL_SEASONS_ALL_STAR_ARENA_UNIQUE',
  ALL_SEASONS_ALL_STAR_COMMON: 'ALL_SEASONS_ALL_STAR_COMMON',
  ALL_SEASONS_ALL_STAR_LIMITED: 'ALL_SEASONS_ALL_STAR_LIMITED',
  ALL_SEASONS_ALL_STAR_RARE: 'ALL_SEASONS_ALL_STAR_RARE',
  ALL_SEASONS_ALL_STAR_SUPER_RARE: 'ALL_SEASONS_ALL_STAR_SUPER_RARE',
  ALL_SEASONS_ALL_STAR_UNIQUE: 'ALL_SEASONS_ALL_STAR_UNIQUE',
  ALL_SEASONS_CHALLENGERS_LIMITED: 'ALL_SEASONS_CHALLENGERS_LIMITED',
  ALL_SEASONS_CHALLENGERS_ONBOARDING: 'ALL_SEASONS_CHALLENGERS_ONBOARDING',
  ALL_SEASONS_CHALLENGERS_RARE: 'ALL_SEASONS_CHALLENGERS_RARE',
  ALL_SEASONS_CHALLENGERS_SUPER_RARE: 'ALL_SEASONS_CHALLENGERS_SUPER_RARE',
  ALL_SEASONS_CHALLENGERS_UNIQUE: 'ALL_SEASONS_CHALLENGERS_UNIQUE',
  ALL_SEASONS_CHAMPIONS_LIMITED: 'ALL_SEASONS_CHAMPIONS_LIMITED',
  ALL_SEASONS_CHAMPIONS_ONBOARDING: 'ALL_SEASONS_CHAMPIONS_ONBOARDING',
  ALL_SEASONS_CHAMPIONS_RARE: 'ALL_SEASONS_CHAMPIONS_RARE',
  ALL_SEASONS_CHAMPIONS_SUPER_RARE: 'ALL_SEASONS_CHAMPIONS_SUPER_RARE',
  ALL_SEASONS_CHAMPIONS_UNIQUE: 'ALL_SEASONS_CHAMPIONS_UNIQUE',
  ALL_SEASONS_CONTENDERS_LIMITED: 'ALL_SEASONS_CONTENDERS_LIMITED',
  ALL_SEASONS_CONTENDERS_ONBOARDING: 'ALL_SEASONS_CONTENDERS_ONBOARDING',
  ALL_SEASONS_CONTENDERS_RARE: 'ALL_SEASONS_CONTENDERS_RARE',
  ALL_SEASONS_CONTENDERS_SUPER_RARE: 'ALL_SEASONS_CONTENDERS_SUPER_RARE',
  ALL_SEASONS_CONTENDERS_UNIQUE: 'ALL_SEASONS_CONTENDERS_UNIQUE',
  ALL_SEASONS_ENGLAND_ARENA_LIMITED: 'ALL_SEASONS_ENGLAND_ARENA_LIMITED',
  ALL_SEASONS_ENGLAND_ARENA_RARE: 'ALL_SEASONS_ENGLAND_ARENA_RARE',
  ALL_SEASONS_ENGLAND_LIMITED: 'ALL_SEASONS_ENGLAND_LIMITED',
  ALL_SEASONS_ENGLAND_ONBOARDING: 'ALL_SEASONS_ENGLAND_ONBOARDING',
  ALL_SEASONS_ENGLAND_RARE: 'ALL_SEASONS_ENGLAND_RARE',
  ALL_SEASONS_ENGLAND_SECOND_ARENA_LIMITED: 'ALL_SEASONS_ENGLAND_SECOND_ARENA_LIMITED',
  ALL_SEASONS_ENGLAND_SECOND_ARENA_RARE: 'ALL_SEASONS_ENGLAND_SECOND_ARENA_RARE',
  ALL_SEASONS_ENGLAND_SUPER_RARE: 'ALL_SEASONS_ENGLAND_SUPER_RARE',
  ALL_SEASONS_ENGLAND_UNIQUE: 'ALL_SEASONS_ENGLAND_UNIQUE',
  ALL_SEASONS_FRANCE_ARENA_LIMITED: 'ALL_SEASONS_FRANCE_ARENA_LIMITED',
  ALL_SEASONS_FRANCE_ARENA_RARE: 'ALL_SEASONS_FRANCE_ARENA_RARE',
  ALL_SEASONS_GERMANY_ARENA_LIMITED: 'ALL_SEASONS_GERMANY_ARENA_LIMITED',
  ALL_SEASONS_GERMANY_ARENA_RARE: 'ALL_SEASONS_GERMANY_ARENA_RARE',
  ALL_SEASONS_GERMANY_LIMITED: 'ALL_SEASONS_GERMANY_LIMITED',
  ALL_SEASONS_GERMANY_ONBOARDING: 'ALL_SEASONS_GERMANY_ONBOARDING',
  ALL_SEASONS_GERMANY_RARE: 'ALL_SEASONS_GERMANY_RARE',
  ALL_SEASONS_GERMANY_SUPER_RARE: 'ALL_SEASONS_GERMANY_SUPER_RARE',
  ALL_SEASONS_GERMANY_UNIQUE: 'ALL_SEASONS_GERMANY_UNIQUE',
  ALL_SEASONS_ITALY_ARENA_LIMITED: 'ALL_SEASONS_ITALY_ARENA_LIMITED',
  ALL_SEASONS_ITALY_ARENA_RARE: 'ALL_SEASONS_ITALY_ARENA_RARE',
  ALL_SEASONS_JAPAN_ARENA_LIMITED: 'ALL_SEASONS_JAPAN_ARENA_LIMITED',
  ALL_SEASONS_JAPAN_ARENA_RARE: 'ALL_SEASONS_JAPAN_ARENA_RARE',
  ALL_SEASONS_JUPILER_ARENA_LIMITED: 'ALL_SEASONS_JUPILER_ARENA_LIMITED',
  ALL_SEASONS_JUPILER_ARENA_RARE: 'ALL_SEASONS_JUPILER_ARENA_RARE',
  ALL_SEASONS_KOREA_ARENA_LIMITED: 'ALL_SEASONS_KOREA_ARENA_LIMITED',
  ALL_SEASONS_KOREA_ARENA_RARE: 'ALL_SEASONS_KOREA_ARENA_RARE',
  ALL_SEASONS_NETHERLANDS_ARENA_LIMITED: 'ALL_SEASONS_NETHERLANDS_ARENA_LIMITED',
  ALL_SEASONS_NETHERLANDS_ARENA_RARE: 'ALL_SEASONS_NETHERLANDS_ARENA_RARE',
  ALL_SEASONS_PORTUGAL_ARENA_LIMITED: 'ALL_SEASONS_PORTUGAL_ARENA_LIMITED',
  ALL_SEASONS_PORTUGAL_ARENA_RARE: 'ALL_SEASONS_PORTUGAL_ARENA_RARE',
  ALL_SEASONS_SCOTLAND_ARENA_LIMITED: 'ALL_SEASONS_SCOTLAND_ARENA_LIMITED',
  ALL_SEASONS_SCOTLAND_ARENA_RARE: 'ALL_SEASONS_SCOTLAND_ARENA_RARE',
  ALL_SEASONS_SPAIN_ARENA_LIMITED: 'ALL_SEASONS_SPAIN_ARENA_LIMITED',
  ALL_SEASONS_SPAIN_ARENA_RARE: 'ALL_SEASONS_SPAIN_ARENA_RARE',
  ALL_SEASONS_SPAIN_LIMITED: 'ALL_SEASONS_SPAIN_LIMITED',
  ALL_SEASONS_SPAIN_ONBOARDING: 'ALL_SEASONS_SPAIN_ONBOARDING',
  ALL_SEASONS_SPAIN_RARE: 'ALL_SEASONS_SPAIN_RARE',
  ALL_SEASONS_SPAIN_SUPER_RARE: 'ALL_SEASONS_SPAIN_SUPER_RARE',
  ALL_SEASONS_SPAIN_UNIQUE: 'ALL_SEASONS_SPAIN_UNIQUE',
  ALL_SEASONS_TURKEY_ARENA_LIMITED: 'ALL_SEASONS_TURKEY_ARENA_LIMITED',
  ALL_SEASONS_TURKEY_ARENA_RARE: 'ALL_SEASONS_TURKEY_ARENA_RARE',
  ALL_SEASONS_UNDER_TWENTY_ONE_ARENA_LIMITED: 'ALL_SEASONS_UNDER_TWENTY_ONE_ARENA_LIMITED',
  ALL_SEASONS_UNDER_TWENTY_ONE_ARENA_RARE: 'ALL_SEASONS_UNDER_TWENTY_ONE_ARENA_RARE',
  ALL_SEASONS_UNDER_TWENTY_ONE_LIMITED: 'ALL_SEASONS_UNDER_TWENTY_ONE_LIMITED',
  ALL_SEASONS_UNDER_TWENTY_ONE_ONBOARDING: 'ALL_SEASONS_UNDER_TWENTY_ONE_ONBOARDING',
  ALL_SEASONS_UNDER_TWENTY_ONE_RARE: 'ALL_SEASONS_UNDER_TWENTY_ONE_RARE',
  ALL_SEASONS_UNDER_TWENTY_ONE_SUPER_RARE: 'ALL_SEASONS_UNDER_TWENTY_ONE_SUPER_RARE',
  ALL_SEASONS_UNDER_TWENTY_ONE_UNIQUE: 'ALL_SEASONS_UNDER_TWENTY_ONE_UNIQUE',
  ALL_SEASONS_US_ARENA_LIMITED: 'ALL_SEASONS_US_ARENA_LIMITED',
  ALL_SEASONS_US_ARENA_RARE: 'ALL_SEASONS_US_ARENA_RARE',
  ALL_SEASONS_US_LIMITED: 'ALL_SEASONS_US_LIMITED',
  ALL_SEASONS_US_ONBOARDING: 'ALL_SEASONS_US_ONBOARDING',
  ALL_SEASONS_US_RARE: 'ALL_SEASONS_US_RARE',
  ALL_SEASONS_US_SUPER_RARE: 'ALL_SEASONS_US_SUPER_RARE',
  ALL_SEASONS_US_UNIQUE: 'ALL_SEASONS_US_UNIQUE',
  CHALLENGER_EUROPE_LIMITED: 'CHALLENGER_EUROPE_LIMITED',
  CHALLENGER_EUROPE_RARE: 'CHALLENGER_EUROPE_RARE',
  CHALLENGER_EUROPE_RARE_PRO: 'CHALLENGER_EUROPE_RARE_PRO',
  CHALLENGER_EUROPE_SUPER_RARE: 'CHALLENGER_EUROPE_SUPER_RARE',
  CHALLENGER_EUROPE_UNIQUE: 'CHALLENGER_EUROPE_UNIQUE',
  CHAMPION_AMERICA_LIMITED: 'CHAMPION_AMERICA_LIMITED',
  CHAMPION_AMERICA_RARE: 'CHAMPION_AMERICA_RARE',
  CHAMPION_AMERICA_RARE_PRO: 'CHAMPION_AMERICA_RARE_PRO',
  CHAMPION_AMERICA_SUPER_RARE: 'CHAMPION_AMERICA_SUPER_RARE',
  CHAMPION_AMERICA_UNIQUE: 'CHAMPION_AMERICA_UNIQUE',
  CHAMPION_ASIA_LIMITED: 'CHAMPION_ASIA_LIMITED',
  CHAMPION_ASIA_RARE: 'CHAMPION_ASIA_RARE',
  CHAMPION_ASIA_RARE_PRO: 'CHAMPION_ASIA_RARE_PRO',
  CHAMPION_ASIA_SUPER_RARE: 'CHAMPION_ASIA_SUPER_RARE',
  CHAMPION_ASIA_UNIQUE: 'CHAMPION_ASIA_UNIQUE',
  CHAMPION_EUROPE_LIMITED: 'CHAMPION_EUROPE_LIMITED',
  CHAMPION_EUROPE_RARE: 'CHAMPION_EUROPE_RARE',
  CHAMPION_EUROPE_RARE_PRO: 'CHAMPION_EUROPE_RARE_PRO',
  CHAMPION_EUROPE_SUPER_RARE: 'CHAMPION_EUROPE_SUPER_RARE',
  CHAMPION_EUROPE_UNIQUE: 'CHAMPION_EUROPE_UNIQUE',
  CHAMPION_JUPILER_RARE: 'CHAMPION_JUPILER_RARE',
  CHAMPION_JUPILER_RARE_PRO: 'CHAMPION_JUPILER_RARE_PRO',
  CHAMPION_JUPILER_SUPER_RARE: 'CHAMPION_JUPILER_SUPER_RARE',
  CHAMPION_JUPILER_UNIQUE: 'CHAMPION_JUPILER_UNIQUE',
  FIRST_DIVISION_ENGLAND_AMATEUR: 'FIRST_DIVISION_ENGLAND_AMATEUR',
  FIRST_DIVISION_ENGLAND_PRO: 'FIRST_DIVISION_ENGLAND_PRO',
  FIRST_DIVISION_ENGLAND_SEMI_PRO: 'FIRST_DIVISION_ENGLAND_SEMI_PRO',
  FIRST_DIVISION_FRANCE_AMATEUR: 'FIRST_DIVISION_FRANCE_AMATEUR',
  FIRST_DIVISION_FRANCE_PRO: 'FIRST_DIVISION_FRANCE_PRO',
  FIRST_DIVISION_FRANCE_SEMI_PRO: 'FIRST_DIVISION_FRANCE_SEMI_PRO',
  FIRST_DIVISION_GERMANY_AMATEUR: 'FIRST_DIVISION_GERMANY_AMATEUR',
  FIRST_DIVISION_GERMANY_PRO: 'FIRST_DIVISION_GERMANY_PRO',
  FIRST_DIVISION_GERMANY_SEMI_PRO: 'FIRST_DIVISION_GERMANY_SEMI_PRO',
  FIRST_DIVISION_ITALY_AMATEUR: 'FIRST_DIVISION_ITALY_AMATEUR',
  FIRST_DIVISION_ITALY_PRO: 'FIRST_DIVISION_ITALY_PRO',
  FIRST_DIVISION_ITALY_SEMI_PRO: 'FIRST_DIVISION_ITALY_SEMI_PRO',
  FIRST_DIVISION_SPAIN_AMATEUR: 'FIRST_DIVISION_SPAIN_AMATEUR',
  FIRST_DIVISION_SPAIN_PRO: 'FIRST_DIVISION_SPAIN_PRO',
  FIRST_DIVISION_SPAIN_SEMI_PRO: 'FIRST_DIVISION_SPAIN_SEMI_PRO',
  FIRST_DIVISION_US_AMATEUR: 'FIRST_DIVISION_US_AMATEUR',
  FIRST_DIVISION_US_PRO: 'FIRST_DIVISION_US_PRO',
  FIRST_DIVISION_US_SEMI_PRO: 'FIRST_DIVISION_US_SEMI_PRO',
  GLOBAL_ALL_STAR_LIMITED: 'GLOBAL_ALL_STAR_LIMITED',
  GLOBAL_ALL_STAR_RARE: 'GLOBAL_ALL_STAR_RARE',
  GLOBAL_ALL_STAR_RARE_PRO: 'GLOBAL_ALL_STAR_RARE_PRO',
  GLOBAL_ALL_STAR_SUPER_RARE: 'GLOBAL_ALL_STAR_SUPER_RARE',
  GLOBAL_ALL_STAR_UNIQUE: 'GLOBAL_ALL_STAR_UNIQUE',
  GLOBAL_ARENA_COMMON: 'GLOBAL_ARENA_COMMON',
  GLOBAL_ARENA_LIMITED: 'GLOBAL_ARENA_LIMITED',
  GLOBAL_ARENA_RARE: 'GLOBAL_ARENA_RARE',
  GLOBAL_ARENA_SUPER_RARE: 'GLOBAL_ARENA_SUPER_RARE',
  GLOBAL_ARENA_UNCAPPED_LIMITED: 'GLOBAL_ARENA_UNCAPPED_LIMITED',
  GLOBAL_ARENA_UNCAPPED_RARE: 'GLOBAL_ARENA_UNCAPPED_RARE',
  GLOBAL_ARENA_UNCAPPED_SUPER_RARE: 'GLOBAL_ARENA_UNCAPPED_SUPER_RARE',
  GLOBAL_ARENA_UNCAPPED_UNIQUE: 'GLOBAL_ARENA_UNCAPPED_UNIQUE',
  GLOBAL_ARENA_UNIQUE: 'GLOBAL_ARENA_UNIQUE',
  GLOBAL_CAP_220_LIMITED: 'GLOBAL_CAP_220_LIMITED',
  GLOBAL_CAP_220_RARE: 'GLOBAL_CAP_220_RARE',
  GLOBAL_CAP_220_SUPER_RARE: 'GLOBAL_CAP_220_SUPER_RARE',
  GLOBAL_CAP_220_UNIQUE: 'GLOBAL_CAP_220_UNIQUE',
  GLOBAL_CAP_240_LIMITED: 'GLOBAL_CAP_240_LIMITED',
  GLOBAL_CAP_240_RARE: 'GLOBAL_CAP_240_RARE',
  GLOBAL_CAP_240_SUPER_RARE: 'GLOBAL_CAP_240_SUPER_RARE',
  GLOBAL_CAP_240_UNIQUE: 'GLOBAL_CAP_240_UNIQUE',
  GLOBAL_CAP_270_LIMITED: 'GLOBAL_CAP_270_LIMITED',
  GLOBAL_CAP_270_RARE: 'GLOBAL_CAP_270_RARE',
  GLOBAL_CAP_270_SUPER_RARE: 'GLOBAL_CAP_270_SUPER_RARE',
  GLOBAL_CAP_270_UNIQUE: 'GLOBAL_CAP_270_UNIQUE',
  GLOBAL_KICKOFF_LIMITED: 'GLOBAL_KICKOFF_LIMITED',
  GLOBAL_KICKOFF_RARE: 'GLOBAL_KICKOFF_RARE',
  GLOBAL_KICKOFF_SUPER_RARE: 'GLOBAL_KICKOFF_SUPER_RARE',
  GLOBAL_KICKOFF_UNIQUE: 'GLOBAL_KICKOFF_UNIQUE',
  GLOBAL_ONBOARDING_COMMON: 'GLOBAL_ONBOARDING_COMMON',
  GLOBAL_ONBOARDING_PRO: 'GLOBAL_ONBOARDING_PRO',
  GLOBAL_SPECIALIST_LIMITED: 'GLOBAL_SPECIALIST_LIMITED',
  GLOBAL_SPECIALIST_RARE: 'GLOBAL_SPECIALIST_RARE',
  GLOBAL_SPECIALIST_SUPER_RARE: 'GLOBAL_SPECIALIST_SUPER_RARE',
  GLOBAL_SPECIALIST_SUPER_RARE_UNIQUE: 'GLOBAL_SPECIALIST_SUPER_RARE_UNIQUE',
  GLOBAL_SPECIALIST_UNIQUE: 'GLOBAL_SPECIALIST_UNIQUE',
  GLOBAL_UNDERDOG_LIMITED: 'GLOBAL_UNDERDOG_LIMITED',
  GLOBAL_UNDERDOG_RARE: 'GLOBAL_UNDERDOG_RARE',
  GLOBAL_UNDERDOG_SUPER_RARE: 'GLOBAL_UNDERDOG_SUPER_RARE',
  GLOBAL_UNDERDOG_UNIQUE: 'GLOBAL_UNDERDOG_UNIQUE',
  GLOBAL_UNDER_TWENTY_ONE_LIMITED: 'GLOBAL_UNDER_TWENTY_ONE_LIMITED',
  GLOBAL_UNDER_TWENTY_ONE_RARE: 'GLOBAL_UNDER_TWENTY_ONE_RARE',
  GLOBAL_UNDER_TWENTY_ONE_RARE_PRO: 'GLOBAL_UNDER_TWENTY_ONE_RARE_PRO',
  GLOBAL_UNDER_TWENTY_ONE_SUPER_RARE: 'GLOBAL_UNDER_TWENTY_ONE_SUPER_RARE',
  GLOBAL_UNDER_TWENTY_ONE_UNIQUE: 'GLOBAL_UNDER_TWENTY_ONE_UNIQUE',
  GLOBAL_UNIQUE_ONLY: 'GLOBAL_UNIQUE_ONLY',
  IN_SEASON_CHALLENGERS_COMMON: 'IN_SEASON_CHALLENGERS_COMMON',
  IN_SEASON_CHALLENGERS_COMMON_PERMANENT: 'IN_SEASON_CHALLENGERS_COMMON_PERMANENT',
  IN_SEASON_CHALLENGERS_COMMON_PRO: 'IN_SEASON_CHALLENGERS_COMMON_PRO',
  IN_SEASON_CHALLENGERS_LIMITED: 'IN_SEASON_CHALLENGERS_LIMITED',
  IN_SEASON_CHALLENGERS_RARE: 'IN_SEASON_CHALLENGERS_RARE',
  IN_SEASON_CHALLENGERS_SUPER_RARE: 'IN_SEASON_CHALLENGERS_SUPER_RARE',
  IN_SEASON_CHALLENGERS_UNIQUE: 'IN_SEASON_CHALLENGERS_UNIQUE',
  IN_SEASON_CHAMPIONS_COMMON: 'IN_SEASON_CHAMPIONS_COMMON',
  IN_SEASON_CHAMPIONS_COMMON_PERMANENT: 'IN_SEASON_CHAMPIONS_COMMON_PERMANENT',
  IN_SEASON_CHAMPIONS_COMMON_PRO: 'IN_SEASON_CHAMPIONS_COMMON_PRO',
  IN_SEASON_CHAMPIONS_LIMITED: 'IN_SEASON_CHAMPIONS_LIMITED',
  IN_SEASON_CHAMPIONS_RARE: 'IN_SEASON_CHAMPIONS_RARE',
  IN_SEASON_CHAMPIONS_SUPER_RARE: 'IN_SEASON_CHAMPIONS_SUPER_RARE',
  IN_SEASON_CHAMPIONS_UNIQUE: 'IN_SEASON_CHAMPIONS_UNIQUE',
  IN_SEASON_CONTENDERS_COMMON: 'IN_SEASON_CONTENDERS_COMMON',
  IN_SEASON_CONTENDERS_COMMON_PERMANENT: 'IN_SEASON_CONTENDERS_COMMON_PERMANENT',
  IN_SEASON_CONTENDERS_COMMON_PRO: 'IN_SEASON_CONTENDERS_COMMON_PRO',
  IN_SEASON_CONTENDERS_LIMITED: 'IN_SEASON_CONTENDERS_LIMITED',
  IN_SEASON_CONTENDERS_RARE: 'IN_SEASON_CONTENDERS_RARE',
  IN_SEASON_CONTENDERS_SUPER_RARE: 'IN_SEASON_CONTENDERS_SUPER_RARE',
  IN_SEASON_CONTENDERS_UNIQUE: 'IN_SEASON_CONTENDERS_UNIQUE',
  IN_SEASON_ENGLAND_COMMON: 'IN_SEASON_ENGLAND_COMMON',
  IN_SEASON_ENGLAND_COMMON_PERMANENT: 'IN_SEASON_ENGLAND_COMMON_PERMANENT',
  IN_SEASON_ENGLAND_COMMON_PRO: 'IN_SEASON_ENGLAND_COMMON_PRO',
  IN_SEASON_ENGLAND_LIMITED: 'IN_SEASON_ENGLAND_LIMITED',
  IN_SEASON_ENGLAND_RARE: 'IN_SEASON_ENGLAND_RARE',
  IN_SEASON_ENGLAND_SECOND_LIMITED: 'IN_SEASON_ENGLAND_SECOND_LIMITED',
  IN_SEASON_ENGLAND_SECOND_RARE: 'IN_SEASON_ENGLAND_SECOND_RARE',
  IN_SEASON_ENGLAND_SECOND_SUPER_RARE: 'IN_SEASON_ENGLAND_SECOND_SUPER_RARE',
  IN_SEASON_ENGLAND_SUPER_RARE: 'IN_SEASON_ENGLAND_SUPER_RARE',
  IN_SEASON_ENGLAND_UNIQUE: 'IN_SEASON_ENGLAND_UNIQUE',
  IN_SEASON_FRANCE_COMMON: 'IN_SEASON_FRANCE_COMMON',
  IN_SEASON_FRANCE_LIMITED: 'IN_SEASON_FRANCE_LIMITED',
  IN_SEASON_FRANCE_RARE: 'IN_SEASON_FRANCE_RARE',
  IN_SEASON_FRANCE_SUPER_RARE: 'IN_SEASON_FRANCE_SUPER_RARE',
  IN_SEASON_GERMANY_COMMON: 'IN_SEASON_GERMANY_COMMON',
  IN_SEASON_GERMANY_LIMITED: 'IN_SEASON_GERMANY_LIMITED',
  IN_SEASON_GERMANY_RARE: 'IN_SEASON_GERMANY_RARE',
  IN_SEASON_GERMANY_SUPER_RARE: 'IN_SEASON_GERMANY_SUPER_RARE',
  IN_SEASON_GERMANY_UNIQUE: 'IN_SEASON_GERMANY_UNIQUE',
  IN_SEASON_GLOBAL_ALL_STAR_COMMON: 'IN_SEASON_GLOBAL_ALL_STAR_COMMON',
  IN_SEASON_JAPAN_LIMITED_PVE: 'IN_SEASON_JAPAN_LIMITED_PVE',
  IN_SEASON_JAPAN_LIMITED_PVP: 'IN_SEASON_JAPAN_LIMITED_PVP',
  IN_SEASON_JAPAN_RARE_PVE: 'IN_SEASON_JAPAN_RARE_PVE',
  IN_SEASON_JAPAN_RARE_PVP: 'IN_SEASON_JAPAN_RARE_PVP',
  IN_SEASON_JAPAN_SUPER_RARE_PVE: 'IN_SEASON_JAPAN_SUPER_RARE_PVE',
  IN_SEASON_JAPAN_SUPER_RARE_PVP: 'IN_SEASON_JAPAN_SUPER_RARE_PVP',
  IN_SEASON_JUPILER_LIMITED: 'IN_SEASON_JUPILER_LIMITED',
  IN_SEASON_JUPILER_RARE: 'IN_SEASON_JUPILER_RARE',
  IN_SEASON_JUPILER_SUPER_RARE: 'IN_SEASON_JUPILER_SUPER_RARE',
  IN_SEASON_KOREA_LIMITED_PVE: 'IN_SEASON_KOREA_LIMITED_PVE',
  IN_SEASON_KOREA_LIMITED_PVP: 'IN_SEASON_KOREA_LIMITED_PVP',
  IN_SEASON_KOREA_RARE_PVE: 'IN_SEASON_KOREA_RARE_PVE',
  IN_SEASON_KOREA_RARE_PVP: 'IN_SEASON_KOREA_RARE_PVP',
  IN_SEASON_KOREA_SUPER_RARE_PVE: 'IN_SEASON_KOREA_SUPER_RARE_PVE',
  IN_SEASON_KOREA_SUPER_RARE_PVP: 'IN_SEASON_KOREA_SUPER_RARE_PVP',
  IN_SEASON_NETHERLANDS_LIMITED: 'IN_SEASON_NETHERLANDS_LIMITED',
  IN_SEASON_NETHERLANDS_RARE: 'IN_SEASON_NETHERLANDS_RARE',
  IN_SEASON_NETHERLANDS_SUPER_RARE: 'IN_SEASON_NETHERLANDS_SUPER_RARE',
  IN_SEASON_PORTUGAL_LIMITED: 'IN_SEASON_PORTUGAL_LIMITED',
  IN_SEASON_PORTUGAL_RARE: 'IN_SEASON_PORTUGAL_RARE',
  IN_SEASON_PORTUGAL_SUPER_RARE: 'IN_SEASON_PORTUGAL_SUPER_RARE',
  IN_SEASON_REST_OF_THE_WORLD_SUPER_RARE: 'IN_SEASON_REST_OF_THE_WORLD_SUPER_RARE',
  IN_SEASON_SCOTLAND_LIMITED: 'IN_SEASON_SCOTLAND_LIMITED',
  IN_SEASON_SCOTLAND_RARE: 'IN_SEASON_SCOTLAND_RARE',
  IN_SEASON_SCOTLAND_SUPER_RARE: 'IN_SEASON_SCOTLAND_SUPER_RARE',
  IN_SEASON_SPAIN_COMMON: 'IN_SEASON_SPAIN_COMMON',
  IN_SEASON_SPAIN_LIMITED: 'IN_SEASON_SPAIN_LIMITED',
  IN_SEASON_SPAIN_RARE: 'IN_SEASON_SPAIN_RARE',
  IN_SEASON_SPAIN_SUPER_RARE: 'IN_SEASON_SPAIN_SUPER_RARE',
  IN_SEASON_SPAIN_UNIQUE: 'IN_SEASON_SPAIN_UNIQUE',
  IN_SEASON_US_COMMON: 'IN_SEASON_US_COMMON',
  IN_SEASON_US_LIMITED: 'IN_SEASON_US_LIMITED',
  IN_SEASON_US_LIMITED_PVE: 'IN_SEASON_US_LIMITED_PVE',
  IN_SEASON_US_LIMITED_PVP: 'IN_SEASON_US_LIMITED_PVP',
  IN_SEASON_US_RARE: 'IN_SEASON_US_RARE',
  IN_SEASON_US_RARE_PVE: 'IN_SEASON_US_RARE_PVE',
  IN_SEASON_US_RARE_PVP: 'IN_SEASON_US_RARE_PVP',
  IN_SEASON_US_SUPER_RARE: 'IN_SEASON_US_SUPER_RARE',
  IN_SEASON_US_SUPER_RARE_PVE: 'IN_SEASON_US_SUPER_RARE_PVE',
  IN_SEASON_US_SUPER_RARE_PVP: 'IN_SEASON_US_SUPER_RARE_PVP',
  IN_SEASON_US_UNIQUE: 'IN_SEASON_US_UNIQUE',
  LEGEND: 'LEGEND',
  LEGEND_PRO: 'LEGEND_PRO',
  MLB_COMMON_ALL_STAR: 'MLB_COMMON_ALL_STAR',
  MLB_COMMON_DAILY_DERBY: 'MLB_COMMON_DAILY_DERBY',
  MLB_COMMON_DAILY_DERBY_ONBOARDING: 'MLB_COMMON_DAILY_DERBY_ONBOARDING',
  MLB_COMMON_DAILY_SWING: 'MLB_COMMON_DAILY_SWING',
  MLB_COMMON_MINORS: 'MLB_COMMON_MINORS',
  MLB_COMMON_PROSPECT: 'MLB_COMMON_PROSPECT',
  MLB_COMMON_WEEKLY: 'MLB_COMMON_WEEKLY',
  MLB_LIMITED_ALL_STAR: 'MLB_LIMITED_ALL_STAR',
  MLB_LIMITED_AMERICAN_LEAGUE: 'MLB_LIMITED_AMERICAN_LEAGUE',
  MLB_LIMITED_ARENA: 'MLB_LIMITED_ARENA',
  MLB_LIMITED_ARENA_AMERICAN: 'MLB_LIMITED_ARENA_AMERICAN',
  MLB_LIMITED_ARENA_BEGINNER: 'MLB_LIMITED_ARENA_BEGINNER',
  MLB_LIMITED_ARENA_ELITE: 'MLB_LIMITED_ARENA_ELITE',
  MLB_LIMITED_ARENA_HITTERS: 'MLB_LIMITED_ARENA_HITTERS',
  MLB_LIMITED_ARENA_LEGACY: 'MLB_LIMITED_ARENA_LEGACY',
  MLB_LIMITED_ARENA_NATIONAL: 'MLB_LIMITED_ARENA_NATIONAL',
  MLB_LIMITED_ARENA_OG: 'MLB_LIMITED_ARENA_OG',
  MLB_LIMITED_ARENA_SANDLOT: 'MLB_LIMITED_ARENA_SANDLOT',
  MLB_LIMITED_CHALLENGER: 'MLB_LIMITED_CHALLENGER',
  MLB_LIMITED_CHAMPION: 'MLB_LIMITED_CHAMPION',
  MLB_LIMITED_CHAMPION_PVE: 'MLB_LIMITED_CHAMPION_PVE',
  MLB_LIMITED_CHAMPION_PVP: 'MLB_LIMITED_CHAMPION_PVP',
  MLB_LIMITED_DAILY_DERBY: 'MLB_LIMITED_DAILY_DERBY',
  MLB_LIMITED_DAILY_SWING: 'MLB_LIMITED_DAILY_SWING',
  MLB_LIMITED_MAJORS: 'MLB_LIMITED_MAJORS',
  MLB_LIMITED_NATIONAL_LEAGUE: 'MLB_LIMITED_NATIONAL_LEAGUE',
  MLB_LIMITED_PRO: 'MLB_LIMITED_PRO',
  MLB_LIMITED_SPECIAL: 'MLB_LIMITED_SPECIAL',
  MLB_LIMITED_SPECIAL_DAILY: 'MLB_LIMITED_SPECIAL_DAILY',
  MLB_LIMITED_UNDER_25: 'MLB_LIMITED_UNDER_25',
  MLB_LIMITED_VAULT: 'MLB_LIMITED_VAULT',
  MLB_LIMITED_WEEKLY: 'MLB_LIMITED_WEEKLY',
  MLB_MONTHLY_CHASE_COMMON: 'MLB_MONTHLY_CHASE_COMMON',
  MLB_MONTHLY_CHASE_LIMITED: 'MLB_MONTHLY_CHASE_LIMITED',
  MLB_MONTHLY_CHASE_RARE: 'MLB_MONTHLY_CHASE_RARE',
  MLB_MONTHLY_CHASE_SUPER_RARE: 'MLB_MONTHLY_CHASE_SUPER_RARE',
  MLB_MONTHLY_CHASE_UNIQUE: 'MLB_MONTHLY_CHASE_UNIQUE',
  MLB_RARE_ALL_STAR: 'MLB_RARE_ALL_STAR',
  MLB_RARE_AMERICAN_LEAGUE: 'MLB_RARE_AMERICAN_LEAGUE',
  MLB_RARE_ARENA: 'MLB_RARE_ARENA',
  MLB_RARE_ARENA_AMERICAN: 'MLB_RARE_ARENA_AMERICAN',
  MLB_RARE_ARENA_BEGINNER: 'MLB_RARE_ARENA_BEGINNER',
  MLB_RARE_ARENA_ELITE: 'MLB_RARE_ARENA_ELITE',
  MLB_RARE_ARENA_NATIONAL: 'MLB_RARE_ARENA_NATIONAL',
  MLB_RARE_ARENA_SANDLOT: 'MLB_RARE_ARENA_SANDLOT',
  MLB_RARE_CHALLENGER: 'MLB_RARE_CHALLENGER',
  MLB_RARE_CHAMPION: 'MLB_RARE_CHAMPION',
  MLB_RARE_CHAMPION_PVE: 'MLB_RARE_CHAMPION_PVE',
  MLB_RARE_CHAMPION_PVP: 'MLB_RARE_CHAMPION_PVP',
  MLB_RARE_DAILY_DERBY: 'MLB_RARE_DAILY_DERBY',
  MLB_RARE_DAILY_SWING: 'MLB_RARE_DAILY_SWING',
  MLB_RARE_NATIONAL_LEAGUE: 'MLB_RARE_NATIONAL_LEAGUE',
  MLB_RARE_PRO: 'MLB_RARE_PRO',
  MLB_RARE_SPECIAL: 'MLB_RARE_SPECIAL',
  MLB_RARE_SPECIAL_DAILY: 'MLB_RARE_SPECIAL_DAILY',
  MLB_RARE_UNDER_25: 'MLB_RARE_UNDER_25',
  MLB_RARE_VAULT: 'MLB_RARE_VAULT',
  MLB_RARE_WEEKLY: 'MLB_RARE_WEEKLY',
  MLB_SANDLOT: 'MLB_SANDLOT',
  MLB_SUPER_RARE_ALL_STAR: 'MLB_SUPER_RARE_ALL_STAR',
  MLB_SUPER_RARE_AMERICAN_LEAGUE: 'MLB_SUPER_RARE_AMERICAN_LEAGUE',
  MLB_SUPER_RARE_ARENA: 'MLB_SUPER_RARE_ARENA',
  MLB_SUPER_RARE_ARENA_AMERICAN: 'MLB_SUPER_RARE_ARENA_AMERICAN',
  MLB_SUPER_RARE_ARENA_NATIONAL: 'MLB_SUPER_RARE_ARENA_NATIONAL',
  MLB_SUPER_RARE_CHALLENGER: 'MLB_SUPER_RARE_CHALLENGER',
  MLB_SUPER_RARE_CHAMPION: 'MLB_SUPER_RARE_CHAMPION',
  MLB_SUPER_RARE_CHAMPION_PVE: 'MLB_SUPER_RARE_CHAMPION_PVE',
  MLB_SUPER_RARE_CHAMPION_PVP: 'MLB_SUPER_RARE_CHAMPION_PVP',
  MLB_SUPER_RARE_DAILY_DERBY: 'MLB_SUPER_RARE_DAILY_DERBY',
  MLB_SUPER_RARE_DAILY_SWING: 'MLB_SUPER_RARE_DAILY_SWING',
  MLB_SUPER_RARE_NATIONAL_LEAGUE: 'MLB_SUPER_RARE_NATIONAL_LEAGUE',
  MLB_SUPER_RARE_PRO: 'MLB_SUPER_RARE_PRO',
  MLB_SUPER_RARE_SPECIAL: 'MLB_SUPER_RARE_SPECIAL',
  MLB_SUPER_RARE_SPECIAL_DAILY: 'MLB_SUPER_RARE_SPECIAL_DAILY',
  MLB_SUPER_RARE_UNDER_25: 'MLB_SUPER_RARE_UNDER_25',
  MLB_SUPER_RARE_VAULT: 'MLB_SUPER_RARE_VAULT',
  MLB_SUPER_RARE_WEEKLY: 'MLB_SUPER_RARE_WEEKLY',
  MLB_TRAINING: 'MLB_TRAINING',
  MLB_UNIQUE_ALL_STAR: 'MLB_UNIQUE_ALL_STAR',
  MLB_UNIQUE_ARENA: 'MLB_UNIQUE_ARENA',
  MLB_UNIQUE_CHALLENGER: 'MLB_UNIQUE_CHALLENGER',
  MLB_UNIQUE_CHAMPION: 'MLB_UNIQUE_CHAMPION',
  MLB_UNIQUE_DAILY_DERBY: 'MLB_UNIQUE_DAILY_DERBY',
  MLB_UNIQUE_DAILY_SWING: 'MLB_UNIQUE_DAILY_SWING',
  MLB_UNIQUE_PRO: 'MLB_UNIQUE_PRO',
  MLB_UNIQUE_SPECIAL: 'MLB_UNIQUE_SPECIAL',
  MLB_UNIQUE_SPECIAL_DAILY: 'MLB_UNIQUE_SPECIAL_DAILY',
  MLB_UNIQUE_UNDER_25: 'MLB_UNIQUE_UNDER_25',
  MLB_UNIQUE_VAULT: 'MLB_UNIQUE_VAULT',
  MLB_UNIQUE_WEEKLY: 'MLB_UNIQUE_WEEKLY',
  NBA_COMMON_CHAMPION: 'NBA_COMMON_CHAMPION',
  NBA_COMMON_CHAMPION_SPECIAL_EDITION: 'NBA_COMMON_CHAMPION_SPECIAL_EDITION',
  NBA_COMMON_CONTENDER: 'NBA_COMMON_CONTENDER',
  NBA_COMMON_CONTENDER_SPECIAL_EDITION: 'NBA_COMMON_CONTENDER_SPECIAL_EDITION',
  NBA_COMMON_DAILY: 'NBA_COMMON_DAILY',
  NBA_COMMON_DAILY_HOOPS: 'NBA_COMMON_DAILY_HOOPS',
  NBA_COMMON_DAILY_PICKUP: 'NBA_COMMON_DAILY_PICKUP',
  NBA_COMMON_DAILY_SPECIAL: 'NBA_COMMON_DAILY_SPECIAL',
  NBA_COMMON_TIP_OFF: 'NBA_COMMON_TIP_OFF',
  NBA_COMMON_WEEKLY: 'NBA_COMMON_WEEKLY',
  NBA_LIMITED_ARENA_75: 'NBA_LIMITED_ARENA_75',
  NBA_LIMITED_ARENA_140: 'NBA_LIMITED_ARENA_140',
  NBA_LIMITED_ARENA_140_UNDER_TWENTY_ONE: 'NBA_LIMITED_ARENA_140_UNDER_TWENTY_ONE',
  NBA_LIMITED_ARENA_140_VETERANS: 'NBA_LIMITED_ARENA_140_VETERANS',
  NBA_LIMITED_ARENA_UNCAPPED: 'NBA_LIMITED_ARENA_UNCAPPED',
  NBA_LIMITED_CHALLENGER: 'NBA_LIMITED_CHALLENGER',
  NBA_LIMITED_CHAMPION: 'NBA_LIMITED_CHAMPION',
  NBA_LIMITED_CONTENDER: 'NBA_LIMITED_CONTENDER',
  NBA_LIMITED_DAILY: 'NBA_LIMITED_DAILY',
  NBA_LIMITED_DAILY_HOOPS: 'NBA_LIMITED_DAILY_HOOPS',
  NBA_LIMITED_DAILY_SPECIAL: 'NBA_LIMITED_DAILY_SPECIAL',
  NBA_LIMITED_IN_SEASON_CHAMPION: 'NBA_LIMITED_IN_SEASON_CHAMPION',
  NBA_LIMITED_IN_SEASON_CONTENDER: 'NBA_LIMITED_IN_SEASON_CONTENDER',
  NBA_LIMITED_IN_SEASON_UNDERDOG: 'NBA_LIMITED_IN_SEASON_UNDERDOG',
  NBA_LIMITED_TIP_OF: 'NBA_LIMITED_TIP_OF',
  NBA_LIMITED_UNDERDOG: 'NBA_LIMITED_UNDERDOG',
  NBA_LIMITED_WEEKLY: 'NBA_LIMITED_WEEKLY',
  NBA_RARE_ARENA_75: 'NBA_RARE_ARENA_75',
  NBA_RARE_ARENA_140: 'NBA_RARE_ARENA_140',
  NBA_RARE_ARENA_140_UNDER_TWENTY_ONE: 'NBA_RARE_ARENA_140_UNDER_TWENTY_ONE',
  NBA_RARE_ARENA_140_VETERANS: 'NBA_RARE_ARENA_140_VETERANS',
  NBA_RARE_ARENA_UNCAPPED: 'NBA_RARE_ARENA_UNCAPPED',
  NBA_RARE_CHALLENGER: 'NBA_RARE_CHALLENGER',
  NBA_RARE_CHAMPION: 'NBA_RARE_CHAMPION',
  NBA_RARE_CONTENDER: 'NBA_RARE_CONTENDER',
  NBA_RARE_DAILY: 'NBA_RARE_DAILY',
  NBA_RARE_DAILY_HOOPS: 'NBA_RARE_DAILY_HOOPS',
  NBA_RARE_DAILY_SPECIAL: 'NBA_RARE_DAILY_SPECIAL',
  NBA_RARE_IN_SEASON_CHAMPION: 'NBA_RARE_IN_SEASON_CHAMPION',
  NBA_RARE_IN_SEASON_CONTENDER: 'NBA_RARE_IN_SEASON_CONTENDER',
  NBA_RARE_IN_SEASON_UNDERDOG: 'NBA_RARE_IN_SEASON_UNDERDOG',
  NBA_RARE_UNDERDOG: 'NBA_RARE_UNDERDOG',
  NBA_RARE_WEEKLY: 'NBA_RARE_WEEKLY',
  NBA_SUPER_RARE_ARENA_75: 'NBA_SUPER_RARE_ARENA_75',
  NBA_SUPER_RARE_ARENA_140: 'NBA_SUPER_RARE_ARENA_140',
  NBA_SUPER_RARE_ARENA_UNCAPPED: 'NBA_SUPER_RARE_ARENA_UNCAPPED',
  NBA_SUPER_RARE_CHALLENGER: 'NBA_SUPER_RARE_CHALLENGER',
  NBA_SUPER_RARE_CHAMPION: 'NBA_SUPER_RARE_CHAMPION',
  NBA_SUPER_RARE_CONTENDER: 'NBA_SUPER_RARE_CONTENDER',
  NBA_SUPER_RARE_DAILY: 'NBA_SUPER_RARE_DAILY',
  NBA_SUPER_RARE_DAILY_HOOPS: 'NBA_SUPER_RARE_DAILY_HOOPS',
  NBA_SUPER_RARE_DAILY_SPECIAL: 'NBA_SUPER_RARE_DAILY_SPECIAL',
  NBA_SUPER_RARE_IN_SEASON_CHAMPION: 'NBA_SUPER_RARE_IN_SEASON_CHAMPION',
  NBA_SUPER_RARE_IN_SEASON_CONTENDER: 'NBA_SUPER_RARE_IN_SEASON_CONTENDER',
  NBA_SUPER_RARE_SPECIAL: 'NBA_SUPER_RARE_SPECIAL',
  NBA_SUPER_RARE_WEEKLY: 'NBA_SUPER_RARE_WEEKLY',
  NBA_TRAINING: 'NBA_TRAINING',
  NBA_UNIQUE_CHAMPION: 'NBA_UNIQUE_CHAMPION',
  NBA_UNIQUE_CONTENDER: 'NBA_UNIQUE_CONTENDER',
  NBA_UNIQUE_DAILY: 'NBA_UNIQUE_DAILY',
  NBA_UNIQUE_DAILY_HOOPS: 'NBA_UNIQUE_DAILY_HOOPS',
  NBA_UNIQUE_DAILY_SPECIAL: 'NBA_UNIQUE_DAILY_SPECIAL',
  NBA_UNIQUE_IN_SEASON_CHAMPION: 'NBA_UNIQUE_IN_SEASON_CHAMPION',
  NBA_UNIQUE_IN_SEASON_CONTENDER: 'NBA_UNIQUE_IN_SEASON_CONTENDER',
  SECOND_DIVISION_EUROPE_LIMITED: 'SECOND_DIVISION_EUROPE_LIMITED',
  SECOND_DIVISION_EUROPE_RARE: 'SECOND_DIVISION_EUROPE_RARE',
  SECOND_DIVISION_EUROPE_RARE_PRO: 'SECOND_DIVISION_EUROPE_RARE_PRO',
  SECOND_DIVISION_EUROPE_SUPER_RARE: 'SECOND_DIVISION_EUROPE_SUPER_RARE',
  SECOND_DIVISION_EUROPE_UNIQUE: 'SECOND_DIVISION_EUROPE_UNIQUE',
  SPECIAL_GLOBAL_CUP: 'SPECIAL_GLOBAL_CUP',
  SPECIAL_TRAINING_CENTER: 'SPECIAL_TRAINING_CENTER',
  SPECIAL_WEEKLY: 'SPECIAL_WEEKLY',
  STARTER_ACADEMY_ADVANCED: 'STARTER_ACADEMY_ADVANCED',
  STARTER_ACADEMY_INTERMEDIATE: 'STARTER_ACADEMY_INTERMEDIATE',
  STARTER_ACADEMY_NOVICE: 'STARTER_ACADEMY_NOVICE',
  STARTER_ACADEMY_PROFICIENT: 'STARTER_ACADEMY_PROFICIENT',
  STARTER_ROOKIE: 'STARTER_ROOKIE'
} as const;

export type So5LeaderboardType = typeof So5LeaderboardType[keyof typeof So5LeaderboardType];
/** A So5 league */
export interface So5League extends Node, So5LeaderboardGroupInterface {
  __typename: 'So5League';
  backgroundUrl?: Maybe<Scalars['String']['output']>;
  bannerUrl: Scalars['String']['output'];
  canCompose: Validity;
  category: Scalars['String']['output'];
  color: Scalars['String']['output'];
  compactBannerUrl?: Maybe<Scalars['String']['output']>;
  /** Get sport games for a window of maximum 2 days. */
  competitionGames: Array<CompetitionGames>;
  competitions: Array<Competition>;
  cutOffDate: Scalars['ISO8601DateTime']['output'];
  description: Scalars['String']['output'];
  displayName: Scalars['String']['output'];
  eligibleCardsCountByPosition: Array<UserCardsCount>;
  featured: Scalars['Boolean']['output'];
  featuredBannerUrl: Scalars['String']['output'];
  /** The `games` field cannot be nested within a list. */
  games: Array<Game>;
  hasLeaderboards: Scalars['Boolean']['output'];
  hasMyCollectionTasks: Scalars['Boolean']['output'];
  headerBackgroundUrl: Scalars['String']['output'];
  headerUrl: Scalars['String']['output'];
  /** The `highlighted_recommendations` field cannot be nested within a list. */
  highlightedRecommendations: Array<PlayerRecommendation>;
  iconUrl: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  leagueSummary?: Maybe<Scalars['String']['output']>;
  lockType?: Maybe<LockTypeEnum>;
  logoUrl: Scalars['String']['output'];
  /** The `my_collection_tasks` field cannot be nested within a list. */
  myCollectionTasks: Array<CardsCountTargetTask | CardsCountTask | CompleteCollectionsCountTargetTask | CompleteCollectionsCountTask | DailyActionTask | DecisivePlayerPickerTask | DropChallengeTask | GameWeeklyTask | GuessTheScoreTask | InviteTaskAsReferrer | So5LeaderboardTask | StarPackTask | Task | TasksTrack | ThresholdPickerTask | ThresholdsDuoConnectionTask | ThresholdsStreakAdditionalLineupTask | ThresholdsStreakTask>;
  /** Eligible rewards until so5 fixture is closed, actual so5 rewards after */
  myEligibleOrSo5Rewards: Array<So5RewardOrConfig>;
  myEligibleRewardConfigs: Array<CardPacksRewardConfig | CardRewardConfig | CardShardRewardConfig | CoinRewardConfig | ConversionCreditRewardConfig | DeliverableItemRewardConfig | ExperienceRewardConfig | InGameCurrencyRewardConfig | MonetaryRewardConfig | ProbabilisticBundleRewardConfig | ShopItemRewardConfig>;
  /** The `my_so5_games` field cannot be nested within a list. */
  mySo5Games: Array<Game>;
  mySo5LeaderboardContenders: Array<So5LeaderboardContender>;
  mySo5Leaderboards: Array<So5Leaderboard>;
  mySo5LineupsCount: Scalars['Int']['output'];
  myThresholdsStreakTasks: Array<ThresholdsStreakTask>;
  myUnclaimedCollectionTasksCount: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  nextOpenedSo5LeaderboardGroup?: Maybe<So5LeaderboardGroup | So5League>;
  /** The `ordered_player_game_scores` field cannot be nested within a list. */
  orderedPlayerGameScores: Array<OrderedPlayerGameScores>;
  /** Get ordered PlayerGameScore by position (default to all positions) */
  orderedPlayerGameScoresByPosition: PlayerGameScoreInterfaceConnection;
  /** The `ordered_so5_scores` field cannot be nested within a list. */
  orderedSo5Scores: Array<OrderedSo5Scores>;
  /** Get ordered So5Score by position (default to all positions) */
  orderedSo5ScoresByPosition: So5ScoreConnection;
  percentageOfGamesPlayed: Scalars['Float']['output'];
  pictureUrl?: Maybe<Scalars['String']['output']>;
  rewardPool: Array<PlayerWithSupply>;
  rewardPoolComputedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  scoringMatrix: ScoringMatrix;
  seasonalities: Array<So5LeaderboardSeasonality>;
  shortDescription?: Maybe<Scalars['String']['output']>;
  shortDisplayName: Scalars['String']['output'];
  slug: Scalars['String']['output'];
  so5Competition: So5Competition;
  so5Fixture: So5Fixture;
  so5LeaderboardContenders: Array<So5LeaderboardContender>;
  so5Leaderboards: Array<So5Leaderboard>;
  so5LeagueTrack?: Maybe<So5LeagueTrack>;
  so5LeagueTrackGroup?: Maybe<So5LeagueTrackGroup>;
  so5LeagueTrackGroups: Array<So5LeagueTrackGroup>;
  so5LeagueTracks: Array<So5LeagueTrack>;
  so5LineupsCount: Scalars['Int']['output'];
  soleSo5Leaderboard?: Maybe<So5Leaderboard>;
  squarePictureUrl: Scalars['String']['output'];
  stadiumUrl?: Maybe<Scalars['String']['output']>;
  tileBackgroundUrl?: Maybe<Scalars['String']['output']>;
  /** The `top_recommendations` field cannot be nested within a list. */
  topRecommendations: Array<PlayerRecommendation>;
  totalRewardConfigs: Array<CardPacksRewardConfig | CardRewardConfig | CardShardRewardConfig | CoinRewardConfig | ConversionCreditRewardConfig | DeliverableItemRewardConfig | ExperienceRewardConfig | InGameCurrencyRewardConfig | MonetaryRewardConfig | ProbabilisticBundleRewardConfig | ShopItemRewardConfig>;
  totalRewards: RewardsOverview;
  vaultPointsRequired: Scalars['Boolean']['output'];
}


/** A So5 league */
export interface So5LeaguebackgroundUrlArgs {
  seasonality?: InputMaybe<So5LeaderboardSeasonality>;
  variant?: InputMaybe<AssetVariant>;
}


/** A So5 league */
export interface So5LeaguecolorArgs {
  variant?: InputMaybe<ColorVariant>;
}


/** A So5 league */
export interface So5LeaguecompetitionGamesArgs {
  fromDate?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  toDate?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
}


/** A So5 league */
export interface So5LeaguehasMyCollectionTasksArgs {
  rarity?: InputMaybe<Rarity>;
}


/** A So5 league */
export interface So5LeagueheaderBackgroundUrlArgs {
  seasonality?: InputMaybe<So5LeaderboardSeasonality>;
}


/** A So5 league */
export interface So5LeaguehighlightedRecommendationsArgs {
  positions?: InputMaybe<Array<Position>>;
  recommendationEngine: RecommendationEngine;
  sport: Sport;
}


/** A So5 league */
export interface So5LeaguemyCollectionTasksArgs {
  rarity?: InputMaybe<Rarity>;
}


/** A So5 league */
export interface So5LeaguemyEligibleOrSo5RewardsArgs {
  multiplyBaseRewards?: InputMaybe<Scalars['Boolean']['input']>;
}


/** A So5 league */
export interface So5LeaguemyEligibleRewardConfigsArgs {
  multiplyBaseRewards?: InputMaybe<Scalars['Boolean']['input']>;
}


/** A So5 league */
export interface So5LeaguemySo5LeaderboardContendersArgs {
  includeHiddenManagerTeam?: InputMaybe<Scalars['Boolean']['input']>;
  sortType?: InputMaybe<So5LeaderboardContenderSort>;
}


/** A So5 league */
export interface So5LeaguemyUnclaimedCollectionTasksCountArgs {
  rarity?: InputMaybe<Rarity>;
}


/** A So5 league */
export interface So5LeagueorderedPlayerGameScoresArgs {
  first: Scalars['Int']['input'];
}


/** A So5 league */
export interface So5LeagueorderedPlayerGameScoresByPositionArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  minScore?: InputMaybe<Scalars['Int']['input']>;
  positionsTyped?: InputMaybe<Array<Position>>;
  sellable?: InputMaybe<Scalars['Boolean']['input']>;
}


/** A So5 league */
export interface So5LeagueorderedSo5ScoresArgs {
  first: Scalars['Int']['input'];
}


/** A So5 league */
export interface So5LeagueorderedSo5ScoresByPositionArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  minScore?: InputMaybe<Scalars['Int']['input']>;
  myCardsRarities?: InputMaybe<Array<Rarity>>;
  positionsTyped?: InputMaybe<Array<Position>>;
  sellable?: InputMaybe<Scalars['Boolean']['input']>;
}


/** A So5 league */
export interface So5LeaguepictureUrlArgs {
  seasonality?: InputMaybe<So5LeaderboardSeasonality>;
}


/** A So5 league */
export interface So5LeaguerewardPoolArgs {
  gameplayTier?: InputMaybe<GameplayTier>;
  quality?: InputMaybe<Scalars['String']['input']>;
  rarity: Scalars['String']['input'];
}


/** A So5 league */
export interface So5Leagueso5LeaderboardContendersArgs {
  includeHiddenManagerTeam?: InputMaybe<Scalars['Boolean']['input']>;
  sortType?: InputMaybe<So5LeaderboardContenderSort>;
  userSlug: Scalars['String']['input'];
}


/** A So5 league */
export interface So5Leagueso5LeaderboardsArgs {
  notRooms?: InputMaybe<Scalars['Boolean']['input']>;
  rarity?: InputMaybe<Rarity>;
}


/** A So5 league */
export interface So5Leagueso5LeagueTrackArgs {
  slug: Scalars['String']['input'];
}


/** A So5 league */
export interface So5Leagueso5LeagueTrackGroupArgs {
  slug: Scalars['String']['input'];
}


/** A So5 league */
export interface So5LeaguesoleSo5LeaderboardArgs {
  rarity?: InputMaybe<Rarity>;
}


/** A So5 league */
export interface So5LeaguestadiumUrlArgs {
  boostedRewards?: InputMaybe<Scalars['Boolean']['input']>;
  seasonality?: InputMaybe<So5LeaderboardSeasonality>;
}


/** A So5 league */
export interface So5LeaguetopRecommendationsArgs {
  filters?: InputMaybe<BenchFilterInput>;
  playingHomeOnly?: InputMaybe<Scalars['Boolean']['input']>;
  positions?: InputMaybe<Array<Position>>;
  query?: InputMaybe<Scalars['String']['input']>;
  recommendationEngine: RecommendationEngine;
  sortType?: InputMaybe<EligibleCardsSort>;
  sport: Sport;
  starterOddsBasisPointsRange?: InputMaybe<RangeInput>;
}


/** A So5 league */
export interface So5LeaguetotalRewardConfigsArgs {
  highestConfigByType?: InputMaybe<Scalars['Boolean']['input']>;
  onlyPlayable?: InputMaybe<Scalars['Boolean']['input']>;
  seasonality?: InputMaybe<So5LeaderboardSeasonality>;
}


/** A So5 league */
export interface So5LeaguetotalRewardsArgs {
  seasonality?: InputMaybe<So5LeaderboardSeasonality>;
}

/** A So5 League Track */
export interface So5LeagueTrack {
  __typename: 'So5LeagueTrack';
  canCompose: Validity;
  completed?: Maybe<Scalars['Boolean']['output']>;
  displayName: Scalars['String']['output'];
  entrySo5Leaderboard: So5Leaderboard;
  groupSlug: Scalars['String']['output'];
  iconUrl?: Maybe<Scalars['String']['output']>;
  maxManagerTeamsCount: Scalars['Int']['output'];
  myManagerTeams: Array<ManagerTeam>;
  mySo5LeaderboardContenders: Array<So5LeaderboardContender>;
  myThresholdsStreakTask?: Maybe<ThresholdsStreakTask>;
  seasonality?: Maybe<So5LeaderboardSeasonality>;
  seasonalityName?: Maybe<Scalars['String']['output']>;
  slug: Scalars['String']['output'];
  so5Leaderboards: Array<So5Leaderboard>;
  so5LineupsCount: Scalars['Int']['output'];
  totalRewardConfigs: Array<CardPacksRewardConfig | CardRewardConfig | CardShardRewardConfig | CoinRewardConfig | ConversionCreditRewardConfig | DeliverableItemRewardConfig | ExperienceRewardConfig | InGameCurrencyRewardConfig | MonetaryRewardConfig | ProbabilisticBundleRewardConfig | ShopItemRewardConfig>;
  totalRewards: RewardsOverview;
  unlockedManagerTeamsCount: Scalars['Int']['output'];
}


/** A So5 League Track */
export interface So5LeagueTrackmySo5LeaderboardContendersArgs {
  includeHiddenManagerTeam?: InputMaybe<Scalars['Boolean']['input']>;
  sortType?: InputMaybe<So5LeaderboardContenderSort>;
}


/** A So5 League Track */
export interface So5LeagueTracktotalRewardConfigsArgs {
  highestConfigByType?: InputMaybe<Scalars['Boolean']['input']>;
}

/** A So5 League Track */
export interface So5LeagueTrackGroup {
  __typename: 'So5LeagueTrackGroup';
  displayName: Scalars['String']['output'];
  mainRarityType?: Maybe<Rarity>;
  seasonalities: Array<So5LeaderboardSeasonality>;
  slug: Scalars['String']['output'];
  so5LeagueTracks: Array<So5LeagueTrack>;
  so5LineupsCount: Scalars['Int']['output'];
}

/** A SO5 lineup */
export interface So5Lineup extends LineupInterface, Node, SocialPicturesInterface {
  __typename: 'So5Lineup';
  anyEarliestGame?: Maybe<Game | GameOfBaseball | GameOfBasketball>;
  bonusPoints?: Maybe<Scalars['Float']['output']>;
  bonusRating?: Maybe<BonusOrdinalRatingEnum>;
  bonuses: Array<So5ActiveClubsBonus | So5AverageScoresBonus | So5BoostBonus | So5CaptainBonus | So5CollectionBonus | So5DifferentNationalitiesBonus | So5GradeBonus | So5LineupBonus | So5MalusAfterTransferBonus | So5NationalityBonus | So5PlayerBonus | So5PositionBonus | So5PositionStacksBonus | So5SameActiveClubBonus | So5ScarcityBonus | So5SeasonBonus | So5SpecialEditionCardsBonus>;
  canEdit: Scalars['Boolean']['output'];
  cancelledAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  cancelledReason?: Maybe<Scalars['String']['output']>;
  completedTasks: Array<CardsCountTargetTask | CardsCountTask | CompleteCollectionsCountTargetTask | CompleteCollectionsCountTask | DailyActionTask | DecisivePlayerPickerTask | DropChallengeTask | GameWeeklyTask | GuessTheScoreTask | InviteTaskAsReferrer | So5LeaderboardTask | StarPackTask | Task | TasksTrack | ThresholdPickerTask | ThresholdsDuoConnectionTask | ThresholdsStreakAdditionalLineupTask | ThresholdsStreakTask>;
  confirmable: Scalars['Boolean']['output'];
  deletable: Scalars['Boolean']['output'];
  displayedPlayer?: Maybe<BaseballPlayer | NBAPlayer | Player>;
  draft: Scalars['Boolean']['output'];
  earliestGame?: Maybe<Game>;
  hasLiveGames: Scalars['Boolean']['output'];
  hidden: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  managerTeam?: Maybe<ManagerTeam>;
  missingCaptain: Scalars['Boolean']['output'];
  myThresholdsStreakTask?: Maybe<ThresholdsStreakTask>;
  name?: Maybe<Scalars['String']['output']>;
  rewardMultiplier: Scalars['Float']['output'];
  scheduledCaptainSo5Appearance: Scalars['Boolean']['output'];
  scheduledSo5AppearancesCount: Scalars['Int']['output'];
  so5Appearances: Array<So5Appearance>;
  so5Fixture: So5Fixture;
  so5Leaderboard?: Maybe<So5Leaderboard>;
  so5LeaderboardContender: So5LeaderboardContender;
  /** Only 1 ranking is returned. An array because a lineup could be played in multiple leaderboards previously. */
  so5Rankings: Array<So5Ranking>;
  socialPictureFingerprint: Scalars['String']['output'];
  socialPictureUrls: SocialPictureDerivative;
  thresholdsStreakTask?: Maybe<ThresholdsStreakTask>;
  updatable: Scalars['Boolean']['output'];
  user: User;
}


/** A SO5 lineup */
export interface So5LineupbonusesArgs {
  highlighted?: InputMaybe<Scalars['Boolean']['input']>;
}


/** A SO5 lineup */
export interface So5Lineupso5AppearancesArgs {
  includeSubs?: InputMaybe<Scalars['Boolean']['input']>;
}

/** The lineup bonus of an appearance */
export interface So5LineupBonus extends So5AppearanceBonusInterface {
  __typename: 'So5LineupBonus';
  bonusBasisPoints: Scalars['Int']['output'];
  description?: Maybe<Scalars['String']['output']>;
  iconUrl: Scalars['String']['output'];
  key: Scalars['String']['output'];
  maxBonusBasisPoints: Scalars['Int']['output'];
  smallIconUrl: Scalars['String']['output'];
  title: Scalars['String']['output'];
}

/** The connection type for So5Lineup. */
export interface So5LineupConnection {
  __typename: 'So5LineupConnection';
  /** A list of edges. */
  edges: Array<So5LineupEdge>;
  hasAny: Scalars['Boolean']['output'];
  /** A list of nodes. */
  nodes: Array<So5Lineup>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
}

/** An edge in a connection. */
export interface So5LineupEdge {
  __typename: 'So5LineupEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<So5Lineup>;
}

/** A So5 lineup import */
export interface So5LineupImport extends Node {
  __typename: 'So5LineupImport';
  aasmState: So5LineupImportState;
  appearances: Array<ImportedSo5Appearance>;
  errorMessage?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  managerTeam?: Maybe<ManagerTeam>;
  so5Leaderboard?: Maybe<So5Leaderboard>;
}

/** A So5 lineup import input */
export interface So5LineupImportInput {
  managerTeamId?: InputMaybe<Scalars['ID']['input']>;
  shouldCreateManagerTeam?: InputMaybe<Scalars['Boolean']['input']>;
  so5Appearances: Array<So5AppearanceInput>;
  so5LeaderboardSlug: Scalars['String']['input'];
  targetedRewardSlug?: InputMaybe<Scalars['String']['input']>;
}

export const So5LineupImportState = {
  DECLINED: 'DECLINED',
  EXPIRED: 'EXPIRED',
  FAILED: 'FAILED',
  PREPARED: 'PREPARED',
  PREPARING: 'PREPARING',
  PROCESSED: 'PROCESSED',
  PROCESSING: 'PROCESSING'
} as const;

export type So5LineupImportState = typeof So5LineupImportState[keyof typeof So5LineupImportState];
export interface So5LineupImportsBatch {
  __typename: 'So5LineupImportsBatch';
  cancelledSo5Lineups?: Maybe<Array<So5Lineup>>;
  id: Scalars['String']['output'];
  impactedTaskLineups?: Maybe<Array<GuessTheScoreTaskLineup | TaskLineup | ThresholdPickerTaskLineup>>;
  so5LineupImports: Array<So5LineupImport>;
  status: So5LineupImportsBatchStatus;
  url: Scalars['String']['output'];
}

export const So5LineupImportsBatchStatus = {
  DECLINED: 'DECLINED',
  EXPIRED: 'EXPIRED',
  PREPARED: 'PREPARED',
  PREPARING: 'PREPARING',
  PROCESSED: 'PROCESSED',
  PROCESSING: 'PROCESSING'
} as const;

export type So5LineupImportsBatchStatus = typeof So5LineupImportsBatchStatus[keyof typeof So5LineupImportsBatchStatus];
/** A user notification regarding a So5Lineup */
export interface So5LineupNotification extends Node, NotificationInterface {
  __typename: 'So5LineupNotification';
  anyCard?: Maybe<BaseballCard | Card | NBACard>;
  body: Scalars['String']['output'];
  createdAt: Scalars['ISO8601DateTime']['output'];
  deeplinkUrl: Scalars['String']['output'];
  iconUrl: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  important: Scalars['Boolean']['output'];
  markdownBody: Scalars['String']['output'];
  name: Scalars['String']['output'];
  pictureUrl?: Maybe<Scalars['String']['output']>;
  read: Scalars['Boolean']['output'];
  so5Lineup: So5Lineup;
  sport?: Maybe<SportOrShared>;
  title: Scalars['String']['output'];
  user: CurrentUser;
}

/** Live lineup information */
export interface So5LineupPreview {
  __typename: 'So5LineupPreview';
  appearances: Array<So5AppearancePreview>;
  bonuses: Array<So5ActiveClubsBonus | So5AverageScoresBonus | So5BoostBonus | So5CaptainBonus | So5CollectionBonus | So5DifferentNationalitiesBonus | So5GradeBonus | So5LineupBonus | So5MalusAfterTransferBonus | So5NationalityBonus | So5PlayerBonus | So5PositionBonus | So5PositionStacksBonus | So5SameActiveClubBonus | So5ScarcityBonus | So5SeasonBonus | So5SpecialEditionCardsBonus>;
  /** @deprecated Energy is deprecated */
  consumedEnergies: Array<InGameCurrencyBalance>;
  feedbackRules?: Maybe<Array<So5RuleFeedback>>;
  rewardBoosts: Array<So5CardRewardBoost | So5PlayerLoyaltyRewardBoost | So5RarityVaultRewardBoost>;
  rewardMultiplier: Scalars['Float']['output'];
  rewardsConfig: LeaderboardRewardsConfig;
}


/** Live lineup information */
export interface So5LineupPreviewbonusesArgs {
  highlighted?: InputMaybe<Scalars['Boolean']['input']>;
}

export interface So5LineupSimulatedResult {
  __typename: 'So5LineupSimulatedResult';
  score: Scalars['Float']['output'];
  so5Fixture: So5Fixture;
}

export interface So5LineupSimulatedResults {
  __typename: 'So5LineupSimulatedResults';
  averageLineupScore: Scalars['Float']['output'];
  simulatedResults: Array<So5LineupSimulatedResult>;
}

/** The malus after transfer of a card */
export interface So5MalusAfterTransferBonus extends So5AppearanceBonusInterface {
  __typename: 'So5MalusAfterTransferBonus';
  bonusBasisPoints: Scalars['Int']['output'];
  description?: Maybe<Scalars['String']['output']>;
  iconUrl: Scalars['String']['output'];
  key: Scalars['String']['output'];
  maxBonusBasisPoints: Scalars['Int']['output'];
  smallIconUrl: Scalars['String']['output'];
  title: Scalars['String']['output'];
}

export interface So5MaximumPlayersAverageScoreRule extends So5RuleInterface {
  __typename: 'So5MaximumPlayersAverageScoreRule';
  averageScoreBoundaries: AverageScoreOpenBoundaries;
  descriptions: Array<So5RuleDescription>;
  id: Scalars['String']['output'];
  key: Scalars['String']['output'];
}

export interface So5MinimumPlayersAverageScoreRule extends So5RuleInterface {
  __typename: 'So5MinimumPlayersAverageScoreRule';
  averageScoreBoundaries: AverageScoreOpenBoundaries;
  descriptions: Array<So5RuleDescription>;
  id: Scalars['String']['output'];
  key: Scalars['String']['output'];
}

/** The nationality bonus of an appearance */
export interface So5NationalityBonus extends So5AppearanceBonusInterface {
  __typename: 'So5NationalityBonus';
  bonusBasisPoints: Scalars['Int']['output'];
  description?: Maybe<Scalars['String']['output']>;
  iconUrl: Scalars['String']['output'];
  key: Scalars['String']['output'];
  maxBonusBasisPoints: Scalars['Int']['output'];
  smallIconUrl: Scalars['String']['output'];
  title: Scalars['String']['output'];
}

/** The nationality rule of a So5Leaderboard */
export interface So5NationalityRule extends So5RuleInterface {
  __typename: 'So5NationalityRule';
  countries: Array<Country>;
  descriptions: Array<So5RuleDescription>;
  id: Scalars['String']['output'];
  key: Scalars['String']['output'];
  max?: Maybe<Scalars['Int']['output']>;
  min?: Maybe<Scalars['Int']['output']>;
}

/** An Appearance of a So5NoCardLineup */
export interface So5NoCardAppearance {
  __typename: 'So5NoCardAppearance';
  player?: Maybe<Player>;
  position?: Maybe<Position>;
  positions?: Maybe<Array<Position>>;
  so5Score?: Maybe<So5Score>;
}

/** A draftable player */
export interface So5NoCardDraftableAppearance {
  __typename: 'So5NoCardDraftableAppearance';
  anyTeam?: Maybe<Club | NationalTeam>;
  bonus?: Maybe<Scalars['Float']['output']>;
  id: Scalars['ID']['output'];
  player: AnyPlayer;
  position: Position;
  positions: Array<Position>;
  season: Season;
}

/** A So5NoCardLineup */
export interface So5NoCardLineup extends Node {
  __typename: 'So5NoCardLineup';
  appearances: Array<So5NoCardAppearance>;
  id: Scalars['ID']['output'];
  so5Fixture: So5Fixture;
  so5Leaderboard?: Maybe<So5Leaderboard>;
  user: User;
}

/** A picking config for a So5Fixture No Card Route */
export interface So5NoCardRouteFixturePickConfig {
  __typename: 'So5NoCardRouteFixturePickConfig';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  pickingSlots: Array<So5NoCardRoutePickingSlot>;
  signature: Scalars['String']['output'];
}

/** So5 No Card Route Picking Slot */
export interface So5NoCardRoutePickingSlot {
  __typename: 'So5NoCardRoutePickingSlot';
  index: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  positions: Array<Position>;
}

/** The not nationality rule of a So5Leaderboard */
export interface So5NotNationalityRule extends So5RuleInterface {
  __typename: 'So5NotNationalityRule';
  descriptions: Array<So5RuleDescription>;
  id: Scalars['String']['output'];
  key: Scalars['String']['output'];
}

/** An onboarding promotional event on So5 */
export interface So5OnboardingPromotionalEvent {
  __typename: 'So5OnboardingPromotionalEvent';
  endDate: Scalars['ISO8601DateTime']['output'];
  id: Scalars['ID']['output'];
  myPromotionalEvent?: Maybe<AirdropPromotionalEvent>;
  so5Leaderboard: So5Leaderboard;
}

/** The player bonus of an appearance */
export interface So5PlayerBonus extends So5AppearanceBonusInterface {
  __typename: 'So5PlayerBonus';
  bonusBasisPoints: Scalars['Int']['output'];
  description?: Maybe<Scalars['String']['output']>;
  iconUrl: Scalars['String']['output'];
  key: Scalars['String']['output'];
  maxBonusBasisPoints: Scalars['Int']['output'];
  smallIconUrl: Scalars['String']['output'];
  title: Scalars['String']['output'];
}

export interface So5PlayerLoyaltyRewardBoost extends So5RewardBoostInterface {
  __typename: 'So5PlayerLoyaltyRewardBoost';
  boostLevel: BoostLevel;
  maximumBoostLevel: BoostLevel;
  nbCards: Scalars['Int']['output'];
  nextBoostLevel?: Maybe<BoostLevel>;
  /** @deprecated Player loyalty is no longer used */
  player: BaseballPlayer | NBAPlayer | Player;
  points: Scalars['Int']['output'];
  rarity: Rarity;
}

/** A podium in a So5 Leaderboard */
export interface So5Podium {
  __typename: 'So5Podium';
  count: Scalars['Int']['output'];
  displayName: Scalars['String']['output'];
  ranking: Scalars['Int']['output'];
  so5LeaderboardType: So5LeaderboardType;
  svgLogoUrl: Scalars['String']['output'];
}


/** A podium in a So5 Leaderboard */
export interface So5PodiumdisplayNameArgs {
  short?: InputMaybe<Scalars['Boolean']['input']>;
}

/** The position bonus of an appearance */
export interface So5PositionBonus extends So5AppearanceBonusInterface {
  __typename: 'So5PositionBonus';
  bonusBasisPoints: Scalars['Int']['output'];
  description?: Maybe<Scalars['String']['output']>;
  iconUrl: Scalars['String']['output'];
  key: Scalars['String']['output'];
  maxBonusBasisPoints: Scalars['Int']['output'];
  smallIconUrl: Scalars['String']['output'];
  title: Scalars['String']['output'];
}

/** The position stacks bonus of an appearance */
export interface So5PositionStacksBonus extends So5AppearanceBonusInterface {
  __typename: 'So5PositionStacksBonus';
  bonusBasisPoints: Scalars['Int']['output'];
  description?: Maybe<Scalars['String']['output']>;
  iconUrl: Scalars['String']['output'];
  key: Scalars['String']['output'];
  maxBonusBasisPoints: Scalars['Int']['output'];
  smallIconUrl: Scalars['String']['output'];
  title: Scalars['String']['output'];
}

/** Potential So5 reward configs for a certain score */
export interface So5PotentialRewardConfigs {
  __typename: 'So5PotentialRewardConfigs';
  eligibleRewards: Array<So5RewardConfig>;
  score: Scalars['Float']['output'];
}

/** A SO5 Ranking */
export interface So5Ranking extends Node, UserRankingInterface {
  __typename: 'So5Ranking';
  adjacentSo5Rankings: Array<So5Ranking>;
  eligibleDivisionChange?: Maybe<DivisionChange>;
  eligibleForReward: Scalars['Boolean']['output'];
  /** Eligible rewards until so5 fixture is closed, actual so5 rewards after */
  eligibleOrSo5Rewards: Array<So5RewardOrConfig>;
  eligibleRewards: Array<So5RewardConfig>;
  id: Scalars['ID']['output'];
  liveBestRanking?: Maybe<Scalars['Int']['output']>;
  liveProjectedRanking?: Maybe<Scalars['Int']['output']>;
  liveWorstRanking?: Maybe<Scalars['Int']['output']>;
  lockedRewards: Array<So5RewardConfig>;
  nextEligibleRewards?: Maybe<So5PotentialRewardConfigs>;
  overallRanking?: Maybe<Scalars['Int']['output']>;
  overallScore: Scalars['Float']['output'];
  previousEligibleRewards?: Maybe<So5PotentialRewardConfigs>;
  ranking?: Maybe<Scalars['Int']['output']>;
  rankingRatio?: Maybe<Scalars['Int']['output']>;
  score: Scalars['Float']['output'];
  so5Fixture: So5Fixture;
  so5Leaderboard: So5Leaderboard;
  so5Lineup: So5Lineup;
  so5Rewards: Array<So5Reward>;
  targetedReward?: Maybe<So5RewardConfig>;
  targetedRewardWithEligibility?: Maybe<So5RewardConfigWithEligibility>;
  unlockedRewards: Array<So5RewardConfig>;
  user: User;
}


/** A SO5 Ranking */
export interface So5RankingadjacentSo5RankingsArgs {
  delta?: InputMaybe<Scalars['Int']['input']>;
}


/** A SO5 Ranking */
export interface So5RankingrankingRatioArgs {
  top?: InputMaybe<Scalars['Boolean']['input']>;
}

/** The connection type for So5Ranking. */
export interface So5RankingConnection {
  __typename: 'So5RankingConnection';
  /** A list of edges. */
  edges: Array<So5RankingEdge>;
  /** A list of nodes. */
  nodes: Array<So5Ranking>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
}

/** An edge in a connection. */
export interface So5RankingEdge {
  __typename: 'So5RankingEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<So5Ranking>;
}

export interface So5RankingsPaginated {
  __typename: 'So5RankingsPaginated';
  currentPage: Scalars['Int']['output'];
  nodes: Array<So5Ranking>;
  pages: Scalars['Int']['output'];
  so5Rankings: Array<So5Ranking>;
  totalCount: Scalars['Int']['output'];
}

/** The rarity rule of a So5Leaderboard */
export interface So5Rarity {
  __typename: 'So5Rarity';
  common: ValueBoundaries;
  customSeries: ValueBoundaries;
  limited: ValueBoundaries;
  rare: ValueBoundaries;
  superRare: ValueBoundaries;
  unique: ValueBoundaries;
}

export interface So5RarityVaultRewardBoost extends So5RewardBoostInterface {
  __typename: 'So5RarityVaultRewardBoost';
  boostLevel: BoostLevel;
  maximumBoostLevel: BoostLevel;
  nbCards: Scalars['Int']['output'];
  nextBoostLevel?: Maybe<BoostLevel>;
  points: Scalars['Int']['output'];
  rarity: Rarity;
}

/** A SO5 Reward */
export interface So5Reward extends Node {
  __typename: 'So5Reward';
  aasmState: Scalars['String']['output'];
  alternativeRewardConfigs?: Maybe<Array<AlternativeRewardConfig>>;
  amount?: Maybe<MonetaryAmount>;
  coinAmount: Scalars['Int']['output'];
  conversionCredit?: Maybe<FootballConversionCredit>;
  deliverableItems?: Maybe<Array<So5DeliverableItemReward>>;
  id: Scalars['ID']['output'];
  poolSize: Scalars['Int']['output'];
  probabilisticBundle?: Maybe<ProbabilisticBundle>;
  rewardCards: Array<RewardCard>;
  rewardConfigs: Array<CardPacksRewardConfig | CardRewardConfig | CardShardRewardConfig | CoinRewardConfig | ConversionCreditRewardConfig | DeliverableItemRewardConfig | ExperienceRewardConfig | InGameCurrencyRewardConfig | MonetaryRewardConfig | ProbabilisticBundleRewardConfig | ShopItemRewardConfig>;
  rewardMultiplier: Scalars['Float']['output'];
  rewardShopItems: Array<FootballRewardShopItem>;
  rewards: Array<AnyCardReward | AnyConversionCreditReward | CardPackReward | CardShardsReward | CoinReward | DeliverableItemReward | ExperienceReward | InGameCurrencyReward | MonetaryReward | ProbabilisticBundleReward | ShopItemReward>;
  slug: Scalars['String']['output'];
  so5Fixture: So5Fixture;
  so5Leaderboard: So5Leaderboard;
  so5Ranking?: Maybe<So5Ranking>;
  so5UserGroupMembership?: Maybe<So5UserGroupMembership>;
  weiAmount: Scalars['WeiAmount']['output'];
}


/** A SO5 Reward */
export interface So5RewardrewardConfigsArgs {
  multiplyBaseRewards?: InputMaybe<Scalars['Boolean']['input']>;
}

export interface So5RewardBoostInterface {
  boostLevel: BoostLevel;
  maximumBoostLevel: BoostLevel;
  nbCards: Scalars['Int']['output'];
  nextBoostLevel?: Maybe<BoostLevel>;
  points: Scalars['Int']['output'];
  rarity: Rarity;
}

/** A So5 Reward card config */
export interface So5RewardCardConfig {
  __typename: 'So5RewardCardConfig';
  anyPlayer?: Maybe<BaseballPlayer | NBAPlayer | Player>;
  competitionSlugs?: Maybe<Array<Scalars['String']['output']>>;
  customCardEditionName?: Maybe<Scalars['String']['output']>;
  customCardEditionNames?: Maybe<Array<Scalars['String']['output']>>;
  description?: Maybe<Scalars['String']['output']>;
  displayEdition?: Maybe<Scalars['String']['output']>;
  gameplayTier?: Maybe<GameplayTier>;
  player?: Maybe<Player>;
  playerSlugs?: Maybe<Array<Scalars['String']['output']>>;
  players?: Maybe<Array<BaseballPlayer | NBAPlayer | Player>>;
  qualities?: Maybe<Array<CardQuality>>;
  quality?: Maybe<CardQuality>;
  quantity: Scalars['Int']['output'];
  rarity: Rarity;
  teamSlugs?: Maybe<Array<Scalars['String']['output']>>;
  title?: Maybe<Scalars['String']['output']>;
  u23GameplayTier?: Maybe<GameplayTier>;
}

/** A So5 Reward config */
export interface So5RewardConfig {
  __typename: 'So5RewardConfig';
  alternativeRewardConfigs: Array<CardPacksRewardConfig | CardRewardConfig | CardShardRewardConfig | CoinRewardConfig | ConversionCreditRewardConfig | DeliverableItemRewardConfig | ExperienceRewardConfig | InGameCurrencyRewardConfig | MonetaryRewardConfig | ProbabilisticBundleRewardConfig | ShopItemRewardConfig>;
  arenaTickets?: Maybe<Scalars['Int']['output']>;
  cardShardRewardConfigs?: Maybe<Array<CardShardRewardConfig>>;
  cards?: Maybe<Array<So5RewardCardConfig>>;
  coinAmount?: Maybe<Scalars['Int']['output']>;
  conversionCredit?: Maybe<FootballConversionCredit>;
  deliverableItems?: Maybe<Array<So5DeliverableItemReward>>;
  /** Rewarded amount in ETH when fixed in ETH */
  ethAmount?: Maybe<Scalars['Float']['output']>;
  experiences?: Maybe<Array<So5RewardExperience>>;
  fromRank?: Maybe<Scalars['Int']['output']>;
  fromSo5Ranking?: Maybe<So5Ranking>;
  fromUserRanking?: Maybe<So5Ranking | So5UserGroupMembership>;
  id: Scalars['ID']['output'];
  /** Only available for carried over pool rewards */
  lastSo5Rewards?: Maybe<Array<So5Reward>>;
  lockedBy?: Maybe<So5RewardConfigLock>;
  /** Minimum USD amount guaranteed when prizes are in ETH */
  minimumGuaranteedUsdAmount?: Maybe<Scalars['Float']['output']>;
  /** If true, the pool amount is added over to the next occurence of the leaderboard when not distributed */
  poolAmountCarriedOver: Scalars['Boolean']['output'];
  /** Number of managers sharing the pool */
  poolSize: Scalars['Int']['output'];
  probabilisticBundleConfigs?: Maybe<Array<ProbabilisticBundleConfig>>;
  rankPct?: Maybe<Scalars['Float']['output']>;
  ranks?: Maybe<Scalars['Int']['output']>;
  rewardConfigs: Array<CardPacksRewardConfig | CardRewardConfig | CardShardRewardConfig | CoinRewardConfig | ConversionCreditRewardConfig | DeliverableItemRewardConfig | ExperienceRewardConfig | InGameCurrencyRewardConfig | MonetaryRewardConfig | ProbabilisticBundleRewardConfig | ShopItemRewardConfig>;
  rewardMultiplier: Scalars['Float']['output'];
  score?: Maybe<Scalars['Float']['output']>;
  /** USD amount, conversion credit amount or card shards quantity is shared between managers meeting the eligibility criteria */
  sharedPool: Scalars['Boolean']['output'];
  target?: Maybe<So5RewardTargetConfig>;
  toRank?: Maybe<Scalars['Int']['output']>;
  toSo5Ranking?: Maybe<So5Ranking>;
  toUserRanking?: Maybe<So5Ranking | So5UserGroupMembership>;
  /** Rewarded amount in USD when fixed in USD */
  usdAmount?: Maybe<Scalars['Float']['output']>;
}


/** A So5 Reward config */
export interface So5RewardConfigrewardConfigsArgs {
  multiplyBaseRewards?: InputMaybe<Scalars['Boolean']['input']>;
}

export interface So5RewardConfigLock {
  __typename: 'So5RewardConfigLock';
  lineupLiveFeedbacksRules?: Maybe<Array<So5RuleFeedback>>;
  rules: Array<CardsCountAsFirstOwnerRule | OwnedSinceRule | PlayerHeightRule | SeasonsRule | So5ActiveClubsRule | So5ActiveNationalTeamsRule | So5AgeRule | So5AppearancesRule | So5AtLeastOfClubs | So5AtLeastOfCompetitions | So5AverageScoresRule | So5CaptainRule | So5CaptainScarcityRule | So5CardEditionsCountRule | So5CompetitionsRule | So5EntryItemRule | So5MaximumPlayersAverageScoreRule | So5MinimumPlayersAverageScoreRule | So5NationalityRule | So5NotNationalityRule | So5SameActiveClubRule | So5ScarcityRule | So5SeasonBonusRule | VaultPointsRule>;
  slug: Scalars['String']['output'];
}


export interface So5RewardConfigLocklineupLiveFeedbacksRulesArgs {
  appearances: Array<So5AppearanceInput>;
}

/** A So5 Reward config with its eligibility */
export interface So5RewardConfigWithEligibility {
  __typename: 'So5RewardConfigWithEligibility';
  eligible: Scalars['Boolean']['output'];
  reward: So5RewardConfig;
}

/** The connection type for So5Reward. */
export interface So5RewardConnection {
  __typename: 'So5RewardConnection';
  /** A list of edges. */
  edges: Array<So5RewardEdge>;
  /** A list of nodes. */
  nodes: Array<So5Reward>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
}

/** An edge in a connection. */
export interface So5RewardEdge {
  __typename: 'So5RewardEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<So5Reward>;
}

/** A So5 Leaderboard experience rewards config */
export interface So5RewardExperience {
  __typename: 'So5RewardExperience';
  description?: Maybe<Scalars['String']['output']>;
  pictureUrl?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  type: CustomRewardExperience;
}

/** Actual So5 Reward or So5 Reward Config type */
export type So5RewardOrConfig = So5Reward | So5RewardConfig;

export interface So5RewardSource extends HistoryTransactionInterface {
  __typename: 'So5RewardSource';
  date: Scalars['ISO8601DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  label: Scalars['String']['output'];
  logoUrl?: Maybe<Scalars['String']['output']>;
  quantityByFlavour: Array<PoolKeyShardsCount>;
  totalQuantity: Scalars['Int']['output'];
}

/** A So5 Reward target config */
export interface So5RewardTargetConfig {
  __typename: 'So5RewardTargetConfig';
  color: Scalars['String']['output'];
  name: Scalars['String']['output'];
  pictureUrl: Scalars['String']['output'];
  slug: Scalars['String']['output'];
}

export interface So5RewardWithSignedAlternativeInput {
  signedAlternativeRewardConfigs?: InputMaybe<Scalars['String']['input']>;
  so5RewardId: Scalars['ID']['input'];
}

/** The So5 fields */
export interface So5Root {
  __typename: 'So5Root';
  /** Get a list of So5Fixture */
  allSo5Fixtures: So5FixturePublicInterfaceConnection;
  canImportLineups: Scalars['Boolean']['output'];
  cardMaxGrade: Scalars['Int']['output'];
  cardXpGradeThreshold: Array<CardXPGradeThreshold>;
  composeTeamBenchObject: ComposeTeamBenchCard | ComposeTeamBenchCommonPlayer | DecisivePlayerPickerTaskAppearance | MissedAppearance | So5Appearance | TaskAppearance | ThresholdPickerTaskAppearance;
  composeTeamBenchObjects: Array<ComposeTeamBenchCard | ComposeTeamBenchCommonPlayer | DecisivePlayerPickerTaskAppearance | MissedAppearance | So5Appearance | TaskAppearance | ThresholdPickerTaskAppearance>;
  currentManagerHasLiveGames: Scalars['Boolean']['output'];
  eligibleTournamentTypesForSo5UserGroups: Array<So5Tournament>;
  eligibleTournamentsForSo5UserGroups: Array<So5UserGroupTournament>;
  featuredSo5Fixtures: Array<So5Fixture>;
  /** Returns all the future leaderboards */
  futureLeaderboardsPaginated: So5LeaderboardConnection;
  gameDaysAfter: GameDayConnection;
  gameDaysBefore: GameDayConnection;
  id: Scalars['ID']['output'];
  lineupPastSimulatedResults: So5LineupSimulatedResults;
  managerTeam: ManagerTeam;
  myAvailableFixtureStory?: Maybe<Story>;
  myFeaturedGamesWithCardsPreview: Array<GameWithCardsPreview>;
  myFeaturedUniversalSo5UserGroup?: Maybe<So5UserGroup>;
  myLiveUniversalSo5UserGroup?: Maybe<So5UserGroup>;
  myOngoingAndRecentSo5Lineups: Array<So5Lineup>;
  /** Get the earliest live or upcoming So5Fixture with lineups for the current user, or the next upcoming if none */
  myOngoingSo5Fixture: So5Fixture;
  myOpenedSo5LineupImportsBatch?: Maybe<So5LineupImportsBatch>;
  mySo5Cover: So5Cover;
  /** The `my_so5_user_groups` field cannot be nested within a list. */
  mySo5UserGroups: So5UserGroupConnection;
  myUpcomingLineupsPaginated: So5LineupConnection;
  /** The `my_user_groups` field cannot be nested within a list. */
  myUserGroups: UserGroupInterfaceConnection;
  noCardRoute: FootballSo5NoCardRouteRoot;
  onboardingPromotionalEvent?: Maybe<So5OnboardingPromotionalEvent>;
  /** Get a PlayerGameScoreInterface */
  playerGameScore: BaseballPlayerGameScore | BasketballPlayerGameScore | PlayerGameScore | So5Score;
  seasonalityInYears: Array<Scalars['Int']['output']>;
  seasonalityName: Scalars['String']['output'];
  /** Get an So5Appearance */
  so5Appearance: So5Appearance;
  so5Competition: So5Competition;
  so5Competitions: Array<So5Competition>;
  /** Get a So5Fixture */
  so5Fixture?: Maybe<So5Fixture>;
  /** Get a list of So5Fixture */
  so5Fixtures: So5FixtureConnection;
  /** Get a So5Leaderboard */
  so5Leaderboard: So5Leaderboard;
  so5LeaderboardContender?: Maybe<So5LeaderboardContender>;
  /** Get a So5LeaderboardGroup */
  so5LeaderboardGroupInterface: So5LeaderboardGroup | So5League;
  /** Get a So5League */
  so5League: So5League;
  /** Get a So5Lineup */
  so5Lineup: So5Lineup;
  so5LineupImportsBatch?: Maybe<So5LineupImportsBatch>;
  /** Get a So5Ranking */
  so5Ranking: So5Ranking;
  /** Get a So5Reward */
  so5Reward: So5Reward;
  /** Get a list of rewards */
  so5Rewards: Array<So5Reward>;
  /** Get a So5Score */
  so5Score: So5Score;
  /** Get a So5UserGroup */
  so5UserGroup: So5UserGroup;
  /** Get a So5UserGroupMembership */
  so5UserGroupMembership: So5UserGroupMembership;
  /** Get a TaskLineup */
  taskLineup: GuessTheScoreTaskLineup | TaskLineup | ThresholdPickerTaskLineup;
  /** Overview of the available rewards in the upcoming leaderboard */
  totalUpcomingRewards: RewardsOverview;
  /** The `universal_so5_user_groups` field cannot be nested within a list. */
  universalSo5UserGroups: So5UserGroupConnection;
  /** The `universal_user_groups` field cannot be nested within a list. */
  universalUserGroups: UserGroupInterfaceConnection;
  /** Returns all the opened leaderboards */
  upcomingLeaderboards: Array<So5Leaderboard>;
  /** Returns all the opened leaderboards */
  upcomingLeaderboardsPaginated: So5LeaderboardConnection;
}


/** The So5 fields */
export interface So5RootallSo5FixturesArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  eventType: So5FixtureEvent;
  first?: InputMaybe<Scalars['Int']['input']>;
  future?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sport: Sport;
}


/** The So5 fields */
export interface So5RootcardMaxGradeArgs {
  sport: Sport;
}


/** The So5 fields */
export interface So5RootcardXpGradeThresholdArgs {
  sport: Sport;
}


/** The So5 fields */
export interface So5RootcomposeTeamBenchObjectArgs {
  id: Scalars['String']['input'];
}


/** The So5 fields */
export interface So5RootcomposeTeamBenchObjectsArgs {
  ids: Array<Scalars['String']['input']>;
}


/** The So5 fields */
export interface So5RootcurrentManagerHasLiveGamesArgs {
  sport?: InputMaybe<Sport>;
}


/** The So5 fields */
export interface So5RootfeaturedSo5FixturesArgs {
  eventType?: InputMaybe<So5FixtureEvent>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sport?: InputMaybe<Sport>;
}


/** The So5 fields */
export interface So5RootfutureLeaderboardsPaginatedArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  rarities?: InputMaybe<Array<So5LeaderboardRarity>>;
}


/** The So5 fields */
export interface So5RootgameDaysAfterArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  date?: InputMaybe<Scalars['ISO8601Date']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  includeDate?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sport: Sport;
  timeZone: Scalars['String']['input'];
}


/** The So5 fields */
export interface So5RootgameDaysBeforeArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  date?: InputMaybe<Scalars['ISO8601Date']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  includeDate?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sport: Sport;
  timeZone: Scalars['String']['input'];
}


/** The So5 fields */
export interface So5RootlineupPastSimulatedResultsArgs {
  last?: InputMaybe<Scalars['Int']['input']>;
  so5Appearances: Array<So5AppearanceInput>;
  so5LeaderboardType: So5LeaderboardType;
}


/** The So5 fields */
export interface So5RootmanagerTeamArgs {
  id: Scalars['ID']['input'];
}


/** The So5 fields */
export interface So5RootmyAvailableFixtureStoryArgs {
  sport?: InputMaybe<Sport>;
}


/** The So5 fields */
export interface So5RootmyFeaturedGamesWithCardsPreviewArgs {
  cardsPreviewLimit?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sport: Sport;
}


/** The So5 fields */
export interface So5RootmyFeaturedUniversalSo5UserGroupArgs {
  sport: Sport;
}


/** The So5 fields */
export interface So5RootmyLiveUniversalSo5UserGroupArgs {
  sport: Sport;
}


/** The So5 fields */
export interface So5RootmyOngoingSo5FixtureArgs {
  eventType?: InputMaybe<So5FixtureEvent>;
  sport?: InputMaybe<Sport>;
}


/** The So5 fields */
export interface So5RootmySo5CoverArgs {
  eventType?: InputMaybe<So5FixtureEvent>;
  sport: Sport;
}


/** The So5 fields */
export interface So5RootmySo5UserGroupsArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  statuses?: InputMaybe<Array<UserGroupStatus>>;
}


/** The So5 fields */
export interface So5RootmyUpcomingLineupsPaginatedArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  draft?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  so5LeaderboardSlug?: InputMaybe<Scalars['String']['input']>;
  training?: InputMaybe<Scalars['Boolean']['input']>;
}


/** The So5 fields */
export interface So5RootmyUserGroupsArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  statuses?: InputMaybe<Array<UserGroupStatus>>;
}


/** The So5 fields */
export interface So5RootnoCardRouteArgs {
  eventType?: InputMaybe<So5FixtureEvent>;
  sport?: InputMaybe<Sport>;
}


/** The So5 fields */
export interface So5RootonboardingPromotionalEventArgs {
  sport: Sport;
}


/** The So5 fields */
export interface So5RootplayerGameScoreArgs {
  id: Scalars['ID']['input'];
}


/** The So5 fields */
export interface So5RootseasonalityInYearsArgs {
  sport?: InputMaybe<Sport>;
}


/** The So5 fields */
export interface So5RootseasonalityNameArgs {
  seasonality: So5LeaderboardSeasonality;
  sport?: InputMaybe<Sport>;
}


/** The So5 fields */
export interface So5Rootso5AppearanceArgs {
  id: Scalars['ID']['input'];
}


/** The So5 fields */
export interface So5Rootso5CompetitionArgs {
  slug: Scalars['String']['input'];
}


/** The So5 fields */
export interface So5Rootso5CompetitionsArgs {
  eventType?: InputMaybe<So5FixtureEvent>;
  scoutable?: InputMaybe<Scalars['Boolean']['input']>;
  sport: Sport;
}


/** The So5 fields */
export interface So5Rootso5FixtureArgs {
  eventType?: InputMaybe<So5FixtureEvent>;
  id?: InputMaybe<Scalars['ID']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  sport?: InputMaybe<Sport>;
  type?: InputMaybe<So5State>;
}


/** The So5 fields */
export interface So5Rootso5FixturesArgs {
  aasmStates?: InputMaybe<Array<Scalars['String']['input']>>;
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  eventType?: InputMaybe<So5FixtureEvent>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  so5LeaderboardTypes?: InputMaybe<Array<So5LeaderboardType>>;
  sport?: InputMaybe<Sport>;
}


/** The So5 fields */
export interface So5Rootso5LeaderboardArgs {
  slug: Scalars['String']['input'];
}


/** The So5 fields */
export interface So5Rootso5LeaderboardContenderArgs {
  slug: Scalars['String']['input'];
}


/** The So5 fields */
export interface So5Rootso5LeaderboardGroupInterfaceArgs {
  slug: Scalars['String']['input'];
}


/** The So5 fields */
export interface So5Rootso5LeagueArgs {
  slug: Scalars['String']['input'];
}


/** The So5 fields */
export interface So5Rootso5LineupArgs {
  id: Scalars['ID']['input'];
}


/** The So5 fields */
export interface So5Rootso5LineupImportsBatchArgs {
  id: Scalars['String']['input'];
}


/** The So5 fields */
export interface So5Rootso5RankingArgs {
  id: Scalars['ID']['input'];
}


/** The So5 fields */
export interface So5Rootso5RewardArgs {
  slug: Scalars['String']['input'];
}


/** The So5 fields */
export interface So5Rootso5RewardsArgs {
  ids: Array<Scalars['String']['input']>;
}


/** The So5 fields */
export interface So5Rootso5ScoreArgs {
  id: Scalars['ID']['input'];
}


/** The So5 fields */
export interface So5Rootso5UserGroupArgs {
  joinSecret?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
}


/** The So5 fields */
export interface So5Rootso5UserGroupMembershipArgs {
  id: Scalars['String']['input'];
}


/** The So5 fields */
export interface So5RoottaskLineupArgs {
  id: Scalars['ID']['input'];
}


/** The So5 fields */
export interface So5RoottotalUpcomingRewardsArgs {
  sport?: InputMaybe<Sport>;
}


/** The So5 fields */
export interface So5RootuniversalSo5UserGroupsArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sport?: InputMaybe<Sport>;
  statuses?: InputMaybe<Array<UserGroupStatus>>;
}


/** The So5 fields */
export interface So5RootuniversalUserGroupsArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  statuses?: InputMaybe<Array<UserGroupStatus>>;
}


/** The So5 fields */
export interface So5RootupcomingLeaderboardsArgs {
  competitionSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  rarities?: InputMaybe<Array<So5LeaderboardRarity>>;
}


/** The So5 fields */
export interface So5RootupcomingLeaderboardsPaginatedArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  competitionSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  rarities?: InputMaybe<Array<So5LeaderboardRarity>>;
}

export interface So5RuleDescription {
  __typename: 'So5RuleDescription';
  icon?: Maybe<Scalars['String']['output']>;
  items: Array<So5RuleDescriptionItem>;
  title: Scalars['String']['output'];
}

export interface So5RuleDescriptionItem {
  __typename: 'So5RuleDescriptionItem';
  icon?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
}

/** The feedback message of a specific rule of a So5Leaderboard */
export interface So5RuleFeedback {
  __typename: 'So5RuleFeedback';
  message?: Maybe<Scalars['String']['output']>;
  ruleName: Scalars['String']['output'];
  state: So5RuleValidationState;
}

export interface So5RuleInterface {
  descriptions: Array<So5RuleDescription>;
  id: Scalars['String']['output'];
  key: Scalars['String']['output'];
}

export const So5RuleValidationState = {
  INVALID: 'INVALID',
  VALID: 'VALID',
  VALIDATABLE: 'VALIDATABLE'
} as const;

export type So5RuleValidationState = typeof So5RuleValidationState[keyof typeof So5RuleValidationState];
/** The rule set of a So5Leaderboard */
export interface So5Rules {
  __typename: 'So5Rules';
  activeClubStacks?: Maybe<Array<ValueOpenBoundaries>>;
  activeClubs?: Maybe<Array<Club>>;
  activeNationalTeams?: Maybe<Array<NationalTeam>>;
  age?: Maybe<Age>;
  allowLegend: Scalars['Boolean']['output'];
  anyCardTeams?: Maybe<Array<Club | NationalTeam>>;
  anyDraftTeams?: Maybe<Array<Club | NationalTeam>>;
  appearances?: Maybe<Array<AppearanceRule>>;
  atLeastOfClubs?: Maybe<So5AtLeastOfClubs>;
  atLeastOfCompetitions?: Maybe<So5AtLeastOfCompetitions>;
  averageScores?: Maybe<AverageScoresRule>;
  captain?: Maybe<Scalars['Json']['output']>;
  captainRarities?: Maybe<Array<Scalars['String']['output']>>;
  /** Enforces restrictions on the card's editions in this leaderboard when set. */
  cardEditionsCount?: Maybe<CardEditionsCount>;
  cardsCountAsFirstOwner?: Maybe<Scalars['Int']['output']>;
  cardsCountOfCurrentUser?: Maybe<MaximumCardsCountOwnedByUser>;
  competitions?: Maybe<Array<Competition>>;
  currentEditedSeason?: Maybe<Array<Scalars['String']['output']>>;
  currentUserGallery?: Maybe<GalleryCards>;
  dateRangeSpecific?: Maybe<DateRangeSpecific>;
  id: Scalars['String']['output'];
  internationalCompetitions?: Maybe<Array<Competition>>;
  leagues?: Maybe<Array<Competition>>;
  lockType: LockTypeEnum;
  maximumPlayersAverageScore?: Maybe<AverageScoreOpenBoundaries>;
  minOrMaxSameNationality?: Maybe<ValueOpenBoundaries>;
  minimumPlayersAverageScore?: Maybe<AverageScoreOpenBoundaries>;
  nationalities?: Maybe<Array<Country>>;
  nationalitiesCount?: Maybe<Nationality>;
  noClassicCommon?: Maybe<Scalars['Boolean']['output']>;
  notDomesticCompetitions?: Maybe<Array<Competition>>;
  notNationalities?: Maybe<Array<Country>>;
  playerHeight?: Maybe<PlayerHeightRule>;
  rarities?: Maybe<Array<Scalars['String']['output']>>;
  rarityLimits?: Maybe<So5Rarity>;
  sameActiveClub?: Maybe<ValueOpenBoundaries>;
  sameNationality?: Maybe<Scalars['Boolean']['output']>;
  seasonBonusForSpecificTeams?: Maybe<SeasonBonus>;
  seasons?: Maybe<Array<Season>>;
  serialNumber?: Maybe<Scalars['String']['output']>;
  sport?: Maybe<Sport>;
  sumOfAverageScores?: Maybe<Scalars['Int']['output']>;
}


/** The rule set of a So5Leaderboard */
export interface So5RulesappearancesArgs {
  includeSubs?: InputMaybe<Scalars['Boolean']['input']>;
}

/** The same active club bonus of an appearance */
export interface So5SameActiveClubBonus extends So5AppearanceBonusInterface {
  __typename: 'So5SameActiveClubBonus';
  bonusBasisPoints: Scalars['Int']['output'];
  description?: Maybe<Scalars['String']['output']>;
  iconUrl: Scalars['String']['output'];
  key: Scalars['String']['output'];
  maxBonusBasisPoints: Scalars['Int']['output'];
  smallIconUrl: Scalars['String']['output'];
  title: Scalars['String']['output'];
}

export interface So5SameActiveClubRule extends So5RuleInterface {
  __typename: 'So5SameActiveClubRule';
  boundaries: ValueOpenBoundaries;
  descriptions: Array<So5RuleDescription>;
  id: Scalars['String']['output'];
  key: Scalars['String']['output'];
}

/** The scarcity bonus of an appearance */
export interface So5ScarcityBonus extends So5AppearanceBonusInterface {
  __typename: 'So5ScarcityBonus';
  bonusBasisPoints: Scalars['Int']['output'];
  description?: Maybe<Scalars['String']['output']>;
  iconUrl: Scalars['String']['output'];
  key: Scalars['String']['output'];
  maxBonusBasisPoints: Scalars['Int']['output'];
  smallIconUrl: Scalars['String']['output'];
  title: Scalars['String']['output'];
}

export interface So5ScarcityRule extends So5RuleInterface {
  __typename: 'So5ScarcityRule';
  descriptions: Array<So5RuleDescription>;
  id: Scalars['String']['output'];
  key: Scalars['String']['output'];
  rarities: Array<Rarity>;
  rarityLimits: So5Rarity;
}

/** A SO5 Score */
export interface So5Score extends Node, PlayerGameScoreInterface {
  __typename: 'So5Score';
  activeSuspensions: Array<Suspension>;
  allAroundStats: Array<StatScore>;
  anyGame: Game | GameOfBaseball | GameOfBasketball;
  anyPlayer: BaseballPlayer | NBAPlayer | Player;
  anyPlayerGameStats: PlayerGameStats | PlayerGameStatsBaseball | PlayerGameStatsBasketball;
  averageScore?: Maybe<Scalars['Float']['output']>;
  decisiveScore?: Maybe<StatScore>;
  detailedScore: Array<StatScore>;
  game: Game;
  id: Scalars['ID']['output'];
  negativeDecisiveStats: Array<StatScore>;
  player: Player;
  playerGameStats: PlayerGameStats;
  position: Scalars['String']['output'];
  positionTyped: Position;
  positiveDecisiveStats: Array<StatScore>;
  projectedScore: Scalars['Float']['output'];
  projection?: Maybe<PlayerGameScoreProjection>;
  score: Scalars['Float']['output'];
  scoreStatus: ScoreStatus;
  scoringVersion: Scalars['Int']['output'];
}


/** A SO5 Score */
export interface So5ScoreaverageScoreArgs {
  type: AveragePlayerScore;
}

/** The connection type for So5Score. */
export interface So5ScoreConnection {
  __typename: 'So5ScoreConnection';
  /** A list of edges. */
  edges: Array<So5ScoreEdge>;
  /** A list of nodes. */
  nodes: Array<So5Score>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
}

/** An edge in a connection. */
export interface So5ScoreEdge {
  __typename: 'So5ScoreEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<So5Score>;
}

/** The season bonus of an appearance */
export interface So5SeasonBonus extends So5AppearanceBonusInterface {
  __typename: 'So5SeasonBonus';
  bonusBasisPoints: Scalars['Int']['output'];
  description?: Maybe<Scalars['String']['output']>;
  iconUrl: Scalars['String']['output'];
  key: Scalars['String']['output'];
  maxBonusBasisPoints: Scalars['Int']['output'];
  smallIconUrl: Scalars['String']['output'];
  title: Scalars['String']['output'];
}

export interface So5SeasonBonusRule extends So5RuleInterface {
  __typename: 'So5SeasonBonusRule';
  boundaries: ValueOpenBoundaries;
  descriptions: Array<So5RuleDescription>;
  /** @deprecated Energy is deprecated */
  energyCostPerAppearance: Scalars['Int']['output'];
  id: Scalars['String']['output'];
  immuneCountByRarity: Array<CountByRarity>;
  key: Scalars['String']['output'];
  /** @deprecated Energy is deprecated */
  maxEnergizedCardsCount: Scalars['Int']['output'];
}

export interface So5SpecialEdition {
  __typename: 'So5SpecialEdition';
  bonusBasisPoints: Scalars['Int']['output'];
  editionNames: Array<Scalars['String']['output']>;
  until?: Maybe<Scalars['ISO8601DateTime']['output']>;
}

/** The special edition cards bonus of an appearance */
export interface So5SpecialEditionCardsBonus extends So5AppearanceBonusInterface {
  __typename: 'So5SpecialEditionCardsBonus';
  bonusBasisPoints: Scalars['Int']['output'];
  description?: Maybe<Scalars['String']['output']>;
  editions: Array<So5SpecialEdition>;
  iconUrl: Scalars['String']['output'];
  key: Scalars['String']['output'];
  maxBonusBasisPoints: Scalars['Int']['output'];
  smallIconUrl: Scalars['String']['output'];
  title: Scalars['String']['output'];
}

export const So5State = {
  LIVE: 'LIVE',
  LIVE_OR_PAST: 'LIVE_OR_PAST',
  MY_ONGOING: 'MY_ONGOING',
  NEXT_WITH_TUTORIAL: 'NEXT_WITH_TUTORIAL',
  ONBOARDING: 'ONBOARDING',
  PAST: 'PAST',
  UPCOMING: 'UPCOMING'
} as const;

export type So5State = typeof So5State[keyof typeof So5State];
export interface So5Tournament {
  __typename: 'So5Tournament';
  displayName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  so5LeaderboardType: So5LeaderboardType;
  svgLogoUrl: Scalars['String']['output'];
}


export interface So5TournamentdisplayNameArgs {
  short?: InputMaybe<Scalars['Boolean']['input']>;
}

/** A trophy (card reward and/or podium) in a So5 Leaderboard */
export interface So5Trophies {
  __typename: 'So5Trophies';
  cardRewards: Scalars['Int']['output'];
  /** Number of rankings for closed fixtures */
  finalRankings: Scalars['Int']['output'];
  podiumRankings: Scalars['Int']['output'];
  so5TournamentType: So5Tournament;
  totalMonetaryRewards?: Maybe<MonetaryAmount>;
}


/** A trophy (card reward and/or podium) in a So5 Leaderboard */
export interface So5TrophiescardRewardsArgs {
  rarity?: InputMaybe<Rarity>;
}


/** A trophy (card reward and/or podium) in a So5 Leaderboard */
export interface So5TrophiespodiumRankingsArgs {
  ranking?: InputMaybe<Scalars['Int']['input']>;
}


/** A trophy (card reward and/or podium) in a So5 Leaderboard */
export interface So5TrophiestotalMonetaryRewardsArgs {
  referenceCurrency: SupportedCurrency;
}

/** A SO5 User Group */
export interface So5UserGroup extends Node, UserGroupInterface {
  __typename: 'So5UserGroup';
  administrator?: Maybe<User>;
  canJoin: Validity;
  conversionCredit?: Maybe<ConversionCredit>;
  conversionCreditCampaign?: Maybe<ConversionCreditCampaign>;
  customEndDate?: Maybe<Scalars['ISO8601DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  displayName: Scalars['String']['output'];
  endGameWeek?: Maybe<Scalars['Int']['output']>;
  endSo5Fixture?: Maybe<So5Fixture>;
  id: Scalars['ID']['output'];
  joinDisabled: Scalars['Boolean']['output'];
  joinRules: So5Rules;
  joinSecret: Scalars['String']['output'];
  latestSo5Leaderboard?: Maybe<So5Leaderboard>;
  liveSo5Leaderboard?: Maybe<So5Leaderboard>;
  logo?: Maybe<SkinShopItem>;
  mainRarityType?: Maybe<Rarity>;
  membership?: Maybe<So5UserGroupMembership>;
  memberships: Array<So5UserGroupMembership>;
  membershipsCount: Scalars['Int']['output'];
  membershipsPaginated: So5UserGroupMembershipsPaginated;
  myMembership?: Maybe<So5UserGroupMembership>;
  myTasks: Array<CardsCountTargetTask | CardsCountTask | CompleteCollectionsCountTargetTask | CompleteCollectionsCountTask | DailyActionTask | DecisivePlayerPickerTask | DropChallengeTask | GameWeeklyTask | GuessTheScoreTask | InviteTaskAsReferrer | So5LeaderboardTask | StarPackTask | Task | TasksTrack | ThresholdPickerTask | ThresholdsDuoConnectionTask | ThresholdsStreakAdditionalLineupTask | ThresholdsStreakTask>;
  /** The `past_so5_leaderboards` field cannot be nested within a list. */
  pastSo5Leaderboards: So5LeaderboardConnection;
  pictureUrl?: Maybe<Scalars['String']['output']>;
  publiclyAccessible: Scalars['Boolean']['output'];
  rarityType: Scalars['String']['output'];
  rewardsConfig: LeaderboardRewardsConfig;
  seasonality?: Maybe<So5LeaderboardSeasonality>;
  seasonalityInYears?: Maybe<Array<Scalars['Int']['output']>>;
  seasonalityName?: Maybe<Scalars['String']['output']>;
  slug: Scalars['String']['output'];
  so5LeaderboardType: So5LeaderboardType;
  /** Get associated rewards. Empty until fixture is closed. The `so5_rewards` field cannot be nested within a list. */
  so5Rewards: So5RewardConnection;
  so5TournamentType: So5Tournament;
  startGameWeek: Scalars['Int']['output'];
  startSo5Fixture?: Maybe<So5Fixture>;
  status: UserGroupStatus;
  svgLogoUrl: Scalars['String']['output'];
  topScoresCount?: Maybe<Scalars['Int']['output']>;
  totalRewardConfigs: Array<CardPacksRewardConfig | CardRewardConfig | CardShardRewardConfig | CoinRewardConfig | ConversionCreditRewardConfig | DeliverableItemRewardConfig | ExperienceRewardConfig | InGameCurrencyRewardConfig | MonetaryRewardConfig | ProbabilisticBundleRewardConfig | ShopItemRewardConfig>;
  /** High level overview of the rewards */
  totalRewards: RewardsOverview;
  tournament: So5UserGroupTournament;
  tournamentType: Scalars['String']['output'];
  upcomingSo5Leaderboard?: Maybe<So5Leaderboard>;
}


/** A SO5 User Group */
export interface So5UserGroupmembershipArgs {
  userSlug: Scalars['String']['input'];
}


/** A SO5 User Group */
export interface So5UserGroupmembershipsPaginatedArgs {
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
}


/** A SO5 User Group */
export interface So5UserGrouppastSo5LeaderboardsArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
}


/** A SO5 User Group */
export interface So5UserGroupso5RewardsArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
}


/** A SO5 User Group */
export interface So5UserGrouptotalRewardConfigsArgs {
  highestConfigByType?: InputMaybe<Scalars['Boolean']['input']>;
}

/** The connection type for So5UserGroup. */
export interface So5UserGroupConnection {
  __typename: 'So5UserGroupConnection';
  /** A list of edges. */
  edges: Array<So5UserGroupEdge>;
  hasAny: Scalars['Boolean']['output'];
  /** A list of nodes. */
  nodes: Array<So5UserGroup>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
}

/** An edge in a connection. */
export interface So5UserGroupEdge {
  __typename: 'So5UserGroupEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<So5UserGroup>;
}

/** A SO5 User Group membership */
export interface So5UserGroupMembership extends Node, UserGroupMembershipInterface, UserRankingInterface {
  __typename: 'So5UserGroupMembership';
  administrator: Scalars['Boolean']['output'];
  createdAt: Scalars['ISO8601DateTime']['output'];
  eligibleRewards: Array<So5RewardConfig>;
  id: Scalars['ID']['output'];
  /** So5Rankings for the last N game weeks ordered by descending game week, null if not existing */
  lastSo5Rankings: Array<Maybe<So5Ranking>>;
  liveSo5Ranking?: Maybe<So5Ranking>;
  overallRanking?: Maybe<Scalars['Int']['output']>;
  overallScore: Scalars['Float']['output'];
  ranking?: Maybe<Scalars['Int']['output']>;
  score: Scalars['Int']['output'];
  /**
   * So5LeaderboardContenders ordered by descending game week The
   * `so5_leaderboard_contenders` field cannot be nested within a list.
   */
  so5LeaderboardContenders: So5LeaderboardContenderConnection;
  /** So5Rankings ordered by descending game week The `so5_rankings` field cannot be nested within a list. */
  so5Rankings: So5RankingConnection;
  so5UserGroup: So5UserGroup;
  topSo5LeaderboardContenders: Array<So5LeaderboardContender>;
  topSo5Rankings?: Maybe<Array<So5Ranking>>;
  user: User;
  userGroup: So5UserGroup;
}


/** A SO5 User Group membership */
export interface So5UserGroupMembershiplastSo5RankingsArgs {
  size?: InputMaybe<Scalars['Int']['input']>;
}


/** A SO5 User Group membership */
export interface So5UserGroupMembershipso5LeaderboardContendersArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  includeUpcoming?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
}


/** A SO5 User Group membership */
export interface So5UserGroupMembershipso5RankingsArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
}

export interface So5UserGroupMembershipsPaginated {
  __typename: 'So5UserGroupMembershipsPaginated';
  currentPage: Scalars['Int']['output'];
  memberships: Array<So5UserGroupMembership>;
  nodes: Array<So5UserGroupMembership>;
  pages: Scalars['Int']['output'];
  totalCount: Scalars['Int']['output'];
}

/** A user notification regarding a so5 user group */
export interface So5UserGroupNotification extends Node, NotificationInterface {
  __typename: 'So5UserGroupNotification';
  body: Scalars['String']['output'];
  createdAt: Scalars['ISO8601DateTime']['output'];
  deeplinkUrl: Scalars['String']['output'];
  iconUrl: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  important: Scalars['Boolean']['output'];
  markdownBody: Scalars['String']['output'];
  membership?: Maybe<So5UserGroupMembership>;
  name: Scalars['String']['output'];
  otherMembershipsCount: Scalars['Int']['output'];
  pictureUrl?: Maybe<Scalars['String']['output']>;
  read: Scalars['Boolean']['output'];
  so5UserGroup: So5UserGroup;
  sport?: Maybe<SportOrShared>;
  title: Scalars['String']['output'];
  user: CurrentUser;
  userGroup: So5UserGroup;
  userGroupMembership?: Maybe<So5UserGroupMembership>;
}

/** A SO5 User Group tournament */
export interface So5UserGroupTournament {
  __typename: 'So5UserGroupTournament';
  id: Scalars['ID']['output'];
  so5TournamentType: So5Tournament;
}

/** A Social picture with all its derivative */
export interface SocialPictureDerivative {
  __typename: 'SocialPictureDerivative';
  post?: Maybe<Scalars['String']['output']>;
  square?: Maybe<Scalars['String']['output']>;
  story?: Maybe<Scalars['String']['output']>;
}

/** Social pictures */
export interface SocialPicturesInterface {
  socialPictureFingerprint: Scalars['String']['output'];
  socialPictureUrls: SocialPictureDerivative;
}

/** A Solana Account */
export interface SolanaAccount extends Node {
  __typename: 'SolanaAccount';
  address: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  user?: Maybe<User>;
}

export interface SolanaBankConditionalTransferApprovalInput {
  conditionalSalt: Scalars['String']['input'];
  expirationTimestamp: Scalars['Int']['input'];
  nonce: Scalars['String']['input'];
  signature: Scalars['String']['input'];
}

/** A Solana conditional bank transfer authorization request */
export interface SolanaBankConditionalTransferAuthorizationRequest {
  __typename: 'SolanaBankConditionalTransferAuthorizationRequest';
  amount: Scalars['CryptocurrencyAmount']['output'];
  authority: Scalars['SolanaAddress']['output'];
  bankProgramAddress: Scalars['SolanaAddress']['output'];
  conditionalAmount: Scalars['CryptocurrencyAmount']['output'];
  conditionalCurrency: Cryptocurrency;
  conditionalNetwork: Blockchain;
  conditionalReceiverAddress: Scalars['String']['output'];
  conditionalSalt: Scalars['String']['output'];
  expirationTimestamp: Scalars['Int']['output'];
  feeAmount: Scalars['CryptocurrencyAmount']['output'];
  nonce: Scalars['String']['output'];
  originator: Scalars['SolanaAddress']['output'];
  receiverAddress: Scalars['String']['output'];
  senderAddress: Scalars['String']['output'];
}

export interface SolanaBankTransferApprovalInput {
  expirationTimestamp: Scalars['Int']['input'];
  nonce: Scalars['String']['input'];
  signature: Scalars['String']['input'];
}

/** A Solana bank transfer authorization request */
export interface SolanaBankTransferAuthorizationRequest {
  __typename: 'SolanaBankTransferAuthorizationRequest';
  amount: Scalars['CryptocurrencyAmount']['output'];
  authority: Scalars['SolanaAddress']['output'];
  bankProgramAddress: Scalars['SolanaAddress']['output'];
  expirationTimestamp: Scalars['Int']['output'];
  feeAmount: Scalars['CryptocurrencyAmount']['output'];
  nonce: Scalars['String']['output'];
  originator: Scalars['SolanaAddress']['output'];
  receiverAddress: Scalars['String']['output'];
  senderAddress: Scalars['String']['output'];
}

/** A solana bank withdrawal authorization request */
export interface SolanaBankWithdrawalAuthorizationRequest {
  __typename: 'SolanaBankWithdrawalAuthorizationRequest';
  amount: Scalars['CryptocurrencyAmount']['output'];
  authority: Scalars['SolanaAddress']['output'];
  bankProgramAddress: Scalars['SolanaAddress']['output'];
  expirationTimestamp: Scalars['Int']['output'];
  feeAmount: Scalars['CryptocurrencyAmount']['output'];
  nonce: Scalars['String']['output'];
  originator: Scalars['SolanaAddress']['output'];
  receiverAddress: Scalars['String']['output'];
  senderAddress: Scalars['String']['output'];
}

/** A transfer of the Solana rent-exempt minimum to a user Solana account */
export interface SolanaRentFunding extends Node {
  __typename: 'SolanaRentFunding';
  amountLamports: Scalars['CryptocurrencyAmount']['output'];
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['ID']['output'];
  status: SolanaRentFundingStatus;
}

export const SolanaRentFundingStatus = {
  FAILED: 'FAILED',
  FUNDED: 'FUNDED',
  PENDING: 'PENDING'
} as const;

export type SolanaRentFundingStatus = typeof SolanaRentFundingStatus[keyof typeof SolanaRentFundingStatus];
export interface SolanaTokenTransferApprovalInput {
  expirationTimestamp: Scalars['Int']['input'];
  nonce: Scalars['String']['input'];
  signature: Scalars['String']['input'];
}

/** A Solana token transfer authorization request */
export interface SolanaTokenTransferAuthorizationRequest {
  __typename: 'SolanaTokenTransferAuthorizationRequest';
  assetId: Scalars['String']['output'];
  expirationTimestamp: Scalars['Int']['output'];
  leafIndex: Scalars['Int']['output'];
  merkleTreeAddress: Scalars['SolanaAddress']['output'];
  nonce: Scalars['String']['output'];
  originator: Scalars['SolanaAddress']['output'];
  receiverAddress: Scalars['String']['output'];
  senderAddress: Scalars['String']['output'];
  transferProxyProgramAddress: Scalars['SolanaAddress']['output'];
}

/** An encrypted private key */
export interface SorarePrivateKey {
  __typename: 'SorarePrivateKey';
  encryptedPrivateKey: Scalars['String']['output'];
  iv: Scalars['String']['output'];
  salt: Scalars['String']['output'];
}

/** An encrypted private key */
export interface SorarePrivateKeyAttributes {
  encryptedPrivateKey: Scalars['String']['input'];
  iv: Scalars['String']['input'];
  salt: Scalars['String']['input'];
}

/** A Sorare refund in the Token service */
export interface SorareRefund extends Node {
  __typename: 'SorareRefund';
  amounts: MonetaryAmount;
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  status: SorareRefundStatus;
}

export const SorareRefundStatus = {
  PAID: 'PAID',
  PAYING: 'PAYING',
  PENDING: 'PENDING'
} as const;

export type SorareRefundStatus = typeof SorareRefundStatus[keyof typeof SorareRefundStatus];
export const SortingOption = {
  ASC: 'ASC',
  DESC: 'DESC'
} as const;

export type SortingOption = typeof SortingOption[keyof typeof SortingOption];
export interface SortingType {
  __typename: 'SortingType';
  description: Scalars['String']['output'];
  name: Scalars['String']['output'];
  readyAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  relatedBenchPlayerScore: BenchPlayerScore;
  searchPlayersSorts: Array<Scalars['String']['output']>;
  type: BenchSortType;
}

/** A promotional event taking place in the marketplace boosting special edition chances */
export interface SpecialEditionPromotionalEvent extends Node, PromotionalEventInterface {
  __typename: 'SpecialEditionPromotionalEvent';
  algoliaFilters: Scalars['String']['output'];
  backgroundPictureUrl?: Maybe<Scalars['String']['output']>;
  bannerAssetsPictureUrl?: Maybe<Scalars['String']['output']>;
  blogUrl?: Maybe<Scalars['String']['output']>;
  description: Scalars['String']['output'];
  eligibilityRules: EligibilityRules;
  endDate: Scalars['ISO8601DateTime']['output'];
  filterPictureUrl?: Maybe<Scalars['String']['output']>;
  hasInstantBuy: Scalars['Boolean']['output'];
  heroValueProps: Array<HeroValueProp>;
  id: Scalars['ID']['output'];
  logoUrl?: Maybe<Scalars['String']['output']>;
  marketBannerTitle: Scalars['String']['output'];
  mobileBackgroundPictureUrl?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  pictureUrl?: Maybe<Scalars['String']['output']>;
  probableRewardConfigs: Array<ProbableRewardConfig>;
  promotionType: PromotionType;
  revealableCardConfig?: Maybe<Array<RevealableCardConfig>>;
  secondaryBannerPictureUrl?: Maybe<Scalars['String']['output']>;
  slug: Scalars['String']['output'];
  sport: Sport;
  startDate: Scalars['ISO8601DateTime']['output'];
  termsAndConditionsUrl?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
}

/** Deprecated — Halloween-specific. Only meaningful for archived halloween_fifty_fifty pulls. */
export const SpecialEventFiftyFiftyResult = {
  /** User got the 5 best cards from special event fifty_fifty */
  NORMAL: 'NORMAL',
  /** User got the 5 worst cards from special event fifty_fifty */
  REVERSED: 'REVERSED'
} as const;

export type SpecialEventFiftyFiftyResult = typeof SpecialEventFiftyFiftyResult[keyof typeof SpecialEventFiftyFiftyResult];
/** A special offers market set section */
export interface SpecialOffers extends MarketSetSection {
  __typename: 'SpecialOffers';
  backgroundUrl?: Maybe<Scalars['String']['output']>;
  cardPacks: Array<CardPack>;
  endsAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** @deprecated Not used anymore */
  hoverColor?: Maybe<Scalars['String']['output']>;
  mainColor?: Maybe<Scalars['String']['output']>;
  resetAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  title: Scalars['String']['output'];
  titleBackgroundUrl?: Maybe<Scalars['String']['output']>;
}

/** A special event banner */
export interface SpecialWeeklyBanner extends Node {
  __typename: 'SpecialWeeklyBanner';
  background?: Maybe<Scalars['String']['output']>;
  cardUrl?: Maybe<Scalars['String']['output']>;
  href?: Maybe<Scalars['String']['output']>;
  hrefLabel?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  logoUrl?: Maybe<Scalars['String']['output']>;
  pictureUrl?: Maybe<Scalars['String']['output']>;
  prizeLabel?: Maybe<Scalars['String']['output']>;
  sectionName?: Maybe<Scalars['String']['output']>;
  slug: Scalars['String']['output'];
  subtitle?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
}


/** A special event banner */
export interface SpecialWeeklyBannerpictureUrlArgs {
  derivative?: InputMaybe<Scalars['String']['input']>;
}

/** JONUM spending period usage */
export interface SpendingUsage {
  __typename: 'SpendingUsage';
  limit?: Maybe<MonetaryAmount>;
  pendingLimitChange?: Maybe<PendingSpendingLimit>;
  periodResetsAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  used: MonetaryAmount;
}

export const Sport = {
  BASEBALL: 'BASEBALL',
  FOOTBALL: 'FOOTBALL',
  NBA: 'NBA'
} as const;

export type Sport = typeof Sport[keyof typeof Sport];
export const SportOrShared = {
  BASEBALL: 'BASEBALL',
  FOOTBALL: 'FOOTBALL',
  GLOBAL: 'GLOBAL',
  NBA: 'NBA'
} as const;

export type SportOrShared = typeof SportOrShared[keyof typeof SportOrShared];
export interface SportSeason {
  __typename: 'SportSeason';
  endYear: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  singleCivilYear: Scalars['Boolean']['output'];
  startYear: Scalars['Int']['output'];
}

/** Stat of an entity in a sport */
export interface SportStat {
  __typename: 'SportStat';
  name: Scalars['String']['output'];
  unit: StatUnit;
  value: Scalars['Float']['output'];
}

/** A live-ops promo surfaced in the Event Hub feed */
export interface Spotlight {
  backgroundUrl?: Maybe<Scalars['String']['output']>;
  body?: Maybe<Scalars['String']['output']>;
  category: SpotlightCategory;
  /** Card accent as a #RRGGBB hex code */
  color?: Maybe<Scalars['String']['output']>;
  ctaLabel?: Maybe<Scalars['String']['output']>;
  /** Deep link to open on tap */
  ctaUrl?: Maybe<Scalars['String']['output']>;
  /** Deep link to open on tap, when the spotlight targets the app */
  deeplinkUrl?: Maybe<Scalars['String']['output']>;
  endDate: Scalars['ISO8601DateTime']['output'];
  featured: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  /** Optional callout artwork displayed alongside the shortcut badge */
  shortcutBadgeCalloutUrl?: Maybe<Scalars['String']['output']>;
  /** Featured-only badge for the Play entry point */
  shortcutBadgeUrl?: Maybe<Scalars['String']['output']>;
  /** Accessibility and analytics label for the shortcut badge */
  shortcutName?: Maybe<Scalars['String']['output']>;
  /** Whether to count down to endDate rather than label the spotlight as live */
  showCountdown: Scalars['Boolean']['output'];
  startDate: Scalars['ISO8601DateTime']['output'];
  statTiles: Array<SpotlightStatTile>;
  tagChips: Array<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  /** Whether the current user already tapped this spotlight, false when anonymous */
  viewed: Scalars['Boolean']['output'];
}

export const SpotlightCategory = {
  GAMEPLAY: 'GAMEPLAY',
  MARKET: 'MARKET'
} as const;

export type SpotlightCategory = typeof SpotlightCategory[keyof typeof SpotlightCategory];
/** A headline stat displayed on a spotlight */
export interface SpotlightStatTile {
  __typename: 'SpotlightStatTile';
  /** Value the spotlight improves on, for a before/after display */
  baseValue?: Maybe<Scalars['String']['output']>;
  /** Icon displayed next to the value */
  iconUrl?: Maybe<Scalars['String']['output']>;
  label: Scalars['String']['output'];
  /** Ribbon label displayed on the stat */
  ribbon?: Maybe<Scalars['String']['output']>;
  value: Scalars['String']['output'];
  /** Color the value is displayed in */
  valueColor?: Maybe<Scalars['String']['output']>;
}

/** A squad of users for a dedicated sport */
export interface Squad extends Node {
  __typename: 'Squad';
  captain: User;
  /** Level of the squad live board step, starting at 1, 1 if none started */
  currentStepLevel: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  /** Invite secret, blank unless the current user is a member of the squad */
  joinSecret: Scalars['String']['output'];
  maxMembersCount: Scalars['Int']['output'];
  members: Array<User>;
  membersCount: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  private: Scalars['Boolean']['output'];
  sport: Sport;
}

export interface SquadBoard extends Board {
  __typename: 'SquadBoard';
  backgroundUrl?: Maybe<Scalars['String']['output']>;
  color?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  endDate?: Maybe<Scalars['ISO8601DateTime']['output']>;
  hasMyCollectionTasks: Scalars['Boolean']['output'];
  iconUrl?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  /** The `last_upcoming_matchday_game` field cannot be nested within a list. */
  lastUpcomingMatchdayGame?: Maybe<Game | GameOfBaseball | GameOfBasketball>;
  myCollectionTasks: Array<CardsCountTargetTask | CardsCountTask | CompleteCollectionsCountTargetTask | CompleteCollectionsCountTask | DailyActionTask | DecisivePlayerPickerTask | DropChallengeTask | GameWeeklyTask | GuessTheScoreTask | InviteTaskAsReferrer | So5LeaderboardTask | StarPackTask | Task | TasksTrack | ThresholdPickerTask | ThresholdsDuoConnectionTask | ThresholdsStreakAdditionalLineupTask | ThresholdsStreakTask>;
  myCurrentStep?: Maybe<CareerProStep | CareerStep | SquadStep>;
  myUnclaimedCollectionTasksCount: Scalars['Int']['output'];
  /** The number of collection tasks, steps and ladder rewards of this board left to claim */
  myUnclaimedRewardsCount: Scalars['Int']['output'];
  nextMatchdayAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  steps: Array<CareerProStep | CareerStep | SquadStep>;
  tileBackgroundUrl?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
}


export interface SquadBoardbackgroundUrlArgs {
  variant?: InputMaybe<AssetVariant>;
}


export interface SquadBoardcolorArgs {
  variant?: InputMaybe<ColorVariant>;
}


export interface SquadBoardhasMyCollectionTasksArgs {
  rarity?: InputMaybe<Rarity>;
}


export interface SquadBoardmyCollectionTasksArgs {
  rarity?: InputMaybe<Rarity>;
}


export interface SquadBoardmyUnclaimedCollectionTasksCountArgs {
  rarity?: InputMaybe<Rarity>;
}

/** The connection type for Squad. */
export interface SquadConnection {
  __typename: 'SquadConnection';
  /** A list of edges. */
  edges: Array<SquadEdge>;
  /** A list of nodes. */
  nodes: Array<Squad>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
}

/** An edge in a connection. */
export interface SquadEdge {
  __typename: 'SquadEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<Squad>;
}

/** A ranked lineup entry in a squad leaderboard */
export interface SquadLeaderboardLineup {
  __typename: 'SquadLeaderboardLineup';
  id: Scalars['ID']['output'];
  lineup: GuessTheScoreTaskLineup | So5Lineup | TaskLineup | ThresholdPickerTaskLineup;
  ranking: Scalars['Int']['output'];
}

/** A step in a squad progression board */
export interface SquadStep extends StepInterface, WithComposeTeamInterface {
  __typename: 'SquadStep';
  acknowledged: Scalars['Boolean']['output'];
  /** Card packs printing players eligible for the upcoming games of this step */
  cardPacks: Array<CardPack>;
  /** Whether some appearances are filled by a contributor rather than the lineup owner. */
  collaborative: Scalars['Boolean']['output'];
  defaultSortType: BenchSort;
  displayedTypedRules: Array<CardsCountAsFirstOwnerRule | OwnedSinceRule | PlayerHeightRule | SeasonsRule | So5ActiveClubsRule | So5ActiveNationalTeamsRule | So5AgeRule | So5AppearancesRule | So5AtLeastOfClubs | So5AtLeastOfCompetitions | So5AverageScoresRule | So5CaptainRule | So5CaptainScarcityRule | So5CardEditionsCountRule | So5CompetitionsRule | So5EntryItemRule | So5MaximumPlayersAverageScoreRule | So5MinimumPlayersAverageScoreRule | So5NationalityRule | So5NotNationalityRule | So5SameActiveClubRule | So5ScarcityRule | So5SeasonBonusRule | VaultPointsRule>;
  engineConfiguration: EngineConfiguration;
  /** The `highlighted_recommendations` field cannot be nested within a list. */
  highlightedRecommendations: Array<PlayerRecommendation>;
  id: Scalars['String']['output'];
  /** The Sorare Points winning this step earns on the active ladders it feeds, null when it feeds none */
  ladderPoints?: Maybe<Scalars['Int']['output']>;
  level: Scalars['Int']['output'];
  marketSections: Array<CardPackGroup | FeaturedCardPack | FeaturedMarketSection | GemsShop | LegacyPacks | MarketLiveOps | MarketSetSpecialBundles | MarketSetWelcomeOffer | SpecialOffers | WeeklyDeals>;
  minimumLineupsToStartStep: Scalars['Int']['output'];
  /** The `my_filtered_bench` field cannot be nested within a list. */
  myFilteredBench: ComposeTeamBenchObjectInterfaceConnection;
  myLineups: Array<GuessTheScoreTaskLineup | So5Lineup | TaskLineup | ThresholdPickerTaskLineup>;
  /** The date until which the config is overriden by a promotion */
  originalConfigOverridenUntil?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** The original value of rewardConfigs outside promotions */
  originalRewardConfigs?: Maybe<Array<CardPacksRewardConfig | CardRewardConfig | CardShardRewardConfig | CoinRewardConfig | ConversionCreditRewardConfig | DeliverableItemRewardConfig | ExperienceRewardConfig | InGameCurrencyRewardConfig | MonetaryRewardConfig | ProbabilisticBundleRewardConfig | ShopItemRewardConfig>>;
  /** The original value of target outside promotions */
  originalTarget?: Maybe<Scalars['Int']['output']>;
  possibleBenchSortingTypes: Array<SortingType>;
  previewSo5Lineup: ComposeTeamLineupPreview;
  rewardConfigs: Array<CardPacksRewardConfig | CardRewardConfig | CardShardRewardConfig | CoinRewardConfig | ConversionCreditRewardConfig | DeliverableItemRewardConfig | ExperienceRewardConfig | InGameCurrencyRewardConfig | MonetaryRewardConfig | ProbabilisticBundleRewardConfig | ShopItemRewardConfig>;
  rewardMultiplierConfiguration?: Maybe<RewardMultiplierConfiguration>;
  squadLeaderboardLineups: Array<SquadLeaderboardLineup>;
  state: StepState;
  target: Scalars['Int']['output'];
  /** The `top_recommendations` field cannot be nested within a list. */
  topRecommendations: Array<PlayerRecommendation>;
  totalLineups: Scalars['Int']['output'];
  totalScore: Scalars['Float']['output'];
}


/** A step in a squad progression board */
export interface SquadStephighlightedRecommendationsArgs {
  positions?: InputMaybe<Array<Position>>;
  recommendationEngine: RecommendationEngine;
  sport: Sport;
}


/** A step in a squad progression board */
export interface SquadStepmyFilteredBenchArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filters: BenchFilterInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  stackByCardData?: InputMaybe<Scalars['Boolean']['input']>;
  topByPosition?: InputMaybe<Scalars['Int']['input']>;
}


/** A step in a squad progression board */
export interface SquadSteppreviewSo5LineupArgs {
  appearances: Array<So5AppearanceInput>;
}


/** A step in a squad progression board */
export interface SquadStepsquadLeaderboardLineupsArgs {
  top?: InputMaybe<Scalars['Int']['input']>;
}


/** A step in a squad progression board */
export interface SquadSteptopRecommendationsArgs {
  filters?: InputMaybe<BenchFilterInput>;
  playingHomeOnly?: InputMaybe<Scalars['Boolean']['input']>;
  positions?: InputMaybe<Array<Position>>;
  query?: InputMaybe<Scalars['String']['input']>;
  recommendationEngine: RecommendationEngine;
  sortType?: InputMaybe<EligibleCardsSort>;
  sport: Sport;
  starterOddsBasisPointsRange?: InputMaybe<RangeInput>;
}

/** A group of a Stage for a competition and season */
export interface StageGroup extends Node {
  __typename: 'StageGroup';
  contestants: Array<BaseballContestantType | BasketballContestantType | FootballContestantType>;
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
}

export interface StarPackTask extends ManagerTaskInterface, TaskInterface {
  __typename: 'StarPackTask';
  aasmState: ManagerProgressionTaskState;
  alternativeRewardConfigs?: Maybe<Array<AlternativeRewardConfig>>;
  /** @deprecated Not used anymore */
  cards: Array<BaseballCard | Card | NBACard>;
  claimableAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** @deprecated Not used anymore */
  claimedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  color?: Maybe<Scalars['String']['output']>;
  completedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  description: Scalars['String']['output'];
  expired: Scalars['Boolean']['output'];
  genre: TaskGenre;
  group?: Maybe<TaskGroup>;
  iconUrl?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  jonumGated: Scalars['Boolean']['output'];
  /** The points this task earned on a ladder leaderboard, empty when it feeds none. */
  ladderContributions: Array<LadderContribution>;
  /** The `my_reward_pool_shares` field cannot be nested within a list. */
  myRewardPoolShares?: Maybe<Array<RewardPoolShare>>;
  name: ManagerProgressionTaskSlug;
  /** @deprecated Not used anymore */
  nextStarPlayerRotationAt: Scalars['ISO8601DateTime']['output'];
  parentTask?: Maybe<CardsCountTargetTask | CardsCountTask | CompleteCollectionsCountTargetTask | CompleteCollectionsCountTask | DailyActionTask | DecisivePlayerPickerTask | DropChallengeTask | GameWeeklyTask | GuessTheScoreTask | InviteTaskAsReferrer | So5LeaderboardTask | StarPackTask | Task | TasksTrack | ThresholdPickerTask | ThresholdsDuoConnectionTask | ThresholdsStreakAdditionalLineupTask | ThresholdsStreakTask>;
  periodicity?: Maybe<ManagerTaskPeriodicity>;
  pickOrList: Scalars['Boolean']['output'];
  possibleRewardConfigsIconUrl?: Maybe<Scalars['String']['output']>;
  /** @deprecated Not used anymore */
  probabilisticBundles: Array<ProbabilisticBundle>;
  progress: Scalars['Int']['output'];
  rarity?: Maybe<Rarity>;
  rewardConfigs: Array<CardPacksRewardConfig | CardRewardConfig | CardShardRewardConfig | CoinRewardConfig | ConversionCreditRewardConfig | DeliverableItemRewardConfig | ExperienceRewardConfig | InGameCurrencyRewardConfig | MonetaryRewardConfig | ProbabilisticBundleRewardConfig | ShopItemRewardConfig>;
  /** The `reward_pool_shares` field cannot be nested within a list. */
  rewardPoolShares?: Maybe<RewardPoolShareConnection>;
  /** @deprecated Not used anymore */
  starPlayer: CommonPlayer;
  /** @deprecated Use starPlayerOddsBasisPoint instead */
  starPlayerOdds: Scalars['Float']['output'];
  /** @deprecated Not used anymore */
  starPlayerOddsBasisPoint: Scalars['Int']['output'];
  startDate?: Maybe<Scalars['ISO8601DateTime']['output']>;
  target: Scalars['Int']['output'];
  taskConfigSlug: Scalars['String']['output'];
  templateIconUrl: Scalars['String']['output'];
  title: Scalars['String']['output'];
  uncapped: Scalars['Boolean']['output'];
}


export interface StarPackTaskcolorArgs {
  variant?: InputMaybe<ColorVariant>;
}


export interface StarPackTaskrewardConfigsArgs {
  mergedConfigsByType?: InputMaybe<Scalars['Boolean']['input']>;
}


export interface StarPackTaskrewardPoolSharesArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
}

export interface StarkexApprovalInput {
  expirationTimestamp: Scalars['Int']['input'];
  nonce: Scalars['Int']['input'];
  signature: StarkwareSignatureInput;
}

/** A StarkEx limit order authorization request */
export interface StarkexLimitOrderAuthorizationRequest {
  __typename: 'StarkexLimitOrderAuthorizationRequest';
  amountBuy: Scalars['WeiAmount']['output'];
  amountSell: Scalars['WeiAmount']['output'];
  expirationTimestamp: Scalars['Int']['output'];
  feeInfo?: Maybe<Fee>;
  nonce: Scalars['Int']['output'];
  tokenBuy: Scalars['String']['output'];
  tokenSell: Scalars['String']['output'];
  vaultIdBuy: Scalars['Int']['output'];
  vaultIdSell: Scalars['Int']['output'];
}

/** A StarkEx transfer authorization request */
export interface StarkexTransferAuthorizationRequest {
  __typename: 'StarkexTransferAuthorizationRequest';
  amount: Scalars['CryptocurrencyAmount']['output'];
  condition?: Maybe<Scalars['String']['output']>;
  expirationTimestamp: Scalars['Int']['output'];
  feeInfoUser?: Maybe<Fee>;
  nonce: Scalars['Int']['output'];
  receiverPublicKey: Scalars['String']['output'];
  receiverVaultId: Scalars['Int']['output'];
  senderVaultId: Scalars['Int']['output'];
  token: Scalars['String']['output'];
}

/** A StarkExV6 token transfer authorization request */
export interface StarkexV6TokenTransferAuthorizationRequest {
  __typename: 'StarkexV6TokenTransferAuthorizationRequest';
  assetId: Scalars['String']['output'];
  expirationTimestamp: Scalars['Int']['output'];
  leafIndex: Scalars['Int']['output'];
  merkleTreeAddress: Scalars['SolanaAddress']['output'];
  nonce: Scalars['String']['output'];
  originator: Scalars['SolanaAddress']['output'];
  receiverAddress: Scalars['String']['output'];
  senderAddress: Scalars['String']['output'];
  transferProxyProgramAddress: Scalars['SolanaAddress']['output'];
}

/** A Starkware Account */
export interface StarkwareAccount extends Node {
  __typename: 'StarkwareAccount';
  id: Scalars['ID']['output'];
  starkKey: Scalars['String']['output'];
  user?: Maybe<User>;
}

/** Escape hatch flow for ETH on the frozen StarkExchange contract */
export interface StarkwareEscapeHatch extends Node {
  __typename: 'StarkwareEscapeHatch';
  createdAt: Scalars['ISO8601DateTime']['output'];
  destination: Scalars['EthereumAddress']['output'];
  id: Scalars['ID']['output'];
  requiresRegistration: Scalars['Boolean']['output'];
  state: EscapeHatchState;
  weiAmount: Scalars['WeiAmount']['output'];
}

/** A Starkware Account */
export interface StarkwarePrivateAccount extends Node {
  __typename: 'StarkwarePrivateAccount';
  availableBalance: Scalars['WeiAmount']['output'];
  /** @deprecated No longer used, always returns 0 */
  availableBalanceForWithdrawal: Scalars['WeiAmount']['output'];
  id: Scalars['ID']['output'];
  publicInfo: StarkwareAccount;
  totalBalance: Scalars['WeiAmount']['output'];
  user?: Maybe<User>;
}

export interface StarkwareSignatureInput {
  r: Scalars['String']['input'];
  s: Scalars['String']['input'];
}

/** Withdrawal of a token to Ethereum */
export interface StarkwareWithdrawal extends Node {
  __typename: 'StarkwareWithdrawal';
  aasmState: Scalars['String']['output'];
  anyCard?: Maybe<BaseballCard | Card | NBACard>;
  destination?: Maybe<Scalars['String']['output']>;
  ethereumTransaction?: Maybe<EthereumTransaction>;
  id: Scalars['ID']['output'];
}

/** Stat of a sport */
export interface Stat {
  __typename: 'Stat';
  name: Scalars['String']['output'];
  shortName: Scalars['String']['output'];
}

export const StatCategory = {
  ATTACKING: 'ATTACKING',
  DEFENDING: 'DEFENDING',
  GENERAL: 'GENERAL',
  GOALKEEPING: 'GOALKEEPING',
  HITTING: 'HITTING',
  NEGATIVE_DECISIVE_STAT: 'NEGATIVE_DECISIVE_STAT',
  PASSING: 'PASSING',
  PITCHING: 'PITCHING',
  POSITIVE_DECISIVE_STAT: 'POSITIVE_DECISIVE_STAT',
  POSSESSION: 'POSSESSION',
  UNKNOWN: 'UNKNOWN'
} as const;

export type StatCategory = typeof StatCategory[keyof typeof StatCategory];
/** Stat custom scoring */
export interface StatCustomScoring {
  __typename: 'StatCustomScoring';
  customPoints: Scalars['Float']['output'];
  points: Scalars['Float']['output'];
  position?: Maybe<Position>;
  stat: Scalars['String']['output'];
}

/** Score contribution of a given stat */
export interface StatScore {
  __typename: 'StatScore';
  category: StatCategory;
  points: Scalars['Float']['output'];
  stat: Scalars['String']['output'];
  statTyped: Stat;
  statValue: Scalars['Float']['output'];
  totalScore: Scalars['Float']['output'];
}

export const StatUnit = {
  FLOAT: 'FLOAT',
  INTEGER: 'INTEGER',
  PERCENTAGE: 'PERCENTAGE'
} as const;

export type StatUnit = typeof StatUnit[keyof typeof StatUnit];
/** Stats of a player for a competition */
export interface Stats {
  __typename: 'Stats';
  appearances: Scalars['Int']['output'];
  assists: Scalars['Int']['output'];
  goals: Scalars['Int']['output'];
  id: Scalars['String']['output'];
  minutesPlayed: Scalars['Int']['output'];
  redCards: Scalars['Int']['output'];
  season?: Maybe<Season>;
  substituteIn: Scalars['Int']['output'];
  substituteOut: Scalars['Int']['output'];
  yellowCards: Scalars['Int']['output'];
}

export interface StepInterface {
  /** Whether some appearances are filled by a contributor rather than the lineup owner. */
  collaborative: Scalars['Boolean']['output'];
  defaultSortType: BenchSort;
  displayedTypedRules: Array<CardsCountAsFirstOwnerRule | OwnedSinceRule | PlayerHeightRule | SeasonsRule | So5ActiveClubsRule | So5ActiveNationalTeamsRule | So5AgeRule | So5AppearancesRule | So5AtLeastOfClubs | So5AtLeastOfCompetitions | So5AverageScoresRule | So5CaptainRule | So5CaptainScarcityRule | So5CardEditionsCountRule | So5CompetitionsRule | So5EntryItemRule | So5MaximumPlayersAverageScoreRule | So5MinimumPlayersAverageScoreRule | So5NationalityRule | So5NotNationalityRule | So5SameActiveClubRule | So5ScarcityRule | So5SeasonBonusRule | VaultPointsRule>;
  engineConfiguration: EngineConfiguration;
  /** The `highlighted_recommendations` field cannot be nested within a list. */
  highlightedRecommendations: Array<PlayerRecommendation>;
  id: Scalars['String']['output'];
  /** The Sorare Points winning this step earns on the active ladders it feeds, null when it feeds none */
  ladderPoints?: Maybe<Scalars['Int']['output']>;
  level: Scalars['Int']['output'];
  /** The `my_filtered_bench` field cannot be nested within a list. */
  myFilteredBench: ComposeTeamBenchObjectInterfaceConnection;
  myLineups: Array<GuessTheScoreTaskLineup | So5Lineup | TaskLineup | ThresholdPickerTaskLineup>;
  /** The date until which the config is overriden by a promotion */
  originalConfigOverridenUntil?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** The original value of rewardConfigs outside promotions */
  originalRewardConfigs?: Maybe<Array<CardPacksRewardConfig | CardRewardConfig | CardShardRewardConfig | CoinRewardConfig | ConversionCreditRewardConfig | DeliverableItemRewardConfig | ExperienceRewardConfig | InGameCurrencyRewardConfig | MonetaryRewardConfig | ProbabilisticBundleRewardConfig | ShopItemRewardConfig>>;
  /** The original value of target outside promotions */
  originalTarget?: Maybe<Scalars['Int']['output']>;
  possibleBenchSortingTypes: Array<SortingType>;
  previewSo5Lineup: ComposeTeamLineupPreview;
  rewardConfigs: Array<CardPacksRewardConfig | CardRewardConfig | CardShardRewardConfig | CoinRewardConfig | ConversionCreditRewardConfig | DeliverableItemRewardConfig | ExperienceRewardConfig | InGameCurrencyRewardConfig | MonetaryRewardConfig | ProbabilisticBundleRewardConfig | ShopItemRewardConfig>;
  rewardMultiplierConfiguration?: Maybe<RewardMultiplierConfiguration>;
  state: StepState;
  target: Scalars['Int']['output'];
  /** The `top_recommendations` field cannot be nested within a list. */
  topRecommendations: Array<PlayerRecommendation>;
}


export interface StepInterfacehighlightedRecommendationsArgs {
  positions?: InputMaybe<Array<Position>>;
  recommendationEngine: RecommendationEngine;
  sport: Sport;
}


export interface StepInterfacemyFilteredBenchArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filters: BenchFilterInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  stackByCardData?: InputMaybe<Scalars['Boolean']['input']>;
  topByPosition?: InputMaybe<Scalars['Int']['input']>;
}


export interface StepInterfacepreviewSo5LineupArgs {
  appearances: Array<So5AppearanceInput>;
}


export interface StepInterfacetopRecommendationsArgs {
  filters?: InputMaybe<BenchFilterInput>;
  playingHomeOnly?: InputMaybe<Scalars['Boolean']['input']>;
  positions?: InputMaybe<Array<Position>>;
  query?: InputMaybe<Scalars['String']['input']>;
  recommendationEngine: RecommendationEngine;
  sortType?: InputMaybe<EligibleCardsSort>;
  sport: Sport;
  starterOddsBasisPointsRange?: InputMaybe<RangeInput>;
}

export const StepState = {
  CLAIMABLE: 'CLAIMABLE',
  CLAIMED: 'CLAIMED',
  FAILED: 'FAILED',
  LINEUP_SET: 'LINEUP_SET',
  LIVE: 'LIVE',
  LOCKED: 'LOCKED',
  PLAYABLE: 'PLAYABLE',
  PRE_MATCHDAY_LOCKED: 'PRE_MATCHDAY_LOCKED'
} as const;

export type StepState = typeof StepState[keyof typeof StepState];
/** Number of times a user won a given step of a card set career track */
export interface StepWonCount {
  __typename: 'StepWonCount';
  /** Number of times the user completed that step */
  count: Scalars['Int']['output'];
  /** Level of the step in the card set career track, starting at 1 */
  level: Scalars['Int']['output'];
}

/** A story */
export interface Story extends Node {
  __typename: 'Story';
  aasmState: StoryState;
  completedThresholdsStreakTasks?: Maybe<Array<ThresholdsStreakTask>>;
  expiresAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  id: Scalars['ID']['output'];
  leveledUpCards?: Maybe<Array<LeveledUpCard>>;
  readable: StoryReadable;
  userGroupMembershipShopItemUpdates?: Maybe<Array<UserGroupMembershipShopItemsUpdate>>;
}

export type StoryReadable = So5Fixture;

export const StoryState = {
  EXPIRED: 'EXPIRED',
  READ: 'READ',
  READY: 'READY'
} as const;

export type StoryState = typeof StoryState[keyof typeof StoryState];
/** A Stripe credit card authorization request */
export interface StripeCreditCardAuthorizationRequest {
  __typename: 'StripeCreditCardAuthorizationRequest';
  amount: Scalars['Int']['output'];
  clientSecret: Scalars['String']['output'];
  currency: FiatCurrency;
  id: Scalars['String']['output'];
  paymentMethod?: Maybe<Scalars['String']['output']>;
  receiptUrl?: Maybe<Scalars['String']['output']>;
}

/** Object that can be subscribed to */
export type Subscribable = BaseballCard | BaseballPlayer | Card | CardCollection | Club | Competition | Country | NBACard | NBAPlayer | Player | User | Watchlist;

export interface SubscribableInput {
  slug: Scalars['String']['input'];
  type: Scalars['String']['input'];
}

export const SubscribableType = {
  BASEBALL_CARD: 'BASEBALL_CARD',
  BASEBALL_PLAYER: 'BASEBALL_PLAYER',
  CARD: 'CARD',
  COUNTRY: 'COUNTRY',
  NBA_CARD: 'NBA_CARD',
  NBA_PLAYER: 'NBA_PLAYER',
  PLAYER: 'PLAYER',
  TEAM: 'TEAM',
  USER: 'USER',
  WATCHLIST: 'WATCHLIST'
} as const;

export type SubscribableType = typeof SubscribableType[keyof typeof SubscribableType];
/** Type of a subscriber to a new card, player, country or club related auction */
export type Subscriber = CurrentUser;

export interface Subscription {
  __typename: 'Subscription';
  aGameWasUpdated?: Maybe<Game>;
  /** Triggered when a manager reacts to an activity the current user shared */
  activityReactionWasHighlighted?: Maybe<ActivityReaction>;
  /** Triggered when a manager the current user follows shares an activity */
  activityWasHighlighted?: Maybe<CardPackActivityFeed | LineupActivityFeed | OwnerActivityFeed>;
  anyCardWasUpdated?: Maybe<AnyCardSubscription>;
  anyGameWasUpdated?: Maybe<Game | GameOfBaseball | GameOfBasketball>;
  currentUserTaskWasUpdated?: Maybe<CurrentUserTaskWasUpdatedPayload>;
  currentUserWasUpdated?: Maybe<CurrentUser>;
  /** Triggered on device update */
  deviceWasUpdated?: Maybe<UserDeviceEvent>;
  gameWasUpdated?: Maybe<Game>;
  /** Triggered on primary offer opened/accepted/cancelled/ended */
  primaryOfferWasUpdated?: Maybe<TokenPrimaryOffer>;
  /** Triggered when a limited-supply pack's remaining_supply changes */
  remainingSupplyWasUpdated?: Maybe<CardPack>;
  /** Triggered on new bid or ended auction */
  tokenAuctionWasUpdated?: Maybe<TokenAuction>;
  /** Triggered on offer accepted/cancelled/ended */
  tokenOfferWasUpdated?: Maybe<TokenOffer>;
  /** Triggered on user card collection update */
  userCardCollectionWasUpdated?: Maybe<UserCardCollection>;
}


export interface SubscriptionaGameWasUpdatedArgs {
  id: Scalars['ID']['input'];
}


export interface SubscriptionanyCardWasUpdatedArgs {
  ages?: InputMaybe<Array<Scalars['Int']['input']>>;
  cardEditions?: InputMaybe<Array<Scalars['String']['input']>>;
  events?: InputMaybe<Array<CardWasUpdatedEvent>>;
  owned?: InputMaybe<Scalars['Boolean']['input']>;
  playerSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  positions?: InputMaybe<Array<Position>>;
  rarities?: InputMaybe<Array<Rarity>>;
  seasonStartYears?: InputMaybe<Array<Scalars['Int']['input']>>;
  serialNumbers?: InputMaybe<Array<Scalars['Int']['input']>>;
  shirtNumbers?: InputMaybe<Array<Scalars['Int']['input']>>;
  slugs?: InputMaybe<Array<Scalars['String']['input']>>;
  sports?: InputMaybe<Array<Sport>>;
}


export interface SubscriptionanyGameWasUpdatedArgs {
  id: Scalars['ID']['input'];
}


export interface SubscriptioncurrentUserTaskWasUpdatedArgs {
  bypassRebuildCollectionTask?: InputMaybe<Scalars['Boolean']['input']>;
}


export interface SubscriptionprimaryOfferWasUpdatedArgs {
  sports?: InputMaybe<Array<Sport>>;
}


export interface SubscriptionremainingSupplyWasUpdatedArgs {
  cardPackSlug: Scalars['String']['input'];
}


export interface SubscriptiontokenAuctionWasUpdatedArgs {
  sports?: InputMaybe<Array<Sport>>;
}


export interface SubscriptiontokenOfferWasUpdatedArgs {
  sports?: InputMaybe<Array<Sport>>;
}


export interface SubscriptionuserCardCollectionWasUpdatedArgs {
  id: Scalars['ID']['input'];
}

/** A substitution within a game */
export interface SubstitutionEvent extends DecisiveEventInterface {
  __typename: 'SubstitutionEvent';
  addedTime?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  minute: Scalars['Int']['output'];
  occurredAt: Scalars['ISO8601DateTime']['output'];
  offPlayer: BaseballPlayer | NBAPlayer | Player;
  period?: Maybe<Period>;
  player: BaseballPlayer | NBAPlayer | Player;
  stat?: Maybe<Scalars['String']['output']>;
}

export const SupportedCurrency = {
  EUR: 'EUR',
  GBP: 'GBP',
  LAMPORT: 'LAMPORT',
  USD: 'USD',
  WEI: 'WEI'
} as const;

export type SupportedCurrency = typeof SupportedCurrency[keyof typeof SupportedCurrency];
/** A player suspension */
export interface Suspension extends Node {
  __typename: 'Suspension';
  active: Scalars['Boolean']['output'];
  competition: Competition;
  endDate?: Maybe<Scalars['ISO8601DateTime']['output']>;
  id: Scalars['ID']['output'];
  kind?: Maybe<Scalars['String']['output']>;
  matches?: Maybe<Scalars['Int']['output']>;
  reason?: Maybe<Scalars['String']['output']>;
  startDate: Scalars['ISO8601DateTime']['output'];
}

/** Task */
export interface Task extends ManagerTaskInterface, TaskInterface {
  __typename: 'Task';
  aasmState: ManagerProgressionTaskState;
  alternativeRewardConfigs?: Maybe<Array<AlternativeRewardConfig>>;
  /** @deprecated Not used anymore */
  cards: Array<BaseballCard | Card | NBACard>;
  claimableAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** @deprecated Not used anymore */
  claimedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  color?: Maybe<Scalars['String']['output']>;
  completedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  description: Scalars['String']['output'];
  expired: Scalars['Boolean']['output'];
  genre: TaskGenre;
  group?: Maybe<TaskGroup>;
  iconUrl?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  jonumGated: Scalars['Boolean']['output'];
  /** The points this task earned on a ladder leaderboard, empty when it feeds none. */
  ladderContributions: Array<LadderContribution>;
  /** The `my_reward_pool_shares` field cannot be nested within a list. */
  myRewardPoolShares?: Maybe<Array<RewardPoolShare>>;
  name: ManagerProgressionTaskSlug;
  parentTask?: Maybe<CardsCountTargetTask | CardsCountTask | CompleteCollectionsCountTargetTask | CompleteCollectionsCountTask | DailyActionTask | DecisivePlayerPickerTask | DropChallengeTask | GameWeeklyTask | GuessTheScoreTask | InviteTaskAsReferrer | So5LeaderboardTask | StarPackTask | Task | TasksTrack | ThresholdPickerTask | ThresholdsDuoConnectionTask | ThresholdsStreakAdditionalLineupTask | ThresholdsStreakTask>;
  periodicity?: Maybe<ManagerTaskPeriodicity>;
  pickOrList: Scalars['Boolean']['output'];
  possibleRewardConfigsIconUrl?: Maybe<Scalars['String']['output']>;
  /** @deprecated Not used anymore */
  probabilisticBundles: Array<ProbabilisticBundle>;
  progress: Scalars['Int']['output'];
  rarity?: Maybe<Rarity>;
  rewardConfigs: Array<CardPacksRewardConfig | CardRewardConfig | CardShardRewardConfig | CoinRewardConfig | ConversionCreditRewardConfig | DeliverableItemRewardConfig | ExperienceRewardConfig | InGameCurrencyRewardConfig | MonetaryRewardConfig | ProbabilisticBundleRewardConfig | ShopItemRewardConfig>;
  /** The `reward_pool_shares` field cannot be nested within a list. */
  rewardPoolShares?: Maybe<RewardPoolShareConnection>;
  startDate?: Maybe<Scalars['ISO8601DateTime']['output']>;
  target: Scalars['Int']['output'];
  taskConfigSlug: Scalars['String']['output'];
  templateIconUrl: Scalars['String']['output'];
  title: Scalars['String']['output'];
  uncapped: Scalars['Boolean']['output'];
}


/** Task */
export interface TaskcolorArgs {
  variant?: InputMaybe<ColorVariant>;
}


/** Task */
export interface TaskrewardConfigsArgs {
  mergedConfigsByType?: InputMaybe<Scalars['Boolean']['input']>;
}


/** Task */
export interface TaskrewardPoolSharesArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
}

/** Task Appearance */
export interface TaskAppearance extends AppearanceInterface, ComposeTeamBenchObjectInterface, TaskAppearanceInterface {
  __typename: 'TaskAppearance';
  activeSuspensions: Array<Suspension>;
  anyCard?: Maybe<BaseballCard | Card | NBACard>;
  anyCardWithLivePrimaryOffer?: Maybe<BaseballCard | Card | NBACard>;
  anyPlayer: BaseballPlayer | NBAPlayer | Player;
  averageScore?: Maybe<Scalars['Float']['output']>;
  bonus?: Maybe<Scalars['Float']['output']>;
  bonusPoints?: Maybe<Scalars['Float']['output']>;
  bonusRating?: Maybe<BonusOrdinalRatingEnum>;
  captain: Scalars['Boolean']['output'];
  card: BaseballCard | Card | NBACard;
  cardBorderRadius: Scalars['Int']['output'];
  completedTask?: Maybe<CardsCountTargetTask | CardsCountTask | CompleteCollectionsCountTargetTask | CompleteCollectionsCountTask | DailyActionTask | DecisivePlayerPickerTask | DropChallengeTask | GameWeeklyTask | GuessTheScoreTask | InviteTaskAsReferrer | So5LeaderboardTask | StarPackTask | Task | TasksTrack | ThresholdPickerTask | ThresholdsDuoConnectionTask | ThresholdsStreakAdditionalLineupTask | ThresholdsStreakTask>;
  contributor?: Maybe<User>;
  eligiblePlayerGameScores: Array<BaseballPlayerGameScore | BasketballPlayerGameScore | PlayerGameScore | So5Score>;
  /**
   * Projected score minus the lowest score of the player star tier for NBA, minus
   * the L10 average otherwise, from the projection the bench sorts
   * GAIN_ON_PROJECTION on: the next game on a card bench with no fixture, the
   * fixture projection otherwise
   */
  gainOnProjection?: Maybe<Scalars['Float']['output']>;
  game?: Maybe<Game | GameOfBaseball | GameOfBasketball>;
  id: Scalars['ID']['output'];
  index: Scalars['Int']['output'];
  licensed: Scalars['Boolean']['output'];
  locked: Scalars['Boolean']['output'];
  /** When a bench object will be locked for a leaderboard */
  lockedAt: Scalars['ISO8601DateTime']['output'];
  /** Wether a bench object can be updated for a leaderboard */
  lockedForLeaderboard: Scalars['Boolean']['output'];
  pictureUrl?: Maybe<Scalars['String']['output']>;
  playedGames: Array<Game | GameOfBaseball | GameOfBasketball>;
  player: Player;
  playerGameScore?: Maybe<BaseballPlayerGameScore | BasketballPlayerGameScore | PlayerGameScore | So5Score>;
  position: Position;
  positions: Array<Position>;
  powerBreakdown: PowerBreakdown;
  /** PowerBreakdown as long as leaderboard is playable. PowerPointsBreakdown after */
  powerBreakdownOrPowerPointsBreakdown?: Maybe<PowerBreakdownOrPowerPointsBreakdown>;
  projectedScore?: Maybe<Scalars['Float']['output']>;
  rarity: Rarity;
  score: Scalars['Float']['output'];
  scoreStatus: ScoreStatus;
  task: CardsCountTargetTask | CardsCountTask | CompleteCollectionsCountTargetTask | CompleteCollectionsCountTask | DailyActionTask | DecisivePlayerPickerTask | DropChallengeTask | GameWeeklyTask | GuessTheScoreTask | InviteTaskAsReferrer | So5LeaderboardTask | StarPackTask | Task | TasksTrack | ThresholdPickerTask | ThresholdsDuoConnectionTask | ThresholdsStreakAdditionalLineupTask | ThresholdsStreakTask;
  upcomingGame?: Maybe<Game | GameOfBaseball | GameOfBasketball>;
  videoUrl?: Maybe<Scalars['String']['output']>;
}


/** Task Appearance */
export interface TaskAppearanceactiveSuspensionsArgs {
  so5LeaderboardSlug?: InputMaybe<Scalars['String']['input']>;
}


/** Task Appearance */
export interface TaskAppearanceanyCardWithLivePrimaryOfferArgs {
  rarity?: InputMaybe<Rarity>;
}


/** Task Appearance */
export interface TaskAppearanceaverageScoreArgs {
  type: AveragePlayerScore;
}


/** Task Appearance */
export interface TaskAppearanceeligiblePlayerGameScoresArgs {
  boardId?: InputMaybe<Scalars['String']['input']>;
  gameId?: InputMaybe<Scalars['ID']['input']>;
  so5LeaderboardSlug?: InputMaybe<Scalars['String']['input']>;
  stepId?: InputMaybe<Scalars['String']['input']>;
  taskId?: InputMaybe<Scalars['ID']['input']>;
}


/** Task Appearance */
export interface TaskAppearancelockedAtArgs {
  so5LeaderboardSlug?: InputMaybe<Scalars['String']['input']>;
}


/** Task Appearance */
export interface TaskAppearancelockedForLeaderboardArgs {
  so5LeaderboardSlug?: InputMaybe<Scalars['String']['input']>;
}


/** Task Appearance */
export interface TaskAppearancepictureUrlArgs {
  derivative?: InputMaybe<Scalars['String']['input']>;
}


/** Task Appearance */
export interface TaskAppearanceprojectedScoreArgs {
  so5LeaderboardSlug: Scalars['String']['input'];
}


/** Task Appearance */
export interface TaskAppearancescoreArgs {
  withBonus?: InputMaybe<Scalars['Boolean']['input']>;
}


/** Task Appearance */
export interface TaskAppearancevideoUrlArgs {
  derivative?: InputMaybe<Scalars['String']['input']>;
}

/** A Task Appearance - a card picked for a task */
export interface TaskAppearanceInput {
  captain?: InputMaybe<Scalars['Boolean']['input']>;
  cardSlug?: InputMaybe<Scalars['String']['input']>;
  composeTeamBenchObjectId?: InputMaybe<Scalars['ID']['input']>;
  gameId?: InputMaybe<Scalars['ID']['input']>;
  index: Scalars['Int']['input'];
}

/** Appearance interface */
export interface TaskAppearanceInterface {
  activeSuspensions: Array<Suspension>;
  anyCard?: Maybe<BaseballCard | Card | NBACard>;
  anyCardWithLivePrimaryOffer?: Maybe<BaseballCard | Card | NBACard>;
  anyPlayer: BaseballPlayer | NBAPlayer | Player;
  averageScore?: Maybe<Scalars['Float']['output']>;
  bonus?: Maybe<Scalars['Float']['output']>;
  bonusPoints?: Maybe<Scalars['Float']['output']>;
  bonusRating?: Maybe<BonusOrdinalRatingEnum>;
  captain: Scalars['Boolean']['output'];
  card: BaseballCard | Card | NBACard;
  cardBorderRadius: Scalars['Int']['output'];
  completedTask?: Maybe<CardsCountTargetTask | CardsCountTask | CompleteCollectionsCountTargetTask | CompleteCollectionsCountTask | DailyActionTask | DecisivePlayerPickerTask | DropChallengeTask | GameWeeklyTask | GuessTheScoreTask | InviteTaskAsReferrer | So5LeaderboardTask | StarPackTask | Task | TasksTrack | ThresholdPickerTask | ThresholdsDuoConnectionTask | ThresholdsStreakAdditionalLineupTask | ThresholdsStreakTask>;
  contributor?: Maybe<User>;
  eligiblePlayerGameScores: Array<BaseballPlayerGameScore | BasketballPlayerGameScore | PlayerGameScore | So5Score>;
  /**
   * Projected score minus the lowest score of the player star tier for NBA, minus
   * the L10 average otherwise, from the projection the bench sorts
   * GAIN_ON_PROJECTION on: the next game on a card bench with no fixture, the
   * fixture projection otherwise
   */
  gainOnProjection?: Maybe<Scalars['Float']['output']>;
  game?: Maybe<Game | GameOfBaseball | GameOfBasketball>;
  id: Scalars['ID']['output'];
  index: Scalars['Int']['output'];
  licensed: Scalars['Boolean']['output'];
  locked: Scalars['Boolean']['output'];
  /** When a bench object will be locked for a leaderboard */
  lockedAt: Scalars['ISO8601DateTime']['output'];
  /** Wether a bench object can be updated for a leaderboard */
  lockedForLeaderboard: Scalars['Boolean']['output'];
  pictureUrl?: Maybe<Scalars['String']['output']>;
  playedGames: Array<Game | GameOfBaseball | GameOfBasketball>;
  player: Player;
  playerGameScore?: Maybe<BaseballPlayerGameScore | BasketballPlayerGameScore | PlayerGameScore | So5Score>;
  position: Position;
  positions: Array<Position>;
  powerBreakdown: PowerBreakdown;
  /** PowerBreakdown as long as leaderboard is playable. PowerPointsBreakdown after */
  powerBreakdownOrPowerPointsBreakdown?: Maybe<PowerBreakdownOrPowerPointsBreakdown>;
  projectedScore?: Maybe<Scalars['Float']['output']>;
  rarity: Rarity;
  score: Scalars['Float']['output'];
  scoreStatus: ScoreStatus;
  task: CardsCountTargetTask | CardsCountTask | CompleteCollectionsCountTargetTask | CompleteCollectionsCountTask | DailyActionTask | DecisivePlayerPickerTask | DropChallengeTask | GameWeeklyTask | GuessTheScoreTask | InviteTaskAsReferrer | So5LeaderboardTask | StarPackTask | Task | TasksTrack | ThresholdPickerTask | ThresholdsDuoConnectionTask | ThresholdsStreakAdditionalLineupTask | ThresholdsStreakTask;
  upcomingGame?: Maybe<Game | GameOfBaseball | GameOfBasketball>;
  videoUrl?: Maybe<Scalars['String']['output']>;
}


/** Appearance interface */
export interface TaskAppearanceInterfaceactiveSuspensionsArgs {
  so5LeaderboardSlug?: InputMaybe<Scalars['String']['input']>;
}


/** Appearance interface */
export interface TaskAppearanceInterfaceanyCardWithLivePrimaryOfferArgs {
  rarity?: InputMaybe<Rarity>;
}


/** Appearance interface */
export interface TaskAppearanceInterfaceaverageScoreArgs {
  type: AveragePlayerScore;
}


/** Appearance interface */
export interface TaskAppearanceInterfaceeligiblePlayerGameScoresArgs {
  boardId?: InputMaybe<Scalars['String']['input']>;
  gameId?: InputMaybe<Scalars['ID']['input']>;
  so5LeaderboardSlug?: InputMaybe<Scalars['String']['input']>;
  stepId?: InputMaybe<Scalars['String']['input']>;
  taskId?: InputMaybe<Scalars['ID']['input']>;
}


/** Appearance interface */
export interface TaskAppearanceInterfacelockedAtArgs {
  so5LeaderboardSlug?: InputMaybe<Scalars['String']['input']>;
}


/** Appearance interface */
export interface TaskAppearanceInterfacelockedForLeaderboardArgs {
  so5LeaderboardSlug?: InputMaybe<Scalars['String']['input']>;
}


/** Appearance interface */
export interface TaskAppearanceInterfacepictureUrlArgs {
  derivative?: InputMaybe<Scalars['String']['input']>;
}


/** Appearance interface */
export interface TaskAppearanceInterfaceprojectedScoreArgs {
  so5LeaderboardSlug: Scalars['String']['input'];
}


/** Appearance interface */
export interface TaskAppearanceInterfacescoreArgs {
  withBonus?: InputMaybe<Scalars['Boolean']['input']>;
}


/** Appearance interface */
export interface TaskAppearanceInterfacevideoUrlArgs {
  derivative?: InputMaybe<Scalars['String']['input']>;
}

/** Task Campaign */
export interface TaskCampaign {
  __typename: 'TaskCampaign';
  color: Scalars['String']['output'];
  description: Scalars['String']['output'];
  detailSections: Array<TaskCampaignDetailSection>;
  endDate: Scalars['ISO8601DateTime']['output'];
  headerUrl: Scalars['String']['output'];
  iconUrl: Scalars['String']['output'];
  name: Scalars['String']['output'];
  rewardConfigs: Array<CardPacksRewardConfig | CardRewardConfig | CardShardRewardConfig | CoinRewardConfig | ConversionCreditRewardConfig | DeliverableItemRewardConfig | ExperienceRewardConfig | InGameCurrencyRewardConfig | MonetaryRewardConfig | ProbabilisticBundleRewardConfig | ShopItemRewardConfig>;
  shareMessage?: Maybe<Scalars['String']['output']>;
  shareUrl?: Maybe<Scalars['String']['output']>;
  slug: Scalars['String']['output'];
  /** The steps of the campaign task config, when it is a tasks track. */
  steps: Array<TaskCampaignStep>;
  tagIconUrl: Scalars['String']['output'];
  tagLabel: Scalars['String']['output'];
}


/** Task Campaign */
export interface TaskCampaigncolorArgs {
  variant?: InputMaybe<ColorVariant>;
}


/** Task Campaign */
export interface TaskCampaignheaderUrlArgs {
  mobile?: InputMaybe<Scalars['Boolean']['input']>;
}


/** Task Campaign */
export interface TaskCampaignrewardConfigsArgs {
  rarity: Rarity;
}

export interface TaskCampaignDetailSection {
  __typename: 'TaskCampaignDetailSection';
  description: Scalars['String']['output'];
  title: Scalars['String']['output'];
}

export interface TaskCampaignStep {
  __typename: 'TaskCampaignStep';
  rewardConfigs: Array<CardPacksRewardConfig | CardRewardConfig | CardShardRewardConfig | CoinRewardConfig | ConversionCreditRewardConfig | DeliverableItemRewardConfig | ExperienceRewardConfig | InGameCurrencyRewardConfig | MonetaryRewardConfig | ProbabilisticBundleRewardConfig | ShopItemRewardConfig>;
  target: Scalars['Int']['output'];
}

export interface TaskCampaignsHomepage {
  __typename: 'TaskCampaignsHomepage';
  campaigns: Array<TaskCampaignsHomepageCampaign>;
  tutorial: TaskCampaignsHomepageTutorial;
}

export interface TaskCampaignsHomepageCampaign {
  __typename: 'TaskCampaignsHomepageCampaign';
  color: Scalars['String']['output'];
  description: Scalars['String']['output'];
  iconUrl: Scalars['String']['output'];
  slug: Scalars['String']['output'];
  startDate?: Maybe<Scalars['ISO8601DateTime']['output']>;
  title: Scalars['String']['output'];
}

export interface TaskCampaignsHomepageTutorial {
  __typename: 'TaskCampaignsHomepageTutorial';
  marketUrl: Scalars['String']['output'];
  sections: Array<TaskCampaignsHomepageTutorialSection>;
  viewStreaksUrl: Scalars['String']['output'];
}

export interface TaskCampaignsHomepageTutorialSection {
  __typename: 'TaskCampaignsHomepageTutorialSection';
  description: Scalars['String']['output'];
  iconUrl: Scalars['String']['output'];
  slug: Scalars['String']['output'];
  title: Scalars['String']['output'];
}

/** Task Config */
export interface TaskConfig {
  __typename: 'TaskConfig';
  /** The `my_tasks` field cannot be nested within a list. */
  myTasks: TaskInterfaceConnection;
}


/** Task Config */
export interface TaskConfigmyTasksArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
}

export const TaskGenre = {
  AFFILIATE: 'AFFILIATE',
  COLLECTION: 'COLLECTION',
  COMMON_GAME_DAILY_ACTION: 'COMMON_GAME_DAILY_ACTION',
  COMMON_GAME_DAILY_ACTION_GROUP: 'COMMON_GAME_DAILY_ACTION_GROUP',
  COMMON_GAME_DAILY_CLAIM: 'COMMON_GAME_DAILY_CLAIM',
  COMMON_GAME_DROP_CHALLENGE: 'COMMON_GAME_DROP_CHALLENGE',
  COMMON_GAME_STAR_PACK: 'COMMON_GAME_STAR_PACK',
  DAILY_WHEEL_TICKET: 'DAILY_WHEEL_TICKET',
  FANTASY: 'FANTASY',
  FOOTBALL_COMMON_END_OF_SEASON_2024: 'FOOTBALL_COMMON_END_OF_SEASON_2024',
  HOT_STREAK: 'HOT_STREAK',
  INBOX: 'INBOX',
  MARKET: 'MARKET',
  MLB_COMPOSE_TEAM: 'MLB_COMPOSE_TEAM',
  ONBOARDING_BEST_OF_EUROPE: 'ONBOARDING_BEST_OF_EUROPE',
  ONBOARDING_COMMON_GAME: 'ONBOARDING_COMMON_GAME',
  ONBOARDING_COMPOSE_FIRST_TEAM: 'ONBOARDING_COMPOSE_FIRST_TEAM',
  ONBOARDING_F2P: 'ONBOARDING_F2P',
  ORGANIC: 'ORGANIC',
  PLAYOFFS_COMPOSE_TEAM: 'PLAYOFFS_COMPOSE_TEAM',
  REFEREE: 'REFEREE',
  REFERRER: 'REFERRER',
  RIVALS: 'RIVALS',
  SET_BOUGHT_PACKS: 'SET_BOUGHT_PACKS',
  SET_CROSS_SPORT_ONBOARDING: 'SET_CROSS_SPORT_ONBOARDING',
  SET_DAILY_REWARDS: 'SET_DAILY_REWARDS',
  SET_END_OF_SEASON: 'SET_END_OF_SEASON',
  SET_ONBOARDING: 'SET_ONBOARDING',
  SET_PLAY: 'SET_PLAY',
  SET_PLAY_GET_STARTED: 'SET_PLAY_GET_STARTED',
  SET_RAFFLE: 'SET_RAFFLE',
  SQUADS: 'SQUADS'
} as const;

export type TaskGenre = typeof TaskGenre[keyof typeof TaskGenre];
/** Task Group */
export interface TaskGroup {
  __typename: 'TaskGroup';
  /** The `campaigns` field cannot be nested within a list. */
  campaigns: Array<TaskCampaign>;
  myTasks: Array<CardsCountTargetTask | CardsCountTask | CompleteCollectionsCountTargetTask | CompleteCollectionsCountTask | DailyActionTask | DecisivePlayerPickerTask | DropChallengeTask | GameWeeklyTask | GuessTheScoreTask | InviteTaskAsReferrer | So5LeaderboardTask | StarPackTask | Task | TasksTrack | ThresholdPickerTask | ThresholdsDuoConnectionTask | ThresholdsStreakAdditionalLineupTask | ThresholdsStreakTask>;
  slug: Scalars['String']['output'];
  totalRewardConfigs: Array<CardPacksRewardConfig | CardRewardConfig | CardShardRewardConfig | CoinRewardConfig | ConversionCreditRewardConfig | DeliverableItemRewardConfig | ExperienceRewardConfig | InGameCurrencyRewardConfig | MonetaryRewardConfig | ProbabilisticBundleRewardConfig | ShopItemRewardConfig>;
}


/** Task Group */
export interface TaskGroupcampaignsArgs {
  rarity?: InputMaybe<Rarity>;
  sport: Sport;
}


/** Task Group */
export interface TaskGroupmyTasksArgs {
  includingArchived?: InputMaybe<Scalars['Boolean']['input']>;
  rarity?: InputMaybe<Rarity>;
  sport: Sport;
  taskConfigSlug?: InputMaybe<Scalars['String']['input']>;
}


/** Task Group */
export interface TaskGrouptotalRewardConfigsArgs {
  highestConfigByType?: InputMaybe<Scalars['Boolean']['input']>;
  sport: Sport;
}

/** Manager Task */
export interface TaskInterface {
  aasmState: ManagerProgressionTaskState;
  alternativeRewardConfigs?: Maybe<Array<AlternativeRewardConfig>>;
  /** @deprecated Not used anymore */
  cards: Array<BaseballCard | Card | NBACard>;
  claimableAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** @deprecated Not used anymore */
  claimedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  color?: Maybe<Scalars['String']['output']>;
  completedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  description: Scalars['String']['output'];
  expired: Scalars['Boolean']['output'];
  genre: TaskGenre;
  group?: Maybe<TaskGroup>;
  iconUrl?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  jonumGated: Scalars['Boolean']['output'];
  /** The points this task earned on a ladder leaderboard, empty when it feeds none. */
  ladderContributions: Array<LadderContribution>;
  /** The `my_reward_pool_shares` field cannot be nested within a list. */
  myRewardPoolShares?: Maybe<Array<RewardPoolShare>>;
  name: ManagerProgressionTaskSlug;
  parentTask?: Maybe<CardsCountTargetTask | CardsCountTask | CompleteCollectionsCountTargetTask | CompleteCollectionsCountTask | DailyActionTask | DecisivePlayerPickerTask | DropChallengeTask | GameWeeklyTask | GuessTheScoreTask | InviteTaskAsReferrer | So5LeaderboardTask | StarPackTask | Task | TasksTrack | ThresholdPickerTask | ThresholdsDuoConnectionTask | ThresholdsStreakAdditionalLineupTask | ThresholdsStreakTask>;
  periodicity?: Maybe<ManagerTaskPeriodicity>;
  pickOrList: Scalars['Boolean']['output'];
  possibleRewardConfigsIconUrl?: Maybe<Scalars['String']['output']>;
  /** @deprecated Not used anymore */
  probabilisticBundles: Array<ProbabilisticBundle>;
  progress: Scalars['Int']['output'];
  rarity?: Maybe<Rarity>;
  rewardConfigs: Array<CardPacksRewardConfig | CardRewardConfig | CardShardRewardConfig | CoinRewardConfig | ConversionCreditRewardConfig | DeliverableItemRewardConfig | ExperienceRewardConfig | InGameCurrencyRewardConfig | MonetaryRewardConfig | ProbabilisticBundleRewardConfig | ShopItemRewardConfig>;
  /** The `reward_pool_shares` field cannot be nested within a list. */
  rewardPoolShares?: Maybe<RewardPoolShareConnection>;
  startDate?: Maybe<Scalars['ISO8601DateTime']['output']>;
  target: Scalars['Int']['output'];
  taskConfigSlug: Scalars['String']['output'];
  templateIconUrl: Scalars['String']['output'];
  title: Scalars['String']['output'];
  uncapped: Scalars['Boolean']['output'];
}


/** Manager Task */
export interface TaskInterfacecolorArgs {
  variant?: InputMaybe<ColorVariant>;
}


/** Manager Task */
export interface TaskInterfacerewardConfigsArgs {
  mergedConfigsByType?: InputMaybe<Scalars['Boolean']['input']>;
}


/** Manager Task */
export interface TaskInterfacerewardPoolSharesArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
}

/** The connection type for TaskInterface. */
export interface TaskInterfaceConnection {
  __typename: 'TaskInterfaceConnection';
  /** A list of edges. */
  edges: Array<TaskInterfaceEdge>;
  /** A list of nodes. */
  nodes: Array<CardsCountTargetTask | CardsCountTask | CompleteCollectionsCountTargetTask | CompleteCollectionsCountTask | DailyActionTask | DecisivePlayerPickerTask | DropChallengeTask | GameWeeklyTask | GuessTheScoreTask | InviteTaskAsReferrer | So5LeaderboardTask | StarPackTask | Task | TasksTrack | ThresholdPickerTask | ThresholdsDuoConnectionTask | ThresholdsStreakAdditionalLineupTask | ThresholdsStreakTask>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
}

/** An edge in a connection. */
export interface TaskInterfaceEdge {
  __typename: 'TaskInterfaceEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<CardsCountTargetTask | CardsCountTask | CompleteCollectionsCountTargetTask | CompleteCollectionsCountTask | DailyActionTask | DecisivePlayerPickerTask | DropChallengeTask | GameWeeklyTask | GuessTheScoreTask | InviteTaskAsReferrer | So5LeaderboardTask | StarPackTask | Task | TasksTrack | ThresholdPickerTask | ThresholdsDuoConnectionTask | ThresholdsStreakAdditionalLineupTask | ThresholdsStreakTask>;
}

/** Task Lineup */
export interface TaskLineup extends LineupInterface, TaskLineupInterface {
  __typename: 'TaskLineup';
  aasmState: TaskLineupType;
  board?: Maybe<CareerBoard | SquadBoard>;
  bonusPoints?: Maybe<Scalars['Float']['output']>;
  bonusRating?: Maybe<BonusOrdinalRatingEnum>;
  bonuses: Array<So5ActiveClubsBonus | So5AverageScoresBonus | So5BoostBonus | So5CaptainBonus | So5CollectionBonus | So5DifferentNationalitiesBonus | So5GradeBonus | So5LineupBonus | So5MalusAfterTransferBonus | So5NationalityBonus | So5PlayerBonus | So5PositionBonus | So5PositionStacksBonus | So5SameActiveClubBonus | So5ScarcityBonus | So5SeasonBonus | So5SpecialEditionCardsBonus>;
  cancelledAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  cancelledReason?: Maybe<Scalars['String']['output']>;
  confirmable: Scalars['Boolean']['output'];
  deletable: Scalars['Boolean']['output'];
  draft: Scalars['Boolean']['output'];
  forfeitable: Scalars['Boolean']['output'];
  hasLiveGames: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  rewardMultiplier: Scalars['Float']['output'];
  score: Scalars['Float']['output'];
  /** Whether the current user can share this lineup */
  shareable: Scalars['Boolean']['output'];
  /** Whether the current user already shared this lineup */
  shared: Scalars['Boolean']['output'];
  step?: Maybe<CareerProStep | CareerStep | SquadStep>;
  taskAppearances: Array<DecisivePlayerPickerTaskAppearance | TaskAppearance | ThresholdPickerTaskAppearance>;
  updatable: Scalars['Boolean']['output'];
  user: User;
}


/** Task Lineup */
export interface TaskLineupbonusesArgs {
  highlighted?: InputMaybe<Scalars['Boolean']['input']>;
}

/** Lineup interface */
export interface TaskLineupInterface {
  aasmState: TaskLineupType;
  board?: Maybe<CareerBoard | SquadBoard>;
  bonusPoints?: Maybe<Scalars['Float']['output']>;
  bonusRating?: Maybe<BonusOrdinalRatingEnum>;
  bonuses: Array<So5ActiveClubsBonus | So5AverageScoresBonus | So5BoostBonus | So5CaptainBonus | So5CollectionBonus | So5DifferentNationalitiesBonus | So5GradeBonus | So5LineupBonus | So5MalusAfterTransferBonus | So5NationalityBonus | So5PlayerBonus | So5PositionBonus | So5PositionStacksBonus | So5SameActiveClubBonus | So5ScarcityBonus | So5SeasonBonus | So5SpecialEditionCardsBonus>;
  cancelledAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  cancelledReason?: Maybe<Scalars['String']['output']>;
  confirmable: Scalars['Boolean']['output'];
  deletable: Scalars['Boolean']['output'];
  draft: Scalars['Boolean']['output'];
  forfeitable: Scalars['Boolean']['output'];
  hasLiveGames: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  rewardMultiplier: Scalars['Float']['output'];
  score: Scalars['Float']['output'];
  /** Whether the current user can share this lineup */
  shareable: Scalars['Boolean']['output'];
  /** Whether the current user already shared this lineup */
  shared: Scalars['Boolean']['output'];
  step?: Maybe<CareerProStep | CareerStep | SquadStep>;
  taskAppearances: Array<DecisivePlayerPickerTaskAppearance | TaskAppearance | ThresholdPickerTaskAppearance>;
  updatable: Scalars['Boolean']['output'];
  user: User;
}


/** Lineup interface */
export interface TaskLineupInterfacebonusesArgs {
  highlighted?: InputMaybe<Scalars['Boolean']['input']>;
}

export const TaskLineupType = {
  CANCELLED: 'CANCELLED',
  EXPIRED: 'EXPIRED',
  FAILED: 'FAILED',
  READY: 'READY',
  SUCCESSFUL: 'SUCCESSFUL'
} as const;

export type TaskLineupType = typeof TaskLineupType[keyof typeof TaskLineupType];
/** A user notification regarding a task. */
export interface TaskNotification extends Node, NotificationInterface {
  __typename: 'TaskNotification';
  body: Scalars['String']['output'];
  createdAt: Scalars['ISO8601DateTime']['output'];
  deeplinkUrl: Scalars['String']['output'];
  iconUrl: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  important: Scalars['Boolean']['output'];
  markdownBody: Scalars['String']['output'];
  name: Scalars['String']['output'];
  pictureUrl?: Maybe<Scalars['String']['output']>;
  read: Scalars['Boolean']['output'];
  sport?: Maybe<SportOrShared>;
  task: CardsCountTargetTask | CardsCountTask | CompleteCollectionsCountTargetTask | CompleteCollectionsCountTask | DailyActionTask | DecisivePlayerPickerTask | DropChallengeTask | GameWeeklyTask | GuessTheScoreTask | InviteTaskAsReferrer | So5LeaderboardTask | StarPackTask | Task | TasksTrack | ThresholdPickerTask | ThresholdsDuoConnectionTask | ThresholdsStreakAdditionalLineupTask | ThresholdsStreakTask;
  title: Scalars['String']['output'];
  user: CurrentUser;
}

/** A draft lineup prepared for the next step of a tasks track */
export interface TaskPreparedLineup extends Node {
  __typename: 'TaskPreparedLineup';
  aasmState: TaskPreparedLineupState;
  carryOver: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  position: Scalars['Int']['output'];
  submissionAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  submissionError?: Maybe<Scalars['String']['output']>;
  submittedTaskLineup?: Maybe<GuessTheScoreTaskLineup | TaskLineup | ThresholdPickerTaskLineup>;
  taskAppearances: Array<DecisivePlayerPickerTaskAppearance | TaskAppearance | ThresholdPickerTaskAppearance>;
}

export const TaskPreparedLineupState = {
  CANCELLED: 'CANCELLED',
  PENDING: 'PENDING',
  SUBMITTED: 'SUBMITTED'
} as const;

export type TaskPreparedLineupState = typeof TaskPreparedLineupState[keyof typeof TaskPreparedLineupState];
export interface TaskSource extends HistoryTransactionInterface {
  __typename: 'TaskSource';
  date: Scalars['ISO8601DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  label: Scalars['String']['output'];
  logoUrl?: Maybe<Scalars['String']['output']>;
  quantityByFlavour: Array<PoolKeyShardsCount>;
  totalQuantity: Scalars['Int']['output'];
}

/** Task Stat Threshold */
export interface TaskStatThreshold {
  __typename: 'TaskStatThreshold';
  color: Scalars['String']['output'];
  min: Scalars['Int']['output'];
  rewardConfigs: Array<CardPacksRewardConfig | CardRewardConfig | CardShardRewardConfig | CoinRewardConfig | ConversionCreditRewardConfig | DeliverableItemRewardConfig | ExperienceRewardConfig | InGameCurrencyRewardConfig | MonetaryRewardConfig | ProbabilisticBundleRewardConfig | ShopItemRewardConfig>;
  stat: Scalars['String']['output'];
}

/** Tasks Track */
export interface TasksTrack extends ManagerTaskInterface, TaskInterface {
  __typename: 'TasksTrack';
  aasmState: ManagerProgressionTaskState;
  alternativeRewardConfigs?: Maybe<Array<AlternativeRewardConfig>>;
  /**
   * The background of the track: the So5 competition one when the track targets a
   * single competition, the card set branding one otherwise.
   */
  backgroundUrl?: Maybe<Scalars['String']['output']>;
  /** @deprecated Not used anymore */
  cards: Array<BaseballCard | Card | NBACard>;
  /** Whether new prepared lineups of the track are carried over to the following step */
  carryOverPreparedLineups: Scalars['Boolean']['output'];
  claimableAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** @deprecated Not used anymore */
  claimedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  color?: Maybe<Scalars['String']['output']>;
  completedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** The user the track is connected to. */
  connectedUser?: Maybe<User>;
  /**
   * The first completed step, or the first ready step if none are completed. When
   * all steps are claimed, returns the last step; otherwise falls back to the first step.
   */
  currentStep?: Maybe<CardsCountTargetTask | CardsCountTask | CompleteCollectionsCountTargetTask | CompleteCollectionsCountTask | DailyActionTask | DecisivePlayerPickerTask | DropChallengeTask | GameWeeklyTask | GuessTheScoreTask | InviteTaskAsReferrer | So5LeaderboardTask | StarPackTask | Task | TasksTrack | ThresholdPickerTask | ThresholdsDuoConnectionTask | ThresholdsStreakAdditionalLineupTask | ThresholdsStreakTask>;
  description: Scalars['String']['output'];
  endDate?: Maybe<Scalars['ISO8601DateTime']['output']>;
  expired: Scalars['Boolean']['output'];
  /**
   * The run of the ladder this board contributes to that the manager should be
   * shown: the most recent one holding a reward left to claim, or the most recent
   * run when there is none. Null when the board contributes to no ladder.
   */
  featuredLadderLeaderboard?: Maybe<LadderLeaderboard>;
  genre: TaskGenre;
  group?: Maybe<TaskGroup>;
  iconUrl?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  jonumGated: Scalars['Boolean']['output'];
  /** The points this task earned on a ladder leaderboard, empty when it feeds none. */
  ladderContributions: Array<LadderContribution>;
  /**
   * Every run of the ladder this board contributes to, most recent first. The
   * `ladder_leaderboards` field cannot be nested within a list.
   */
  ladderLeaderboards: LadderLeaderboardConnection;
  /** @deprecated Renamed to featuredLadderLeaderboard, which prefers a run with a reward to claim. */
  latestLadderLeaderboard?: Maybe<LadderLeaderboard>;
  /** The `my_reward_pool_shares` field cannot be nested within a list. */
  myRewardPoolShares?: Maybe<Array<RewardPoolShare>>;
  name: ManagerProgressionTaskSlug;
  parentTask?: Maybe<CardsCountTargetTask | CardsCountTask | CompleteCollectionsCountTargetTask | CompleteCollectionsCountTask | DailyActionTask | DecisivePlayerPickerTask | DropChallengeTask | GameWeeklyTask | GuessTheScoreTask | InviteTaskAsReferrer | So5LeaderboardTask | StarPackTask | Task | TasksTrack | ThresholdPickerTask | ThresholdsDuoConnectionTask | ThresholdsStreakAdditionalLineupTask | ThresholdsStreakTask>;
  periodicity?: Maybe<ManagerTaskPeriodicity>;
  pickOrList: Scalars['Boolean']['output'];
  possibleRewardConfigsIconUrl?: Maybe<Scalars['String']['output']>;
  /** @deprecated Not used anymore */
  probabilisticBundles: Array<ProbabilisticBundle>;
  progress: Scalars['Int']['output'];
  rarity?: Maybe<Rarity>;
  restartable: Scalars['Boolean']['output'];
  rewardConfigs: Array<CardPacksRewardConfig | CardRewardConfig | CardShardRewardConfig | CoinRewardConfig | ConversionCreditRewardConfig | DeliverableItemRewardConfig | ExperienceRewardConfig | InGameCurrencyRewardConfig | MonetaryRewardConfig | ProbabilisticBundleRewardConfig | ShopItemRewardConfig>;
  /** The `reward_pool_shares` field cannot be nested within a list. */
  rewardPoolShares?: Maybe<RewardPoolShareConnection>;
  startDate?: Maybe<Scalars['ISO8601DateTime']['output']>;
  steps: Array<CardsCountTargetTask | CardsCountTask | CompleteCollectionsCountTargetTask | CompleteCollectionsCountTask | DailyActionTask | DecisivePlayerPickerTask | DropChallengeTask | GameWeeklyTask | GuessTheScoreTask | InviteTaskAsReferrer | So5LeaderboardTask | StarPackTask | Task | TasksTrack | ThresholdPickerTask | ThresholdsDuoConnectionTask | ThresholdsStreakAdditionalLineupTask | ThresholdsStreakTask>;
  target: Scalars['Int']['output'];
  taskConfigSlug: Scalars['String']['output'];
  templateIconUrl: Scalars['String']['output'];
  title: Scalars['String']['output'];
  uncapped: Scalars['Boolean']['output'];
  /** The task unlocked on completing this track. */
  unlockableTask?: Maybe<CardsCountTargetTask | CardsCountTask | CompleteCollectionsCountTargetTask | CompleteCollectionsCountTask | DailyActionTask | DecisivePlayerPickerTask | DropChallengeTask | GameWeeklyTask | GuessTheScoreTask | InviteTaskAsReferrer | So5LeaderboardTask | StarPackTask | Task | TasksTrack | ThresholdPickerTask | ThresholdsDuoConnectionTask | ThresholdsStreakAdditionalLineupTask | ThresholdsStreakTask>;
}


/** Tasks Track */
export interface TasksTrackbackgroundUrlArgs {
  variant?: InputMaybe<AssetVariant>;
}


/** Tasks Track */
export interface TasksTrackcolorArgs {
  variant?: InputMaybe<ColorVariant>;
}


/** Tasks Track */
export interface TasksTrackladderLeaderboardsArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
}


/** Tasks Track */
export interface TasksTrackrewardConfigsArgs {
  mergedConfigsByType?: InputMaybe<Scalars['Boolean']['input']>;
}


/** Tasks Track */
export interface TasksTrackrewardPoolSharesArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
}

/** Object that can be a team */
export type Team = Club | NationalTeam;

/** A representation of team formation for a specific game */
export interface TeamFormation {
  __typename: 'TeamFormation';
  bench: Array<Player>;
  startingLineup: Array<Array<Player>>;
  startingLineupAvailable: Scalars['Boolean']['output'];
}

export interface TeamGameStatsInterface {
  decisiveEvents: Array<FootballGoalEvent | FootballSanctionCardEvent | SubstitutionEvent>;
  id: Scalars['ID']['output'];
  stats?: Maybe<Array<SportStat>>;
}

export interface TeamInterface {
  activeCompetitions: Array<Competition>;
  /** The `active_memberships` field cannot be nested within a list. */
  activeMemberships: MembershipConnection;
  /** The `active_players` field cannot be nested within a list. */
  activePlayers: PlayerConnection;
  /** The `any_active_players` field cannot be nested within a list. */
  anyActivePlayers: AnyPlayerInterfaceConnection;
  /** The `any_cards` field cannot be nested within a list. */
  anyCards: AnyCardInterfaceConnection;
  /** The `any_games` field cannot be nested within a list. */
  anyGames: AnyGameInterfaceConnection;
  /** The `any_players` field cannot be nested within a list. */
  anyPlayers: AnyPlayerInterfaceConnection;
  /** The `any_recent_departures` field cannot be nested within a list. */
  anyRecentDepartures: AnyPlayerInterfaceConnection;
  code?: Maybe<Scalars['String']['output']>;
  country: Country;
  currentUserSubscription?: Maybe<EmailSubscription>;
  dataPartner?: Maybe<DataPartner>;
  founded?: Maybe<Scalars['String']['output']>;
  /** The `games` field cannot be nested within a list. */
  games: GameConnection;
  id: Scalars['ID']['output'];
  lastFiveAnyGames: Array<Game | GameOfBaseball | GameOfBasketball>;
  lastFiveGames: Array<Game>;
  /** The `latest_any_games` field cannot be nested within a list. */
  latestAnyGames: AnyGameInterfaceConnection;
  /** The `latest_games` field cannot be nested within a list. */
  latestGames: GameConnection;
  name: Scalars['String']['output'];
  officialName: Scalars['String']['output'];
  optaId?: Maybe<Scalars['String']['output']>;
  pictureSecondaryUrl?: Maybe<Scalars['String']['output']>;
  pictureUrl?: Maybe<Scalars['String']['output']>;
  /** The `players` field cannot be nested within a list. */
  players: PlayerConnection;
  ready: Scalars['Boolean']['output'];
  /** The `recent_departures` field cannot be nested within a list. */
  recentDepartures: PlayerConnection;
  shortName: Scalars['String']['output'];
  slug: Scalars['String']['output'];
  styleGuideColor?: Maybe<Scalars['String']['output']>;
  subscriptionsCount: Scalars['Int']['output'];
  upcomingAnyGames: Array<Maybe<Game | GameOfBaseball | GameOfBasketball>>;
  upcomingGames: Array<Maybe<Game>>;
  withSellablePlayers: Scalars['Boolean']['output'];
}


export interface TeamInterfaceactiveMembershipsArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
}


export interface TeamInterfaceactivePlayersArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
}


export interface TeamInterfaceanyActivePlayersArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
}


export interface TeamInterfaceanyCardsArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  age?: InputMaybe<Scalars['Int']['input']>;
  assetIds?: InputMaybe<Array<Scalars['String']['input']>>;
  before?: InputMaybe<Scalars['String']['input']>;
  classicOnly?: InputMaybe<Scalars['Boolean']['input']>;
  customCardEditionName?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  inActiveCompetitions?: InputMaybe<Array<Scalars['String']['input']>>;
  inSeasonEligible?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  owned?: InputMaybe<Scalars['Boolean']['input']>;
  ownedByMe?: InputMaybe<Scalars['Boolean']['input']>;
  ownedSinceAfter?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  playerSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  positions?: InputMaybe<Array<Position>>;
  rarities?: InputMaybe<Array<Rarity>>;
  revealable?: InputMaybe<Scalars['Boolean']['input']>;
  seasonStartYears?: InputMaybe<Array<Scalars['Int']['input']>>;
  serialNumber?: InputMaybe<Scalars['Int']['input']>;
  shirtNumber?: InputMaybe<Scalars['Int']['input']>;
  slugs?: InputMaybe<Array<Scalars['String']['input']>>;
  sorts?: InputMaybe<Array<CardSort>>;
  sport?: InputMaybe<Sport>;
  teamSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  withinDeckFirst?: InputMaybe<Scalars['String']['input']>;
}


export interface TeamInterfaceanyGamesArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  endDate: Scalars['ISO8601DateTime']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  startDate: Scalars['ISO8601DateTime']['input'];
}


export interface TeamInterfaceanyPlayersArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
}


export interface TeamInterfaceanyRecentDeparturesArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
}


export interface TeamInterfacegamesArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  endDate: Scalars['ISO8601DateTime']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  startDate: Scalars['ISO8601DateTime']['input'];
}


export interface TeamInterfacelatestAnyGamesArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  includingLive?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
}


export interface TeamInterfacelatestGamesArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  includingLive?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
}


export interface TeamInterfacepictureUrlArgs {
  derivative?: InputMaybe<Scalars['String']['input']>;
}


export interface TeamInterfaceplayersArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
}


export interface TeamInterfacerecentDeparturesArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
}


export interface TeamInterfaceupcomingAnyGamesArgs {
  first: Scalars['Int']['input'];
}


export interface TeamInterfaceupcomingGamesArgs {
  first: Scalars['Int']['input'];
}


export interface TeamInterfacewithSellablePlayersArgs {
  withSingleSales?: InputMaybe<Scalars['Boolean']['input']>;
}

/** The connection type for TeamInterface. */
export interface TeamInterfaceConnection {
  __typename: 'TeamInterfaceConnection';
  /** A list of edges. */
  edges: Array<TeamInterfaceEdge>;
  /** A list of nodes. */
  nodes: Array<Club | NationalTeam>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
}

/** An edge in a connection. */
export interface TeamInterfaceEdge {
  __typename: 'TeamInterfaceEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<Club | NationalTeam>;
}

export interface TeamVariantStock {
  __typename: 'TeamVariantStock';
  id: Scalars['String']['output'];
  outOfStock: Scalars['Boolean']['output'];
  team: Team;
}

/** Teams playing in the upcoming So5 Fixture */
export interface TeamsPlayingNextGameWeek {
  __typename: 'TeamsPlayingNextGameWeek';
  endDate: Scalars['ISO8601DateTime']['output'];
  gameWeek: Scalars['Int']['output'];
  longDisplayName: Scalars['String']['output'];
  shortDisplayName: Scalars['String']['output'];
  slug: Scalars['String']['output'];
  startDate: Scalars['ISO8601DateTime']['output'];
  teamSlugs: Array<Scalars['String']['output']>;
}

export const TermsAndConditionsStatus = {
  /** Has approved the latest TCUs */
  ACCEPTED: 'ACCEPTED',
  /** Has never approved any TCUs */
  INITIAL: 'INITIAL',
  /** Has approved TCUs but those are now outdated */
  OUTDATED: 'OUTDATED'
} as const;

export type TermsAndConditionsStatus = typeof TermsAndConditionsStatus[keyof typeof TermsAndConditionsStatus];
/** A three dimensional asset */
export interface ThreeDimensionalAsset {
  __typename: 'ThreeDimensionalAsset';
  backNormalUrl: Scalars['String']['output'];
  backUrl: Scalars['String']['output'];
  caseUsdzUrl?: Maybe<Scalars['String']['output']>;
  frontNormalUrl: Scalars['String']['output'];
  frontUrl: Scalars['String']['output'];
  gltfUrl: Scalars['String']['output'];
}

/** Represents a three dimensional card layout */
export interface ThreeDimensionalCardLayout {
  __typename: 'ThreeDimensionalCardLayout';
  backgroundNormalUrl?: Maybe<Scalars['String']['output']>;
}

/** Threshold Picker Task */
export interface ThresholdPickerTask extends ManagerTaskInterface, TaskInterface, WithComposeTeamInterface {
  __typename: 'ThresholdPickerTask';
  aasmState: ManagerProgressionTaskState;
  alternativeRewardConfigs?: Maybe<Array<AlternativeRewardConfig>>;
  averageMode: Scalars['Boolean']['output'];
  canPrepareLineups: Scalars['Boolean']['output'];
  /** @deprecated Not used anymore */
  cards: Array<BaseballCard | Card | NBACard>;
  claimableAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** @deprecated Not used anymore */
  claimedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Whether some appearances are filled by a contributor rather than the lineup owner. */
  collaborative: Scalars['Boolean']['output'];
  color?: Maybe<Scalars['String']['output']>;
  completedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  defaultSortType: BenchSort;
  description: Scalars['String']['output'];
  displayedPlayer?: Maybe<BaseballPlayer | NBAPlayer | Player>;
  displayedTypedRules: Array<CardsCountAsFirstOwnerRule | OwnedSinceRule | PlayerHeightRule | SeasonsRule | So5ActiveClubsRule | So5ActiveNationalTeamsRule | So5AgeRule | So5AppearancesRule | So5AtLeastOfClubs | So5AtLeastOfCompetitions | So5AverageScoresRule | So5CaptainRule | So5CaptainScarcityRule | So5CardEditionsCountRule | So5CompetitionsRule | So5EntryItemRule | So5MaximumPlayersAverageScoreRule | So5MinimumPlayersAverageScoreRule | So5NationalityRule | So5NotNationalityRule | So5SameActiveClubRule | So5ScarcityRule | So5SeasonBonusRule | VaultPointsRule>;
  engineConfiguration: EngineConfiguration;
  expirationProgressBasisPoints?: Maybe<Scalars['Int']['output']>;
  expired: Scalars['Boolean']['output'];
  expiresAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  forfeitable: Scalars['Boolean']['output'];
  genre: TaskGenre;
  group?: Maybe<TaskGroup>;
  /** The `highlighted_recommendations` field cannot be nested within a list. */
  highlightedRecommendations: Array<PlayerRecommendation>;
  iconUrl?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  jonumGated: Scalars['Boolean']['output'];
  /** The points this task earned on a ladder leaderboard, empty when it feeds none. */
  ladderContributions: Array<LadderContribution>;
  /** @deprecated Use forfeitable instead */
  lineupForfeitable: Scalars['Boolean']['output'];
  lockedLineupsCount: Scalars['Int']['output'];
  maxLineupsCount: Scalars['Int']['output'];
  /** The `my_filtered_bench` field cannot be nested within a list. */
  myFilteredBench: ComposeTeamBenchObjectInterfaceConnection;
  myLineups: Array<GuessTheScoreTaskLineup | So5Lineup | TaskLineup | ThresholdPickerTaskLineup>;
  /** The `my_reward_pool_shares` field cannot be nested within a list. */
  myRewardPoolShares?: Maybe<Array<RewardPoolShare>>;
  name: ManagerProgressionTaskSlug;
  /** The `next_pickable_game` field cannot be nested within a list. */
  nextPickableGame?: Maybe<GameWithCardsPreview>;
  parentTask?: Maybe<CardsCountTargetTask | CardsCountTask | CompleteCollectionsCountTargetTask | CompleteCollectionsCountTask | DailyActionTask | DecisivePlayerPickerTask | DropChallengeTask | GameWeeklyTask | GuessTheScoreTask | InviteTaskAsReferrer | So5LeaderboardTask | StarPackTask | Task | TasksTrack | ThresholdPickerTask | ThresholdsDuoConnectionTask | ThresholdsStreakAdditionalLineupTask | ThresholdsStreakTask>;
  pendingLineupsCount: Scalars['Int']['output'];
  periodicity?: Maybe<ManagerTaskPeriodicity>;
  pickOrList: Scalars['Boolean']['output'];
  pickableDays: GameDayConnection;
  /** The `pickable_games` field cannot be nested within a list. */
  pickableGames: GameWithCardsPreviewConnection;
  possibleBenchSortingTypes: Array<SortingType>;
  possibleRewardConfigsIconUrl?: Maybe<Scalars['String']['output']>;
  postSnapshotCompletionProbability?: Maybe<PostSnapshotCompletionProbability>;
  previewSo5Lineup: ComposeTeamLineupPreview;
  /** @deprecated Not used anymore */
  probabilisticBundles: Array<ProbabilisticBundle>;
  progress: Scalars['Int']['output'];
  rarity?: Maybe<Rarity>;
  remainingLineupsCount: Scalars['Int']['output'];
  /** @deprecated Use averageMode instead */
  replay: Scalars['Boolean']['output'];
  rewardConfigs: Array<CardPacksRewardConfig | CardRewardConfig | CardShardRewardConfig | CoinRewardConfig | ConversionCreditRewardConfig | DeliverableItemRewardConfig | ExperienceRewardConfig | InGameCurrencyRewardConfig | MonetaryRewardConfig | ProbabilisticBundleRewardConfig | ShopItemRewardConfig>;
  rewardMultiplierConfiguration?: Maybe<RewardMultiplierConfiguration>;
  /** The `reward_pool_shares` field cannot be nested within a list. */
  rewardPoolShares?: Maybe<RewardPoolShareConnection>;
  so5Competition?: Maybe<So5Competition>;
  stadiumUrl?: Maybe<Scalars['String']['output']>;
  startDate?: Maybe<Scalars['ISO8601DateTime']['output']>;
  target: Scalars['Int']['output'];
  taskConfigSlug: Scalars['String']['output'];
  taskLineups: Array<ThresholdPickerTaskLineup>;
  taskPreparedLineups: Array<TaskPreparedLineup>;
  templateIconUrl: Scalars['String']['output'];
  title: Scalars['String']['output'];
  /** The `top_recommendations` field cannot be nested within a list. */
  topRecommendations: Array<PlayerRecommendation>;
  uncapped: Scalars['Boolean']['output'];
  wouldExpireAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
}


/** Threshold Picker Task */
export interface ThresholdPickerTaskcolorArgs {
  variant?: InputMaybe<ColorVariant>;
}


/** Threshold Picker Task */
export interface ThresholdPickerTaskhighlightedRecommendationsArgs {
  positions?: InputMaybe<Array<Position>>;
  recommendationEngine: RecommendationEngine;
  sport: Sport;
}


/** Threshold Picker Task */
export interface ThresholdPickerTaskmyFilteredBenchArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filters: BenchFilterInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  stackByCardData?: InputMaybe<Scalars['Boolean']['input']>;
  topByPosition?: InputMaybe<Scalars['Int']['input']>;
}


/** Threshold Picker Task */
export interface ThresholdPickerTaskpickableDaysArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  timeZone: Scalars['String']['input'];
}


/** Threshold Picker Task */
export interface ThresholdPickerTaskpickableGamesArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  fromDate?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  toDate?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
}


/** Threshold Picker Task */
export interface ThresholdPickerTaskpreviewSo5LineupArgs {
  appearances: Array<So5AppearanceInput>;
}


/** Threshold Picker Task */
export interface ThresholdPickerTaskrewardConfigsArgs {
  mergedConfigsByType?: InputMaybe<Scalars['Boolean']['input']>;
}


/** Threshold Picker Task */
export interface ThresholdPickerTaskrewardPoolSharesArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
}


/** Threshold Picker Task */
export interface ThresholdPickerTasktopRecommendationsArgs {
  filters?: InputMaybe<BenchFilterInput>;
  playingHomeOnly?: InputMaybe<Scalars['Boolean']['input']>;
  positions?: InputMaybe<Array<Position>>;
  query?: InputMaybe<Scalars['String']['input']>;
  recommendationEngine: RecommendationEngine;
  sortType?: InputMaybe<EligibleCardsSort>;
  sport: Sport;
  starterOddsBasisPointsRange?: InputMaybe<RangeInput>;
}

/** Threshold Picker Task Appearance */
export interface ThresholdPickerTaskAppearance extends AppearanceInterface, ComposeTeamBenchObjectInterface, TaskAppearanceInterface {
  __typename: 'ThresholdPickerTaskAppearance';
  activeSuspensions: Array<Suspension>;
  anyCard?: Maybe<BaseballCard | Card | NBACard>;
  anyCardWithLivePrimaryOffer?: Maybe<BaseballCard | Card | NBACard>;
  anyPlayer: BaseballPlayer | NBAPlayer | Player;
  averageScore?: Maybe<Scalars['Float']['output']>;
  bonus?: Maybe<Scalars['Float']['output']>;
  bonusPoints?: Maybe<Scalars['Float']['output']>;
  bonusRating?: Maybe<BonusOrdinalRatingEnum>;
  captain: Scalars['Boolean']['output'];
  card: BaseballCard | Card | NBACard;
  cardBorderRadius: Scalars['Int']['output'];
  completedTask?: Maybe<CardsCountTargetTask | CardsCountTask | CompleteCollectionsCountTargetTask | CompleteCollectionsCountTask | DailyActionTask | DecisivePlayerPickerTask | DropChallengeTask | GameWeeklyTask | GuessTheScoreTask | InviteTaskAsReferrer | So5LeaderboardTask | StarPackTask | Task | TasksTrack | ThresholdPickerTask | ThresholdsDuoConnectionTask | ThresholdsStreakAdditionalLineupTask | ThresholdsStreakTask>;
  contributor?: Maybe<User>;
  eligiblePlayerGameScores: Array<BaseballPlayerGameScore | BasketballPlayerGameScore | PlayerGameScore | So5Score>;
  /**
   * Projected score minus the lowest score of the player star tier for NBA, minus
   * the L10 average otherwise, from the projection the bench sorts
   * GAIN_ON_PROJECTION on: the next game on a card bench with no fixture, the
   * fixture projection otherwise
   */
  gainOnProjection?: Maybe<Scalars['Float']['output']>;
  game?: Maybe<Game | GameOfBaseball | GameOfBasketball>;
  id: Scalars['ID']['output'];
  index: Scalars['Int']['output'];
  licensed: Scalars['Boolean']['output'];
  locked: Scalars['Boolean']['output'];
  /** When a bench object will be locked for a leaderboard */
  lockedAt: Scalars['ISO8601DateTime']['output'];
  /** Wether a bench object can be updated for a leaderboard */
  lockedForLeaderboard: Scalars['Boolean']['output'];
  pictureUrl?: Maybe<Scalars['String']['output']>;
  playedGames: Array<Game | GameOfBaseball | GameOfBasketball>;
  player: Player;
  playerGameScore?: Maybe<BaseballPlayerGameScore | BasketballPlayerGameScore | PlayerGameScore | So5Score>;
  position: Position;
  positions: Array<Position>;
  powerBreakdown: PowerBreakdown;
  /** PowerBreakdown as long as leaderboard is playable. PowerPointsBreakdown after */
  powerBreakdownOrPowerPointsBreakdown?: Maybe<PowerBreakdownOrPowerPointsBreakdown>;
  projectedScore?: Maybe<Scalars['Float']['output']>;
  rarity: Rarity;
  score: Scalars['Float']['output'];
  scoreStatus: ScoreStatus;
  task: CardsCountTargetTask | CardsCountTask | CompleteCollectionsCountTargetTask | CompleteCollectionsCountTask | DailyActionTask | DecisivePlayerPickerTask | DropChallengeTask | GameWeeklyTask | GuessTheScoreTask | InviteTaskAsReferrer | So5LeaderboardTask | StarPackTask | Task | TasksTrack | ThresholdPickerTask | ThresholdsDuoConnectionTask | ThresholdsStreakAdditionalLineupTask | ThresholdsStreakTask;
  upcomingGame?: Maybe<Game | GameOfBaseball | GameOfBasketball>;
  videoUrl?: Maybe<Scalars['String']['output']>;
}


/** Threshold Picker Task Appearance */
export interface ThresholdPickerTaskAppearanceactiveSuspensionsArgs {
  so5LeaderboardSlug?: InputMaybe<Scalars['String']['input']>;
}


/** Threshold Picker Task Appearance */
export interface ThresholdPickerTaskAppearanceanyCardWithLivePrimaryOfferArgs {
  rarity?: InputMaybe<Rarity>;
}


/** Threshold Picker Task Appearance */
export interface ThresholdPickerTaskAppearanceaverageScoreArgs {
  type: AveragePlayerScore;
}


/** Threshold Picker Task Appearance */
export interface ThresholdPickerTaskAppearanceeligiblePlayerGameScoresArgs {
  boardId?: InputMaybe<Scalars['String']['input']>;
  gameId?: InputMaybe<Scalars['ID']['input']>;
  so5LeaderboardSlug?: InputMaybe<Scalars['String']['input']>;
  stepId?: InputMaybe<Scalars['String']['input']>;
  taskId?: InputMaybe<Scalars['ID']['input']>;
}


/** Threshold Picker Task Appearance */
export interface ThresholdPickerTaskAppearancelockedAtArgs {
  so5LeaderboardSlug?: InputMaybe<Scalars['String']['input']>;
}


/** Threshold Picker Task Appearance */
export interface ThresholdPickerTaskAppearancelockedForLeaderboardArgs {
  so5LeaderboardSlug?: InputMaybe<Scalars['String']['input']>;
}


/** Threshold Picker Task Appearance */
export interface ThresholdPickerTaskAppearancepictureUrlArgs {
  derivative?: InputMaybe<Scalars['String']['input']>;
}


/** Threshold Picker Task Appearance */
export interface ThresholdPickerTaskAppearanceprojectedScoreArgs {
  so5LeaderboardSlug: Scalars['String']['input'];
}


/** Threshold Picker Task Appearance */
export interface ThresholdPickerTaskAppearancescoreArgs {
  withBonus?: InputMaybe<Scalars['Boolean']['input']>;
}


/** Threshold Picker Task Appearance */
export interface ThresholdPickerTaskAppearancevideoUrlArgs {
  derivative?: InputMaybe<Scalars['String']['input']>;
}

/** Threshold Picker Task Lineup */
export interface ThresholdPickerTaskLineup extends LineupInterface, TaskLineupInterface {
  __typename: 'ThresholdPickerTaskLineup';
  aasmState: TaskLineupType;
  board?: Maybe<CareerBoard | SquadBoard>;
  bonusPoints?: Maybe<Scalars['Float']['output']>;
  bonusRating?: Maybe<BonusOrdinalRatingEnum>;
  bonuses: Array<So5ActiveClubsBonus | So5AverageScoresBonus | So5BoostBonus | So5CaptainBonus | So5CollectionBonus | So5DifferentNationalitiesBonus | So5GradeBonus | So5LineupBonus | So5MalusAfterTransferBonus | So5NationalityBonus | So5PlayerBonus | So5PositionBonus | So5PositionStacksBonus | So5SameActiveClubBonus | So5ScarcityBonus | So5SeasonBonus | So5SpecialEditionCardsBonus>;
  cancelledAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  cancelledReason?: Maybe<Scalars['String']['output']>;
  confirmable: Scalars['Boolean']['output'];
  deletable: Scalars['Boolean']['output'];
  draft: Scalars['Boolean']['output'];
  forfeitable: Scalars['Boolean']['output'];
  hasLiveGames: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  rewardMultiplier: Scalars['Float']['output'];
  score: Scalars['Float']['output'];
  /** Whether the current user can share this lineup */
  shareable: Scalars['Boolean']['output'];
  /** Whether the current user already shared this lineup */
  shared: Scalars['Boolean']['output'];
  step?: Maybe<CareerProStep | CareerStep | SquadStep>;
  taskAppearances: Array<ThresholdPickerTaskAppearance>;
  updatable: Scalars['Boolean']['output'];
  user: User;
}


/** Threshold Picker Task Lineup */
export interface ThresholdPickerTaskLineupbonusesArgs {
  highlighted?: InputMaybe<Scalars['Boolean']['input']>;
}

export const ThresholdStreakTaskCurrentThresholdState = {
  CLAIMED: 'CLAIMED',
  COMPLETED: 'COMPLETED',
  FAILED: 'FAILED',
  LIVE_LINEUP_HIT: 'LIVE_LINEUP_HIT',
  LIVE_LINEUP_IN_PROGRESS: 'LIVE_LINEUP_IN_PROGRESS',
  LIVE_LINEUP_MISSED: 'LIVE_LINEUP_MISSED',
  LIVE_LINEUP_NOT_SET: 'LIVE_LINEUP_NOT_SET',
  NO_UPCOMING_FIXTURE: 'NO_UPCOMING_FIXTURE',
  UPCOMING_LINEUP_NOT_SET: 'UPCOMING_LINEUP_NOT_SET',
  UPCOMING_LINEUP_SET: 'UPCOMING_LINEUP_SET'
} as const;

export type ThresholdStreakTaskCurrentThresholdState = typeof ThresholdStreakTaskCurrentThresholdState[keyof typeof ThresholdStreakTaskCurrentThresholdState];
export interface ThresholdStreakTaskCurrentThresholdStatus {
  __typename: 'ThresholdStreakTaskCurrentThresholdStatus';
  claimableAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  liveScore?: Maybe<Scalars['Float']['output']>;
  state: ThresholdStreakTaskCurrentThresholdState;
}

/** So5 Threshold Streak Task Threshold */
export interface ThresholdStreakTaskThreshold {
  __typename: 'ThresholdStreakTaskThreshold';
  additionalLineupTasks: Array<ThresholdsStreakAdditionalLineupTask>;
  current: Scalars['Boolean']['output'];
  /** The original value of rewardConfigs outside promotions */
  originalRewardConfigs?: Maybe<Array<CardPacksRewardConfig | CardRewardConfig | CardShardRewardConfig | CoinRewardConfig | ConversionCreditRewardConfig | DeliverableItemRewardConfig | ExperienceRewardConfig | InGameCurrencyRewardConfig | MonetaryRewardConfig | ProbabilisticBundleRewardConfig | ShopItemRewardConfig>>;
  /** The original value of score outside promotions */
  originalScore?: Maybe<Scalars['Int']['output']>;
  /** The original value of uniqueAdditionalLineupRewardConfig outside promotions */
  originalUniqueAdditionalLineupRewardConfig?: Maybe<CardPacksRewardConfig | CardRewardConfig | CardShardRewardConfig | CoinRewardConfig | ConversionCreditRewardConfig | DeliverableItemRewardConfig | ExperienceRewardConfig | InGameCurrencyRewardConfig | MonetaryRewardConfig | ProbabilisticBundleRewardConfig | ShopItemRewardConfig>;
  rewardConfigs: Array<CardPacksRewardConfig | CardRewardConfig | CardShardRewardConfig | CoinRewardConfig | ConversionCreditRewardConfig | DeliverableItemRewardConfig | ExperienceRewardConfig | InGameCurrencyRewardConfig | MonetaryRewardConfig | ProbabilisticBundleRewardConfig | ShopItemRewardConfig>;
  score: Scalars['Int']['output'];
  uniqueAdditionalLineupRewardConfig?: Maybe<CardPacksRewardConfig | CardRewardConfig | CardShardRewardConfig | CoinRewardConfig | ConversionCreditRewardConfig | DeliverableItemRewardConfig | ExperienceRewardConfig | InGameCurrencyRewardConfig | MonetaryRewardConfig | ProbabilisticBundleRewardConfig | ShopItemRewardConfig>;
}

/** Thresholds Duo Connection Task */
export interface ThresholdsDuoConnectionTask extends ManagerTaskInterface, TaskInterface {
  __typename: 'ThresholdsDuoConnectionTask';
  aasmState: ManagerProgressionTaskState;
  alternativeRewardConfigs?: Maybe<Array<AlternativeRewardConfig>>;
  campaign?: Maybe<TaskCampaign>;
  /** @deprecated Not used anymore */
  cards: Array<BaseballCard | Card | NBACard>;
  claimableAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** @deprecated Not used anymore */
  claimedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  color?: Maybe<Scalars['String']['output']>;
  completedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  connectedLineup?: Maybe<So5Lineup>;
  connectedUser: User;
  description: Scalars['String']['output'];
  expired: Scalars['Boolean']['output'];
  genre: TaskGenre;
  group?: Maybe<TaskGroup>;
  iconUrl?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  jonumGated: Scalars['Boolean']['output'];
  /** The points this task earned on a ladder leaderboard, empty when it feeds none. */
  ladderContributions: Array<LadderContribution>;
  myLineup?: Maybe<So5Lineup>;
  /** The `my_reward_pool_shares` field cannot be nested within a list. */
  myRewardPoolShares?: Maybe<Array<RewardPoolShare>>;
  myUser: User;
  name: ManagerProgressionTaskSlug;
  parentTask?: Maybe<CardsCountTargetTask | CardsCountTask | CompleteCollectionsCountTargetTask | CompleteCollectionsCountTask | DailyActionTask | DecisivePlayerPickerTask | DropChallengeTask | GameWeeklyTask | GuessTheScoreTask | InviteTaskAsReferrer | So5LeaderboardTask | StarPackTask | Task | TasksTrack | ThresholdPickerTask | ThresholdsDuoConnectionTask | ThresholdsStreakAdditionalLineupTask | ThresholdsStreakTask>;
  periodicity?: Maybe<ManagerTaskPeriodicity>;
  pickOrList: Scalars['Boolean']['output'];
  possibleRewardConfigsIconUrl?: Maybe<Scalars['String']['output']>;
  /** @deprecated Not used anymore */
  probabilisticBundles: Array<ProbabilisticBundle>;
  progress: Scalars['Int']['output'];
  rarity?: Maybe<Rarity>;
  rewardConfigs: Array<CardPacksRewardConfig | CardRewardConfig | CardShardRewardConfig | CoinRewardConfig | ConversionCreditRewardConfig | DeliverableItemRewardConfig | ExperienceRewardConfig | InGameCurrencyRewardConfig | MonetaryRewardConfig | ProbabilisticBundleRewardConfig | ShopItemRewardConfig>;
  /** The `reward_pool_shares` field cannot be nested within a list. */
  rewardPoolShares?: Maybe<RewardPoolShareConnection>;
  startDate?: Maybe<Scalars['ISO8601DateTime']['output']>;
  target: Scalars['Int']['output'];
  taskConfigSlug: Scalars['String']['output'];
  templateIconUrl: Scalars['String']['output'];
  title: Scalars['String']['output'];
  uncapped: Scalars['Boolean']['output'];
}


/** Thresholds Duo Connection Task */
export interface ThresholdsDuoConnectionTaskcolorArgs {
  variant?: InputMaybe<ColorVariant>;
}


/** Thresholds Duo Connection Task */
export interface ThresholdsDuoConnectionTaskrewardConfigsArgs {
  mergedConfigsByType?: InputMaybe<Scalars['Boolean']['input']>;
}


/** Thresholds Duo Connection Task */
export interface ThresholdsDuoConnectionTaskrewardPoolSharesArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
}

/** So5 Threshold Streak Additional Lineup Task */
export interface ThresholdsStreakAdditionalLineupTask extends ManagerTaskInterface, TaskInterface {
  __typename: 'ThresholdsStreakAdditionalLineupTask';
  aasmState: ManagerProgressionTaskState;
  alternativeRewardConfigs?: Maybe<Array<AlternativeRewardConfig>>;
  /** @deprecated Not used anymore */
  cards: Array<BaseballCard | Card | NBACard>;
  claimableAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** @deprecated Not used anymore */
  claimedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  color?: Maybe<Scalars['String']['output']>;
  completedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  description: Scalars['String']['output'];
  expired: Scalars['Boolean']['output'];
  genre: TaskGenre;
  group?: Maybe<TaskGroup>;
  iconUrl?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  jonumGated: Scalars['Boolean']['output'];
  /** The points this task earned on a ladder leaderboard, empty when it feeds none. */
  ladderContributions: Array<LadderContribution>;
  /** The `my_reward_pool_shares` field cannot be nested within a list. */
  myRewardPoolShares?: Maybe<Array<RewardPoolShare>>;
  name: ManagerProgressionTaskSlug;
  parentTask?: Maybe<CardsCountTargetTask | CardsCountTask | CompleteCollectionsCountTargetTask | CompleteCollectionsCountTask | DailyActionTask | DecisivePlayerPickerTask | DropChallengeTask | GameWeeklyTask | GuessTheScoreTask | InviteTaskAsReferrer | So5LeaderboardTask | StarPackTask | Task | TasksTrack | ThresholdPickerTask | ThresholdsDuoConnectionTask | ThresholdsStreakAdditionalLineupTask | ThresholdsStreakTask>;
  periodicity?: Maybe<ManagerTaskPeriodicity>;
  pickOrList: Scalars['Boolean']['output'];
  possibleRewardConfigsIconUrl?: Maybe<Scalars['String']['output']>;
  /** @deprecated Not used anymore */
  probabilisticBundles: Array<ProbabilisticBundle>;
  progress: Scalars['Int']['output'];
  rarity?: Maybe<Rarity>;
  rewardConfigs: Array<CardPacksRewardConfig | CardRewardConfig | CardShardRewardConfig | CoinRewardConfig | ConversionCreditRewardConfig | DeliverableItemRewardConfig | ExperienceRewardConfig | InGameCurrencyRewardConfig | MonetaryRewardConfig | ProbabilisticBundleRewardConfig | ShopItemRewardConfig>;
  /** The `reward_pool_shares` field cannot be nested within a list. */
  rewardPoolShares?: Maybe<RewardPoolShareConnection>;
  startDate?: Maybe<Scalars['ISO8601DateTime']['output']>;
  target: Scalars['Int']['output'];
  taskConfigSlug: Scalars['String']['output'];
  templateIconUrl: Scalars['String']['output'];
  thresholdsStreakTask: ThresholdsStreakTask;
  title: Scalars['String']['output'];
  uncapped: Scalars['Boolean']['output'];
}


/** So5 Threshold Streak Additional Lineup Task */
export interface ThresholdsStreakAdditionalLineupTaskcolorArgs {
  variant?: InputMaybe<ColorVariant>;
}


/** So5 Threshold Streak Additional Lineup Task */
export interface ThresholdsStreakAdditionalLineupTaskrewardConfigsArgs {
  mergedConfigsByType?: InputMaybe<Scalars['Boolean']['input']>;
}


/** So5 Threshold Streak Additional Lineup Task */
export interface ThresholdsStreakAdditionalLineupTaskrewardPoolSharesArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
}

/** So5 Threshold Streak Task */
export interface ThresholdsStreakTask extends ManagerTaskInterface, TaskInterface {
  __typename: 'ThresholdsStreakTask';
  aasmState: ManagerProgressionTaskState;
  alternativeRewardConfigs?: Maybe<Array<AlternativeRewardConfig>>;
  /** @deprecated Not used anymore */
  cards: Array<BaseballCard | Card | NBACard>;
  claimableAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** @deprecated Not used anymore */
  claimedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  color?: Maybe<Scalars['String']['output']>;
  completedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  completedBy?: Maybe<So5Lineup>;
  currentThreshold: ThresholdStreakTaskThreshold;
  currentThresholdStatus: ThresholdStreakTaskCurrentThresholdStatus;
  description: Scalars['String']['output'];
  engaged: Scalars['Boolean']['output'];
  expired: Scalars['Boolean']['output'];
  genre: TaskGenre;
  group?: Maybe<TaskGroup>;
  iconUrl?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  jonumGated: Scalars['Boolean']['output'];
  /** The points this task earned on a ladder leaderboard, empty when it feeds none. */
  ladderContributions: Array<LadderContribution>;
  /** The `my_reward_pool_shares` field cannot be nested within a list. */
  myRewardPoolShares?: Maybe<Array<RewardPoolShare>>;
  name: ManagerProgressionTaskSlug;
  nextPlayableSo5LeagueTrack?: Maybe<So5LeagueTrack>;
  originalRewardConfigs?: Maybe<Array<CardPacksRewardConfig | CardRewardConfig | CardShardRewardConfig | CoinRewardConfig | ConversionCreditRewardConfig | DeliverableItemRewardConfig | ExperienceRewardConfig | InGameCurrencyRewardConfig | MonetaryRewardConfig | ProbabilisticBundleRewardConfig | ShopItemRewardConfig>>;
  parentTask?: Maybe<CardsCountTargetTask | CardsCountTask | CompleteCollectionsCountTargetTask | CompleteCollectionsCountTask | DailyActionTask | DecisivePlayerPickerTask | DropChallengeTask | GameWeeklyTask | GuessTheScoreTask | InviteTaskAsReferrer | So5LeaderboardTask | StarPackTask | Task | TasksTrack | ThresholdPickerTask | ThresholdsDuoConnectionTask | ThresholdsStreakAdditionalLineupTask | ThresholdsStreakTask>;
  periodicity?: Maybe<ManagerTaskPeriodicity>;
  pickOrList: Scalars['Boolean']['output'];
  possibleRewardConfigsIconUrl?: Maybe<Scalars['String']['output']>;
  /** @deprecated Not used anymore */
  probabilisticBundles: Array<ProbabilisticBundle>;
  progress: Scalars['Int']['output'];
  rarity: Rarity;
  rewardConfigs: Array<CardPacksRewardConfig | CardRewardConfig | CardShardRewardConfig | CoinRewardConfig | ConversionCreditRewardConfig | DeliverableItemRewardConfig | ExperienceRewardConfig | InGameCurrencyRewardConfig | MonetaryRewardConfig | ProbabilisticBundleRewardConfig | ShopItemRewardConfig>;
  /** The `reward_pool_shares` field cannot be nested within a list. */
  rewardPoolShares?: Maybe<RewardPoolShareConnection>;
  rewardTaskCampaign?: Maybe<TaskCampaign>;
  scoreTaskCampaign?: Maybe<TaskCampaign>;
  so5LeagueTrack?: Maybe<So5LeagueTrack>;
  so5Lineups: Array<So5Lineup>;
  startDate?: Maybe<Scalars['ISO8601DateTime']['output']>;
  target: Scalars['Int']['output'];
  taskConfigSlug: Scalars['String']['output'];
  templateIconUrl: Scalars['String']['output'];
  thresholds: Array<ThresholdStreakTaskThreshold>;
  title: Scalars['String']['output'];
  uncapped: Scalars['Boolean']['output'];
}


/** So5 Threshold Streak Task */
export interface ThresholdsStreakTaskcolorArgs {
  variant?: InputMaybe<ColorVariant>;
}


/** So5 Threshold Streak Task */
export interface ThresholdsStreakTaskcurrentThresholdArgs {
  forNextLineup?: InputMaybe<Scalars['Boolean']['input']>;
}


/** So5 Threshold Streak Task */
export interface ThresholdsStreakTaskcurrentThresholdStatusArgs {
  forNextLineup?: InputMaybe<Scalars['Boolean']['input']>;
}


/** So5 Threshold Streak Task */
export interface ThresholdsStreakTaskdescriptionArgs {
  forNextLineup?: InputMaybe<Scalars['Boolean']['input']>;
}


/** So5 Threshold Streak Task */
export interface ThresholdsStreakTaskprogressArgs {
  forNextLineup?: InputMaybe<Scalars['Boolean']['input']>;
}


/** So5 Threshold Streak Task */
export interface ThresholdsStreakTaskrewardConfigsArgs {
  mergedConfigsByType?: InputMaybe<Scalars['Boolean']['input']>;
}


/** So5 Threshold Streak Task */
export interface ThresholdsStreakTaskrewardPoolSharesArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
}

/** A tickets deliverable item interface */
export interface TicketsDeliverableItem extends DeliverableItemInterface {
  __typename: 'TicketsDeliverableItem';
  id: Scalars['ID']['output'];
  mandatoryWearableSizeInput: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  pictureUrl: Scalars['String']['output'];
  slug: Scalars['String']['output'];
  sport: Sport;
  threeDimensionalAssetUrl?: Maybe<Scalars['String']['output']>;
}


/** A tickets deliverable item interface */
export interface TicketsDeliverableItempictureUrlArgs {
  derivative?: InputMaybe<DeliverableItemDerivative>;
}


/** A tickets deliverable item interface */
export interface TicketsDeliverableItemthreeDimensionalAssetUrlArgs {
  format?: InputMaybe<DeliverableItemThreeDimensionalAssetFormat>;
}

/** A title body notification rendered for mobile */
export interface TitleBodyNotificationMobileRendering {
  __typename: 'TitleBodyNotificationMobileRendering';
  body: Scalars['String']['output'];
  deepLinkUrl: Scalars['String']['output'];
  iconUrl?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
}

/** A title body notification rendering instruction */
export interface TitleBodyNotificationRendering {
  __typename: 'TitleBodyNotificationRendering';
  mobile?: Maybe<TitleBodyNotificationMobileRendering>;
}

/** An auction in the Token service */
export interface TokenAuction extends DealInterface, Node, PromotionalEventsInterface, SocialPicturesInterface, TokenOperationTradeInterface, WheelTicketRewardsInterface {
  __typename: 'TokenAuction';
  anyCards: Array<BaseballCard | Card | NBACard>;
  bestBid?: Maybe<TokenBid>;
  bidToEarn: Scalars['Boolean']['output'];
  bidToEarnRewardConfigs: Array<BidToEarnRewardConfig>;
  bidToEarnRewards?: Maybe<Array<BidToEarnReward>>;
  /** The `bids` field cannot be nested within a list. */
  bids: TokenBidConnection;
  bidsCount: Scalars['Int']['output'];
  blockchainId: Scalars['String']['output'];
  /** Return the cards if they are bundled, empty otherwise */
  bundledAnyCards: Array<BaseballCard | Card | NBACard>;
  cancelled: Scalars['Boolean']['output'];
  cardPaymentProvider: PaymentMethodProvider;
  creditCardFee: Scalars['Float']['output'];
  currency: SupportedCurrency;
  /** Current price, in auction currency. */
  currentPrice: Scalars['String']['output'];
  dealStatus: DealStatus;
  eligibleForBlueprintRewards: Scalars['Boolean']['output'];
  eligiblePromotionalEvents: Array<AirdropPromotionalEvent | BidToEarnPromotionalEvent | CardShardThresholdsPromotionalEvent | CartPurchaseRewardPromotionalEvent | DepositPromotionalEvent | MarketPromotionalEvent | SpecialEditionPromotionalEvent | XPCooldownPromotionalEvent>;
  eligiblePromotionalEventsProbableRewards: Array<ProbableRewardConfig>;
  eligibleRewardsProbabilisticBundleConfigs: Array<ProbabilisticBundleConfig>;
  endDate: Scalars['ISO8601DateTime']['output'];
  id: Scalars['ID']['output'];
  /** Minimum next bid amount, in auction currency. */
  minNextBid: Scalars['String']['output'];
  /** Best bid if the connected user is the best bidder, null otherwise */
  myBestBid?: Maybe<TokenMyBid>;
  /** Last bid of the connected user if there is a connected user, null otherwise */
  myLastBid?: Maybe<TokenMyBid>;
  myReminder?: Maybe<AuctionReminder>;
  open: Scalars['Boolean']['output'];
  privateCurrentPrice: Scalars['String']['output'];
  privateMinNextBid: Scalars['String']['output'];
  socialPictureFingerprint: Scalars['String']['output'];
  socialPictureUrls: SocialPictureDerivative;
  startDate: Scalars['ISO8601DateTime']['output'];
  /** Team of all tokens if they all belong to the same team, null otherwise */
  team?: Maybe<Scalars['String']['output']>;
  transactionDate?: Maybe<Scalars['ISO8601DateTime']['output']>;
  updatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  userAcceptor?: Maybe<User>;
  userBuyer?: Maybe<User>;
  userSeller?: Maybe<User>;
  wheelTicketsRewardedAfterPurchase: Array<InGameCurrencyRewardConfig>;
}


/** An auction in the Token service */
export interface TokenAuctionbidsArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
}

/** The connection type for TokenAuction. */
export interface TokenAuctionConnection {
  __typename: 'TokenAuctionConnection';
  /** A list of edges. */
  edges: Array<TokenAuctionEdge>;
  hasAny: Scalars['Boolean']['output'];
  /** A list of nodes. */
  nodes: Array<TokenAuction>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
}

/** An edge in a connection. */
export interface TokenAuctionEdge {
  __typename: 'TokenAuctionEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<TokenAuction>;
}

/** A bid on an TokenAuction */
export interface TokenBid extends Node {
  __typename: 'TokenBid';
  amounts: MonetaryAmount;
  auction: TokenAuction;
  conversionCredit?: Maybe<ConversionCredit>;
  conversionCredits: Array<ConversionCredit>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  fiatPayment: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  maximumAmount?: Maybe<Scalars['String']['output']>;
  maximumAmounts: MonetaryAmount;
  userBidder?: Maybe<User>;
}

/** The connection type for TokenBid. */
export interface TokenBidConnection {
  __typename: 'TokenBidConnection';
  /** A list of edges. */
  edges: Array<TokenBidEdge>;
  hasAny: Scalars['Boolean']['output'];
  /** A list of nodes. */
  nodes: Array<TokenBid>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
}

/** An edge in a connection. */
export interface TokenBidEdge {
  __typename: 'TokenBidEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<TokenBid>;
}

/** Offer, PrimaryOffer or Auction */
export type TokenDeal = TokenAuction | TokenOffer | TokenPrimaryOffer;

/** The connection type for TokenDeal. */
export interface TokenDealConnection {
  __typename: 'TokenDealConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<TokenDealEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<TokenDeal>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
}

/** An edge in a connection. */
export interface TokenDealEdge {
  __typename: 'TokenDealEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<TokenDeal>;
}

/** Payload required to make a Starkware NFT deposit */
export interface TokenDeposit {
  __typename: 'TokenDeposit';
  assetType: Scalars['String']['output'];
  starkKey: Scalars['String']['output'];
  tokenId: Scalars['String']['output'];
  vaultId: Scalars['Int']['output'];
}

/** A monetary reward in the Token service */
export interface TokenMonetaryReward extends Node {
  __typename: 'TokenMonetaryReward';
  amount: Scalars['WeiAmount']['output'];
  amounts: MonetaryAmount;
  id: Scalars['ID']['output'];
  rewardId: Scalars['String']['output'];
  sport: Sport;
}

/** My bid on an TokenAuction */
export interface TokenMyBid extends Node {
  __typename: 'TokenMyBid';
  amounts: MonetaryAmount;
  auction: TokenAuction;
  conversionCredit?: Maybe<ConversionCredit>;
  conversionCredits: Array<ConversionCredit>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  fiatPayment: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  maximumAmount?: Maybe<Scalars['String']['output']>;
  maximumAmounts: MonetaryAmount;
  userBidder?: Maybe<User>;
}

/** An offer in the Token service */
export interface TokenOffer extends DealInterface, Node, TokenOperationTradeInterface {
  __typename: 'TokenOffer';
  acceptedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  actualReceiver?: Maybe<BlockchainUser>;
  blockchainId?: Maybe<Scalars['String']['output']>;
  cancelledAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  cardPaymentProvider: PaymentMethodProvider;
  counteredOffer?: Maybe<TokenOffer>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  dealStatus: DealStatus;
  endDate: Scalars['ISO8601DateTime']['output'];
  id: Scalars['ID']['output'];
  marketFeeAmounts?: Maybe<MonetaryAmount>;
  owners?: Maybe<Array<TokenOwner>>;
  receiver?: Maybe<BlockchainUser>;
  receiverSide: TokenOfferSide;
  rejectionReason?: Maybe<TokenOfferRejectionReason>;
  sender: BlockchainUser;
  senderSide: TokenOfferSide;
  settlementCurrencies: Array<SupportedCurrency>;
  startDate: Scalars['ISO8601DateTime']['output'];
  status: Scalars['String']['output'];
  transactionDate?: Maybe<Scalars['ISO8601DateTime']['output']>;
  type: OfferType;
  updatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  userAcceptor?: Maybe<User>;
  userBuyer?: Maybe<User>;
  userSeller?: Maybe<User>;
}

/** The connection type for TokenOffer. */
export interface TokenOfferConnection {
  __typename: 'TokenOfferConnection';
  /** A list of edges. */
  edges: Array<TokenOfferEdge>;
  hasAny: Scalars['Boolean']['output'];
  /** A list of nodes. */
  nodes: Array<TokenOffer>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
}

/** An edge in a connection. */
export interface TokenOfferEdge {
  __typename: 'TokenOfferEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<TokenOffer>;
}

export const TokenOfferRejectionReason = {
  ADD_CASH: 'ADD_CASH',
  CARD_NOT_WANTED: 'CARD_NOT_WANTED',
  IN_A_LINEUP: 'IN_A_LINEUP',
  NOT_SELLING: 'NOT_SELLING',
  OFFER_TOO_LOW: 'OFFER_TOO_LOW',
  ONLY_CASH: 'ONLY_CASH'
} as const;

export type TokenOfferRejectionReason = typeof TokenOfferRejectionReason[keyof typeof TokenOfferRejectionReason];
/** One side of an Offer */
export interface TokenOfferSide {
  __typename: 'TokenOfferSide';
  amounts: MonetaryAmount;
  anyCards: Array<BaseballCard | Card | NBACard>;
  id: Scalars['String']['output'];
}

/** Operation that have a trade */
export interface TokenOperationTradeInterface {
  id: Scalars['ID']['output'];
  transactionDate?: Maybe<Scalars['ISO8601DateTime']['output']>;
  userAcceptor?: Maybe<User>;
  userBuyer?: Maybe<User>;
  userSeller?: Maybe<User>;
}

export interface TokenOwner extends Node {
  __typename: 'TokenOwner';
  account?: Maybe<Account>;
  address: Scalars['String']['output'];
  amounts?: Maybe<MonetaryAmount>;
  blockchain: Blockchain;
  card: BaseballCard | Card | NBACard;
  deal?: Maybe<TokenDeal>;
  from: Scalars['ISO8601DateTime']['output'];
  id: Scalars['ID']['output'];
  optimistic: Scalars['Boolean']['output'];
  settleAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  settlementDelayReason?: Maybe<SettlementDelayReason>;
  transferType: OwnerTransfer;
  user?: Maybe<User>;
}

export const TokenPaymentMethod = {
  APPLE_IAP: 'APPLE_IAP',
  APPLE_PAY: 'APPLE_PAY',
  CREDIT_CARD: 'CREDIT_CARD',
  GIFT_CARD: 'GIFT_CARD',
  GOOGLE_IAP: 'GOOGLE_IAP',
  KLARNA: 'KLARNA',
  PAYPAL: 'PAYPAL',
  WALLET: 'WALLET',
  WALLET_AND_CREDIT_CARD: 'WALLET_AND_CREDIT_CARD'
} as const;

export type TokenPaymentMethod = typeof TokenPaymentMethod[keyof typeof TokenPaymentMethod];
/** A recorded market price for a Token */
export interface TokenPrice extends Node {
  __typename: 'TokenPrice';
  amounts: MonetaryAmount;
  card?: Maybe<BaseballCard | Card | NBACard>;
  date: Scalars['ISO8601DateTime']['output'];
  deal: TokenDeal;
  id: Scalars['ID']['output'];
}

/** The connection type for TokenPrice. */
export interface TokenPriceConnection {
  __typename: 'TokenPriceConnection';
  /** A list of edges. */
  edges: Array<TokenPriceEdge>;
  /** A list of nodes. */
  nodes: Array<TokenPrice>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
}

/** An edge in a connection. */
export interface TokenPriceEdge {
  __typename: 'TokenPriceEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<TokenPrice>;
}

/** A primary offer in the Token service */
export interface TokenPrimaryOffer extends DealInterface, Node, PromotionalEventsInterface, TokenOperationTradeInterface, WheelTicketRewardsInterface {
  __typename: 'TokenPrimaryOffer';
  acceptedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  anyCards: Array<BaseballCard | Card | NBACard>;
  applePrice?: Maybe<MonetaryAmount>;
  appleProductId?: Maybe<Scalars['String']['output']>;
  buyer?: Maybe<User>;
  /** @deprecated Use instantBuyCampaign.remainingSupply instead */
  campaignRemainingSupply?: Maybe<Scalars['Int']['output']>;
  cancelledAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  cardPaymentProvider: PaymentMethodProvider;
  dealStatus: DealStatus;
  eligiblePromotionalEvents: Array<AirdropPromotionalEvent | BidToEarnPromotionalEvent | CardShardThresholdsPromotionalEvent | CartPurchaseRewardPromotionalEvent | DepositPromotionalEvent | MarketPromotionalEvent | SpecialEditionPromotionalEvent | XPCooldownPromotionalEvent>;
  eligiblePromotionalEventsProbableRewards: Array<ProbableRewardConfig>;
  eligibleRewardsProbabilisticBundleConfigs: Array<ProbabilisticBundleConfig>;
  endDate: Scalars['ISO8601DateTime']['output'];
  googlePrice?: Maybe<Scalars['String']['output']>;
  googleProductId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  instantBuyCampaign?: Maybe<InstantBuyCampaign>;
  price?: Maybe<MonetaryAmount>;
  /** The `purchased_items` field cannot be nested within a list. */
  purchasedItems?: Maybe<Array<BundledPurchasableItem | CardShardsPurchasableItem | InGameCurrencyPurchasableItem | PackConfigPurchasableItem>>;
  /** @deprecated Use instantBuyCampaign.quantityPerStep instead */
  quantityPerStep?: Maybe<Scalars['Int']['output']>;
  /** @deprecated Use instantBuyCampaign.remainingAtCurrentPrice instead */
  remainingAtCurrentPrice?: Maybe<Scalars['Int']['output']>;
  rewards?: Maybe<Array<AnyCardReward | AnyConversionCreditReward | CardPackReward | CardShardsReward | CoinReward | DeliverableItemReward | ExperienceReward | InGameCurrencyReward | MonetaryReward | ProbabilisticBundleReward | ShopItemReward>>;
  settledAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  signedAmount?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use instantBuyCampaign.soldOut instead */
  soldOut?: Maybe<Scalars['Boolean']['output']>;
  startDate: Scalars['ISO8601DateTime']['output'];
  status: Scalars['String']['output'];
  transactionDate?: Maybe<Scalars['ISO8601DateTime']['output']>;
  updatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  userAcceptor?: Maybe<User>;
  userBuyer?: Maybe<User>;
  userSeller?: Maybe<User>;
  wheelTicketsRewardedAfterPurchase: Array<InGameCurrencyRewardConfig>;
}


/** A primary offer in the Token service */
export interface TokenPrimaryOffergooglePriceArgs {
  countryCode?: InputMaybe<Scalars['String']['input']>;
}

/** The connection type for TokenPrimaryOffer. */
export interface TokenPrimaryOfferConnection {
  __typename: 'TokenPrimaryOfferConnection';
  /** A list of edges. */
  edges: Array<TokenPrimaryOfferEdge>;
  /** A list of nodes. */
  nodes: Array<TokenPrimaryOffer>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
}

/** An edge in a connection. */
export interface TokenPrimaryOfferEdge {
  __typename: 'TokenPrimaryOfferEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<TokenPrimaryOffer>;
}

/** The Tokens queries */
export interface TokenRoot {
  __typename: 'TokenRoot';
  allCards: AnyCardInterfaceConnection;
  anyCard: BaseballCard | Card | NBACard;
  anyCards: Array<BaseballCard | Card | NBACard>;
  auction: TokenAuction;
  auctions: Array<TokenAuction>;
  /** Get a conversion credit campaign */
  conversionCreditCampaign?: Maybe<ConversionCreditCampaign>;
  inGameCurrencyPurchasableItems: Array<InGameCurrencyPurchasableItem>;
  /** Live auctions, sorted by updated time (from 10 days ago). */
  liveAuctions: TokenAuctionConnection;
  /** Live primary offers, sorted by updated time (from 8 days ago). */
  livePrimaryOffers: TokenPrimaryOfferConnection;
  /** Live single sale offers, sorted by updated time (from 8 days ago). */
  liveSingleSaleOffers: TokenOfferConnection;
  offer: TokenOffer;
  offers: Array<TokenOffer>;
  primaryOffer: TokenPrimaryOffer;
  primaryOffers: Array<TokenPrimaryOffer>;
  promotionalEvents: Array<AirdropPromotionalEvent | BidToEarnPromotionalEvent | CardShardThresholdsPromotionalEvent | CartPurchaseRewardPromotionalEvent | DepositPromotionalEvent | MarketPromotionalEvent | SpecialEditionPromotionalEvent | XPCooldownPromotionalEvent>;
  purchasableItem: BundledPurchasableItem | CardShardsPurchasableItem | InGameCurrencyPurchasableItem | PackConfigPurchasableItem;
  /** @deprecated Use inGameCurrencyPurchasableItems instead */
  purchasableItems: Array<BundledPurchasableItem | CardShardsPurchasableItem | InGameCurrencyPurchasableItem | PackConfigPurchasableItem>;
  tokenPrices: Array<TokenPrice>;
}


/** The Tokens queries */
export interface TokenRootallCardsArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  playerSlug?: InputMaybe<Scalars['String']['input']>;
  rarities?: InputMaybe<Array<Rarity>>;
  sport?: InputMaybe<Array<Sport>>;
}


/** The Tokens queries */
export interface TokenRootanyCardArgs {
  assetId: Scalars['String']['input'];
}


/** The Tokens queries */
export interface TokenRootanyCardsArgs {
  assetIds: Array<Scalars['String']['input']>;
}


/** The Tokens queries */
export interface TokenRootauctionArgs {
  id: Scalars['String']['input'];
}


/** The Tokens queries */
export interface TokenRootauctionsArgs {
  ids: Array<Scalars['String']['input']>;
}


/** The Tokens queries */
export interface TokenRootconversionCreditCampaignArgs {
  code: Scalars['String']['input'];
}


/** The Tokens queries */
export interface TokenRootinGameCurrencyPurchasableItemsArgs {
  currency: InGameCurrency;
  sport: Sport;
}


/** The Tokens queries */
export interface TokenRootliveAuctionsArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sport?: InputMaybe<Sport>;
  updatedAfter?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
}


/** The Tokens queries */
export interface TokenRootlivePrimaryOffersArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sport?: InputMaybe<Sport>;
  updatedAfter?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
}


/** The Tokens queries */
export interface TokenRootliveSingleSaleOffersArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  playerSlug?: InputMaybe<Scalars['String']['input']>;
  sport?: InputMaybe<Sport>;
  updatedAfter?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
}


/** The Tokens queries */
export interface TokenRootofferArgs {
  id: Scalars['String']['input'];
}


/** The Tokens queries */
export interface TokenRootoffersArgs {
  ids: Array<Scalars['String']['input']>;
}


/** The Tokens queries */
export interface TokenRootprimaryOfferArgs {
  id: Scalars['String']['input'];
}


/** The Tokens queries */
export interface TokenRootprimaryOffersArgs {
  ids: Array<Scalars['String']['input']>;
}


/** The Tokens queries */
export interface TokenRootpromotionalEventsArgs {
  sport: Sport;
}


/** The Tokens queries */
export interface TokenRootpurchasableItemArgs {
  id: Scalars['String']['input'];
}


/** The Tokens queries */
export interface TokenRootpurchasableItemsArgs {
  sport: Sport;
}


/** The Tokens queries */
export interface TokenRoottokenPricesArgs {
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  includePrivateSales?: InputMaybe<Scalars['Boolean']['input']>;
  playerSlug: Scalars['String']['input'];
  printBatch?: InputMaybe<Scalars['Int']['input']>;
  rarity: Rarity;
  season?: InputMaybe<Scalars['Int']['input']>;
  seasonEligibility?: InputMaybe<SeasonEligibility>;
  to?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
}

/** Withdrawal of an NFT to Ethereum */
export interface TokenWithdrawal extends Node {
  __typename: 'TokenWithdrawal';
  aasmState: Scalars['String']['output'];
  destination?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
}

export const TournamentCalendarRankType = {
  PROMOTED: 'PROMOTED',
  RELEGATED: 'RELEGATED',
  STABLE: 'STABLE'
} as const;

export type TournamentCalendarRankType = typeof TournamentCalendarRankType[keyof typeof TournamentCalendarRankType];
/** A stage of a competition in season */
export interface TournamentCalendarStage extends Node {
  __typename: 'TournamentCalendarStage';
  groups: Array<StageGroup>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
}

/** User current tournament eligibility */
export interface TournamentEligibility {
  __typename: 'TournamentEligibility';
  eligible: Scalars['Boolean']['output'];
  maxProgress: Scalars['Int']['output'];
  progress: Scalars['Int']['output'];
  so5LeaderboardType: So5LeaderboardType;
}

export const Tradeable = {
  /** The card should be deposited on Sorare before being traded */
  DEPOSIT_REQUIRED: 'DEPOSIT_REQUIRED',
  /** The card is not in the Sorare managed account, or the owner does not want to trade it */
  NO: 'NO',
  /** The card has not yet been transferred */
  NOT_YET: 'NOT_YET',
  /** The card has no owner or does not belong to the user */
  UNDEFINED: 'UNDEFINED',
  /** The card is transferrable */
  YES: 'YES'
} as const;

export type Tradeable = typeof Tradeable[keyof typeof Tradeable];
/** A trending player by trades count */
export interface TradedPlayer {
  __typename: 'TradedPlayer';
  id: Scalars['String']['output'];
  player: BaseballPlayer | NBAPlayer | Player;
  tradesCount: Scalars['Int']['output'];
}

/** The connection type for TradedPlayer. */
export interface TradedPlayerConnection {
  __typename: 'TradedPlayerConnection';
  /** A list of edges. */
  edges: Array<TradedPlayerEdge>;
  /** A list of nodes. */
  nodes: Array<TradedPlayer>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
}

/** An edge in a connection. */
export interface TradedPlayerEdge {
  __typename: 'TradedPlayerEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<TradedPlayer>;
}

export const TransactionStatus = {
  /** Transaction cancelled */
  CANCELLED: 'CANCELLED',
  /** Transaction confirmed */
  CONFIRMED: 'CONFIRMED',
  /** Transaction dropped */
  DROPPED: 'DROPPED',
  /** Transaction failed */
  FAILED: 'FAILED',
  /** Transaction is currently minting */
  PENDING: 'PENDING'
} as const;

export type TransactionStatus = typeof TransactionStatus[keyof typeof TransactionStatus];
/** A summary of a user trophies (card reward and/or podium) */
export interface TrophiesSummary {
  __typename: 'TrophiesSummary';
  cardRewards: Scalars['Int']['output'];
  /**
   * Number of rankings for closed fixtures
   * @deprecated No longer computed
   */
  finalRankings: Scalars['Int']['output'];
  podiumRankings: Scalars['Int']['output'];
  totalMonetaryRewards?: Maybe<MonetaryAmount>;
}


/** A summary of a user trophies (card reward and/or podium) */
export interface TrophiesSummarycardRewardsArgs {
  rarity?: InputMaybe<Rarity>;
}


/** A summary of a user trophies (card reward and/or podium) */
export interface TrophiesSummarypodiumRankingsArgs {
  ranking?: InputMaybe<Scalars['Int']['input']>;
}


/** A summary of a user trophies (card reward and/or podium) */
export interface TrophiesSummarytotalMonetaryRewardsArgs {
  referenceCurrency: SupportedCurrency;
}

/** Autogenerated input type of UnblockEmail */
export interface UnblockEmailInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
}

/** Autogenerated return type of UnblockEmail. */
export interface UnblockEmailPayload {
  __typename: 'UnblockEmailPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  currentUser?: Maybe<CurrentUser>;
  errors: Array<UserError>;
}

export interface UnknownSource extends HistoryTransactionInterface {
  __typename: 'UnknownSource';
  date: Scalars['ISO8601DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  label: Scalars['String']['output'];
  logoUrl?: Maybe<Scalars['String']['output']>;
  quantityByFlavour: Array<PoolKeyShardsCount>;
  totalQuantity: Scalars['Int']['output'];
}

/** Autogenerated return type of UpdateMutation. */
export interface UpdateMutationPayload {
  __typename: 'UpdateMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  currentUser?: Maybe<CurrentUser>;
  errors: Array<UserError>;
  oAuthApplication?: Maybe<OAuthApplication>;
}

/** A Mangopay US bank account type */
export interface UsBankAccount extends BankAccountInterface, Node {
  __typename: 'UsBankAccount';
  /** Account number (last 4 digits) */
  accountNumber: Scalars['String']['output'];
  country: Country;
  id: Scalars['ID']['output'];
  minimumWithdrawalAmounts: MonetaryAmount;
  ownerAddress?: Maybe<MangopayBankAccountOwnerAddress>;
  ownerName?: Maybe<Scalars['String']['output']>;
  /** American Banking Association routing number */
  routingNumber: Scalars['String']['output'];
  status?: Maybe<MangopayBankAccountStatus>;
  withdrawalFeeAmounts: MonetaryAmount;
  withdrawalFeeType: MangopayBankAccountWithdrawalFeeType;
}

export interface UsedInSo5Lineups extends CardUsageInterface {
  __typename: 'UsedInSo5Lineups';
  slug: Scalars['String']['output'];
  so5Lineups: Array<So5Lineup>;
}

export interface UsedInTaskLineups extends CardUsageInterface {
  __typename: 'UsedInTaskLineups';
  slug: Scalars['String']['output'];
  taskLineups: Array<GuessTheScoreTaskLineup | TaskLineup | ThresholdPickerTaskLineup>;
}

export interface UsedInTaskPreparedLineups extends CardUsageInterface {
  __typename: 'UsedInTaskPreparedLineups';
  slug: Scalars['String']['output'];
  taskPreparedLineups: Array<TaskPreparedLineup>;
}

export interface UsedInTasks extends CardUsageInterface {
  __typename: 'UsedInTasks';
  slug: Scalars['String']['output'];
  taskAppearances: Array<DecisivePlayerPickerTaskAppearance | TaskAppearance | ThresholdPickerTaskAppearance>;
  tasks: Array<CardsCountTargetTask | CardsCountTask | CompleteCollectionsCountTargetTask | CompleteCollectionsCountTask | DailyActionTask | DecisivePlayerPickerTask | DropChallengeTask | GameWeeklyTask | GuessTheScoreTask | InviteTaskAsReferrer | So5LeaderboardTask | StarPackTask | Task | TasksTrack | ThresholdPickerTask | ThresholdsDuoConnectionTask | ThresholdsStreakAdditionalLineupTask | ThresholdsStreakTask>;
}

/** A Sorare user */
export interface User extends Node, PublicUserInfoInterface, WithSubscriptionsInterface {
  __typename: 'User';
  active?: Maybe<Scalars['Boolean']['output']>;
  anyPlayer?: Maybe<BaseballPlayer | NBAPlayer | Player>;
  anyUserSportProfile?: Maybe<BaseballUserSportProfile | FootballUserSportProfile | NBAUserSportProfile>;
  baseballUserProfile?: Maybe<BaseballUserSportProfile>;
  /** Get a list of all blueprint cards */
  blueprintCards: AnyCardInterfaceConnection;
  board: CareerBoard | SquadBoard;
  boards: Array<CareerBoard | SquadBoard>;
  /** The `bought_primary_offers` field cannot be nested within a list. */
  boughtPrimaryOffers: TokenPrimaryOfferConnection;
  /** The `bought_single_sale_token_offers` field cannot be nested within a list. */
  boughtSingleSaleTokenOffers: TokenOfferConnection;
  /** The `buying_token_auctions` field cannot be nested within a list. */
  buyingTokenAuctions: Array<TokenAuction>;
  /** The `card_collections` field cannot be nested within a list. */
  cardCollections?: Maybe<CardCollectionConnection>;
  cardCounts: CardCount;
  /** Get a list of all cards */
  cards: AnyCardInterfaceConnection;
  cardsCount: Scalars['Int']['output'];
  /**
   * The `competition_card_collections` field cannot be nested within a list.
   * @deprecated No longer used
   */
  competitionCardCollections: Array<CompetitionCardCollections>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  cryptocurrency?: Maybe<Cryptocurrency>;
  currentUserSubscription?: Maybe<EmailSubscription>;
  /** The `ended_with_no_buyer_single_sale_token_offers` field cannot be nested within a list. */
  endedWithNoBuyerSingleSaleTokenOffers: TokenOfferConnection;
  ethVaultId?: Maybe<Scalars['Int']['output']>;
  ethereumAddress?: Maybe<Scalars['EthereumAddress']['output']>;
  followed?: Maybe<EmailSubscription>;
  /** The `followers` field cannot be nested within a list. */
  followers: UserWithSubscriptionSlugConnection;
  followersCount: Scalars['Int']['output'];
  /** The `following` field cannot be nested within a list. */
  following: UserWithSubscriptionSlugConnection;
  followingCount: Scalars['Int']['output'];
  footballUserProfile?: Maybe<FootballUserSportProfile>;
  /**
   * Number of times the user won each step of the hot streak tracks of the game
   * mode. SET reads the career track of the active card set, or of the previous
   * card set when no set is active. PRO adds up the active career boards of the
   * sport, up to the longest board
   */
  hotStreakStepsWon: Array<StepWonCount>;
  /** Typical number of hours the manager takes to answer trades */
  hoursToAnswerTrades?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  /**
   * The standings of this manager on every run of every ladder of that sport and
   * game mode, most recent run first. The `ladder_rankings` field cannot be nested within a list.
   */
  ladderRankings: Array<LadderRanking>;
  /** The `live_single_sale_token_offers` field cannot be nested within a list. */
  liveSingleSaleTokenOffers: TokenOfferConnection;
  /** The `lost_token_auctions` field cannot be nested within a list. */
  lostTokenAuctions: TokenAuctionConnection;
  /** The `manager_teams` field cannot be nested within a list. */
  managerTeams: ManagerTeamConnection;
  nbaUserProfile?: Maybe<NBAUserSportProfile>;
  nickname: Scalars['String']['output'];
  ownedPlayersCount: Scalars['Int']['output'];
  pictureUrl?: Maybe<Scalars['String']['output']>;
  player?: Maybe<Player>;
  /**
   * The `podium_rankings` field cannot be nested within a list.
   * @deprecated Use so5_trophies_summary instead
   */
  podiumRankings: So5RankingConnection;
  /**
   * The `podiums` field cannot be nested within a list.
   * @deprecated Use so5_trophies_summary instead
   */
  podiums: Array<So5Podium>;
  profile: UserProfile;
  /** The `public_watchlists` field cannot be nested within a list. */
  publicWatchlists?: Maybe<WatchlistConnection>;
  /** The `recommended_managers` field cannot be nested within a list. */
  recommendedManagers: UserConnection;
  /**
   * The `rewarded_rankings` field cannot be nested within a list.
   * @deprecated Use so5_trophies_summary instead
   */
  rewardedRankings: So5RankingConnection;
  /** The `search_card_facet_values` field cannot be nested within a list. */
  searchCardFacetValues: Array<SearchFacetValue>;
  /** The `search_cards` field cannot be nested within a list. */
  searchCards: SearchCards;
  setBoard?: Maybe<CareerBoard | SquadBoard>;
  /**
   * Live step of the set tasks track, falling back to the last claimed step The
   * `set_live_tasks_track_step` field cannot be nested within a list.
   */
  setLiveTasksTrackStep?: Maybe<CardsCountTargetTask | CardsCountTask | CompleteCollectionsCountTargetTask | CompleteCollectionsCountTask | DailyActionTask | DecisivePlayerPickerTask | DropChallengeTask | GameWeeklyTask | GuessTheScoreTask | InviteTaskAsReferrer | So5LeaderboardTask | StarPackTask | Task | TasksTrack | ThresholdPickerTask | ThresholdsDuoConnectionTask | ThresholdsStreakAdditionalLineupTask | ThresholdsStreakTask>;
  /**
   * Headline stats of the user for the active card set, or for the previous card
   * set when no set is active The `set_manager_profile_stats` field cannot be
   * nested within a list.
   */
  setManagerProfileStats: Array<BestScoreManagerProfileStat | CollectionCompletionManagerProfileStat>;
  setTasksTrack?: Maybe<TasksTrack>;
  /** The `single_sale_token_offers` field cannot be nested within a list. */
  singleSaleTokenOffers: TokenOfferConnection;
  slug: Scalars['String']['output'];
  /** The `so5_trophies_summary` field cannot be nested within a list. */
  so5TrophiesSummary: TrophiesSummary;
  /** The `sold_single_sale_token_offers` field cannot be nested within a list. */
  soldSingleSaleTokenOffers: TokenOfferConnection;
  sorareAddress?: Maybe<Scalars['EthereumAddress']['output']>;
  squad?: Maybe<Squad>;
  starkKey?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  subscriptionsCount: Scalars['Int']['output'];
  /** Set to true if the user deleted his account or was suspended */
  suspended: Scalars['Boolean']['output'];
  tasksTracks: Array<TasksTrack>;
  /** The `token_auctions` field cannot be nested within a list. */
  tokenAuctions: TokenAuctionConnection;
  totalPlayersCount: Scalars['Int']['output'];
  /** The `trades` field cannot be nested within a list. */
  trades: TokenDealConnection;
  /**
   * The `trophies` field cannot be nested within a list.
   * @deprecated Use so5_trophies_summary instead
   */
  trophies: Array<So5Trophies>;
  userCardCollectionsPresence: Scalars['Boolean']['output'];
  /** The `won_token_auctions` field cannot be nested within a list. */
  wonTokenAuctions: TokenAuctionConnection;
}


/** A Sorare user */
export interface UseranyUserSportProfileArgs {
  sport: Sport;
  variant?: InputMaybe<UserSportProfileVariant>;
}


/** A Sorare user */
export interface UserblueprintCardsArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  age?: InputMaybe<Scalars['Int']['input']>;
  assetIds?: InputMaybe<Array<Scalars['String']['input']>>;
  before?: InputMaybe<Scalars['String']['input']>;
  classicOnly?: InputMaybe<Scalars['Boolean']['input']>;
  customCardEditionName?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  inActiveCompetitions?: InputMaybe<Array<Scalars['String']['input']>>;
  inSeasonEligible?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  owned?: InputMaybe<Scalars['Boolean']['input']>;
  ownedByMe?: InputMaybe<Scalars['Boolean']['input']>;
  ownedSinceAfter?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  playerSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  positions?: InputMaybe<Array<Position>>;
  rarities?: InputMaybe<Array<Rarity>>;
  revealable?: InputMaybe<Scalars['Boolean']['input']>;
  seasonStartYears?: InputMaybe<Array<Scalars['Int']['input']>>;
  serialNumber?: InputMaybe<Scalars['Int']['input']>;
  shirtNumber?: InputMaybe<Scalars['Int']['input']>;
  slugs?: InputMaybe<Array<Scalars['String']['input']>>;
  sorts?: InputMaybe<Array<CardSort>>;
  sport?: InputMaybe<Sport>;
  teamSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  withinDeckFirst?: InputMaybe<Scalars['String']['input']>;
}


/** A Sorare user */
export interface UserboardArgs {
  configSlug?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
}


/** A Sorare user */
export interface UserboardsArgs {
  engaged?: InputMaybe<Scalars['Boolean']['input']>;
  mode: BoardMode;
  rarities?: InputMaybe<Array<Rarity>>;
  rarity?: InputMaybe<Rarity>;
  so5Competition?: InputMaybe<Scalars['String']['input']>;
  sport: Sport;
}


/** A Sorare user */
export interface UserboughtPrimaryOffersArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sortByEndDate?: InputMaybe<SortingOption>;
  sport?: InputMaybe<Array<Sport>>;
}


/** A Sorare user */
export interface UserboughtSingleSaleTokenOffersArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sortByEndDate?: InputMaybe<SortingOption>;
  sport?: InputMaybe<Array<Sport>>;
}


/** A Sorare user */
export interface UserbuyingTokenAuctionsArgs {
  newlyListed?: InputMaybe<Scalars['Boolean']['input']>;
  sport?: InputMaybe<Array<Sport>>;
}


/** A Sorare user */
export interface UsercardCollectionsArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  cardSetSlug?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forCompetitions?: InputMaybe<Array<Scalars['String']['input']>>;
  inSeasonOnly?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  rarities?: InputMaybe<Array<InputMaybe<Rarity>>>;
  seasonStartYears?: InputMaybe<Array<Scalars['Int']['input']>>;
  sortType?: InputMaybe<CardCollectionSortingOption>;
  sport?: InputMaybe<Sport>;
  startedOnly?: InputMaybe<Scalars['Boolean']['input']>;
  teamSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
}


/** A Sorare user */
export interface UsercardCountsArgs {
  sport: Sport;
}


/** A Sorare user */
export interface UsercardsArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  age?: InputMaybe<Scalars['Int']['input']>;
  assetIds?: InputMaybe<Array<Scalars['String']['input']>>;
  before?: InputMaybe<Scalars['String']['input']>;
  classicOnly?: InputMaybe<Scalars['Boolean']['input']>;
  customCardEditionName?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  inActiveCompetitions?: InputMaybe<Array<Scalars['String']['input']>>;
  inSeasonEligible?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  owned?: InputMaybe<Scalars['Boolean']['input']>;
  ownedByMe?: InputMaybe<Scalars['Boolean']['input']>;
  ownedSinceAfter?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  playerSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  positions?: InputMaybe<Array<Position>>;
  rarities?: InputMaybe<Array<Rarity>>;
  revealable?: InputMaybe<Scalars['Boolean']['input']>;
  seasonStartYears?: InputMaybe<Array<Scalars['Int']['input']>>;
  serialNumber?: InputMaybe<Scalars['Int']['input']>;
  shirtNumber?: InputMaybe<Scalars['Int']['input']>;
  slugs?: InputMaybe<Array<Scalars['String']['input']>>;
  sorts?: InputMaybe<Array<CardSort>>;
  sport?: InputMaybe<Sport>;
  teamSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  transferredOutAfter?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  withinDeckFirst?: InputMaybe<Scalars['String']['input']>;
}


/** A Sorare user */
export interface UsercompetitionCardCollectionsArgs {
  cardSetSlug: Scalars['String']['input'];
  competitionSlug?: InputMaybe<Scalars['String']['input']>;
  competitionSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  sport: Sport;
}


/** A Sorare user */
export interface UserendedWithNoBuyerSingleSaleTokenOffersArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sortByEndDate?: InputMaybe<SortingOption>;
  sport?: InputMaybe<Array<Sport>>;
}


/** A Sorare user */
export interface UserfollowersArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
}


/** A Sorare user */
export interface UserfollowingArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
}


/** A Sorare user */
export interface UserfootballUserProfileArgs {
  variant?: InputMaybe<UserSportProfileVariant>;
}


/** A Sorare user */
export interface UserhotStreakStepsWonArgs {
  configSlug?: InputMaybe<Scalars['String']['input']>;
  gameMode: PlatformGameMode;
  sport: Sport;
}


/** A Sorare user */
export interface UserladderRankingsArgs {
  mode: PlatformGameMode;
  sport: Sport;
}


/** A Sorare user */
export interface UserliveSingleSaleTokenOffersArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sortByEndDate?: InputMaybe<SortingOption>;
  sport?: InputMaybe<Array<Sport>>;
}


/** A Sorare user */
export interface UserlostTokenAuctionsArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sortByEndDate?: InputMaybe<SortingOption>;
  sport?: InputMaybe<Array<Sport>>;
}


/** A Sorare user */
export interface UsermanagerTeamsArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
}


/** A Sorare user */
export interface UserownedPlayersCountArgs {
  cardSetSlug: Scalars['String']['input'];
  sport: Sport;
}


/** A Sorare user */
export interface UserpictureUrlArgs {
  derivative?: InputMaybe<Scalars['String']['input']>;
}


/** A Sorare user */
export interface UserpodiumRankingsArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  ranking?: InputMaybe<Scalars['Int']['input']>;
  so5LeaderboardType?: InputMaybe<So5LeaderboardType>;
  sport?: InputMaybe<Sport>;
}


/** A Sorare user */
export interface UserpodiumsArgs {
  sport?: InputMaybe<Sport>;
}


/** A Sorare user */
export interface UserpublicWatchlistsArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sport: Sport;
}


/** A Sorare user */
export interface UserrecommendedManagersArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sport?: InputMaybe<Sport>;
}


/** A Sorare user */
export interface UserrewardedRankingsArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  so5LeaderboardType?: InputMaybe<So5LeaderboardType>;
  sport?: InputMaybe<Sport>;
}


/** A Sorare user */
export interface UsersearchCardFacetValuesArgs {
  advancedFilters?: InputMaybe<Scalars['String']['input']>;
  cardSetSlug?: InputMaybe<Scalars['String']['input']>;
  facetQuery: Scalars['String']['input'];
  field: Scalars['String']['input'];
  filters?: InputMaybe<Array<SearchFilterInput>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  rarity?: InputMaybe<Rarity>;
  refinements?: InputMaybe<Array<SearchRefinementInput>>;
  sport?: InputMaybe<Sport>;
}


/** A Sorare user */
export interface UsersearchCardsArgs {
  advancedFilters?: InputMaybe<Scalars['String']['input']>;
  cardSetSlug?: InputMaybe<Scalars['String']['input']>;
  duplicatedKey?: InputMaybe<Scalars['String']['input']>;
  facets?: InputMaybe<Array<SearchFacetDefinitionInput>>;
  filters?: InputMaybe<Array<SearchFilterInput>>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  rarity?: InputMaybe<Rarity>;
  refinements?: InputMaybe<Array<SearchRefinementInput>>;
  sorts?: InputMaybe<Array<SearchSortInput>>;
  sport?: InputMaybe<Sport>;
}


/** A Sorare user */
export interface UsersetBoardArgs {
  mode: BoardMode;
  sport: Sport;
}


/** A Sorare user */
export interface UsersetLiveTasksTrackStepArgs {
  sport: Sport;
}


/** A Sorare user */
export interface UsersetManagerProfileStatsArgs {
  sport: Sport;
}


/** A Sorare user */
export interface UsersetTasksTrackArgs {
  sport: Sport;
}


/** A Sorare user */
export interface UsersingleSaleTokenOffersArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sortByEndDate?: InputMaybe<SortingOption>;
  sport?: InputMaybe<Array<Sport>>;
}


/** A Sorare user */
export interface Userso5TrophiesSummaryArgs {
  sport?: InputMaybe<Sport>;
}


/** A Sorare user */
export interface UsersoldSingleSaleTokenOffersArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sortByEndDate?: InputMaybe<SortingOption>;
  sport?: InputMaybe<Array<Sport>>;
}


/** A Sorare user */
export interface UsersquadArgs {
  sport: Sport;
}


/** A Sorare user */
export interface UsertasksTracksArgs {
  rarity?: InputMaybe<Rarity>;
  sport: Sport;
}


/** A Sorare user */
export interface UsertokenAuctionsArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sortByEndDate?: InputMaybe<SortingOption>;
  sport?: InputMaybe<Array<Sport>>;
}


/** A Sorare user */
export interface UsertotalPlayersCountArgs {
  cardSetSlug: Scalars['String']['input'];
  sport: Sport;
}


/** A Sorare user */
export interface UsertradesArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sortByEndDate?: InputMaybe<SortingOption>;
  sport?: InputMaybe<Array<Sport>>;
}


/** A Sorare user */
export interface UsertrophiesArgs {
  sport?: InputMaybe<Sport>;
}


/** A Sorare user */
export interface UseruserCardCollectionsPresenceArgs {
  rarity: Rarity;
  sport: Sport;
}


/** A Sorare user */
export interface UserwonTokenAuctionsArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sortByEndDate?: InputMaybe<SortingOption>;
  sport?: InputMaybe<Array<Sport>>;
}

/** A user account entry */
export interface UserAccountEntry extends Node {
  __typename: 'UserAccountEntry';
  aasmState: UserAccountEntryState;
  account?: Maybe<Account>;
  amounts: MonetaryAmount;
  date: Scalars['ISO8601DateTime']['output'];
  entryType: UserAccountEntryEntry;
  id: Scalars['ID']['output'];
  internal: Scalars['Boolean']['output'];
  provisional: Scalars['Boolean']['output'];
  tokenOperation?: Maybe<UserAccountEntryTokenOperation>;
  user: User;
}

/** The connection type for UserAccountEntry. */
export interface UserAccountEntryConnection {
  __typename: 'UserAccountEntryConnection';
  /** A list of edges. */
  edges: Array<UserAccountEntryEdge>;
  /** A list of nodes. */
  nodes: Array<UserAccountEntry>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
}

/** An edge in a connection. */
export interface UserAccountEntryEdge {
  __typename: 'UserAccountEntryEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<UserAccountEntry>;
}

export const UserAccountEntryEntry = {
  CREDIT_CARD_FEE: 'CREDIT_CARD_FEE',
  DEPOSIT: 'DEPOSIT',
  ETH_MIGRATION_ROUNDING: 'ETH_MIGRATION_ROUNDING',
  FX_FEE: 'FX_FEE',
  PAYMENT: 'PAYMENT',
  PAYMENT_FEE: 'PAYMENT_FEE',
  REWARD: 'REWARD',
  WITHDRAWAL: 'WITHDRAWAL',
  WITHDRAWAL_FEE: 'WITHDRAWAL_FEE'
} as const;

export type UserAccountEntryEntry = typeof UserAccountEntryEntry[keyof typeof UserAccountEntryEntry];
export const UserAccountEntryState = {
  CANCELLED: 'CANCELLED',
  CONFIRMED: 'CONFIRMED',
  PENDING: 'PENDING'
} as const;

export type UserAccountEntryState = typeof UserAccountEntryState[keyof typeof UserAccountEntryState];
/** Object that can be an tokenOperation of a UserAccountEntry */
export type UserAccountEntryTokenOperation = BankWithdrawal | EthMigration | FastWithdrawal | FullWithdrawalRequest | MangopayInternalTransfer | MangopayWithdrawal | OffRampWithdrawal | So5Reward | SolanaRentFunding | StarkwareWithdrawal | TokenBid | TokenMonetaryReward | TokenOffer | TokenPrimaryOffer | TokenWithdrawal | Withdrawal;

/** The cards of a user for a collection */
export interface UserCardCollection extends Node {
  __typename: 'UserCardCollection';
  bonus: Scalars['Float']['output'];
  cardCollection: CardCollection;
  /** The `card_collection_cards` field cannot be nested within a list. */
  cardCollectionCards: Array<CardCollectionCard>;
  complete: Scalars['Boolean']['output'];
  completedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  firstOwnedPlayersCount: Scalars['Int']['output'];
  fulfilledSlotsCount: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  liveRanking: Scalars['Int']['output'];
  liveRankingRatio?: Maybe<Scalars['Int']['output']>;
  ownedPlayersCount: Scalars['Int']['output'];
  score: Scalars['Int']['output'];
  slots: Array<UserCardCollectionSlot>;
  slotsCount: Scalars['Int']['output'];
  totalPlayersCount: Scalars['Int']['output'];
  user: User;
  withAnimation: Scalars['Boolean']['output'];
  withRanking: Scalars['Boolean']['output'];
}


/** The cards of a user for a collection */
export interface UserCardCollectionliveRankingRatioArgs {
  top?: InputMaybe<Scalars['Boolean']['input']>;
}


/** The cards of a user for a collection */
export interface UserCardCollectionslotsArgs {
  onlyFulfilled?: InputMaybe<Scalars['Boolean']['input']>;
  skin?: InputMaybe<Skin>;
  skins?: InputMaybe<Array<Skin>>;
  stackByPlayer?: InputMaybe<Scalars['Boolean']['input']>;
}

/** The connection type for UserCardCollection. */
export interface UserCardCollectionConnection {
  __typename: 'UserCardCollectionConnection';
  /** A list of edges. */
  edges: Array<UserCardCollectionEdge>;
  /** A list of nodes. */
  nodes: Array<UserCardCollection>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
}

/** An edge in a connection. */
export interface UserCardCollectionEdge {
  __typename: 'UserCardCollectionEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<UserCardCollection>;
}

/** A slot in a user collection of cards */
export interface UserCardCollectionSlot {
  __typename: 'UserCardCollectionSlot';
  cardBackgroundUrl?: Maybe<Scalars['String']['output']>;
  cardCollectionCards: Array<CardCollectionCard>;
  cardCollectionCardsCount: Scalars['Int']['output'];
  highlightedCardCollectionCard?: Maybe<CardCollectionCard>;
  nomenclature: Scalars['String']['output'];
  relatedCardEditionSlots: Array<UserCardCollectionSlot>;
  skinEdition?: Maybe<SkinEdition>;
  slot: CardCollectionSlot;
  slug: Scalars['String']['output'];
  /** @deprecated No longer used */
  snapshottedNumberOfGameWeeksPlayed: Scalars['Int']['output'];
}

export interface UserCardsCount {
  __typename: 'UserCardsCount';
  position: Position;
  seasonality: So5LeaderboardSeasonality;
  slug: Scalars['String']['output'];
  totalCount: Scalars['Int']['output'];
  usedCardsCount: Scalars['Int']['output'];
}

/** The connection type for User. */
export interface UserConnection {
  __typename: 'UserConnection';
  /** A list of edges. */
  edges: Array<UserEdge>;
  /** A list of nodes. */
  nodes: Array<User>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
}

/** A Sorare manager device */
export interface UserDevice extends Node {
  __typename: 'UserDevice';
  deviceType: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  lastUsedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  os: Scalars['String']['output'];
  userAgent: Scalars['String']['output'];
}

/** A Sorare manager device related event */
export interface UserDeviceEvent extends Node {
  __typename: 'UserDeviceEvent';
  deviceType: Scalars['String']['output'];
  eventType: DeviceWasUpdatedEvent;
  id: Scalars['ID']['output'];
  lastUsedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  os: Scalars['String']['output'];
  userAgent: Scalars['String']['output'];
}

/** An edge in a connection. */
export interface UserEdge {
  __typename: 'UserEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<User>;
}

/** A user-readable error */
export interface UserError {
  __typename: 'UserError';
  /** The error code */
  code?: Maybe<Scalars['Int']['output']>;
  /** A description of the error */
  message: Scalars['String']['output'];
  /** Which input value this error came from */
  path?: Maybe<Array<Scalars['String']['output']>>;
}

export interface UserFixtureResults {
  __typename: 'UserFixtureResults';
  completedThresholdsStreakTasksCount: Scalars['Int']['output'];
  eligibleOrSo5Rewards: Array<So5RewardOrConfig>;
  slug: Scalars['String']['output'];
  so5LeaderboardContenders: So5LeaderboardContenderConnection;
  totalRewardConfigs: Array<CardPacksRewardConfig | CardRewardConfig | CardShardRewardConfig | CoinRewardConfig | ConversionCreditRewardConfig | DeliverableItemRewardConfig | ExperienceRewardConfig | InGameCurrencyRewardConfig | MonetaryRewardConfig | ProbabilisticBundleRewardConfig | ShopItemRewardConfig>;
  user: User;
}


export interface UserFixtureResultscompletedThresholdsStreakTasksCountArgs {
  rarities?: InputMaybe<Array<Rarity>>;
}


export interface UserFixtureResultsso5LeaderboardContendersArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  groupSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  last?: InputMaybe<Scalars['Int']['input']>;
  rarities?: InputMaybe<Array<So5LeaderboardRarity>>;
}


export interface UserFixtureResultstotalRewardConfigsArgs {
  multiplyBaseRewards?: InputMaybe<Scalars['Boolean']['input']>;
}

/** The connection type for UserFixtureResults. */
export interface UserFixtureResultsConnection {
  __typename: 'UserFixtureResultsConnection';
  /** A list of edges. */
  edges: Array<UserFixtureResultsEdge>;
  hasAny: Scalars['Boolean']['output'];
  /** A list of nodes. */
  nodes: Array<UserFixtureResults>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
}

/** An edge in a connection. */
export interface UserFixtureResultsEdge {
  __typename: 'UserFixtureResultsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<UserFixtureResults>;
}

/** A flag reflecting a warning or a ban of a user */
export interface UserFlag extends Node {
  __typename: 'UserFlag';
  id: Scalars['ID']['output'];
  reason: UserFlagReason;
  relatedUsers: Array<CurrentUser | User | UserWithSubscriptionSlug>;
  until?: Maybe<Scalars['ISO8601DateTime']['output']>;
}

export const UserFlagReason = {
  ABUSIVE_LANGUAGE: 'ABUSIVE_LANGUAGE',
  ANTICOMPETITIVE_LENDING: 'ANTICOMPETITIVE_LENDING',
  EMAIL_HARD_BOUNCE: 'EMAIL_HARD_BOUNCE',
  MULTI_ACCOUNT: 'MULTI_ACCOUNT',
  REFERRAL_ABUSE: 'REFERRAL_ABUSE',
  REFERRAL_SPAM: 'REFERRAL_SPAM',
  UNFAIR_GALLERY: 'UNFAIR_GALLERY'
} as const;

export type UserFlagReason = typeof UserFlagReason[keyof typeof UserFlagReason];
export interface UserGroupInterface {
  administrator?: Maybe<User>;
  canJoin: Validity;
  conversionCredit?: Maybe<ConversionCredit>;
  conversionCreditCampaign?: Maybe<ConversionCreditCampaign>;
  description?: Maybe<Scalars['String']['output']>;
  displayName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  joinDisabled: Scalars['Boolean']['output'];
  joinRules: So5Rules;
  joinSecret: Scalars['String']['output'];
  logo?: Maybe<SkinShopItem>;
  membership?: Maybe<So5UserGroupMembership>;
  memberships: Array<So5UserGroupMembership>;
  membershipsCount: Scalars['Int']['output'];
  membershipsPaginated: So5UserGroupMembershipsPaginated;
  myMembership?: Maybe<So5UserGroupMembership>;
  pictureUrl?: Maybe<Scalars['String']['output']>;
  publiclyAccessible: Scalars['Boolean']['output'];
  rewardsConfig: LeaderboardRewardsConfig;
  slug: Scalars['String']['output'];
  status: UserGroupStatus;
  totalRewardConfigs: Array<CardPacksRewardConfig | CardRewardConfig | CardShardRewardConfig | CoinRewardConfig | ConversionCreditRewardConfig | DeliverableItemRewardConfig | ExperienceRewardConfig | InGameCurrencyRewardConfig | MonetaryRewardConfig | ProbabilisticBundleRewardConfig | ShopItemRewardConfig>;
  /** High level overview of the rewards */
  totalRewards: RewardsOverview;
}


export interface UserGroupInterfacemembershipArgs {
  userSlug: Scalars['String']['input'];
}


export interface UserGroupInterfacemembershipsPaginatedArgs {
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
}


export interface UserGroupInterfacetotalRewardConfigsArgs {
  highestConfigByType?: InputMaybe<Scalars['Boolean']['input']>;
}

/** The connection type for UserGroupInterface. */
export interface UserGroupInterfaceConnection {
  __typename: 'UserGroupInterfaceConnection';
  /** A list of edges. */
  edges: Array<UserGroupInterfaceEdge>;
  hasAny: Scalars['Boolean']['output'];
  /** A list of nodes. */
  nodes: Array<So5UserGroup>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
}

/** An edge in a connection. */
export interface UserGroupInterfaceEdge {
  __typename: 'UserGroupInterfaceEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<So5UserGroup>;
}

export interface UserGroupMembershipInterface {
  administrator: Scalars['Boolean']['output'];
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['ID']['output'];
  ranking?: Maybe<Scalars['Int']['output']>;
  score: Scalars['Int']['output'];
  user: User;
}

export interface UserGroupMembershipShopItemsUpdate {
  __typename: 'UserGroupMembershipShopItemsUpdate';
  evolution: UserGroupMembershipShopItemsUpdateEvolution;
  id: Scalars['String']['output'];
  newShopItems: Array<AppearanceBoostShopItem | CommonCardSwapShopItem | DeliverableWithCustomVariantShopItem | DeliverableWithNoVariantShopItem | ExtraSwapShopItem | JerseyShopItem | LevelUpShopItem | PictureFrameShopItem | RaffleShopItem | ShopItem | SkinShopItem>;
  previousShopItems: Array<AppearanceBoostShopItem | CommonCardSwapShopItem | DeliverableWithCustomVariantShopItem | DeliverableWithNoVariantShopItem | ExtraSwapShopItem | JerseyShopItem | LevelUpShopItem | PictureFrameShopItem | RaffleShopItem | ShopItem | SkinShopItem>;
  userGroupMembership: So5UserGroupMembership;
}

export const UserGroupMembershipShopItemsUpdateEvolution = {
  BETTER: 'BETTER',
  NOVEL: 'NOVEL',
  WORSE: 'WORSE'
} as const;

export type UserGroupMembershipShopItemsUpdateEvolution = typeof UserGroupMembershipShopItemsUpdateEvolution[keyof typeof UserGroupMembershipShopItemsUpdateEvolution];
export const UserGroupStatus = {
  ENDED: 'ENDED',
  STARTED: 'STARTED',
  TO_START: 'TO_START'
} as const;

export type UserGroupStatus = typeof UserGroupStatus[keyof typeof UserGroupStatus];
/** A user lifecycle entry */
export interface UserLifecycleInput {
  name: Scalars['String']['input'];
  value?: InputMaybe<Scalars['Json']['input']>;
}

/** User Offer Interface */
export interface UserOffersInterface {
  blockedUntil?: Maybe<Scalars['ISO8601DateTime']['output']>;
  blockedUsers: UserConnection;
  endedTokenOffersReceived: TokenOfferConnection;
  endedTokenOffersSent: TokenOfferConnection;
  pendingTokenOffersReceived: TokenOfferConnection;
  pendingTokenOffersSent: TokenOfferConnection;
  tokenOffers: TokenOfferConnection;
}


/** User Offer Interface */
export interface UserOffersInterfaceblockedUsersArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
}


/** User Offer Interface */
export interface UserOffersInterfaceendedTokenOffersReceivedArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sortType?: InputMaybe<SortingOption>;
  sport?: InputMaybe<Array<Sport>>;
  states?: InputMaybe<Array<OfferState>>;
}


/** User Offer Interface */
export interface UserOffersInterfaceendedTokenOffersSentArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sortType?: InputMaybe<SortingOption>;
  sport?: InputMaybe<Array<Sport>>;
  states?: InputMaybe<Array<OfferState>>;
}


/** User Offer Interface */
export interface UserOffersInterfacependingTokenOffersReceivedArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sortType?: InputMaybe<SortingOption>;
  sport?: InputMaybe<Array<Sport>>;
}


/** User Offer Interface */
export interface UserOffersInterfacependingTokenOffersSentArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sortType?: InputMaybe<SortingOption>;
  sport?: InputMaybe<Array<Sport>>;
}


/** User Offer Interface */
export interface UserOffersInterfacetokenOffersArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  direction: OfferDirection;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sortType?: InputMaybe<SortingOption>;
  sport?: InputMaybe<Array<Sport>>;
  states?: InputMaybe<Array<OfferState>>;
}

/** An object representing the past or present ownership of a card by a user */
export interface UserOwner extends OwnerInterface {
  __typename: 'UserOwner';
  account?: Maybe<Account>;
  address: Scalars['String']['output'];
  amounts?: Maybe<MonetaryAmount>;
  blockchain: Scalars['String']['output'];
  card: Card;
  from: Scalars['ISO8601DateTime']['output'];
  id: Scalars['ID']['output'];
  optimistic: Scalars['Boolean']['output'];
  /** Card price, in wei. */
  price: Scalars['String']['output'];
  referenceId?: Maybe<Scalars['String']['output']>;
  settleAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  transferType: Scalars['String']['output'];
}

/** A Sorare user profile */
export interface UserProfile extends Node {
  __typename: 'UserProfile';
  badge?: Maybe<UserProfileBadge>;
  clubBanner?: Maybe<SkinShopItem>;
  clubName: Scalars['String']['output'];
  clubShield?: Maybe<SkinShopItem>;
  discordUsername?: Maybe<Scalars['String']['output']>;
  enabledWallets?: Maybe<Array<EnabledWallet>>;
  id: Scalars['ID']['output'];
  /** Get marketplace preferences */
  marketplacePreferences: Array<MarketplaceSportPreferences>;
  pictureUrl?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  twitterUsername?: Maybe<Scalars['String']['output']>;
  user: User;
  verified: Scalars['Boolean']['output'];
}


/** A Sorare user profile */
export interface UserProfilemarketplacePreferencesArgs {
  sports?: InputMaybe<Array<Sport>>;
}


/** A Sorare user profile */
export interface UserProfilepictureUrlArgs {
  derivative?: InputMaybe<Scalars['String']['input']>;
}

/** A Sorare user profile badge */
export interface UserProfileBadge {
  __typename: 'UserProfileBadge';
  description: Scalars['String']['output'];
  pictureUrl: Scalars['String']['output'];
  slug: Scalars['String']['output'];
}

export interface UserRankingInterface {
  id: Scalars['ID']['output'];
  overallRanking?: Maybe<Scalars['Int']['output']>;
  overallScore: Scalars['Float']['output'];
  user: User;
}

/** A user relation */
export interface UserRelation extends Node {
  __typename: 'UserRelation';
  id: Scalars['ID']['output'];
  knownAs: Scalars['String']['output'];
  knownPhoneNumber?: Maybe<Scalars['String']['output']>;
  knownUser?: Maybe<User>;
  user: User;
  userDiscoverableName?: Maybe<Scalars['String']['output']>;
  userRelationsInCommonCount?: Maybe<Scalars['Int']['output']>;
}

/** The connection type for UserRelation. */
export interface UserRelationConnection {
  __typename: 'UserRelationConnection';
  /** A list of edges. */
  edges: Array<UserRelationEdge>;
  /** A list of nodes. */
  nodes: Array<UserRelation>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
}

/** An edge in a connection. */
export interface UserRelationEdge {
  __typename: 'UserRelationEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<UserRelation>;
}

/** A user notification regarding a UserRelation */
export interface UserRelationNotification extends Node, NotificationInterface {
  __typename: 'UserRelationNotification';
  body: Scalars['String']['output'];
  createdAt: Scalars['ISO8601DateTime']['output'];
  deeplinkUrl: Scalars['String']['output'];
  iconUrl: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  important: Scalars['Boolean']['output'];
  markdownBody: Scalars['String']['output'];
  name: Scalars['String']['output'];
  pictureUrl?: Maybe<Scalars['String']['output']>;
  read: Scalars['Boolean']['output'];
  sport?: Maybe<SportOrShared>;
  title: Scalars['String']['output'];
  user: CurrentUser;
  userRelation: UserRelation;
}

export const UserReportCategory = {
  ABUSIVE_BEHAVIOR: 'ABUSIVE_BEHAVIOR',
  FRAUDULENT_TRADES: 'FRAUDULENT_TRADES',
  MULTI_ACCOUNTING: 'MULTI_ACCOUNTING',
  OTHER: 'OTHER',
  SCAM_OR_PHISHING: 'SCAM_OR_PHISHING'
} as const;

export type UserReportCategory = typeof UserReportCategory[keyof typeof UserReportCategory];
export const UserReportContext = {
  PROFILE: 'PROFILE'
} as const;

export type UserReportContext = typeof UserReportContext[keyof typeof UserReportContext];
/** A user selection for a deliverable item */
export interface UserSelectionInput {
  size?: InputMaybe<WearableSize>;
}

/** A Sorare user settings */
export interface UserSettings {
  __typename: 'UserSettings';
  ageLimitDisclaimer?: Maybe<Scalars['String']['output']>;
  billingAddress?: Maybe<PostalAddress>;
  cryptocurrency?: Maybe<Cryptocurrency>;
  currency?: Maybe<Currency>;
  disableAllEmails: Scalars['Boolean']['output'];
  discoverable?: Maybe<Scalars['Boolean']['output']>;
  discoverableName?: Maybe<Scalars['String']['output']>;
  fiatCurrency?: Maybe<FiatCurrency>;
  hideBalance: Scalars['Boolean']['output'];
  hideCommonCards: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  lifecycle: Scalars['Json']['output'];
  locale?: Maybe<Scalars['String']['output']>;
  maxDailyPushNotifications: Scalars['Int']['output'];
  /** Get notification settings. If no sport parameter is provided the football one will be returned */
  notificationPreferences: Array<NotificationPreference>;
  postalAddress: PostalAddress;
  rewardCurrency: Currency;
  suggestedDiscoverableName: Scalars['String']['output'];
  /** User status with regards to Sorare's TCU */
  tcuStatus: TermsAndConditionsStatus;
}


/** A Sorare user settings */
export interface UserSettingsnotificationPreferencesArgs {
  sport?: InputMaybe<SportOrShared>;
}

/** A user shop item */
export interface UserShopItem extends Node {
  __typename: 'UserShopItem';
  id: Scalars['ID']['output'];
  shopItem: ClubShopItem;
}

/** User social connections */
export interface UserSocialInterface {
  followed?: Maybe<EmailSubscription>;
  /** The `followers` field cannot be nested within a list. */
  followers: UserWithSubscriptionSlugConnection;
  followersCount: Scalars['Int']['output'];
  /** The `following` field cannot be nested within a list. */
  following: UserWithSubscriptionSlugConnection;
  followingCount: Scalars['Int']['output'];
  /** The `recommended_managers` field cannot be nested within a list. */
  recommendedManagers: UserConnection;
}


/** User social connections */
export interface UserSocialInterfacefollowersArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
}


/** User social connections */
export interface UserSocialInterfacefollowingArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
}


/** User social connections */
export interface UserSocialInterfacerecommendedManagersArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sport?: InputMaybe<Sport>;
}

/** An affiliate */
export interface UserSource extends Node {
  __typename: 'UserSource';
  category?: Maybe<UserSourceCategory>;
  displayName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  pictureUrl?: Maybe<Scalars['String']['output']>;
}

export const UserSourceCategory = {
  COMMUNITY: 'COMMUNITY',
  CREATOR: 'CREATOR',
  INFLUENCER: 'INFLUENCER',
  PARTNERSHIP: 'PARTNERSHIP'
} as const;

export type UserSourceCategory = typeof UserSourceCategory[keyof typeof UserSourceCategory];
export interface UserSportProfileInterface {
  achievementBadges?: Maybe<Array<Maybe<SkinShopItem>>>;
  /** @deprecated Not used anymore */
  availableOnboardingLeaderboards: Scalars['Boolean']['output'];
  background?: Maybe<SkinShopItem>;
  bannerColor?: Maybe<Scalars['String']['output']>;
  bannerUrl?: Maybe<Scalars['String']['output']>;
  /**
   * Up to five cards owned in the current set, or in the previous set when no set
   * is active, best gameplay tier and last ten average score first, with a single
   * card per player keeping the rarest edition owned The `best_cards` field cannot
   * be nested within a list.
   */
  bestCards: Array<BaseballCard | Card | NBACard>;
  blueprintCardsCount: Scalars['Int']['output'];
  clubBadge?: Maybe<SkinShopItem>;
  clubName?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use CardSet.starterPackClaimed instead */
  commonGameOnboarded: Scalars['Boolean']['output'];
  /** Get a deck of cards */
  deck?: Maybe<Deck>;
  /** The `decks` field cannot be nested within a list. */
  decks: DeckConnection;
  favoriteTeam?: Maybe<Club | NationalTeam>;
  forceToProOnboarding: Scalars['Boolean']['output'];
  gallerySocialPictureUrls: SocialPictureDerivative;
  highlightPro: Scalars['Boolean']['output'];
  /** The `highlighted_deck` field cannot be nested within a list. */
  highlightedDeck?: Maybe<Deck>;
  id: Scalars['ID']['output'];
  managerProfileSocialPictureUrls: SocialPictureDerivative;
  onboarded: Scalars['Boolean']['output'];
  onboardingCompetitions: Array<Competition>;
  /** @deprecated Not used anymore */
  onboardingLeaderboards: Array<OnboardingLeaderboard>;
  onboardingSo5Fixture?: Maybe<So5Fixture>;
  /**
   * The `onboarding_so5_leaderboard` field cannot be nested within a list.
   * @deprecated Not used anymore
   */
  onboardingSo5Leaderboard?: Maybe<So5Leaderboard>;
  /** A frame to apply on top of user profile picture */
  pictureFrame?: Maybe<PictureFrameShopItem>;
  /** @deprecated Player loyalty is no longer used */
  playerLoyaltyBoost: RewardBoost;
  /** @deprecated Use highlightPro instead */
  proOnboarded: Scalars['Boolean']['output'];
  proUnlocked: Scalars['Boolean']['output'];
  rarityVaultBoost: RewardBoost;
  remainingUnsealsInPeriod: Scalars['Int']['output'];
  selectedUserSportStatistics: Array<Maybe<UserSportStatistic>>;
  shieldUrl?: Maybe<Scalars['String']['output']>;
  socialPictureFingerprint: Scalars['String']['output'];
  tournamentEligibilities: Array<TournamentEligibility>;
  userSportStatistics: Array<UserSportStatistic>;
  variant: UserSportProfileVariant;
}


export interface UserSportProfileInterfaceavailableOnboardingLeaderboardsArgs {
  rarity?: InputMaybe<Rarity>;
}


export interface UserSportProfileInterfacebestCardsArgs {
  skins?: InputMaybe<Array<Skin>>;
}


export interface UserSportProfileInterfacedeckArgs {
  name?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
}


export interface UserSportProfileInterfacedecksArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
}


export interface UserSportProfileInterfaceonboardingLeaderboardsArgs {
  rarity?: InputMaybe<Rarity>;
}


export interface UserSportProfileInterfaceplayerLoyaltyBoostArgs {
  editedSeasonsCount: Scalars['Int']['input'];
  sealedCards: Scalars['Int']['input'];
}


export interface UserSportProfileInterfacerarityVaultBoostArgs {
  rarity: Rarity;
  sport: Sport;
  unseals?: InputMaybe<Scalars['Int']['input']>;
}


export interface UserSportProfileInterfaceremainingUnsealsInPeriodArgs {
  rarity: Rarity;
}

export const UserSportProfileVariant = {
  GLOBAL_CUP_22: 'GLOBAL_CUP_22',
  NONE: 'NONE',
  OFF_SEASON: 'OFF_SEASON'
} as const;

export type UserSportProfileVariant = typeof UserSportProfileVariant[keyof typeof UserSportProfileVariant];
/** Aggregated statistics for a specific user and sport */
export interface UserSportStatistic extends Node {
  __typename: 'UserSportStatistic';
  format: UserSportStatisticFormat;
  id: Scalars['ID']['output'];
  name: UserSportStatisticSlug;
  title: Scalars['String']['output'];
  value: Scalars['Int']['output'];
}

export const UserSportStatisticFormat = {
  NUMBER: 'NUMBER',
  TIMESTAMP: 'TIMESTAMP'
} as const;

export type UserSportStatisticFormat = typeof UserSportStatisticFormat[keyof typeof UserSportStatisticFormat];
export const UserSportStatisticSlug = {
  FOLLOWERS: 'FOLLOWERS',
  PRO_CARDS_OWNED: 'PRO_CARDS_OWNED',
  PRO_CARDS_WON_COUNT: 'PRO_CARDS_WON_COUNT',
  SIGNED_UP: 'SIGNED_UP'
} as const;

export type UserSportStatisticSlug = typeof UserSportStatisticSlug[keyof typeof UserSportStatisticSlug];
/** A Sorare wallet */
export interface UserWallet extends Node {
  __typename: 'UserWallet';
  /** Whether the requesting device has been confirmed */
  confirmedDevice: Scalars['Boolean']['output'];
  ethereumAddress: Scalars['EthereumAddress']['output'];
  holdsValue: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  passwordEncryptedPrivateKey?: Maybe<PasswordEncryptedPrivateKey>;
  privateKeyRecoveryPayload?: Maybe<PrivateKeyRecoveryPayload>;
  privateKeyRecoveryPayloads: Array<PrivateKeyRecoveryPayload>;
  recoveryOptions: Array<PrivateKeyRecoveryOption>;
  solanaAddress?: Maybe<Scalars['SolanaAddress']['output']>;
  starkKey: Scalars['String']['output'];
  starkKeyWithPrefix: Scalars['String']['output'];
  status: UserWalletStatusEnum;
}


/** A Sorare wallet */
export interface UserWalletprivateKeyRecoveryPayloadArgs {
  id: Scalars['String']['input'];
}

export const UserWalletStatusEnum = {
  LOCKED: 'LOCKED',
  READY: 'READY',
  RECOVERY_SENT: 'RECOVERY_SENT'
} as const;

export type UserWalletStatusEnum = typeof UserWalletStatusEnum[keyof typeof UserWalletStatusEnum];
/** A Sorare user with the subscription slug of the current user */
export interface UserWithSubscriptionSlug extends PublicUserInfoInterface, UserSocialInterface {
  __typename: 'UserWithSubscriptionSlug';
  active?: Maybe<Scalars['Boolean']['output']>;
  anyPlayer?: Maybe<BaseballPlayer | NBAPlayer | Player>;
  anyUserSportProfile?: Maybe<BaseballUserSportProfile | FootballUserSportProfile | NBAUserSportProfile>;
  baseballUserProfile?: Maybe<BaseballUserSportProfile>;
  /** Get a list of all blueprint cards */
  blueprintCards: AnyCardInterfaceConnection;
  /** The `bought_primary_offers` field cannot be nested within a list. */
  boughtPrimaryOffers: TokenPrimaryOfferConnection;
  /** The `bought_single_sale_token_offers` field cannot be nested within a list. */
  boughtSingleSaleTokenOffers: TokenOfferConnection;
  /** The `buying_token_auctions` field cannot be nested within a list. */
  buyingTokenAuctions: Array<TokenAuction>;
  /** The `card_collections` field cannot be nested within a list. */
  cardCollections?: Maybe<CardCollectionConnection>;
  cardCounts: CardCount;
  /** Get a list of all cards */
  cards: AnyCardInterfaceConnection;
  cardsCount: Scalars['Int']['output'];
  /**
   * The `competition_card_collections` field cannot be nested within a list.
   * @deprecated No longer used
   */
  competitionCardCollections: Array<CompetitionCardCollections>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  cryptocurrency?: Maybe<Cryptocurrency>;
  /** The `ended_with_no_buyer_single_sale_token_offers` field cannot be nested within a list. */
  endedWithNoBuyerSingleSaleTokenOffers: TokenOfferConnection;
  ethVaultId?: Maybe<Scalars['Int']['output']>;
  ethereumAddress?: Maybe<Scalars['EthereumAddress']['output']>;
  followed?: Maybe<EmailSubscription>;
  /** The `followers` field cannot be nested within a list. */
  followers: UserWithSubscriptionSlugConnection;
  followersCount: Scalars['Int']['output'];
  /** The `following` field cannot be nested within a list. */
  following: UserWithSubscriptionSlugConnection;
  followingCount: Scalars['Int']['output'];
  footballUserProfile?: Maybe<FootballUserSportProfile>;
  /**
   * Number of times the user won each step of the hot streak tracks of the game
   * mode. SET reads the career track of the active card set, or of the previous
   * card set when no set is active. PRO adds up the active career boards of the
   * sport, up to the longest board
   */
  hotStreakStepsWon: Array<StepWonCount>;
  /** Typical number of hours the manager takes to answer trades */
  hoursToAnswerTrades?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  /** The `live_single_sale_token_offers` field cannot be nested within a list. */
  liveSingleSaleTokenOffers: TokenOfferConnection;
  /** The `lost_token_auctions` field cannot be nested within a list. */
  lostTokenAuctions: TokenAuctionConnection;
  /** The `manager_teams` field cannot be nested within a list. */
  managerTeams: ManagerTeamConnection;
  nbaUserProfile?: Maybe<NBAUserSportProfile>;
  nickname: Scalars['String']['output'];
  ownedPlayersCount: Scalars['Int']['output'];
  pictureUrl?: Maybe<Scalars['String']['output']>;
  player?: Maybe<Player>;
  /**
   * The `podium_rankings` field cannot be nested within a list.
   * @deprecated Use so5_trophies_summary instead
   */
  podiumRankings: So5RankingConnection;
  /**
   * The `podiums` field cannot be nested within a list.
   * @deprecated Use so5_trophies_summary instead
   */
  podiums: Array<So5Podium>;
  profile: UserProfile;
  /** The `public_watchlists` field cannot be nested within a list. */
  publicWatchlists?: Maybe<WatchlistConnection>;
  /** The `recommended_managers` field cannot be nested within a list. */
  recommendedManagers: UserConnection;
  /**
   * The `rewarded_rankings` field cannot be nested within a list.
   * @deprecated Use so5_trophies_summary instead
   */
  rewardedRankings: So5RankingConnection;
  /** The `search_card_facet_values` field cannot be nested within a list. */
  searchCardFacetValues: Array<SearchFacetValue>;
  /** The `search_cards` field cannot be nested within a list. */
  searchCards: SearchCards;
  setBoard?: Maybe<CareerBoard | SquadBoard>;
  /**
   * Live step of the set tasks track, falling back to the last claimed step The
   * `set_live_tasks_track_step` field cannot be nested within a list.
   */
  setLiveTasksTrackStep?: Maybe<CardsCountTargetTask | CardsCountTask | CompleteCollectionsCountTargetTask | CompleteCollectionsCountTask | DailyActionTask | DecisivePlayerPickerTask | DropChallengeTask | GameWeeklyTask | GuessTheScoreTask | InviteTaskAsReferrer | So5LeaderboardTask | StarPackTask | Task | TasksTrack | ThresholdPickerTask | ThresholdsDuoConnectionTask | ThresholdsStreakAdditionalLineupTask | ThresholdsStreakTask>;
  /**
   * Headline stats of the user for the active card set, or for the previous card
   * set when no set is active The `set_manager_profile_stats` field cannot be
   * nested within a list.
   */
  setManagerProfileStats: Array<BestScoreManagerProfileStat | CollectionCompletionManagerProfileStat>;
  setTasksTrack?: Maybe<TasksTrack>;
  /** The `single_sale_token_offers` field cannot be nested within a list. */
  singleSaleTokenOffers: TokenOfferConnection;
  slug: Scalars['String']['output'];
  /** The `so5_trophies_summary` field cannot be nested within a list. */
  so5TrophiesSummary: TrophiesSummary;
  /** The `sold_single_sale_token_offers` field cannot be nested within a list. */
  soldSingleSaleTokenOffers: TokenOfferConnection;
  sorareAddress?: Maybe<Scalars['EthereumAddress']['output']>;
  squad?: Maybe<Squad>;
  starkKey?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  subscriptionSlug?: Maybe<Scalars['String']['output']>;
  /** Set to true if the user deleted his account or was suspended */
  suspended: Scalars['Boolean']['output'];
  tasksTracks: Array<TasksTrack>;
  /** The `token_auctions` field cannot be nested within a list. */
  tokenAuctions: TokenAuctionConnection;
  totalPlayersCount: Scalars['Int']['output'];
  /** The `trades` field cannot be nested within a list. */
  trades: TokenDealConnection;
  /**
   * The `trophies` field cannot be nested within a list.
   * @deprecated Use so5_trophies_summary instead
   */
  trophies: Array<So5Trophies>;
  userCardCollectionsPresence: Scalars['Boolean']['output'];
  /** The `won_token_auctions` field cannot be nested within a list. */
  wonTokenAuctions: TokenAuctionConnection;
}


/** A Sorare user with the subscription slug of the current user */
export interface UserWithSubscriptionSluganyUserSportProfileArgs {
  sport: Sport;
  variant?: InputMaybe<UserSportProfileVariant>;
}


/** A Sorare user with the subscription slug of the current user */
export interface UserWithSubscriptionSlugblueprintCardsArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  age?: InputMaybe<Scalars['Int']['input']>;
  assetIds?: InputMaybe<Array<Scalars['String']['input']>>;
  before?: InputMaybe<Scalars['String']['input']>;
  classicOnly?: InputMaybe<Scalars['Boolean']['input']>;
  customCardEditionName?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  inActiveCompetitions?: InputMaybe<Array<Scalars['String']['input']>>;
  inSeasonEligible?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  owned?: InputMaybe<Scalars['Boolean']['input']>;
  ownedByMe?: InputMaybe<Scalars['Boolean']['input']>;
  ownedSinceAfter?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  playerSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  positions?: InputMaybe<Array<Position>>;
  rarities?: InputMaybe<Array<Rarity>>;
  revealable?: InputMaybe<Scalars['Boolean']['input']>;
  seasonStartYears?: InputMaybe<Array<Scalars['Int']['input']>>;
  serialNumber?: InputMaybe<Scalars['Int']['input']>;
  shirtNumber?: InputMaybe<Scalars['Int']['input']>;
  slugs?: InputMaybe<Array<Scalars['String']['input']>>;
  sorts?: InputMaybe<Array<CardSort>>;
  sport?: InputMaybe<Sport>;
  teamSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  withinDeckFirst?: InputMaybe<Scalars['String']['input']>;
}


/** A Sorare user with the subscription slug of the current user */
export interface UserWithSubscriptionSlugboughtPrimaryOffersArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sortByEndDate?: InputMaybe<SortingOption>;
  sport?: InputMaybe<Array<Sport>>;
}


/** A Sorare user with the subscription slug of the current user */
export interface UserWithSubscriptionSlugboughtSingleSaleTokenOffersArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sortByEndDate?: InputMaybe<SortingOption>;
  sport?: InputMaybe<Array<Sport>>;
}


/** A Sorare user with the subscription slug of the current user */
export interface UserWithSubscriptionSlugbuyingTokenAuctionsArgs {
  newlyListed?: InputMaybe<Scalars['Boolean']['input']>;
  sport?: InputMaybe<Array<Sport>>;
}


/** A Sorare user with the subscription slug of the current user */
export interface UserWithSubscriptionSlugcardCollectionsArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  cardSetSlug?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forCompetitions?: InputMaybe<Array<Scalars['String']['input']>>;
  inSeasonOnly?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  rarities?: InputMaybe<Array<InputMaybe<Rarity>>>;
  seasonStartYears?: InputMaybe<Array<Scalars['Int']['input']>>;
  sortType?: InputMaybe<CardCollectionSortingOption>;
  sport?: InputMaybe<Sport>;
  startedOnly?: InputMaybe<Scalars['Boolean']['input']>;
  teamSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
}


/** A Sorare user with the subscription slug of the current user */
export interface UserWithSubscriptionSlugcardCountsArgs {
  sport: Sport;
}


/** A Sorare user with the subscription slug of the current user */
export interface UserWithSubscriptionSlugcardsArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  age?: InputMaybe<Scalars['Int']['input']>;
  assetIds?: InputMaybe<Array<Scalars['String']['input']>>;
  before?: InputMaybe<Scalars['String']['input']>;
  classicOnly?: InputMaybe<Scalars['Boolean']['input']>;
  customCardEditionName?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  inActiveCompetitions?: InputMaybe<Array<Scalars['String']['input']>>;
  inSeasonEligible?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  owned?: InputMaybe<Scalars['Boolean']['input']>;
  ownedByMe?: InputMaybe<Scalars['Boolean']['input']>;
  ownedSinceAfter?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  playerSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  positions?: InputMaybe<Array<Position>>;
  rarities?: InputMaybe<Array<Rarity>>;
  revealable?: InputMaybe<Scalars['Boolean']['input']>;
  seasonStartYears?: InputMaybe<Array<Scalars['Int']['input']>>;
  serialNumber?: InputMaybe<Scalars['Int']['input']>;
  shirtNumber?: InputMaybe<Scalars['Int']['input']>;
  slugs?: InputMaybe<Array<Scalars['String']['input']>>;
  sorts?: InputMaybe<Array<CardSort>>;
  sport?: InputMaybe<Sport>;
  teamSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  transferredOutAfter?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  withinDeckFirst?: InputMaybe<Scalars['String']['input']>;
}


/** A Sorare user with the subscription slug of the current user */
export interface UserWithSubscriptionSlugcompetitionCardCollectionsArgs {
  cardSetSlug: Scalars['String']['input'];
  competitionSlug?: InputMaybe<Scalars['String']['input']>;
  competitionSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  sport: Sport;
}


/** A Sorare user with the subscription slug of the current user */
export interface UserWithSubscriptionSlugendedWithNoBuyerSingleSaleTokenOffersArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sortByEndDate?: InputMaybe<SortingOption>;
  sport?: InputMaybe<Array<Sport>>;
}


/** A Sorare user with the subscription slug of the current user */
export interface UserWithSubscriptionSlugfollowersArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
}


/** A Sorare user with the subscription slug of the current user */
export interface UserWithSubscriptionSlugfollowingArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
}


/** A Sorare user with the subscription slug of the current user */
export interface UserWithSubscriptionSlugfootballUserProfileArgs {
  variant?: InputMaybe<UserSportProfileVariant>;
}


/** A Sorare user with the subscription slug of the current user */
export interface UserWithSubscriptionSlughotStreakStepsWonArgs {
  configSlug?: InputMaybe<Scalars['String']['input']>;
  gameMode: PlatformGameMode;
  sport: Sport;
}


/** A Sorare user with the subscription slug of the current user */
export interface UserWithSubscriptionSlugliveSingleSaleTokenOffersArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sortByEndDate?: InputMaybe<SortingOption>;
  sport?: InputMaybe<Array<Sport>>;
}


/** A Sorare user with the subscription slug of the current user */
export interface UserWithSubscriptionSluglostTokenAuctionsArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sortByEndDate?: InputMaybe<SortingOption>;
  sport?: InputMaybe<Array<Sport>>;
}


/** A Sorare user with the subscription slug of the current user */
export interface UserWithSubscriptionSlugmanagerTeamsArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
}


/** A Sorare user with the subscription slug of the current user */
export interface UserWithSubscriptionSlugownedPlayersCountArgs {
  cardSetSlug: Scalars['String']['input'];
  sport: Sport;
}


/** A Sorare user with the subscription slug of the current user */
export interface UserWithSubscriptionSlugpictureUrlArgs {
  derivative?: InputMaybe<Scalars['String']['input']>;
}


/** A Sorare user with the subscription slug of the current user */
export interface UserWithSubscriptionSlugpodiumRankingsArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  ranking?: InputMaybe<Scalars['Int']['input']>;
  so5LeaderboardType?: InputMaybe<So5LeaderboardType>;
  sport?: InputMaybe<Sport>;
}


/** A Sorare user with the subscription slug of the current user */
export interface UserWithSubscriptionSlugpodiumsArgs {
  sport?: InputMaybe<Sport>;
}


/** A Sorare user with the subscription slug of the current user */
export interface UserWithSubscriptionSlugpublicWatchlistsArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sport: Sport;
}


/** A Sorare user with the subscription slug of the current user */
export interface UserWithSubscriptionSlugrecommendedManagersArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sport?: InputMaybe<Sport>;
}


/** A Sorare user with the subscription slug of the current user */
export interface UserWithSubscriptionSlugrewardedRankingsArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  so5LeaderboardType?: InputMaybe<So5LeaderboardType>;
  sport?: InputMaybe<Sport>;
}


/** A Sorare user with the subscription slug of the current user */
export interface UserWithSubscriptionSlugsearchCardFacetValuesArgs {
  advancedFilters?: InputMaybe<Scalars['String']['input']>;
  cardSetSlug?: InputMaybe<Scalars['String']['input']>;
  facetQuery: Scalars['String']['input'];
  field: Scalars['String']['input'];
  filters?: InputMaybe<Array<SearchFilterInput>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  rarity?: InputMaybe<Rarity>;
  refinements?: InputMaybe<Array<SearchRefinementInput>>;
  sport?: InputMaybe<Sport>;
}


/** A Sorare user with the subscription slug of the current user */
export interface UserWithSubscriptionSlugsearchCardsArgs {
  advancedFilters?: InputMaybe<Scalars['String']['input']>;
  cardSetSlug?: InputMaybe<Scalars['String']['input']>;
  duplicatedKey?: InputMaybe<Scalars['String']['input']>;
  facets?: InputMaybe<Array<SearchFacetDefinitionInput>>;
  filters?: InputMaybe<Array<SearchFilterInput>>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  rarity?: InputMaybe<Rarity>;
  refinements?: InputMaybe<Array<SearchRefinementInput>>;
  sorts?: InputMaybe<Array<SearchSortInput>>;
  sport?: InputMaybe<Sport>;
}


/** A Sorare user with the subscription slug of the current user */
export interface UserWithSubscriptionSlugsetBoardArgs {
  mode: BoardMode;
  sport: Sport;
}


/** A Sorare user with the subscription slug of the current user */
export interface UserWithSubscriptionSlugsetLiveTasksTrackStepArgs {
  sport: Sport;
}


/** A Sorare user with the subscription slug of the current user */
export interface UserWithSubscriptionSlugsetManagerProfileStatsArgs {
  sport: Sport;
}


/** A Sorare user with the subscription slug of the current user */
export interface UserWithSubscriptionSlugsetTasksTrackArgs {
  sport: Sport;
}


/** A Sorare user with the subscription slug of the current user */
export interface UserWithSubscriptionSlugsingleSaleTokenOffersArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sortByEndDate?: InputMaybe<SortingOption>;
  sport?: InputMaybe<Array<Sport>>;
}


/** A Sorare user with the subscription slug of the current user */
export interface UserWithSubscriptionSlugso5TrophiesSummaryArgs {
  sport?: InputMaybe<Sport>;
}


/** A Sorare user with the subscription slug of the current user */
export interface UserWithSubscriptionSlugsoldSingleSaleTokenOffersArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sortByEndDate?: InputMaybe<SortingOption>;
  sport?: InputMaybe<Array<Sport>>;
}


/** A Sorare user with the subscription slug of the current user */
export interface UserWithSubscriptionSlugsquadArgs {
  sport: Sport;
}


/** A Sorare user with the subscription slug of the current user */
export interface UserWithSubscriptionSlugtasksTracksArgs {
  rarity?: InputMaybe<Rarity>;
  sport: Sport;
}


/** A Sorare user with the subscription slug of the current user */
export interface UserWithSubscriptionSlugtokenAuctionsArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sortByEndDate?: InputMaybe<SortingOption>;
  sport?: InputMaybe<Array<Sport>>;
}


/** A Sorare user with the subscription slug of the current user */
export interface UserWithSubscriptionSlugtotalPlayersCountArgs {
  cardSetSlug: Scalars['String']['input'];
  sport: Sport;
}


/** A Sorare user with the subscription slug of the current user */
export interface UserWithSubscriptionSlugtradesArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sortByEndDate?: InputMaybe<SortingOption>;
  sport?: InputMaybe<Array<Sport>>;
}


/** A Sorare user with the subscription slug of the current user */
export interface UserWithSubscriptionSlugtrophiesArgs {
  sport?: InputMaybe<Sport>;
}


/** A Sorare user with the subscription slug of the current user */
export interface UserWithSubscriptionSluguserCardCollectionsPresenceArgs {
  rarity: Rarity;
  sport: Sport;
}


/** A Sorare user with the subscription slug of the current user */
export interface UserWithSubscriptionSlugwonTokenAuctionsArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sortByEndDate?: InputMaybe<SortingOption>;
  sport?: InputMaybe<Array<Sport>>;
}

/** The connection type for UserWithSubscriptionSlug. */
export interface UserWithSubscriptionSlugConnection {
  __typename: 'UserWithSubscriptionSlugConnection';
  /** A list of edges. */
  edges: Array<UserWithSubscriptionSlugEdge>;
  /** A list of nodes. */
  nodes: Array<UserWithSubscriptionSlug>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
}

/** An edge in a connection. */
export interface UserWithSubscriptionSlugEdge {
  __typename: 'UserWithSubscriptionSlugEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<UserWithSubscriptionSlug>;
}

/** Preview of the so5 results of users in a fixture */
export interface UsersFixtureResultsPreview {
  __typename: 'UsersFixtureResultsPreview';
  totalUsersCount: Scalars['Int']['output'];
  users: Array<User>;
}

/** Utm params */
export interface UtmInput {
  partner?: InputMaybe<Scalars['String']['input']>;
  trafficCategory?: InputMaybe<Scalars['String']['input']>;
  user?: InputMaybe<Scalars['String']['input']>;
  utmCampaign?: InputMaybe<Scalars['String']['input']>;
  utmContent?: InputMaybe<Scalars['String']['input']>;
  utmMedium?: InputMaybe<Scalars['String']['input']>;
  utmSource?: InputMaybe<Scalars['String']['input']>;
  utmTerm?: InputMaybe<Scalars['String']['input']>;
}

/** A boolean value and its reason */
export interface Validity {
  __typename: 'Validity';
  missingAnyRarities: Array<Rarity>;
  missingCards: Scalars['Int']['output'];
  missingPositions: Array<Position>;
  missingRarity: Scalars['Int']['output'];
  missingVaultPoints: Scalars['Int']['output'];
  notEnoughEligibleCards: Scalars['Boolean']['output'];
  reason?: Maybe<Scalars['String']['output']>;
  transferMarketFilters?: Maybe<Scalars['String']['output']>;
  upcomingAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  value: Scalars['Boolean']['output'];
}


/** A boolean value and its reason */
export interface ValiditymissingRarityArgs {
  rarity: Rarity;
}

export interface ValueBoundaries {
  __typename: 'ValueBoundaries';
  max: Scalars['Int']['output'];
  min: Scalars['Int']['output'];
}

export interface ValueOpenBoundaries {
  __typename: 'ValueOpenBoundaries';
  max?: Maybe<Scalars['Int']['output']>;
  min?: Maybe<Scalars['Int']['output']>;
}

/** A representation of the stock count per variant on a shop item */
export interface VariantStockCount {
  __typename: 'VariantStockCount';
  currentStockCount: Scalars['Int']['output'];
  initialStockCount: Scalars['Int']['output'];
  size?: Maybe<ShirtSize>;
  variant: Scalars['String']['output'];
}

export const VariantStockCountType = {
  SHIRT_SIZE: 'SHIRT_SIZE'
} as const;

export type VariantStockCountType = typeof VariantStockCountType[keyof typeof VariantStockCountType];
/** The vault points rule of a So5Leaderboard */
export interface VaultPointsRule extends So5RuleInterface {
  __typename: 'VaultPointsRule';
  descriptions: Array<So5RuleDescription>;
  id: Scalars['String']['output'];
  key: Scalars['String']['output'];
  minVaultBoost: RewardBoost;
  rarity: Rarity;
}

/** A venue where a game is played */
export interface Venue extends Node {
  __typename: 'Venue';
  address?: Maybe<Scalars['String']['output']>;
  capacity?: Maybe<Scalars['Int']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Country>;
  id: Scalars['ID']['output'];
  latitude?: Maybe<Scalars['Float']['output']>;
  longitude?: Maybe<Scalars['Float']['output']>;
  name: Scalars['String']['output'];
}

/** JONUM compliance verification for a French user */
export interface Verification {
  __typename: 'Verification';
  dateOfBirth?: Maybe<Scalars['ISO8601Date']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  gracePeriodExpiresAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  gracePeriodStartedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  id: Scalars['ID']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
  missingInfo: Array<JonumMissingUserInfo>;
  /**
   * Pending weekly playtime limit in hours
   * @deprecated Use playtime { pendingLimitChange { limitMinutes } } instead
   */
  pendingPlaytimeLimit?: Maybe<Scalars['Float']['output']>;
  /** @deprecated Use playtime { pendingLimitChange { effectiveAt } } instead */
  pendingPlaytimeLimitEffectiveAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /**
   * Pending weekly spending limit
   * @deprecated Use spending { pendingLimitChange { limit } } instead
   */
  pendingSpendingLimit?: Maybe<MonetaryAmount>;
  /** @deprecated Use spending { pendingLimitChange { effectiveAt } } instead */
  pendingSpendingLimitEffectiveAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  playtime: PlaytimeUsage;
  /**
   * Weekly playtime limit in hours
   * @deprecated Use playtime { limitMinutes } instead
   */
  playtimeLimitWeekly?: Maybe<Scalars['Float']['output']>;
  remediationExpiresAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  restrictions: JonumRestrictions;
  reward: RewardUsage;
  selfExcludedUntil?: Maybe<Scalars['ISO8601DateTime']['output']>;
  spending: SpendingUsage;
  /** @deprecated Use spending { limit } instead */
  spendingLimitWeekly?: Maybe<MonetaryAmount>;
  status: JonumVerificationStatus;
  verifiedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
}

/** A Stripe Verification Session */
export interface VerificationSession {
  __typename: 'VerificationSession';
  clientSecret?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
}

export interface WalletInput {
  backupPrivateKeyRecoveries: Array<BackupPrivateKeyRecoveryInput>;
  ethereumAddress: Scalars['EthereumAddress']['input'];
  passwordEncryptedPrivateKey: PasswordEncryptedPrivateKeyInput;
  privateKeyRecovery: PrivateKeyRecoveryInput;
  solanaAddress?: InputMaybe<Scalars['SolanaAddress']['input']>;
  starkKeyWithPrefix: Scalars['String']['input'];
}

export const WalletStatus = {
  /** The card is stored in an account that is not managed by Sorare */
  EXTERNAL: 'EXTERNAL',
  /** The card is stored in the Sorare account */
  INTERNAL: 'INTERNAL',
  /** The card has no owner or does not belong to the user */
  UNKNOWN: 'UNKNOWN'
} as const;

export type WalletStatus = typeof WalletStatus[keyof typeof WalletStatus];
/** A watchlist */
export interface Watchlist extends Node, WithSubscriptionsInterface {
  __typename: 'Watchlist';
  /** The `common_players` field cannot be nested within a list. */
  commonPlayers: CommonPlayerConnection;
  createdAt: Scalars['ISO8601DateTime']['output'];
  currentUserSubscription?: Maybe<EmailSubscription>;
  id: Scalars['ID']['output'];
  /** @deprecated No longer used by Sorare clients */
  lastAddedPlayer?: Maybe<CommonPlayer>;
  playersPanel: Array<CommonPlayer>;
  public: Scalars['Boolean']['output'];
  /** The `search_player_facet_values` field cannot be nested within a list. */
  searchPlayerFacetValues: Array<SearchFacetValue>;
  /** The `search_players` field cannot be nested within a list. */
  searchPlayers: SearchPlayers;
  sellableCards?: Maybe<Array<BaseballCard | Card | NBACard>>;
  slug: Scalars['String']['output'];
  sport: Sport;
  subscriptionsCount: Scalars['Int']['output'];
  title: Scalars['String']['output'];
  totalPlayersCount: Scalars['Int']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
  user: User;
}


/** A watchlist */
export interface WatchlistcommonPlayersArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
}


/** A watchlist */
export interface WatchlistsearchPlayerFacetValuesArgs {
  advancedFilters?: InputMaybe<Scalars['String']['input']>;
  facetQuery: Scalars['String']['input'];
  field: Scalars['String']['input'];
  filters?: InputMaybe<Array<SearchFilterInput>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  onlyFollowed?: InputMaybe<Scalars['Boolean']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  refinements?: InputMaybe<Array<SearchRefinementInput>>;
}


/** A watchlist */
export interface WatchlistsearchPlayersArgs {
  advancedFilters?: InputMaybe<Scalars['String']['input']>;
  facets?: InputMaybe<Array<SearchFacetDefinitionInput>>;
  filters?: InputMaybe<Array<SearchFilterInput>>;
  onlyFollowed?: InputMaybe<Scalars['Boolean']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  refinements?: InputMaybe<Array<SearchRefinementInput>>;
  so5LeaderboardSlug?: InputMaybe<Scalars['String']['input']>;
  sorts?: InputMaybe<Array<SearchSortInput>>;
}


/** A watchlist */
export interface WatchlistsellableCardsArgs {
  rarity: Rarity;
}

/** The connection type for Watchlist. */
export interface WatchlistConnection {
  __typename: 'WatchlistConnection';
  /** A list of edges. */
  edges: Array<WatchlistEdge>;
  /** A list of nodes. */
  nodes: Array<Watchlist>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
}

/** An edge in a connection. */
export interface WatchlistEdge {
  __typename: 'WatchlistEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<Watchlist>;
}

export const WatchlistFilter = {
  ALL_WATCHLISTS: 'ALL_WATCHLISTS',
  FOLLOWED_WATCHLISTS: 'FOLLOWED_WATCHLISTS',
  OWNED_WATCHLISTS: 'OWNED_WATCHLISTS'
} as const;

export type WatchlistFilter = typeof WatchlistFilter[keyof typeof WatchlistFilter];
export const WatchlistSorting = {
  MOST_FOLLOWED: 'MOST_FOLLOWED',
  MOST_FOLLOWED_WITHIN_SEVEN_DAYS: 'MOST_FOLLOWED_WITHIN_SEVEN_DAYS',
  MOST_RECENTLY_ADDED_PLAYER: 'MOST_RECENTLY_ADDED_PLAYER'
} as const;

export type WatchlistSorting = typeof WatchlistSorting[keyof typeof WatchlistSorting];
/** A wearable deliverable item interface */
export interface WearableDeliverableItem extends DeliverableItemInterface {
  __typename: 'WearableDeliverableItem';
  id: Scalars['ID']['output'];
  mandatoryWearableSizeInput: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  pictureUrl: Scalars['String']['output'];
  signed: Scalars['Boolean']['output'];
  slug: Scalars['String']['output'];
  sport: Sport;
  threeDimensionalAssetUrl?: Maybe<Scalars['String']['output']>;
}


/** A wearable deliverable item interface */
export interface WearableDeliverableItempictureUrlArgs {
  derivative?: InputMaybe<DeliverableItemDerivative>;
}


/** A wearable deliverable item interface */
export interface WearableDeliverableItemthreeDimensionalAssetUrlArgs {
  format?: InputMaybe<DeliverableItemThreeDimensionalAssetFormat>;
}

export const WearableSize = {
  L: 'L',
  M: 'M',
  S: 'S',
  XL: 'XL',
  XS: 'XS',
  XXL: 'XXL'
} as const;

export type WearableSize = typeof WearableSize[keyof typeof WearableSize];
/** A weekly deals market set section */
export interface WeeklyDeals extends MarketSetSection {
  __typename: 'WeeklyDeals';
  backgroundUrl?: Maybe<Scalars['String']['output']>;
  cardPacks: Array<CardPack>;
  endsAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** @deprecated Not used anymore */
  hoverColor?: Maybe<Scalars['String']['output']>;
  mainColor?: Maybe<Scalars['String']['output']>;
  resetAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  title: Scalars['String']['output'];
  titleBackgroundUrl?: Maybe<Scalars['String']['output']>;
}

/** A wheel config */
export interface WheelConfig extends Node {
  __typename: 'WheelConfig';
  algoliaFilters?: Maybe<Scalars['String']['output']>;
  bidToEarnRewardConfigs: Array<BidToEarnRewardConfig>;
  dailyClaimTask: Scalars['Boolean']['output'];
  endDate: Scalars['ISO8601DateTime']['output'];
  id: Scalars['ID']['output'];
  logoUrl?: Maybe<Scalars['String']['output']>;
  rarity: Rarity;
  rewardPurchaseEligibilityRules?: Maybe<WheelTicketEligibilityRules>;
  slug: Scalars['String']['output'];
  sport: Sport;
  startDate: Scalars['ISO8601DateTime']['output'];
  ticketDistributionEndDate: Scalars['ISO8601DateTime']['output'];
  ticketsRewardedAfterPurchase?: Maybe<InGameCurrencyRewardConfig>;
  title: Scalars['String']['output'];
  wheelCost: WheelCost;
  wheelOdds?: Maybe<ProbabilisticBundleConfig>;
}


/** A wheel config */
export interface WheelConfigwheelCostArgs {
  wheelType: WheelType;
}


/** A wheel config */
export interface WheelConfigwheelOddsArgs {
  wheelType: WheelType;
}

export interface WheelCost {
  __typename: 'WheelCost';
  currency: InGameCurrency;
  quantity: Scalars['Int']['output'];
  wheelType: WheelType;
}

export interface WheelTicketEligibilityRules extends CardEligibilityRulesInterface {
  __typename: 'WheelTicketEligibilityRules';
  eligibleCardEditions?: Maybe<Array<Scalars['String']['output']>>;
  eligibleCompetitions?: Maybe<Array<Competition>>;
  eligibleRarities?: Maybe<Array<Rarity>>;
  eligibleSerialNumbers?: Maybe<Array<Scalars['String']['output']>>;
  eligibleSo5Leagues?: Maybe<Array<Scalars['String']['output']>>;
  eligibleTeams?: Maybe<Array<Team>>;
  id: Scalars['String']['output'];
}

export interface WheelTicketRewardsInterface {
  wheelTicketsRewardedAfterPurchase: Array<InGameCurrencyRewardConfig>;
}

export const WheelType = {
  GOLDEN: 'GOLDEN',
  STANDARD: 'STANDARD'
} as const;

export type WheelType = typeof WheelType[keyof typeof WheelType];
export interface WinningLineup {
  __typename: 'WinningLineup';
  so5Leaderboard: So5Leaderboard;
  so5League: So5League;
  so5Lineup: So5Lineup;
}

export interface WithComposeTeamInterface {
  /** Whether some appearances are filled by a contributor rather than the lineup owner. */
  collaborative: Scalars['Boolean']['output'];
  defaultSortType: BenchSort;
  displayedTypedRules: Array<CardsCountAsFirstOwnerRule | OwnedSinceRule | PlayerHeightRule | SeasonsRule | So5ActiveClubsRule | So5ActiveNationalTeamsRule | So5AgeRule | So5AppearancesRule | So5AtLeastOfClubs | So5AtLeastOfCompetitions | So5AverageScoresRule | So5CaptainRule | So5CaptainScarcityRule | So5CardEditionsCountRule | So5CompetitionsRule | So5EntryItemRule | So5MaximumPlayersAverageScoreRule | So5MinimumPlayersAverageScoreRule | So5NationalityRule | So5NotNationalityRule | So5SameActiveClubRule | So5ScarcityRule | So5SeasonBonusRule | VaultPointsRule>;
  engineConfiguration: EngineConfiguration;
  /** The `highlighted_recommendations` field cannot be nested within a list. */
  highlightedRecommendations: Array<PlayerRecommendation>;
  /** The `my_filtered_bench` field cannot be nested within a list. */
  myFilteredBench: ComposeTeamBenchObjectInterfaceConnection;
  myLineups: Array<GuessTheScoreTaskLineup | So5Lineup | TaskLineup | ThresholdPickerTaskLineup>;
  possibleBenchSortingTypes: Array<SortingType>;
  previewSo5Lineup: ComposeTeamLineupPreview;
  rewardMultiplierConfiguration?: Maybe<RewardMultiplierConfiguration>;
  /** The `top_recommendations` field cannot be nested within a list. */
  topRecommendations: Array<PlayerRecommendation>;
}


export interface WithComposeTeamInterfacehighlightedRecommendationsArgs {
  positions?: InputMaybe<Array<Position>>;
  recommendationEngine: RecommendationEngine;
  sport: Sport;
}


export interface WithComposeTeamInterfacemyFilteredBenchArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filters: BenchFilterInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  stackByCardData?: InputMaybe<Scalars['Boolean']['input']>;
  topByPosition?: InputMaybe<Scalars['Int']['input']>;
}


export interface WithComposeTeamInterfacepreviewSo5LineupArgs {
  appearances: Array<So5AppearanceInput>;
}


export interface WithComposeTeamInterfacetopRecommendationsArgs {
  filters?: InputMaybe<BenchFilterInput>;
  playingHomeOnly?: InputMaybe<Scalars['Boolean']['input']>;
  positions?: InputMaybe<Array<Position>>;
  query?: InputMaybe<Scalars['String']['input']>;
  recommendationEngine: RecommendationEngine;
  sortType?: InputMaybe<EligibleCardsSort>;
  sport: Sport;
  starterOddsBasisPointsRange?: InputMaybe<RangeInput>;
}

/** Favorites */
export interface WithFavoriteInterface {
  mySubscriptions: EmailSubscriptionConnection;
}


/** Favorites */
export interface WithFavoriteInterfacemySubscriptionsArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sortType?: InputMaybe<SortingOption>;
  types?: InputMaybe<Array<SubscribableType>>;
}

/** Notifications */
export interface WithNotifications {
  anyNotifications: NotificationInterfaceConnection;
  /** Get the last notification created_at */
  lastNotificationCreatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Get the last unread notification created_at */
  lastUnreadNotificationCreatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  unreadNotificationsCount: Scalars['Int']['output'];
}


/** Notifications */
export interface WithNotificationsanyNotificationsArgs {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  categories?: InputMaybe<Array<NotificationCategoryInput>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sections?: InputMaybe<Array<Scalars['String']['input']>>;
  sports?: InputMaybe<Array<Sport>>;
  subsections?: InputMaybe<Array<Scalars['String']['input']>>;
}


/** Notifications */
export interface WithNotificationsunreadNotificationsCountArgs {
  categories?: InputMaybe<Array<NotificationCategoryInput>>;
  sports?: InputMaybe<Array<Sport>>;
}

export const WithOwnedCardsScope = {
  EXCLUDING_SNAPSHOTTED: 'EXCLUDING_SNAPSHOTTED',
  INCLUDING_SNAPSHOTTED: 'INCLUDING_SNAPSHOTTED'
} as const;

export type WithOwnedCardsScope = typeof WithOwnedCardsScope[keyof typeof WithOwnedCardsScope];
/** With Referral Interface */
export interface WithReferralsInterface {
  /** Link to share to invite managers to play on behalf of this referrer */
  inviteLink: Scalars['String']['output'];
  inviteTaskAsReferee?: Maybe<CardsCountTargetTask | CardsCountTask | CompleteCollectionsCountTargetTask | CompleteCollectionsCountTask | DailyActionTask | DecisivePlayerPickerTask | DropChallengeTask | GameWeeklyTask | GuessTheScoreTask | InviteTaskAsReferrer | So5LeaderboardTask | StarPackTask | Task | TasksTrack | ThresholdPickerTask | ThresholdsDuoConnectionTask | ThresholdsStreakAdditionalLineupTask | ThresholdsStreakTask>;
  inviteTasksAsReferee?: Maybe<Array<CardsCountTargetTask | CardsCountTask | CompleteCollectionsCountTargetTask | CompleteCollectionsCountTask | DailyActionTask | DecisivePlayerPickerTask | DropChallengeTask | GameWeeklyTask | GuessTheScoreTask | InviteTaskAsReferrer | So5LeaderboardTask | StarPackTask | Task | TasksTrack | ThresholdPickerTask | ThresholdsDuoConnectionTask | ThresholdsStreakAdditionalLineupTask | ThresholdsStreakTask>>;
  inviteTasksAsReferrer: Array<CardsCountTargetTask | CardsCountTask | CompleteCollectionsCountTargetTask | CompleteCollectionsCountTask | DailyActionTask | DecisivePlayerPickerTask | DropChallengeTask | GameWeeklyTask | GuessTheScoreTask | InviteTaskAsReferrer | So5LeaderboardTask | StarPackTask | Task | TasksTrack | ThresholdPickerTask | ThresholdsDuoConnectionTask | ThresholdsStreakAdditionalLineupTask | ThresholdsStreakTask>;
  referee: Scalars['Boolean']['output'];
  refereeRewards: Array<ReferralReward>;
  referralAsReferee?: Maybe<Referral>;
  referralRewardsCount: Scalars['Int']['output'];
  /** @deprecated Use inviteLink instead, which carries the acquisition attribution context. */
  referralUrl: Scalars['String']['output'];
  /** Get the list of referrals */
  referrals: ReferralPaginated;
  referrer?: Maybe<User>;
  referrerCode?: Maybe<Scalars['String']['output']>;
  referrerCodeDeadline?: Maybe<Scalars['ISO8601DateTime']['output']>;
  unclaimedReferralRewardsCount: Scalars['Int']['output'];
}


/** With Referral Interface */
export interface WithReferralsInterfaceinviteLinkArgs {
  gameMode: PlatformGameMode;
  sport: Sport;
}


/** With Referral Interface */
export interface WithReferralsInterfaceinviteTaskAsRefereeArgs {
  sport: Sport;
}


/** With Referral Interface */
export interface WithReferralsInterfaceinviteTasksAsRefereeArgs {
  sport: Sport;
}


/** With Referral Interface */
export interface WithReferralsInterfaceinviteTasksAsReferrerArgs {
  sport: Sport;
}


/** With Referral Interface */
export interface WithReferralsInterfacereferralAsRefereeArgs {
  sport?: InputMaybe<Sport>;
}


/** With Referral Interface */
export interface WithReferralsInterfacereferralsArgs {
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  sport?: InputMaybe<Sport>;
  state?: InputMaybe<ReferralState>;
}

export interface WithSubscriptionsInterface {
  currentUserSubscription?: Maybe<EmailSubscription>;
  slug: Scalars['String']['output'];
  subscriptionsCount: Scalars['Int']['output'];
}

/** A withdrawal */
export interface Withdrawal extends Node {
  __typename: 'Withdrawal';
  agreedFeeAmount: Scalars['WeiAmount']['output'];
  amount: Scalars['WeiAmount']['output'];
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['ID']['output'];
  quantizedAmount: Scalars['String']['output'];
  status: WithdrawalStatus;
  to: Scalars['String']['output'];
  transactionHash?: Maybe<Scalars['String']['output']>;
}

export const WithdrawalState = {
  CANCELLED: 'CANCELLED',
  CREATED: 'CREATED',
  FAILED: 'FAILED',
  FINALIZED: 'FINALIZED',
  PROCESSING: 'PROCESSING',
  REFUNDED: 'REFUNDED'
} as const;

export type WithdrawalState = typeof WithdrawalState[keyof typeof WithdrawalState];
export const WithdrawalStatus = {
  /** Withdrawal was cancelled */
  CANCELLED: 'CANCELLED',
  /** Withdrawal is confirmed */
  CONFIRMED: 'CONFIRMED',
  /** Withdrawal is created and should be confirmed */
  CREATED: 'CREATED',
  /** Withdrawal has settled on the blockchain */
  SETTLED: 'SETTLED',
  /** Withdrawal has failed */
  SETTLEMENT_FAILED: 'SETTLEMENT_FAILED',
  /** Withdrawal has been published on the blockchain */
  SETTLEMENT_PUBLISHED: 'SETTLEMENT_PUBLISHED'
} as const;

export type WithdrawalStatus = typeof WithdrawalStatus[keyof typeof WithdrawalStatus];
/** A withdrawal with conversion rates */
export interface WithdrawalWithRates extends Node {
  __typename: 'WithdrawalWithRates';
  agreedFeeAmount: Scalars['WeiAmount']['output'];
  amount: Scalars['WeiAmount']['output'];
  amounts: MonetaryAmount;
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['ID']['output'];
  quantizedAmount: Scalars['String']['output'];
  status: WithdrawalStatus;
  to: Scalars['String']['output'];
  transactionHash?: Maybe<Scalars['String']['output']>;
}

export interface XPBoosterShopItemInterface {
  endLevel: Scalars['Int']['output'];
  rarity: Rarity;
  startLevel: Scalars['Int']['output'];
}

/** A promotional event that temporarily removes the cooldown of purchased cards up to a given grade */
export interface XPCooldownPromotionalEvent extends Node, PromotionalEventInterface {
  __typename: 'XPCooldownPromotionalEvent';
  algoliaFilters: Scalars['String']['output'];
  backgroundPictureUrl?: Maybe<Scalars['String']['output']>;
  bannerAssetsPictureUrl?: Maybe<Scalars['String']['output']>;
  blogUrl?: Maybe<Scalars['String']['output']>;
  description: Scalars['String']['output'];
  eligibilityRules: EligibilityRules;
  endDate: Scalars['ISO8601DateTime']['output'];
  filterPictureUrl?: Maybe<Scalars['String']['output']>;
  heroValueProps: Array<HeroValueProp>;
  id: Scalars['ID']['output'];
  logoUrl?: Maybe<Scalars['String']['output']>;
  marketBannerTitle: Scalars['String']['output'];
  mobileBackgroundPictureUrl?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  pictureUrl?: Maybe<Scalars['String']['output']>;
  probableRewardConfigs: Array<ProbableRewardConfig>;
  promotionType: PromotionType;
  secondaryBannerPictureUrl?: Maybe<Scalars['String']['output']>;
  slug: Scalars['String']['output'];
  sport: Sport;
  startDate: Scalars['ISO8601DateTime']['output'];
  stopCooldownUpToGrade: Scalars['Int']['output'];
  termsAndConditionsUrl?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
}

/** Autogenerated input type of acceptOffer */
export interface acceptOfferInput {
  approvals: Array<AuthorizationApprovalInput>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  migrationData?: InputMaybe<OfferMigrationInput>;
  /** Global ID of the Offer or PrimaryOffer to accept. */
  offerId: Scalars['ID']['input'];
  settlementInfo: AcceptorSettlementInfoInput;
  /** The signed amount to be used for dynamic price offers */
  signedAmount?: InputMaybe<Scalars['String']['input']>;
}

/** Autogenerated return type of acceptOffer. */
export interface acceptOfferPayload {
  __typename: 'acceptOfferPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  currentUser?: Maybe<CurrentUser>;
  deal?: Maybe<TokenDeal>;
  errors: Array<UserError>;
  rewards?: Maybe<Array<AnyCardReward | AnyConversionCreditReward | CardPackReward | CardShardsReward | CoinReward | DeliverableItemReward | ExperienceReward | InGameCurrencyReward | MonetaryReward | ProbabilisticBundleReward | ShopItemReward>>;
  /** The sport-agnostic offer */
  tokenOffer?: Maybe<TokenOffer>;
}

/** Autogenerated input type of acceptSo5NoCardBoardDraftableAppearance */
export interface acceptSo5NoCardBoardDraftableAppearanceInput {
  accessToken: Scalars['String']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  sport: Sport;
}

/** Autogenerated return type of acceptSo5NoCardBoardDraftableAppearance. */
export interface acceptSo5NoCardBoardDraftableAppearancePayload {
  __typename: 'acceptSo5NoCardBoardDraftableAppearancePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  currentUser?: Maybe<CurrentUser>;
  draftableAppearance?: Maybe<So5NoCardDraftableAppearance>;
  errors: Array<UserError>;
}

/** Autogenerated input type of acceptSo5NoCardDraftableAppearance */
export interface acceptSo5NoCardDraftableAppearanceInput {
  accessToken: Scalars['String']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  so5FixtureId: Scalars['ID']['input'];
}

/** Autogenerated return type of acceptSo5NoCardDraftableAppearance. */
export interface acceptSo5NoCardDraftableAppearancePayload {
  __typename: 'acceptSo5NoCardDraftableAppearancePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  currentUser?: Maybe<CurrentUser>;
  draftableAppearance?: Maybe<So5NoCardDraftableAppearance>;
  errors: Array<UserError>;
}

/** Autogenerated input type of acceptSo5NoCardLineup */
export interface acceptSo5NoCardLineupInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  so5NoCardLineupId: Scalars['ID']['input'];
}

/** Autogenerated return type of acceptSo5NoCardLineup. */
export interface acceptSo5NoCardLineupPayload {
  __typename: 'acceptSo5NoCardLineupPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  currentUser?: Maybe<CurrentUser>;
  errors: Array<UserError>;
  so5NoCardLineup?: Maybe<So5NoCardLineup>;
}

/** Autogenerated input type of acceptTerms */
export interface acceptTermsInput {
  acceptAgeLimit?: InputMaybe<Scalars['Boolean']['input']>;
  acceptGameRules: Scalars['Boolean']['input'];
  acceptPrivacyPolicy: Scalars['Boolean']['input'];
  acceptTerms: Scalars['Boolean']['input'];
  agreedToReceiveOffersFromPartners?: InputMaybe<Scalars['Boolean']['input']>;
  agreedToReceiveOffersFromPartnersSpecific?: InputMaybe<Array<Scalars['String']['input']>>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  tcuToken?: InputMaybe<Scalars['String']['input']>;
}

/** Autogenerated input type of acknowledgeStep */
export interface acknowledgeStepInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  stepId: Scalars['String']['input'];
}

/** Autogenerated return type of acknowledgeStep. */
export interface acknowledgeStepPayload {
  __typename: 'acknowledgeStepPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  currentUser?: Maybe<CurrentUser>;
  errors: Array<UserError>;
  rewards?: Maybe<Array<AnyCardReward | AnyConversionCreditReward | CardPackReward | CardShardsReward | CoinReward | DeliverableItemReward | ExperienceReward | InGameCurrencyReward | MonetaryReward | ProbabilisticBundleReward | ShopItemReward>>;
  step?: Maybe<CareerProStep | CareerStep | SquadStep>;
}

/** Autogenerated input type of activateWalletRecovery */
export interface activateWalletRecoveryInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Use recoveryOptionId, which does not require the plaintext destination */
  destination?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Use recoveryOptionId, which does not require the plaintext destination */
  method?: InputMaybe<PrivateKeyRecoveryOptionMethodEnum>;
  recoveryOptionId?: InputMaybe<Scalars['ID']['input']>;
  verificationCode: Scalars['String']['input'];
}

/** Autogenerated return type of activateWalletRecovery. */
export interface activateWalletRecoveryPayload {
  __typename: 'activateWalletRecoveryPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  currentUser?: Maybe<CurrentUser>;
  errors: Array<UserError>;
}

/** Autogenerated input type of addAuctionReminder */
export interface addAuctionReminderInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  tokenAuctionId: Scalars['ID']['input'];
}

/** Autogenerated return type of addAuctionReminder. */
export interface addAuctionReminderPayload {
  __typename: 'addAuctionReminderPayload';
  auction?: Maybe<TokenAuction>;
  auctionReminder?: Maybe<AuctionReminder>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  currentUser?: Maybe<CurrentUser>;
  errors: Array<UserError>;
}

/** Autogenerated input type of addDevice */
export interface addDeviceInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  verificationType?: InputMaybe<DeviceVerificationMode>;
}

/** Autogenerated return type of addDevice. */
export interface addDevicePayload {
  __typename: 'addDevicePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  currentUser?: Maybe<CurrentUser>;
  deliveryType?: Maybe<Array<Delivery>>;
  errors: Array<UserError>;
}

/** Autogenerated input type of addReferrerCode */
export interface addReferrerCodeInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  referrerCode: Scalars['String']['input'];
}

/** Autogenerated return type of addReferrerCode. */
export interface addReferrerCodePayload {
  __typename: 'addReferrerCodePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  currentUser?: Maybe<CurrentUser>;
  errors: Array<UserError>;
}

/** Autogenerated input type of addSolanaAddress */
export interface addSolanaAddressInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  solanaAddress: Scalars['SolanaAddress']['input'];
}

/** Autogenerated return type of addSolanaAddress. */
export interface addSolanaAddressPayload {
  __typename: 'addSolanaAddressPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  currentUser?: Maybe<CurrentUser>;
  errors: Array<UserError>;
}

/** Autogenerated input type of addToCart */
export interface addToCartInput {
  cardSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  cartItemIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  sport: Sport;
}

/** Autogenerated return type of addToCart. */
export interface addToCartPayload {
  __typename: 'addToCartPayload';
  cart?: Maybe<Cart>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  currentUser?: Maybe<CurrentUser>;
  errors: Array<UserError>;
}

/** Autogenerated input type of addToWatchlist */
export interface addToWatchlistInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  printablePlayerIds: Array<Scalars['ID']['input']>;
  watchlistId?: InputMaybe<Scalars['ID']['input']>;
}

/** Autogenerated return type of addToWatchlist. */
export interface addToWatchlistPayload {
  __typename: 'addToWatchlistPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  currentUser?: Maybe<CurrentUser>;
  errors: Array<UserError>;
  watchlist?: Maybe<Watchlist>;
}

/** Autogenerated input type of addTokensToDeck */
export interface addTokensToDeckInput {
  assetIds?: InputMaybe<Array<Scalars['String']['input']>>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  deckSlug: Scalars['String']['input'];
  slugs?: InputMaybe<Array<Scalars['String']['input']>>;
}

/** Autogenerated return type of addTokensToDeck. */
export interface addTokensToDeckPayload {
  __typename: 'addTokensToDeckPayload';
  cards?: Maybe<Array<BaseballCard | Card | NBACard>>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  currentUser?: Maybe<CurrentUser>;
  deck?: Maybe<Deck>;
  errors: Array<UserError>;
}

/** Autogenerated input type of addWalletRecovery */
export interface addWalletRecoveryInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  otpAttempt?: InputMaybe<Scalars['String']['input']>;
  privateKeyRecovery: PrivateKeyRecoveryInput;
}

/** Autogenerated return type of addWalletRecovery. */
export interface addWalletRecoveryPayload {
  __typename: 'addWalletRecoveryPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  currentUser?: Maybe<CurrentUser>;
  errors: Array<UserError>;
}

/** Autogenerated input type of approveMigrator */
export interface approveMigratorInput {
  address: Scalars['String']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  nonce: Scalars['Int']['input'];
  signature: Scalars['String']['input'];
}

/** Autogenerated return type of approveMigrator. */
export interface approveMigratorPayload {
  __typename: 'approveMigratorPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<UserError>;
}

/** Autogenerated input type of askForProxyConsent */
export interface askForProxyConsentInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  returnUrl: Scalars['String']['input'];
}

/** Autogenerated return type of askForProxyConsent. */
export interface askForProxyConsentPayload {
  __typename: 'askForProxyConsentPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<UserError>;
  mangopayConsentUrl?: Maybe<Scalars['String']['output']>;
}

/** Autogenerated input type of bid */
export interface bidInput {
  /** Amount in the currency provided in settlement info */
  amount: Scalars['String']['input'];
  approvals: Array<AuthorizationApprovalInput>;
  /** Global ID of the english auction to bid on */
  auctionId: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  settlementInfo: AcceptorSettlementInfoInput;
}

/** Autogenerated return type of bid. */
export interface bidPayload {
  __typename: 'bidPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  currentUser?: Maybe<CurrentUser>;
  errors: Array<UserError>;
  /** The sport-agnostic bid */
  tokenBid?: Maybe<TokenBid>;
}

/** Autogenerated input type of blockUserOffers */
export interface blockUserOffersInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  userSlug: Scalars['String']['input'];
}

/** Autogenerated return type of blockUserOffers. */
export interface blockUserOffersPayload {
  __typename: 'blockUserOffersPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  currentUser?: Maybe<CurrentUser>;
  errors: Array<UserError>;
}

/** Autogenerated input type of buyCardPack */
export interface buyCardPackInput {
  cardPackSlug: Scalars['String']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  interactionContext?: InputMaybe<Scalars['String']['input']>;
  sport: Sport;
}

/** Autogenerated return type of buyCardPack. */
export interface buyCardPackPayload {
  __typename: 'buyCardPackPayload';
  cards?: Maybe<Array<BaseballCard | Card | NBACard>>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  currentUser?: Maybe<CurrentUser>;
  errors: Array<UserError>;
  pack?: Maybe<Pack>;
}

/** Autogenerated input type of cancelBankWithdrawal */
export interface cancelBankWithdrawalInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  withdrawalId: Scalars['ID']['input'];
}

/** Autogenerated return type of cancelBankWithdrawal. */
export interface cancelBankWithdrawalPayload {
  __typename: 'cancelBankWithdrawalPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  currentUser?: Maybe<CurrentUser>;
  errors: Array<UserError>;
  withdrawal?: Maybe<BankWithdrawal>;
}

/** Autogenerated input type of cancelMobilePurchase */
export interface cancelMobilePurchaseInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Global ID of the Offer or PrimaryOffer or GoogleProductId to cancel. */
  offerId: Scalars['ID']['input'];
}

/** Autogenerated return type of cancelMobilePurchase. */
export interface cancelMobilePurchasePayload {
  __typename: 'cancelMobilePurchasePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deal?: Maybe<TokenPrimaryOffer>;
  errors: Array<UserError>;
}

/** Autogenerated input type of cancelOffer */
export interface cancelOfferInput {
  blockchainId: Scalars['String']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
}

/** Autogenerated return type of cancelOffer. */
export interface cancelOfferPayload {
  __typename: 'cancelOfferPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  currentUser?: Maybe<CurrentUser>;
  errors: Array<UserError>;
  /** The sport-agnostic offer */
  tokenOffer?: Maybe<TokenOffer>;
}

/** Autogenerated input type of changePassword */
export interface changePasswordInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  newPasswordHash: Scalars['String']['input'];
  passwordEncryptedPrivateKey: PasswordEncryptedPrivateKeyInput;
  passwordHash: Scalars['String']['input'];
}

/** Autogenerated return type of changePassword. */
export interface changePasswordPayload {
  __typename: 'changePasswordPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  currentUser?: Maybe<CurrentUser>;
  errors: Array<UserError>;
}

/** Autogenerated input type of checkPhoneNumberVerificationCode */
export interface checkPhoneNumberVerificationCodeInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  code: Scalars['String']['input'];
  privateKeyRecovery?: InputMaybe<PrivateKeyRecoveryInput>;
}

/** Autogenerated return type of checkPhoneNumberVerificationCode. */
export interface checkPhoneNumberVerificationCodePayload {
  __typename: 'checkPhoneNumberVerificationCodePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  currentUser?: Maybe<CurrentUser>;
  errors: Array<UserError>;
}

/** Autogenerated input type of claimAllSetRaffleTasks */
export interface claimAllSetRaffleTasksInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  sport: Sport;
}

/** Autogenerated return type of claimAllSetRaffleTasks. */
export interface claimAllSetRaffleTasksPayload {
  __typename: 'claimAllSetRaffleTasksPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  currentUser?: Maybe<CurrentUser>;
  errors: Array<UserError>;
  remainingTasksCount?: Maybe<Scalars['Int']['output']>;
  /** The merged configs of claimed rewards */
  rewardConfigs?: Maybe<Array<CardPacksRewardConfig | CardRewardConfig | CardShardRewardConfig | CoinRewardConfig | ConversionCreditRewardConfig | DeliverableItemRewardConfig | ExperienceRewardConfig | InGameCurrencyRewardConfig | MonetaryRewardConfig | ProbabilisticBundleRewardConfig | ShopItemRewardConfig>>;
}

/** Autogenerated input type of claimAnyReward */
export interface claimAnyRewardInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  rewardId: Scalars['ID']['input'];
}

/** Autogenerated return type of claimAnyReward. */
export interface claimAnyRewardPayload {
  __typename: 'claimAnyRewardPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  currentUser?: Maybe<CurrentUser>;
  errors: Array<UserError>;
  reward?: Maybe<AnyCardReward | AnyConversionCreditReward | CardPackReward | CardShardsReward | CoinReward | DeliverableItemReward | ExperienceReward | InGameCurrencyReward | MonetaryReward | ProbabilisticBundleReward | ShopItemReward>;
}

/** Autogenerated input type of claimCardsFromPack */
export interface claimCardsFromPackInput {
  chosenCardSlugs: Array<Scalars['String']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  packId: Scalars['ID']['input'];
}

/** Autogenerated return type of claimCardsFromPack. */
export interface claimCardsFromPackPayload {
  __typename: 'claimCardsFromPackPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  currentUser?: Maybe<CurrentUser>;
  errors: Array<UserError>;
  pack?: Maybe<Pack>;
}

/** Autogenerated input type of claimConversionCredit */
export interface claimConversionCreditInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  conversionCreditId?: InputMaybe<Scalars['ID']['input']>;
  promoCode?: InputMaybe<Scalars['String']['input']>;
}

/** Autogenerated return type of claimConversionCredit. */
export interface claimConversionCreditPayload {
  __typename: 'claimConversionCreditPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  conversionCredit?: Maybe<ConversionCredit>;
  currentUser?: Maybe<CurrentUser>;
  errors: Array<UserError>;
}

/** Autogenerated input type of claimDeliverableItemOrder */
export interface claimDeliverableItemOrderInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  deliverableItemOrderId: Scalars['ID']['input'];
  postalAddress: PostalAddressInput;
  userSelection: UserSelectionInput;
}

/** Autogenerated return type of claimDeliverableItemOrder. */
export interface claimDeliverableItemOrderPayload {
  __typename: 'claimDeliverableItemOrderPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deliverableItemOrder?: Maybe<DeliverableItemOrder>;
  errors: Array<UserError>;
}

/** Autogenerated input type of claimOnboardingConversionCredit */
export interface claimOnboardingConversionCreditInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  sport: Sport;
}

/** Autogenerated return type of claimOnboardingConversionCredit. */
export interface claimOnboardingConversionCreditPayload {
  __typename: 'claimOnboardingConversionCreditPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  conversionCredit?: Maybe<ConversionCredit>;
  errors: Array<UserError>;
}

/** Autogenerated input type of claimOnboardingEnergyGift */
export interface claimOnboardingEnergyGiftInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  sport: Sport;
}

/** Autogenerated return type of claimOnboardingEnergyGift. */
export interface claimOnboardingEnergyGiftPayload {
  __typename: 'claimOnboardingEnergyGiftPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  currentUser?: Maybe<CurrentUser>;
  errors: Array<UserError>;
  /** @deprecated Energy is deprecated */
  giftedEnergies: Array<InGameCurrencyBalance>;
}

/** Autogenerated input type of claimPromotionalEventAirdrop */
export interface claimPromotionalEventAirdropInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  promotionalEventId: Scalars['ID']['input'];
}

/** Autogenerated return type of claimPromotionalEventAirdrop. */
export interface claimPromotionalEventAirdropPayload {
  __typename: 'claimPromotionalEventAirdropPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  currentUser?: Maybe<CurrentUser>;
  errors: Array<UserError>;
  promotionalEvent?: Maybe<AirdropPromotionalEvent>;
}

/** Autogenerated input type of claimReferralReward */
export interface claimReferralRewardInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  referralRewardId: Scalars['ID']['input'];
}

/** Autogenerated return type of claimReferralReward. */
export interface claimReferralRewardPayload {
  __typename: 'claimReferralRewardPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  currentUser?: Maybe<CurrentUser>;
  errors: Array<UserError>;
  referralReward?: Maybe<ReferralReward>;
}

/** Autogenerated input type of claimReward */
export interface claimRewardInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  signedAlternativeRewardConfigs?: InputMaybe<Scalars['String']['input']>;
  so5RewardId: Scalars['ID']['input'];
}

/** Autogenerated return type of claimReward. */
export interface claimRewardPayload {
  __typename: 'claimRewardPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  currentUser?: Maybe<CurrentUser>;
  errors: Array<UserError>;
  so5Reward?: Maybe<So5Reward>;
}

/** Autogenerated input type of claimRewards */
export interface claimRewardsInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  so5RewardIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  so5RewardsWithSignedAlternative?: InputMaybe<Array<So5RewardWithSignedAlternativeInput>>;
}

/** Autogenerated return type of claimRewards. */
export interface claimRewardsPayload {
  __typename: 'claimRewardsPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  currentUser?: Maybe<CurrentUser>;
  errors: Array<UserError>;
  so5Rewards?: Maybe<Array<So5Reward>>;
}

/** Autogenerated input type of claimStarterPack */
export interface claimStarterPackInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  favoriteTeamSlug?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Not used anymore */
  onboardingSo5LeaderboardId?: InputMaybe<Scalars['ID']['input']>;
  sport: Sport;
  starPlayerSlug?: InputMaybe<Scalars['String']['input']>;
}

/** Autogenerated return type of claimStarterPack. */
export interface claimStarterPackPayload {
  __typename: 'claimStarterPackPayload';
  cards?: Maybe<Array<BaseballCard | Card | NBACard>>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  currentUser?: Maybe<CurrentUser>;
  errors: Array<UserError>;
  onboardingPack?: Maybe<Pack>;
  pack?: Maybe<CardPack>;
}

/** Autogenerated input type of claimStep */
export interface claimStepInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  stepId: Scalars['String']['input'];
}

/** Autogenerated return type of claimStep. */
export interface claimStepPayload {
  __typename: 'claimStepPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  currentUser?: Maybe<CurrentUser>;
  errors: Array<UserError>;
  rewards?: Maybe<Array<AnyCardReward | AnyConversionCreditReward | CardPackReward | CardShardsReward | CoinReward | DeliverableItemReward | ExperienceReward | InGameCurrencyReward | MonetaryReward | ProbabilisticBundleReward | ShopItemReward>>;
  step?: Maybe<CareerProStep | CareerStep | SquadStep>;
}

/** Autogenerated input type of claimTask */
export interface claimTaskInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  interactionContext?: InputMaybe<Scalars['String']['input']>;
  signedAlternativeRewardConfigs?: InputMaybe<Scalars['String']['input']>;
  taskId: Scalars['ID']['input'];
}

/** Autogenerated return type of claimTask. */
export interface claimTaskPayload {
  __typename: 'claimTaskPayload';
  cardSet?: Maybe<CardSetRoot>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  currentUser?: Maybe<CurrentUser>;
  errors: Array<UserError>;
  rewards?: Maybe<Array<AnyCardReward | AnyConversionCreditReward | CardPackReward | CardShardsReward | CoinReward | DeliverableItemReward | ExperienceReward | InGameCurrencyReward | MonetaryReward | ProbabilisticBundleReward | ShopItemReward>>;
  task?: Maybe<CardsCountTargetTask | CardsCountTask | CompleteCollectionsCountTargetTask | CompleteCollectionsCountTask | DailyActionTask | DecisivePlayerPickerTask | DropChallengeTask | GameWeeklyTask | GuessTheScoreTask | InviteTaskAsReferrer | So5LeaderboardTask | StarPackTask | Task | TasksTrack | ThresholdPickerTask | ThresholdsDuoConnectionTask | ThresholdsStreakAdditionalLineupTask | ThresholdsStreakTask>;
}

/** Autogenerated input type of collectJonumPersonalInfo */
export interface collectJonumPersonalInfoInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  dateOfBirth?: InputMaybe<Scalars['ISO8601Date']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
}

/** Autogenerated return type of collectJonumPersonalInfo. */
export interface collectJonumPersonalInfoPayload {
  __typename: 'collectJonumPersonalInfoPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<UserError>;
  verification?: Maybe<Verification>;
}

/** Autogenerated input type of completeDropChallenge */
export interface completeDropChallengeInput {
  cardSlugs: Array<Scalars['String']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  taskId: Scalars['ID']['input'];
}

/** Autogenerated return type of completeDropChallenge. */
export interface completeDropChallengePayload {
  __typename: 'completeDropChallengePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  currentUser?: Maybe<CurrentUser>;
  errors: Array<UserError>;
  rewards?: Maybe<Array<AnyCardReward | AnyConversionCreditReward | CardPackReward | CardShardsReward | CoinReward | DeliverableItemReward | ExperienceReward | InGameCurrencyReward | MonetaryReward | ProbabilisticBundleReward | ShopItemReward>>;
  task?: Maybe<DropChallengeTask>;
}

/** Autogenerated input type of confirmCardPull */
export interface confirmCardPullInput {
  cardPullId: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
}

/** Autogenerated return type of confirmCardPull. */
export interface confirmCardPullPayload {
  __typename: 'confirmCardPullPayload';
  cardPull?: Maybe<CardPull>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  confirmedCard?: Maybe<BaseballCard | Card | NBACard>;
  currentUser?: Maybe<CurrentUser>;
  errors: Array<UserError>;
}

/** Autogenerated input type of confirmDevice */
export interface confirmDeviceInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  token: Scalars['String']['input'];
}

/** Autogenerated input type of confirmDeviceWithCode */
export interface confirmDeviceWithCodeInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  code: Scalars['String']['input'];
}

/** Autogenerated return type of confirmDeviceWithCode. */
export interface confirmDeviceWithCodePayload {
  __typename: 'confirmDeviceWithCodePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  currentUser?: Maybe<CurrentUser>;
  errors: Array<UserError>;
}

/** Autogenerated input type of confirmEmail */
export interface confirmEmailInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  token: Scalars['String']['input'];
}

/** Autogenerated input type of confirmSo5LineupImportsBatch */
export interface confirmSo5LineupImportsBatchInput {
  batchId: Scalars['String']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
}

/** Autogenerated return type of confirmSo5LineupImportsBatch. */
export interface confirmSo5LineupImportsBatchPayload {
  __typename: 'confirmSo5LineupImportsBatchPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<UserError>;
}

/** Autogenerated input type of confirmSo5Lineups */
export interface confirmSo5LineupsInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  so5LeagueIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  so5LineupIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  targetedRewardSlug?: InputMaybe<Scalars['String']['input']>;
}

/** Autogenerated return type of confirmSo5Lineups. */
export interface confirmSo5LineupsPayload {
  __typename: 'confirmSo5LineupsPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  currentUser?: Maybe<CurrentUser>;
  errors: Array<UserError>;
  so5Lineups?: Maybe<Array<So5Lineup>>;
}

/** Autogenerated input type of confirmSo5NoCardLineup */
export interface confirmSo5NoCardLineupInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  so5LeaderboardId: Scalars['ID']['input'];
  so5NoCardLineupId: Scalars['ID']['input'];
}

/** Autogenerated return type of confirmSo5NoCardLineup. */
export interface confirmSo5NoCardLineupPayload {
  __typename: 'confirmSo5NoCardLineupPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  currentUser?: Maybe<CurrentUser>;
  errors: Array<UserError>;
  so5NoCardLineup?: Maybe<So5NoCardLineup>;
}

/** Autogenerated input type of consumeEphemeralToken */
export interface consumeEphemeralTokenInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  token: Scalars['String']['input'];
}

/** Autogenerated input type of convertCraftClues */
export interface convertCraftCluesInput {
  /** Number of source clues to spend */
  amount: Scalars['Int']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The clue base to convert (e.g. country, competition) */
  clueBaseName: CraftClueBase;
  /** Rarity of the source clues to spend */
  fromRarity: Rarity;
  /** Sport the clues belong to */
  sport: Sport;
  /** Rarity of the clues to receive */
  toRarity: Rarity;
}

/** Autogenerated return type of convertCraftClues. */
export interface convertCraftCluesPayload {
  __typename: 'convertCraftCluesPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  currentUser?: Maybe<CurrentUser>;
  errors: Array<UserError>;
}

/** Autogenerated input type of createApiKey */
export interface createApiKeyInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
}

/** Autogenerated return type of createApiKey. */
export interface createApiKeyPayload {
  __typename: 'createApiKeyPayload';
  apiKey?: Maybe<ApiKey>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  currentUser?: Maybe<CurrentUser>;
  errors: Array<UserError>;
}

/** Autogenerated input type of createBankWithdrawal */
export interface createBankWithdrawalInput {
  /** Amount to withdraw. */
  amount: CryptoAmountInput;
  approval: AuthorizationApprovalInput;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Destination Blockchain address. */
  destination: Scalars['String']['input'];
}

/** Autogenerated return type of createBankWithdrawal. */
export interface createBankWithdrawalPayload {
  __typename: 'createBankWithdrawalPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  currentUser?: Maybe<CurrentUser>;
  errors: Array<UserError>;
  withdrawal?: Maybe<BankWithdrawal>;
}

/** Autogenerated input type of createBookmark */
export interface createBookmarkInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  so5LeaderboardType?: InputMaybe<So5LeaderboardType>;
  taskConfigSlug?: InputMaybe<Scalars['String']['input']>;
}

/** Autogenerated return type of createBookmark. */
export interface createBookmarkPayload {
  __typename: 'createBookmarkPayload';
  bookmark?: Maybe<BoardBookmark | So5LeaderboardBookmark>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  currentUser?: Maybe<CurrentUser>;
  errors: Array<UserError>;
}

/** Autogenerated input type of createCardAuthorization */
export interface createCardAuthorizationInput {
  authorizationId: Scalars['String']['input'];
  browserInfo: BrowserInfoInput;
  cardId: Scalars['String']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
}

/** Autogenerated return type of createCardAuthorization. */
export interface createCardAuthorizationPayload {
  __typename: 'createCardAuthorizationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<UserError>;
  providerErrorCode?: Maybe<Scalars['String']['output']>;
  providerId?: Maybe<Scalars['String']['output']>;
  secureModeRedirectUrl?: Maybe<Scalars['String']['output']>;
}

/** Autogenerated input type of createCardRegistration */
export interface createCardRegistrationInput {
  cardType?: InputMaybe<CreditCardType>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
}

/** Autogenerated return type of createCardRegistration. */
export interface createCardRegistrationPayload {
  __typename: 'createCardRegistrationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<UserError>;
  preRegistrationData?: Maybe<PreRegistrationData>;
}

/** Autogenerated input type of createConnectedTasks */
export interface createConnectedTasksInput {
  campaignSlug: Scalars['String']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  connectedUserSlug: Scalars['String']['input'];
  simulate?: InputMaybe<Scalars['Boolean']['input']>;
}

/** Autogenerated return type of createConnectedTasks. */
export interface createConnectedTasksPayload {
  __typename: 'createConnectedTasksPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<UserError>;
  tasks?: Maybe<Array<CardsCountTargetTask | CardsCountTask | CompleteCollectionsCountTargetTask | CompleteCollectionsCountTask | DailyActionTask | DecisivePlayerPickerTask | DropChallengeTask | GameWeeklyTask | GuessTheScoreTask | InviteTaskAsReferrer | So5LeaderboardTask | StarPackTask | Task | TasksTrack | ThresholdPickerTask | ThresholdsDuoConnectionTask | ThresholdsStreakAdditionalLineupTask | ThresholdsStreakTask>>;
}

/** Autogenerated input type of createCryptoDeposit */
export interface createCryptoDepositInput {
  /** Pending deposit amount */
  amount: AmountInput;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Transaction hash of the deposit */
  transactionHash: Scalars['String']['input'];
}

/** Autogenerated return type of createCryptoDeposit. */
export interface createCryptoDepositPayload {
  __typename: 'createCryptoDepositPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  currentUser?: Maybe<CurrentUser>;
  errors: Array<UserError>;
}

/** Autogenerated input type of createDeck */
export interface createDeckInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  sport: Sport;
  visible: Scalars['Boolean']['input'];
}

/** Autogenerated return type of createDeck. */
export interface createDeckPayload {
  __typename: 'createDeckPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  currentUser?: Maybe<CurrentUser>;
  deck?: Maybe<Deck>;
  errors: Array<UserError>;
  userSportProfile?: Maybe<AnyUserSportProfile>;
}

/** Autogenerated input type of createDepositBankAccountMutation */
export interface createDepositBankAccountMutationInput {
  /** Residential address to register with Mangopay when addressRequired is true */
  address?: InputMaybe<MangopayNaturalUserAddressInput>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
}

/** Autogenerated return type of createDepositBankAccountMutation. */
export interface createDepositBankAccountMutationPayload {
  __typename: 'createDepositBankAccountMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  currentUser?: Maybe<CurrentUser>;
  errors: Array<UserError>;
}

/** Autogenerated input type of createDirectOffer */
export interface createDirectOfferInput {
  approvals: Array<AuthorizationApprovalInput>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  counteredOfferId?: InputMaybe<Scalars['String']['input']>;
  /** ID used as unique deal identifier. Consider using `crypto.getRandomValues(new Uint32Array(4)).join()` to generate one. */
  dealId: Scalars['String']['input'];
  /**
   * Number of seconds this offer should be valid. Will be rounded to
   *                                    86400 (1 day) if given a lower value.
   */
  duration?: InputMaybe<Scalars['Int']['input']>;
  migrationData?: InputMaybe<OfferMigrationInput>;
  /** Amount to receive and its currency. if set, must be one of the proposer wallet currencies. */
  receiveAmount?: InputMaybe<AmountInput>;
  receiveAssetIds?: InputMaybe<Array<Scalars['String']['input']>>;
  receiverSlug: Scalars['String']['input'];
  /** Amount to send and its currency. If set, must be one of the proposer wallet currencies. */
  sendAmount?: InputMaybe<AmountInput>;
  sendAssetIds?: InputMaybe<Array<Scalars['String']['input']>>;
}

/** Autogenerated return type of createDirectOffer. */
export interface createDirectOfferPayload {
  __typename: 'createDirectOfferPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  currentUser?: Maybe<CurrentUser>;
  errors: Array<UserError>;
  /** The sport-agnostic offer */
  tokenOffer?: Maybe<TokenOffer>;
}

/** Autogenerated input type of createEphemeralLink */
export interface createEphemeralLinkInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  tokenAsQueryParam?: InputMaybe<Scalars['Boolean']['input']>;
  url: Scalars['String']['input'];
}

/** Autogenerated return type of createEphemeralLink. */
export interface createEphemeralLinkPayload {
  __typename: 'createEphemeralLinkPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<UserError>;
  /** The resulting URL if there was no error */
  url?: Maybe<Scalars['String']['output']>;
}

/** Autogenerated input type of createEthBankWithdrawalIntent */
export interface createEthBankWithdrawalIntentInput {
  amount: Scalars['String']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
}

/** Autogenerated return type of createEthBankWithdrawalIntent. */
export interface createEthBankWithdrawalIntentPayload {
  __typename: 'createEthBankWithdrawalIntentPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<UserError>;
  ethBankWithdrawalIntent?: Maybe<EthBankWithdrawalIntent>;
}

/** Autogenerated input type of createEthDeposit */
export interface createEthDepositInput {
  /** Pending deposit amount, in wei */
  amount: Scalars['WeiAmount']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Transaction hash of the deposit */
  transactionHash: Scalars['String']['input'];
}

/** Autogenerated return type of createEthDeposit. */
export interface createEthDepositPayload {
  __typename: 'createEthDepositPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  currentUser?: Maybe<CurrentUser>;
  errors: Array<UserError>;
}

/** Autogenerated input type of createEthVault */
export interface createEthVaultInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
}

/** Autogenerated return type of createEthVault. */
export interface createEthVaultPayload {
  __typename: 'createEthVaultPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  currentUser?: Maybe<CurrentUser>;
  errors: Array<UserError>;
}

/** Autogenerated input type of createFiatPayer */
export interface createFiatPayerInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
}

/** Autogenerated return type of createFiatPayer. */
export interface createFiatPayerPayload {
  __typename: 'createFiatPayerPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  currentUser?: Maybe<CurrentUser>;
  errors: Array<UserError>;
}

/** Autogenerated input type of createFiatWallet */
export interface createFiatWalletInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  countryOfResidenceCode: Scalars['String']['input'];
  currency: FiatCurrency;
  dob: Scalars['ISO8601Date']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  mangopayTermsAndConditionsAccepted: Scalars['Boolean']['input'];
  nationalityCode: Scalars['String']['input'];
  /** URL to redirect the user to after the enrollment process is completed.  */
  returnUrl?: InputMaybe<Scalars['String']['input']>;
}

/** Autogenerated return type of createFiatWallet. */
export interface createFiatWalletPayload {
  __typename: 'createFiatWalletPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  currentUser?: Maybe<CurrentUser>;
  errors: Array<UserError>;
  redirectUrl?: Maybe<Scalars['String']['output']>;
}

/** Autogenerated input type of createFiatWithdrawal */
export interface createFiatWithdrawalInput {
  /** Amount to withdraw and its currency */
  amounts: AmountInput;
  attemptReference?: InputMaybe<Scalars['String']['input']>;
  bankAccountId: Scalars['String']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
}

/** Autogenerated return type of createFiatWithdrawal. */
export interface createFiatWithdrawalPayload {
  __typename: 'createFiatWithdrawalPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  currentUser?: Maybe<CurrentUser>;
  errors: Array<UserError>;
  withdrawal?: Maybe<MangopayWithdrawal>;
}

/** Autogenerated input type of createIdentityVerificationSession */
export interface createIdentityVerificationSessionInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  userIdentityVerificationId: Scalars['String']['input'];
}

/** Autogenerated return type of createIdentityVerificationSession. */
export interface createIdentityVerificationSessionPayload {
  __typename: 'createIdentityVerificationSessionPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<UserError>;
  verificationSession?: Maybe<VerificationSession>;
}

/** Autogenerated input type of createJonumVerification */
export interface createJonumVerificationInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
}

/** Autogenerated return type of createJonumVerification. */
export interface createJonumVerificationPayload {
  __typename: 'createJonumVerificationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  currentUser?: Maybe<CurrentUser>;
  errors: Array<UserError>;
  /** @deprecated Use current_user.jonumVerification instead */
  verification?: Maybe<Verification>;
}

/** Autogenerated input type of createJwtToken */
export interface createJwtTokenInput {
  /**
   * Audience claim identifies the intended audience for this token. Consider using
   * a value that uniquely identifies your use case.
   */
  aud: Scalars['String']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
}

/** Autogenerated return type of createJwtToken. */
export interface createJwtTokenPayload {
  __typename: 'createJwtTokenPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  currentUser?: Maybe<CurrentUser>;
  errors: Array<UserError>;
  /** Generate a JWT Token. null if, and only if, currentUser is null. */
  jwtToken?: Maybe<JwtToken>;
}

/** Autogenerated input type of createOAuthApplication */
export interface createOAuthApplicationInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  logoContentType: Scalars['String']['input'];
  logoData: Scalars['String']['input'];
  name: Scalars['String']['input'];
  redirectUris: Array<Scalars['String']['input']>;
}

/** Autogenerated input type of createOffRampBridgeCustomer */
export interface createOffRampBridgeCustomerInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  residentialAddress: OffRampBridgeResidentialAddressInput;
  /** The signed_agreement_id returned by Bridge after the user accepted ToS */
  signedAgreementId: Scalars['String']['input'];
}

/** Autogenerated return type of createOffRampBridgeCustomer. */
export interface createOffRampBridgeCustomerPayload {
  __typename: 'createOffRampBridgeCustomerPayload';
  bridgeAccount?: Maybe<OffRampBridgeAccount>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<UserError>;
}

/** Autogenerated input type of createOffRampBridgeTosLink */
export interface createOffRampBridgeTosLinkInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  returnUrl: Scalars['String']['input'];
}

/** Autogenerated return type of createOffRampBridgeTosLink. */
export interface createOffRampBridgeTosLinkPayload {
  __typename: 'createOffRampBridgeTosLinkPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<UserError>;
  tosUrl?: Maybe<Scalars['String']['output']>;
}

/** Autogenerated input type of createOnboardingSo5Lineup */
export interface createOnboardingSo5LineupInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  draft?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  so5Appearances: Array<So5AppearanceInput>;
  so5LeaderboardId: Scalars['ID']['input'];
  so5LineupId?: InputMaybe<Scalars['ID']['input']>;
}

/** Autogenerated return type of createOnboardingSo5Lineup. */
export interface createOnboardingSo5LineupPayload {
  __typename: 'createOnboardingSo5LineupPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  currentUser?: Maybe<CurrentUser>;
  errors: Array<UserError>;
  probabilisticBundle?: Maybe<ProbabilisticBundle>;
  so5LeaderboardContender?: Maybe<So5LeaderboardContender>;
  so5Lineup?: Maybe<So5Lineup>;
}

/** Autogenerated input type of createOrUpdateSingleBuyOfferMinPrice */
export interface createOrUpdateSingleBuyOfferMinPriceInput {
  assetId: Scalars['String']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  isPrivate: Scalars['Boolean']['input'];
  /** Min price to set and its currency. */
  minPrice?: InputMaybe<AmountInput>;
}

/** Autogenerated return type of createOrUpdateSingleBuyOfferMinPrice. */
export interface createOrUpdateSingleBuyOfferMinPricePayload {
  __typename: 'createOrUpdateSingleBuyOfferMinPricePayload';
  card?: Maybe<BaseballCard | Card | NBACard>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<UserError>;
}

/** Autogenerated input type of createOrUpdateSo5Lineup */
export interface createOrUpdateSo5LineupInput {
  /** @deprecated Not used anymore */
  addedCards?: InputMaybe<Array<AddCardInput>>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  composeSessionId?: InputMaybe<Scalars['String']['input']>;
  draft?: InputMaybe<Scalars['Boolean']['input']>;
  droppedCards?: InputMaybe<Array<DropCardInput>>;
  entryItemId?: InputMaybe<Scalars['ID']['input']>;
  managerTeamId?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  shouldCreateManagerTeam?: InputMaybe<Scalars['Boolean']['input']>;
  so5Appearances: Array<So5AppearanceInput>;
  so5LeaderboardId: Scalars['ID']['input'];
  so5LineupId?: InputMaybe<Scalars['ID']['input']>;
  targetedRewardSlug?: InputMaybe<Scalars['String']['input']>;
}

/** Autogenerated input type of createPasskey */
export interface createPasskeyInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  nickname?: InputMaybe<Scalars['String']['input']>;
  otpAttempt?: InputMaybe<Scalars['String']['input']>;
  passkeyCredential: PasskeyCredentialForCreateInput;
  passkeyEncryptedPrivateKey?: InputMaybe<PasswordEncryptedPrivateKeyInput>;
}

/** Autogenerated return type of createPasskey. */
export interface createPasskeyPayload {
  __typename: 'createPasskeyPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  currentUser?: Maybe<CurrentUser>;
  errors: Array<UserError>;
  passkey?: Maybe<Passkey>;
}

/** Autogenerated input type of createSingleSaleOffer */
export interface createSingleSaleOfferInput {
  approvals: Array<AuthorizationApprovalInput>;
  assetId: Scalars['String']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** ID used as unique deal identifier. Consider using `crypto.getRandomValues(new Uint32Array(4)).join()` to generate one. */
  dealId: Scalars['String']['input'];
  /** Number of seconds this offer should be valid */
  duration?: InputMaybe<Scalars['Int']['input']>;
  migrationData?: InputMaybe<OfferMigrationInput>;
  /** Reference amount to receive and its currency. Must be one of the settlement currencies. */
  receiveAmount: AmountInput;
  /**
   * List of accepted currencies. Must match the proposer wallet currencies (e.g:
   * you cannot receive fiat without a fiat wallet).
   */
  settlementCurrencies?: InputMaybe<Array<SupportedCurrency>>;
  startDate?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
}

/** Autogenerated return type of createSingleSaleOffer. */
export interface createSingleSaleOfferPayload {
  __typename: 'createSingleSaleOfferPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<UserError>;
  /** The sport-agnostic offer */
  tokenOffer?: Maybe<TokenOffer>;
}

/** Autogenerated input type of createSo5LineupImportsBatch */
export interface createSo5LineupImportsBatchInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  so5Lineups: Array<So5LineupImportInput>;
  sport?: InputMaybe<Sport>;
}

/** Autogenerated return type of createSo5LineupImportsBatch. */
export interface createSo5LineupImportsBatchPayload {
  __typename: 'createSo5LineupImportsBatchPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<UserError>;
  so5LineupImportsBatch?: Maybe<So5LineupImportsBatch>;
}

/** Autogenerated input type of createSo5NoCardBoardLineup */
export interface createSo5NoCardBoardLineupInput {
  accessToken: Scalars['String']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  proofOfResidencyPresignedKey?: InputMaybe<Scalars['String']['input']>;
  sport: Sport;
}

/** Autogenerated return type of createSo5NoCardBoardLineup. */
export interface createSo5NoCardBoardLineupPayload {
  __typename: 'createSo5NoCardBoardLineupPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  currentUser?: Maybe<CurrentUser>;
  errors: Array<UserError>;
}

/** Autogenerated input type of createSo5UserGroup */
export interface createSo5UserGroupInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  displayName: Scalars['String']['input'];
  endGameWeek?: InputMaybe<Scalars['Int']['input']>;
  gameMode?: InputMaybe<GameMode>;
  logoId?: InputMaybe<Scalars['ID']['input']>;
  publiclyAccessible?: InputMaybe<Scalars['Boolean']['input']>;
  so5LeaderboardType?: InputMaybe<So5LeaderboardType>;
  startGameWeek?: InputMaybe<Scalars['Int']['input']>;
}

/** Autogenerated return type of createSo5UserGroup. */
export interface createSo5UserGroupPayload {
  __typename: 'createSo5UserGroupPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<UserError>;
  so5UserGroup?: Maybe<So5UserGroup>;
  userGroup?: Maybe<So5UserGroup>;
}

/** Autogenerated input type of createSquad */
export interface createSquadInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  private?: InputMaybe<Scalars['Boolean']['input']>;
  sport: Sport;
}

/** Autogenerated return type of createSquad. */
export interface createSquadPayload {
  __typename: 'createSquadPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  currentUser?: Maybe<CurrentUser>;
  errors: Array<UserError>;
}

/** Autogenerated input type of createStarkwareEscapeHatch */
export interface createStarkwareEscapeHatchInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Ethereum address receiving the escaped ETH. */
  destination: Scalars['EthereumAddress']['input'];
  /** Stark-signed registerEthAddress payload, required if no Ethereum address is registered yet. */
  registrationSignature?: InputMaybe<Scalars['String']['input']>;
  /** User-signed escape `withdrawWithFee` payload. */
  withdrawWithFeeSignature: Scalars['String']['input'];
  /** User-signed escape `withdrawWithFeeToBaseBank` payload. */
  withdrawWithFeeToBaseBankSignature: Scalars['String']['input'];
}

/** Autogenerated return type of createStarkwareEscapeHatch. */
export interface createStarkwareEscapeHatchPayload {
  __typename: 'createStarkwareEscapeHatchPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  currentUser?: Maybe<CurrentUser>;
  errors: Array<UserError>;
  escapeHatch?: Maybe<StarkwareEscapeHatch>;
}

/** Autogenerated input type of createSubscription */
export interface createSubscriptionInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  interactionContext?: InputMaybe<Scalars['String']['input']>;
  subscribable: SubscribableInput;
}

/** Autogenerated return type of createSubscription. */
export interface createSubscriptionPayload {
  __typename: 'createSubscriptionPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<UserError>;
  subscription?: Maybe<EmailSubscription>;
}

/** Autogenerated input type of createTaskPreparedLineupFromTaskLineup */
export interface createTaskPreparedLineupFromTaskLineupInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  taskLineupId: Scalars['ID']['input'];
}

/** Autogenerated return type of createTaskPreparedLineupFromTaskLineup. */
export interface createTaskPreparedLineupFromTaskLineupPayload {
  __typename: 'createTaskPreparedLineupFromTaskLineupPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  currentUser?: Maybe<CurrentUser>;
  errors: Array<UserError>;
  task?: Maybe<CardsCountTargetTask | CardsCountTask | CompleteCollectionsCountTargetTask | CompleteCollectionsCountTask | DailyActionTask | DecisivePlayerPickerTask | DropChallengeTask | GameWeeklyTask | GuessTheScoreTask | InviteTaskAsReferrer | So5LeaderboardTask | StarPackTask | Task | TasksTrack | ThresholdPickerTask | ThresholdsDuoConnectionTask | ThresholdsStreakAdditionalLineupTask | ThresholdsStreakTask>;
  taskPreparedLineup?: Maybe<TaskPreparedLineup>;
}

/** Autogenerated input type of createWallet */
export interface createWalletInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  passwordHash: Scalars['String']['input'];
  wallet: WalletInput;
}

/** Autogenerated return type of createWallet. */
export interface createWalletPayload {
  __typename: 'createWalletPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  currentUser?: Maybe<CurrentUser>;
  errors: Array<UserError>;
}

/** Autogenerated input type of createWireTransferDeposit */
export interface createWireTransferDepositInput {
  /** Amount to deposit and its currency */
  amounts: AmountInput;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
}

/** Autogenerated return type of createWireTransferDeposit. */
export interface createWireTransferDepositPayload {
  __typename: 'createWireTransferDepositPayload';
  bankAccount?: Maybe<BankAccount>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<UserError>;
  wireReference?: Maybe<Scalars['String']['output']>;
}

/** Autogenerated input type of createWithdrawalBankAccount */
export interface createWithdrawalBankAccountInput {
  accountIdentifier: Scalars['String']['input'];
  bankAccountType: BankAccountType;
  bankIdentifier: Scalars['String']['input'];
  bankName?: InputMaybe<Scalars['String']['input']>;
  branchCode?: InputMaybe<Scalars['String']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  countryCode: Scalars['String']['input'];
  /** Optional For Further Credit reference for US bank accounts */
  ffc?: InputMaybe<Scalars['String']['input']>;
  ownerAddress: BankAccountOwnerAddressInput;
  /** Defaults to the current user first name when omitted */
  ownerFirstName?: InputMaybe<Scalars['String']['input']>;
  /** Defaults to the current user last name when omitted */
  ownerLastName?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated use ownerFirstName and ownerLastName instead */
  ownerName?: InputMaybe<Scalars['String']['input']>;
  /** URL to redirect to after SCA verification */
  returnUrl?: InputMaybe<Scalars['String']['input']>;
}

/** Autogenerated return type of createWithdrawalBankAccount. */
export interface createWithdrawalBankAccountPayload {
  __typename: 'createWithdrawalBankAccountPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  currentUser?: Maybe<CurrentUser>;
  errors: Array<UserError>;
  mangopayBankAccount?: Maybe<BankAccount>;
  /** URL to redirect to for Strong customer authentication (SCA) */
  redirectUrl?: Maybe<Scalars['String']['output']>;
}

/** Autogenerated input type of deactivateWalletRecovery */
export interface deactivateWalletRecoveryInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Use recoveryOptionId, which does not require the plaintext destination */
  destination?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Use recoveryOptionId, which does not require the plaintext destination */
  method?: InputMaybe<PrivateKeyRecoveryOptionMethodEnum>;
  recoveryOptionId?: InputMaybe<Scalars['ID']['input']>;
}

/** Autogenerated return type of deactivateWalletRecovery. */
export interface deactivateWalletRecoveryPayload {
  __typename: 'deactivateWalletRecoveryPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  currentUser?: Maybe<CurrentUser>;
  errors: Array<UserError>;
}

/** Autogenerated input type of declineSo5LineupImportsBatch */
export interface declineSo5LineupImportsBatchInput {
  batchId: Scalars['String']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
}

/** Autogenerated return type of declineSo5LineupImportsBatch. */
export interface declineSo5LineupImportsBatchPayload {
  __typename: 'declineSo5LineupImportsBatchPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<UserError>;
}

/** Autogenerated input type of declineSo5NoCardLineup */
export interface declineSo5NoCardLineupInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  so5NoCardLineupId: Scalars['ID']['input'];
}

/** Autogenerated return type of declineSo5NoCardLineup. */
export interface declineSo5NoCardLineupPayload {
  __typename: 'declineSo5NoCardLineupPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  currentUser?: Maybe<CurrentUser>;
  errors: Array<UserError>;
  so5NoCardLineup?: Maybe<So5NoCardLineup>;
}

/** Autogenerated input type of deleteApiKey */
export interface deleteApiKeyInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
}

/** Autogenerated return type of deleteApiKey. */
export interface deleteApiKeyPayload {
  __typename: 'deleteApiKeyPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  currentUser?: Maybe<CurrentUser>;
  errors: Array<UserError>;
}

/** Autogenerated input type of deleteBookmark */
export interface deleteBookmarkInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  so5LeaderboardType?: InputMaybe<So5LeaderboardType>;
  taskConfigSlug?: InputMaybe<Scalars['String']['input']>;
}

/** Autogenerated return type of deleteBookmark. */
export interface deleteBookmarkPayload {
  __typename: 'deleteBookmarkPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  currentUser?: Maybe<CurrentUser>;
  errors: Array<UserError>;
}

/** Autogenerated input type of deleteConnectedTask */
export interface deleteConnectedTaskInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  taskId: Scalars['ID']['input'];
}

/** Autogenerated return type of deleteConnectedTask. */
export interface deleteConnectedTaskPayload {
  __typename: 'deleteConnectedTaskPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  currentUser?: Maybe<CurrentUser>;
  errors: Array<UserError>;
}

/** Autogenerated input type of deleteDeck */
export interface deleteDeckInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  deckSlug: Scalars['String']['input'];
}

/** Autogenerated return type of deleteDeck. */
export interface deleteDeckPayload {
  __typename: 'deleteDeckPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  currentUser?: Maybe<CurrentUser>;
  deck?: Maybe<Deck>;
  errors: Array<UserError>;
  userSportProfile?: Maybe<AnyUserSportProfile>;
}

/** Autogenerated input type of deleteOAuthApplication */
export interface deleteOAuthApplicationInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
}

/** Autogenerated return type of deleteOAuthApplication. */
export interface deleteOAuthApplicationPayload {
  __typename: 'deleteOAuthApplicationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  currentUser?: Maybe<CurrentUser>;
  errors: Array<UserError>;
}

/** Autogenerated input type of deletePasskey */
export interface deletePasskeyInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  passkeyId: Scalars['ID']['input'];
}

/** Autogenerated return type of deletePasskey. */
export interface deletePasskeyPayload {
  __typename: 'deletePasskeyPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  currentUser?: Maybe<CurrentUser>;
  errors: Array<UserError>;
}

/** Autogenerated input type of deletePostalAddress */
export interface deletePostalAddressInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
}

/** Autogenerated return type of deletePostalAddress. */
export interface deletePostalAddressPayload {
  __typename: 'deletePostalAddressPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  currentUser?: Maybe<CurrentUser>;
  errors: Array<UserError>;
}

/** Autogenerated input type of deleteSo5Lineup */
export interface deleteSo5LineupInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  so5LineupId: Scalars['ID']['input'];
}

/** Autogenerated return type of deleteSo5Lineup. */
export interface deleteSo5LineupPayload {
  __typename: 'deleteSo5LineupPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  currentUser?: Maybe<CurrentUser>;
  errors: Array<UserError>;
  so5Leaderboard?: Maybe<So5Leaderboard>;
  so5LeaderboardContender?: Maybe<So5LeaderboardContender>;
}

/** Autogenerated input type of deleteSo5UserGroup */
export interface deleteSo5UserGroupInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  so5UserGroupId: Scalars['ID']['input'];
}

/** Autogenerated return type of deleteSo5UserGroup. */
export interface deleteSo5UserGroupPayload {
  __typename: 'deleteSo5UserGroupPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<UserError>;
}

/** Autogenerated input type of deleteSubscription */
export interface deleteSubscriptionInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  slug: Scalars['String']['input'];
}

/** Autogenerated return type of deleteSubscription. */
export interface deleteSubscriptionPayload {
  __typename: 'deleteSubscriptionPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<UserError>;
  subscribable?: Maybe<Subscribable>;
  subscription?: Maybe<EmailSubscription>;
}

/** Autogenerated input type of deleteTaskLineup */
export interface deleteTaskLineupInput {
  cancelIfLocked?: InputMaybe<Scalars['Boolean']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  taskLineupId: Scalars['ID']['input'];
}

/** Autogenerated return type of deleteTaskLineup. */
export interface deleteTaskLineupPayload {
  __typename: 'deleteTaskLineupPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<UserError>;
  task?: Maybe<CardsCountTargetTask | CardsCountTask | CompleteCollectionsCountTargetTask | CompleteCollectionsCountTask | DailyActionTask | DecisivePlayerPickerTask | DropChallengeTask | GameWeeklyTask | GuessTheScoreTask | InviteTaskAsReferrer | So5LeaderboardTask | StarPackTask | Task | TasksTrack | ThresholdPickerTask | ThresholdsDuoConnectionTask | ThresholdsStreakAdditionalLineupTask | ThresholdsStreakTask>;
}

/** Autogenerated input type of deleteWithdrawalBankAccount */
export interface deleteWithdrawalBankAccountInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  mangopayBankAccountId: Scalars['String']['input'];
}

/** Autogenerated return type of deleteWithdrawalBankAccount. */
export interface deleteWithdrawalBankAccountPayload {
  __typename: 'deleteWithdrawalBankAccountPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  currentUser?: Maybe<CurrentUser>;
  errors: Array<UserError>;
}

/** Autogenerated input type of depositWithApplePay */
export interface depositWithApplePayInput {
  /** Amount to deposit and its currency */
  amounts: AmountInput;
  /** ApplePay payment data */
  applePaymentData: ApplePayPaymentDataInput;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
}

/** Autogenerated return type of depositWithApplePay. */
export interface depositWithApplePayPayload {
  __typename: 'depositWithApplePayPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  currentUser?: Maybe<CurrentUser>;
  deposit?: Maybe<PendingDeposit>;
  errors: Array<UserError>;
  providerId?: Maybe<Scalars['String']['output']>;
}

/** Autogenerated input type of destroyAccount */
export interface destroyAccountInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  password: Scalars['String']['input'];
}

/** Autogenerated return type of destroyAccount. */
export interface destroyAccountPayload {
  __typename: 'destroyAccountPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  currentUser?: Maybe<CurrentUser>;
  errors: Array<UserError>;
}

/** Autogenerated input type of destroyReferral */
export interface destroyReferralInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  referralId: Scalars['ID']['input'];
}

/** Autogenerated return type of destroyReferral. */
export interface destroyReferralPayload {
  __typename: 'destroyReferralPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  currentUser?: Maybe<CurrentUser>;
  errors: Array<UserError>;
}

/** Autogenerated input type of destroyTaskPreparedLineup */
export interface destroyTaskPreparedLineupInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  taskPreparedLineupId: Scalars['ID']['input'];
}

/** Autogenerated return type of destroyTaskPreparedLineup. */
export interface destroyTaskPreparedLineupPayload {
  __typename: 'destroyTaskPreparedLineupPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<UserError>;
  task?: Maybe<CardsCountTargetTask | CardsCountTask | CompleteCollectionsCountTargetTask | CompleteCollectionsCountTask | DailyActionTask | DecisivePlayerPickerTask | DropChallengeTask | GameWeeklyTask | GuessTheScoreTask | InviteTaskAsReferrer | So5LeaderboardTask | StarPackTask | Task | TasksTrack | ThresholdPickerTask | ThresholdsDuoConnectionTask | ThresholdsStreakAdditionalLineupTask | ThresholdsStreakTask>;
}

/** Autogenerated input type of destroyWatchlist */
export interface destroyWatchlistInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  watchlistId?: InputMaybe<Scalars['ID']['input']>;
}

/** Autogenerated return type of destroyWatchlist. */
export interface destroyWatchlistPayload {
  __typename: 'destroyWatchlistPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  currentUser?: Maybe<CurrentUser>;
  errors: Array<UserError>;
}

/** Autogenerated input type of detachPaymentMethod */
export interface detachPaymentMethodInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  paymentMethod: Scalars['String']['input'];
  provider?: InputMaybe<PaymentMethodProvider>;
}

/** Autogenerated return type of detachPaymentMethod. */
export interface detachPaymentMethodPayload {
  __typename: 'detachPaymentMethodPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  currentUser?: Maybe<CurrentUser>;
  errors: Array<UserError>;
}

/** Autogenerated input type of disable2fa */
export interface disable2faInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  otpAttempt: Scalars['String']['input'];
  password: Scalars['String']['input'];
}

/** Autogenerated return type of disable2fa. */
export interface disable2faPayload {
  __typename: 'disable2faPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  currentUser?: Maybe<CurrentUser>;
  errors: Array<UserError>;
}

/** Autogenerated input type of disconnectOmniauthProvider */
export interface disconnectOmniauthProviderInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  provider: Scalars['String']['input'];
}

/** Autogenerated return type of disconnectOmniauthProvider. */
export interface disconnectOmniauthProviderPayload {
  __typename: 'disconnectOmniauthProviderPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  currentUser?: Maybe<CurrentUser>;
  errors: Array<UserError>;
  userProfile?: Maybe<UserProfile>;
}

/** Autogenerated input type of dropAndAddCards */
export interface dropAndAddCardsInput {
  /** @deprecated Use `sorts` instead */
  addedCards?: InputMaybe<Array<AddCardInput>>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  droppedCards?: InputMaybe<Array<DropCardInput>>;
  interactionContext?: InputMaybe<Scalars['String']['input']>;
}

/** Autogenerated return type of dropAndAddCards. */
export interface dropAndAddCardsPayload {
  __typename: 'dropAndAddCardsPayload';
  /** @deprecated Use `sorts` instead */
  addedCards?: Maybe<Array<BaseballCard | Card | NBACard>>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  currentUser?: Maybe<CurrentUser>;
  droppedCards?: Maybe<Array<BaseballCard | Card | NBACard>>;
  errors: Array<UserError>;
}

/** Autogenerated input type of editDeck */
export interface editDeckInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  deckSlug: Scalars['String']['input'];
  name: Scalars['String']['input'];
  newIndex?: InputMaybe<Scalars['Int']['input']>;
  visible: Scalars['Boolean']['input'];
}

/** Autogenerated return type of editDeck. */
export interface editDeckPayload {
  __typename: 'editDeckPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  currentUser?: Maybe<CurrentUser>;
  deck?: Maybe<Deck>;
  errors: Array<UserError>;
}

/** Autogenerated input type of enable2fa */
export interface enable2faInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  otpAttempt: Scalars['String']['input'];
}

/** Autogenerated return type of enable2fa. */
export interface enable2faPayload {
  __typename: 'enable2faPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  currentUser?: Maybe<CurrentUser>;
  errors: Array<UserError>;
  otpBackupCodes?: Maybe<Array<Scalars['String']['output']>>;
}

/** Autogenerated input type of enrollSCA */
export interface enrollSCAInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** URL to redirect the user to after the enrollment process is completed.  */
  returnUrl: Scalars['String']['input'];
}

/** Autogenerated return type of enrollSCA. */
export interface enrollSCAPayload {
  __typename: 'enrollSCAPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<UserError>;
  redirectUrl?: Maybe<Scalars['String']['output']>;
}

/** Autogenerated input type of fetchEncryptedPrivateKey */
export interface fetchEncryptedPrivateKeyInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  otpAttempt?: InputMaybe<Scalars['String']['input']>;
}

/** Autogenerated return type of fetchEncryptedPrivateKey. */
export interface fetchEncryptedPrivateKeyPayload {
  __typename: 'fetchEncryptedPrivateKeyPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<UserError>;
  sorarePrivateKey?: Maybe<SorarePrivateKey>;
}

/** Autogenerated input type of generateAccountingExtract */
export interface generateAccountingExtractInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  includeCardRewards?: InputMaybe<Scalars['Boolean']['input']>;
  includeCreditCardPayments?: InputMaybe<Scalars['Boolean']['input']>;
  includeFiatEntries?: InputMaybe<Scalars['Boolean']['input']>;
  includeLostBids?: InputMaybe<Scalars['Boolean']['input']>;
  startDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
}

/** Autogenerated return type of generateAccountingExtract. */
export interface generateAccountingExtractPayload {
  __typename: 'generateAccountingExtractPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  currentUser?: Maybe<CurrentUser>;
  errors: Array<UserError>;
}

/** Autogenerated input type of generateOtpBackupCodes */
export interface generateOtpBackupCodesInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  otpAttempt?: InputMaybe<Scalars['String']['input']>;
}

/** Autogenerated return type of generateOtpBackupCodes. */
export interface generateOtpBackupCodesPayload {
  __typename: 'generateOtpBackupCodesPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  currentUser?: Maybe<CurrentUser>;
  errors: Array<UserError>;
  otpBackupCodes?: Maybe<Array<Scalars['String']['output']>>;
}

/** Autogenerated input type of generateOtpProvisioningUri */
export interface generateOtpProvisioningUriInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
}

/** Autogenerated return type of generateOtpProvisioningUri. */
export interface generateOtpProvisioningUriPayload {
  __typename: 'generateOtpProvisioningUriPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  currentUser?: Maybe<CurrentUser>;
  errors: Array<UserError>;
  otpProvisioningUri?: Maybe<Scalars['String']['output']>;
}

/** Autogenerated input type of generatePasskeyChallengeForCreate */
export interface generatePasskeyChallengeForCreateInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
}

/** Autogenerated return type of generatePasskeyChallengeForCreate. */
export interface generatePasskeyChallengeForCreatePayload {
  __typename: 'generatePasskeyChallengeForCreatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<UserError>;
  passkeyChallenge?: Maybe<PasskeyChallenge>;
}

/** Autogenerated input type of generatePasskeyChallengeForSignIn */
export interface generatePasskeyChallengeForSignInInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
}

/** Autogenerated return type of generatePasskeyChallengeForSignIn. */
export interface generatePasskeyChallengeForSignInPayload {
  __typename: 'generatePasskeyChallengeForSignInPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<UserError>;
  passkeyChallenge?: Maybe<PasskeyChallenge>;
}

/** Autogenerated input type of generateReferrerCode */
export interface generateReferrerCodeInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
}

/** Autogenerated return type of generateReferrerCode. */
export interface generateReferrerCodePayload {
  __typename: 'generateReferrerCodePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  currentUser?: Maybe<CurrentUser>;
  errors: Array<UserError>;
}

/** Autogenerated input type of generateSo5NoCardLineup */
export interface generateSo5NoCardLineupInput {
  accessToken: Scalars['String']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  proofOfResidencyPresignedKey?: InputMaybe<Scalars['String']['input']>;
  recaptchaToken?: InputMaybe<Scalars['String']['input']>;
  recaptchaTokenIos?: InputMaybe<Scalars['String']['input']>;
  recaptchaTokenV2?: InputMaybe<Scalars['String']['input']>;
  so5FixtureId: Scalars['ID']['input'];
}

/** Autogenerated return type of generateSo5NoCardLineup. */
export interface generateSo5NoCardLineupPayload {
  __typename: 'generateSo5NoCardLineupPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  currentUser?: Maybe<CurrentUser>;
  errors: Array<UserError>;
}

/** Autogenerated input type of hideMyFeaturedSo5LeaderboardGroup */
export interface hideMyFeaturedSo5LeaderboardGroupInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  so5FixtureId: Scalars['ID']['input'];
}

/** Autogenerated return type of hideMyFeaturedSo5LeaderboardGroup. */
export interface hideMyFeaturedSo5LeaderboardGroupPayload {
  __typename: 'hideMyFeaturedSo5LeaderboardGroupPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<UserError>;
  so5Fixture?: Maybe<So5Fixture>;
}

/** Autogenerated input type of joinSo5UserGroup */
export interface joinSo5UserGroupInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  joinSecret?: InputMaybe<Scalars['String']['input']>;
  userGroupId?: InputMaybe<Scalars['ID']['input']>;
}

/** Autogenerated return type of joinSo5UserGroup. */
export interface joinSo5UserGroupPayload {
  __typename: 'joinSo5UserGroupPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  currentUser?: Maybe<CurrentUser>;
  errors: Array<UserError>;
  so5UserGroup?: Maybe<So5UserGroup>;
  userGroup?: Maybe<So5UserGroup>;
}

/** Autogenerated input type of joinSquad */
export interface joinSquadInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  joinSecret?: InputMaybe<Scalars['String']['input']>;
  squadId?: InputMaybe<Scalars['ID']['input']>;
}

/** Autogenerated return type of joinSquad. */
export interface joinSquadPayload {
  __typename: 'joinSquadPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  currentUser?: Maybe<CurrentUser>;
  errors: Array<UserError>;
}

/** Autogenerated input type of leaveSquad */
export interface leaveSquadInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  squadId: Scalars['ID']['input'];
}

/** Autogenerated return type of leaveSquad. */
export interface leaveSquadPayload {
  __typename: 'leaveSquadPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  currentUser?: Maybe<CurrentUser>;
  errors: Array<UserError>;
}

/** Autogenerated input type of levelUpCardWithXpCurrency */
export interface levelUpCardWithXpCurrencyInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  levelUpCard: LevelUpCardInput;
}

/** Autogenerated return type of levelUpCardWithXpCurrency. */
export interface levelUpCardWithXpCurrencyPayload {
  __typename: 'levelUpCardWithXpCurrencyPayload';
  card?: Maybe<BaseballCard | Card | NBACard>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  currentUser?: Maybe<CurrentUser>;
  errors: Array<UserError>;
  recomputedBonusSo5Lineups?: Maybe<Array<So5Lineup>>;
  recomputedBonusTaskLineups?: Maybe<Array<GuessTheScoreTaskLineup | TaskLineup | ThresholdPickerTaskLineup>>;
}

/** Autogenerated input type of levelUpCardsWithXpCurrency */
export interface levelUpCardsWithXpCurrencyInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  levelUpCards: Array<LevelUpCardInput>;
}

/** Autogenerated return type of levelUpCardsWithXpCurrency. */
export interface levelUpCardsWithXpCurrencyPayload {
  __typename: 'levelUpCardsWithXpCurrencyPayload';
  cards?: Maybe<Array<BaseballCard | Card | NBACard>>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  currentUser?: Maybe<CurrentUser>;
  errors: Array<UserError>;
  recomputedBonusSo5Lineups?: Maybe<Array<So5Lineup>>;
  recomputedBonusTaskLineups?: Maybe<Array<GuessTheScoreTaskLineup | TaskLineup | ThresholdPickerTaskLineup>>;
}

/** Autogenerated input type of linkEthereumAddress */
export interface linkEthereumAddressInput {
  address: Scalars['String']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  signature: Scalars['String']['input'];
}

/** Autogenerated return type of linkEthereumAddress. */
export interface linkEthereumAddressPayload {
  __typename: 'linkEthereumAddressPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  currentUser?: Maybe<CurrentUser>;
  errors: Array<UserError>;
}

/** Autogenerated input type of loadPreviousLineup */
export interface loadPreviousLineupInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  managerTeamId: Scalars['ID']['input'];
  previousSo5LineupId: Scalars['ID']['input'];
  so5LeaderboardId: Scalars['ID']['input'];
}

/** Autogenerated return type of loadPreviousLineup. */
export interface loadPreviousLineupPayload {
  __typename: 'loadPreviousLineupPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  currentUser?: Maybe<CurrentUser>;
  errors: Array<UserError>;
  so5LeaderboardContender?: Maybe<So5LeaderboardContender>;
  so5Lineup?: Maybe<So5Lineup>;
}

/** Autogenerated input type of loadSuggestedLineup */
export interface loadSuggestedLineupInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  managerTeamId?: InputMaybe<Scalars['ID']['input']>;
  shouldCreateManagerTeam?: InputMaybe<Scalars['Boolean']['input']>;
  so5LeaderboardId: Scalars['ID']['input'];
}

/** Autogenerated return type of loadSuggestedLineup. */
export interface loadSuggestedLineupPayload {
  __typename: 'loadSuggestedLineupPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  currentUser?: Maybe<CurrentUser>;
  errors: Array<UserError>;
  so5LeaderboardContender?: Maybe<So5LeaderboardContender>;
  so5Lineup?: Maybe<So5Lineup>;
}

/** Autogenerated input type of lockProMode */
export interface lockProModeInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  interactionContext?: InputMaybe<Scalars['String']['input']>;
  sport: Sport;
}

/** Autogenerated return type of lockProMode. */
export interface lockProModePayload {
  __typename: 'lockProModePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  currentUser?: Maybe<CurrentUser>;
  errors: Array<UserError>;
}

/** Autogenerated input type of markAsProOnboarded */
export interface markAsProOnboardedInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  sport: Sport;
}

/** Autogenerated return type of markAsProOnboarded. */
export interface markAsProOnboardedPayload {
  __typename: 'markAsProOnboardedPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  currentUser?: Maybe<CurrentUser>;
  errors: Array<UserError>;
}

/** Autogenerated input type of markCardShardsChestUnlockedThresholdAsSeen */
export interface markCardShardsChestUnlockedThresholdAsSeenInput {
  cardShardsChestId: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
}

/** Autogenerated return type of markCardShardsChestUnlockedThresholdAsSeen. */
export interface markCardShardsChestUnlockedThresholdAsSeenPayload {
  __typename: 'markCardShardsChestUnlockedThresholdAsSeenPayload';
  cardShardsChest?: Maybe<CardShardsChest>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<UserError>;
}

/** Autogenerated input type of markNotificationsAsRead */
export interface markNotificationsAsReadInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  notificationId?: InputMaybe<Scalars['String']['input']>;
  notificationIds?: InputMaybe<Array<Scalars['String']['input']>>;
  sport?: InputMaybe<Sport>;
}

/** Autogenerated return type of markNotificationsAsRead. */
export interface markNotificationsAsReadPayload {
  __typename: 'markNotificationsAsReadPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  currentUser?: Maybe<CurrentUser>;
  errors: Array<UserError>;
  notifications: Array<AnnouncementNotification | AuctionNotification | AutoClaimNotification | CardCollectionNotification | CardNotification | ConversionCreditNotification | DecisiveActionNotification | DecisivePurchaseNotification | ExternalDepositNotification | InGameCurrencyNotification | JonumVerificationNotification | KycRequestNotification | LoanNotification | MarketingNotification | OffRampKycNotification | OfferNotification | ReferralRewardNotification | ReminderNotification | SaleNotification | So5LineupNotification | So5UserGroupNotification | TaskNotification | UserRelationNotification>;
}

/** Autogenerated input type of markSocialFeedAsRead */
export interface markSocialFeedAsReadInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  gameMode?: InputMaybe<PlatformGameMode>;
  sport?: InputMaybe<Sport>;
}

/** Autogenerated return type of markSocialFeedAsRead. */
export interface markSocialFeedAsReadPayload {
  __typename: 'markSocialFeedAsReadPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  currentUser?: Maybe<CurrentUser>;
  errors: Array<UserError>;
}

/** Autogenerated input type of markSpotlightAsSeen */
export interface markSpotlightAsSeenInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  spotlightId: Scalars['ID']['input'];
}

/** Autogenerated return type of markSpotlightAsSeen. */
export interface markSpotlightAsSeenPayload {
  __typename: 'markSpotlightAsSeenPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  currentUser?: Maybe<CurrentUser>;
  errors: Array<UserError>;
  spotlight?: Maybe<GenericSpotlight | So5CompetitionSpotlight>;
}

/** Autogenerated input type of markStoriesAsRead */
export interface markStoriesAsReadInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  storyIds: Array<Scalars['String']['input']>;
}

/** Autogenerated return type of markStoriesAsRead. */
export interface markStoriesAsReadPayload {
  __typename: 'markStoriesAsReadPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  currentUser?: Maybe<CurrentUser>;
  errors: Array<UserError>;
  stories?: Maybe<Array<Story>>;
}

/** Autogenerated input type of migrateEth */
export interface migrateEthInput {
  approval: AuthorizationApprovalInput;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  weiAmount: Scalars['WeiAmount']['input'];
}

/** Autogenerated return type of migrateEth. */
export interface migrateEthPayload {
  __typename: 'migrateEthPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  currentUser?: Maybe<CurrentUser>;
  errors: Array<UserError>;
}

/** Autogenerated input type of offRamp */
export interface offRampInput {
  /** Minimum USDC (micros) out, as signed in the authorization */
  amountOutMinimum: Scalars['CryptocurrencyAmount']['input'];
  amountWei: Scalars['WeiAmount']['input'];
  approval: OffRampAuthorizationApprovalInput;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
}

/** Autogenerated return type of offRamp. */
export interface offRampPayload {
  __typename: 'offRampPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<UserError>;
  withdrawal?: Maybe<OffRampWithdrawal>;
}

/** Autogenerated input type of pickPulledCard */
export interface pickPulledCardInput {
  cardPullCardId: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
}

/** Autogenerated return type of pickPulledCard. */
export interface pickPulledCardPayload {
  __typename: 'pickPulledCardPayload';
  cardPull?: Maybe<CardPull>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  currentUser?: Maybe<CurrentUser>;
  errors: Array<UserError>;
}

/** Autogenerated input type of prepareAcceptOffer */
export interface prepareAcceptOfferInput {
  attemptReference?: InputMaybe<Scalars['String']['input']>;
  cartId?: InputMaybe<Scalars['ID']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Global ID of the Offer or PrimaryOffer to accept. */
  offerId?: InputMaybe<Scalars['ID']['input']>;
  purchasableItemId?: InputMaybe<Scalars['ID']['input']>;
  settlementInfo: AcceptorSettlementInfoInput;
  /** The signed amount to be used for dynamic price offers */
  signedAmount?: InputMaybe<Scalars['String']['input']>;
}

/** Autogenerated return type of prepareAcceptOffer. */
export interface prepareAcceptOfferPayload {
  __typename: 'prepareAcceptOfferPayload';
  authorizations?: Maybe<Array<AuthorizationRequest>>;
  cart?: Maybe<Cart>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<UserError>;
  primaryOffer?: Maybe<TokenPrimaryOffer>;
}

/** Autogenerated input type of prepareAcceptTradeWithWalletAndCreditCard */
export interface prepareAcceptTradeWithWalletAndCreditCardInput {
  /** The amount to be used when bidding, in the currency provided in settlement info */
  amount?: InputMaybe<Scalars['String']['input']>;
  /** The wallet approval to be used in addition to the credit card payment. */
  approval: AuthorizationApprovalInput;
  /** The intent id corresponding to a credit card authorization */
  authorizationId: Scalars['String']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  settlementInfo: AcceptorSettlementInfoInput;
  /** The signed amount to be used for dynamic price offers */
  signedAmount?: InputMaybe<Scalars['String']['input']>;
}

/** Autogenerated return type of prepareAcceptTradeWithWalletAndCreditCard. */
export interface prepareAcceptTradeWithWalletAndCreditCardPayload {
  __typename: 'prepareAcceptTradeWithWalletAndCreditCardPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<UserError>;
}

/** Autogenerated input type of prepareBankWithdrawal */
export interface prepareBankWithdrawalInput {
  /** Amount to withdraw */
  amount: CryptoAmountInput;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Destination Blockchain address. */
  destination: Scalars['String']['input'];
}

/** Autogenerated return type of prepareBankWithdrawal. */
export interface prepareBankWithdrawalPayload {
  __typename: 'prepareBankWithdrawalPayload';
  authorization?: Maybe<AuthorizationRequest>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  currentUser?: Maybe<CurrentUser>;
  errors: Array<UserError>;
}

/** Autogenerated input type of prepareBid */
export interface prepareBidInput {
  amount: Scalars['String']['input'];
  attemptReference?: InputMaybe<Scalars['String']['input']>;
  /** Global ID of the english auction to bid on */
  auctionId: Scalars['String']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  settlementInfo: AcceptorSettlementInfoInput;
}

/** Autogenerated return type of prepareBid. */
export interface prepareBidPayload {
  __typename: 'prepareBidPayload';
  authorizations?: Maybe<Array<AuthorizationRequest>>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<UserError>;
}

/** Autogenerated input type of prepareBuyInGameCurrencyPackWithCreditCard */
export interface prepareBuyInGameCurrencyPackWithCreditCardInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The id of the pack to be purchased */
  packId: Scalars['ID']['input'];
  settlementInfo: AcceptorSettlementInfoInput;
}

/** Autogenerated return type of prepareBuyInGameCurrencyPackWithCreditCard. */
export interface prepareBuyInGameCurrencyPackWithCreditCardPayload {
  __typename: 'prepareBuyInGameCurrencyPackWithCreditCardPayload';
  authorization?: Maybe<AuthorizationRequest>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<UserError>;
}

/** Autogenerated input type of prepareDeposit */
export interface prepareDepositInput {
  amount: Scalars['Int']['input'];
  attemptReference?: InputMaybe<Scalars['String']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  saveCard: Scalars['Boolean']['input'];
}

/** Autogenerated return type of prepareDeposit. */
export interface prepareDepositPayload {
  __typename: 'prepareDepositPayload';
  authorization?: Maybe<MangopayCreditCardAuthorizationRequest>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  creditCardAuthorization?: Maybe<CreditCardAuthorizationRequest>;
  errors: Array<UserError>;
}

/** Autogenerated input type of prepareEthDeposit */
export interface prepareEthDepositInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  weiAmount: Scalars['WeiAmount']['input'];
}

/** Autogenerated return type of prepareEthDeposit. */
export interface prepareEthDepositPayload {
  __typename: 'prepareEthDepositPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<UserError>;
  ethDeposit?: Maybe<EthDeposit>;
}

/** Autogenerated input type of prepareIdealDeposit */
export interface prepareIdealDepositInput {
  /** Amount to deposit and its currency */
  amounts: AmountInput;
  attemptReference?: InputMaybe<Scalars['String']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** URL to redirect the user to after the deposit is completed */
  returnUrl?: InputMaybe<Scalars['String']['input']>;
}

/** Autogenerated return type of prepareIdealDeposit. */
export interface prepareIdealDepositPayload {
  __typename: 'prepareIdealDepositPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<UserError>;
  redirectUrl?: Maybe<Scalars['String']['output']>;
}

/** Autogenerated input type of prepareMigrateEth */
export interface prepareMigrateEthInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
}

/** Autogenerated return type of prepareMigrateEth. */
export interface prepareMigrateEthPayload {
  __typename: 'prepareMigrateEthPayload';
  authorization?: Maybe<AuthorizationRequest>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<UserError>;
  weiAmount?: Maybe<Scalars['WeiAmount']['output']>;
}

/** Autogenerated input type of prepareOffRamp */
export interface prepareOffRampInput {
  amountWei: Scalars['String']['input'];
  attemptReference?: InputMaybe<Scalars['String']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
}

/** Autogenerated return type of prepareOffRamp. */
export interface prepareOffRampPayload {
  __typename: 'prepareOffRampPayload';
  authorizations?: Maybe<Array<AuthorizationRequest>>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<UserError>;
  quote?: Maybe<OffRampQuote>;
}

/** Autogenerated input type of prepareOffer */
export interface prepareOfferInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Amount to receive and its currency. Must be one of the settlement currencies. */
  receiveAmount?: InputMaybe<AmountInput>;
  receiveAssetIds: Array<Scalars['String']['input']>;
  receiverSlug?: InputMaybe<Scalars['String']['input']>;
  /** Amount to send and its currency. Must be one of the settlement currencies. */
  sendAmount?: InputMaybe<AmountInput>;
  sendAssetIds: Array<Scalars['String']['input']>;
  /**
   * List of accepted currencies. Must match the proposer wallet currencies (e.g:
   * you cannot receive fiat without a fiat wallet).
   */
  settlementCurrencies?: InputMaybe<Array<SupportedCurrency>>;
}

/** Autogenerated return type of prepareOffer. */
export interface prepareOfferPayload {
  __typename: 'prepareOfferPayload';
  authorizations?: Maybe<Array<AuthorizationRequest>>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<UserError>;
}

/** Autogenerated input type of preparePayByBankDeposit */
export interface preparePayByBankDepositInput {
  /** Amount to deposit and its currency */
  amounts: AmountInput;
  attemptReference?: InputMaybe<Scalars['String']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** URL to redirect the user to after the deposit is completed */
  returnUrl?: InputMaybe<Scalars['String']['input']>;
}

/** Autogenerated return type of preparePayByBankDeposit. */
export interface preparePayByBankDepositPayload {
  __typename: 'preparePayByBankDepositPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<UserError>;
  redirectUrl?: Maybe<Scalars['String']['output']>;
}

/** Autogenerated input type of preparePaypalDeposit */
export interface preparePaypalDepositInput {
  /** Amount to deposit and its currency */
  amounts: AmountInput;
  attemptReference?: InputMaybe<Scalars['String']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** URL to redirect the user to after the deposit is completed */
  returnUrl?: InputMaybe<Scalars['String']['input']>;
}

/** Autogenerated return type of preparePaypalDeposit. */
export interface preparePaypalDepositPayload {
  __typename: 'preparePaypalDepositPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<UserError>;
  redirectUrl?: Maybe<Scalars['String']['output']>;
}

/** Autogenerated input type of prepareSorareRefund */
export interface prepareSorareRefundInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  sorareRefundId: Scalars['ID']['input'];
}

/** Autogenerated return type of prepareSorareRefund. */
export interface prepareSorareRefundPayload {
  __typename: 'prepareSorareRefundPayload';
  authorization?: Maybe<AuthorizationRequest>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<UserError>;
}

/** Autogenerated input type of prepareTokenDeposit */
export interface prepareTokenDepositInput {
  assetId: Scalars['String']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
}

/** Autogenerated return type of prepareTokenDeposit. */
export interface prepareTokenDepositPayload {
  __typename: 'prepareTokenDepositPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<UserError>;
  tokenDeposit?: Maybe<TokenDeposit>;
}

/** Autogenerated input type of probabilisticBundlesOpen */
export interface probabilisticBundlesOpenInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  probabilisticBundleId: Scalars['ID']['input'];
}

/** Autogenerated return type of probabilisticBundlesOpen. */
export interface probabilisticBundlesOpenPayload {
  __typename: 'probabilisticBundlesOpenPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  currentUser?: Maybe<CurrentUser>;
  errors: Array<UserError>;
  probabilisticBundle?: Maybe<ProbabilisticBundle>;
}

/** Autogenerated input type of pullCards */
export interface pullCardsInput {
  cardShardsChestId: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
}

/** Autogenerated return type of pullCards. */
export interface pullCardsPayload {
  __typename: 'pullCardsPayload';
  cardPull?: Maybe<CardPull>;
  cardShardsChest?: Maybe<CardShardsChest>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  currentUser?: Maybe<CurrentUser>;
  errors: Array<UserError>;
}

/** Autogenerated input type of reactToActivity */
export interface reactToActivityInput {
  activityId: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The emoji to toggle, or null to leave the reactions unchanged */
  emoji?: InputMaybe<Scalars['String']['input']>;
}

/** Autogenerated return type of reactToActivity. */
export interface reactToActivityPayload {
  __typename: 'reactToActivityPayload';
  activity?: Maybe<CardPackActivityFeed | LineupActivityFeed | OwnerActivityFeed>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<UserError>;
}

/** Autogenerated input type of refreshCart */
export interface refreshCartInput {
  cartId: Scalars['ID']['input'];
  cartItemIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
}

/** Autogenerated return type of refreshCart. */
export interface refreshCartPayload {
  __typename: 'refreshCartPayload';
  cart?: Maybe<Cart>;
  cartItems?: Maybe<Array<CartItem>>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  currentUser?: Maybe<CurrentUser>;
  errors: Array<UserError>;
}

/** Autogenerated input type of refundSorare */
export interface refundSorareInput {
  approval: AuthorizationApprovalInput;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  sorareRefundId: Scalars['ID']['input'];
}

/** Autogenerated return type of refundSorare. */
export interface refundSorarePayload {
  __typename: 'refundSorarePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  currentUser?: Maybe<CurrentUser>;
  errors: Array<UserError>;
  sorareRefund?: Maybe<SorareRefund>;
}

/** Autogenerated input type of rejectCardPull */
export interface rejectCardPullInput {
  cardPullId: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
}

/** Autogenerated return type of rejectCardPull. */
export interface rejectCardPullPayload {
  __typename: 'rejectCardPullPayload';
  cardPull?: Maybe<CardPull>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  currentUser?: Maybe<CurrentUser>;
  errors: Array<UserError>;
}

/** Autogenerated input type of rejectOffer */
export interface rejectOfferInput {
  block?: InputMaybe<Scalars['Boolean']['input']>;
  blockchainId: Scalars['String']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  rejectionReason?: InputMaybe<TokenOfferRejectionReason>;
}

/** Autogenerated return type of rejectOffer. */
export interface rejectOfferPayload {
  __typename: 'rejectOfferPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<UserError>;
  /** The sport-agnostic offer */
  tokenOffer?: Maybe<TokenOffer>;
}

/** Autogenerated input type of removeActivity */
export interface removeActivityInput {
  activityId: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
}

/** Autogenerated return type of removeActivity. */
export interface removeActivityPayload {
  __typename: 'removeActivityPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  currentUser?: Maybe<CurrentUser>;
  errors: Array<UserError>;
}

/** Autogenerated input type of removeAuctionReminder */
export interface removeAuctionReminderInput {
  auctionReminderId: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
}

/** Autogenerated return type of removeAuctionReminder. */
export interface removeAuctionReminderPayload {
  __typename: 'removeAuctionReminderPayload';
  auction?: Maybe<TokenAuction>;
  auctionReminder?: Maybe<AuctionReminder>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  currentUser?: Maybe<CurrentUser>;
  errors: Array<UserError>;
}

/** Autogenerated input type of removeFromCart */
export interface removeFromCartInput {
  cartId: Scalars['ID']['input'];
  cartItemIds: Array<Scalars['ID']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
}

/** Autogenerated return type of removeFromCart. */
export interface removeFromCartPayload {
  __typename: 'removeFromCartPayload';
  cart?: Maybe<Cart>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  currentUser?: Maybe<CurrentUser>;
  errors: Array<UserError>;
}

/** Autogenerated input type of removeFromWatchlist */
export interface removeFromWatchlistInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  printablePlayerIds: Array<Scalars['ID']['input']>;
  watchlistId?: InputMaybe<Scalars['ID']['input']>;
}

/** Autogenerated return type of removeFromWatchlist. */
export interface removeFromWatchlistPayload {
  __typename: 'removeFromWatchlistPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  currentUser?: Maybe<CurrentUser>;
  errors: Array<UserError>;
  watchlist?: Maybe<Watchlist>;
}

/** Autogenerated input type of removeMemberFromSquad */
export interface removeMemberFromSquadInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  squadId: Scalars['ID']['input'];
  /** The member to remove. Pass the current user to leave the squad. */
  userId: Scalars['ID']['input'];
}

/** Autogenerated return type of removeMemberFromSquad. */
export interface removeMemberFromSquadPayload {
  __typename: 'removeMemberFromSquadPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<UserError>;
  squad?: Maybe<Squad>;
}

/** Autogenerated input type of removeTokenFromDeck */
export interface removeTokenFromDeckInput {
  assetId?: InputMaybe<Scalars['String']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  deckSlug: Scalars['String']['input'];
  slug?: InputMaybe<Scalars['String']['input']>;
}

/** Autogenerated return type of removeTokenFromDeck. */
export interface removeTokenFromDeckPayload {
  __typename: 'removeTokenFromDeckPayload';
  card?: Maybe<BaseballCard | Card | NBACard>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  currentUser?: Maybe<CurrentUser>;
  deck?: Maybe<Deck>;
  errors: Array<UserError>;
}

/** Autogenerated input type of removeUserFromSo5UserGroup */
export interface removeUserFromSo5UserGroupInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  so5UserGroupId: Scalars['String']['input'];
  userId: Scalars['String']['input'];
}

/** Autogenerated return type of removeUserFromSo5UserGroup. */
export interface removeUserFromSo5UserGroupPayload {
  __typename: 'removeUserFromSo5UserGroupPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  currentUser?: Maybe<CurrentUser>;
  errors: Array<UserError>;
  so5UserGroup?: Maybe<So5UserGroup>;
  userGroup?: Maybe<So5UserGroup>;
}

/** Autogenerated input type of reorderTaskPreparedLineup */
export interface reorderTaskPreparedLineupInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  newIndex: Scalars['Int']['input'];
  taskPreparedLineupId: Scalars['ID']['input'];
}

/** Autogenerated return type of reorderTaskPreparedLineup. */
export interface reorderTaskPreparedLineupPayload {
  __typename: 'reorderTaskPreparedLineupPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<UserError>;
  task?: Maybe<CardsCountTargetTask | CardsCountTask | CompleteCollectionsCountTargetTask | CompleteCollectionsCountTask | DailyActionTask | DecisivePlayerPickerTask | DropChallengeTask | GameWeeklyTask | GuessTheScoreTask | InviteTaskAsReferrer | So5LeaderboardTask | StarPackTask | Task | TasksTrack | ThresholdPickerTask | ThresholdsDuoConnectionTask | ThresholdsStreakAdditionalLineupTask | ThresholdsStreakTask>;
  taskPreparedLineup?: Maybe<TaskPreparedLineup>;
}

/** Autogenerated input type of reportTelemetry */
export interface reportTelemetryInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  operations: Array<OperationInput>;
}

/** Autogenerated return type of reportTelemetry. */
export interface reportTelemetryPayload {
  __typename: 'reportTelemetryPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<UserError>;
}

/** Autogenerated input type of reportUser */
export interface reportUserInput {
  category: UserReportCategory;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  comment?: InputMaybe<Scalars['String']['input']>;
  contextSlug?: InputMaybe<Scalars['String']['input']>;
  contextType: UserReportContext;
  reportedUserSlug: Scalars['String']['input'];
}

/** Autogenerated return type of reportUser. */
export interface reportUserPayload {
  __typename: 'reportUserPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<UserError>;
}

/** Autogenerated input type of requestJonumSelfExclusion */
export interface requestJonumSelfExclusionInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** End date of the self-exclusion period (must be between 24 hours and 12 months from now) */
  exclusionEndDate: Scalars['ISO8601DateTime']['input'];
}

/** Autogenerated return type of requestJonumSelfExclusion. */
export interface requestJonumSelfExclusionPayload {
  __typename: 'requestJonumSelfExclusionPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<UserError>;
  verification?: Maybe<Verification>;
}

/** Autogenerated input type of requestSo5NoCardBoardDraftableAppearance */
export interface requestSo5NoCardBoardDraftableAppearanceInput {
  accessToken: Scalars['String']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  sport: Sport;
}

/** Autogenerated return type of requestSo5NoCardBoardDraftableAppearance. */
export interface requestSo5NoCardBoardDraftableAppearancePayload {
  __typename: 'requestSo5NoCardBoardDraftableAppearancePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  currentUser?: Maybe<CurrentUser>;
  draftableAppearance?: Maybe<So5NoCardDraftableAppearance>;
  eligibleSlotIndex?: Maybe<Scalars['Int']['output']>;
  errors: Array<UserError>;
}

/** Autogenerated input type of requestSo5NoCardDraftableAppearance */
export interface requestSo5NoCardDraftableAppearanceInput {
  accessToken: Scalars['String']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  configSignature?: InputMaybe<Scalars['String']['input']>;
  so5FixtureId: Scalars['ID']['input'];
}

/** Autogenerated return type of requestSo5NoCardDraftableAppearance. */
export interface requestSo5NoCardDraftableAppearancePayload {
  __typename: 'requestSo5NoCardDraftableAppearancePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  currentUser?: Maybe<CurrentUser>;
  draftableAppearance?: Maybe<So5NoCardDraftableAppearance>;
  eligibleSlotIndex?: Maybe<Scalars['Int']['output']>;
  errors: Array<UserError>;
}

/** Autogenerated input type of requestSo5NoCardLineupEligibleLeaderboards */
export interface requestSo5NoCardLineupEligibleLeaderboardsInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  so5NoCardLineupId: Scalars['ID']['input'];
}

/** Autogenerated return type of requestSo5NoCardLineupEligibleLeaderboards. */
export interface requestSo5NoCardLineupEligibleLeaderboardsPayload {
  __typename: 'requestSo5NoCardLineupEligibleLeaderboardsPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  currentUser?: Maybe<CurrentUser>;
  errors: Array<UserError>;
  so5NoCardLineup?: Maybe<So5NoCardLineup>;
}

/** Autogenerated input type of resendConfirmationInstructions */
export interface resendConfirmationInstructionsInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The path where the user should be redirected after email confirmation */
  fromPath?: InputMaybe<Scalars['String']['input']>;
  recaptchaToken?: InputMaybe<Scalars['String']['input']>;
  recaptchaTokenIos?: InputMaybe<Scalars['String']['input']>;
  recaptchaTokenV2?: InputMaybe<Scalars['String']['input']>;
}

/** Autogenerated return type of resendConfirmationInstructions. */
export interface resendConfirmationInstructionsPayload {
  __typename: 'resendConfirmationInstructionsPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  currentUser?: Maybe<CurrentUser>;
  errors: Array<UserError>;
}

/** Autogenerated input type of resendVerificationCode */
export interface resendVerificationCodeInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  reference: Scalars['String']['input'];
}

/** Autogenerated return type of resendVerificationCode. */
export interface resendVerificationCodePayload {
  __typename: 'resendVerificationCodePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  currentUser?: Maybe<CurrentUser>;
  errors: Array<UserError>;
}

/** Autogenerated input type of resetPrivateKey */
export interface resetPrivateKeyInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  starkKey?: InputMaybe<Scalars['String']['input']>;
}

/** Autogenerated return type of resetPrivateKey. */
export interface resetPrivateKeyPayload {
  __typename: 'resetPrivateKeyPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  currentUser?: Maybe<CurrentUser>;
  errors: Array<UserError>;
}

/** Autogenerated input type of resetSo5NoCardBoardDraftedAppearances */
export interface resetSo5NoCardBoardDraftedAppearancesInput {
  accessToken: Scalars['String']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  sport: Sport;
}

/** Autogenerated return type of resetSo5NoCardBoardDraftedAppearances. */
export interface resetSo5NoCardBoardDraftedAppearancesPayload {
  __typename: 'resetSo5NoCardBoardDraftedAppearancesPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  currentUser?: Maybe<CurrentUser>;
  errors: Array<UserError>;
}

/** Autogenerated input type of resetSo5NoCardDraftedAppearances */
export interface resetSo5NoCardDraftedAppearancesInput {
  accessToken: Scalars['String']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  so5FixtureId: Scalars['ID']['input'];
}

/** Autogenerated return type of resetSo5NoCardDraftedAppearances. */
export interface resetSo5NoCardDraftedAppearancesPayload {
  __typename: 'resetSo5NoCardDraftedAppearancesPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  currentUser?: Maybe<CurrentUser>;
  errors: Array<UserError>;
}

/** Autogenerated input type of restartTasksTrack */
export interface restartTasksTrackInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  force?: InputMaybe<Scalars['Boolean']['input']>;
  taskId: Scalars['ID']['input'];
}

/** Autogenerated return type of restartTasksTrack. */
export interface restartTasksTrackPayload {
  __typename: 'restartTasksTrackPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  currentUser?: Maybe<CurrentUser>;
  errors: Array<UserError>;
  newTask?: Maybe<CardsCountTargetTask | CardsCountTask | CompleteCollectionsCountTargetTask | CompleteCollectionsCountTask | DailyActionTask | DecisivePlayerPickerTask | DropChallengeTask | GameWeeklyTask | GuessTheScoreTask | InviteTaskAsReferrer | So5LeaderboardTask | StarPackTask | Task | TasksTrack | ThresholdPickerTask | ThresholdsDuoConnectionTask | ThresholdsStreakAdditionalLineupTask | ThresholdsStreakTask>;
}

/** Autogenerated input type of restoreWallet */
export interface restoreWalletInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  passwordEncryptedPrivateKey: PasswordEncryptedPrivateKeyInput;
  passwordHash: Scalars['String']['input'];
}

/** Autogenerated return type of restoreWallet. */
export interface restoreWalletPayload {
  __typename: 'restoreWalletPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  currentUser?: Maybe<CurrentUser>;
  errors: Array<UserError>;
}

/** Autogenerated input type of revealBlueprints */
export interface revealBlueprintsInput {
  cardSlugs: Array<Scalars['String']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
}

/** Autogenerated return type of revealBlueprints. */
export interface revealBlueprintsPayload {
  __typename: 'revealBlueprintsPayload';
  cards?: Maybe<Array<BaseballCard | Card | NBACard>>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  currentUser?: Maybe<CurrentUser>;
  errors: Array<UserError>;
  nonRevealableCards?: Maybe<Array<BaseballCard | Card | NBACard>>;
}

/** Autogenerated input type of revealProperty */
export interface revealPropertyInput {
  cardPullId: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  propertyName: RevealableProperty;
  revealPropertyCurrency?: InputMaybe<RevealPropertyCurrency>;
}

/** Autogenerated return type of revealProperty. */
export interface revealPropertyPayload {
  __typename: 'revealPropertyPayload';
  cardPull?: Maybe<CardPull>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  currentUser?: Maybe<CurrentUser>;
  errors: Array<UserError>;
}

/** Autogenerated input type of revokeDevice */
export interface revokeDeviceInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  deviceId: Scalars['String']['input'];
}

/** Autogenerated return type of revokeDevice. */
export interface revokeDevicePayload {
  __typename: 'revokeDevicePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  currentUser?: Maybe<CurrentUser>;
  errors: Array<UserError>;
}

/** Autogenerated input type of revokeEip7702Delegation */
export interface revokeEip7702DelegationInput {
  authorization: Eip7702AuthorizationInput;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
}

/** Autogenerated return type of revokeEip7702Delegation. */
export interface revokeEip7702DelegationPayload {
  __typename: 'revokeEip7702DelegationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<UserError>;
  revocation?: Maybe<Eip7702Revocation>;
}

/** Autogenerated input type of revokeOAuthAccessTokenForApplication */
export interface revokeOAuthAccessTokenForApplicationInput {
  applicationId: Scalars['String']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
}

/** Autogenerated return type of revokeOAuthAccessTokenForApplication. */
export interface revokeOAuthAccessTokenForApplicationPayload {
  __typename: 'revokeOAuthAccessTokenForApplicationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  currentUser?: Maybe<CurrentUser>;
  errors: Array<UserError>;
}

/** Autogenerated input type of revokeOAuthAccessToken */
export interface revokeOAuthAccessTokenInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
}

/** Autogenerated return type of revokeOAuthAccessToken. */
export interface revokeOAuthAccessTokenPayload {
  __typename: 'revokeOAuthAccessTokenPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  currentUser?: Maybe<CurrentUser>;
  errors: Array<UserError>;
}

/** Autogenerated input type of saveForLater */
export interface saveForLaterInput {
  cartId: Scalars['ID']['input'];
  cartItemIds: Array<Scalars['ID']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
}

/** Autogenerated return type of saveForLater. */
export interface saveForLaterPayload {
  __typename: 'saveForLaterPayload';
  cart?: Maybe<Cart>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  currentUser?: Maybe<CurrentUser>;
  errors: Array<UserError>;
}

/** Autogenerated input type of sealCards */
export interface sealCardsInput {
  cardSlugs: Array<Scalars['String']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
}

/** Autogenerated return type of sealCards. */
export interface sealCardsPayload {
  __typename: 'sealCardsPayload';
  cards?: Maybe<Array<BaseballCard | Card | NBACard>>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  currentUser?: Maybe<CurrentUser>;
  errors: Array<UserError>;
}

/** Autogenerated input type of sendWalletRecovery */
export interface sendWalletRecoveryInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Use recoveryOptionId, which does not require the plaintext destination */
  destination?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Use recoveryOptionId, which does not require the plaintext destination */
  method?: InputMaybe<PrivateKeyRecoveryOptionMethodEnum>;
  recoveryOptionId?: InputMaybe<Scalars['ID']['input']>;
}

/** Autogenerated return type of sendWalletRecovery. */
export interface sendWalletRecoveryPayload {
  __typename: 'sendWalletRecoveryPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  currentUser?: Maybe<CurrentUser>;
  errors: Array<UserError>;
  recoveryKeySent?: Maybe<Scalars['Boolean']['output']>;
}

/** Autogenerated input type of setDeviceToken */
export interface setDeviceTokenInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  devicePlatform: Scalars['String']['input'];
  deviceToken: Scalars['String']['input'];
  disable?: InputMaybe<Scalars['Boolean']['input']>;
}

/** Autogenerated return type of setDeviceToken. */
export interface setDeviceTokenPayload {
  __typename: 'setDeviceTokenPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<UserError>;
}

/** Autogenerated input type of setJonumPlaytimeLimit */
export interface setJonumPlaytimeLimitInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Weekly playtime limit in minutes */
  playtimeLimitWeekly: Scalars['Int']['input'];
}

/** Autogenerated return type of setJonumPlaytimeLimit. */
export interface setJonumPlaytimeLimitPayload {
  __typename: 'setJonumPlaytimeLimitPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<UserError>;
  /** When the change will take effect (null if applied immediately) */
  pendingEffectiveAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  verification?: Maybe<Verification>;
}

/** Autogenerated input type of setJonumSpendingLimit */
export interface setJonumSpendingLimitInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Weekly spending limit */
  spendingLimitWeekly: PositiveAmountInput;
}

/** Autogenerated return type of setJonumSpendingLimit. */
export interface setJonumSpendingLimitPayload {
  __typename: 'setJonumSpendingLimitPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<UserError>;
  /** When the change will take effect (null if applied immediately) */
  pendingEffectiveAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  verification?: Maybe<Verification>;
}

/** Autogenerated input type of setTokenTradeStatus */
export interface setTokenTradeStatusInput {
  assetId: Scalars['String']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  tradeable: Scalars['Boolean']['input'];
}

/** Autogenerated return type of setTokenTradeStatus. */
export interface setTokenTradeStatusPayload {
  __typename: 'setTokenTradeStatusPayload';
  card?: Maybe<BaseballCard | Card | NBACard>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<UserError>;
}

/** Autogenerated input type of shareCard */
export interface shareCardInput {
  cardSlug: Scalars['String']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
}

/** Autogenerated input type of shareCardPack */
export interface shareCardPackInput {
  cardSlug: Scalars['String']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
}

/** Autogenerated return type of shareCardPack. */
export interface shareCardPackPayload {
  __typename: 'shareCardPackPayload';
  activity?: Maybe<CardPackActivityFeed | LineupActivityFeed | OwnerActivityFeed>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  currentUser?: Maybe<CurrentUser>;
  errors: Array<UserError>;
}

/** Autogenerated return type of shareCard. */
export interface shareCardPayload {
  __typename: 'shareCardPayload';
  activity?: Maybe<CardPackActivityFeed | LineupActivityFeed | OwnerActivityFeed>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  currentUser?: Maybe<CurrentUser>;
  errors: Array<UserError>;
}

/** Autogenerated input type of shareLineup */
export interface shareLineupInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  taskLineupId: Scalars['ID']['input'];
}

/** Autogenerated return type of shareLineup. */
export interface shareLineupPayload {
  __typename: 'shareLineupPayload';
  activity?: Maybe<CardPackActivityFeed | LineupActivityFeed | OwnerActivityFeed>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<UserError>;
}

/** Autogenerated input type of signIn */
export interface signInInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  deviceFingerprint?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  gaClientId?: InputMaybe<Scalars['String']['input']>;
  otpAttempt?: InputMaybe<Scalars['String']['input']>;
  otpSessionChallenge?: InputMaybe<Scalars['String']['input']>;
  passkeyChallenge?: InputMaybe<Scalars['String']['input']>;
  passkeyCredential?: InputMaybe<PasskeyCredentialForGetInput>;
  password?: InputMaybe<Scalars['String']['input']>;
}

/** Autogenerated input type of signInWithOAuth */
export interface signInWithOAuthInput {
  acceptAgeLimit?: InputMaybe<Scalars['Boolean']['input']>;
  acceptGameRules?: InputMaybe<Scalars['Boolean']['input']>;
  acceptPrivacyPolicy?: InputMaybe<Scalars['Boolean']['input']>;
  acceptTerms?: InputMaybe<Scalars['Boolean']['input']>;
  agreedToReceiveOffersFromPartners?: InputMaybe<Scalars['Boolean']['input']>;
  agreedToReceiveOffersFromPartnersSpecific?: InputMaybe<Array<Scalars['String']['input']>>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  facebookClickId?: InputMaybe<Scalars['String']['input']>;
  googleClickId?: InputMaybe<Scalars['String']['input']>;
  idToken: Scalars['String']['input'];
  impactClickId?: InputMaybe<Scalars['String']['input']>;
  nickname?: InputMaybe<Scalars['String']['input']>;
  platform?: InputMaybe<Platform>;
  provider: OAuthProvider;
  redditClickId?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Use referrerCode instead */
  referrer?: InputMaybe<Scalars['String']['input']>;
  referrerCode?: InputMaybe<Scalars['String']['input']>;
  /** Slug of the inviting user, as carried by the legacy /r/:user_slug links */
  referrerSlug?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Use platform instead */
  signupPlatform?: InputMaybe<SignupPlatform>;
  signupSport?: InputMaybe<Sport>;
  snapchatClickId?: InputMaybe<Scalars['String']['input']>;
  tikTokClickId?: InputMaybe<Scalars['String']['input']>;
  twitterClickId?: InputMaybe<Scalars['String']['input']>;
  utmParams?: InputMaybe<UtmInput>;
}

/** Autogenerated input type of signOutFromAllDevices */
export interface signOutFromAllDevicesInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
}

/** Autogenerated return type of signOutFromAllDevices. */
export interface signOutFromAllDevicesPayload {
  __typename: 'signOutFromAllDevicesPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<UserError>;
}

/** Autogenerated input type of signUp */
export interface signUpInput {
  acceptAgeLimit: Scalars['Boolean']['input'];
  acceptGameRules: Scalars['Boolean']['input'];
  acceptPrivacyPolicy: Scalars['Boolean']['input'];
  acceptTerms: Scalars['Boolean']['input'];
  agreedToReceiveOffersFromPartners?: InputMaybe<Scalars['Boolean']['input']>;
  agreedToReceiveOffersFromPartnersSpecific?: InputMaybe<Array<Scalars['String']['input']>>;
  certified?: InputMaybe<Scalars['String']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  facebookClickId?: InputMaybe<Scalars['String']['input']>;
  /** The path the new User is from (to be used to redirect him after email confirmation) */
  fromPath?: InputMaybe<Scalars['String']['input']>;
  gaClientId?: InputMaybe<Scalars['String']['input']>;
  googleClickId?: InputMaybe<Scalars['String']['input']>;
  impactClickId?: InputMaybe<Scalars['String']['input']>;
  nickname: Scalars['String']['input'];
  password: Scalars['String']['input'];
  platform?: InputMaybe<Platform>;
  promoCode?: InputMaybe<Scalars['String']['input']>;
  recaptchaToken?: InputMaybe<Scalars['String']['input']>;
  recaptchaTokenIos?: InputMaybe<Scalars['String']['input']>;
  recaptchaTokenV2?: InputMaybe<Scalars['String']['input']>;
  redditClickId?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Use referrerCode instead */
  referrer?: InputMaybe<Scalars['String']['input']>;
  referrerCode?: InputMaybe<Scalars['String']['input']>;
  /** Slug of the inviting user, as carried by the legacy /r/:user_slug links */
  referrerSlug?: InputMaybe<Scalars['String']['input']>;
  signupSport?: InputMaybe<Sport>;
  snapchatClickId?: InputMaybe<Scalars['String']['input']>;
  sorareAddress?: InputMaybe<Scalars['EthereumAddress']['input']>;
  sorarePrivateKey?: InputMaybe<SorarePrivateKeyAttributes>;
  sorarePrivateKeyBackup?: InputMaybe<Scalars['String']['input']>;
  starkKey?: InputMaybe<Scalars['String']['input']>;
  tikTokClickId?: InputMaybe<Scalars['String']['input']>;
  twitterClickId?: InputMaybe<Scalars['String']['input']>;
  utmParams?: InputMaybe<UtmInput>;
  wallet?: InputMaybe<WalletInput>;
}

/** Autogenerated input type of skipOnboarding */
export interface skipOnboardingInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  interactionContext?: InputMaybe<Scalars['String']['input']>;
  sport: Sport;
}

/** Autogenerated return type of skipOnboarding. */
export interface skipOnboardingPayload {
  __typename: 'skipOnboardingPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  currentUser?: Maybe<CurrentUser>;
  errors: Array<UserError>;
}

/** Autogenerated input type of spinWheel */
export interface spinWheelInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  rarity?: InputMaybe<Rarity>;
  sport: Sport;
  wheelType: WheelType;
}

/** Autogenerated return type of spinWheel. */
export interface spinWheelPayload {
  __typename: 'spinWheelPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  currentUser?: Maybe<CurrentUser>;
  errors: Array<UserError>;
  reward?: Maybe<ProbabilisticBundle>;
}

/** Autogenerated input type of startFiatWalletIdentityVerification */
export interface startFiatWalletIdentityVerificationInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** URL to redirect the user to after the hosted verification is completed. */
  returnUrl: Scalars['String']['input'];
}

/** Autogenerated return type of startFiatWalletIdentityVerification. */
export interface startFiatWalletIdentityVerificationPayload {
  __typename: 'startFiatWalletIdentityVerificationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<UserError>;
  identityVerification?: Maybe<MangopayIdentityVerification>;
  mangopayUser?: Maybe<MangopayUser>;
}

/** Autogenerated input type of startOffRampBridgeKyc */
export interface startOffRampBridgeKycInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** URL to redirect the user to after completing the hosted KYC flow. */
  returnUrl?: InputMaybe<Scalars['String']['input']>;
}

/** Autogenerated return type of startOffRampBridgeKyc. */
export interface startOffRampBridgeKycPayload {
  __typename: 'startOffRampBridgeKycPayload';
  bridgeAccount?: Maybe<OffRampBridgeAccount>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  currentUser?: Maybe<CurrentUser>;
  errors: Array<UserError>;
  /** Hosted Bridge.xyz KYC link the frontend redirects to. */
  kycLinkUrl?: Maybe<Scalars['String']['output']>;
}

/** Autogenerated input type of stopAutoBid */
export interface stopAutoBidInput {
  bidId: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
}

/** Autogenerated return type of stopAutoBid. */
export interface stopAutoBidPayload {
  __typename: 'stopAutoBidPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<UserError>;
  /** The sport-agnostic bid */
  tokenBid?: Maybe<TokenBid>;
}

/** Autogenerated input type of storeApplePurchaseToken */
export interface storeApplePurchaseTokenInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  token: Scalars['String']['input'];
}

/** Autogenerated return type of storeApplePurchaseToken. */
export interface storeApplePurchaseTokenPayload {
  __typename: 'storeApplePurchaseTokenPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  currentUser?: Maybe<CurrentUser>;
  errors: Array<UserError>;
  token?: Maybe<ApplePurchaseToken>;
}

/** Autogenerated input type of suggestLineup */
export interface suggestLineupInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  so5LeaderboardId: Scalars['ID']['input'];
  so5LineupId?: InputMaybe<Scalars['ID']['input']>;
}

/** Autogenerated return type of suggestLineup. */
export interface suggestLineupPayload {
  __typename: 'suggestLineupPayload';
  captainIndex?: Maybe<Scalars['Int']['output']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  composeTeamBenchObjects?: Maybe<Array<ComposeTeamBenchCard | ComposeTeamBenchCommonPlayer | DecisivePlayerPickerTaskAppearance | MissedAppearance | So5Appearance | TaskAppearance | ThresholdPickerTaskAppearance>>;
  errors: Array<UserError>;
}

/** Autogenerated input type of swapTaskAppearances */
export interface swapTaskAppearancesInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  firstTaskAppearanceId: Scalars['ID']['input'];
  secondTaskAppearanceId: Scalars['ID']['input'];
}

/** Autogenerated return type of swapTaskAppearances. */
export interface swapTaskAppearancesPayload {
  __typename: 'swapTaskAppearancesPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  currentUser?: Maybe<CurrentUser>;
  errors: Array<UserError>;
  firstTask?: Maybe<CardsCountTargetTask | CardsCountTask | CompleteCollectionsCountTargetTask | CompleteCollectionsCountTask | DailyActionTask | DecisivePlayerPickerTask | DropChallengeTask | GameWeeklyTask | GuessTheScoreTask | InviteTaskAsReferrer | So5LeaderboardTask | StarPackTask | Task | TasksTrack | ThresholdPickerTask | ThresholdsDuoConnectionTask | ThresholdsStreakAdditionalLineupTask | ThresholdsStreakTask>;
  secondTask?: Maybe<CardsCountTargetTask | CardsCountTask | CompleteCollectionsCountTargetTask | CompleteCollectionsCountTask | DailyActionTask | DecisivePlayerPickerTask | DropChallengeTask | GameWeeklyTask | GuessTheScoreTask | InviteTaskAsReferrer | So5LeaderboardTask | StarPackTask | Task | TasksTrack | ThresholdPickerTask | ThresholdsDuoConnectionTask | ThresholdsStreakAdditionalLineupTask | ThresholdsStreakTask>;
}

/** Autogenerated input type of unblockFiatWallet */
export interface unblockFiatWalletInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  files: Array<DocumentInput>;
}

/** Autogenerated return type of unblockFiatWallet. */
export interface unblockFiatWalletPayload {
  __typename: 'unblockFiatWalletPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  currentUser?: Maybe<CurrentUser>;
  errors: Array<UserError>;
}

/** Autogenerated input type of unblockUserOffers */
export interface unblockUserOffersInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  userSlug: Scalars['String']['input'];
}

/** Autogenerated return type of unblockUserOffers. */
export interface unblockUserOffersPayload {
  __typename: 'unblockUserOffersPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  currentUser?: Maybe<CurrentUser>;
  errors: Array<UserError>;
}

/** Autogenerated input type of unlockNextBoard */
export interface unlockNextBoardInput {
  boardId: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  interactionContext?: InputMaybe<Scalars['String']['input']>;
}

/** Autogenerated return type of unlockNextBoard. */
export interface unlockNextBoardPayload {
  __typename: 'unlockNextBoardPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  currentUser?: Maybe<CurrentUser>;
  errors: Array<UserError>;
}

/** Autogenerated input type of unlockProMode */
export interface unlockProModeInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  interactionContext?: InputMaybe<Scalars['String']['input']>;
  rarity?: InputMaybe<Rarity>;
  sport: Sport;
}

/** Autogenerated return type of unlockProMode. */
export interface unlockProModePayload {
  __typename: 'unlockProModePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  currentUser?: Maybe<CurrentUser>;
  errors: Array<UserError>;
}

/** Autogenerated input type of unsealCards */
export interface unsealCardsInput {
  cardSlugs: Array<Scalars['String']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
}

/** Autogenerated return type of unsealCards. */
export interface unsealCardsPayload {
  __typename: 'unsealCardsPayload';
  cards?: Maybe<Array<BaseballCard | Card | NBACard>>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  currentUser?: Maybe<CurrentUser>;
  errors: Array<UserError>;
}

/** Autogenerated input type of unsubscribeFromEmails */
export interface unsubscribeFromEmailsInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  token: Scalars['String']['input'];
}

/** Autogenerated return type of unsubscribeFromEmails. */
export interface unsubscribeFromEmailsPayload {
  __typename: 'unsubscribeFromEmailsPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<UserError>;
}

/** Autogenerated input type of updateCardFilters */
export interface updateCardFiltersInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  filters: Scalars['Json']['input'];
  sport: Sport;
}

/** Autogenerated return type of updateCardFilters. */
export interface updateCardFiltersPayload {
  __typename: 'updateCardFiltersPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  currentUser?: Maybe<CurrentUser>;
  errors: Array<UserError>;
}

/** Autogenerated input type of updateExternalEthDeposit */
export interface updateExternalEthDepositInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** ID of the deposit */
  id: Scalars['ID']['input'];
  /** Transaction hash of the deposit to the bridge */
  transactionHash: Scalars['String']['input'];
}

/** Autogenerated return type of updateExternalEthDeposit. */
export interface updateExternalEthDepositPayload {
  __typename: 'updateExternalEthDepositPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  currentUser?: Maybe<CurrentUser>;
  errors: Array<UserError>;
}

/** Autogenerated input type of updateFavoriteTeam */
export interface updateFavoriteTeamInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  favoriteTeamSlug: Scalars['ID']['input'];
  sport: Sport;
}

/** Autogenerated return type of updateFavoriteTeam. */
export interface updateFavoriteTeamPayload {
  __typename: 'updateFavoriteTeamPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<UserError>;
  team?: Maybe<Club | NationalTeam>;
  userSportProfile?: Maybe<BaseballUserSportProfile | FootballUserSportProfile | NBAUserSportProfile>;
}

/** Autogenerated input type of updateFiatWallet */
export interface updateFiatWalletInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  dob?: InputMaybe<Scalars['ISO8601Date']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
}

/** Autogenerated return type of updateFiatWallet. */
export interface updateFiatWalletPayload {
  __typename: 'updateFiatWalletPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  currentUser?: Maybe<CurrentUser>;
  errors: Array<UserError>;
}

/** Autogenerated input type of updateHighlightedCard */
export interface updateHighlightedCardInput {
  cardCollectionCardId: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
}

/** Autogenerated return type of updateHighlightedCard. */
export interface updateHighlightedCardPayload {
  __typename: 'updateHighlightedCardPayload';
  cardCollectionCard?: Maybe<CardCollectionCard>;
  cardCollectionSlot?: Maybe<CardCollectionSlot>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<UserError>;
}

/** Autogenerated input type of updateManagerTeam */
export interface updateManagerTeamInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  hidden?: InputMaybe<Scalars['Boolean']['input']>;
  managerTeamId: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
}

/** Autogenerated return type of updateManagerTeam. */
export interface updateManagerTeamPayload {
  __typename: 'updateManagerTeamPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  currentUser?: Maybe<CurrentUser>;
  errors: Array<UserError>;
  managerTeam?: Maybe<ManagerTeam>;
}

/** Autogenerated input type of updateOAuthApplication */
export interface updateOAuthApplicationInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  logoContentType?: InputMaybe<Scalars['String']['input']>;
  logoData?: InputMaybe<Scalars['String']['input']>;
  redirectUris: Array<Scalars['String']['input']>;
}

/** Autogenerated input type of updateOnboardingSo5Leaderboard */
export interface updateOnboardingSo5LeaderboardInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  onboardingSo5LeaderboardId: Scalars['ID']['input'];
}

/** Autogenerated return type of updateOnboardingSo5Leaderboard. */
export interface updateOnboardingSo5LeaderboardPayload {
  __typename: 'updateOnboardingSo5LeaderboardPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  currentUser?: Maybe<CurrentUser>;
  errors: Array<UserError>;
}

/** Autogenerated input type of updatePartnerOffersAgreement */
export interface updatePartnerOffersAgreementInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  partner: Scalars['String']['input'];
  value: Scalars['Boolean']['input'];
}

/** Autogenerated return type of updatePartnerOffersAgreement. */
export interface updatePartnerOffersAgreementPayload {
  __typename: 'updatePartnerOffersAgreementPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  currentUser?: Maybe<CurrentUser>;
  errors: Array<UserError>;
}

/** Autogenerated input type of updateSectionNotificationPreferences */
export interface updateSectionNotificationPreferencesInput {
  channels: Array<NotificationPreferenceChannel>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  section: Scalars['String']['input'];
  sport: SportOrShared;
}

/** Autogenerated return type of updateSectionNotificationPreferences. */
export interface updateSectionNotificationPreferencesPayload {
  __typename: 'updateSectionNotificationPreferencesPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  currentUser?: Maybe<CurrentUser>;
  errors: Array<UserError>;
  section?: Maybe<NotificationSection>;
}

/** Autogenerated input type of updateSo5LineupSettings */
export interface updateSo5LineupSettingsInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  hidden?: InputMaybe<Scalars['Boolean']['input']>;
  so5LineupId: Scalars['ID']['input'];
}

/** Autogenerated return type of updateSo5LineupSettings. */
export interface updateSo5LineupSettingsPayload {
  __typename: 'updateSo5LineupSettingsPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  currentUser?: Maybe<CurrentUser>;
  errors: Array<UserError>;
  so5Lineup?: Maybe<So5Lineup>;
}

/** Autogenerated input type of updateSo5UserGroup */
export interface updateSo5UserGroupInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  joinDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  logoId?: InputMaybe<Scalars['ID']['input']>;
  newAdminId?: InputMaybe<Scalars['ID']['input']>;
  publiclyAccessible?: InputMaybe<Scalars['Boolean']['input']>;
  so5UserGroupId: Scalars['ID']['input'];
}

/** Autogenerated return type of updateSo5UserGroup. */
export interface updateSo5UserGroupPayload {
  __typename: 'updateSo5UserGroupPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<UserError>;
  so5UserGroup?: Maybe<So5UserGroup>;
  userGroup?: Maybe<So5UserGroup>;
}

/** Autogenerated input type of updateSportProfile */
export interface updateSportProfileInput {
  achievementBadgesIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  backgroundId?: InputMaybe<Scalars['ID']['input']>;
  bannerColor?: InputMaybe<Scalars['String']['input']>;
  bannerUrl?: InputMaybe<Scalars['String']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  clubBadgeId?: InputMaybe<Scalars['ID']['input']>;
  clubName?: InputMaybe<Scalars['String']['input']>;
  /** pass an empty value to unset */
  highlightedDeckId?: InputMaybe<Scalars['ID']['input']>;
  selectedStatistics?: InputMaybe<Array<InputMaybe<UserSportStatisticSlug>>>;
  shieldUrl?: InputMaybe<Scalars['String']['input']>;
  sport: Sport;
}

/** Autogenerated return type of updateSportProfile. */
export interface updateSportProfilePayload {
  __typename: 'updateSportProfilePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<UserError>;
  userSportProfile?: Maybe<AnyUserSportProfile>;
}

/** Autogenerated input type of updateSquadPrivacy */
export interface updateSquadPrivacyInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  private: Scalars['Boolean']['input'];
  squadId: Scalars['ID']['input'];
}

/** Autogenerated return type of updateSquadPrivacy. */
export interface updateSquadPrivacyPayload {
  __typename: 'updateSquadPrivacyPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<UserError>;
  squad?: Maybe<Squad>;
}

/** Autogenerated input type of updateSubscription */
export interface updateSubscriptionInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  enabled: Scalars['Boolean']['input'];
  rarities: Array<Scalars['String']['input']>;
  slug: Scalars['String']['input'];
}

/** Autogenerated return type of updateSubscription. */
export interface updateSubscriptionPayload {
  __typename: 'updateSubscriptionPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<UserError>;
  subscription?: Maybe<EmailSubscription>;
}

/** Autogenerated input type of updateTaskConfigPreferences */
export interface updateTaskConfigPreferencesInput {
  /** Whether new prepared lineups of the track are carried over to the following step, unchanged if omitted */
  carryOverPreparedLineups?: InputMaybe<Scalars['Boolean']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  taskId: Scalars['ID']['input'];
}

/** Autogenerated return type of updateTaskConfigPreferences. */
export interface updateTaskConfigPreferencesPayload {
  __typename: 'updateTaskConfigPreferencesPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<UserError>;
  task?: Maybe<CardsCountTargetTask | CardsCountTask | CompleteCollectionsCountTargetTask | CompleteCollectionsCountTask | DailyActionTask | DecisivePlayerPickerTask | DropChallengeTask | GameWeeklyTask | GuessTheScoreTask | InviteTaskAsReferrer | So5LeaderboardTask | StarPackTask | Task | TasksTrack | ThresholdPickerTask | ThresholdsDuoConnectionTask | ThresholdsStreakAdditionalLineupTask | ThresholdsStreakTask>;
}

/** Autogenerated input type of updateTaskPreparedLineupsCarryOver */
export interface updateTaskPreparedLineupsCarryOverInput {
  carryOver: Scalars['Boolean']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  taskPreparedLineupIds: Array<Scalars['ID']['input']>;
}

/** Autogenerated return type of updateTaskPreparedLineupsCarryOver. */
export interface updateTaskPreparedLineupsCarryOverPayload {
  __typename: 'updateTaskPreparedLineupsCarryOverPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<UserError>;
  taskPreparedLineups?: Maybe<Array<TaskPreparedLineup>>;
}

/** Autogenerated input type of updateUserEmail */
export interface updateUserEmailInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  otpAttempt?: InputMaybe<Scalars['String']['input']>;
  passwordHash?: InputMaybe<Scalars['String']['input']>;
  privateKeyRecovery?: InputMaybe<PrivateKeyRecoveryInput>;
  recaptchaToken?: InputMaybe<Scalars['String']['input']>;
  recaptchaTokenIos?: InputMaybe<Scalars['String']['input']>;
  recaptchaTokenV2?: InputMaybe<Scalars['String']['input']>;
}

/** Autogenerated return type of updateUserEmail. */
export interface updateUserEmailPayload {
  __typename: 'updateUserEmailPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  currentUser?: Maybe<CurrentUser>;
  errors: Array<UserError>;
}

/** Autogenerated input type of updateUserProfile */
export interface updateUserProfileInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  clubBannerId?: InputMaybe<Scalars['ID']['input']>;
  clubName?: InputMaybe<Scalars['String']['input']>;
  clubShieldId?: InputMaybe<Scalars['ID']['input']>;
  enabledWallets?: InputMaybe<Array<EnabledWallet>>;
  marketplacePreferences?: InputMaybe<Array<MarketplacePreferenceInput>>;
  nickname?: InputMaybe<Scalars['String']['input']>;
  picturePresignedKey?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
}

/** Autogenerated return type of updateUserProfile. */
export interface updateUserProfilePayload {
  __typename: 'updateUserProfilePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<UserError>;
  userProfile?: Maybe<UserProfile>;
}

/** Autogenerated input type of updateUserSettings */
export interface updateUserSettingsInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  cryptocurrency?: InputMaybe<Cryptocurrency>;
  currency?: InputMaybe<Currency>;
  discoverable?: InputMaybe<Scalars['Boolean']['input']>;
  discoverableName?: InputMaybe<Scalars['String']['input']>;
  fiatCurrency?: InputMaybe<FiatCurrency>;
  hideBalance?: InputMaybe<Scalars['Boolean']['input']>;
  lastWeb3Provider?: InputMaybe<Scalars['String']['input']>;
  lifecycle?: InputMaybe<UserLifecycleInput>;
  locale?: InputMaybe<Scalars['String']['input']>;
  maxDailyPushNotifications?: InputMaybe<Scalars['Int']['input']>;
  notificationPreference?: InputMaybe<NotificationPreferenceInput>;
  postalAddress?: InputMaybe<PostalAddressInput>;
  rewardCurrency?: InputMaybe<Currency>;
}

/** Autogenerated return type of updateUserSettings. */
export interface updateUserSettingsPayload {
  __typename: 'updateUserSettingsPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  currentUser?: Maybe<CurrentUser>;
  errors: Array<UserError>;
  userSettings?: Maybe<UserSettings>;
}

/** Autogenerated input type of upsertStepLineup */
export interface upsertStepLineupInput {
  appearances: Array<AppearanceInput>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  lineupId?: InputMaybe<Scalars['ID']['input']>;
  stepId: Scalars['String']['input'];
}

/** Autogenerated return type of upsertStepLineup. */
export interface upsertStepLineupPayload {
  __typename: 'upsertStepLineupPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  currentUser?: Maybe<CurrentUser>;
  errors: Array<UserError>;
  lineup?: Maybe<GuessTheScoreTaskLineup | So5Lineup | TaskLineup | ThresholdPickerTaskLineup>;
  step?: Maybe<CareerProStep | CareerStep | SquadStep>;
}

/** Autogenerated input type of upsertTaskAppearances */
export interface upsertTaskAppearancesInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  taskAppearances: Array<TaskAppearanceInput>;
  taskId: Scalars['ID']['input'];
}

/** Autogenerated return type of upsertTaskAppearances. */
export interface upsertTaskAppearancesPayload {
  __typename: 'upsertTaskAppearancesPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  currentUser?: Maybe<CurrentUser>;
  errors: Array<UserError>;
  task?: Maybe<CardsCountTargetTask | CardsCountTask | CompleteCollectionsCountTargetTask | CompleteCollectionsCountTask | DailyActionTask | DecisivePlayerPickerTask | DropChallengeTask | GameWeeklyTask | GuessTheScoreTask | InviteTaskAsReferrer | So5LeaderboardTask | StarPackTask | Task | TasksTrack | ThresholdPickerTask | ThresholdsDuoConnectionTask | ThresholdsStreakAdditionalLineupTask | ThresholdsStreakTask>;
}

/** Autogenerated input type of upsertTaskLineup */
export interface upsertTaskLineupInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  targetScore?: InputMaybe<Scalars['Int']['input']>;
  taskAppearances: Array<TaskAppearanceInput>;
  taskId: Scalars['ID']['input'];
  taskLineupId?: InputMaybe<Scalars['ID']['input']>;
}

/** Autogenerated return type of upsertTaskLineup. */
export interface upsertTaskLineupPayload {
  __typename: 'upsertTaskLineupPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  currentUser?: Maybe<CurrentUser>;
  errors: Array<UserError>;
  task?: Maybe<CardsCountTargetTask | CardsCountTask | CompleteCollectionsCountTargetTask | CompleteCollectionsCountTask | DailyActionTask | DecisivePlayerPickerTask | DropChallengeTask | GameWeeklyTask | GuessTheScoreTask | InviteTaskAsReferrer | So5LeaderboardTask | StarPackTask | Task | TasksTrack | ThresholdPickerTask | ThresholdsDuoConnectionTask | ThresholdsStreakAdditionalLineupTask | ThresholdsStreakTask>;
  taskLineup?: Maybe<GuessTheScoreTaskLineup | TaskLineup | ThresholdPickerTaskLineup>;
}

/** Autogenerated input type of upsertTaskPreparedLineup */
export interface upsertTaskPreparedLineupInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  taskAppearances: Array<TaskAppearanceInput>;
  taskId: Scalars['ID']['input'];
  taskPreparedLineupId?: InputMaybe<Scalars['ID']['input']>;
}

/** Autogenerated return type of upsertTaskPreparedLineup. */
export interface upsertTaskPreparedLineupPayload {
  __typename: 'upsertTaskPreparedLineupPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  currentUser?: Maybe<CurrentUser>;
  errors: Array<UserError>;
  task?: Maybe<CardsCountTargetTask | CardsCountTask | CompleteCollectionsCountTargetTask | CompleteCollectionsCountTask | DailyActionTask | DecisivePlayerPickerTask | DropChallengeTask | GameWeeklyTask | GuessTheScoreTask | InviteTaskAsReferrer | So5LeaderboardTask | StarPackTask | Task | TasksTrack | ThresholdPickerTask | ThresholdsDuoConnectionTask | ThresholdsStreakAdditionalLineupTask | ThresholdsStreakTask>;
  taskPreparedLineup?: Maybe<TaskPreparedLineup>;
}

/** Autogenerated input type of upsertWatchlist */
export interface upsertWatchlistInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  public?: InputMaybe<Scalars['Boolean']['input']>;
  sport: Sport;
  title?: InputMaybe<Scalars['String']['input']>;
  watchlistId?: InputMaybe<Scalars['ID']['input']>;
}

/** Autogenerated return type of upsertWatchlist. */
export interface upsertWatchlistPayload {
  __typename: 'upsertWatchlistPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  currentUser?: Maybe<CurrentUser>;
  errors: Array<UserError>;
  watchlist?: Maybe<Watchlist>;
}

/** Autogenerated input type of validateApplePayMerchantSession */
export interface validateApplePayMerchantSessionInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  merchantValidationUrl: Scalars['String']['input'];
}

/** Autogenerated return type of validateApplePayMerchantSession. */
export interface validateApplePayMerchantSessionPayload {
  __typename: 'validateApplePayMerchantSessionPayload';
  applePaySessionData?: Maybe<Scalars['String']['output']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<UserError>;
}

/** Autogenerated input type of validateFiatWallet */
export interface validateFiatWalletInput {
  backPagePresignedKey?: InputMaybe<Scalars['String']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  frontPagePresignedKey: Scalars['String']['input'];
}

/** Autogenerated return type of validateFiatWallet. */
export interface validateFiatWalletPayload {
  __typename: 'validateFiatWalletPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  currentUser?: Maybe<CurrentUser>;
  errors: Array<UserError>;
}

/** Autogenerated input type of verifyInGameCurrencyPackMobilePurchase */
export interface verifyInGameCurrencyPackMobilePurchaseInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  packageName?: InputMaybe<Scalars['String']['input']>;
  paymentMethod: TokenPaymentMethod;
  paymentToken: Scalars['String']['input'];
  productId?: InputMaybe<Scalars['String']['input']>;
}

/** Autogenerated return type of verifyInGameCurrencyPackMobilePurchase. */
export interface verifyInGameCurrencyPackMobilePurchasePayload {
  __typename: 'verifyInGameCurrencyPackMobilePurchasePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  currentUser?: Maybe<CurrentUser>;
  errors: Array<UserError>;
}

/** Autogenerated input type of verifyMobilePurchase */
export interface verifyMobilePurchaseInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  packageName?: InputMaybe<Scalars['String']['input']>;
  paymentMethod: TokenPaymentMethod;
  paymentToken: Scalars['String']['input'];
  productId?: InputMaybe<Scalars['String']['input']>;
}

/** Autogenerated return type of verifyMobilePurchase. */
export interface verifyMobilePurchasePayload {
  __typename: 'verifyMobilePurchasePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deal?: Maybe<TokenPrimaryOffer>;
  errors: Array<UserError>;
}

/** Autogenerated input type of verifyPhoneNumber */
export interface verifyPhoneNumberInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  discoverable?: InputMaybe<Scalars['Boolean']['input']>;
  phoneNumber: Scalars['String']['input'];
}

/** Autogenerated return type of verifyPhoneNumber. */
export interface verifyPhoneNumberPayload {
  __typename: 'verifyPhoneNumberPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  currentUser?: Maybe<CurrentUser>;
  errors: Array<UserError>;
}

/** Autogenerated input type of visitCampaignPage */
export interface visitCampaignPageInput {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  url: Scalars['String']['input'];
}

/** Autogenerated return type of visitCampaignPage. */
export interface visitCampaignPagePayload {
  __typename: 'visitCampaignPagePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  currentUser?: Maybe<CurrentUser>;
  errors: Array<UserError>;
}

export type TYPES = {
	AcceptTermsMutationPayload: AcceptTermsMutationPayload;
	AcceptorSettlementInfoInput: AcceptorSettlementInfoInput;
	Account: Account;
	AccountOwner: Contract | User;
	Accountable: CommonAccount | EthereumAccount | FiatWalletAccount | LoomAccount | SolanaAccount | StarkwareAccount;
	ActivityFeedInterface: CardPackActivityFeed | LineupActivityFeed | OwnerActivityFeed;
	ActivityFeedInterfaceConnection: ActivityFeedInterfaceConnection;
	ActivityFeedInterfaceEdge: ActivityFeedInterfaceEdge;
	ActivityReaction: ActivityReaction;
	ActivityReactionConnection: ActivityReactionConnection;
	ActivityReactionCount: ActivityReactionCount;
	ActivityReactionEdge: ActivityReactionEdge;
	AddCardInput: AddCardInput;
	AdditionalKycRequestRequestType: AdditionalKycRequestRequestType;
	AdditionalKycRequestState: AdditionalKycRequestState;
	AdditionalPaymentInfoInput: AdditionalPaymentInfoInput;
	Age: Age;
	AirdropPromotionalEvent: AirdropPromotionalEvent;
	AlternativeRewardConfig: AlternativeRewardConfig;
	AmountInput: AmountInput;
	Announcement: Announcement;
	AnnouncementConnection: AnnouncementConnection;
	AnnouncementEdge: AnnouncementEdge;
	AnnouncementNotification: AnnouncementNotification;
	AnonymousUser: AnonymousUser;
	AnyAverageStatWithValueInterface: BaseballAverageStatWithValueType | BasketballAverageStatWithValueType | FootballAverageStatWithValueType;
	AnyCardInterface: BaseballCard | Card | NBACard;
	AnyCardInterfaceConnection: AnyCardInterfaceConnection;
	AnyCardInterfaceEdge: AnyCardInterfaceEdge;
	AnyCardReward: AnyCardReward;
	AnyCardSubscription: AnyCardSubscription;
	AnyCardWithPlayerGameScore: AnyCardWithPlayerGameScore;
	AnyCardWithPlayerGameScoreConnection: AnyCardWithPlayerGameScoreConnection;
	AnyCardWithPlayerGameScoreEdge: AnyCardWithPlayerGameScoreEdge;
	AnyContestantInterface: BaseballContestantType | BasketballContestantType | FootballContestantType;
	AnyConversionCreditReward: AnyConversionCreditReward;
	AnyGameInterface: Game | GameOfBaseball | GameOfBasketball;
	AnyGameInterfaceConnection: AnyGameInterfaceConnection;
	AnyGameInterfaceEdge: AnyGameInterfaceEdge;
	AnyPlayer: BaseballPlayer | NBAPlayer | Player;
	AnyPlayerGameStatsInterface: PlayerGameStats | PlayerGameStatsBaseball | PlayerGameStatsBasketball;
	AnyPlayerInterface: BaseballPlayer | NBAPlayer | Player;
	AnyPlayerInterfaceConnection: AnyPlayerInterfaceConnection;
	AnyPlayerInterfaceEdge: AnyPlayerInterfaceEdge;
	AnyPlayerNewsUpdate: AnyPlayerNewsUpdate;
	AnyRewardConfigInterface: CardPacksRewardConfig | CardRewardConfig | CardShardRewardConfig | CoinRewardConfig | ConversionCreditRewardConfig | DeliverableItemRewardConfig | ExperienceRewardConfig | InGameCurrencyRewardConfig | MonetaryRewardConfig | ProbabilisticBundleRewardConfig | ShopItemRewardConfig;
	AnyRewardInterface: AnyCardReward | AnyConversionCreditReward | CardPackReward | CardShardsReward | CoinReward | DeliverableItemReward | ExperienceReward | InGameCurrencyReward | MonetaryReward | ProbabilisticBundleReward | ShopItemReward;
	AnyRewardInterfaceConnection: AnyRewardInterfaceConnection;
	AnyRewardInterfaceEdge: AnyRewardInterfaceEdge;
	AnyUserSportProfile: BaseballUserSportProfile | FootballUserSportProfile | NBAUserSportProfile;
	ApiKey: ApiKey;
	AppearanceBoostShopItem: AppearanceBoostShopItem;
	AppearanceInput: AppearanceInput;
	AppearanceInterface: DecisivePlayerPickerTaskAppearance | MissedAppearance | So5Appearance | TaskAppearance | ThresholdPickerTaskAppearance;
	AppearanceRule: AppearanceRule;
	ApplePayPaymentDataInput: ApplePayPaymentDataInput;
	ApplePurchaseToken: ApplePurchaseToken;
	AssetVariant: AssetVariant;
	AuctionNotification: AuctionNotification;
	AuctionReminder: AuctionReminder;
	AuctionReminderConnection: AuctionReminderConnection;
	AuctionReminderEdge: AuctionReminderEdge;
	AuthorizationApprovalInput: AuthorizationApprovalInput;
	AuthorizationOperation: TokenAuction | TokenBid | TokenOffer | TokenPrimaryOffer;
	AuthorizationRequest: AuthorizationRequest;
	AuthorizationRequestConnection: AuthorizationRequestConnection;
	AuthorizationRequestEdge: AuthorizationRequestEdge;
	AuthorizationStatus: AuthorizationStatus;
	AutoClaimNotification: AutoClaimNotification;
	AvailableBalances: AvailableBalances;
	AverageLastScore: AverageLastScore;
	AverageLastScoreInterface: AverageLastScore | BaseAverageLastScore;
	AverageLastScoreLocation: AverageLastScoreLocation;
	AverageLastScoreSpan: AverageLastScoreSpan;
	AverageLimit: AverageLimit;
	AveragePlayerScore: AveragePlayerScore;
	AverageScoreOpenBoundaries: AverageScoreOpenBoundaries;
	AverageScoreTeamMode: AverageScoreTeamMode;
	AverageScoresRule: AverageScoresRule;
	AverageStat: AverageStat;
	BackupPrivateKeyRecoveryInput: BackupPrivateKeyRecoveryInput;
	BankAccount: CaBankAccount | GbBankAccount | IbanBankAccount | OtherBankAccount | UsBankAccount;
	BankAccountConnection: BankAccountConnection;
	BankAccountEdge: BankAccountEdge;
	BankAccountInterface: CaBankAccount | GbBankAccount | IbanBankAccount | OtherBankAccount | UsBankAccount;
	BankAccountOwnerAddressInput: BankAccountOwnerAddressInput;
	BankAccountType: BankAccountType;
	BankWithdrawal: BankWithdrawal;
	BaseAverageLastScore: BaseAverageLastScore;
	BaseWithdrawalAuthorizationRequest: BaseWithdrawalAuthorizationRequest;
	BaseballAverageStatType: BaseballAverageStatType;
	BaseballAverageStatWithValueType: BaseballAverageStatWithValueType;
	BaseballCard: BaseballCard;
	BaseballContestantType: BaseballContestantType;
	BaseballDivision: BaseballDivision;
	BaseballPlayer: BaseballPlayer;
	BaseballPlayerGameScore: BaseballPlayerGameScore;
	BaseballPosition: BaseballPosition;
	BaseballTeamGameStats: BaseballTeamGameStats;
	BaseballUserSportProfile: BaseballUserSportProfile;
	BasketballAverageStatType: BasketballAverageStatType;
	BasketballAverageStatWithValueType: BasketballAverageStatWithValueType;
	BasketballContestantType: BasketballContestantType;
	BasketballDivision: BasketballDivision;
	BasketballPlayerGameScore: BasketballPlayerGameScore;
	BasketballTeamGameStats: BasketballTeamGameStats;
	BenchFilterInput: BenchFilterInput;
	BenchPlayerScore: BenchPlayerScore;
	BenchSort: BenchSort;
	BenchSortType: BenchSortType;
	BestScoreManagerProfileStat: BestScoreManagerProfileStat;
	BidSource: BidSource;
	BidToEarnPromotionalEvent: BidToEarnPromotionalEvent;
	BidToEarnReward: BidToEarnReward;
	BidToEarnRewardConfig: BidToEarnRewardConfig;
	BillingAddressInput: BillingAddressInput;
	Blockchain: Blockchain;
	BlockchainUser: AnonymousUser | User;
	BlockchainUserInterface: AnonymousUser;
	Blueprint: Blueprint;
	BlueprintRevealStatus: BlueprintRevealStatus;
	Board: CareerBoard | SquadBoard;
	BoardBookmark: BoardBookmark;
	BoardMode: BoardMode;
	BoardWithSpecialEditionBonus: BoardWithSpecialEditionBonus;
	BonusOrdinalRatingEnum: BonusOrdinalRatingEnum;
	Bookmark: BoardBookmark | So5LeaderboardBookmark;
	Boolean: Scalars['Boolean']['output'];
	BoostLevel: BoostLevel;
	BoostedPackOdds: BoostedPackOdds;
	BrowserInfoInput: BrowserInfoInput;
	BudgetType: BudgetType;
	BundledPurchasableItem: BundledPurchasableItem;
	CaBankAccount: CaBankAccount;
	Card: Card;
	CardBoost: CardBoost;
	CardBoostConfig: CardBoostConfig;
	CardCollection: CardCollection;
	CardCollectionBonusThreshold: CardCollectionBonusThreshold;
	CardCollectionCard: CardCollectionCard;
	CardCollectionCardScoreBreakdown: CardCollectionCardScoreBreakdown;
	CardCollectionConnection: CardCollectionConnection;
	CardCollectionEdge: CardCollectionEdge;
	CardCollectionNotification: CardCollectionNotification;
	CardCollectionRequirement: CardCollectionRequirement;
	CardCollectionScoreIncrease: CardCollectionScoreIncrease;
	CardCollectionScoringMatrix: CardCollectionScoringMatrix;
	CardCollectionSlot: CardCollectionSlot;
	CardCollectionSortingOption: CardCollectionSortingOption;
	CardCollectionWithProgress: CardCollectionWithProgress;
	CardCollectionWithProgressConnection: CardCollectionWithProgressConnection;
	CardCollectionWithProgressEdge: CardCollectionWithProgressEdge;
	CardConnection: CardConnection;
	CardCount: CardCount;
	CardCoverageStatus: CardCoverageStatus;
	CardDesign: CardDesign;
	CardEdge: CardEdge;
	CardEditionCount: CardEditionCount;
	CardEditionsCount: CardEditionsCount;
	CardEligibilityRulesInterface: EligibilityRules | WheelTicketEligibilityRules;
	CardGameInterface: Card;
	CardLayout: CardLayout;
	CardNotification: CardNotification;
	CardPack: CardPack;
	CardPackActivityFeed: CardPackActivityFeed;
	CardPackCategory: CardPackCategory;
	CardPackCurrency: CardPackCurrency;
	CardPackGroup: CardPackGroup;
	CardPackQuality: CardPackQuality;
	CardPackReward: CardPackReward;
	CardPackSection: CardPackSection;
	CardPackSlot: CardPackSlot;
	CardPackSlotPlayingStatusOdd: CardPackSlotPlayingStatusOdd;
	CardPackSlotRankOdd: CardPackSlotRankOdd;
	CardPacksRewardConfig: CardPacksRewardConfig;
	CardPull: CardPull;
	CardPullCard: CardPullCard;
	CardPullConfig: CardPullConfig;
	CardPullSource: CardPullSource;
	CardQuality: CardQuality;
	CardRewardConfig: CardRewardConfig;
	CardSample: CardSample;
	CardSeasonSupply: CardSeasonSupply;
	CardSet: CardSet;
	CardSetBranding: CardSetBranding;
	CardSetBrandingAssetDerivative: CardSetBrandingAssetDerivative;
	CardSetBrandingAssetSlot: CardSetBrandingAssetSlot;
	CardSetBrandingColorTheme: CardSetBrandingColorTheme;
	CardSetBrandingColors: CardSetBrandingColors;
	CardSetConnection: CardSetConnection;
	CardSetEdge: CardSetEdge;
	CardSetRoot: CardSetRoot;
	CardShardRewardConfig: CardShardRewardConfig;
	CardShardThresholdsPromotionalEvent: CardShardThresholdsPromotionalEvent;
	CardShardsChest: CardShardsChest;
	CardShardsChestThreshold: CardShardsChestThreshold;
	CardShardsChestThresholdDraw: CardShardsChestThresholdDraw;
	CardShardsChestThresholdDrawsProbability: CardShardsChestThresholdDrawsProbability;
	CardShardsChestThresholdProbability: CardShardsChestThresholdProbability;
	CardShardsHistoryTransactionFilter: CardShardsHistoryTransactionFilter;
	CardShardsPurchasableItem: CardShardsPurchasableItem;
	CardShardsReward: CardShardsReward;
	CardSort: CardSort;
	CardSource: CardSource;
	CardStats: CardStats;
	CardUsageInterface: ListedOnMarket | UsedInSo5Lineups | UsedInTaskLineups | UsedInTaskPreparedLineups | UsedInTasks;
	CardWasUpdatedEvent: CardWasUpdatedEvent;
	CardXPGradeThreshold: CardXPGradeThreshold;
	CardsCountAsFirstOwnerRule: CardsCountAsFirstOwnerRule;
	CardsCountTargetTask: CardsCountTargetTask;
	CardsCountTask: CardsCountTask;
	CareerBoard: CareerBoard;
	CareerProStep: CareerProStep;
	CareerStep: CareerStep;
	Cart: Cart;
	CartItem: CartItem;
	CartItemState: CartItemState;
	CartPurchaseRewardPromotionalEvent: CartPurchaseRewardPromotionalEvent;
	CheckoutCreditCardAuthorizationRequest: CheckoutCreditCardAuthorizationRequest;
	Club: Club;
	ClubConnection: ClubConnection;
	ClubEdge: ClubEdge;
	ClubShopItem: AppearanceBoostShopItem | CommonCardSwapShopItem | DeliverableWithCustomVariantShopItem | DeliverableWithNoVariantShopItem | ExtraSwapShopItem | JerseyShopItem | LevelUpShopItem | RaffleShopItem | ShopItem | SkinShopItem;
	ClubShopItemConnection: ClubShopItemConnection;
	ClubShopItemEdge: ClubShopItemEdge;
	CoinReward: CoinReward;
	CoinRewardConfig: CoinRewardConfig;
	Collection: Collection;
	CollectionCompletionManagerProfileStat: CollectionCompletionManagerProfileStat;
	CollectionTaskThreshold: CollectionTaskThreshold;
	ColorVariant: ColorVariant;
	CommonAccount: CommonAccount;
	CommonCardSwapShopItem: CommonCardSwapShopItem;
	CommonPlayer: CommonPlayer;
	CommonPlayerConnection: CommonPlayerConnection;
	CommonPlayerEdge: CommonPlayerEdge;
	CommonPlayerOdds: CommonPlayerOdds;
	Competition: Competition;
	CompetitionCardCollections: CompetitionCardCollections;
	CompetitionCardCollectionsStats: CompetitionCardCollectionsStats;
	CompetitionCount: CompetitionCount;
	CompetitionFormat: CompetitionFormat;
	CompetitionGames: CompetitionGames;
	CompetitionType: CompetitionType;
	CompletablePromotionalEventInterface: DepositPromotionalEvent;
	CompleteCollectionsCountTargetTask: CompleteCollectionsCountTargetTask;
	CompleteCollectionsCountTask: CompleteCollectionsCountTask;
	ComposeTeamBenchCard: ComposeTeamBenchCard;
	ComposeTeamBenchCommonPlayer: ComposeTeamBenchCommonPlayer;
	ComposeTeamBenchObjectInterface: ComposeTeamBenchCard | ComposeTeamBenchCommonPlayer | DecisivePlayerPickerTaskAppearance | MissedAppearance | So5Appearance | TaskAppearance | ThresholdPickerTaskAppearance;
	ComposeTeamBenchObjectInterfaceConnection: ComposeTeamBenchObjectInterfaceConnection;
	ComposeTeamBenchObjectInterfaceEdge: ComposeTeamBenchObjectInterfaceEdge;
	ComposeTeamLineupPreview: ComposeTeamLineupPreview;
	Config: Config;
	ConfirmDeviceMutationPayload: ConfirmDeviceMutationPayload;
	ConfirmEmailMutationPayload: ConfirmEmailMutationPayload;
	ConnectedOAuth: ConnectedOAuth;
	ConsumeEphemeralTokenMutationPayload: ConsumeEphemeralTokenMutationPayload;
	Contestant: Contestant;
	Contract: Contract;
	ConversionCredit: ConversionCredit;
	ConversionCreditCampaign: ConversionCreditCampaign;
	ConversionCreditCampaignStatus: ConversionCreditCampaignStatus;
	ConversionCreditConnection: ConversionCreditConnection;
	ConversionCreditEdge: ConversionCreditEdge;
	ConversionCreditNotification: ConversionCreditNotification;
	ConversionCreditPurchase: TokenAuction | TokenPrimaryOffer;
	ConversionCreditRewardConfig: ConversionCreditRewardConfig;
	ConversionCreditStatus: ConversionCreditStatus;
	CountByRarity: CountByRarity;
	Country: Country;
	Counts: Counts;
	CraftClueBase: CraftClueBase;
	CraftGameplayTier: CraftGameplayTier;
	CreateMutationPayload: CreateMutationPayload;
	CreateOrUpdateSo5LineupMutationPayload: CreateOrUpdateSo5LineupMutationPayload;
	CreditCard: CreditCard;
	CreditCardAuthorizationRequest: MangopayCreditCardAuthorizationRequest | StripeCreditCardAuthorizationRequest;
	CreditCardBrand: CreditCardBrand;
	CreditCardType: CreditCardType;
	CryptoAmountInput: CryptoAmountInput;
	Cryptocurrency: Cryptocurrency;
	CryptocurrencyAmount: Scalars['CryptocurrencyAmount']['output'];
	Currency: Currency;
	CurrentUser: CurrentUser;
	CurrentUserTaskWasUpdatedPayload: CurrentUserTaskWasUpdatedPayload;
	CustomRewardExperience: CustomRewardExperience;
	CustomSortingOption: CustomSortingOption;
	DailyActionTask: DailyActionTask;
	DataPartner: DataPartner;
	DateRangeInput: DateRangeInput;
	DateRangeSpecific: DateRangeSpecific;
	DealInterface: TokenAuction | TokenOffer | TokenPrimaryOffer;
	DealStatus: DealStatus;
	DecisiveActionNotification: DecisiveActionNotification;
	DecisiveEventInterface: FootballGoalEvent | FootballSanctionCardEvent | SubstitutionEvent;
	DecisivePlayerPickerMode: DecisivePlayerPickerMode;
	DecisivePlayerPickerTask: DecisivePlayerPickerTask;
	DecisivePlayerPickerTaskAppearance: DecisivePlayerPickerTaskAppearance;
	DecisivePlayerPickerTaskAppearanceStatus: DecisivePlayerPickerTaskAppearanceStatus;
	DecisivePurchaseNotification: DecisivePurchaseNotification;
	Deck: Deck;
	DeckConnection: DeckConnection;
	DeckEdge: DeckEdge;
	DeliverableItemDerivative: DeliverableItemDerivative;
	DeliverableItemInterface: ExperienceDeliverableItem | JerseyDeliverableItem | TicketsDeliverableItem | WearableDeliverableItem;
	DeliverableItemOrder: DeliverableItemOrder;
	DeliverableItemReward: DeliverableItemReward;
	DeliverableItemRewardConfig: DeliverableItemRewardConfig;
	DeliverableItemStatus: DeliverableItemStatus;
	DeliverableItemThreeDimensionalAssetFormat: DeliverableItemThreeDimensionalAssetFormat;
	DeliverableItemVariantsStocks: DeliverableItemVariantsStocks;
	DeliverableItemsRewardsOverview: DeliverableItemsRewardsOverview;
	DeliverableWithCustomVariantShopItem: DeliverableWithCustomVariantShopItem;
	DeliverableWithNoVariantShopItem: DeliverableWithNoVariantShopItem;
	Delivery: Delivery;
	DepositOperationStatus: DepositOperationStatus;
	DepositPromotionalEvent: DepositPromotionalEvent;
	DepositProvider: DepositProvider;
	DepositStatus: DepositStatus;
	DeviceVerificationMode: DeviceVerificationMode;
	DeviceWasUpdatedEvent: DeviceWasUpdatedEvent;
	DivisionChange: DivisionChange;
	DivisionChangeConfiguration: DivisionChangeConfiguration;
	DivisionInterface: BaseballDivision | BasketballDivision;
	DocumentInput: DocumentInput;
	DocumentType: DocumentType;
	DropCardInput: DropCardInput;
	DropChallengeTask: DropChallengeTask;
	EditionVariant: EditionVariant;
	Eip7702AuthorizationInput: Eip7702AuthorizationInput;
	Eip7702Revocation: Eip7702Revocation;
	Eip7702RevocationStatus: Eip7702RevocationStatus;
	EligibilityRules: EligibilityRules;
	EligibleCardsSort: EligibleCardsSort;
	EligibleCollectionRule: EligibleCollectionRule;
	EmailSubscription: EmailSubscription;
	EmailSubscriptionConnection: EmailSubscriptionConnection;
	EmailSubscriptionEdge: EmailSubscriptionEdge;
	EmailSubscriptionPreferences: EmailSubscriptionPreferences;
	EnabledWallet: EnabledWallet;
	EngineConfiguration: EngineConfiguration;
	EnglishAuctionSource: EnglishAuctionSource;
	EscapeHatchState: EscapeHatchState;
	EthBankWithdrawalIntent: EthBankWithdrawalIntent;
	EthDeposit: EthDeposit;
	EthMigration: EthMigration;
	EthereumAccount: EthereumAccount;
	EthereumAddress: Scalars['EthereumAddress']['output'];
	EthereumBankConditionalTransferApprovalInput: EthereumBankConditionalTransferApprovalInput;
	EthereumBankConditionalTransferAuthorizationRequest: EthereumBankConditionalTransferAuthorizationRequest;
	EthereumBankTransferApprovalInput: EthereumBankTransferApprovalInput;
	EthereumBankTransferAuthorizationRequest: EthereumBankTransferAuthorizationRequest;
	EthereumTransaction: EthereumTransaction;
	Event: Event;
	ExchangeRate: ExchangeRate;
	ExperienceDeliverableItem: ExperienceDeliverableItem;
	ExperienceReward: ExperienceReward;
	ExperienceRewardConfig: ExperienceRewardConfig;
	ExternalDepositNotification: ExternalDepositNotification;
	ExternalDepositNotificationStatus: ExternalDepositNotificationStatus;
	ExternalProvider: ExternalProvider;
	ExternalProviderIdInput: ExternalProviderIdInput;
	ExtraSwapShopItem: ExtraSwapShopItem;
	FaceLandmark: FaceLandmark;
	FastWithdrawal: FastWithdrawal;
	FastWithdrawalWithRates: FastWithdrawalWithRates;
	FeaturedCardPack: FeaturedCardPack;
	FeaturedLeagues: FeaturedLeagues;
	FeaturedMarketSection: FeaturedMarketSection;
	FeaturedMarketSectionItem: FeaturedMarketSectionItem;
	FeaturedMarketSectionValueProp: FeaturedMarketSectionValueProp;
	FeaturedSo5LeaderboardContenders: FeaturedSo5LeaderboardContenders;
	FeaturedSo5LeaderboardGroups: FeaturedSo5LeaderboardGroups;
	Fee: Fee;
	Fiat: Fiat;
	FiatCurrency: FiatCurrency;
	FiatWalletAccount: FiatWalletAccount;
	FiatWalletAccountState: FiatWalletAccountState;
	FiatWalletKycRefusedReason: FiatWalletKycRefusedReason;
	FiatWalletKycState: FiatWalletKycState;
	FixturePlayer: FixturePlayer;
	FixturePlayerConnection: FixturePlayerConnection;
	FixturePlayerEdge: FixturePlayerEdge;
	FlashSalePicks: FlashSalePicks;
	Float: Scalars['Float']['output'];
	FloatRangeInput: FloatRangeInput;
	FootballAverageStatWithValueType: FootballAverageStatWithValueType;
	FootballContestantType: FootballContestantType;
	FootballConversionCredit: FootballConversionCredit;
	FootballGoalEvent: FootballGoalEvent;
	FootballGoalType: FootballGoalType;
	FootballPosition: FootballPosition;
	FootballRewardShopItem: FootballRewardShopItem;
	FootballRoot: FootballRoot;
	FootballSanctionCard: FootballSanctionCard;
	FootballSanctionCardEvent: FootballSanctionCardEvent;
	FootballSo5NoCardRouteRoot: FootballSo5NoCardRouteRoot;
	FootballTeamGameStats: FootballTeamGameStats;
	FootballUserSportProfile: FootballUserSportProfile;
	ForYouRoot: ForYouRoot;
	FullWithdrawalRequest: FullWithdrawalRequest;
	GalleryCards: GalleryCards;
	Game: Game;
	GameConnection: GameConnection;
	GameCoverageStatus: GameCoverageStatus;
	GameDay: GameDay;
	GameDayConnection: GameDayConnection;
	GameDayEdge: GameDayEdge;
	GameEdge: GameEdge;
	GameMode: GameMode;
	GameOfBaseball: GameOfBaseball;
	GameOfBasketball: GameOfBasketball;
	GameStatus: GameStatus;
	GameWeeklyTask: GameWeeklyTask;
	GameWeeklyTaskInterface: GameWeeklyTask;
	GameWithCardsPreview: GameWithCardsPreview;
	GameWithCardsPreviewConnection: GameWithCardsPreviewConnection;
	GameWithCardsPreviewEdge: GameWithCardsPreviewEdge;
	GameWithCardsPreviewSortType: GameWithCardsPreviewSortType;
	GameWithPlayerGameScoresPreview: GameWithPlayerGameScoresPreview;
	GameWithPlayerGameScoresPreviewConnection: GameWithPlayerGameScoresPreviewConnection;
	GameWithPlayerGameScoresPreviewEdge: GameWithPlayerGameScoresPreviewEdge;
	GameplayTier: GameplayTier;
	GameplayTierOdds: GameplayTierOdds;
	GameplayTierRating: GameplayTierRating;
	GbBankAccount: GbBankAccount;
	GemsShop: GemsShop;
	GenericSpotlight: GenericSpotlight;
	GuessTheScoreTask: GuessTheScoreTask;
	GuessTheScoreTaskLineup: GuessTheScoreTaskLineup;
	HeroValueProp: HeroValueProp;
	HighScarcity: HighScarcity;
	HighScarcityStatus: HighScarcityStatus;
	HighScarcityStatuses: HighScarcityStatuses;
	HighlightedStat: HighlightedStat;
	HighlightedStatType: HighlightedStatType;
	HistoryTransactionInterface: BidSource | CardPullSource | CardSource | EnglishAuctionSource | InGameCurrencySource | PackSource | PrimaryOfferSource | PrintablePlayerSource | ProbabilisticBundleSource | RejectedCraftSource | So5LeaderboardEntryItemSource | So5RewardSource | TaskSource | UnknownSource;
	HistoryTransactionInterfaceConnection: HistoryTransactionInterfaceConnection;
	HistoryTransactionInterfaceEdge: HistoryTransactionInterfaceEdge;
	ID: Scalars['ID']['output'];
	ISO8601Date: Scalars['ISO8601Date']['output'];
	ISO8601DateTime: Scalars['ISO8601DateTime']['output'];
	IbanBankAccount: IbanBankAccount;
	ImportedSo5Appearance: ImportedSo5Appearance;
	InGameCurrency: InGameCurrency;
	InGameCurrencyBalance: InGameCurrencyBalance;
	InGameCurrencyNotification: InGameCurrencyNotification;
	InGameCurrencyPack: InGameCurrencyPack;
	InGameCurrencyPurchasableItem: InGameCurrencyPurchasableItem;
	InGameCurrencyReward: InGameCurrencyReward;
	InGameCurrencyRewardConfig: InGameCurrencyRewardConfig;
	InGameCurrencySource: InGameCurrencySource;
	InGameCurrencyTransaction: InGameCurrencyTransaction;
	InGameCurrencyTransactionConnection: InGameCurrencyTransactionConnection;
	InGameCurrencyTransactionEdge: InGameCurrencyTransactionEdge;
	IncompleteCardCollection: IncompleteCardCollection;
	IncompleteCardCollectionConnection: IncompleteCardCollectionConnection;
	IncompleteCardCollectionEdge: IncompleteCardCollectionEdge;
	Injury: Injury;
	Inning: Inning;
	InningHalf: InningHalf;
	InstantBuyCampaign: InstantBuyCampaign;
	InstantBuyCampaignConnection: InstantBuyCampaignConnection;
	InstantBuyCampaignEdge: InstantBuyCampaignEdge;
	Int: Scalars['Int']['output'];
	IntegerBySportType: IntegerBySportType;
	InternalTransferState: InternalTransferState;
	InviteTaskAsReferrer: InviteTaskAsReferrer;
	JSON: Scalars['JSON']['output'];
	JerseyDeliverableItem: JerseyDeliverableItem;
	JerseyShopItem: JerseyShopItem;
	JonumBlockingReason: JonumBlockingReason;
	JonumBlockingStatus: JonumBlockingStatus;
	JonumMissingUserInfo: JonumMissingUserInfo;
	JonumRestrictions: JonumRestrictions;
	JonumVerificationNotification: JonumVerificationNotification;
	JonumVerificationStatus: JonumVerificationStatus;
	Json: Scalars['Json']['output'];
	JwtToken: JwtToken;
	KlarnaAdditionalInfoInput: KlarnaAdditionalInfoInput;
	KlarnaPayinConfig: KlarnaPayinConfig;
	KycDocumentRequirement: KycDocumentRequirement;
	KycDocumentType: KycDocumentType;
	KycRequestNotification: KycRequestNotification;
	KycRequestNotificationStatus: KycRequestNotificationStatus;
	KycRequestState: KycRequestState;
	LadderContribution: LadderContribution;
	LadderLeaderboard: LadderLeaderboard;
	LadderLeaderboardConnection: LadderLeaderboardConnection;
	LadderLeaderboardEdge: LadderLeaderboardEdge;
	LadderRanking: LadderRanking;
	LadderRankingConnection: LadderRankingConnection;
	LadderRankingEdge: LadderRankingEdge;
	LadderRewardBracket: LadderRewardBracket;
	LeaderboardRewardsConfig: LeaderboardRewardsConfig;
	LeaguesSortInput: LeaguesSortInput;
	LeaguesSorting: LeaguesSorting;
	LegacyPacks: LegacyPacks;
	LevelUpCardInput: LevelUpCardInput;
	LevelUpShopItem: LevelUpShopItem;
	LeveledUpCard: LeveledUpCard;
	LineupActivityFeed: LineupActivityFeed;
	LineupInterface: GuessTheScoreTaskLineup | So5Lineup | TaskLineup | ThresholdPickerTaskLineup;
	LineupInterfaceConnection: LineupInterfaceConnection;
	LineupInterfaceEdge: LineupInterfaceEdge;
	ListedOnMarket: ListedOnMarket;
	Loan: Loan;
	LoanNotification: LoanNotification;
	LoanStatus: LoanStatus;
	LoanableConfigRoot: LoanableConfigRoot;
	LoanableRoster: LoanableRoster;
	LoanedToken: LoanedToken;
	LobbySection: LobbySection;
	LobbySectionType: LobbySectionType;
	Location: Location;
	LockTypeEnum: LockTypeEnum;
	LoomAccount: LoomAccount;
	ManagerProfileStat: BestScoreManagerProfileStat | CollectionCompletionManagerProfileStat;
	ManagerProgressionTaskSlug: ManagerProgressionTaskSlug;
	ManagerProgressionTaskState: ManagerProgressionTaskState;
	ManagerTaskInterface: CardsCountTargetTask | CardsCountTask | CompleteCollectionsCountTargetTask | CompleteCollectionsCountTask | DailyActionTask | DecisivePlayerPickerTask | DropChallengeTask | GameWeeklyTask | GuessTheScoreTask | InviteTaskAsReferrer | So5LeaderboardTask | StarPackTask | Task | TasksTrack | ThresholdPickerTask | ThresholdsDuoConnectionTask | ThresholdsStreakAdditionalLineupTask | ThresholdsStreakTask;
	ManagerTaskPeriodicity: ManagerTaskPeriodicity;
	ManagerTeam: ManagerTeam;
	ManagerTeamConnection: ManagerTeamConnection;
	ManagerTeamEdge: ManagerTeamEdge;
	MangopayApplePayApprovalInput: MangopayApplePayApprovalInput;
	MangopayApplePayAuthorizationRequest: MangopayApplePayAuthorizationRequest;
	MangopayBankAccountOwnerAddress: MangopayBankAccountOwnerAddress;
	MangopayBankAccountStatus: MangopayBankAccountStatus;
	MangopayBankAccountWithdrawalFeeType: MangopayBankAccountWithdrawalFeeType;
	MangopayCreditCardAuthorizationRequest: MangopayCreditCardAuthorizationRequest;
	MangopayIdentityVerification: MangopayIdentityVerification;
	MangopayIdentityVerificationStatus: MangopayIdentityVerificationStatus;
	MangopayInternalTransfer: MangopayInternalTransfer;
	MangopayKlarnaAuthorizationRequest: MangopayKlarnaAuthorizationRequest;
	MangopayKycDocument: MangopayKycDocument;
	MangopayKycRequest: MangopayKycRequest;
	MangopayNaturalUserAddressInput: MangopayNaturalUserAddressInput;
	MangopayPreAuthorizationStatus: MangopayPreAuthorizationStatus;
	MangopayRemotePreAuthorizationStatus: MangopayRemotePreAuthorizationStatus;
	MangopayRemoteTransactionStatus: MangopayRemoteTransactionStatus;
	MangopayRoot: MangopayRoot;
	MangopayTransactionStatus: MangopayTransactionStatus;
	MangopayUser: MangopayUser;
	MangopayWalletTransferApprovalInput: MangopayWalletTransferApprovalInput;
	MangopayWalletTransferAuthorizationRequest: MangopayWalletTransferAuthorizationRequest;
	MangopayWithdrawal: MangopayWithdrawal;
	MarketItem: CardPack | PurchasableItemsVoucher;
	MarketLiveOps: MarketLiveOps;
	MarketPromotionalEvent: MarketPromotionalEvent;
	MarketRoot: MarketRoot;
	MarketSetSection: CardPackGroup | FeaturedCardPack | FeaturedMarketSection | GemsShop | LegacyPacks | MarketLiveOps | MarketSetSpecialBundles | MarketSetWelcomeOffer | SpecialOffers | WeeklyDeals;
	MarketSetSpecialBundles: MarketSetSpecialBundles;
	MarketSetWelcomeOffer: MarketSetWelcomeOffer;
	MarketingNotification: MarketingNotification;
	MarketplacePreference: MarketplacePreference;
	MarketplacePreferenceInput: MarketplacePreferenceInput;
	MarketplaceSportPreferences: MarketplaceSportPreferences;
	MaximumCardsCountOwnedByUser: MaximumCardsCountOwnedByUser;
	Membership: Membership;
	MembershipConnection: MembershipConnection;
	MembershipEdge: MembershipEdge;
	MissedAppearance: MissedAppearance;
	MissedLineup: MissedLineup;
	MonetaryAmount: MonetaryAmount;
	MonetaryReward: MonetaryReward;
	MonetaryRewardConfig: MonetaryRewardConfig;
	Mutation: Mutation;
	NBACard: NBACard;
	NBAPlayer: NBAPlayer;
	NBAPosition: NBAPosition;
	NBAUserSportProfile: NBAUserSportProfile;
	NationalTeam: NationalTeam;
	Nationality: Nationality;
	NoCardRoute: NoCardRoute;
	NoCardRouteEntryRoute: NoCardRouteEntryRoute;
	Node: Account | ActivityReaction | AirdropPromotionalEvent | Announcement | AnnouncementNotification | AnonymousUser | AnyCardReward | AnyConversionCreditReward | ApiKey | AppearanceBoostShopItem | ApplePurchaseToken | AuctionNotification | AuctionReminder | AuthorizationRequest | AutoClaimNotification | AverageLastScore | BankWithdrawal | BaseAverageLastScore | BaseballCard | BaseballContestantType | BaseballPlayerGameScore | BaseballUserSportProfile | BasketballContestantType | BasketballPlayerGameScore | BidToEarnPromotionalEvent | BidToEarnReward | BundledPurchasableItem | CaBankAccount | Card | CardCollection | CardCollectionCard | CardCollectionNotification | CardCollectionSlot | CardNotification | CardPackActivityFeed | CardPackReward | CardPull | CardPullCard | CardSample | CardShardThresholdsPromotionalEvent | CardShardsChest | CardShardsPurchasableItem | CardShardsReward | CardStats | Cart | CartItem | CartPurchaseRewardPromotionalEvent | Club | CoinReward | CommonAccount | CommonCardSwapShopItem | CommonPlayer | Competition | ConnectedOAuth | Contestant | Contract | ConversionCredit | ConversionCreditCampaign | ConversionCreditNotification | Country | DataPartner | DecisiveActionNotification | DecisivePurchaseNotification | Deck | DeliverableItemOrder | DeliverableItemReward | DeliverableWithCustomVariantShopItem | DeliverableWithNoVariantShopItem | DepositPromotionalEvent | Eip7702Revocation | EmailSubscription | EthMigration | EthereumAccount | EthereumTransaction | ExchangeRate | ExperienceReward | ExternalDepositNotification | ExtraSwapShopItem | FastWithdrawal | FastWithdrawalWithRates | FiatWalletAccount | FixturePlayer | FootballContestantType | FootballUserSportProfile | FullWithdrawalRequest | Game | GameDay | GbBankAccount | GenericSpotlight | IbanBankAccount | InGameCurrencyNotification | InGameCurrencyPack | InGameCurrencyPurchasableItem | InGameCurrencyReward | Injury | InstantBuyCampaign | JerseyShopItem | JonumVerificationNotification | KycRequestNotification | LevelUpShopItem | LineupActivityFeed | Loan | LoanNotification | LoanableRoster | LoanedToken | LoomAccount | ManagerTeam | MangopayIdentityVerification | MangopayInternalTransfer | MangopayKycDocument | MangopayKycRequest | MangopayUser | MangopayWithdrawal | MarketPromotionalEvent | MarketingNotification | Membership | MonetaryReward | NBACard | NBAUserSportProfile | NationalTeam | OffRampKycNotification | OffRampWithdrawal | OfferNotification | OtherBankAccount | Owner | OwnerActivityFeed | OwnerWithRates | Pack | PackConfigPurchasableItem | Passkey | Payment | PictureFrameShopItem | Player | PlayerGameScore | PlayerGameStats | PlayerGameStatsBaseball | PlayerGameStatsBasketball | PlayerRecommendation | PrivateAccount | PrivateEmptyAccount | PrivateFiatWalletAccount | PrivateKeyRecoveryOption | ProbabilisticBundle | ProbabilisticBundleReward | PromotionalEventCompletion | PurchasableItemsVoucher | Raffle | RaffleShopItem | Referral | ReferralReward | ReferralRewardNotification | ReminderNotification | RevealableCardCampaign | RewardCard | SaleNotification | ScoringMatrix | Season | SeasonPicture | ShopItem | ShopItemReward | SkinShopItem | So5Appearance | So5CompetitionSpotlight | So5Fixture | So5FixturePreparing | So5Leaderboard | So5League | So5Lineup | So5LineupImport | So5LineupNotification | So5NoCardLineup | So5Ranking | So5Reward | So5Score | So5UserGroup | So5UserGroupMembership | So5UserGroupNotification | SolanaAccount | SolanaRentFunding | SorareRefund | SpecialEditionPromotionalEvent | SpecialWeeklyBanner | Squad | StageGroup | StarkwareAccount | StarkwareEscapeHatch | StarkwarePrivateAccount | StarkwareWithdrawal | Story | Suspension | TaskNotification | TaskPreparedLineup | TokenAuction | TokenBid | TokenMonetaryReward | TokenMyBid | TokenOffer | TokenOwner | TokenPrice | TokenPrimaryOffer | TokenWithdrawal | TournamentCalendarStage | UsBankAccount | User | UserAccountEntry | UserCardCollection | UserDevice | UserDeviceEvent | UserFlag | UserProfile | UserRelation | UserRelationNotification | UserShopItem | UserSource | UserSportStatistic | UserWallet | Venue | Watchlist | WheelConfig | Withdrawal | WithdrawalWithRates | XPCooldownPromotionalEvent;
	Notification: AnnouncementNotification | AuctionNotification | AutoClaimNotification | CardCollectionNotification | CardNotification | ConversionCreditNotification | DecisiveActionNotification | DecisivePurchaseNotification | ExternalDepositNotification | InGameCurrencyNotification | JonumVerificationNotification | KycRequestNotification | LoanNotification | MarketingNotification | OffRampKycNotification | OfferNotification | ReferralRewardNotification | ReminderNotification | SaleNotification | So5LineupNotification | So5UserGroupNotification | TaskNotification | UserRelationNotification;
	NotificationCategoryInput: NotificationCategoryInput;
	NotificationInterface: AnnouncementNotification | AuctionNotification | AutoClaimNotification | CardCollectionNotification | CardNotification | ConversionCreditNotification | DecisiveActionNotification | DecisivePurchaseNotification | ExternalDepositNotification | InGameCurrencyNotification | JonumVerificationNotification | KycRequestNotification | LoanNotification | MarketingNotification | OffRampKycNotification | OfferNotification | ReferralRewardNotification | ReminderNotification | SaleNotification | So5LineupNotification | So5UserGroupNotification | TaskNotification | UserRelationNotification;
	NotificationInterfaceConnection: NotificationInterfaceConnection;
	NotificationInterfaceEdge: NotificationInterfaceEdge;
	NotificationPreference: NotificationPreference;
	NotificationPreferenceChannel: NotificationPreferenceChannel;
	NotificationPreferenceInput: NotificationPreferenceInput;
	NotificationSection: NotificationSection;
	NotificationSubsection: NotificationSubsection;
	OAuthAccessToken: OAuthAccessToken;
	OAuthApplication: OAuthApplication;
	OAuthApplicationStatus: OAuthApplicationStatus;
	OAuthGrantType: OAuthGrantType;
	OAuthProvider: OAuthProvider;
	OffRampAuthorizationApprovalInput: OffRampAuthorizationApprovalInput;
	OffRampAuthorizationRequest: OffRampAuthorizationRequest;
	OffRampBridgeAccount: OffRampBridgeAccount;
	OffRampBridgeKycStatus: OffRampBridgeKycStatus;
	OffRampBridgeResidentialAddressInput: OffRampBridgeResidentialAddressInput;
	OffRampKycNotification: OffRampKycNotification;
	OffRampQuote: OffRampQuote;
	OffRampWithdrawal: OffRampWithdrawal;
	OffRampWithdrawalStatus: OffRampWithdrawalStatus;
	OfferDirection: OfferDirection;
	OfferMigrationInput: OfferMigrationInput;
	OfferNotification: OfferNotification;
	OfferState: OfferState;
	OfferType: OfferType;
	OnboardingLeaderboard: OnboardingLeaderboard;
	OperationInput: OperationInput;
	OrderedPlayerGameScores: OrderedPlayerGameScores;
	OrderedSo5Scores: OrderedSo5Scores;
	OrdinalRatingEnum: OrdinalRatingEnum;
	Orientation: Orientation;
	OtherBankAccount: OtherBankAccount;
	OverperformAverageScoreConfig: OverperformAverageScoreConfig;
	OwnedSinceRule: OwnedSinceRule;
	Owner: Owner;
	OwnerActivityFeed: OwnerActivityFeed;
	OwnerInterface: Owner | OwnerWithRates | UserOwner;
	OwnerTransfer: OwnerTransfer;
	OwnerWithRates: OwnerWithRates;
	Pack: Pack;
	PackConfigGroup: PackConfigGroup;
	PackConfigPurchasableItem: PackConfigPurchasableItem;
	PackConnection: PackConnection;
	PackEdge: PackEdge;
	PackPlayerOdds: PackPlayerOdds;
	PackSource: PackSource;
	PageInfo: PageInfo;
	Passkey: Passkey;
	PasskeyChallenge: PasskeyChallenge;
	PasskeyCredentialForCreateInput: PasskeyCredentialForCreateInput;
	PasskeyCredentialForGetInput: PasskeyCredentialForGetInput;
	PasskeyCredentialResponseForCreateInput: PasskeyCredentialResponseForCreateInput;
	PasskeyCredentialResponseForGetInput: PasskeyCredentialResponseForGetInput;
	PasskeyCredentialUserInput: PasskeyCredentialUserInput;
	PasswordEncryptedPrivateKey: PasswordEncryptedPrivateKey;
	PasswordEncryptedPrivateKeyInput: PasswordEncryptedPrivateKeyInput;
	Payment: Payment;
	PaymentConnection: PaymentConnection;
	PaymentCurrency: PaymentCurrency;
	PaymentDepositStatus: PaymentDepositStatus;
	PaymentEdge: PaymentEdge;
	PaymentIntentState: PaymentIntentState;
	PaymentIntentTokenOperation: TokenBid | TokenOffer | TokenPrimaryOffer;
	PaymentMethod: PaymentMethod;
	PaymentMethodFeeRate: PaymentMethodFeeRate;
	PaymentMethodProvider: PaymentMethodProvider;
	PaymentProvider: PaymentProvider;
	PaymentRoot: PaymentRoot;
	PaypalAuthorizationRequest: PaypalAuthorizationRequest;
	PendingDeposit: PendingDeposit;
	PendingPlaytimeLimit: PendingPlaytimeLimit;
	PendingSpendingLimit: PendingSpendingLimit;
	Period: Period;
	PeriodScore: PeriodScore;
	PickableCard: PickableCard;
	PickablePlayer: PickablePlayer;
	PickableTeam: PickableTeam;
	PictureFrameShopItem: PictureFrameShopItem;
	PicturePositioning: PicturePositioning;
	Platform: Platform;
	PlatformGameMode: PlatformGameMode;
	Player: Player;
	PlayerConnection: PlayerConnection;
	PlayerEdge: PlayerEdge;
	PlayerFieldStatus: PlayerFieldStatus;
	PlayerGameScore: PlayerGameScore;
	PlayerGameScoreInterface: BaseballPlayerGameScore | BasketballPlayerGameScore | PlayerGameScore | So5Score;
	PlayerGameScoreInterfaceConnection: PlayerGameScoreInterfaceConnection;
	PlayerGameScoreInterfaceEdge: PlayerGameScoreInterfaceEdge;
	PlayerGameScoreProjection: PlayerGameScoreProjection;
	PlayerGameScoreProjectionGrade: PlayerGameScoreProjectionGrade;
	PlayerGameStats: PlayerGameStats;
	PlayerGameStatsBaseball: PlayerGameStatsBaseball;
	PlayerGameStatsBasketball: PlayerGameStatsBasketball;
	PlayerHeightRule: PlayerHeightRule;
	PlayerPlayingStatus: PlayerPlayingStatus;
	PlayerRecommendation: PlayerRecommendation;
	PlayerWithSupply: PlayerWithSupply;
	PlayingStatusOdds: PlayingStatusOdds;
	PlaytimeUsage: PlaytimeUsage;
	PoolKeyShardsCount: PoolKeyShardsCount;
	PopularSortingOption: PopularSortingOption;
	Position: Position;
	PositiveAmountInput: PositiveAmountInput;
	PostSnapshotCompletionProbability: PostSnapshotCompletionProbability;
	PostalAddress: PostalAddress;
	PostalAddressInput: PostalAddressInput;
	PotentialDiscountBreakdown: PotentialDiscountBreakdown;
	PowerBreakdown: PowerBreakdown;
	PowerBreakdownOrPowerPointsBreakdown: PowerBreakdown | PowerPointsBreakdown;
	PowerPointsBreakdown: PowerPointsBreakdown;
	PreRegistrationData: PreRegistrationData;
	PreferredSide: PreferredSide;
	PrimaryOfferSource: PrimaryOfferSource;
	PrintablePlayerSource: PrintablePlayerSource;
	PrivateAccount: PrivateAccount;
	PrivateAccountable: PrivateEmptyAccount | PrivateFiatWalletAccount | StarkwarePrivateAccount;
	PrivateEmptyAccount: PrivateEmptyAccount;
	PrivateFiatWalletAccount: PrivateFiatWalletAccount;
	PrivateKeyRecoveryInput: PrivateKeyRecoveryInput;
	PrivateKeyRecoveryOption: PrivateKeyRecoveryOption;
	PrivateKeyRecoveryOptionMethodEnum: PrivateKeyRecoveryOptionMethodEnum;
	PrivateKeyRecoveryOptionStatusEnum: PrivateKeyRecoveryOptionStatusEnum;
	PrivateKeyRecoveryPayload: PrivateKeyRecoveryPayload;
	ProbabilisticBundle: ProbabilisticBundle;
	ProbabilisticBundleConfig: ProbabilisticBundleConfig;
	ProbabilisticBundleConfigSlot: ProbabilisticBundleConfigSlot;
	ProbabilisticBundleConnection: ProbabilisticBundleConnection;
	ProbabilisticBundleDesign: ProbabilisticBundleDesign;
	ProbabilisticBundleEdge: ProbabilisticBundleEdge;
	ProbabilisticBundleIntensity: ProbabilisticBundleIntensity;
	ProbabilisticBundleOpeningDisclaimer: ProbabilisticBundleOpeningDisclaimer;
	ProbabilisticBundleQuality: ProbabilisticBundleQuality;
	ProbabilisticBundleReward: ProbabilisticBundleReward;
	ProbabilisticBundleRewardConfig: ProbabilisticBundleRewardConfig;
	ProbabilisticBundleRewardConnection: ProbabilisticBundleRewardConnection;
	ProbabilisticBundleRewardEdge: ProbabilisticBundleRewardEdge;
	ProbabilisticBundleSlotArenaTicketItem: ProbabilisticBundleSlotArenaTicketItem;
	ProbabilisticBundleSlotCardItem: ProbabilisticBundleSlotCardItem;
	ProbabilisticBundleSlotCardShardItem: ProbabilisticBundleSlotCardShardItem;
	ProbabilisticBundleSlotConfig: ProbabilisticBundleSlotConfig;
	ProbabilisticBundleSlotConversionCreditItem: ProbabilisticBundleSlotConversionCreditItem;
	ProbabilisticBundleSlotDeliverableItem: ProbabilisticBundleSlotDeliverableItem;
	ProbabilisticBundleSlotInGameCurrencyItem: ProbabilisticBundleSlotInGameCurrencyItem;
	ProbabilisticBundleSlotItemInterface: ProbabilisticBundleSlotArenaTicketItem | ProbabilisticBundleSlotCardItem | ProbabilisticBundleSlotCardShardItem | ProbabilisticBundleSlotConversionCreditItem | ProbabilisticBundleSlotDeliverableItem | ProbabilisticBundleSlotInGameCurrencyItem | ProbabilisticBundleSlotPackItem | ProbabilisticBundleSlotRewardShopItem;
	ProbabilisticBundleSlotPackItem: ProbabilisticBundleSlotPackItem;
	ProbabilisticBundleSlotRewardShopItem: ProbabilisticBundleSlotRewardShopItem;
	ProbabilisticBundleSource: ProbabilisticBundleSource;
	ProbabilisticBundlesRewardsOverview: ProbabilisticBundlesRewardsOverview;
	ProbablePitchersForGameWeek: ProbablePitchersForGameWeek;
	ProbableRewardConfig: ProbableRewardConfig;
	ProgressionForRewardConfigThresholds: ProgressionForRewardConfigThresholds;
	PromotionType: PromotionType;
	PromotionalEventCompletion: PromotionalEventCompletion;
	PromotionalEventCompletionState: PromotionalEventCompletionState;
	PromotionalEventInterface: AirdropPromotionalEvent | BidToEarnPromotionalEvent | CardShardThresholdsPromotionalEvent | CartPurchaseRewardPromotionalEvent | DepositPromotionalEvent | MarketPromotionalEvent | SpecialEditionPromotionalEvent | XPCooldownPromotionalEvent;
	PromotionalEventsInterface: TokenAuction | TokenPrimaryOffer;
	PublicUserInfoInterface: CurrentUser | User | UserWithSubscriptionSlug;
	PurchasableItemDerivative: PurchasableItemDerivative;
	PurchasableItemInterface: BundledPurchasableItem | CardShardsPurchasableItem | InGameCurrencyPurchasableItem | PackConfigPurchasableItem;
	PurchasableItemsVoucher: PurchasableItemsVoucher;
	Query: Query;
	Raffle: Raffle;
	RaffleShopItem: RaffleShopItem;
	RaffleState: RaffleState;
	Range: Range;
	RangeInput: RangeInput;
	RankingRatioRange: RankingRatioRange;
	Rarity: Rarity;
	RarityCount: RarityCount;
	RarityRewardConfigs: RarityRewardConfigs;
	Rates: Rates;
	RecommendationEngine: RecommendationEngine;
	Referral: Referral;
	ReferralPaginated: ReferralPaginated;
	ReferralProgramConfig: ReferralProgramConfig;
	ReferralProgramNature: ReferralProgramNature;
	ReferralReward: ReferralReward;
	ReferralRewardConnection: ReferralRewardConnection;
	ReferralRewardEdge: ReferralRewardEdge;
	ReferralRewardNotification: ReferralRewardNotification;
	ReferralRewardState: ReferralRewardState;
	ReferralState: ReferralState;
	Referrer: User | UserSource;
	RejectedCraftSource: RejectedCraftSource;
	Remindable: TokenAuction;
	ReminderNotification: ReminderNotification;
	Request: BaseWithdrawalAuthorizationRequest | CheckoutCreditCardAuthorizationRequest | EthereumBankConditionalTransferAuthorizationRequest | EthereumBankTransferAuthorizationRequest | MangopayApplePayAuthorizationRequest | MangopayCreditCardAuthorizationRequest | MangopayKlarnaAuthorizationRequest | MangopayWalletTransferAuthorizationRequest | OffRampAuthorizationRequest | PaypalAuthorizationRequest | SolanaBankConditionalTransferAuthorizationRequest | SolanaBankTransferAuthorizationRequest | SolanaBankWithdrawalAuthorizationRequest | SolanaTokenTransferAuthorizationRequest | StarkexLimitOrderAuthorizationRequest | StarkexTransferAuthorizationRequest | StarkexV6TokenTransferAuthorizationRequest | StripeCreditCardAuthorizationRequest;
	RevealCost: RevealCost;
	RevealPropertyCurrency: RevealPropertyCurrency;
	RevealableCardCampaign: RevealableCardCampaign;
	RevealableCardConfig: RevealableCardConfig;
	RevealableProperty: RevealableProperty;
	RevealedCardsSummary: RevealedCardsSummary;
	RevealedEditionsConfig: RevealedEditionsConfig;
	RewardBoost: RewardBoost;
	RewardCard: RewardCard;
	RewardConfigRarity: RewardConfigRarity;
	RewardConfigThreshold: RewardConfigThreshold;
	RewardDeliverableItem: RewardDeliverableItem;
	RewardMultiplierConfiguration: RewardMultiplierConfiguration;
	RewardPoolShare: RewardPoolShare;
	RewardPoolShareConnection: RewardPoolShareConnection;
	RewardPoolShareEdge: RewardPoolShareEdge;
	RewardState: RewardState;
	RewardUsage: RewardUsage;
	RewardsOverview: RewardsOverview;
	RoomsConfig: RoomsConfig;
	SCAEnrollmentState: SCAEnrollmentState;
	SaleNotification: SaleNotification;
	ScoreStatus: ScoreStatus;
	ScoringMatrix: ScoringMatrix;
	ScreenshottableCard: ScreenshottableCard;
	SealingConfig: SealingConfig;
	SearchCardGroupBy: SearchCardGroupBy;
	SearchCardHit: SearchCardHit;
	SearchCardHits: SearchCardHits;
	SearchCardSale: SearchCardSale;
	SearchCards: SearchCards;
	SearchFacet: SearchFacet;
	SearchFacetDefinitionInput: SearchFacetDefinitionInput;
	SearchFacetValue: SearchFacetValue;
	SearchFaceting: SearchFaceting;
	SearchFilterInput: SearchFilterInput;
	SearchGroup: SearchGroup;
	SearchGroupKey: SearchGroupKey;
	SearchGroupedCards: SearchGroupedCards;
	SearchInterface: FlashSalePicks | SearchCardHits | SearchCards | SearchGroupedCards | SearchPlayers;
	SearchOperator: SearchOperator;
	SearchPlayers: SearchPlayers;
	SearchProcessingTime: SearchProcessingTime;
	SearchRefinementInput: SearchRefinementInput;
	SearchSortDirection: SearchSortDirection;
	SearchSortInput: SearchSortInput;
	SearchValueInput: SearchValueInput;
	Season: Season;
	SeasonBonus: SeasonBonus;
	SeasonCount: SeasonCount;
	SeasonEligibility: SeasonEligibility;
	SeasonPicture: SeasonPicture;
	SeasonsRule: SeasonsRule;
	SettlementDelayReason: SettlementDelayReason;
	ShippingState: ShippingState;
	ShirtSize: ShirtSize;
	ShopItem: ShopItem;
	ShopItemDerivative: ShopItemDerivative;
	ShopItemInterface: AppearanceBoostShopItem | CommonCardSwapShopItem | DeliverableWithCustomVariantShopItem | DeliverableWithNoVariantShopItem | ExtraSwapShopItem | JerseyShopItem | LevelUpShopItem | PictureFrameShopItem | RaffleShopItem | ShopItem | SkinShopItem;
	ShopItemReward: ShopItemReward;
	ShopItemRewardConfig: ShopItemRewardConfig;
	ShopItemThreeDimensionalAssetFormat: ShopItemThreeDimensionalAssetFormat;
	ShopItemType: ShopItemType;
	ShopItemsSortInput: ShopItemsSortInput;
	ShopItemsSorting: ShopItemsSorting;
	SignInMutationPayload: SignInMutationPayload;
	SignInWithOAuthMutationPayload: SignInWithOAuthMutationPayload;
	SignUpMutationPayload: SignUpMutationPayload;
	SignedCardPrice: SignedCardPrice;
	SignupPlatform: SignupPlatform;
	Skin: Skin;
	SkinEdition: SkinEdition;
	SkinShopItem: SkinShopItem;
	SkinTierOdds: SkinTierOdds;
	So5ActiveClubsBonus: So5ActiveClubsBonus;
	So5ActiveClubsRule: So5ActiveClubsRule;
	So5ActiveNationalTeamsRule: So5ActiveNationalTeamsRule;
	So5AgeRule: So5AgeRule;
	So5Appearance: So5Appearance;
	So5AppearanceBonusInterface: So5ActiveClubsBonus | So5AverageScoresBonus | So5BoostBonus | So5CaptainBonus | So5CollectionBonus | So5DifferentNationalitiesBonus | So5GradeBonus | So5LineupBonus | So5MalusAfterTransferBonus | So5NationalityBonus | So5PlayerBonus | So5PositionBonus | So5PositionStacksBonus | So5SameActiveClubBonus | So5ScarcityBonus | So5SeasonBonus | So5SpecialEditionCardsBonus;
	So5AppearanceConnection: So5AppearanceConnection;
	So5AppearanceEdge: So5AppearanceEdge;
	So5AppearanceInput: So5AppearanceInput;
	So5AppearanceInterface: MissedAppearance | So5Appearance;
	So5AppearancePreview: So5AppearancePreview;
	So5AppearanceSubstitutionState: So5AppearanceSubstitutionState;
	So5AppearancesRule: So5AppearancesRule;
	So5AtLeastOfClubs: So5AtLeastOfClubs;
	So5AtLeastOfCompetitions: So5AtLeastOfCompetitions;
	So5AverageScoresBonus: So5AverageScoresBonus;
	So5AverageScoresRule: So5AverageScoresRule;
	So5BoostBonus: So5BoostBonus;
	So5CaptainBonus: So5CaptainBonus;
	So5CaptainRule: So5CaptainRule;
	So5CaptainScarcityRule: So5CaptainScarcityRule;
	So5CardEditionsCountRule: So5CardEditionsCountRule;
	So5CardRewardBoost: So5CardRewardBoost;
	So5CardShardsEntryItem: So5CardShardsEntryItem;
	So5CollectionBonus: So5CollectionBonus;
	So5Competition: So5Competition;
	So5CompetitionSpotlight: So5CompetitionSpotlight;
	So5CompetitionsRule: So5CompetitionsRule;
	So5Config: So5Config;
	So5Cover: FeaturedSo5LeaderboardContenders | FeaturedSo5LeaderboardGroups | So5Leaderboard;
	So5CurrentUserInterface: CurrentUser;
	So5DeliverableItemReward: So5DeliverableItemReward;
	So5DifferentNationalitiesBonus: So5DifferentNationalitiesBonus;
	So5EntryItemInterface: So5CardShardsEntryItem;
	So5EntryItemRule: So5EntryItemRule;
	So5Fixture: So5Fixture;
	So5FixtureConnection: So5FixtureConnection;
	So5FixtureEdge: So5FixtureEdge;
	So5FixtureEvent: So5FixtureEvent;
	So5FixturePreparing: So5FixturePreparing;
	So5FixturePublicInterface: So5Fixture | So5FixturePreparing;
	So5FixturePublicInterfaceConnection: So5FixturePublicInterfaceConnection;
	So5FixturePublicInterfaceEdge: So5FixturePublicInterfaceEdge;
	So5GradeBonus: So5GradeBonus;
	So5Leaderboard: So5Leaderboard;
	So5LeaderboardBookmark: So5LeaderboardBookmark;
	So5LeaderboardConnection: So5LeaderboardConnection;
	So5LeaderboardContender: So5LeaderboardContender;
	So5LeaderboardContenderConnection: So5LeaderboardContenderConnection;
	So5LeaderboardContenderEdge: So5LeaderboardContenderEdge;
	So5LeaderboardContenderSort: So5LeaderboardContenderSort;
	So5LeaderboardEdge: So5LeaderboardEdge;
	So5LeaderboardEntryItemSource: So5LeaderboardEntryItemSource;
	So5LeaderboardFormat: So5LeaderboardFormat;
	So5LeaderboardGroup: So5LeaderboardGroup;
	So5LeaderboardGroupInterface: So5LeaderboardGroup | So5League;
	So5LeaderboardGroupInterfaceConnection: So5LeaderboardGroupInterfaceConnection;
	So5LeaderboardGroupInterfaceEdge: So5LeaderboardGroupInterfaceEdge;
	So5LeaderboardGroupType: So5LeaderboardGroupType;
	So5LeaderboardRarity: So5LeaderboardRarity;
	So5LeaderboardRulesInterface: So5Leaderboard;
	So5LeaderboardSeasonality: So5LeaderboardSeasonality;
	So5LeaderboardTask: So5LeaderboardTask;
	So5LeaderboardTaskInterface: So5LeaderboardTask;
	So5LeaderboardType: So5LeaderboardType;
	So5League: So5League;
	So5LeagueTrack: So5LeagueTrack;
	So5LeagueTrackGroup: So5LeagueTrackGroup;
	So5Lineup: So5Lineup;
	So5LineupBonus: So5LineupBonus;
	So5LineupConnection: So5LineupConnection;
	So5LineupEdge: So5LineupEdge;
	So5LineupImport: So5LineupImport;
	So5LineupImportInput: So5LineupImportInput;
	So5LineupImportState: So5LineupImportState;
	So5LineupImportsBatch: So5LineupImportsBatch;
	So5LineupImportsBatchStatus: So5LineupImportsBatchStatus;
	So5LineupNotification: So5LineupNotification;
	So5LineupPreview: So5LineupPreview;
	So5LineupSimulatedResult: So5LineupSimulatedResult;
	So5LineupSimulatedResults: So5LineupSimulatedResults;
	So5MalusAfterTransferBonus: So5MalusAfterTransferBonus;
	So5MaximumPlayersAverageScoreRule: So5MaximumPlayersAverageScoreRule;
	So5MinimumPlayersAverageScoreRule: So5MinimumPlayersAverageScoreRule;
	So5NationalityBonus: So5NationalityBonus;
	So5NationalityRule: So5NationalityRule;
	So5NoCardAppearance: So5NoCardAppearance;
	So5NoCardDraftableAppearance: So5NoCardDraftableAppearance;
	So5NoCardLineup: So5NoCardLineup;
	So5NoCardRouteFixturePickConfig: So5NoCardRouteFixturePickConfig;
	So5NoCardRoutePickingSlot: So5NoCardRoutePickingSlot;
	So5NotNationalityRule: So5NotNationalityRule;
	So5OnboardingPromotionalEvent: So5OnboardingPromotionalEvent;
	So5PlayerBonus: So5PlayerBonus;
	So5PlayerLoyaltyRewardBoost: So5PlayerLoyaltyRewardBoost;
	So5Podium: So5Podium;
	So5PositionBonus: So5PositionBonus;
	So5PositionStacksBonus: So5PositionStacksBonus;
	So5PotentialRewardConfigs: So5PotentialRewardConfigs;
	So5Ranking: So5Ranking;
	So5RankingConnection: So5RankingConnection;
	So5RankingEdge: So5RankingEdge;
	So5RankingsPaginated: So5RankingsPaginated;
	So5Rarity: So5Rarity;
	So5RarityVaultRewardBoost: So5RarityVaultRewardBoost;
	So5Reward: So5Reward;
	So5RewardBoostInterface: So5CardRewardBoost | So5PlayerLoyaltyRewardBoost | So5RarityVaultRewardBoost;
	So5RewardCardConfig: So5RewardCardConfig;
	So5RewardConfig: So5RewardConfig;
	So5RewardConfigLock: So5RewardConfigLock;
	So5RewardConfigWithEligibility: So5RewardConfigWithEligibility;
	So5RewardConnection: So5RewardConnection;
	So5RewardEdge: So5RewardEdge;
	So5RewardExperience: So5RewardExperience;
	So5RewardOrConfig: So5Reward | So5RewardConfig;
	So5RewardSource: So5RewardSource;
	So5RewardTargetConfig: So5RewardTargetConfig;
	So5RewardWithSignedAlternativeInput: So5RewardWithSignedAlternativeInput;
	So5Root: So5Root;
	So5RuleDescription: So5RuleDescription;
	So5RuleDescriptionItem: So5RuleDescriptionItem;
	So5RuleFeedback: So5RuleFeedback;
	So5RuleInterface: CardsCountAsFirstOwnerRule | OwnedSinceRule | PlayerHeightRule | SeasonsRule | So5ActiveClubsRule | So5ActiveNationalTeamsRule | So5AgeRule | So5AppearancesRule | So5AtLeastOfClubs | So5AtLeastOfCompetitions | So5AverageScoresRule | So5CaptainRule | So5CaptainScarcityRule | So5CardEditionsCountRule | So5CompetitionsRule | So5EntryItemRule | So5MaximumPlayersAverageScoreRule | So5MinimumPlayersAverageScoreRule | So5NationalityRule | So5NotNationalityRule | So5SameActiveClubRule | So5ScarcityRule | So5SeasonBonusRule | VaultPointsRule;
	So5RuleValidationState: So5RuleValidationState;
	So5Rules: So5Rules;
	So5SameActiveClubBonus: So5SameActiveClubBonus;
	So5SameActiveClubRule: So5SameActiveClubRule;
	So5ScarcityBonus: So5ScarcityBonus;
	So5ScarcityRule: So5ScarcityRule;
	So5Score: So5Score;
	So5ScoreConnection: So5ScoreConnection;
	So5ScoreEdge: So5ScoreEdge;
	So5SeasonBonus: So5SeasonBonus;
	So5SeasonBonusRule: So5SeasonBonusRule;
	So5SpecialEdition: So5SpecialEdition;
	So5SpecialEditionCardsBonus: So5SpecialEditionCardsBonus;
	So5State: So5State;
	So5Tournament: So5Tournament;
	So5Trophies: So5Trophies;
	So5UserGroup: So5UserGroup;
	So5UserGroupConnection: So5UserGroupConnection;
	So5UserGroupEdge: So5UserGroupEdge;
	So5UserGroupMembership: So5UserGroupMembership;
	So5UserGroupMembershipsPaginated: So5UserGroupMembershipsPaginated;
	So5UserGroupNotification: So5UserGroupNotification;
	So5UserGroupTournament: So5UserGroupTournament;
	SocialPictureDerivative: SocialPictureDerivative;
	SocialPicturesInterface: Deck | So5Lineup | TokenAuction;
	SolanaAccount: SolanaAccount;
	SolanaAddress: Scalars['SolanaAddress']['output'];
	SolanaBankConditionalTransferApprovalInput: SolanaBankConditionalTransferApprovalInput;
	SolanaBankConditionalTransferAuthorizationRequest: SolanaBankConditionalTransferAuthorizationRequest;
	SolanaBankTransferApprovalInput: SolanaBankTransferApprovalInput;
	SolanaBankTransferAuthorizationRequest: SolanaBankTransferAuthorizationRequest;
	SolanaBankWithdrawalAuthorizationRequest: SolanaBankWithdrawalAuthorizationRequest;
	SolanaRentFunding: SolanaRentFunding;
	SolanaRentFundingStatus: SolanaRentFundingStatus;
	SolanaTokenTransferApprovalInput: SolanaTokenTransferApprovalInput;
	SolanaTokenTransferAuthorizationRequest: SolanaTokenTransferAuthorizationRequest;
	SorarePrivateKey: SorarePrivateKey;
	SorarePrivateKeyAttributes: SorarePrivateKeyAttributes;
	SorareRefund: SorareRefund;
	SorareRefundStatus: SorareRefundStatus;
	SortingOption: SortingOption;
	SortingType: SortingType;
	SpecialEditionPromotionalEvent: SpecialEditionPromotionalEvent;
	SpecialEventFiftyFiftyResult: SpecialEventFiftyFiftyResult;
	SpecialOffers: SpecialOffers;
	SpecialWeeklyBanner: SpecialWeeklyBanner;
	SpendingUsage: SpendingUsage;
	Sport: Sport;
	SportOrShared: SportOrShared;
	SportSeason: SportSeason;
	SportStat: SportStat;
	Spotlight: GenericSpotlight | So5CompetitionSpotlight;
	SpotlightCategory: SpotlightCategory;
	SpotlightStatTile: SpotlightStatTile;
	Squad: Squad;
	SquadBoard: SquadBoard;
	SquadConnection: SquadConnection;
	SquadEdge: SquadEdge;
	SquadLeaderboardLineup: SquadLeaderboardLineup;
	SquadStep: SquadStep;
	StageGroup: StageGroup;
	StarPackTask: StarPackTask;
	StarkexApprovalInput: StarkexApprovalInput;
	StarkexLimitOrderAuthorizationRequest: StarkexLimitOrderAuthorizationRequest;
	StarkexTransferAuthorizationRequest: StarkexTransferAuthorizationRequest;
	StarkexV6TokenTransferAuthorizationRequest: StarkexV6TokenTransferAuthorizationRequest;
	StarkwareAccount: StarkwareAccount;
	StarkwareEscapeHatch: StarkwareEscapeHatch;
	StarkwarePrivateAccount: StarkwarePrivateAccount;
	StarkwareSignatureInput: StarkwareSignatureInput;
	StarkwareWithdrawal: StarkwareWithdrawal;
	Stat: Stat;
	StatCategory: StatCategory;
	StatCustomScoring: StatCustomScoring;
	StatScore: StatScore;
	StatUnit: StatUnit;
	Stats: Stats;
	StepInterface: CareerProStep | CareerStep | SquadStep;
	StepState: StepState;
	StepWonCount: StepWonCount;
	Story: Story;
	StoryReadable: So5Fixture;
	StoryState: StoryState;
	String: Scalars['String']['output'];
	StripeCreditCardAuthorizationRequest: StripeCreditCardAuthorizationRequest;
	Subscribable: BaseballCard | BaseballPlayer | Card | CardCollection | Club | Competition | Country | NBACard | NBAPlayer | Player | User | Watchlist;
	SubscribableInput: SubscribableInput;
	SubscribableType: SubscribableType;
	Subscriber: CurrentUser;
	Subscription: Subscription;
	SubstitutionEvent: SubstitutionEvent;
	SupportedCurrency: SupportedCurrency;
	Suspension: Suspension;
	Task: Task;
	TaskAppearance: TaskAppearance;
	TaskAppearanceInput: TaskAppearanceInput;
	TaskAppearanceInterface: DecisivePlayerPickerTaskAppearance | TaskAppearance | ThresholdPickerTaskAppearance;
	TaskCampaign: TaskCampaign;
	TaskCampaignDetailSection: TaskCampaignDetailSection;
	TaskCampaignStep: TaskCampaignStep;
	TaskCampaignsHomepage: TaskCampaignsHomepage;
	TaskCampaignsHomepageCampaign: TaskCampaignsHomepageCampaign;
	TaskCampaignsHomepageTutorial: TaskCampaignsHomepageTutorial;
	TaskCampaignsHomepageTutorialSection: TaskCampaignsHomepageTutorialSection;
	TaskConfig: TaskConfig;
	TaskGenre: TaskGenre;
	TaskGroup: TaskGroup;
	TaskInterface: CardsCountTargetTask | CardsCountTask | CompleteCollectionsCountTargetTask | CompleteCollectionsCountTask | DailyActionTask | DecisivePlayerPickerTask | DropChallengeTask | GameWeeklyTask | GuessTheScoreTask | InviteTaskAsReferrer | So5LeaderboardTask | StarPackTask | Task | TasksTrack | ThresholdPickerTask | ThresholdsDuoConnectionTask | ThresholdsStreakAdditionalLineupTask | ThresholdsStreakTask;
	TaskInterfaceConnection: TaskInterfaceConnection;
	TaskInterfaceEdge: TaskInterfaceEdge;
	TaskLineup: TaskLineup;
	TaskLineupInterface: GuessTheScoreTaskLineup | TaskLineup | ThresholdPickerTaskLineup;
	TaskLineupType: TaskLineupType;
	TaskNotification: TaskNotification;
	TaskPreparedLineup: TaskPreparedLineup;
	TaskPreparedLineupState: TaskPreparedLineupState;
	TaskSource: TaskSource;
	TaskStatThreshold: TaskStatThreshold;
	TasksTrack: TasksTrack;
	Team: Club | NationalTeam;
	TeamFormation: TeamFormation;
	TeamGameStatsInterface: BaseballTeamGameStats | BasketballTeamGameStats | FootballTeamGameStats;
	TeamInterface: Club | NationalTeam;
	TeamInterfaceConnection: TeamInterfaceConnection;
	TeamInterfaceEdge: TeamInterfaceEdge;
	TeamVariantStock: TeamVariantStock;
	TeamsPlayingNextGameWeek: TeamsPlayingNextGameWeek;
	TermsAndConditionsStatus: TermsAndConditionsStatus;
	ThreeDimensionalAsset: ThreeDimensionalAsset;
	ThreeDimensionalCardLayout: ThreeDimensionalCardLayout;
	ThresholdPickerTask: ThresholdPickerTask;
	ThresholdPickerTaskAppearance: ThresholdPickerTaskAppearance;
	ThresholdPickerTaskLineup: ThresholdPickerTaskLineup;
	ThresholdStreakTaskCurrentThresholdState: ThresholdStreakTaskCurrentThresholdState;
	ThresholdStreakTaskCurrentThresholdStatus: ThresholdStreakTaskCurrentThresholdStatus;
	ThresholdStreakTaskThreshold: ThresholdStreakTaskThreshold;
	ThresholdsDuoConnectionTask: ThresholdsDuoConnectionTask;
	ThresholdsStreakAdditionalLineupTask: ThresholdsStreakAdditionalLineupTask;
	ThresholdsStreakTask: ThresholdsStreakTask;
	TicketsDeliverableItem: TicketsDeliverableItem;
	TitleBodyNotificationMobileRendering: TitleBodyNotificationMobileRendering;
	TitleBodyNotificationRendering: TitleBodyNotificationRendering;
	TokenAuction: TokenAuction;
	TokenAuctionConnection: TokenAuctionConnection;
	TokenAuctionEdge: TokenAuctionEdge;
	TokenBid: TokenBid;
	TokenBidConnection: TokenBidConnection;
	TokenBidEdge: TokenBidEdge;
	TokenDeal: TokenAuction | TokenOffer | TokenPrimaryOffer;
	TokenDealConnection: TokenDealConnection;
	TokenDealEdge: TokenDealEdge;
	TokenDeposit: TokenDeposit;
	TokenMonetaryReward: TokenMonetaryReward;
	TokenMyBid: TokenMyBid;
	TokenOffer: TokenOffer;
	TokenOfferConnection: TokenOfferConnection;
	TokenOfferEdge: TokenOfferEdge;
	TokenOfferRejectionReason: TokenOfferRejectionReason;
	TokenOfferSide: TokenOfferSide;
	TokenOperationTradeInterface: TokenAuction | TokenOffer | TokenPrimaryOffer;
	TokenOwner: TokenOwner;
	TokenPaymentMethod: TokenPaymentMethod;
	TokenPrice: TokenPrice;
	TokenPriceConnection: TokenPriceConnection;
	TokenPriceEdge: TokenPriceEdge;
	TokenPrimaryOffer: TokenPrimaryOffer;
	TokenPrimaryOfferConnection: TokenPrimaryOfferConnection;
	TokenPrimaryOfferEdge: TokenPrimaryOfferEdge;
	TokenRoot: TokenRoot;
	TokenWithdrawal: TokenWithdrawal;
	TournamentCalendarRankType: TournamentCalendarRankType;
	TournamentCalendarStage: TournamentCalendarStage;
	TournamentEligibility: TournamentEligibility;
	Tradeable: Tradeable;
	TradedPlayer: TradedPlayer;
	TradedPlayerConnection: TradedPlayerConnection;
	TradedPlayerEdge: TradedPlayerEdge;
	TransactionStatus: TransactionStatus;
	TrophiesSummary: TrophiesSummary;
	UnblockEmailInput: UnblockEmailInput;
	UnblockEmailPayload: UnblockEmailPayload;
	UnknownSource: UnknownSource;
	UpdateMutationPayload: UpdateMutationPayload;
	UsBankAccount: UsBankAccount;
	UsedInSo5Lineups: UsedInSo5Lineups;
	UsedInTaskLineups: UsedInTaskLineups;
	UsedInTaskPreparedLineups: UsedInTaskPreparedLineups;
	UsedInTasks: UsedInTasks;
	User: User;
	UserAccountEntry: UserAccountEntry;
	UserAccountEntryConnection: UserAccountEntryConnection;
	UserAccountEntryEdge: UserAccountEntryEdge;
	UserAccountEntryEntry: UserAccountEntryEntry;
	UserAccountEntryState: UserAccountEntryState;
	UserAccountEntryTokenOperation: BankWithdrawal | EthMigration | FastWithdrawal | FullWithdrawalRequest | MangopayInternalTransfer | MangopayWithdrawal | OffRampWithdrawal | So5Reward | SolanaRentFunding | StarkwareWithdrawal | TokenBid | TokenMonetaryReward | TokenOffer | TokenPrimaryOffer | TokenWithdrawal | Withdrawal;
	UserCardCollection: UserCardCollection;
	UserCardCollectionConnection: UserCardCollectionConnection;
	UserCardCollectionEdge: UserCardCollectionEdge;
	UserCardCollectionSlot: UserCardCollectionSlot;
	UserCardsCount: UserCardsCount;
	UserConnection: UserConnection;
	UserDevice: UserDevice;
	UserDeviceEvent: UserDeviceEvent;
	UserEdge: UserEdge;
	UserError: UserError;
	UserFixtureResults: UserFixtureResults;
	UserFixtureResultsConnection: UserFixtureResultsConnection;
	UserFixtureResultsEdge: UserFixtureResultsEdge;
	UserFlag: UserFlag;
	UserFlagReason: UserFlagReason;
	UserGroupInterface: So5UserGroup;
	UserGroupInterfaceConnection: UserGroupInterfaceConnection;
	UserGroupInterfaceEdge: UserGroupInterfaceEdge;
	UserGroupMembershipInterface: So5UserGroupMembership;
	UserGroupMembershipShopItemsUpdate: UserGroupMembershipShopItemsUpdate;
	UserGroupMembershipShopItemsUpdateEvolution: UserGroupMembershipShopItemsUpdateEvolution;
	UserGroupStatus: UserGroupStatus;
	UserLifecycleInput: UserLifecycleInput;
	UserOffersInterface: CurrentUser;
	UserOwner: UserOwner;
	UserProfile: UserProfile;
	UserProfileBadge: UserProfileBadge;
	UserRankingInterface: So5Ranking | So5UserGroupMembership;
	UserRelation: UserRelation;
	UserRelationConnection: UserRelationConnection;
	UserRelationEdge: UserRelationEdge;
	UserRelationNotification: UserRelationNotification;
	UserReportCategory: UserReportCategory;
	UserReportContext: UserReportContext;
	UserSelectionInput: UserSelectionInput;
	UserSettings: UserSettings;
	UserShopItem: UserShopItem;
	UserSocialInterface: CurrentUser | UserWithSubscriptionSlug;
	UserSource: UserSource;
	UserSourceCategory: UserSourceCategory;
	UserSportProfileInterface: BaseballUserSportProfile | FootballUserSportProfile | NBAUserSportProfile;
	UserSportProfileVariant: UserSportProfileVariant;
	UserSportStatistic: UserSportStatistic;
	UserSportStatisticFormat: UserSportStatisticFormat;
	UserSportStatisticSlug: UserSportStatisticSlug;
	UserWallet: UserWallet;
	UserWalletStatusEnum: UserWalletStatusEnum;
	UserWithSubscriptionSlug: UserWithSubscriptionSlug;
	UserWithSubscriptionSlugConnection: UserWithSubscriptionSlugConnection;
	UserWithSubscriptionSlugEdge: UserWithSubscriptionSlugEdge;
	UsersFixtureResultsPreview: UsersFixtureResultsPreview;
	UtmInput: UtmInput;
	Validity: Validity;
	ValueBoundaries: ValueBoundaries;
	ValueOpenBoundaries: ValueOpenBoundaries;
	VariantStockCount: VariantStockCount;
	VariantStockCountType: VariantStockCountType;
	VaultPointsRule: VaultPointsRule;
	Venue: Venue;
	Verification: Verification;
	VerificationSession: VerificationSession;
	WalletInput: WalletInput;
	WalletStatus: WalletStatus;
	Watchlist: Watchlist;
	WatchlistConnection: WatchlistConnection;
	WatchlistEdge: WatchlistEdge;
	WatchlistFilter: WatchlistFilter;
	WatchlistSorting: WatchlistSorting;
	WearableDeliverableItem: WearableDeliverableItem;
	WearableSize: WearableSize;
	WeeklyDeals: WeeklyDeals;
	WeiAmount: Scalars['WeiAmount']['output'];
	WheelConfig: WheelConfig;
	WheelCost: WheelCost;
	WheelTicketEligibilityRules: WheelTicketEligibilityRules;
	WheelTicketRewardsInterface: TokenAuction | TokenPrimaryOffer;
	WheelType: WheelType;
	WinningLineup: WinningLineup;
	WithComposeTeamInterface: CareerProStep | CareerStep | GuessTheScoreTask | SquadStep | ThresholdPickerTask;
	WithFavoriteInterface: CurrentUser;
	WithNotifications: CurrentUser;
	WithOwnedCardsScope: WithOwnedCardsScope;
	WithReferralsInterface: CurrentUser;
	WithSubscriptionsInterface: BaseballCard | BaseballPlayer | Card | Club | Competition | Country | NBACard | NBAPlayer | NationalTeam | Player | User | Watchlist;
	Withdrawal: Withdrawal;
	WithdrawalState: WithdrawalState;
	WithdrawalStatus: WithdrawalStatus;
	WithdrawalWithRates: WithdrawalWithRates;
	XPBoosterShopItemInterface: LevelUpShopItem;
	XPCooldownPromotionalEvent: XPCooldownPromotionalEvent;
	acceptOfferInput: acceptOfferInput;
	acceptOfferPayload: acceptOfferPayload;
	acceptSo5NoCardBoardDraftableAppearanceInput: acceptSo5NoCardBoardDraftableAppearanceInput;
	acceptSo5NoCardBoardDraftableAppearancePayload: acceptSo5NoCardBoardDraftableAppearancePayload;
	acceptSo5NoCardDraftableAppearanceInput: acceptSo5NoCardDraftableAppearanceInput;
	acceptSo5NoCardDraftableAppearancePayload: acceptSo5NoCardDraftableAppearancePayload;
	acceptSo5NoCardLineupInput: acceptSo5NoCardLineupInput;
	acceptSo5NoCardLineupPayload: acceptSo5NoCardLineupPayload;
	acceptTermsInput: acceptTermsInput;
	acknowledgeStepInput: acknowledgeStepInput;
	acknowledgeStepPayload: acknowledgeStepPayload;
	activateWalletRecoveryInput: activateWalletRecoveryInput;
	activateWalletRecoveryPayload: activateWalletRecoveryPayload;
	addAuctionReminderInput: addAuctionReminderInput;
	addAuctionReminderPayload: addAuctionReminderPayload;
	addDeviceInput: addDeviceInput;
	addDevicePayload: addDevicePayload;
	addReferrerCodeInput: addReferrerCodeInput;
	addReferrerCodePayload: addReferrerCodePayload;
	addSolanaAddressInput: addSolanaAddressInput;
	addSolanaAddressPayload: addSolanaAddressPayload;
	addToCartInput: addToCartInput;
	addToCartPayload: addToCartPayload;
	addToWatchlistInput: addToWatchlistInput;
	addToWatchlistPayload: addToWatchlistPayload;
	addTokensToDeckInput: addTokensToDeckInput;
	addTokensToDeckPayload: addTokensToDeckPayload;
	addWalletRecoveryInput: addWalletRecoveryInput;
	addWalletRecoveryPayload: addWalletRecoveryPayload;
	approveMigratorInput: approveMigratorInput;
	approveMigratorPayload: approveMigratorPayload;
	askForProxyConsentInput: askForProxyConsentInput;
	askForProxyConsentPayload: askForProxyConsentPayload;
	bidInput: bidInput;
	bidPayload: bidPayload;
	blockUserOffersInput: blockUserOffersInput;
	blockUserOffersPayload: blockUserOffersPayload;
	buyCardPackInput: buyCardPackInput;
	buyCardPackPayload: buyCardPackPayload;
	cancelBankWithdrawalInput: cancelBankWithdrawalInput;
	cancelBankWithdrawalPayload: cancelBankWithdrawalPayload;
	cancelMobilePurchaseInput: cancelMobilePurchaseInput;
	cancelMobilePurchasePayload: cancelMobilePurchasePayload;
	cancelOfferInput: cancelOfferInput;
	cancelOfferPayload: cancelOfferPayload;
	changePasswordInput: changePasswordInput;
	changePasswordPayload: changePasswordPayload;
	checkPhoneNumberVerificationCodeInput: checkPhoneNumberVerificationCodeInput;
	checkPhoneNumberVerificationCodePayload: checkPhoneNumberVerificationCodePayload;
	claimAllSetRaffleTasksInput: claimAllSetRaffleTasksInput;
	claimAllSetRaffleTasksPayload: claimAllSetRaffleTasksPayload;
	claimAnyRewardInput: claimAnyRewardInput;
	claimAnyRewardPayload: claimAnyRewardPayload;
	claimCardsFromPackInput: claimCardsFromPackInput;
	claimCardsFromPackPayload: claimCardsFromPackPayload;
	claimConversionCreditInput: claimConversionCreditInput;
	claimConversionCreditPayload: claimConversionCreditPayload;
	claimDeliverableItemOrderInput: claimDeliverableItemOrderInput;
	claimDeliverableItemOrderPayload: claimDeliverableItemOrderPayload;
	claimOnboardingConversionCreditInput: claimOnboardingConversionCreditInput;
	claimOnboardingConversionCreditPayload: claimOnboardingConversionCreditPayload;
	claimOnboardingEnergyGiftInput: claimOnboardingEnergyGiftInput;
	claimOnboardingEnergyGiftPayload: claimOnboardingEnergyGiftPayload;
	claimPromotionalEventAirdropInput: claimPromotionalEventAirdropInput;
	claimPromotionalEventAirdropPayload: claimPromotionalEventAirdropPayload;
	claimReferralRewardInput: claimReferralRewardInput;
	claimReferralRewardPayload: claimReferralRewardPayload;
	claimRewardInput: claimRewardInput;
	claimRewardPayload: claimRewardPayload;
	claimRewardsInput: claimRewardsInput;
	claimRewardsPayload: claimRewardsPayload;
	claimStarterPackInput: claimStarterPackInput;
	claimStarterPackPayload: claimStarterPackPayload;
	claimStepInput: claimStepInput;
	claimStepPayload: claimStepPayload;
	claimTaskInput: claimTaskInput;
	claimTaskPayload: claimTaskPayload;
	collectJonumPersonalInfoInput: collectJonumPersonalInfoInput;
	collectJonumPersonalInfoPayload: collectJonumPersonalInfoPayload;
	completeDropChallengeInput: completeDropChallengeInput;
	completeDropChallengePayload: completeDropChallengePayload;
	confirmCardPullInput: confirmCardPullInput;
	confirmCardPullPayload: confirmCardPullPayload;
	confirmDeviceInput: confirmDeviceInput;
	confirmDeviceWithCodeInput: confirmDeviceWithCodeInput;
	confirmDeviceWithCodePayload: confirmDeviceWithCodePayload;
	confirmEmailInput: confirmEmailInput;
	confirmSo5LineupImportsBatchInput: confirmSo5LineupImportsBatchInput;
	confirmSo5LineupImportsBatchPayload: confirmSo5LineupImportsBatchPayload;
	confirmSo5LineupsInput: confirmSo5LineupsInput;
	confirmSo5LineupsPayload: confirmSo5LineupsPayload;
	confirmSo5NoCardLineupInput: confirmSo5NoCardLineupInput;
	confirmSo5NoCardLineupPayload: confirmSo5NoCardLineupPayload;
	consumeEphemeralTokenInput: consumeEphemeralTokenInput;
	convertCraftCluesInput: convertCraftCluesInput;
	convertCraftCluesPayload: convertCraftCluesPayload;
	createApiKeyInput: createApiKeyInput;
	createApiKeyPayload: createApiKeyPayload;
	createBankWithdrawalInput: createBankWithdrawalInput;
	createBankWithdrawalPayload: createBankWithdrawalPayload;
	createBookmarkInput: createBookmarkInput;
	createBookmarkPayload: createBookmarkPayload;
	createCardAuthorizationInput: createCardAuthorizationInput;
	createCardAuthorizationPayload: createCardAuthorizationPayload;
	createCardRegistrationInput: createCardRegistrationInput;
	createCardRegistrationPayload: createCardRegistrationPayload;
	createConnectedTasksInput: createConnectedTasksInput;
	createConnectedTasksPayload: createConnectedTasksPayload;
	createCryptoDepositInput: createCryptoDepositInput;
	createCryptoDepositPayload: createCryptoDepositPayload;
	createDeckInput: createDeckInput;
	createDeckPayload: createDeckPayload;
	createDepositBankAccountMutationInput: createDepositBankAccountMutationInput;
	createDepositBankAccountMutationPayload: createDepositBankAccountMutationPayload;
	createDirectOfferInput: createDirectOfferInput;
	createDirectOfferPayload: createDirectOfferPayload;
	createEphemeralLinkInput: createEphemeralLinkInput;
	createEphemeralLinkPayload: createEphemeralLinkPayload;
	createEthBankWithdrawalIntentInput: createEthBankWithdrawalIntentInput;
	createEthBankWithdrawalIntentPayload: createEthBankWithdrawalIntentPayload;
	createEthDepositInput: createEthDepositInput;
	createEthDepositPayload: createEthDepositPayload;
	createEthVaultInput: createEthVaultInput;
	createEthVaultPayload: createEthVaultPayload;
	createFiatPayerInput: createFiatPayerInput;
	createFiatPayerPayload: createFiatPayerPayload;
	createFiatWalletInput: createFiatWalletInput;
	createFiatWalletPayload: createFiatWalletPayload;
	createFiatWithdrawalInput: createFiatWithdrawalInput;
	createFiatWithdrawalPayload: createFiatWithdrawalPayload;
	createIdentityVerificationSessionInput: createIdentityVerificationSessionInput;
	createIdentityVerificationSessionPayload: createIdentityVerificationSessionPayload;
	createJonumVerificationInput: createJonumVerificationInput;
	createJonumVerificationPayload: createJonumVerificationPayload;
	createJwtTokenInput: createJwtTokenInput;
	createJwtTokenPayload: createJwtTokenPayload;
	createOAuthApplicationInput: createOAuthApplicationInput;
	createOffRampBridgeCustomerInput: createOffRampBridgeCustomerInput;
	createOffRampBridgeCustomerPayload: createOffRampBridgeCustomerPayload;
	createOffRampBridgeTosLinkInput: createOffRampBridgeTosLinkInput;
	createOffRampBridgeTosLinkPayload: createOffRampBridgeTosLinkPayload;
	createOnboardingSo5LineupInput: createOnboardingSo5LineupInput;
	createOnboardingSo5LineupPayload: createOnboardingSo5LineupPayload;
	createOrUpdateSingleBuyOfferMinPriceInput: createOrUpdateSingleBuyOfferMinPriceInput;
	createOrUpdateSingleBuyOfferMinPricePayload: createOrUpdateSingleBuyOfferMinPricePayload;
	createOrUpdateSo5LineupInput: createOrUpdateSo5LineupInput;
	createPasskeyInput: createPasskeyInput;
	createPasskeyPayload: createPasskeyPayload;
	createSingleSaleOfferInput: createSingleSaleOfferInput;
	createSingleSaleOfferPayload: createSingleSaleOfferPayload;
	createSo5LineupImportsBatchInput: createSo5LineupImportsBatchInput;
	createSo5LineupImportsBatchPayload: createSo5LineupImportsBatchPayload;
	createSo5NoCardBoardLineupInput: createSo5NoCardBoardLineupInput;
	createSo5NoCardBoardLineupPayload: createSo5NoCardBoardLineupPayload;
	createSo5UserGroupInput: createSo5UserGroupInput;
	createSo5UserGroupPayload: createSo5UserGroupPayload;
	createSquadInput: createSquadInput;
	createSquadPayload: createSquadPayload;
	createStarkwareEscapeHatchInput: createStarkwareEscapeHatchInput;
	createStarkwareEscapeHatchPayload: createStarkwareEscapeHatchPayload;
	createSubscriptionInput: createSubscriptionInput;
	createSubscriptionPayload: createSubscriptionPayload;
	createTaskPreparedLineupFromTaskLineupInput: createTaskPreparedLineupFromTaskLineupInput;
	createTaskPreparedLineupFromTaskLineupPayload: createTaskPreparedLineupFromTaskLineupPayload;
	createWalletInput: createWalletInput;
	createWalletPayload: createWalletPayload;
	createWireTransferDepositInput: createWireTransferDepositInput;
	createWireTransferDepositPayload: createWireTransferDepositPayload;
	createWithdrawalBankAccountInput: createWithdrawalBankAccountInput;
	createWithdrawalBankAccountPayload: createWithdrawalBankAccountPayload;
	deactivateWalletRecoveryInput: deactivateWalletRecoveryInput;
	deactivateWalletRecoveryPayload: deactivateWalletRecoveryPayload;
	declineSo5LineupImportsBatchInput: declineSo5LineupImportsBatchInput;
	declineSo5LineupImportsBatchPayload: declineSo5LineupImportsBatchPayload;
	declineSo5NoCardLineupInput: declineSo5NoCardLineupInput;
	declineSo5NoCardLineupPayload: declineSo5NoCardLineupPayload;
	deleteApiKeyInput: deleteApiKeyInput;
	deleteApiKeyPayload: deleteApiKeyPayload;
	deleteBookmarkInput: deleteBookmarkInput;
	deleteBookmarkPayload: deleteBookmarkPayload;
	deleteConnectedTaskInput: deleteConnectedTaskInput;
	deleteConnectedTaskPayload: deleteConnectedTaskPayload;
	deleteDeckInput: deleteDeckInput;
	deleteDeckPayload: deleteDeckPayload;
	deleteOAuthApplicationInput: deleteOAuthApplicationInput;
	deleteOAuthApplicationPayload: deleteOAuthApplicationPayload;
	deletePasskeyInput: deletePasskeyInput;
	deletePasskeyPayload: deletePasskeyPayload;
	deletePostalAddressInput: deletePostalAddressInput;
	deletePostalAddressPayload: deletePostalAddressPayload;
	deleteSo5LineupInput: deleteSo5LineupInput;
	deleteSo5LineupPayload: deleteSo5LineupPayload;
	deleteSo5UserGroupInput: deleteSo5UserGroupInput;
	deleteSo5UserGroupPayload: deleteSo5UserGroupPayload;
	deleteSubscriptionInput: deleteSubscriptionInput;
	deleteSubscriptionPayload: deleteSubscriptionPayload;
	deleteTaskLineupInput: deleteTaskLineupInput;
	deleteTaskLineupPayload: deleteTaskLineupPayload;
	deleteWithdrawalBankAccountInput: deleteWithdrawalBankAccountInput;
	deleteWithdrawalBankAccountPayload: deleteWithdrawalBankAccountPayload;
	depositWithApplePayInput: depositWithApplePayInput;
	depositWithApplePayPayload: depositWithApplePayPayload;
	destroyAccountInput: destroyAccountInput;
	destroyAccountPayload: destroyAccountPayload;
	destroyReferralInput: destroyReferralInput;
	destroyReferralPayload: destroyReferralPayload;
	destroyTaskPreparedLineupInput: destroyTaskPreparedLineupInput;
	destroyTaskPreparedLineupPayload: destroyTaskPreparedLineupPayload;
	destroyWatchlistInput: destroyWatchlistInput;
	destroyWatchlistPayload: destroyWatchlistPayload;
	detachPaymentMethodInput: detachPaymentMethodInput;
	detachPaymentMethodPayload: detachPaymentMethodPayload;
	disable2faInput: disable2faInput;
	disable2faPayload: disable2faPayload;
	disconnectOmniauthProviderInput: disconnectOmniauthProviderInput;
	disconnectOmniauthProviderPayload: disconnectOmniauthProviderPayload;
	dropAndAddCardsInput: dropAndAddCardsInput;
	dropAndAddCardsPayload: dropAndAddCardsPayload;
	editDeckInput: editDeckInput;
	editDeckPayload: editDeckPayload;
	enable2faInput: enable2faInput;
	enable2faPayload: enable2faPayload;
	enrollSCAInput: enrollSCAInput;
	enrollSCAPayload: enrollSCAPayload;
	fetchEncryptedPrivateKeyInput: fetchEncryptedPrivateKeyInput;
	fetchEncryptedPrivateKeyPayload: fetchEncryptedPrivateKeyPayload;
	generateAccountingExtractInput: generateAccountingExtractInput;
	generateAccountingExtractPayload: generateAccountingExtractPayload;
	generateOtpBackupCodesInput: generateOtpBackupCodesInput;
	generateOtpBackupCodesPayload: generateOtpBackupCodesPayload;
	generateOtpProvisioningUriInput: generateOtpProvisioningUriInput;
	generateOtpProvisioningUriPayload: generateOtpProvisioningUriPayload;
	generatePasskeyChallengeForCreateInput: generatePasskeyChallengeForCreateInput;
	generatePasskeyChallengeForCreatePayload: generatePasskeyChallengeForCreatePayload;
	generatePasskeyChallengeForSignInInput: generatePasskeyChallengeForSignInInput;
	generatePasskeyChallengeForSignInPayload: generatePasskeyChallengeForSignInPayload;
	generateReferrerCodeInput: generateReferrerCodeInput;
	generateReferrerCodePayload: generateReferrerCodePayload;
	generateSo5NoCardLineupInput: generateSo5NoCardLineupInput;
	generateSo5NoCardLineupPayload: generateSo5NoCardLineupPayload;
	hideMyFeaturedSo5LeaderboardGroupInput: hideMyFeaturedSo5LeaderboardGroupInput;
	hideMyFeaturedSo5LeaderboardGroupPayload: hideMyFeaturedSo5LeaderboardGroupPayload;
	joinSo5UserGroupInput: joinSo5UserGroupInput;
	joinSo5UserGroupPayload: joinSo5UserGroupPayload;
	joinSquadInput: joinSquadInput;
	joinSquadPayload: joinSquadPayload;
	leaveSquadInput: leaveSquadInput;
	leaveSquadPayload: leaveSquadPayload;
	levelUpCardWithXpCurrencyInput: levelUpCardWithXpCurrencyInput;
	levelUpCardWithXpCurrencyPayload: levelUpCardWithXpCurrencyPayload;
	levelUpCardsWithXpCurrencyInput: levelUpCardsWithXpCurrencyInput;
	levelUpCardsWithXpCurrencyPayload: levelUpCardsWithXpCurrencyPayload;
	linkEthereumAddressInput: linkEthereumAddressInput;
	linkEthereumAddressPayload: linkEthereumAddressPayload;
	loadPreviousLineupInput: loadPreviousLineupInput;
	loadPreviousLineupPayload: loadPreviousLineupPayload;
	loadSuggestedLineupInput: loadSuggestedLineupInput;
	loadSuggestedLineupPayload: loadSuggestedLineupPayload;
	lockProModeInput: lockProModeInput;
	lockProModePayload: lockProModePayload;
	markAsProOnboardedInput: markAsProOnboardedInput;
	markAsProOnboardedPayload: markAsProOnboardedPayload;
	markCardShardsChestUnlockedThresholdAsSeenInput: markCardShardsChestUnlockedThresholdAsSeenInput;
	markCardShardsChestUnlockedThresholdAsSeenPayload: markCardShardsChestUnlockedThresholdAsSeenPayload;
	markNotificationsAsReadInput: markNotificationsAsReadInput;
	markNotificationsAsReadPayload: markNotificationsAsReadPayload;
	markSocialFeedAsReadInput: markSocialFeedAsReadInput;
	markSocialFeedAsReadPayload: markSocialFeedAsReadPayload;
	markSpotlightAsSeenInput: markSpotlightAsSeenInput;
	markSpotlightAsSeenPayload: markSpotlightAsSeenPayload;
	markStoriesAsReadInput: markStoriesAsReadInput;
	markStoriesAsReadPayload: markStoriesAsReadPayload;
	migrateEthInput: migrateEthInput;
	migrateEthPayload: migrateEthPayload;
	offRampInput: offRampInput;
	offRampPayload: offRampPayload;
	pickPulledCardInput: pickPulledCardInput;
	pickPulledCardPayload: pickPulledCardPayload;
	prepareAcceptOfferInput: prepareAcceptOfferInput;
	prepareAcceptOfferPayload: prepareAcceptOfferPayload;
	prepareAcceptTradeWithWalletAndCreditCardInput: prepareAcceptTradeWithWalletAndCreditCardInput;
	prepareAcceptTradeWithWalletAndCreditCardPayload: prepareAcceptTradeWithWalletAndCreditCardPayload;
	prepareBankWithdrawalInput: prepareBankWithdrawalInput;
	prepareBankWithdrawalPayload: prepareBankWithdrawalPayload;
	prepareBidInput: prepareBidInput;
	prepareBidPayload: prepareBidPayload;
	prepareBuyInGameCurrencyPackWithCreditCardInput: prepareBuyInGameCurrencyPackWithCreditCardInput;
	prepareBuyInGameCurrencyPackWithCreditCardPayload: prepareBuyInGameCurrencyPackWithCreditCardPayload;
	prepareDepositInput: prepareDepositInput;
	prepareDepositPayload: prepareDepositPayload;
	prepareEthDepositInput: prepareEthDepositInput;
	prepareEthDepositPayload: prepareEthDepositPayload;
	prepareIdealDepositInput: prepareIdealDepositInput;
	prepareIdealDepositPayload: prepareIdealDepositPayload;
	prepareMigrateEthInput: prepareMigrateEthInput;
	prepareMigrateEthPayload: prepareMigrateEthPayload;
	prepareOffRampInput: prepareOffRampInput;
	prepareOffRampPayload: prepareOffRampPayload;
	prepareOfferInput: prepareOfferInput;
	prepareOfferPayload: prepareOfferPayload;
	preparePayByBankDepositInput: preparePayByBankDepositInput;
	preparePayByBankDepositPayload: preparePayByBankDepositPayload;
	preparePaypalDepositInput: preparePaypalDepositInput;
	preparePaypalDepositPayload: preparePaypalDepositPayload;
	prepareSorareRefundInput: prepareSorareRefundInput;
	prepareSorareRefundPayload: prepareSorareRefundPayload;
	prepareTokenDepositInput: prepareTokenDepositInput;
	prepareTokenDepositPayload: prepareTokenDepositPayload;
	probabilisticBundlesOpenInput: probabilisticBundlesOpenInput;
	probabilisticBundlesOpenPayload: probabilisticBundlesOpenPayload;
	pullCardsInput: pullCardsInput;
	pullCardsPayload: pullCardsPayload;
	reactToActivityInput: reactToActivityInput;
	reactToActivityPayload: reactToActivityPayload;
	refreshCartInput: refreshCartInput;
	refreshCartPayload: refreshCartPayload;
	refundSorareInput: refundSorareInput;
	refundSorarePayload: refundSorarePayload;
	rejectCardPullInput: rejectCardPullInput;
	rejectCardPullPayload: rejectCardPullPayload;
	rejectOfferInput: rejectOfferInput;
	rejectOfferPayload: rejectOfferPayload;
	removeActivityInput: removeActivityInput;
	removeActivityPayload: removeActivityPayload;
	removeAuctionReminderInput: removeAuctionReminderInput;
	removeAuctionReminderPayload: removeAuctionReminderPayload;
	removeFromCartInput: removeFromCartInput;
	removeFromCartPayload: removeFromCartPayload;
	removeFromWatchlistInput: removeFromWatchlistInput;
	removeFromWatchlistPayload: removeFromWatchlistPayload;
	removeMemberFromSquadInput: removeMemberFromSquadInput;
	removeMemberFromSquadPayload: removeMemberFromSquadPayload;
	removeTokenFromDeckInput: removeTokenFromDeckInput;
	removeTokenFromDeckPayload: removeTokenFromDeckPayload;
	removeUserFromSo5UserGroupInput: removeUserFromSo5UserGroupInput;
	removeUserFromSo5UserGroupPayload: removeUserFromSo5UserGroupPayload;
	reorderTaskPreparedLineupInput: reorderTaskPreparedLineupInput;
	reorderTaskPreparedLineupPayload: reorderTaskPreparedLineupPayload;
	reportTelemetryInput: reportTelemetryInput;
	reportTelemetryPayload: reportTelemetryPayload;
	reportUserInput: reportUserInput;
	reportUserPayload: reportUserPayload;
	requestJonumSelfExclusionInput: requestJonumSelfExclusionInput;
	requestJonumSelfExclusionPayload: requestJonumSelfExclusionPayload;
	requestSo5NoCardBoardDraftableAppearanceInput: requestSo5NoCardBoardDraftableAppearanceInput;
	requestSo5NoCardBoardDraftableAppearancePayload: requestSo5NoCardBoardDraftableAppearancePayload;
	requestSo5NoCardDraftableAppearanceInput: requestSo5NoCardDraftableAppearanceInput;
	requestSo5NoCardDraftableAppearancePayload: requestSo5NoCardDraftableAppearancePayload;
	requestSo5NoCardLineupEligibleLeaderboardsInput: requestSo5NoCardLineupEligibleLeaderboardsInput;
	requestSo5NoCardLineupEligibleLeaderboardsPayload: requestSo5NoCardLineupEligibleLeaderboardsPayload;
	resendConfirmationInstructionsInput: resendConfirmationInstructionsInput;
	resendConfirmationInstructionsPayload: resendConfirmationInstructionsPayload;
	resendVerificationCodeInput: resendVerificationCodeInput;
	resendVerificationCodePayload: resendVerificationCodePayload;
	resetPrivateKeyInput: resetPrivateKeyInput;
	resetPrivateKeyPayload: resetPrivateKeyPayload;
	resetSo5NoCardBoardDraftedAppearancesInput: resetSo5NoCardBoardDraftedAppearancesInput;
	resetSo5NoCardBoardDraftedAppearancesPayload: resetSo5NoCardBoardDraftedAppearancesPayload;
	resetSo5NoCardDraftedAppearancesInput: resetSo5NoCardDraftedAppearancesInput;
	resetSo5NoCardDraftedAppearancesPayload: resetSo5NoCardDraftedAppearancesPayload;
	restartTasksTrackInput: restartTasksTrackInput;
	restartTasksTrackPayload: restartTasksTrackPayload;
	restoreWalletInput: restoreWalletInput;
	restoreWalletPayload: restoreWalletPayload;
	revealBlueprintsInput: revealBlueprintsInput;
	revealBlueprintsPayload: revealBlueprintsPayload;
	revealPropertyInput: revealPropertyInput;
	revealPropertyPayload: revealPropertyPayload;
	revokeDeviceInput: revokeDeviceInput;
	revokeDevicePayload: revokeDevicePayload;
	revokeEip7702DelegationInput: revokeEip7702DelegationInput;
	revokeEip7702DelegationPayload: revokeEip7702DelegationPayload;
	revokeOAuthAccessTokenForApplicationInput: revokeOAuthAccessTokenForApplicationInput;
	revokeOAuthAccessTokenForApplicationPayload: revokeOAuthAccessTokenForApplicationPayload;
	revokeOAuthAccessTokenInput: revokeOAuthAccessTokenInput;
	revokeOAuthAccessTokenPayload: revokeOAuthAccessTokenPayload;
	saveForLaterInput: saveForLaterInput;
	saveForLaterPayload: saveForLaterPayload;
	sealCardsInput: sealCardsInput;
	sealCardsPayload: sealCardsPayload;
	sendWalletRecoveryInput: sendWalletRecoveryInput;
	sendWalletRecoveryPayload: sendWalletRecoveryPayload;
	setDeviceTokenInput: setDeviceTokenInput;
	setDeviceTokenPayload: setDeviceTokenPayload;
	setJonumPlaytimeLimitInput: setJonumPlaytimeLimitInput;
	setJonumPlaytimeLimitPayload: setJonumPlaytimeLimitPayload;
	setJonumSpendingLimitInput: setJonumSpendingLimitInput;
	setJonumSpendingLimitPayload: setJonumSpendingLimitPayload;
	setTokenTradeStatusInput: setTokenTradeStatusInput;
	setTokenTradeStatusPayload: setTokenTradeStatusPayload;
	shareCardInput: shareCardInput;
	shareCardPackInput: shareCardPackInput;
	shareCardPackPayload: shareCardPackPayload;
	shareCardPayload: shareCardPayload;
	shareLineupInput: shareLineupInput;
	shareLineupPayload: shareLineupPayload;
	signInInput: signInInput;
	signInWithOAuthInput: signInWithOAuthInput;
	signOutFromAllDevicesInput: signOutFromAllDevicesInput;
	signOutFromAllDevicesPayload: signOutFromAllDevicesPayload;
	signUpInput: signUpInput;
	skipOnboardingInput: skipOnboardingInput;
	skipOnboardingPayload: skipOnboardingPayload;
	spinWheelInput: spinWheelInput;
	spinWheelPayload: spinWheelPayload;
	startFiatWalletIdentityVerificationInput: startFiatWalletIdentityVerificationInput;
	startFiatWalletIdentityVerificationPayload: startFiatWalletIdentityVerificationPayload;
	startOffRampBridgeKycInput: startOffRampBridgeKycInput;
	startOffRampBridgeKycPayload: startOffRampBridgeKycPayload;
	stopAutoBidInput: stopAutoBidInput;
	stopAutoBidPayload: stopAutoBidPayload;
	storeApplePurchaseTokenInput: storeApplePurchaseTokenInput;
	storeApplePurchaseTokenPayload: storeApplePurchaseTokenPayload;
	suggestLineupInput: suggestLineupInput;
	suggestLineupPayload: suggestLineupPayload;
	swapTaskAppearancesInput: swapTaskAppearancesInput;
	swapTaskAppearancesPayload: swapTaskAppearancesPayload;
	unblockFiatWalletInput: unblockFiatWalletInput;
	unblockFiatWalletPayload: unblockFiatWalletPayload;
	unblockUserOffersInput: unblockUserOffersInput;
	unblockUserOffersPayload: unblockUserOffersPayload;
	unlockNextBoardInput: unlockNextBoardInput;
	unlockNextBoardPayload: unlockNextBoardPayload;
	unlockProModeInput: unlockProModeInput;
	unlockProModePayload: unlockProModePayload;
	unsealCardsInput: unsealCardsInput;
	unsealCardsPayload: unsealCardsPayload;
	unsubscribeFromEmailsInput: unsubscribeFromEmailsInput;
	unsubscribeFromEmailsPayload: unsubscribeFromEmailsPayload;
	updateCardFiltersInput: updateCardFiltersInput;
	updateCardFiltersPayload: updateCardFiltersPayload;
	updateExternalEthDepositInput: updateExternalEthDepositInput;
	updateExternalEthDepositPayload: updateExternalEthDepositPayload;
	updateFavoriteTeamInput: updateFavoriteTeamInput;
	updateFavoriteTeamPayload: updateFavoriteTeamPayload;
	updateFiatWalletInput: updateFiatWalletInput;
	updateFiatWalletPayload: updateFiatWalletPayload;
	updateHighlightedCardInput: updateHighlightedCardInput;
	updateHighlightedCardPayload: updateHighlightedCardPayload;
	updateManagerTeamInput: updateManagerTeamInput;
	updateManagerTeamPayload: updateManagerTeamPayload;
	updateOAuthApplicationInput: updateOAuthApplicationInput;
	updateOnboardingSo5LeaderboardInput: updateOnboardingSo5LeaderboardInput;
	updateOnboardingSo5LeaderboardPayload: updateOnboardingSo5LeaderboardPayload;
	updatePartnerOffersAgreementInput: updatePartnerOffersAgreementInput;
	updatePartnerOffersAgreementPayload: updatePartnerOffersAgreementPayload;
	updateSectionNotificationPreferencesInput: updateSectionNotificationPreferencesInput;
	updateSectionNotificationPreferencesPayload: updateSectionNotificationPreferencesPayload;
	updateSo5LineupSettingsInput: updateSo5LineupSettingsInput;
	updateSo5LineupSettingsPayload: updateSo5LineupSettingsPayload;
	updateSo5UserGroupInput: updateSo5UserGroupInput;
	updateSo5UserGroupPayload: updateSo5UserGroupPayload;
	updateSportProfileInput: updateSportProfileInput;
	updateSportProfilePayload: updateSportProfilePayload;
	updateSquadPrivacyInput: updateSquadPrivacyInput;
	updateSquadPrivacyPayload: updateSquadPrivacyPayload;
	updateSubscriptionInput: updateSubscriptionInput;
	updateSubscriptionPayload: updateSubscriptionPayload;
	updateTaskConfigPreferencesInput: updateTaskConfigPreferencesInput;
	updateTaskConfigPreferencesPayload: updateTaskConfigPreferencesPayload;
	updateTaskPreparedLineupsCarryOverInput: updateTaskPreparedLineupsCarryOverInput;
	updateTaskPreparedLineupsCarryOverPayload: updateTaskPreparedLineupsCarryOverPayload;
	updateUserEmailInput: updateUserEmailInput;
	updateUserEmailPayload: updateUserEmailPayload;
	updateUserProfileInput: updateUserProfileInput;
	updateUserProfilePayload: updateUserProfilePayload;
	updateUserSettingsInput: updateUserSettingsInput;
	updateUserSettingsPayload: updateUserSettingsPayload;
	upsertStepLineupInput: upsertStepLineupInput;
	upsertStepLineupPayload: upsertStepLineupPayload;
	upsertTaskAppearancesInput: upsertTaskAppearancesInput;
	upsertTaskAppearancesPayload: upsertTaskAppearancesPayload;
	upsertTaskLineupInput: upsertTaskLineupInput;
	upsertTaskLineupPayload: upsertTaskLineupPayload;
	upsertTaskPreparedLineupInput: upsertTaskPreparedLineupInput;
	upsertTaskPreparedLineupPayload: upsertTaskPreparedLineupPayload;
	upsertWatchlistInput: upsertWatchlistInput;
	upsertWatchlistPayload: upsertWatchlistPayload;
	validateApplePayMerchantSessionInput: validateApplePayMerchantSessionInput;
	validateApplePayMerchantSessionPayload: validateApplePayMerchantSessionPayload;
	validateFiatWalletInput: validateFiatWalletInput;
	validateFiatWalletPayload: validateFiatWalletPayload;
	verifyInGameCurrencyPackMobilePurchaseInput: verifyInGameCurrencyPackMobilePurchaseInput;
	verifyInGameCurrencyPackMobilePurchasePayload: verifyInGameCurrencyPackMobilePurchasePayload;
	verifyMobilePurchaseInput: verifyMobilePurchaseInput;
	verifyMobilePurchasePayload: verifyMobilePurchasePayload;
	verifyPhoneNumberInput: verifyPhoneNumberInput;
	verifyPhoneNumberPayload: verifyPhoneNumberPayload;
	visitCampaignPageInput: visitCampaignPageInput;
	visitCampaignPagePayload: visitCampaignPagePayload;
};